var curtainsList = [
    {
        "id": 36313,
        "title": "Zoe Linen Look Soft Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/custom-woven-natural-texture-faux-linen-blackout-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "37684",
        "_fabric_color": [
            {
                "term_id": 37684,
                "gallery": [
                    50937,
                    104801,
                    104800,
                    106613,
                    106612,
                    106614,
                    106610,
                    106611
                ],
                "imgSrc": "/cdn/shop/files/Honeyview_114-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Honeyview_114-1.jpg",
                "imgSrcF": "/cdn/shop/files/Ivory-White-1.png",
                "price": 50,
                "title": "Zoe / Ivory white",
                "color": "White"
            },
            {
                "term_id": 37663,
                "gallery": [
                    106617,
                    104801,
                    104800,
                    106616,
                    106618,
                    106615
                ],
                "imgSrc": "/cdn/shop/files/Silver-White-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-White-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/Silver-White-3.png",
                "price": 50,
                "title": "Zoe / Silver White",
                "color": "White"
            },
            {
                "term_id": 37681,
                "gallery": [
                    106619,
                    104801,
                    104800,
                    106621,
                    106620,
                    106622
                ],
                "imgSrc": "/cdn/shop/files/Haze-Blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Haze-Blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/Haze-Blue-1.png",
                "price": 50,
                "title": "Zoe / Haze Blue",
                "color": "Blue"
            },
            {
                "term_id": 41990,
                "gallery": [
                    106634,
                    104801,
                    104800,
                    106631,
                    106635,
                    106633
                ],
                "imgSrc": "/cdn/shop/files/Grey-2-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-2-3.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-3.png",
                "price": 50,
                "title": "Zoe / Grey",
                "color": "Grey"
            },
            {
                "term_id": 37730,
                "gallery": [
                    106628,
                    104801,
                    104800,
                    106629,
                    106630,
                    106627
                ],
                "imgSrc": "/cdn/shop/files/Navy-Blue-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Navy-Blue-2.jpg",
                "imgSrcF": "/cdn/shop/files/Navy-Blue-3.png",
                "price": 50,
                "title": "Zoe / Navy Blue",
                "color": "Blue"
            },
            {
                "term_id": 41986,
                "gallery": [
                    106638,
                    104801,
                    104800,
                    106636,
                    106637,
                    106639
                ],
                "imgSrc": "/cdn/shop/files/Brown-2-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Brown-2-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/Brown-2.png",
                "price": 50,
                "title": "Zoe / Brown",
                "color": "Brown"
            },
            {
                "term_id": 41988,
                "gallery": [
                    106641,
                    104801,
                    104800,
                    106640,
                    106642,
                    106643
                ],
                "imgSrc": "/cdn/shop/files/Caramel-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Caramel-2.jpg",
                "imgSrcF": "/cdn/shop/files/Caramel-2.png",
                "price": 50,
                "title": "Zoe / Caramel",
                "color": "Beige"
            },
            {
                "term_id": 41984,
                "gallery": [
                    106645,
                    104801,
                    104800,
                    106646,
                    106647,
                    106644
                ],
                "imgSrc": "/cdn/shop/files/Angora-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Angora-2.jpg",
                "imgSrcF": "/cdn/shop/files/Angora-3.png",
                "price": 50,
                "title": "Zoe / Angora",
                "color": "Beige"
            },
            {
                "term_id": 41981,
                "gallery": [
                    106650,
                    104801,
                    104800,
                    106651,
                    106649,
                    106648
                ],
                "imgSrc": "/cdn/shop/files/Straw-Brown-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Straw-Brown-2.jpg",
                "imgSrcF": "/cdn/shop/files/Straw-Brown-2-2.png",
                "price": 50,
                "title": "Zoe / Straw Brown",
                "color": "Beige"
            },
            {
                "term_id": 58394,
                "gallery": [
                    106653,
                    104801,
                    104800,
                    106654,
                    106655,
                    106652
                ],
                "imgSrc": "/cdn/shop/files/Silver-Grey-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-Grey-2.jpg",
                "imgSrcF": "/cdn/shop/files/Silver-Grey-3.png",
                "price": 50,
                "title": "Zoe / Silver Grey",
                "color": "Grey"
            },
            {
                "term_id": 102147,
                "gallery": [
                    106657,
                    104801,
                    104800,
                    106659,
                    106658,
                    106656
                ],
                "imgSrc": "/cdn/shop/files/Dark-rose-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Dark-rose-2.jpg",
                "imgSrcF": "/cdn/shop/files/Dark-rose-2-1.png",
                "price": 50,
                "title": "Zoe / Dark rose",
                "color": "Grey"
            },
            {
                "term_id": 102145,
                "gallery": [
                    106661,
                    104801,
                    104800,
                    106662,
                    106663,
                    106660
                ],
                "imgSrc": "/cdn/shop/files/Sage-green-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sage-green-2.jpg",
                "imgSrcF": "/cdn/shop/files/Sage-green-3-1.png",
                "price": 50,
                "title": "Zoe / Sage green",
                "color": "Grey"
            },
            {
                "term_id": 102142,
                "gallery": [
                    106665,
                    104801,
                    104800,
                    106667,
                    106666,
                    106664
                ],
                "imgSrc": "/cdn/shop/files/Stone-blue-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Stone-blue-2.jpg",
                "imgSrcF": "/cdn/shop/files/Stone-blue-2-1.png",
                "price": 50,
                "title": "Zoe / Stone blue",
                "color": "Grey"
            },
            {
                "term_id": 102140,
                "gallery": [
                    106668,
                    104801,
                    104800,
                    106669,
                    106670,
                    106671
                ],
                "imgSrc": "/cdn/shop/files/Forest-green-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Forest-green-2.jpg",
                "imgSrcF": "/cdn/shop/files/Forest-green-1-1.png",
                "price": 50,
                "title": "Zoe / Forest green",
                "color": "Grey"
            },
            {
                "term_id": 102138,
                "gallery": [
                    106673,
                    104801,
                    104800,
                    106674,
                    106675,
                    106672
                ],
                "imgSrc": "/cdn/shop/files/Oatmeal-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Oatmeal-2.jpg",
                "imgSrcF": "/cdn/shop/files/Oatmeal-3-2.png",
                "price": 50,
                "title": "Zoe / Oatmeal",
                "color": "Grey"
            },
            {
                "term_id": 102136,
                "gallery": [
                    106677,
                    104801,
                    104800,
                    106679,
                    106676,
                    106678
                ],
                "imgSrc": "/cdn/shop/files/Dark-Green-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Dark-Green-2.jpg",
                "imgSrcF": "/cdn/shop/files/Dark-Green-1-1.png",
                "price": 50,
                "title": "Zoe / Dark Green",
                "color": "Grey"
            },
            {
                "term_id": 102134,
                "gallery": [
                    106681,
                    104801,
                    104800,
                    106682,
                    106683,
                    106680
                ],
                "imgSrc": "/cdn/shop/files/Golden-Brown-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Golden-Brown-2.jpg",
                "imgSrcF": "/cdn/shop/files/Golden-Brown-3-1.png",
                "price": 50,
                "title": "Zoe / Golden Brown",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 98227,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Linen Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtain Sale",
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search linen",
            "Search Pinch pleat",
            "Solid Curtains",
            "Spring Time Sale",
            "Summer Collection",
            "Synthetic Curtains",
            "同材质内衬面料分类",
            "绍兴-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "Zoe\r\n<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \" style=\"border-radius: 0px;\"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\">\r\n<p style=\"margin-bottom: 20px;\">Made from high-quality materials, these curtains offer a rich and realistic woven texture that adds depth and dimension to any decor. The faux linen fabric has a soft, warm feel that will envelop your room in comfort and create a cozy atmosphere.</p>\r\n<p style=\"margin-bottom: 20px;\">In addition to its beautiful look, these curtains are also highly functional that blocks out light and noise, providing you with a peaceful and dark environment for a good night's sleep. Whether you are looking for a solution for your bedroom, living room, or any other room in your home, these curtains are the perfect choice.</p>\r\n<p style=\"margin-bottom: 20px;\">Customizable to fit your window size, these curtains offer both quality and style, making them a versatile addition to any room. With their elegant look, they are perfect for adding a touch of sophistication to your home, while the blackout feature makes them ideal for creating a comfortable and private space.</p>\r\n\r\n</article></div>\r\n</section></div>\r\n<div class=\"hr hr-invisible avia-builder-el-15 el_after_av_one_full el_before_av_two_fifth \" style=\"height: 35px;\"></div>",
        "imgSrc": "/cdn/shop/files/Honeyview_114-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Ivory-White-2-500x500.png",
        "subheading": "Linen Look Soft Custom Curtain",
        "Fabrics": [
            "Zoe"
        ],
        "Feature": [],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White",
            "White",
            "Blue",
            "Grey",
            "Blue",
            "Brown",
            "Beige",
            "Beige",
            "Beige",
            "Grey"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 132,
        "newPrice": 122,
        "extra": "Extra 10%"
    },
    {
        "id": 1193,
        "title": "Frisian Custom Flame Retardant Curtain",
        "ProductUrl": "/custom-blackout-curtain/custom-flame-retardant-blackout-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "967",
        "_fabric_color": [
            {
                "term_id": 970,
                "gallery": [
                    108284,
                    105618,
                    108283,
                    108282,
                    108281
                ],
                "imgSrc": "/cdn/shop/files/black-3-6-500x500.png",
                "imgSrc_n": "/cdn/shop/files/black-3-6.png",
                "imgSrcF": "/cdn/shop/files/black-9.jpg",
                "price": 40,
                "title": "Frisian / Black",
                "color": "Black"
            },
            {
                "term_id": 969,
                "gallery": [
                    108296,
                    105618,
                    108295,
                    108294,
                    108293
                ],
                "imgSrc": "/cdn/shop/files/red-3-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/red-3-1.png",
                "imgSrcF": "/cdn/shop/files/Red-6.jpg",
                "price": 40,
                "title": "Frisian / Red",
                "color": "Red"
            },
            {
                "term_id": 968,
                "gallery": [
                    108288,
                    105618,
                    108287,
                    108286,
                    108285
                ],
                "imgSrc": "/cdn/shop/files/darkblue-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/darkblue-3.png",
                "imgSrcF": "/cdn/shop/files/Dark-Blue.jpg",
                "price": 40,
                "title": "Frisian / Dark Blue",
                "color": "Blue"
            },
            {
                "term_id": 967,
                "gallery": [
                    108292,
                    105618,
                    108291,
                    108290,
                    108289
                ],
                "imgSrc": "/cdn/shop/files/grey-3-10-500x500.png",
                "imgSrc_n": "/cdn/shop/files/grey-3-10.png",
                "imgSrcF": "/cdn/shop/files/Grey-5.jpg",
                "price": 40,
                "title": "Frisian / Grey",
                "color": "Grey"
            },
            {
                "term_id": 32158,
                "gallery": [
                    108299,
                    105618,
                    108298,
                    108297,
                    108300
                ],
                "imgSrc": "/cdn/shop/files/white-2-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/white-2-2.png",
                "imgSrcF": "/cdn/shop/files/greyishwhite.jpg",
                "price": 40,
                "title": "Frisian / Greyish White",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "Flame Retardant Curtains",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Search curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Spring Time Sale",
            "同材质内衬面料分类",
            "绍兴-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "fire-frisian",
                "name": "fire Frisian"
            },
            {
                "slug": "frisian",
                "name": "Frisian"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            },
            {
                "slug": "thanksgiving-20",
                "name": "Thanksgiving 20%"
            }
        ],
        "short_description": "<p style=\"margin-bottom: 10px;\">WIDE COMPATIBILITY: Since this panel is NFPA certified, it is perfect for schools, hospitals, offices, dorm rooms, nursing homes, or any other place where flame retardant curtains are required.</p>\r\n<p style=\"margin-bottom: 10px;\">AMAZING FABRIC: 100% inherent flame retardant (fire resistant) polyester fiber, non-toxic, smokeless, eco-friendly, extinguish immediately when leaving the fire. Each Fire Resistant Curtain sews a wash mark with a flame retardant mark. Please acknowledge the logo when you receive the curtain.</p>\r\n<p style=\"margin-bottom: 10px;\">MULTIPLE FUNCTIONS: This flame retardant curtain provides safety and protection for your home. And blocks out 85%-99% of light, insulate thermally and saves up to 25% heating and cooling costs.</p>\r\nFrisian\r\nBlack\r\nBlack out curtains\r\nBlack curtains\r\n\r\nfire retardant\r\n\r\n<span class=\"keyword _ngcontent-ome-121\" aria-hidden=\"false\">fireproof</span>\r\n<div aria-label=\"\">flame resistant</div>\r\n<div aria-label=\"\">fire proof curtains</div>",
        "imgSrc": "/cdn/shop/files/grey-3-10-500x500.png",
        "hoverImg": "/cdn/shop/files/grey-6-500x500.jpg",
        "subheading": "Custom Flame Retardant Curtain",
        "Fabrics": [
            "Frisian"
        ],
        "Feature": [],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Black",
            "Red",
            "Blue",
            "Grey",
            "White"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 153,
        "newPrice": 101,
        "extra": "Extra 10%"
    },
    {
        "id": 1171,
        "title": "Hussein 4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/hussein-thermal-blackout-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "696",
        "_fabric_color": [
            {
                "term_id": 696,
                "gallery": [
                    106002,
                    106004,
                    106005,
                    106008,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/22-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/22.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-ok.jpg",
                "price": 55,
                "title": "Hussein / Beige",
                "color": "Beige"
            },
            {
                "term_id": 711,
                "gallery": [
                    106014,
                    106010,
                    106012,
                    106011,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/24-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/24.jpg",
                "imgSrcF": "/cdn/shop/files/Cappuccino-ok.jpg",
                "price": 55,
                "title": "Hussein / Cappuccino",
                "color": "Brown"
            },
            {
                "term_id": 733,
                "gallery": [
                    106035,
                    106036,
                    106038,
                    106039,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/20-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/20-1.jpg",
                "imgSrcF": "/cdn/shop/files/Pure-White-ok.jpg",
                "price": 55,
                "title": "Hussein / Pure White",
                "color": "White"
            },
            {
                "term_id": 720,
                "gallery": [
                    106047,
                    106048,
                    106049,
                    106050,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/18-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/18.jpg",
                "imgSrcF": "/cdn/shop/files/Grayish-White-ok.jpg",
                "price": 55,
                "title": "Hussein / Greyish White",
                "color": "White"
            },
            {
                "term_id": 703,
                "gallery": [
                    106053,
                    106054,
                    106055,
                    106057,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/3.jpg",
                "imgSrcF": "/cdn/shop/files/Black-ok.jpg",
                "price": 55,
                "title": "Hussein / Black",
                "color": "Black"
            },
            {
                "term_id": 722,
                "gallery": [
                    106061,
                    106062,
                    106063,
                    106064,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-6-800x800-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-1-6-800x800-1.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-ok.jpg",
                "price": 55,
                "title": "Hussein / Grey",
                "color": "Grey"
            },
            {
                "term_id": 734,
                "gallery": [
                    106066,
                    106067,
                    106068,
                    106069,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4.jpg",
                "imgSrcF": "/cdn/shop/files/red-ok-1.jpg",
                "price": 55,
                "title": "Hussein / Red",
                "color": "Red"
            },
            {
                "term_id": 728,
                "gallery": [
                    106070,
                    106071,
                    106072,
                    106073,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/27-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/27.jpg",
                "imgSrcF": "/cdn/shop/files/navyblue-ok.jpg",
                "price": 55,
                "title": "Hussein / Navy Blue",
                "color": "Blue"
            },
            {
                "term_id": 748,
                "gallery": [
                    106074,
                    106075,
                    106076,
                    106077,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/29-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/29.jpg",
                "imgSrcF": "/cdn/shop/files/Yellow-ok.jpg",
                "price": 55,
                "title": "Hussein / Yellow",
                "color": "Yellow"
            },
            {
                "term_id": 745,
                "gallery": [
                    106078,
                    106079,
                    106080,
                    106081,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/25-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/25.jpg",
                "imgSrcF": "/cdn/shop/files/Teal-Blue-ok.jpg",
                "price": 55,
                "title": "Hussein / Teal Blue",
                "color": "Blue"
            },
            {
                "term_id": 740,
                "gallery": [
                    106082,
                    106083,
                    106084,
                    106085,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/13-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/13.jpg",
                "imgSrcF": "/cdn/shop/files/Stone-Blue-ok.jpg",
                "price": 55,
                "title": "Hussein / Stone Blue",
                "color": "Blue"
            },
            {
                "term_id": 738,
                "gallery": [
                    106086,
                    106087,
                    106088,
                    106089,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/10-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/10.jpg",
                "imgSrcF": "/cdn/shop/files/Sea-Teal-ok-1.png",
                "price": 55,
                "title": "Hussein / Sea Teal",
                "color": "Blue"
            },
            {
                "term_id": 730,
                "gallery": [
                    106092,
                    106093,
                    106095,
                    106096,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/34-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/34.jpg",
                "imgSrcF": "/cdn/shop/files/Olive-Green-ok.jpg",
                "price": 55,
                "title": "Hussein / Olive Green",
                "color": "Green"
            },
            {
                "term_id": 723,
                "gallery": [
                    106104,
                    106103,
                    106106,
                    106109,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/16-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/16.jpg",
                "imgSrcF": "/cdn/shop/files/Hunter-Green-ok.jpg",
                "price": 55,
                "title": "Hussein / Hunter Green",
                "color": "Green"
            },
            {
                "term_id": 713,
                "gallery": [
                    106113,
                    106114,
                    106115,
                    106117,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/14-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/14.jpg",
                "imgSrcF": "/cdn/shop/files/Coffee-ok.jpg",
                "price": 55,
                "title": "Hussein / Coffee",
                "color": "Brown"
            },
            {
                "term_id": 704,
                "gallery": [
                    106118,
                    106120,
                    106121,
                    106122,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/12-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/12.jpg",
                "imgSrcF": "/cdn/shop/files/Brick-Red-ok.jpg",
                "price": 55,
                "title": "Hussein / Brick Red",
                "color": "Brown"
            },
            {
                "term_id": 725,
                "gallery": [
                    106123,
                    106124,
                    106125,
                    106126,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/lightbeige-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/lightbeige-1.jpg",
                "imgSrcF": "/cdn/shop/files/Light-Beige-ok.jpg",
                "price": 55,
                "title": "Hussein / Light Beige",
                "color": "Beige"
            },
            {
                "term_id": 747,
                "gallery": [
                    106127,
                    106128,
                    106129,
                    106131,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/31-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/31.jpg",
                "imgSrcF": "/cdn/shop/files/Tender-Cyan-ok.jpg",
                "price": 55,
                "title": "Hussein / Tender Cyan",
                "color": "Green"
            },
            {
                "term_id": 1077,
                "gallery": [
                    106155,
                    106156,
                    106157,
                    106159,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/11-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/11.jpg",
                "imgSrcF": "/cdn/shop/files/Hussein-Sand-ok.jpg",
                "price": 55,
                "title": "Hussein / Sand Color",
                "color": "Grey"
            },
            {
                "term_id": 1076,
                "gallery": [
                    106162,
                    106163,
                    106165,
                    106166,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/6.jpg",
                "imgSrcF": "/cdn/shop/files/Hussein-Light-pink-ok.jpg",
                "price": 55,
                "title": "Hussein / Light Pink",
                "color": "Pink"
            },
            {
                "term_id": 1075,
                "gallery": [
                    106170,
                    106171,
                    106172,
                    106173,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/8.jpg",
                "imgSrcF": "/cdn/shop/files/Hussein-blue-green-ok.jpg",
                "price": 55,
                "title": "Hussein / Blue Green",
                "color": "Green"
            },
            {
                "term_id": 1074,
                "gallery": [
                    106174,
                    106175,
                    106176,
                    106177,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Hussein-Vintage-blue.jpg",
                "price": 55,
                "title": "Hussein / Vintage Blue",
                "color": "Blue"
            },
            {
                "term_id": 1073,
                "gallery": [
                    106178,
                    106179,
                    106180,
                    106181,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/26-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/26.jpg",
                "imgSrcF": "/cdn/shop/files/Hussein-Silver-Grey-ok.jpg",
                "price": 55,
                "title": "Hussein / Silver Grey",
                "color": "Grey"
            },
            {
                "term_id": 1072,
                "gallery": [
                    106194,
                    106195,
                    106196,
                    106197,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/8-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/8-1.jpg",
                "imgSrcF": "/cdn/shop/files/Hussein-Sea-blue-ok.jpg",
                "price": 55,
                "title": "Hussein / Sea Blue",
                "color": "Blue"
            },
            {
                "term_id": 717,
                "gallery": [
                    106214,
                    106215,
                    106216,
                    106217,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/36-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/36.jpg",
                "imgSrcF": "/cdn/shop/files/Deep-Purple-ok.jpg",
                "price": 55,
                "title": "Hussein / Deep Purple",
                "color": "Purple"
            },
            {
                "term_id": 1069,
                "gallery": [
                    106218,
                    106219,
                    106220,
                    106221,
                    99530,
                    43447,
                    98724
                ],
                "imgSrc": "/cdn/shop/files/5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/5.jpg",
                "imgSrcF": "/cdn/shop/files/Eggplant-purple-ok.jpg",
                "price": 55,
                "title": "Hussein / Eggplant Purple",
                "color": "Purple"
            },
            {
                "term_id": 96083,
                "gallery": [
                    106223,
                    106224,
                    106225,
                    106226,
                    99530,
                    43447,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/4-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-1.jpg",
                "imgSrcF": "/cdn/shop/files/Burgundy-Red.jpg",
                "price": 55,
                "title": "Hussein / Burgundy Red",
                "color": "Red"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "4 layer",
            "All Curtain Sale",
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Cyber Monday",
            "Easter Sale",
            "Extra 10%",
            "Factory products",
            "Fall Collection",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Oeko",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search dust",
            "Search soundproof",
            "Search thermal",
            "Soundproof &amp; Blackout Curtains",
            "Spring Time Sale",
            "summer best seller",
            "Synthetic Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "绍兴-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "hussein",
                "name": "Hussein"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "oeko",
                "name": "OEKO"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "thermal",
                "name": "Thermal"
            },
            {
                "slug": "thermal-curtains",
                "name": "thermal curtains"
            }
        ],
        "short_description": "<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \" style=\"border-radius: 0px;\"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\">\r\n<p style=\"margin-bottom: 20px;\">These four-layered curtains are the best problem solved: 100% blackout, soundproof, heat insulation, and dust absorbing. Allow the dust to settle down on the curtain by preventing them from entering your house. They will not get folded easily, and they last long by resisting strict conditions.</p>\r\n\r\n</article></div>\r\n</section></div>\r\n<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \" style=\"border-radius: 0px;\"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\">\r\n<p style=\"margin-bottom: 20px;\">Dust is a considerable problem anytime. Dirty places, primary work locations, need cleaning supplies and the workforce to clean surfaces all the time. Trying to maintain cleanliness is expensive and complicated. Our industrial curtains are removable, practical barriers that help control dust and fumes. They can reduce workplace noises and be adjusted or reinstalled to work around interior and exterior projects. They are composed of two layers of blackout cloth and two lining layers. One of the blackout clothes is always grayish white</p>\r\n\r\n</article></div>\r\n</section></div>",
        "imgSrc": "/cdn/shop/files/22-800x800.jpg",
        "hoverImg": "/cdn/shop/files/Beige-4-500x500.jpg",
        "subheading": "4 Layers OEKO Certified Soundproof Thermal 100% Blackout Anti-Dust Premium Custom Curtain",
        "Fabrics": [
            "Hussein"
        ],
        "Feature": [
            "Anti-Dust",
            "Soundproof",
            "Thermal"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Brown",
            "White",
            "White",
            "Black",
            "Grey",
            "Red",
            "Blue",
            "Yellow",
            "Blue",
            "Blue",
            "Blue",
            "Green",
            "Green",
            "Brown",
            "Brown",
            "Beige",
            "Green",
            "Grey",
            "Pink",
            "Green",
            "Blue",
            "Grey",
            "Blue",
            "Purple",
            "Purple",
            "Red"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 170,
        "newPrice": 119,
        "extra": "Extra 10%"
    },
    {
        "id": 31662,
        "title": "Cronin Linen Look Blackout Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/cronin-linen-blackout-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "31703",
        "_fabric_color": [
            {
                "term_id": 31703,
                "gallery": [
                    106462,
                    106463,
                    106464,
                    106469,
                    106468,
                    106467,
                    106466,
                    106465
                ],
                "imgSrc": "/cdn/shop/files/natural-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/natural.jpg",
                "imgSrcF": "/cdn/shop/files/natural.png",
                "price": 40,
                "title": "Cronin / Natural",
                "color": "Beige"
            },
            {
                "term_id": 31700,
                "gallery": [
                    106470,
                    106471,
                    106472,
                    50914,
                    50915,
                    50916,
                    50917,
                    50919,
                    50920
                ],
                "imgSrc": "/cdn/shop/files/sagegreen-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/sagegreen-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Sea-Green-2-300x300-1.png",
                "price": 40,
                "title": "Cronin / Sage Green",
                "color": "Green"
            },
            {
                "term_id": 31694,
                "gallery": [
                    106475,
                    106474,
                    106473,
                    50914,
                    50915,
                    50916,
                    50917,
                    50919,
                    50920
                ],
                "imgSrc": "/cdn/shop/files/silvergrey-2-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/silvergrey-2-2.jpg",
                "imgSrcF": "/cdn/shop/files/silvergrey.png",
                "price": 40,
                "title": "Cronin / Sliver Grey",
                "color": "Grey"
            },
            {
                "term_id": 102203,
                "gallery": [
                    106453,
                    106455,
                    106454,
                    50914,
                    50915,
                    102201,
                    102195,
                    102200,
                    102196,
                    102199
                ],
                "imgSrc": "/cdn/shop/files/beige-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/beige-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-2-3.png",
                "price": 40,
                "title": "Cronin / Beige",
                "color": "Grey"
            },
            {
                "term_id": 102210,
                "gallery": [
                    106458,
                    106457,
                    106456,
                    106468,
                    106469,
                    106467
                ],
                "imgSrc": "/cdn/shop/files/camel-2-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/camel-2-3.jpg",
                "imgSrcF": "/cdn/shop/files/Camel-3-1.png",
                "price": 40,
                "title": "Cronin / Camel",
                "color": "Orange"
            },
            {
                "term_id": 102208,
                "gallery": [
                    106459,
                    106461,
                    106460,
                    50914,
                    50915,
                    102166,
                    102168,
                    102165,
                    102163,
                    102167
                ],
                "imgSrc": "/cdn/shop/files/ivory-1-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/ivory-1-3.jpg",
                "imgSrcF": "/cdn/shop/files/Ivory-White-3-1-300x300-1.png",
                "price": 40,
                "title": "Cronin / Ivory",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 54949,
                "gallery": null,
                "price": 0,
                "title": "White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Linen Curtains",
            "Blackout Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Black Friday",
            "Cotton Blend Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Cyber Monday",
            "Easter Sale",
            "Extra 10%",
            "Factory products",
            "Fall Collection",
            "Faux Linen Curtains",
            "flash_categories",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Spring Time Sale",
            "summer best seller",
            "同材质内衬面料分类",
            "绍兴-单层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "cronin",
                "name": "Cronin"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "signature",
                "name": "signature"
            }
        ],
        "short_description": "These durable and elegant linen blend blackout curtains will decorate your windows and rooms with a new feel. Ideal for bedrooms, living rooms, kitchens, patios, room dividers, practical and modern. While saving energy and reducing noise, it creates a transparent, breathable and rustic style.\r\n<p class=\"atrst\" style=\"margin-bottom: 20px;\">Linen blackout curtains bring casual warmth and sophisticated style to a room. The weave of natural fibers creates dimensional highs and lows for added depth. This curtain is an elegant choice for any room in your home. Lab tests show that these awesome curtain panels are eco-friendly and vinyl-free.</p>",
        "imgSrc": "/cdn/shop/files/Natural-2--500x500.jpg",
        "hoverImg": "/cdn/shop/files/Honeyview_112-8-500x500.jpg",
        "subheading": "Linen Look Blackout Custom Curtain",
        "Fabrics": [
            "Cronin"
        ],
        "Feature": [],
        "Material": [
            "Faux Linen",
            "Linen",
            "Polyester"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Green",
            "Grey",
            "Orange",
            "Beige"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 146,
        "newPrice": 102,
        "extra": "Extra 10%"
    },
    {
        "id": 35822,
        "title": "Laborien 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/custom-size-soundproof-blackout-cross-weave-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "30317",
        "_fabric_color": [
            {
                "term_id": 39608,
                "gallery": [
                    106905,
                    106904,
                    45590,
                    45591,
                    45592,
                    99530,
                    45596,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/kgorge_52134_httpss.mj_.runXCbpO1PSrNU_a_curtain_on_a_window_som_24d8f6eb-6801-427c-a6c0-9d40fe58e419-copy-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/kgorge_52134_httpss.mj_.runXCbpO1PSrNU_a_curtain_on_a_window_som_24d8f6eb-6801-427c-a6c0-9d40fe58e419-copy-3.jpg",
                "imgSrcF": "/cdn/shop/files/12-1-2.jpg",
                "price": 50,
                "title": "Laborien / White",
                "color": "White"
            },
            {
                "term_id": 30317,
                "gallery": [
                    106881,
                    106883,
                    106882,
                    106885,
                    106884,
                    105594,
                    99530,
                    45596,
                    99116,
                    106886
                ],
                "imgSrc": "/cdn/shop/files/grey1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/grey1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Grey.jpg",
                "price": 50,
                "title": "Laborien / Grey",
                "color": "Grey"
            },
            {
                "term_id": 30319,
                "gallery": [
                    106888,
                    106887,
                    106889,
                    106891,
                    106890,
                    43202,
                    99530,
                    45596,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/greyblue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/greyblue-1.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-Blue.jpg",
                "price": 50,
                "title": "Laborien / Grey-Blue",
                "color": "Blue"
            },
            {
                "term_id": 30320,
                "gallery": [
                    106895,
                    106894,
                    106893,
                    45590,
                    45592,
                    106897,
                    105586,
                    99530,
                    45596,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/lakeblue-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/lakeblue-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/28.jpg",
                "price": 50,
                "title": "Laborien / Lake-Blue",
                "color": "Blue"
            },
            {
                "term_id": 30324,
                "gallery": [
                    106875,
                    106869,
                    106871,
                    106870,
                    106874,
                    106873,
                    99530,
                    45596,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/kgorge_52134_httpss.mj_.runXCbpO1PSrNU_a_curtain_on_a_window_som_24d8f6eb-6801-427c-a6c0-9d40fe58e419-copy-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/kgorge_52134_httpss.mj_.runXCbpO1PSrNU_a_curtain_on_a_window_som_24d8f6eb-6801-427c-a6c0-9d40fe58e419-copy.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-6.jpg",
                "price": 50,
                "title": "Laborien / Beige",
                "color": "Beige"
            },
            {
                "term_id": 32156,
                "gallery": [
                    106878,
                    106876,
                    106877,
                    45590,
                    106880,
                    106879,
                    99530,
                    45596,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/coffee-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/coffee-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/Laborien-3.png",
                "price": 50,
                "title": "Laborien / Coffee",
                "color": "Brown"
            },
            {
                "term_id": 940,
                "gallery": [
                    106901,
                    106902,
                    106903,
                    43178,
                    43182,
                    43181,
                    99530,
                    99116,
                    43452
                ],
                "imgSrc": "/cdn/shop/files/0_0-4-copy-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/0_0-4-copy-2.jpg",
                "imgSrcF": "/cdn/shop/files/Laborien-2.png",
                "price": 50,
                "title": "Laborien / Red",
                "color": "Red"
            },
            {
                "term_id": 39605,
                "gallery": [
                    106899,
                    106898,
                    106900,
                    43178,
                    43182,
                    43181,
                    99530,
                    99116,
                    45596
                ],
                "imgSrc": "/cdn/shop/files/kgorge_52134_httpss.mj_.runXCbpO1PSrNU_a_curtain_on_a_window_som_24d8f6eb-6801-427c-a6c0-9d40fe58e419-copy-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/kgorge_52134_httpss.mj_.runXCbpO1PSrNU_a_curtain_on_a_window_som_24d8f6eb-6801-427c-a6c0-9d40fe58e419-copy-1.jpg",
                "imgSrcF": "/cdn/shop/files/Labronain-navy-blue.png",
                "price": 50,
                "title": "Laborien / Navy Blue",
                "color": "Blue"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "4 layer",
            "All Bestsellers",
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Cyber Monday",
            "Extra 10%",
            "Factory products",
            "Fall Collection",
            "Faux Linen Curtains",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Search blackout",
            "Search curtains",
            "Search soundproof",
            "Search thermal",
            "Soundproof &amp; Blackout Curtains",
            "Spring Time Sale",
            "summer best seller",
            "Synthetic Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "绍兴-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "3-layers-collections",
                "name": "3 layers collections"
            },
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "laborien",
                "name": "Laborien"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "signature",
                "name": "signature"
            },
            {
                "slug": "thermal-thermal-insulated-thermal-window-curtains-thermal-insulated-curtains-insulated",
                "name": "Thermal Thermal insulated Thermal window curtains Thermal Insulated Curtains Insulated"
            }
        ],
        "short_description": "Laborien\r\n\r\nThe eco-friendly polyester fabric offers a natural dark environment for the night shift worker who has to sleep during the day. Good quality finishing will withstand years of use. In some cases, light can still be seen on the edges of the curtain. The deeper the color, the better the blackout effect it can provide. Blackout curtains are made of polyester, an excellent fabric for blackout curtains; they are smooth, durable, strong, and low-cost. This fabric is also easy-to-clean, and it can hold out against wrinkling.\r\nTheHues_Blackout\r\nTheHues_Blackout_Petit\r\nBlackout curtains\r\nblackout\r\nTheHues_Blackout\r\nTheHues_Blackout_Petit\r\n100% blackout\r\nBlack\r\nBlack out curtains\r\nBlack curtains",
        "imgSrc": "/cdn/shop/files/grey-blue-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Beige-6-7-500x500.jpg",
        "subheading": "4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain",
        "Fabrics": [
            "Laborien"
        ],
        "Feature": [
            "Anti-Dust",
            "Soundproof",
            "Thermal"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White",
            "Grey",
            "Blue",
            "Blue",
            "Beige",
            "Brown",
            "Red",
            "Blue"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 178,
        "newPrice": 125,
        "extra": "Extra 10%"
    },
    {
        "id": 95285,
        "title": "Impression Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "ProductUrl": "/custom-curtains/custom-impression-foil-printed-velvet-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95490",
        "_fabric_color": [
            {
                "term_id": 95482,
                "gallery": [
                    96592,
                    95794,
                    95802,
                    95799,
                    95795,
                    95800,
                    95796,
                    95801,
                    95798,
                    95797
                ],
                "imgSrc": "/cdn/shop/files/BF-577-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-577-1.png",
                "imgSrcF": "/cdn/shop/files/BF-577-1.png",
                "price": 50,
                "title": "Impression / Cream",
                "color": "White"
            },
            {
                "term_id": 95477,
                "gallery": [
                    96597,
                    95794,
                    95802,
                    95799,
                    95795,
                    95800,
                    95796,
                    95801,
                    95798,
                    95797
                ],
                "imgSrc": "/cdn/shop/files/BF-577-6-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-577-6.png",
                "imgSrcF": "/cdn/shop/files/BF-577-6-2.png",
                "price": 50,
                "title": "Impression / Gold",
                "color": "Gold"
            },
            {
                "term_id": 95478,
                "gallery": [
                    96596,
                    95794,
                    95802,
                    95799,
                    95795,
                    95800,
                    95796,
                    95801,
                    95798,
                    95797
                ],
                "imgSrc": "/cdn/shop/files/BF-577-5-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-577-5.png",
                "imgSrcF": "/cdn/shop/files/BF-577-5-2.png",
                "price": 50,
                "title": "Impression / Pink",
                "color": "Pink"
            },
            {
                "term_id": 95479,
                "gallery": [
                    96595,
                    95794,
                    95802,
                    95799,
                    95795,
                    95800,
                    95796,
                    95801,
                    95798,
                    95797
                ],
                "imgSrc": "/cdn/shop/files/BF-577-4-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-577-4.png",
                "imgSrcF": "/cdn/shop/files/BF-577-4-2.png",
                "price": 50,
                "title": "Impression / Blue",
                "color": "Blue"
            },
            {
                "term_id": 95480,
                "gallery": [
                    96594,
                    95794,
                    95802,
                    95799,
                    95795,
                    95800,
                    95796,
                    95801,
                    95798,
                    95797
                ],
                "imgSrc": "/cdn/shop/files/BF-577-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-577-3.png",
                "imgSrcF": "/cdn/shop/files/BF-577-3-2.png",
                "price": 50,
                "title": "Impression / Grey Blue",
                "color": "Blue"
            },
            {
                "term_id": 95481,
                "gallery": [
                    96593,
                    95802,
                    95794,
                    95799,
                    95795,
                    95800,
                    95796,
                    95801,
                    95798,
                    95797
                ],
                "imgSrc": "/cdn/shop/files/BF-577-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-577-2.png",
                "imgSrcF": "/cdn/shop/files/BF-577-2-2.png",
                "price": 50,
                "title": "Impression / Lit",
                "color": "Beige"
            },
            {
                "term_id": 95490,
                "gallery": [
                    95794,
                    95802,
                    95799,
                    96599,
                    95795,
                    95800,
                    95796,
                    95801,
                    95798,
                    95797
                ],
                "imgSrc": "/cdn/shop/files/Impression-Black-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Impression-Black-1.png",
                "imgSrcF": "/cdn/shop/files/BF-577-8-2.png",
                "price": 50,
                "title": "Impression / Black",
                "color": "Black"
            },
            {
                "term_id": 95491,
                "gallery": [
                    96598,
                    95794,
                    95802,
                    95799,
                    95795,
                    95800,
                    95796,
                    95801,
                    95798,
                    95797
                ],
                "imgSrc": "/cdn/shop/files/BF-577-7-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-577-7.png",
                "imgSrcF": "/cdn/shop/files/BF-577-7-2.png",
                "price": 50,
                "title": "Impression / Teal",
                "color": "Green"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Foil Printed Velvet Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "black custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Sale",
            "Search curtains",
            "Search Foil Print",
            "Search Pinch pleat",
            "Search velvet",
            "Solid Velvet Curtains",
            "upcoming fall",
            "velvet custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": true,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "premiere",
                "name": "premiere"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Impression-Black-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Impression-Black-4-500x500.png",
        "subheading": "Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "Fabrics": [
            "Impression"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "White",
            "Gold",
            "Pink",
            "Blue",
            "Blue",
            "Beige",
            "Black",
            "Green"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 220,
        "newPrice": 154,
        "extra": "Extra 10%"
    },
    {
        "id": 53698,
        "title": "Zoe 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/zoe-thermal-blackout-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "37684",
        "_fabric_color": [
            {
                "term_id": 37684,
                "gallery": [
                    104799,
                    104798,
                    106684,
                    106687,
                    106685,
                    106686,
                    99530,
                    53728,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Ivory-White-1.png",
                "price": 50,
                "title": "Zoe / Ivory white",
                "color": "White"
            },
            {
                "term_id": 37663,
                "gallery": [
                    104799,
                    104798,
                    106688,
                    106689,
                    106691,
                    106690,
                    99530,
                    53728,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Silver-White-3.png",
                "price": 50,
                "title": "Zoe / Silver White",
                "color": "White"
            },
            {
                "term_id": 37681,
                "gallery": [
                    104799,
                    104798,
                    106692,
                    106695,
                    106693,
                    106694,
                    99530,
                    53728,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Haze-Blue-1.png",
                "price": 50,
                "title": "Zoe / Haze Blue",
                "color": "Blue"
            },
            {
                "term_id": 37730,
                "gallery": [
                    104799,
                    104798,
                    106696,
                    106697,
                    106699,
                    106698,
                    99530,
                    53728,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Navy-Blue-3.png",
                "price": 50,
                "title": "Zoe / Navy Blue",
                "color": "Blue"
            },
            {
                "term_id": 41986,
                "gallery": [
                    104799,
                    104798,
                    106700,
                    106703,
                    106702,
                    106701,
                    99530,
                    53728,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Brown-2.png",
                "price": 50,
                "title": "Zoe / Brown",
                "color": "Brown"
            },
            {
                "term_id": 41990,
                "gallery": [
                    104799,
                    104798,
                    106705,
                    106706,
                    106707,
                    106704,
                    99530,
                    53728,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-3.png",
                "price": 50,
                "title": "Zoe / Grey",
                "color": "Grey"
            },
            {
                "term_id": 41988,
                "gallery": [
                    104799,
                    104798,
                    106708,
                    106711,
                    106710,
                    106709,
                    99530,
                    53728,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Caramel-2.png",
                "price": 50,
                "title": "Zoe / Caramel",
                "color": "Beige"
            },
            {
                "term_id": 41984,
                "gallery": [
                    104799,
                    104798,
                    106712,
                    106713,
                    106715,
                    106714,
                    99530,
                    53728,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Angora-3.png",
                "price": 50,
                "title": "Zoe / Angora",
                "color": "Beige"
            },
            {
                "term_id": 41981,
                "gallery": [
                    104799,
                    104798,
                    106716,
                    106717,
                    106718,
                    106720,
                    99530,
                    53728,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Straw-Brown-2-2.png",
                "price": 50,
                "title": "Zoe / Straw Brown",
                "color": "Beige"
            },
            {
                "term_id": 58394,
                "gallery": [
                    104799,
                    104798,
                    106721,
                    106722,
                    106724,
                    106723,
                    99530,
                    43447,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Silver-Grey-3.png",
                "price": 50,
                "title": "Zoe / Silver Grey",
                "color": "Grey"
            },
            {
                "term_id": 102147,
                "gallery": [
                    104799,
                    104798,
                    106726,
                    106727,
                    106728,
                    106729,
                    99530,
                    43447,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Dark-rose-2-1.png",
                "price": 50,
                "title": "Zoe / Dark rose",
                "color": "Grey"
            },
            {
                "term_id": 102145,
                "gallery": [
                    104799,
                    104798,
                    106730,
                    106731,
                    106733,
                    106732,
                    99530,
                    43447,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Sage-green-3-1.png",
                "price": 50,
                "title": "Zoe / Sage green",
                "color": "Grey"
            },
            {
                "term_id": 102142,
                "gallery": [
                    104799,
                    104798,
                    106734,
                    106735,
                    106736,
                    106737,
                    99530,
                    43447,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Stone-blue-2-1.png",
                "price": 50,
                "title": "Zoe / Stone blue",
                "color": "Grey"
            },
            {
                "term_id": 102140,
                "gallery": [
                    104799,
                    104798,
                    106738,
                    106740,
                    106739,
                    106741,
                    99530,
                    43447,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Forest-green-1-1.png",
                "price": 50,
                "title": "Zoe / Forest green",
                "color": "Grey"
            },
            {
                "term_id": 102138,
                "gallery": [
                    104799,
                    104798,
                    106742,
                    106743,
                    106745,
                    106744,
                    99530,
                    43447,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Oatmeal-3-2.png",
                "price": 50,
                "title": "Zoe / Oatmeal",
                "color": "Grey"
            },
            {
                "term_id": 102136,
                "gallery": [
                    104799,
                    104798,
                    106746,
                    106748,
                    106747,
                    106749,
                    99530,
                    43447,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Dark-Green-1-1.png",
                "price": 50,
                "title": "Zoe / Dark Green",
                "color": "Grey"
            },
            {
                "term_id": 102134,
                "gallery": [
                    104799,
                    104798,
                    106751,
                    106750,
                    106753,
                    106752,
                    99530,
                    43447,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-layers-1.jpg",
                "imgSrcF": "/cdn/shop/files/Golden-Brown-3-1.png",
                "price": 50,
                "title": "Zoe / Golden Brown",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Linen Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "4 layer",
            "All Curtain Sale",
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Cyber Monday",
            "Easter Sale",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search dust",
            "Search linen",
            "Search Linen blend curtains",
            "Search soundproof",
            "Solid Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Spring Time Sale",
            "summer best seller",
            "Synthetic Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "绍兴-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "dundee",
                "name": "Dundee"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "Zoe\r\n<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \" style=\"border-radius: 0px;\"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\">\r\n<p style=\"margin-bottom: 20px;\">Made from high-quality materials, these curtains offer a rich and realistic woven texture that adds depth and dimension to any decor. The faux linen fabric has a soft, warm feel that will envelop your room in comfort and create a cozy atmosphere.</p>\r\n<p style=\"margin-bottom: 20px;\">In addition to its beautiful look, these curtains are also highly functional that blocks out light and noise, providing you with a peaceful and dark environment for a good night's sleep. Whether you are looking for a solution for your bedroom, living room, or any other room in your home, these curtains are the perfect choice.</p>\r\n<p style=\"margin-bottom: 20px;\">Customizable to fit your window size, these curtains offer both quality and style, making them a versatile addition to any room. With their elegant look, they are perfect for adding a touch of sophistication to your home, while the blackout feature makes them ideal for creating a comfortable and private space.</p>\r\n\r\n</article></div>\r\n</section></div>\r\n<div class=\"hr hr-invisible avia-builder-el-15 el_after_av_one_full el_before_av_two_fifth \" style=\"height: 35px;\"></div>",
        "imgSrc": "/cdn/shop/files/4-layers-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Ivory-white-10-500x500.jpg",
        "subheading": "4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Custom Curtain",
        "Fabrics": [
            "Zoe"
        ],
        "Feature": [
            "Soundproof"
        ],
        "Material": [
            "Linen",
            "Polyester"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White",
            "White",
            "Blue",
            "Blue",
            "Brown",
            "Grey",
            "Beige",
            "Beige",
            "Beige",
            "Grey"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 172,
        "newPrice": 120,
        "extra": "Extra 10%"
    },
    {
        "id": 59223,
        "title": "Jazlynn 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/jazlynn-thermal-blackout-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "61945",
        "_fabric_color": [
            {
                "term_id": 61677,
                "gallery": [
                    108396,
                    108397,
                    108399,
                    108398,
                    108400,
                    108401,
                    99530,
                    102750,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Coffee-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Coffee-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Coffee-6.jpg",
                "price": 50,
                "title": "Jazlynn / Coffee",
                "color": "Brown"
            },
            {
                "term_id": 61947,
                "gallery": [
                    108385,
                    108388,
                    108389,
                    108386,
                    108390,
                    108387,
                    99530,
                    102750,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/ginger-yellow-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/ginger-yellow-1.jpg",
                "imgSrcF": "/cdn/shop/files/ginger-yellow-4.jpg",
                "price": 50,
                "title": "Jazlynn / Ginger",
                "color": "Gold"
            },
            {
                "term_id": 61948,
                "gallery": [
                    108379,
                    108382,
                    108383,
                    108380,
                    108384,
                    108381,
                    99530,
                    102750,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Ink-blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Ink-blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/Ink-blue-4.jpg",
                "price": 50,
                "title": "Jazlynn / Ink Blue",
                "color": "Blue"
            },
            {
                "term_id": 61946,
                "gallery": [
                    108367,
                    108369,
                    108370,
                    108371,
                    108372,
                    108366,
                    99530,
                    102750,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/silver-gray-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/silver-gray-1.jpg",
                "imgSrcF": "/cdn/shop/files/silver-gray-3.jpg",
                "price": 50,
                "title": "Jazlynn / Silver Gray",
                "color": "Grey"
            },
            {
                "term_id": 61945,
                "gallery": [
                    108373,
                    108374,
                    108376,
                    108375,
                    108378,
                    108377,
                    99530,
                    102750,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/olive-green-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/olive-green-1.jpg",
                "imgSrcF": "/cdn/shop/files/olive-green-6-1.jpg",
                "price": 50,
                "title": "Jazlynn / Olive Green",
                "color": "Green"
            },
            {
                "term_id": 61944,
                "gallery": [
                    108391,
                    108393,
                    108394,
                    108392,
                    108395,
                    108363,
                    99530,
                    102750,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/dustyrose-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/dustyrose-1.jpg",
                "imgSrcF": "/cdn/shop/files/gray-pink-6.jpg",
                "price": 50,
                "title": "Jazlynn / Dusty Rose",
                "color": "Red"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 329,
                "gallery": null,
                "price": 0,
                "title": "Grommet Silver"
            },
            {
                "term_id": 328,
                "gallery": null,
                "price": 0,
                "title": "Grommet Anti Brass"
            },
            {
                "term_id": 612,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 614,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "4 layer",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Easter Sale",
            "Factory products",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Oeko",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search soundproof",
            "Search thermal",
            "Search velvet",
            "Solid Velvet Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "绍兴-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "Sheer shades are lightweight and flexible. This curtain offers a thin layer to filter light which is the perfect solution for anyone who seeks the best of both privacy and light control. The fabric is highly versatile, allowing you to easily modify the filtration of natural lighting.",
        "imgSrc": "/cdn/shop/files/olive-green-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/olive-green-6-1-500x500.jpg",
        "subheading": "4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain",
        "Fabrics": [
            "Jazlynn"
        ],
        "Feature": [
            "Anti-Dust",
            "Soundproof",
            "Thermal"
        ],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Brown",
            "Gold",
            "Blue",
            "Grey",
            "Green",
            "Red"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 160,
        "newPrice": 128,
        "extra": "Extra 10%"
    },
    {
        "id": 64172,
        "title": "Silhouette Linen Blend Woven Sheer Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-silhouette-sheer-linen-blend-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64081",
        "_fabric_color": [
            {
                "term_id": 64081,
                "gallery": [
                    108904,
                    108906,
                    108910,
                    108909,
                    108908,
                    108907,
                    108905,
                    108903
                ],
                "imgSrc": "/cdn/shop/files/Sand-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sand-1.jpg",
                "imgSrcF": "/cdn/shop/files/FA-FT0103-color-1.png",
                "price": 40,
                "title": "Silhouette / Sand",
                "color": "Beige"
            },
            {
                "term_id": 64071,
                "gallery": [
                    108912,
                    108914,
                    108918,
                    108917,
                    108916,
                    108915,
                    108913,
                    108911
                ],
                "imgSrc": "/cdn/shop/files/White-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-1.jpg",
                "imgSrcF": "/cdn/shop/files/FA-FT0103-color-3.png",
                "price": 40,
                "title": "Silhouette / White",
                "color": "White"
            },
            {
                "term_id": 64072,
                "gallery": [
                    108896,
                    108898,
                    108902,
                    108901,
                    108900,
                    108899,
                    108897,
                    108895
                ],
                "imgSrc": "/cdn/shop/files/Ivory-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Ivory-1.jpg",
                "imgSrcF": "/cdn/shop/files/FA-FT0103-color-2.png",
                "price": 40,
                "title": "Silhouette / Ivory",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "15% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "beige custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Easter Sale",
            "farmhouse custom curtains",
            "Faux Linen Curtains",
            "flash_categories",
            "Independence Day",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Sheer Curtains",
            "Outsourced products",
            "pinch pleat custom curtains",
            "Sale",
            "Search curtains",
            "Search faux linen blackout",
            "Search linen",
            "Search Linen blend curtains",
            "Search sheer",
            "Summer",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Sand-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Sand-1-500x500.png",
        "subheading": "Linen Blend Woven Sheer Custom Curtain",
        "Fabrics": [
            "Silhouette"
        ],
        "Feature": [],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "White",
            "White"
        ],
        "Light": [
            "Light Filtering"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 181,
        "newPrice": 154,
        "extra": "Extra 10%"
    },
    {
        "id": 101725,
        "title": "Quinn 100% Blackout OEKO Heavyweight Velvet Custom Curtain",
        "ProductUrl": "/blackout-curtain/quinn-100-blackout-heavyweight-velvet-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "101891",
        "_fabric_color": [
            {
                "term_id": 101891,
                "gallery": [
                    107449,
                    107448,
                    102747,
                    107447,
                    110694
                ],
                "imgSrc": "/cdn/shop/files/Grey-Blue-3-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-Blue-3-3.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-Blue-4-300x300-1.jpg",
                "price": 45,
                "title": "Quinn / Grey Blue",
                "color": "Beige"
            },
            {
                "term_id": 101889,
                "gallery": [
                    107454,
                    107453,
                    102747,
                    107452,
                    110701
                ],
                "imgSrc": "/cdn/shop/files/Light-Brown3-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Light-Brown3-3.jpg",
                "imgSrcF": "/cdn/shop/files/Light-Brown-4-300x300-1.jpg",
                "price": 45,
                "title": "Quinn / Light Brown",
                "color": "Beige"
            },
            {
                "term_id": 101887,
                "gallery": [
                    107438,
                    107437,
                    102747,
                    107436,
                    110696
                ],
                "imgSrc": "/cdn/shop/files/Champagne-3-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Champagne-3-3.jpg",
                "imgSrcF": "/cdn/shop/files/Champagne-4-300x300-1.jpg",
                "price": 45,
                "title": "Quinn / Champagne",
                "color": "Beige"
            },
            {
                "term_id": 101885,
                "gallery": [
                    108887,
                    108888,
                    102747,
                    107824,
                    110695
                ],
                "imgSrc": "/cdn/shop/files/Bone-4-copy-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Bone-4-copy.jpg",
                "imgSrcF": "/cdn/shop/files/Bone-4-300x300-1.jpg",
                "price": 45,
                "title": "Quinn / Bone",
                "color": "Beige"
            },
            {
                "term_id": 101883,
                "gallery": [
                    107446,
                    107445,
                    102747,
                    107444,
                    110699
                ],
                "imgSrc": "/cdn/shop/files/grey-3-3-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/grey-3-3-2.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-4-2-300x300-1.jpg",
                "price": 45,
                "title": "Quinn / Grey",
                "color": "Beige"
            },
            {
                "term_id": 101868,
                "gallery": [
                    107441,
                    107440,
                    102747,
                    107439,
                    110697
                ],
                "imgSrc": "/cdn/shop/files/Chocolate-3-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Chocolate-3-3.jpg",
                "imgSrcF": "/cdn/shop/files/Chocolate-4-300x300-1.jpg",
                "price": 45,
                "title": "Quinn / Chocolate",
                "color": "Beige"
            },
            {
                "term_id": 104246,
                "gallery": [
                    107465,
                    102747,
                    107466,
                    110707
                ],
                "imgSrc": "/cdn/shop/files/wine-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/wine-1.jpg",
                "imgSrcF": "/cdn/shop/files/wine.jpg",
                "price": 45,
                "title": "Quinn / Wine",
                "color": "Beige"
            },
            {
                "term_id": 104244,
                "gallery": [
                    107463,
                    102747,
                    107464,
                    110706
                ],
                "imgSrc": "/cdn/shop/files/teal-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/teal-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/teal-4.jpg",
                "price": 45,
                "title": "Quinn / Teal",
                "color": "Beige"
            },
            {
                "term_id": 104242,
                "gallery": [
                    107461,
                    102747,
                    107462,
                    110705
                ],
                "imgSrc": "/cdn/shop/files/taro-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/taro-1.jpg",
                "imgSrcF": "/cdn/shop/files/taro.jpg",
                "price": 45,
                "title": "Quinn / Taro",
                "color": "Beige"
            },
            {
                "term_id": 104240,
                "gallery": [
                    107459,
                    102747,
                    107460,
                    110704
                ],
                "imgSrc": "/cdn/shop/files/purple-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/purple-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/purple-4.jpg",
                "price": 45,
                "title": "Quinn / Purple",
                "color": "Beige"
            },
            {
                "term_id": 104238,
                "gallery": [
                    107457,
                    102747,
                    107458,
                    110703
                ],
                "imgSrc": "/cdn/shop/files/ocean-blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/ocean-blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/oceanblue.jpg",
                "price": 45,
                "title": "Quinn / Ocean Blue",
                "color": "Beige"
            },
            {
                "term_id": 104236,
                "gallery": [
                    107455,
                    102747,
                    107456,
                    110702
                ],
                "imgSrc": "/cdn/shop/files/navy-blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/navy-blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/navyblue.jpg",
                "price": 45,
                "title": "Quinn / Navy Blue",
                "color": "Beige"
            },
            {
                "term_id": 104234,
                "gallery": [
                    107451,
                    102747,
                    107450,
                    110700
                ],
                "imgSrc": "/cdn/shop/files/khaki-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/khaki-2.jpg",
                "imgSrcF": "/cdn/shop/files/khaki.jpg",
                "price": 45,
                "title": "Quinn / Khaki",
                "color": "Beige"
            },
            {
                "term_id": 104232,
                "gallery": [
                    107442,
                    102747,
                    107443,
                    110698
                ],
                "imgSrc": "/cdn/shop/files/grass-green-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/grass-green-1.jpg",
                "imgSrcF": "/cdn/shop/files/grassgreen.jpg",
                "price": 45,
                "title": "Quinn / Grass Green",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 54949,
                "gallery": null,
                "price": 0,
                "title": "White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Blackout Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Blackout pro Curtain",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Easter Sale",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Synthetic Curtains",
            "华辰-单层",
            "同材质内衬面料分类",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "signature",
                "name": "signature"
            },
            {
                "slug": "velvet-curtains",
                "name": "velvet curtains"
            }
        ],
        "short_description": "These durable and elegant linen blend blackout curtains will decorate your windows and rooms with a new feel. Ideal for bedrooms, living rooms, kitchens, patios, room dividers, practical and modern. While saving energy and reducing noise, it creates a transparent, breathable and rustic style.\r\n<p class=\"atrst\" style=\"margin-bottom: 20px;\">Linen blackout curtains bring casual warmth and sophisticated style to a room. The weave of natural fibers creates dimensional highs and lows for added depth. This curtain is an elegant choice for any room in your home. Lab tests show that these awesome curtain panels are eco-friendly and vinyl-free.</p>",
        "imgSrc": "/cdn/shop/files/grey-3-3-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Grey-3-2-500x500.jpg",
        "subheading": "100% Blackout OEKO Heavyweight Velvet Custom Curtain",
        "Fabrics": [
            "Quinn"
        ],
        "Feature": [],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 187,
        "newPrice": 131,
        "extra": "Extra 10%"
    },
    {
        "id": 36329,
        "title": "Cronin 4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/cronin-thermal-blackout-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "31703",
        "_fabric_color": [
            {
                "term_id": 31703,
                "gallery": [
                    106504,
                    106503,
                    106507,
                    106505,
                    106501,
                    106502,
                    106506,
                    99530,
                    45603,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/natual-2-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/natual-2-2.jpg",
                "imgSrcF": "/cdn/shop/files/natural.png",
                "price": 40,
                "title": "Cronin / Natural",
                "color": "Beige"
            },
            {
                "term_id": 31700,
                "gallery": [
                    106511,
                    106512,
                    106508,
                    106509,
                    106510,
                    106837,
                    99530,
                    45603,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/sage-green-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/sage-green-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Sea-Green-2-300x300-1.png",
                "price": 40,
                "title": "Cronin / Sage Green",
                "color": "Green"
            },
            {
                "term_id": 31694,
                "gallery": [
                    106518,
                    106517,
                    106513,
                    106514,
                    106515,
                    106516,
                    99530,
                    45603,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/silvergrey-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/silvergrey-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/silvergrey.png",
                "price": 40,
                "title": "Cronin / Sliver Grey",
                "color": "Grey"
            },
            {
                "term_id": 102203,
                "gallery": [
                    106476,
                    106477,
                    106482,
                    106483,
                    106478,
                    106480,
                    106479,
                    106481,
                    99530,
                    45603,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/beige-2-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/beige-2-2.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-2-3.png",
                "price": 40,
                "title": "Cronin / Beige",
                "color": "Grey"
            },
            {
                "term_id": 102210,
                "gallery": [
                    106488,
                    106485,
                    106490,
                    106491,
                    106487,
                    106486,
                    106484,
                    106489,
                    99530,
                    45603,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/camel-2-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/camel-2-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Camel-3-1.png",
                "price": 40,
                "title": "Cronin / Camel",
                "color": "Orange"
            },
            {
                "term_id": 102208,
                "gallery": [
                    106493,
                    106492,
                    106498,
                    106500,
                    106495,
                    99530,
                    106496,
                    106494,
                    106499,
                    102750,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/ivory-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/ivory-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/Ivory-White-3-1-300x300-1.png",
                "price": 40,
                "title": "Cronin / Ivory",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "4 layer",
            "All Bestsellers",
            "All Curtain Sale",
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search soundproof",
            "Search thermal",
            "Soundproof &amp; Blackout Curtains",
            "Spring Time Sale",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "绍兴-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "cronin",
                "name": "Cronin"
            },
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "thermal-curtains",
                "name": "thermal curtains"
            }
        ],
        "short_description": "Free",
        "imgSrc": "/cdn/shop/files/Natural-2-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/6-7-500x500.jpg",
        "subheading": "4 Layers Linen Look Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain",
        "Fabrics": [
            "Cronin"
        ],
        "Feature": [
            "Anti-Dust",
            "Soundproof",
            "Thermal"
        ],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Green",
            "Grey",
            "Orange",
            "Beige"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 153,
        "newPrice": 122,
        "extra": "Extra 10%"
    },
    {
        "id": 64167,
        "title": "Aztec Linen Blend Woven Patterned Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-aztec-patterned-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64059",
        "_fabric_color": [
            {
                "term_id": 64059,
                "gallery": [
                    94731,
                    94730,
                    94726,
                    94725,
                    94728,
                    94727,
                    94732,
                    94738
                ],
                "imgSrc": "/cdn/shop/files/2405-6-661-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/2405-6-661-4.jpg",
                "imgSrcF": "/cdn/shop/files/2405-6-661-color-3.png",
                "price": 50,
                "title": "Aztec / Black",
                "color": "Black"
            },
            {
                "term_id": 64057,
                "gallery": [
                    94737,
                    94731,
                    94730,
                    94726,
                    94725,
                    94728,
                    94727,
                    94732
                ],
                "imgSrc": "/cdn/shop/files/2405-6-661-display-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/2405-6-661-display-1.png",
                "imgSrcF": "/cdn/shop/files/2405-6-661-color-1.png",
                "price": 50,
                "title": "Aztec / White",
                "color": "White"
            },
            {
                "term_id": 64058,
                "gallery": [
                    94739,
                    94731,
                    94730,
                    94726,
                    94725,
                    94728,
                    94727,
                    94732
                ],
                "imgSrc": "/cdn/shop/files/2405-6-661-display-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/2405-6-661-display-3.png",
                "imgSrcF": "/cdn/shop/files/2405-6-661-color-4.png",
                "price": 50,
                "title": "Aztec / Lavender Grey",
                "color": "Grey"
            },
            {
                "term_id": 64060,
                "gallery": [
                    94740,
                    94731,
                    94730,
                    94726,
                    94725,
                    94728,
                    94727,
                    94732
                ],
                "imgSrc": "/cdn/shop/files/2405-6-661-display-4-500x500.png",
                "imgSrc_n": "/cdn/shop/files/2405-6-661-display-4.png",
                "imgSrcF": "/cdn/shop/files/2405-6-661-color-2.png",
                "price": 50,
                "title": "Aztec / Light Taro",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Designer Curtains",
            "Linen Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "black custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Designer Curtains",
            "Extra 10%",
            "Faux Linen Curtains",
            "flash_categories",
            "geometric custom curtains",
            "Independence Day",
            "Linen Blend Curtains",
            "Linen Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Sale",
            "Search curtains",
            "Search faux linen blackout",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "upcoming fall",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": true,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "premiere",
                "name": "premiere"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/2405-6-661-4-500x500.jpg",
        "hoverImg": "/cdn/shop/files/2405-6-661-1-500x500.jpg",
        "subheading": "Linen Blend Woven Patterned Custom Curtain",
        "Fabrics": [
            "Aztec"
        ],
        "Feature": [],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Black",
            "White",
            "Grey",
            "Beige"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 152,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 53696,
        "title": "Classic 4 Layers Velvet Heavyweight Soundproof Thermal 100% Blackout Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/classic-velvet-thermal-blackout-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "34966",
        "_fabric_color": [
            {
                "term_id": 34966,
                "gallery": [
                    106520,
                    106521,
                    106522,
                    106524,
                    106523,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/1-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/1-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/black.jpg",
                "price": 50,
                "title": "Classic / Black",
                "color": "Black"
            },
            {
                "term_id": 34908,
                "gallery": [
                    106530,
                    106531,
                    106532,
                    106534,
                    106533,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/11-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/11-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/ivory.jpg",
                "price": 50,
                "title": "Classic / Ivory White",
                "color": "White"
            },
            {
                "term_id": 34935,
                "gallery": [
                    106525,
                    106526,
                    106527,
                    106529,
                    106528,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/2-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/2-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/blushbeige.jpg",
                "price": 50,
                "title": "Classic / Blush Beige",
                "color": "Beige"
            },
            {
                "term_id": 34917,
                "gallery": [
                    106535,
                    106536,
                    106537,
                    106539,
                    106538,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/19-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/19-1.jpg",
                "imgSrcF": "/cdn/shop/files/stoneblue.jpg",
                "price": 50,
                "title": "Classic / Stone Blue",
                "color": "Blue"
            },
            {
                "term_id": 34953,
                "gallery": [
                    106540,
                    106541,
                    106542,
                    106544,
                    106543,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/13-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/13-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/mossgreen.jpg",
                "price": 50,
                "title": "Classic / Moss Green",
                "color": "Green"
            },
            {
                "term_id": 34932,
                "gallery": [
                    106545,
                    106546,
                    106547,
                    106549,
                    106548,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/18-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/18-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/lightgrey.jpg",
                "price": 50,
                "title": "Classic / Light Grey",
                "color": "Grey"
            },
            {
                "term_id": 34959,
                "gallery": [
                    106550,
                    106551,
                    106552,
                    106554,
                    106553,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/14-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/14-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/navyblue.jpg",
                "price": 50,
                "title": "Classic / Navy Blue",
                "color": "Blue"
            },
            {
                "term_id": 34998,
                "gallery": [
                    106555,
                    106556,
                    106557,
                    106559,
                    106558,
                    99731,
                    53701,
                    99116,
                    53702
                ],
                "imgSrc": "/cdn/shop/files/17-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/17-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/grey.jpg",
                "price": 50,
                "title": "Classic / Grey",
                "color": "Grey"
            },
            {
                "term_id": 34923,
                "gallery": [
                    106560,
                    106561,
                    106562,
                    106564,
                    106563,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/22-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/22-1.jpg",
                "imgSrcF": "/cdn/shop/files/warmgold.jpg",
                "price": 50,
                "title": "Classic / Warm Gold",
                "color": "Gold"
            },
            {
                "term_id": 34969,
                "gallery": [
                    106565,
                    106566,
                    106567,
                    106569,
                    106568,
                    99731,
                    53701,
                    99116,
                    53702
                ],
                "imgSrc": "/cdn/shop/files/5-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/5-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/coffee.jpg",
                "price": 50,
                "title": "Classic / Chestnut",
                "color": "Brown"
            },
            {
                "term_id": 34938,
                "gallery": [
                    106570,
                    106571,
                    106572,
                    106574,
                    106573,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/16-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/16-1.jpg",
                "imgSrcF": "/cdn/shop/files/red.jpg",
                "price": 50,
                "title": "Classic / Red",
                "color": "Red"
            },
            {
                "term_id": 34963,
                "gallery": [
                    106575,
                    106576,
                    106577,
                    106579,
                    106578,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/10-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/10-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/darkgreen.jpg",
                "price": 50,
                "title": "Classic / Dark Green",
                "color": "Green"
            },
            {
                "term_id": 34956,
                "gallery": [
                    106580,
                    106581,
                    106582,
                    106584,
                    106583,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/21-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/21-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/tealblue.jpg",
                "price": 50,
                "title": "Classic / Teal Blue",
                "color": "Green"
            },
            {
                "term_id": 34941,
                "gallery": [
                    106585,
                    106586,
                    106587,
                    106589,
                    106588,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/3-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/3-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/burgundy.jpg",
                "price": 50,
                "title": "Classic / Burgundy",
                "color": "Red"
            },
            {
                "term_id": 34913,
                "gallery": [
                    106590,
                    106591,
                    106592,
                    106594,
                    106593,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/4-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/taupe.jpg",
                "price": 50,
                "title": "Classic / Taupe",
                "color": "Brown"
            },
            {
                "term_id": 34929,
                "gallery": [
                    106595,
                    106596,
                    106597,
                    106599,
                    106598,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/9-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/9-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/goldbrown.jpg",
                "price": 50,
                "title": "Classic / Gold Brown",
                "color": "Brown"
            },
            {
                "term_id": 34926,
                "gallery": [
                    106600,
                    106601,
                    106602,
                    106604,
                    106603,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/23-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/23-1.jpg",
                "imgSrcF": "/cdn/shop/files/wildrose.jpg",
                "price": 50,
                "title": "Classic / Wild Rose",
                "color": "Red"
            },
            {
                "term_id": 34972,
                "gallery": [
                    106605,
                    106606,
                    106607,
                    106609,
                    106608,
                    99530,
                    53701,
                    98724,
                    53805
                ],
                "imgSrc": "/cdn/shop/files/12-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/12-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/lightpink.jpg",
                "price": 50,
                "title": "Classic / Light Pink",
                "color": "Pink"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 614,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 612,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "4 layer",
            "All Bestsellers",
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Oeko",
            "Search blackout",
            "Search curtains",
            "Search dust",
            "Search soundproof",
            "Search velvet",
            "Solid Velvet Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Spring Time Sale",
            "summer best seller",
            "Thermal Curtains",
            "velvet custom curtains",
            "同材质内衬面料分类",
            "绍兴-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "luxury",
                "name": "Luxury"
            },
            {
                "slug": "oeko",
                "name": "OEKO"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "<p style=\"margin-bottom: 20px;\">These three-layered curtains are the best problem solved: 100% blackout, soundproof and heat insulation. They will not get folded easily, and they last long by resisting strict conditions. These elegant, luxurious velvet curtain panels will set a perfect relaxation mood of your living room to your bedroom. Velvet curtains impede most light from outside, and they block 100% of harsh sunlight and block the UV light and noise.</p>\r\n<p style=\"margin-bottom: 20px;\">Velvet is environmentally friendly and offers a soft and royal look proving the best window outfit. It is a thick conductive accessory to use in the cold seasons. It has an aesthetic value, and it blends in with different decor styles.</p>\r\nLuxury\r\nVelvet\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
        "imgSrc": "/cdn/shop/files/11-3-500x500.jpg",
        "hoverImg": "/cdn/shop/files/89-500x500.jpg",
        "subheading": "4 Layers Velvet Heavyweight Soundproof Thermal 100% Blackout Custom Curtain",
        "Fabrics": [
            "Classic"
        ],
        "Feature": [
            "Soundproof"
        ],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Black",
            "White",
            "Beige",
            "Blue",
            "Green",
            "Grey",
            "Blue",
            "Grey",
            "Gold",
            "Brown",
            "Red",
            "Green",
            "Green",
            "Red",
            "Brown",
            "Brown",
            "Red",
            "Pink"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 146,
        "newPrice": 120,
        "extra": "Extra 10%"
    },
    {
        "id": 42644,
        "title": "Voy Linen Look Custom Curtain",
        "ProductUrl": "/linen-cotton-curtains/custom-faux-linen-weave-textured-light-filtering-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "42755",
        "_fabric_color": [
            {
                "term_id": 42755,
                "gallery": [
                    109187,
                    109189,
                    109190,
                    109191,
                    109194,
                    109193,
                    109192,
                    109188
                ],
                "imgSrc": "/cdn/shop/files/Beige-1-6-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Beige-1-6-1.jpg",
                "imgSrcF": "/cdn/shop/files/beige-1.png",
                "price": 35,
                "title": "Voy / Beige",
                "color": "Beige"
            },
            {
                "term_id": 42757,
                "gallery": [
                    109199,
                    109197,
                    109198,
                    109200,
                    109202,
                    109195,
                    109201,
                    109196
                ],
                "imgSrc": "/cdn/shop/files/Light-Beige-4-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Light-Beige-4-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/lightbeige-1.png",
                "price": 35,
                "title": "Voy / Light Beige",
                "color": "Beige"
            },
            {
                "term_id": 42759,
                "gallery": [
                    109203,
                    109205,
                    109206,
                    109207,
                    109208,
                    109209,
                    109210,
                    109204
                ],
                "imgSrc": "/cdn/shop/files/Pure-White-1-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Pure-White-1-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/white-3.png",
                "price": 35,
                "title": "Voy / Pure White",
                "color": "White"
            },
            {
                "term_id": 42761,
                "gallery": [
                    109211,
                    109218,
                    109217,
                    109216,
                    109215,
                    109214,
                    109213,
                    109212
                ],
                "imgSrc": "/cdn/shop/files/Silver-Grey-1-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-Grey-1-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/silvergrey-1.png",
                "price": 35,
                "title": "Voy / Silver Gray",
                "color": "Grey"
            },
            {
                "term_id": 42763,
                "gallery": [
                    109223,
                    109219,
                    109220,
                    109222,
                    109224,
                    109225,
                    109226,
                    109221
                ],
                "imgSrc": "/cdn/shop/files/Stone-Blue-3-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Stone-Blue-3-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/stoneblue-2.png",
                "price": 35,
                "title": "Voy / Stone Blue",
                "color": "Blue"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 98227,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Linen Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "Faux Linen Curtains",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "summer best seller",
            "Summer Collection",
            "Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "This single-layer blackout curtain can block 80%-95% of light and UV rays (black works better than white). The eco-friendly polyester fabric offers a natural dark environment for the night shift worker who has to sleep during the day. Good quality finishing will withstand years of use.\r\nIn some cases, light can still be seen on the edges of the curtain. The deeper the color, the better the blackout effect it can provide. Blackout curtains are made of polyester, an excellent fabric for blackout curtains; they are smooth, durable, strong, and low-cost. This fabric is also easy-to-clean, and it can hold out against wrinkling.",
        "imgSrc": "/cdn/shop/files/Light-Beige-4-2-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/light-beige-2-2-500x500.jpg",
        "subheading": "Linen Look Custom Curtain",
        "Fabrics": [
            "Voy"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Beige",
            "White",
            "Grey",
            "Blue"
        ],
        "Light": [
            "Light Filtering"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 134,
        "newPrice": 107,
        "extra": "Extra 10%"
    },
    {
        "id": 101735,
        "title": "Victoria 100% Blackout OEKO Linen Look Heavyweight Custom Curtain",
        "ProductUrl": "/blackout-curtain/victoria-100-blackout-linen-look-heavyweight-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "101903",
        "_fabric_color": [
            {
                "term_id": 101905,
                "gallery": [
                    106919,
                    106922,
                    102747,
                    106920,
                    110686
                ],
                "imgSrc": "/cdn/shop/files/Moss-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Moss-1.jpg",
                "imgSrcF": "/cdn/shop/files/Moss-4-300x300-2.jpg",
                "price": 40,
                "title": "Victoria / Moss",
                "color": "Beige"
            },
            {
                "term_id": 101903,
                "gallery": [
                    106911,
                    106913,
                    102747,
                    106912,
                    110684
                ],
                "imgSrc": "/cdn/shop/files/Hazelnut-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Hazelnut-1.jpg",
                "imgSrcF": "/cdn/shop/files/Hazelnut-4-300x300-2.jpg",
                "price": 40,
                "title": "Victoria / Hazelnut",
                "color": "Beige"
            },
            {
                "term_id": 101901,
                "gallery": [
                    106923,
                    106922,
                    102747,
                    106924,
                    110687
                ],
                "imgSrc": "/cdn/shop/files/Oat-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Oat-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Oat-4-1-300x300-2.jpg",
                "price": 40,
                "title": "Victoria / Oat",
                "color": "Beige"
            },
            {
                "term_id": 101899,
                "gallery": [
                    106907,
                    106908,
                    102747,
                    106909,
                    110681
                ],
                "imgSrc": "/cdn/shop/files/beige-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/beige.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-4-1-300x300-2.jpg",
                "price": 40,
                "title": "Victoria / Beige",
                "color": "Beige"
            },
            {
                "term_id": 101897,
                "gallery": [
                    106927,
                    106930,
                    102747,
                    106928,
                    110688
                ],
                "imgSrc": "/cdn/shop/files/Pink-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Pink-1.jpg",
                "imgSrcF": "/cdn/shop/files/Pink-4.jpg",
                "price": 40,
                "title": "Victoria / Pink",
                "color": "Beige"
            },
            {
                "term_id": 101895,
                "gallery": [
                    106932,
                    106931,
                    102747,
                    106933,
                    110691
                ],
                "imgSrc": "/cdn/shop/files/Silver-White-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-White-1.jpg",
                "imgSrcF": "/cdn/shop/files/Silver-White-4-300x300-2.jpg",
                "price": 40,
                "title": "Victoria / Silver White",
                "color": "Beige"
            },
            {
                "term_id": 101893,
                "gallery": [
                    106916,
                    106915,
                    102747,
                    106917,
                    110685
                ],
                "imgSrc": "/cdn/shop/files/Ivory-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Ivory-1.jpg",
                "imgSrcF": "/cdn/shop/files/Ivory-4-300x300-2.jpg",
                "price": 40,
                "title": "Victoria / Ivory",
                "color": "Beige"
            },
            {
                "term_id": 104261,
                "gallery": [
                    106970,
                    102747,
                    106943,
                    110680
                ],
                "imgSrc": "/cdn/shop/files/2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/2.jpg",
                "imgSrcF": "/cdn/shop/files/ash.jpg",
                "price": 40,
                "title": "Victoria / Ash",
                "color": "Beige"
            },
            {
                "term_id": 104259,
                "gallery": [
                    107374,
                    102747,
                    107376,
                    110682
                ],
                "imgSrc": "/cdn/shop/files/Blue-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Blue-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/blue.jpg",
                "price": 40,
                "title": "Victoria / Blue",
                "color": "Beige"
            },
            {
                "term_id": 104257,
                "gallery": [
                    105568,
                    102747,
                    106939,
                    110683
                ],
                "imgSrc": "/cdn/shop/files/Blue-Grey-copy-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Blue-Grey-copy.jpg",
                "imgSrcF": "/cdn/shop/files/bluegrey.jpg",
                "price": 40,
                "title": "Victoria / Blue Grey",
                "color": "Beige"
            },
            {
                "term_id": 104255,
                "gallery": [
                    106944,
                    102747,
                    106946,
                    110689
                ],
                "imgSrc": "/cdn/shop/files/purple-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/purple-1.jpg",
                "imgSrcF": "/cdn/shop/files/purple.jpg",
                "price": 40,
                "title": "Victoria / Purple",
                "color": "Beige"
            },
            {
                "term_id": 104253,
                "gallery": [
                    106947,
                    102747,
                    106949,
                    110690
                ],
                "imgSrc": "/cdn/shop/files/red-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/red-1.jpg",
                "imgSrcF": "/cdn/shop/files/red.jpg",
                "price": 40,
                "title": "Victoria / Red",
                "color": "Beige"
            },
            {
                "term_id": 104251,
                "gallery": [
                    106975,
                    102747,
                    106952,
                    110692
                ],
                "imgSrc": "/cdn/shop/files/4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4.jpg",
                "imgSrcF": "/cdn/shop/files/taupe.jpg",
                "price": 40,
                "title": "Victoria / Taupe",
                "color": "Beige"
            },
            {
                "term_id": 104248,
                "gallery": [
                    106976,
                    102747,
                    106955,
                    110693
                ],
                "imgSrc": "/cdn/shop/files/1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/1.jpg",
                "imgSrcF": "/cdn/shop/files/teal.jpg",
                "price": 40,
                "title": "Victoria / Teal",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 54949,
                "gallery": null,
                "price": 0,
                "title": "White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Blackout Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Blackout pro Curtain",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Easter Sale",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Synthetic Curtains",
            "华辰-单层",
            "同材质内衬面料分类",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "linen-curtains",
                "name": "linen curtains"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "signature",
                "name": "signature"
            }
        ],
        "short_description": "These durable and elegant linen blend blackout curtains will decorate your windows and rooms with a new feel. Ideal for bedrooms, living rooms, kitchens, patios, room dividers, practical and modern. While saving energy and reducing noise, it creates a transparent, breathable and rustic style.\r\n<p class=\"atrst\" style=\"margin-bottom: 20px;\">Linen blackout curtains bring casual warmth and sophisticated style to a room. The weave of natural fibers creates dimensional highs and lows for added depth. This curtain is an elegant choice for any room in your home. Lab tests show that these awesome curtain panels are eco-friendly and vinyl-free.</p>",
        "imgSrc": "/cdn/shop/files/Hazelnut-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Hazelnut-3-500x500.jpg",
        "subheading": "100% Blackout OEKO Linen Look Heavyweight Custom Curtain",
        "Fabrics": [
            "Victoria"
        ],
        "Feature": [],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 165,
        "newPrice": 116,
        "extra": "Extra 10%"
    },
    {
        "id": 95283,
        "title": "Lana Cotton Blend Lightweight Textured Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-lana-textured-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95475",
        "_fabric_color": [
            {
                "term_id": 95475,
                "gallery": [
                    107224,
                    107229,
                    107230,
                    107239,
                    107227,
                    107226,
                    107225,
                    107228
                ],
                "imgSrc": "/cdn/shop/files/pink-3-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/pink-3-1.png",
                "imgSrcF": "/cdn/shop/files/Pink-8.png",
                "price": 35,
                "title": "Lana / Pink",
                "color": "Pink"
            },
            {
                "term_id": 95474,
                "gallery": [
                    107202,
                    107207,
                    107208,
                    107201,
                    107205,
                    107204,
                    107203,
                    107206
                ],
                "imgSrc": "/cdn/shop/files/Ivory-3-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Ivory-3-2.png",
                "imgSrcF": "/cdn/shop/files/Ivory-3-1.png",
                "price": 35,
                "title": "Lana / Ivory",
                "color": "White"
            },
            {
                "term_id": 95472,
                "gallery": [
                    107186,
                    107191,
                    107192,
                    107185,
                    107189,
                    107188,
                    107187,
                    107190
                ],
                "imgSrc": "/cdn/shop/files/brown-3-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/brown-3-2.png",
                "imgSrcF": "/cdn/shop/files/brown-3-1.png",
                "price": 35,
                "title": "Lana / Brown",
                "color": "Brown"
            },
            {
                "term_id": 95473,
                "gallery": [
                    107217,
                    107223,
                    107222,
                    107216,
                    107220,
                    107219,
                    107218,
                    107221
                ],
                "imgSrc": "/cdn/shop/files/Oatmeal-3-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Oatmeal-3-2.png",
                "imgSrcF": "/cdn/shop/files/Oatmeal-3-1.png",
                "price": 35,
                "title": "Lana / Oatmeal",
                "color": "Beige"
            },
            {
                "term_id": 95476,
                "gallery": [
                    107209,
                    107215,
                    107214,
                    107732,
                    107212,
                    107211,
                    107210,
                    107213
                ],
                "imgSrc": "/cdn/shop/files/moss-3-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/moss-3-1.png",
                "imgSrcF": "/cdn/shop/files/Moss-1-1.png",
                "price": 35,
                "title": "Lana / Moss",
                "color": "Green"
            },
            {
                "term_id": 95483,
                "gallery": [
                    107231,
                    107236,
                    107237,
                    107238,
                    107234,
                    107233,
                    107232,
                    107235
                ],
                "imgSrc": "/cdn/shop/files/stone-3-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/stone-3-1.png",
                "imgSrcF": "/cdn/shop/files/stone-3-8.png",
                "price": 35,
                "title": "Lana / Stone",
                "color": "Grey"
            },
            {
                "term_id": 95484,
                "gallery": [
                    107194,
                    107200,
                    107199,
                    107193,
                    107197,
                    107196,
                    107195,
                    107198
                ],
                "imgSrc": "/cdn/shop/files/grey-3-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/grey-3-2.png",
                "imgSrcF": "/cdn/shop/files/grey-3-1.png",
                "price": 35,
                "title": "Lana / Grey",
                "color": "Grey"
            },
            {
                "term_id": 95485,
                "gallery": [
                    95906,
                    95894,
                    95899,
                    95900,
                    95897,
                    95896,
                    95895,
                    95898
                ],
                "imgSrc": "/cdn/shop/files/Beige-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Beige.png",
                "imgSrcF": "/cdn/shop/files/Beige.png",
                "price": 35,
                "title": "Lana / Beige",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Cotton Curtains",
            "Light Filtering Curtains",
            "Textured Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Cotton Blend Curtains",
            "Cotton Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Independence Day",
            "Light Filtering Curtains",
            "Linen Cotton Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "pinch pleat custom curtains",
            "pink custom curtains",
            "Search cotton",
            "Search curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Textured Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/pink-3-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Pink-2-500x500.png",
        "subheading": "Cotton Blend Lightweight Textured Custom Curtain",
        "Fabrics": [
            "Lana"
        ],
        "Feature": [],
        "Material": [
            "Cotton"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Pink",
            "White",
            "Brown",
            "Beige",
            "Green",
            "Grey",
            "Grey",
            "Beige"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 141,
        "newPrice": 154,
        "extra": "Extra 10%"
    },
    {
        "id": 64160,
        "title": "Mist Patterned Heavyweight Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-mist-patterned-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64061",
        "_fabric_color": [
            {
                "term_id": 64061,
                "gallery": [
                    107344,
                    107345,
                    107343,
                    107346,
                    107351,
                    107347,
                    107349,
                    107348,
                    107350
                ],
                "imgSrc": "/cdn/shop/files/sand-4-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/sand-4-2.png",
                "imgSrcF": "/cdn/shop/files/sand-4-1.png",
                "price": 35,
                "title": "Mist / Sand",
                "color": "Beige"
            },
            {
                "term_id": 64062,
                "gallery": [
                    107328,
                    107329,
                    107326,
                    107330,
                    107327,
                    107331,
                    107333,
                    107332,
                    107325
                ],
                "imgSrc": "/cdn/shop/files/black-4-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/black-4-2.png",
                "imgSrcF": "/cdn/shop/files/black-4-1.png",
                "price": 35,
                "title": "Mist / Black",
                "color": "Black"
            },
            {
                "term_id": 64051,
                "gallery": [
                    107335,
                    107336,
                    107334,
                    107337,
                    107342,
                    107338,
                    107340,
                    107339,
                    107341
                ],
                "imgSrc": "/cdn/shop/files/light-grey-4-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/light-grey-4-2.png",
                "imgSrcF": "/cdn/shop/files/light-grey-3-1.png",
                "price": 35,
                "title": "Mist / Light Grey",
                "color": "Grey"
            },
            {
                "term_id": 64052,
                "gallery": [
                    107317,
                    107318,
                    107316,
                    107319,
                    107324,
                    107320,
                    107322,
                    107321,
                    107323
                ],
                "imgSrc": "/cdn/shop/files/ash-4-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/ash-4-2.png",
                "imgSrcF": "/cdn/shop/files/ash-4-1.png",
                "price": 35,
                "title": "Mist / Ash",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Cotton Curtains",
            "Designer Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "beige custom curtains",
            "Cotton Blend Curtains",
            "Cotton Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Designer Curtains",
            "Extra 10%",
            "flash_categories",
            "heavyweight custom curtains",
            "Independence Day",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Search cotton",
            "Search curtains",
            "Search Pinch pleat",
            "Synthetic Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/sand-4-2-500x500.png",
        "hoverImg": "/cdn/shop/files/Mist-4-500x500.png",
        "subheading": "Patterned Heavyweight Custom Curtain",
        "Fabrics": [
            "Mist"
        ],
        "Feature": [],
        "Material": [
            "Cotton"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Beige",
            "Black",
            "Grey",
            "Grey"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 123,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 95261,
        "title": "Aspen Wool Blend Sweater Soft Textured Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-aspen-wool-textured-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95444",
        "_fabric_color": [
            {
                "term_id": 95444,
                "gallery": [
                    108222,
                    107991,
                    107989,
                    107990,
                    107988,
                    107987,
                    107960
                ],
                "imgSrc": "/cdn/shop/files/taupe1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/taupe1.png",
                "imgSrcF": "/cdn/shop/files/taupe.png",
                "price": 50,
                "title": "Aspen / Taupe",
                "color": "Brown"
            },
            {
                "term_id": 95445,
                "gallery": [
                    108226,
                    107962,
                    107966,
                    107967,
                    107965,
                    107963,
                    107956
                ],
                "imgSrc": "/cdn/shop/files/ashypink-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/ashypink.jpg",
                "imgSrcF": "/cdn/shop/files/ashypink.png",
                "price": 50,
                "title": "Aspen / Ashy PInk",
                "color": "Pink"
            },
            {
                "term_id": 95446,
                "gallery": [
                    108224,
                    107978,
                    107979,
                    107977,
                    107976,
                    107975,
                    107958
                ],
                "imgSrc": "/cdn/shop/files/greengrey-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/greengrey.jpg",
                "imgSrcF": "/cdn/shop/files/greengrey.png",
                "price": 50,
                "title": "Aspen / Green Grey",
                "color": "Grey"
            },
            {
                "term_id": 95448,
                "gallery": [
                    108225,
                    107973,
                    107972,
                    107971,
                    107970,
                    107969,
                    107957
                ],
                "imgSrc": "/cdn/shop/files/camel-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/camel-1.jpg",
                "imgSrcF": "/cdn/shop/files/camel-1.png",
                "price": 50,
                "title": "Aspen / Camel",
                "color": "Pink"
            },
            {
                "term_id": 95449,
                "gallery": [
                    108223,
                    107985,
                    107984,
                    107983,
                    107982,
                    107981,
                    107959
                ],
                "imgSrc": "/cdn/shop/files/moonwalk-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/moonwalk.jpg",
                "imgSrcF": "/cdn/shop/files/moonwalk.png",
                "price": 50,
                "title": "Aspen / Moonwalk",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Cotton Curtains",
            "Textured Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Cotton Blend Curtains",
            "Cotton Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Independence Day",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "pinch pleat custom curtains",
            "Sale",
            "Search cotton",
            "Search curtains",
            "Search Pinch pleat",
            "Textured Curtains",
            "winter custom curtains",
            "Wool Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": true,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "premiere",
                "name": "premiere"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/taupe1-500x500.png",
        "hoverImg": "/cdn/shop/files/Aspen-4-500x500.png",
        "subheading": "Wool Blend Sweater Soft Textured Custom Curtain",
        "Fabrics": [
            "Aspen"
        ],
        "Feature": [],
        "Material": [
            "Cotton",
            "Wool"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Brown",
            "Pink",
            "Grey",
            "Pink",
            "Grey"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 309,
        "newPrice": 278,
        "extra": "Extra 10%"
    },
    {
        "id": 95284,
        "title": "Pebbles Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "ProductUrl": "/custom-curtains/custom-pebbles-foil-printed-velvet-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95541",
        "_fabric_color": [
            {
                "term_id": 95541,
                "gallery": [
                    95818,
                    95821,
                    95820,
                    96543,
                    95819
                ],
                "imgSrc": "/cdn/shop/files/Pebbles-Gold-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Pebbles-Gold-1.png",
                "imgSrcF": "/cdn/shop/files/BF-A10-1-2.png",
                "price": 40,
                "title": "Pebbles / Ivory",
                "color": "White"
            },
            {
                "term_id": 95542,
                "gallery": [
                    96544,
                    95818,
                    95821,
                    95820,
                    95819
                ],
                "imgSrc": "/cdn/shop/files/BF-A10-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-A10-2.png",
                "imgSrcF": "/cdn/shop/files/BF-A10-2-2.png",
                "price": 40,
                "title": "Pebbles / Shimmer",
                "color": "Silver"
            },
            {
                "term_id": 95543,
                "gallery": [
                    96547,
                    95818,
                    95821,
                    95820,
                    95819
                ],
                "imgSrc": "/cdn/shop/files/BF-A10-5-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-A10-5.png",
                "imgSrcF": "/cdn/shop/files/BF-A10-5-2.png",
                "price": 40,
                "title": "Pebbles / Hazy Blue",
                "color": "Blue"
            },
            {
                "term_id": 95544,
                "gallery": [
                    96546,
                    95818,
                    95821,
                    95820,
                    95819
                ],
                "imgSrc": "/cdn/shop/files/BF-A10-4-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-A10-4.png",
                "imgSrcF": "/cdn/shop/files/BF-A10-4-2.png",
                "price": 40,
                "title": "Pebbles / Silver Grey",
                "color": "Grey"
            },
            {
                "term_id": 95548,
                "gallery": [
                    96564,
                    95818,
                    95821,
                    95820,
                    95819
                ],
                "imgSrc": "/cdn/shop/files/BF-A10-7-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-A10-7-2.png",
                "imgSrcF": "/cdn/shop/files/BF-A10-7-2.png",
                "price": 40,
                "title": "Pebbles / Black Gold",
                "color": "Black"
            },
            {
                "term_id": 95545,
                "gallery": [
                    96546,
                    95818,
                    95821,
                    95820,
                    95819
                ],
                "imgSrc": "/cdn/shop/files/BF-A10-4-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-A10-4.png",
                "imgSrcF": "/cdn/shop/files/BF-A10-3-2.png",
                "price": 40,
                "title": "Pebbles / Gold",
                "color": "Gold"
            },
            {
                "term_id": 95547,
                "gallery": [
                    96548,
                    95818,
                    95821,
                    95820,
                    95819
                ],
                "imgSrc": "/cdn/shop/files/BF-A10-6-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-A10-6.png",
                "imgSrcF": "/cdn/shop/files/BF-A10-6-2.png",
                "price": 40,
                "title": "Pebbles / Teal",
                "color": "Cyan"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Foil Printed Velvet Curtains",
            "Light Filtering Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "patterned custom curtains",
            "Sale",
            "Search curtains",
            "Search Pinch pleat",
            "Search velvet",
            "Solid Velvet Curtains",
            "velvet custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Pebbles-Gold-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Pebbles-Gold-4-500x500.png",
        "subheading": "Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "Fabrics": [
            "Pebbles"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "White",
            "Silver",
            "Blue",
            "Grey",
            "Black",
            "Gold",
            "Cyan"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 206,
        "newPrice": 165,
        "extra": "Extra 10%"
    },
    {
        "id": 105173,
        "title": "Glimmer 4 Layers Linen Blend Lightweight Soundproof Thermal Blackout Anti-Dust Textured Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/4-layer-linen-blend-lightweight-soundproof-thermal-blackout-anti-dust-textured-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64073",
        "_fabric_color": [
            {
                "term_id": 64073,
                "gallery": [
                    97628,
                    97630,
                    97629,
                    97627,
                    97631,
                    99530,
                    99116,
                    94748
                ],
                "imgSrc": "/cdn/shop/files/FA-BD4202-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/FA-BD4202-2.png",
                "imgSrcF": "/cdn/shop/files/glimmer-color.png",
                "price": 50,
                "title": "Glimmer / Glimmer",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Linen Curtains",
            "Textured Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "4 layer",
            "All Curtains",
            "beige custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Extra 10%",
            "farmhouse custom curtains",
            "Faux Linen Curtains",
            "flash_categories",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "Search blackout",
            "Search curtains",
            "Search faux linen blackout",
            "Search linen",
            "Search Linen blend curtains",
            "Search thermal",
            "Solid Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Textured Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "外包4家-四层",
            "Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/FA-BD4202-2-500x500.png",
        "hoverImg": "/cdn/shop/files/Glimmer-2-500x500.jpg",
        "subheading": "4 Layers Linen Blend Lightweight Soundproof Thermal Blackout Anti-Dust Textured Custom Curtain",
        "Fabrics": [
            "Glimmer"
        ],
        "Feature": [],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Beige"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 170,
        "newPrice": 115,
        "extra": "Extra 10%"
    },
    {
        "id": 64180,
        "title": "Casablanca Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "ProductUrl": "/custom-curtains/custom-casablanca-foil-printed-velvet-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64137",
        "_fabric_color": [
            {
                "term_id": 64136,
                "gallery": [
                    94756,
                    65395,
                    65397,
                    65399,
                    65396,
                    65393,
                    65401,
                    65400,
                    65394
                ],
                "imgSrc": "/cdn/shop/files/Casablanca-display-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Casablanca-display-1.png",
                "imgSrcF": "/cdn/shop/files/Casablanca-color-7.png",
                "price": 40,
                "title": "Casablanca / Black",
                "color": "Black"
            },
            {
                "term_id": 64137,
                "gallery": [
                    65395,
                    65397,
                    94757,
                    65399,
                    65396,
                    65393,
                    65401,
                    65400,
                    65394
                ],
                "imgSrc": "/cdn/shop/files/Sahara-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sahara-2.jpg",
                "imgSrcF": "/cdn/shop/files/Casablanca-color-1.png",
                "price": 40,
                "title": "Casablanca / Sahara",
                "color": "Gold"
            },
            {
                "term_id": 64138,
                "gallery": [
                    94797,
                    65395,
                    65397,
                    65399,
                    65396,
                    65393,
                    65401,
                    65400,
                    65394
                ],
                "imgSrc": "/cdn/shop/files/Casablanca-display-3-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Casablanca-display-3-1.png",
                "imgSrcF": "/cdn/shop/files/Casablanca-color-2-2.png",
                "price": 40,
                "title": "Casablanca / Grey",
                "color": "Grey"
            },
            {
                "term_id": 64128,
                "gallery": [
                    94759,
                    65395,
                    65397,
                    65399,
                    65396,
                    65393,
                    65401,
                    65400,
                    65394
                ],
                "imgSrc": "/cdn/shop/files/Casablanca-display-4-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Casablanca-display-4.png",
                "imgSrcF": "/cdn/shop/files/Casablanca-color-3.png",
                "price": 40,
                "title": "Casablanca / Hazy Blue",
                "color": "Blue"
            },
            {
                "term_id": 64129,
                "gallery": [
                    94760,
                    65395,
                    65397,
                    65399,
                    65396,
                    65393,
                    65401,
                    65400,
                    65394
                ],
                "imgSrc": "/cdn/shop/files/Casablanca-display-5-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Casablanca-display-5.png",
                "imgSrcF": "/cdn/shop/files/Casablanca-color-4.png",
                "price": 40,
                "title": "Casablanca / Misty",
                "color": "Grey"
            },
            {
                "term_id": 64130,
                "gallery": [
                    94761,
                    65395,
                    65397,
                    65399,
                    65396,
                    65393,
                    65401,
                    65400,
                    65394
                ],
                "imgSrc": "/cdn/shop/files/Casablanca-display-6-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Casablanca-display-6.png",
                "imgSrcF": "/cdn/shop/files/Casablanca-color-5.png",
                "price": 40,
                "title": "Casablanca / Champagne",
                "color": "Gold"
            },
            {
                "term_id": 64131,
                "gallery": [
                    94762,
                    65395,
                    65397,
                    65399,
                    65396,
                    65393,
                    65401,
                    65400,
                    65394
                ],
                "imgSrc": "/cdn/shop/files/Casablanca-display-7-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Casablanca-display-7.png",
                "imgSrcF": "/cdn/shop/files/Casablanca-color-6.png",
                "price": 40,
                "title": "Casablanca / Cream",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Foil Printed Velvet Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "flash_categories",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "patterned custom curtains",
            "Sale",
            "Search curtains",
            "Search Foil Print",
            "Search Pinch pleat",
            "Search velvet",
            "Synthetic Curtains",
            "upcoming fall",
            "velvet custom curtains",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Sahara-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Sahara-6-500x500.jpg",
        "subheading": "Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "Fabrics": [
            "Casablanca"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Black",
            "Gold",
            "Grey",
            "Blue",
            "Grey",
            "Gold",
            "White"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 180,
        "newPrice": 144,
        "extra": "Extra 10%"
    },
    {
        "id": 95270,
        "title": "Ambient Linen Blend Jacquard Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-ambient-linen-blend-textured-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95452",
        "_fabric_color": [
            {
                "term_id": 95452,
                "gallery": [
                    107928,
                    107929,
                    107931,
                    107932,
                    107934,
                    107933,
                    107930,
                    95891
                ],
                "imgSrc": "/cdn/shop/files/Cream-1-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Cream-1-2.png",
                "imgSrcF": "/cdn/shop/files/Cream-1.png",
                "price": 40,
                "title": "Ambient / Cream",
                "color": "Beige"
            },
            {
                "term_id": 95447,
                "gallery": [
                    107949,
                    107950,
                    107952,
                    107953,
                    107954,
                    107955,
                    107951,
                    107903
                ],
                "imgSrc": "/cdn/shop/files/white-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/white-1-1.png",
                "imgSrcF": "/cdn/shop/files/White-6.png",
                "price": 40,
                "title": "Ambient / White",
                "color": "White"
            },
            {
                "term_id": 95453,
                "gallery": [
                    107942,
                    107943,
                    107948,
                    107947,
                    107946,
                    107945,
                    107944,
                    107902
                ],
                "imgSrc": "/cdn/shop/files/silver-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/silver-1-1.png",
                "imgSrcF": "/cdn/shop/files/Silver-1.png",
                "price": 40,
                "title": "Ambient / Silver",
                "color": "Silver"
            },
            {
                "term_id": 95451,
                "gallery": [
                    107935,
                    107936,
                    107941,
                    107940,
                    107939,
                    107938,
                    107937,
                    107901
                ],
                "imgSrc": "/cdn/shop/files/Moss-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Moss-1-1.png",
                "imgSrcF": "/cdn/shop/files/Moss-1.png",
                "price": 40,
                "title": "Ambient / Moss",
                "color": "Green"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Textured Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "beige custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Extra 10%",
            "farmhouse custom curtains",
            "Faux Linen Curtains",
            "Independence Day",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "pinch pleat custom curtains",
            "Sale",
            "Search curtains",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Summer",
            "Textured Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/white-2-1-500x500.png",
        "hoverImg": "/cdn/shop/files/White-6-500x500.png",
        "subheading": "Linen Blend Jacquard Custom Curtain",
        "Fabrics": [
            "Ambient"
        ],
        "Feature": [],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Beige",
            "White",
            "Silver",
            "Green"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 145,
        "newPrice": 102,
        "extra": "Extra 10%"
    },
    {
        "id": 102741,
        "title": "Victoria 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Linen Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/victoria-4-layer-oeko-heavyweight-soundproof-thermal-blackout-linen-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "101895",
        "_fabric_color": [
            {
                "term_id": 101905,
                "gallery": [
                    106963,
                    106962,
                    106920,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Moss-4-copy-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Moss-4-copy-2.jpg",
                "imgSrcF": "/cdn/shop/files/Moss-4-300x300-2.jpg",
                "price": 50,
                "title": "Victoria / Moss",
                "color": "Beige"
            },
            {
                "term_id": 101903,
                "gallery": [
                    106959,
                    106958,
                    106912,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Hazelnut-4-copy-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Hazelnut-4-copy-2.jpg",
                "imgSrcF": "/cdn/shop/files/Hazelnut-4-300x300-2.jpg",
                "price": 50,
                "title": "Victoria / Hazelnut",
                "color": "Beige"
            },
            {
                "term_id": 101901,
                "gallery": [
                    106965,
                    106964,
                    106924,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Oat-4-1-copy-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Oat-4-1-copy-2.jpg",
                "imgSrcF": "/cdn/shop/files/Oat-4-1-300x300-2.jpg",
                "price": 50,
                "title": "Victoria / Oat",
                "color": "Beige"
            },
            {
                "term_id": 101899,
                "gallery": [
                    106957,
                    106956,
                    106910,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Beige-4-1-copy-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Beige-4-1-copy-2.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-4-1-300x300-2.jpg",
                "price": 50,
                "title": "Victoria / Beige",
                "color": "Beige"
            },
            {
                "term_id": 101897,
                "gallery": [
                    106967,
                    106966,
                    101863,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Pink-4-copy-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Pink-4-copy-2.jpg",
                "imgSrcF": "/cdn/shop/files/Pink-4.jpg",
                "price": 50,
                "title": "Victoria / Pink",
                "color": "Beige"
            },
            {
                "term_id": 101895,
                "gallery": [
                    106969,
                    106968,
                    101859,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Silver-White-4-copy-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-White-4-copy-2.jpg",
                "imgSrcF": "/cdn/shop/files/Silver-White-4-300x300-2.jpg",
                "price": 50,
                "title": "Victoria / Silver White",
                "color": "Beige"
            },
            {
                "term_id": 101893,
                "gallery": [
                    106961,
                    106960,
                    106917,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Ivory-4-copy-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Ivory-4-copy-2.jpg",
                "imgSrcF": "/cdn/shop/files/Ivory-4-300x300-2.jpg",
                "price": 50,
                "title": "Victoria / Ivory",
                "color": "Beige"
            },
            {
                "term_id": 104261,
                "gallery": [
                    106941,
                    102747,
                    106943
                ],
                "imgSrc": "/cdn/shop/files/ash-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/ash-1.jpg",
                "imgSrcF": "/cdn/shop/files/ash.jpg",
                "price": 50,
                "title": "Victoria / Ash",
                "color": "Beige"
            },
            {
                "term_id": 104259,
                "gallery": [
                    107377,
                    102747,
                    107376
                ],
                "imgSrc": "/cdn/shop/files/blue-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/blue-4.jpg",
                "imgSrcF": "/cdn/shop/files/blue.jpg",
                "price": 50,
                "title": "Victoria / Blue",
                "color": "Beige"
            },
            {
                "term_id": 104257,
                "gallery": [
                    106972,
                    102747,
                    106939
                ],
                "imgSrc": "/cdn/shop/files/5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/5.jpg",
                "imgSrcF": "/cdn/shop/files/bluegrey.jpg",
                "price": 50,
                "title": "Victoria / Blue Grey",
                "color": "Beige"
            },
            {
                "term_id": 104255,
                "gallery": [
                    106973,
                    102747,
                    106946
                ],
                "imgSrc": "/cdn/shop/files/7-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/7.jpg",
                "imgSrcF": "/cdn/shop/files/purple.jpg",
                "price": 50,
                "title": "Victoria / Purple",
                "color": "Beige"
            },
            {
                "term_id": 104253,
                "gallery": [
                    106974,
                    102747,
                    106949
                ],
                "imgSrc": "/cdn/shop/files/6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/6.jpg",
                "imgSrcF": "/cdn/shop/files/red.jpg",
                "price": 50,
                "title": "Victoria / Red",
                "color": "Beige"
            },
            {
                "term_id": 104251,
                "gallery": [
                    106975,
                    102747,
                    106952
                ],
                "imgSrc": "/cdn/shop/files/4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4.jpg",
                "imgSrcF": "/cdn/shop/files/taupe.jpg",
                "price": 50,
                "title": "Victoria / Taupe",
                "color": "Beige"
            },
            {
                "term_id": 104248,
                "gallery": [
                    106976,
                    102747,
                    106955
                ],
                "imgSrc": "/cdn/shop/files/1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/1.jpg",
                "imgSrcF": "/cdn/shop/files/teal.jpg",
                "price": 50,
                "title": "Victoria / Teal",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Linen Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "4 layer",
            "All Curtains",
            "Blackout pro Curtain",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "flash_categories",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Search blackout",
            "Search curtains",
            "Search soundproof",
            "Solid Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Synthetic Curtains",
            "Thermal Curtains",
            "华辰-四层",
            "同材质内衬面料分类",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "linen-curtains",
                "name": "linen curtains"
            },
            {
                "slug": "signature",
                "name": "signature"
            }
        ],
        "short_description": "These durable and elegant linen blend blackout curtains will decorate your windows and rooms with a new feel. Ideal for bedrooms, living rooms, kitchens, patios, room dividers, practical and modern. While saving energy and reducing noise, it creates a transparent, breathable and rustic style.\r\n<p class=\"atrst\" style=\"margin-bottom: 20px;\">Linen blackout curtains bring casual warmth and sophisticated style to a room. The weave of natural fibers creates dimensional highs and lows for added depth. This curtain is an elegant choice for any room in your home. Lab tests show that these awesome curtain panels are eco-friendly and vinyl-free.</p>",
        "imgSrc": "/cdn/shop/files/Ivory-4-copy-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Oat-3-1-500x500.jpg",
        "subheading": "4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Linen Custom Curtain",
        "Fabrics": [
            "Victoria"
        ],
        "Feature": [],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 162,
        "newPrice": 193,
        "extra": "Extra 10%"
    },
    {
        "id": 95271,
        "title": "Ivy Linen Look Heavyweight Herringbone Textured Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-ivy-textured-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95460",
        "_fabric_color": [
            {
                "term_id": 95460,
                "gallery": [
                    108351,
                    108350,
                    108352,
                    108354,
                    108353,
                    108323
                ],
                "imgSrc": "/cdn/shop/files/Oatmeal-2-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Oatmeal-2-1-1.png",
                "imgSrcF": "/cdn/shop/files/oatmeal-1.png",
                "price": 35,
                "title": "Ivy / Oatmeal",
                "color": "Beige"
            },
            {
                "term_id": 95450,
                "gallery": [
                    108347,
                    108346,
                    108348,
                    108349,
                    108345,
                    108322
                ],
                "imgSrc": "/cdn/shop/files/Moss-3-8-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Moss-3-8.png",
                "imgSrcF": "/cdn/shop/files/moss-8.png",
                "price": 35,
                "title": "Ivy / Moss",
                "color": "Green"
            },
            {
                "term_id": 95457,
                "gallery": [
                    108327,
                    108326,
                    108328,
                    108329,
                    108325,
                    108318
                ],
                "imgSrc": "/cdn/shop/files/Black-3-7-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Black-3-7.png",
                "imgSrcF": "/cdn/shop/files/black-5.png",
                "price": 35,
                "title": "Ivy / Black",
                "color": "Black"
            },
            {
                "term_id": 95458,
                "gallery": [
                    108357,
                    108356,
                    108358,
                    108359,
                    108355,
                    108324
                ],
                "imgSrc": "/cdn/shop/files/Stone-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Stone-3.png",
                "imgSrcF": "/cdn/shop/files/stone.png",
                "price": 35,
                "title": "Ivy / Stone",
                "color": "Grey"
            },
            {
                "term_id": 95459,
                "gallery": [
                    108331,
                    108330,
                    108332,
                    108334,
                    108333,
                    108319
                ],
                "imgSrc": "/cdn/shop/files/Brown-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Brown-2.png",
                "imgSrcF": "/cdn/shop/files/brown.png",
                "price": 35,
                "title": "Ivy / Brown",
                "color": "Brown"
            },
            {
                "term_id": 95461,
                "gallery": [
                    108335,
                    108336,
                    108337,
                    108339,
                    108338,
                    108320
                ],
                "imgSrc": "/cdn/shop/files/Ivory-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Ivory-1-1.png",
                "imgSrcF": "/cdn/shop/files/ivory-3.png",
                "price": 35,
                "title": "Ivy / Ivory",
                "color": "White"
            },
            {
                "term_id": 95462,
                "gallery": [
                    108341,
                    108340,
                    108344,
                    108343,
                    108342,
                    108321
                ],
                "imgSrc": "/cdn/shop/files/Maldives-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Maldives-2.png",
                "imgSrcF": "/cdn/shop/files/maldives.jpg",
                "price": 35,
                "title": "Ivy / Maldives",
                "color": "Green"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Textured Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Easter Sale",
            "Extra 10%",
            "heavyweight custom curtains",
            "Independence Day",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "pinch pleat custom curtains",
            "Sale",
            "Search curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Synthetic Curtains",
            "Textured Curtains",
            "upcoming fall",
            "vintage custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Oatmeal-2-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Oatmeal-3-500x500.png",
        "subheading": "Linen Look Heavyweight Herringbone Textured Custom Curtain",
        "Fabrics": [
            "Ivy"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Beige",
            "Green",
            "Black",
            "Grey",
            "Brown",
            "White",
            "Green"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 135,
        "newPrice": 108,
        "extra": "Extra 10%"
    },
    {
        "id": 64179,
        "title": "Zen Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "ProductUrl": "/custom-curtains/custom-zen-foil-printed-velvet-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64132",
        "_fabric_color": [
            {
                "term_id": 64132,
                "gallery": [
                    94923,
                    65392,
                    94686,
                    65390,
                    65389,
                    65645
                ],
                "imgSrc": "/cdn/shop/files/BF509-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF509-3.png",
                "imgSrcF": "/cdn/shop/files/Frame-1000005879-1.png",
                "price": 50,
                "title": "Zen / Black",
                "color": "Black"
            },
            {
                "term_id": 64122,
                "gallery": [
                    65649,
                    94923,
                    65392,
                    94686,
                    65390,
                    65389
                ],
                "imgSrc": "/-500x500.",
                "imgSrc_n": null,
                "imgSrcF": "/cdn/shop/files/Frame-1000005878-2.png",
                "price": 50,
                "title": "Zen / Silver",
                "color": "Silver"
            },
            {
                "term_id": 64123,
                "gallery": [
                    65648,
                    94923,
                    65392,
                    94686,
                    65390,
                    65389
                ],
                "imgSrc": "/cdn/shop/files/Frame-1000005877-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-1000005877.png",
                "imgSrcF": "/cdn/shop/files/Frame-1000005877-1.png",
                "price": 50,
                "title": "Zen / Brown",
                "color": "Brown"
            },
            {
                "term_id": 64124,
                "gallery": [
                    65647,
                    94923,
                    65392,
                    94686,
                    65390,
                    65389
                ],
                "imgSrc": "/cdn/shop/files/Frame-1000005876-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-1000005876.png",
                "imgSrcF": "/cdn/shop/files/Rectangle-23.png",
                "price": 50,
                "title": "Zen / Gold",
                "color": "Gold"
            },
            {
                "term_id": 64125,
                "gallery": [
                    65646,
                    94923,
                    65392,
                    94686,
                    65390,
                    65389
                ],
                "imgSrc": "/cdn/shop/files/Frame-1000005875-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-1000005875.png",
                "imgSrcF": "/cdn/shop/files/Frame-1000005875-1.png",
                "price": 50,
                "title": "Zen / Cream",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Foil Printed Velvet Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "flash_categories",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Sale",
            "Search curtains",
            "Search Foil Print",
            "Search Pinch pleat",
            "Search velvet",
            "Synthetic Curtains",
            "upcoming fall",
            "velvet custom curtains",
            "Velvet Pattern Curtains",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "primere",
                "name": "primere"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/BF509-3-500x500.png",
        "hoverImg": "/cdn/shop/files/Black-2-2-500x500.jpg",
        "subheading": "Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "Fabrics": [
            "Zen"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Nature"
        ],
        "Color": [
            "Black",
            "Silver",
            "Brown",
            "Gold",
            "Beige"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 230,
        "newPrice": 207,
        "extra": "Extra 10%"
    },
    {
        "id": 64173,
        "title": "Glimmer Linen Blend Lightweight Textured Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-glimmer-linen-blend-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64073",
        "_fabric_color": [
            {
                "term_id": 64073,
                "gallery": [
                    107092,
                    107089,
                    107088,
                    107093,
                    107091,
                    107094,
                    107087,
                    107086
                ],
                "imgSrc": "/cdn/shop/files/Glimmer-2-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Glimmer-2-3.jpg",
                "imgSrcF": "/cdn/shop/files/glimmer-color.png",
                "price": 35,
                "title": "Glimmer / Glimmer",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Textured Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "beige custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Extra 10%",
            "farmhouse custom curtains",
            "Faux Linen Curtains",
            "flash_categories",
            "Independence Day",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "Sale",
            "Search curtains",
            "Search faux linen blackout",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Summer",
            "Textured Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Glimmer-2-3-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Glimmer-1-500x500.jpg",
        "subheading": "Linen Blend Lightweight Textured Custom Curtain",
        "Fabrics": [
            "Glimmer"
        ],
        "Feature": [],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Beige"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 142,
        "newPrice": 99,
        "extra": "Extra 10%"
    },
    {
        "id": 35747,
        "title": "Latvian 4 Layers Linen Blend Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain",
        "ProductUrl": "/linen-cotton-curtains/custom-3-in-1-blackout-soundproof-thermal-linen-texture-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "35762",
        "_fabric_color": [
            {
                "term_id": 35762,
                "gallery": [
                    108735,
                    108737,
                    108736,
                    108734,
                    108738,
                    108739,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/natural-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/natural-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/natural.png",
                "price": 40,
                "title": "Latvian / Natural",
                "color": "Beige"
            },
            {
                "term_id": 96254,
                "gallery": [
                    108753,
                    108755,
                    108754,
                    108752,
                    108756,
                    108757,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/terracotta-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/terracotta-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/terracotta.png",
                "price": 40,
                "title": "Latvian / Terracotta",
                "color": "Red"
            },
            {
                "term_id": 96252,
                "gallery": [
                    108711,
                    108713,
                    108712,
                    108710,
                    108714,
                    108715,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/angora-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/angora-2.jpg",
                "imgSrcF": "/cdn/shop/files/angora-1.png",
                "price": 40,
                "title": "Latvian / Angora",
                "color": "Beige"
            },
            {
                "term_id": 96250,
                "gallery": [
                    108723,
                    108725,
                    108724,
                    108722,
                    108726,
                    108727,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/burlap-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/burlap-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/burlap-1.png",
                "price": 40,
                "title": "Latvian / Burlap",
                "color": "Beige"
            },
            {
                "term_id": 96248,
                "gallery": [
                    108747,
                    108749,
                    108748,
                    108746,
                    108750,
                    108751,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/stoneblue-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/stoneblue-2.jpg",
                "imgSrcF": "/cdn/shop/files/stoneblue.png",
                "price": 40,
                "title": "Latvian / Stone Blue",
                "color": "Blue"
            },
            {
                "term_id": 96246,
                "gallery": [
                    108717,
                    108719,
                    108718,
                    108716,
                    108720,
                    108721,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/brickred-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/brickred-2.jpg",
                "imgSrcF": "/cdn/shop/files/brickred.png",
                "price": 40,
                "title": "Latvian / Brick Red",
                "color": "Red"
            },
            {
                "term_id": 96243,
                "gallery": [
                    108729,
                    108731,
                    108730,
                    108728,
                    108733,
                    108732,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/grey-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/grey-2.jpg",
                "imgSrcF": "/cdn/shop/files/grey-1.png",
                "price": 40,
                "title": "Latvian / Grey",
                "color": "Grey"
            },
            {
                "term_id": 96241,
                "gallery": [
                    108741,
                    108743,
                    108742,
                    108740,
                    108745,
                    108744,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/shell-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/shell-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/shell.png",
                "price": 40,
                "title": "Latvian / Shell",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Linen Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "4 layer",
            "All Bestsellers",
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Search blackout",
            "Search curtains",
            "Search linen",
            "Search soundproof",
            "Search thermal",
            "Soundproof &amp; Blackout Curtains",
            "Synthetic Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "绍兴-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "latvian",
                "name": "Latvian"
            },
            {
                "slug": "thanksgiving-20",
                "name": "Thanksgiving 20%"
            },
            {
                "slug": "thermal-thermal-insulated-thermal-window-curtains-thermal-insulated-curtains-insulated",
                "name": "Thermal Thermal insulated Thermal window curtains Thermal Insulated Curtains Insulated"
            }
        ],
        "short_description": "Latvians\r\n<p style=\"margin-bottom: 20px;\">This three-layered curtains will fulfill all your needs: 100% blackout blocks the light and UV rays, excellent sound deadening.The eco-friendly linen blend fabric offers a natural dark environment for the night shift worker who has to sleep during the day. Good quality finishing will withstand years of use. Soft, easy draping, linen, curtains provide privacy while at the same time letting just enough daylight to keep the room cheered.</p>\r\nTriple-layer curtains are the choice for all situations. They are designed to keep cold air out and warm air in and dampen noise, creating a more peaceful environment inside your home. This fabric is also easy-to-clean, and it can hold out against wrinkling.\r\n\r\n&nbsp;",
        "imgSrc": "/cdn/shop/files/shell-2-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/7-12-500x500.jpg",
        "subheading": "4 Layers Linen Blend Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain",
        "Fabrics": [
            "Latvian"
        ],
        "Feature": [
            "Anti-Dust",
            "Soundproof",
            "Thermal"
        ],
        "Material": [
            "Linen",
            "Linen Blend"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Red",
            "Beige",
            "Blue",
            "Red",
            "Grey",
            "Beige"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 140,
        "newPrice": 125,
        "extra": "Extra 10%"
    },
    {
        "id": 1236,
        "title": "Cracovia Linen Blend Lightweight Airy Textured Custom Curtain",
        "ProductUrl": "/linen-cotton-curtains/custom-loosely-woven-natural-texture-linen-blend-light-filtering-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "1119",
        "_fabric_color": [
            {
                "term_id": 1119,
                "gallery": [
                    108196,
                    108199,
                    108194,
                    108193,
                    108192,
                    108200,
                    108195,
                    108198
                ],
                "imgSrc": "/cdn/shop/files/natural-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/natural-1.jpg",
                "imgSrcF": "/cdn/shop/files/Natural-2.png",
                "price": 40,
                "title": "Cracovia / Natural",
                "color": "White"
            },
            {
                "term_id": 102213,
                "gallery": [
                    108202,
                    108201,
                    108208,
                    108205,
                    108206,
                    108204,
                    108203,
                    108209
                ],
                "imgSrc": "/cdn/shop/files/Oatmeal-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Oatmeal-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Oatmeal-3-1-1.png",
                "price": 40,
                "title": "Cracovia / Oatmeal",
                "color": "Beige"
            },
            {
                "term_id": 102264,
                "gallery": [
                    108235,
                    108240,
                    108238,
                    108237,
                    108236,
                    108241,
                    108239,
                    108242
                ],
                "imgSrc": "/cdn/shop/files/violetblue1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/violetblue1.jpg",
                "imgSrcF": "/cdn/shop/files/Violet-Blue-2.png",
                "price": 40,
                "title": "Cracovia / Violet Blue",
                "color": "Blue"
            },
            {
                "term_id": 102321,
                "gallery": [
                    108165,
                    108168,
                    108167,
                    108166,
                    108173,
                    108172,
                    108170,
                    108171
                ],
                "imgSrc": "/cdn/shop/files/Cream-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Cream-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Cream-3-2.png",
                "price": 40,
                "title": "Cracovia / Cream",
                "color": "Beige"
            },
            {
                "term_id": 102319,
                "gallery": [
                    108156,
                    108161,
                    108160,
                    108158,
                    108159,
                    108157,
                    108162,
                    108163
                ],
                "imgSrc": "/cdn/shop/files/Beige-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Beige-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-3-1.png",
                "price": 40,
                "title": "Cracovia / Beige",
                "color": "Beige"
            },
            {
                "term_id": 102317,
                "gallery": [
                    108174,
                    108179,
                    108177,
                    108176,
                    108178,
                    108175,
                    108180,
                    108181
                ],
                "imgSrc": "/cdn/shop/files/Dark-Grey-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Dark-Grey-1.jpg",
                "imgSrcF": "/cdn/shop/files/Dark-Grey-2.png",
                "price": 40,
                "title": "Cracovia / Dark Grey",
                "color": "Grey"
            },
            {
                "term_id": 102315,
                "gallery": [
                    108138,
                    108143,
                    108142,
                    108140,
                    108144,
                    108141,
                    108139,
                    108145
                ],
                "imgSrc": "/cdn/shop/files/Ash-Blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Ash-Blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/Ash-Blue-3.png",
                "price": 40,
                "title": "Cracovia / Ash Blue",
                "color": "Grey"
            },
            {
                "term_id": 102313,
                "gallery": [
                    108210,
                    108215,
                    108214,
                    108212,
                    108216,
                    108213,
                    108211,
                    108217
                ],
                "imgSrc": "/cdn/shop/files/Steel-Blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Steel-Blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/Steel-Blue-3.png",
                "price": 40,
                "title": "Cracovia / Steel Blue",
                "color": "Grey"
            },
            {
                "term_id": 102311,
                "gallery": [
                    108147,
                    108152,
                    108151,
                    108149,
                    108148,
                    108153,
                    108150,
                    108154
                ],
                "imgSrc": "/cdn/shop/files/Ash-Pink-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Ash-Pink-1.jpg",
                "imgSrcF": "/cdn/shop/files/Ash-Pink-3.png",
                "price": 40,
                "title": "Cracovia / Ash Pink",
                "color": "Grey"
            },
            {
                "term_id": 108244,
                "gallery": [
                    108183,
                    108188,
                    108185,
                    108187,
                    108189,
                    108186,
                    108184,
                    108190
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-3-9.png",
                "price": 40,
                "title": "Cracovia / Grey",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Linen Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Fall Collection",
            "flash_categories",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Search curtains",
            "Search linen",
            "Solid Curtains",
            "Summer Collection",
            "Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            }
        ],
        "short_description": "Cracovia\r\n\r\nMade of 32% linen and 68% polyester fabric in a natural style with an original linen texture. They have better performance in room decoration than ordinary linen curtains. These linen textured curtains provide privacy and block approximately 70-80% of light. They are widely used in various occasions such as living room, bedroom, dining room, attic, villa, etc. The curtains are exquisitely crafted by our senior workers, neatly trimmed, and they can hang naturally, with a tightly woven linen texture.",
        "imgSrc": "/cdn/shop/files/Oatmeal-1-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Cracovia-6-1-500x500.jpg",
        "subheading": "Linen Blend Lightweight Airy Textured Custom Curtain",
        "Fabrics": [
            "Cracovia"
        ],
        "Feature": [],
        "Material": [
            "Linen",
            "Linen Blend"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Blue",
            "Beige",
            "Beige",
            "Grey",
            "Beige"
        ],
        "Light": [
            "Light Filtering"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 129,
        "newPrice": 97,
        "extra": "Extra 10%"
    },
    {
        "id": 102742,
        "title": "Quinn 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/quinn-4-layer-oeko-heavyweight-soundproof-thermal-blackout-velvet-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "101891",
        "_fabric_color": [
            {
                "term_id": 101889,
                "gallery": [
                    107497,
                    107498,
                    107452,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Light-Brown-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Light-Brown-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/Light-Brown-4-300x300-1.jpg",
                "price": 50,
                "title": "Quinn / Light Brown",
                "color": "Beige"
            },
            {
                "term_id": 101891,
                "gallery": [
                    107495,
                    107494,
                    107447,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/grey-blue-4-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/grey-blue-4-2.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-Blue-4-300x300-1.jpg",
                "price": 50,
                "title": "Quinn / Grey Blue",
                "color": "Beige"
            },
            {
                "term_id": 101887,
                "gallery": [
                    107483,
                    107484,
                    107436,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Champagne-4-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Champagne-4-1.jpg",
                "imgSrcF": "/cdn/shop/files/Champagne-4-300x300-1.jpg",
                "price": 50,
                "title": "Quinn / Champagne",
                "color": "Beige"
            },
            {
                "term_id": 101885,
                "gallery": [
                    108883,
                    108884,
                    108885,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Bone-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Bone-1.jpg",
                "imgSrcF": "/cdn/shop/files/Bone-4-300x300-1.jpg",
                "price": 50,
                "title": "Quinn / Bone",
                "color": "Beige"
            },
            {
                "term_id": 101883,
                "gallery": [
                    107492,
                    107493,
                    107444,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/grey-3-1-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/grey-3-1-3.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-4-2-300x300-1.jpg",
                "price": 50,
                "title": "Quinn / Grey",
                "color": "Beige"
            },
            {
                "term_id": 101868,
                "gallery": [
                    107490,
                    107489,
                    107439,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Chocolate3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Chocolate3-1.jpg",
                "imgSrcF": "/cdn/shop/files/Chocolate-4-300x300-1.jpg",
                "price": 50,
                "title": "Quinn / Chocolate",
                "color": "Beige"
            },
            {
                "term_id": 104246,
                "gallery": [
                    107504,
                    107466,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/red-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/red-4.jpg",
                "imgSrcF": "/cdn/shop/files/wine.jpg",
                "price": 50,
                "title": "Quinn / Wine",
                "color": "Beige"
            },
            {
                "term_id": 104244,
                "gallery": [
                    107503,
                    107464,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/teal-4-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/teal-4-1.jpg",
                "imgSrcF": "/cdn/shop/files/teal-4.jpg",
                "price": 50,
                "title": "Quinn / Teal",
                "color": "Beige"
            },
            {
                "term_id": 104242,
                "gallery": [
                    107502,
                    107462,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/taro-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/taro-4.jpg",
                "imgSrcF": "/cdn/shop/files/taro.jpg",
                "price": 50,
                "title": "Quinn / Taro",
                "color": "Beige"
            },
            {
                "term_id": 104240,
                "gallery": [
                    107501,
                    107460,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/purple-4-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/purple-4-1.jpg",
                "imgSrcF": "/cdn/shop/files/purple-4.jpg",
                "price": 50,
                "title": "Quinn / Purple",
                "color": "Beige"
            },
            {
                "term_id": 104238,
                "gallery": [
                    107500,
                    107458,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/ocean-blue-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/ocean-blue.jpg",
                "imgSrcF": "/cdn/shop/files/oceanblue.jpg",
                "price": 50,
                "title": "Quinn / Ocean Blue",
                "color": "Beige"
            },
            {
                "term_id": 104236,
                "gallery": [
                    107499,
                    107456,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/navy-blue-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/navy-blue.jpg",
                "imgSrcF": "/cdn/shop/files/navyblue.jpg",
                "price": 50,
                "title": "Quinn / Navy Blue",
                "color": "Beige"
            },
            {
                "term_id": 104234,
                "gallery": [
                    107496,
                    107450,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/khaki-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/khaki-4.jpg",
                "imgSrcF": "/cdn/shop/files/khaki.jpg",
                "price": 50,
                "title": "Quinn / Khaki",
                "color": "Beige"
            },
            {
                "term_id": 104232,
                "gallery": [
                    107491,
                    107443,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/grass-green-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/grass-green.jpg",
                "imgSrcF": "/cdn/shop/files/grassgreen.jpg",
                "price": 50,
                "title": "Quinn / Grass Green",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "4 layer",
            "All Curtain Sale",
            "All Curtains",
            "Blackout pro Curtain",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Oeko",
            "Outsourced products",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search soundproof",
            "Solid Curtains",
            "Solid Velvet Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Synthetic Curtains",
            "Thermal Curtains",
            "华辰-四层",
            "同材质内衬面料分类",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "signature",
                "name": "signature"
            },
            {
                "slug": "velvet-curtains",
                "name": "velvet curtains"
            }
        ],
        "short_description": "These durable and elegant linen blend blackout curtains will decorate your windows and rooms with a new feel. Ideal for bedrooms, living rooms, kitchens, patios, room dividers, practical and modern. While saving energy and reducing noise, it creates a transparent, breathable and rustic style.\r\n<p class=\"atrst\" style=\"margin-bottom: 20px;\">Linen blackout curtains bring casual warmth and sophisticated style to a room. The weave of natural fibers creates dimensional highs and lows for added depth. This curtain is an elegant choice for any room in your home. Lab tests show that these awesome curtain panels are eco-friendly and vinyl-free.</p>",
        "imgSrc": "/cdn/shop/files/grey-3-1-3-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Grey-3-2-500x500.jpg",
        "subheading": "4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain",
        "Fabrics": [
            "Quinn"
        ],
        "Feature": [],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 276,
        "newPrice": 193,
        "extra": "Extra 10%"
    },
    {
        "id": 1198,
        "title": "Latvian Linen Blend Lightweight Custom Curtain",
        "ProductUrl": "/linen-cotton-curtains/custom-linen-texture-blackout-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "1035",
        "_fabric_color": [
            {
                "term_id": 1035,
                "gallery": [
                    108691,
                    108693,
                    108692,
                    50909,
                    50910
                ],
                "imgSrc": "/cdn/shop/files/Natural-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Natural-1.jpg",
                "imgSrcF": "/cdn/shop/files/natural.jpg",
                "price": 30,
                "title": "Latvian / Natural",
                "color": "Beige"
            },
            {
                "term_id": 1036,
                "gallery": [
                    108696,
                    108698,
                    108697,
                    50909,
                    50910
                ],
                "imgSrc": "/cdn/shop/files/Shell-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Shell-1.jpg",
                "imgSrcF": "/cdn/shop/files/shell.jpg",
                "price": 30,
                "title": "Latvian / Shell",
                "color": "Beige"
            },
            {
                "term_id": 36923,
                "gallery": [
                    108686,
                    108688,
                    108687,
                    50910,
                    50909
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-1-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/grey.png",
                "price": 30,
                "title": "Latvian / Grey",
                "color": "Grey"
            },
            {
                "term_id": 36911,
                "gallery": [
                    108680,
                    108682,
                    108681,
                    50909,
                    50910
                ],
                "imgSrc": "/cdn/shop/files/Brick-Red-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Brick-Red-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/brick.png",
                "price": 30,
                "title": "Latvian / Brick Red",
                "color": "Red"
            },
            {
                "term_id": 36898,
                "gallery": [
                    108677,
                    108679,
                    108678,
                    50909,
                    50910
                ],
                "imgSrc": "/cdn/shop/files/Stone-Blue-1-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Stone-Blue-1-3.jpg",
                "imgSrcF": "/cdn/shop/files/blue.png",
                "price": 30,
                "title": "Latvian / Stone Blue",
                "color": "Blue"
            },
            {
                "term_id": 36886,
                "gallery": [
                    108683,
                    108685,
                    108684,
                    50909,
                    50910
                ],
                "imgSrc": "/cdn/shop/files/Burlap-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Burlap-1.jpg",
                "imgSrcF": "/cdn/shop/files/burlap.png",
                "price": 30,
                "title": "Latvian / Burlap",
                "color": "Brown"
            },
            {
                "term_id": 36874,
                "gallery": [
                    108674,
                    108675,
                    108676,
                    43287,
                    43283
                ],
                "imgSrc": "/cdn/shop/files/Angora-1-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Angora-1-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/angora.png",
                "price": 30,
                "title": "Latvian / Angora",
                "color": "Beige"
            },
            {
                "term_id": 36862,
                "gallery": [
                    108699,
                    108701,
                    108700,
                    43358,
                    43353
                ],
                "imgSrc": "/cdn/shop/files/Terracotta-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Terracotta-1.jpg",
                "imgSrcF": "/cdn/shop/files/terracotta.png",
                "price": 30,
                "title": "Latvian / Terracotta",
                "color": "Red"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 98227,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Linen Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Search blackout",
            "Search curtains",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Summer Collection",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "latvian",
                "name": "Latvian"
            }
        ],
        "short_description": "<p style=\"margin-bottom: 20px;\">This single-layer blackout curtain can block 80%-95% of light and UV rays (black works better than white). The eco-friendly linen blend fabric offers a natural dark environment for the night shift worker who has to sleep during the day. Good quality finishing will withstand years of use. Linen curtain panel available in various home textile colors. Soft, easy draping, linen curtains provide privacy while at the same time letting just enough daylight to keep the room cheered.</p>\r\nIn some cases, light can still be seen on the edges of the curtain. The deeper the color, the better the blackout effect it can provide. Blackout curtains are made of polyester, an excellent fabric for blackout curtains; they are smooth, durable, strong, and low-cost. This fabric is also easy-to-clean, and it can hold out against wrinkling.\r\n\r\nLatvian\r\n\r\n&nbsp;",
        "imgSrc": "/cdn/shop/files/Terracotta-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Terracotta-4-500x500.jpg",
        "subheading": "Linen Blend Lightweight Custom Curtain",
        "Fabrics": [
            "Latvian"
        ],
        "Feature": [],
        "Material": [
            "Linen",
            "Linen Blend"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Beige",
            "Grey",
            "Red",
            "Blue",
            "Brown",
            "Beige",
            "Red"
        ],
        "Light": [
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 106,
        "newPrice": 88,
        "extra": "Extra 10%"
    },
    {
        "id": 1238,
        "title": "Traunsee Cotton Blend Textured Custom Curtain",
        "ProductUrl": "/linen-cotton-curtains/custom-natural-cotton-blend-woolen-spun-light-filtering-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "1120",
        "_fabric_color": [
            {
                "term_id": 1120,
                "gallery": [
                    24132,
                    51032,
                    51033,
                    51034,
                    51035,
                    51037,
                    51038
                ],
                "imgSrc": "/cdn/shop/files/Traunsee-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Traunsee-1.jpg",
                "imgSrcF": "/cdn/shop/files/16.jpg",
                "price": 50,
                "title": "Traunsee / White",
                "color": "White"
            },
            {
                "term_id": 104576,
                "gallery": [
                    104474,
                    104475,
                    51035,
                    51034,
                    51033,
                    51032
                ],
                "imgSrc": "/cdn/shop/files/Denim-Blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Denim-Blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/31.jpg",
                "price": 50,
                "title": "Traunsee / Denim Blue",
                "color": "White"
            },
            {
                "term_id": 104570,
                "gallery": [
                    104480,
                    104481,
                    51035,
                    51034,
                    51033,
                    51032
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-1.jpg",
                "imgSrcF": "/cdn/shop/files/20.jpg",
                "price": 50,
                "title": "Traunsee / Grey",
                "color": "White"
            },
            {
                "term_id": 104574,
                "gallery": [
                    104468,
                    104469,
                    51032,
                    51035,
                    51034,
                    51033
                ],
                "imgSrc": "/cdn/shop/files/Cappuccino-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Cappuccino-1.jpg",
                "imgSrcF": "/cdn/shop/files/Cappuccino-3.jpg",
                "price": 50,
                "title": "Traunsee / Cappuccino",
                "color": "White"
            },
            {
                "term_id": 104572,
                "gallery": [
                    104471,
                    104472,
                    51032,
                    51035,
                    51034,
                    51033
                ],
                "imgSrc": "/cdn/shop/files/dark-grey-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/dark-grey-1.jpg",
                "imgSrcF": "/cdn/shop/files/22.jpg",
                "price": 50,
                "title": "Traunsee / Dark Grey",
                "color": "White"
            },
            {
                "term_id": 104568,
                "gallery": [
                    104477,
                    104478,
                    51032,
                    51035,
                    51034,
                    51033
                ],
                "imgSrc": "/cdn/shop/files/green-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/green-1.jpg",
                "imgSrcF": "/cdn/shop/files/green-3.jpg",
                "price": 50,
                "title": "Traunsee / Green",
                "color": "White"
            },
            {
                "term_id": 104566,
                "gallery": [
                    104593,
                    104594,
                    51032,
                    51035,
                    51034,
                    51033
                ],
                "imgSrc": "/cdn/shop/files/sand-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/sand-1.jpg",
                "imgSrcF": "/cdn/shop/files/30.jpg",
                "price": 50,
                "title": "Traunsee / Sand",
                "color": "White"
            },
            {
                "term_id": 104564,
                "gallery": [
                    107535,
                    107536,
                    51032,
                    51035,
                    51034,
                    51033
                ],
                "imgSrc": "/cdn/shop/files/silvergrey-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/silvergrey-1.jpg",
                "imgSrcF": "/cdn/shop/files/3-3.jpg",
                "price": 50,
                "title": "Traunsee / Silver Grey",
                "color": "White"
            },
            {
                "term_id": 104562,
                "gallery": [
                    104486,
                    104484,
                    51032,
                    51035,
                    51034,
                    51033
                ],
                "imgSrc": "/cdn/shop/files/white-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/white-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-2.jpg",
                "price": 50,
                "title": "Traunsee / Ivory",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 616,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 617,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 98227,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Cotton Curtains",
            "Indoor Sheer Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Black Friday",
            "Cotton Blend Curtains",
            "Cotton Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Cyber Monday",
            "flash_categories",
            "Indoor Sheer Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Search cotton",
            "Search curtains",
            "Solid Curtains",
            "Spring Time Sale",
            "Summer Collection",
            "Curtains"
        ],
        "isBestseller": false,
        "isPremiere": true,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            },
            {
                "slug": "premiere",
                "name": "premiere"
            },
            {
                "slug": "sheer",
                "name": "sheer"
            }
        ],
        "short_description": "Traunsee\r\n<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \" style=\"border-radius: 0px;\"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\">\r\n<p style=\"margin-bottom: 20px;\">Made of 50% cotton and 50% polyester blend fabric, and weighted 310 g/m², natural style with a cross linen texture. The linen texture curtain comes with a tight cross linen texture, and the white cotton yards blend with the texture making it become different and look soft. Have better performance on room decor than normal linen curtains. This linen texture curtain can provide privacy and block about 30% of light. The curtains are exquisite workmanship by our senior workers with neat trimming, curtains hang naturally with a close-woven linen texture. Soft texture, appearance with silky touch backing.</p>\r\n\r\n</article></div>\r\n</section></div>\r\n<div class=\"hr hr-invisible avia-builder-el-15 el_after_av_one_full el_before_av_two_fifth \" style=\"height: 35px;\"></div>",
        "imgSrc": "/cdn/shop/files/Traunsee-1-600x600.jpg",
        "hoverImg": "/cdn/shop/files/Traunsee-5-1-1-500x500.jpg",
        "subheading": "Cotton Blend Textured Custom Curtain",
        "Fabrics": [
            "Traunsee"
        ],
        "Feature": [],
        "Material": [
            "Cotton Blend",
            "Cotton",
            "Sheer"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 146,
        "newPrice": 97,
        "extra": "Extra 10%"
    },
    {
        "id": 1219,
        "title": "Venetian Linen Blend Heavyweight Textured Custom Curtain",
        "ProductUrl": "/linen-cotton-curtains/custom-ivory-linen-cotton-blend-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "1096",
        "_fabric_color": [
            {
                "term_id": 1096,
                "gallery": [
                    109020,
                    109021,
                    109022,
                    109023,
                    109024,
                    109025,
                    109026,
                    51056
                ],
                "imgSrc": "/cdn/shop/files/natural-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/natural-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/6.jpg",
                "price": 40,
                "title": "Venetian / Natural",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 98227,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Linen Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Cyber Monday",
            "Fall Collection",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Search blackout",
            "Search curtains",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "summer best seller",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            }
        ],
        "short_description": "Venetian\r\n\r\nThese curtain panels are made of  70% high-quality, eco-friendly linen &amp; 30% polyester blend fabric and weighted 700 g/m², giving a natural look with a grainy linen texture. This heavyweight linen is masterfully woven for beauty and durability. These curtains can decor your room well, provide privacy as well as block 80% of light out. That is to reduce direct sunlight, create a limited view, and protect your furniture.",
        "imgSrc": "/cdn/shop/files/natural-1-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/3-1-2-500x500.jpg",
        "subheading": "Linen Blend Heavyweight Textured Custom Curtain",
        "Fabrics": [
            "Venetian"
        ],
        "Feature": [],
        "Material": [
            "Linen",
            "Linen Blend"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 138,
        "newPrice": 106,
        "extra": "Extra 10%"
    },
    {
        "id": 95280,
        "title": "Chelsea Cotton Blend Geometric Golden Grid Patterned Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-chelsea-patterned-cotton-blend-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95471",
        "_fabric_color": [
            {
                "term_id": 95470,
                "gallery": [
                    108618,
                    95917,
                    95912,
                    95916,
                    95915,
                    95914,
                    95913
                ],
                "imgSrc": "/cdn/shop/files/Grid-7-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Grid-7.png",
                "imgSrcF": "/cdn/shop/files/Grid-7.png",
                "price": 40,
                "title": "Chelsea / Grid",
                "color": "Brown"
            },
            {
                "term_id": 95469,
                "gallery": [
                    108617,
                    95917,
                    95912,
                    95916,
                    95915,
                    95914,
                    95913
                ],
                "imgSrc": "/cdn/shop/files/Ivory-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Ivory-1-1.png",
                "imgSrcF": "/cdn/shop/files/Ivory-1-1.png",
                "price": 40,
                "title": "Chelsea / Ivory",
                "color": "Beige"
            },
            {
                "term_id": 95471,
                "gallery": [
                    107997,
                    107998,
                    107996,
                    108002,
                    108001,
                    108000,
                    107999
                ],
                "imgSrc": "/cdn/shop/files/circuit-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/circuit-1-1.png",
                "imgSrcF": "/cdn/shop/files/Circuit-1.png",
                "price": 40,
                "title": "Chelsea / Circuit",
                "color": "Blue"
            },
            {
                "term_id": 95465,
                "gallery": [
                    108616,
                    95917,
                    95912,
                    95916,
                    95915,
                    95914,
                    95913
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Grey-1-2.png",
                "imgSrcF": "/cdn/shop/files/Grey-1-2.png",
                "price": 40,
                "title": "Chelsea / Grey",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Cotton Curtains",
            "Designer Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Cotton Blend Curtains",
            "Cotton Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Designer Curtains",
            "geometric custom curtains",
            "Independence Day",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "Sale",
            "Search cotton",
            "Search curtains",
            "Search Pinch pleat",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/circuit-1-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Grid-3-500x500.png",
        "subheading": "Cotton Blend Geometric Golden Grid Patterned Custom Curtain",
        "Fabrics": [
            "Chelsea"
        ],
        "Feature": [],
        "Material": [
            "Cotton"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Brown",
            "Beige",
            "Blue",
            "Grey"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 120,
        "newPrice": 96,
        "extra": "Extra 10%"
    },
    {
        "id": 64168,
        "title": "Deconstructed Linen &#038; Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-deconstructed-wool-linen-blend-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "65275",
        "_fabric_color": [
            {
                "term_id": 65275,
                "gallery": [
                    65286,
                    65287,
                    65290,
                    65289,
                    65288,
                    65285
                ],
                "imgSrc": "/cdn/shop/files/Urban-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Urban-2.jpg",
                "imgSrcF": "/cdn/shop/files/Urban-1.jpg",
                "price": 40,
                "title": "Deconstructed / Urban",
                "color": "Beige"
            },
            {
                "term_id": 65277,
                "gallery": [
                    65294,
                    65286,
                    65287,
                    65290,
                    65289,
                    65288
                ],
                "imgSrc": "/cdn/shop/files/FB-KF0303-Pool-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FB-KF0303-Pool.jpg",
                "imgSrcF": "/cdn/shop/files/FB-KF0303-Pool.jpg",
                "price": 40,
                "title": "Deconstructed / Pool",
                "color": "Green"
            },
            {
                "term_id": 65276,
                "gallery": [
                    65292,
                    65286,
                    65287,
                    65290,
                    65289,
                    65288
                ],
                "imgSrc": "/cdn/shop/files/FB-KF0301-Khaki-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FB-KF0301-Khaki-1.jpg",
                "imgSrcF": "/cdn/shop/files/FB-KF0301-Khaki-1.jpg",
                "price": 40,
                "title": "Deconstructed / Khaki",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Designer Curtains",
            "Linen Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Designer Curtains",
            "Faux Linen Curtains",
            "geometric custom curtains",
            "grey custom curtains",
            "heavyweight custom curtains",
            "Independence Day",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Patterned Curtains",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Sale",
            "Search curtains",
            "Search faux linen blackout",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "winter custom curtains",
            "Wool Curtains",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Urban-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Urban-6-500x500.jpg",
        "subheading": "Linen & Wool Blend Heavyweight Geometric Fringed Patterned Custom Curtain",
        "Fabrics": [
            "Deconstructed"
        ],
        "Feature": [],
        "Material": [
            "Linen",
            "Wool"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Beige",
            "Green",
            "Beige"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 190,
        "newPrice": 152,
        "extra": "Extra 10%"
    },
    {
        "id": 101732,
        "title": "Kensington 100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain",
        "ProductUrl": "/blackout-curtain/kensington-100-blackout-linen-look-smooth-lightweight-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "101758",
        "_fabric_color": [
            {
                "term_id": 101764,
                "gallery": [
                    105608,
                    105607,
                    102747,
                    105606,
                    110711
                ],
                "imgSrc": "/cdn/shop/files/Brown-4-copy-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Brown-4-copy.jpg",
                "imgSrcF": "/cdn/shop/files/Brown-4.jpg",
                "price": 45,
                "title": "Kensington / Brown",
                "color": "Beige"
            },
            {
                "term_id": 101762,
                "gallery": [
                    107156,
                    107157,
                    102747,
                    107155,
                    110710
                ],
                "imgSrc": "/cdn/shop/files/Terracotta-3-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Terracotta-3-2.jpg",
                "imgSrcF": "/cdn/shop/files/Terracotta-4-300x300-1.jpg",
                "price": 45,
                "title": "Kensington / Terracotta",
                "color": "Beige"
            },
            {
                "term_id": 101760,
                "gallery": [
                    105612,
                    105613,
                    102747,
                    105614,
                    110709
                ],
                "imgSrc": "/cdn/shop/files/Sand-3-copy-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sand-3-copy.jpg",
                "imgSrcF": "/cdn/shop/files/Sand-3-300x300-1.jpg",
                "price": 45,
                "title": "Kensington / Sand",
                "color": "Beige"
            },
            {
                "term_id": 101758,
                "gallery": [
                    107150,
                    107151,
                    102747,
                    107149,
                    110708
                ],
                "imgSrc": "/cdn/shop/files/grey-3-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/grey-3-2.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-4-300x300-1.jpg",
                "price": 45,
                "title": "Kensington / Grey",
                "color": "Beige"
            },
            {
                "term_id": 101736,
                "gallery": [
                    107146,
                    107147,
                    102747,
                    107145,
                    110712
                ],
                "imgSrc": "/cdn/shop/files/Cream-3-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Cream-3-2.jpg",
                "imgSrcF": "/cdn/shop/files/Cream-4-300x300-1.jpg",
                "price": 45,
                "title": "Kensington / Cream",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 54949,
                "gallery": null,
                "price": 0,
                "title": "White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Blackout Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Blackout pro Curtain",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Synthetic Curtains",
            "华辰-单层",
            "同材质内衬面料分类",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "linen-curtains",
                "name": "linen curtains"
            },
            {
                "slug": "new-arrival",
                "name": "New Arrival"
            },
            {
                "slug": "signature",
                "name": "signature"
            }
        ],
        "short_description": "These durable and elegant linen blend blackout curtains will decorate your windows and rooms with a new feel. Ideal for bedrooms, living rooms, kitchens, patios, room dividers, practical and modern. While saving energy and reducing noise, it creates a transparent, breathable and rustic style.\r\n<p class=\"atrst\" style=\"margin-bottom: 20px;\">Linen blackout curtains bring casual warmth and sophisticated style to a room. The weave of natural fibers creates dimensional highs and lows for added depth. This curtain is an elegant choice for any room in your home. Lab tests show that these awesome curtain panels are eco-friendly and vinyl-free.</p>",
        "imgSrc": "/cdn/shop/files/Brown-3-3-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Brown-3-1-500x500.jpg",
        "subheading": "100% Blackout OEKO Linen Look Smooth Lightweight Custom Curtain",
        "Fabrics": [
            "Kensington"
        ],
        "Feature": [],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 145,
        "newPrice": 131,
        "extra": "Extra 10%"
    },
    {
        "id": 102738,
        "title": "Kensington 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Linen Look Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/kensington-4-layer-oeko-heavyweight-soundproof-thermal-blackout-anti-dust-linen-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "101758",
        "_fabric_color": [
            {
                "term_id": 101764,
                "gallery": [
                    107164,
                    107163,
                    107165,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/brown-4-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/brown-4-2.jpg",
                "imgSrcF": "/cdn/shop/files/Brown-4.jpg",
                "price": 50,
                "title": "Kensington / Brown",
                "color": "Beige"
            },
            {
                "term_id": 101762,
                "gallery": [
                    107176,
                    107175,
                    107177,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/terracotta-4-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/terracotta-4-2.jpg",
                "imgSrcF": "/cdn/shop/files/Terracotta-4-300x300-1.jpg",
                "price": 50,
                "title": "Kensington / Terracotta",
                "color": "Beige"
            },
            {
                "term_id": 101760,
                "gallery": [
                    107173,
                    107172,
                    107174,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/sand-4-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/sand-4-2.jpg",
                "imgSrcF": "/cdn/shop/files/Sand-3-300x300-1.jpg",
                "price": 50,
                "title": "Kensington / Sand",
                "color": "Beige"
            },
            {
                "term_id": 101758,
                "gallery": [
                    107170,
                    107169,
                    107171,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/grey-4-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/grey-4-2.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-4-300x300-1.jpg",
                "price": 50,
                "title": "Kensington / Grey",
                "color": "Beige"
            },
            {
                "term_id": 101736,
                "gallery": [
                    107167,
                    107166,
                    107168,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/cream-4-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/cream-4-2.jpg",
                "imgSrcF": "/cdn/shop/files/Cream-4-300x300-1.jpg",
                "price": 50,
                "title": "Kensington / Cream",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Linen Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "4 layer",
            "All Curtain Sale",
            "All Curtains",
            "Blackout pro Curtain",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "flash_categories",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search soundproof",
            "Solid Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Synthetic Curtains",
            "Thermal Curtains",
            "华辰-四层",
            "同材质内衬面料分类",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "linen-curtains",
                "name": "linen curtains"
            },
            {
                "slug": "signature",
                "name": "signature"
            }
        ],
        "short_description": "These durable and elegant linen blend blackout curtains will decorate your windows and rooms with a new feel. Ideal for bedrooms, living rooms, kitchens, patios, room dividers, practical and modern. While saving energy and reducing noise, it creates a transparent, breathable and rustic style.\r\n<p class=\"atrst\" style=\"margin-bottom: 20px;\">Linen blackout curtains bring casual warmth and sophisticated style to a room. The weave of natural fibers creates dimensional highs and lows for added depth. This curtain is an elegant choice for any room in your home. Lab tests show that these awesome curtain panels are eco-friendly and vinyl-free.</p>",
        "imgSrc": "/cdn/shop/files/grey-4-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/grey-4-3-500x500.jpg",
        "subheading": "4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Linen Look Custom Curtain",
        "Fabrics": [
            "Kensington"
        ],
        "Feature": [],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 171,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 1199,
        "title": "Laborien Linen Look Textured Custom Curtain",
        "ProductUrl": "/linen-cotton-curtains/custom-linen-cotton-all-style-solid-blackout-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "30317",
        "_fabric_color": [
            {
                "term_id": 936,
                "gallery": [
                    106841,
                    106842,
                    106840,
                    50956,
                    50957,
                    50958,
                    50960,
                    50961
                ],
                "imgSrc": "/cdn/shop/files/Beige-6-copy-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Beige-6-copy.jpg",
                "imgSrcF": "/cdn/shop/files/Laborien-7.png",
                "price": 35,
                "title": "Laborien / Beige",
                "color": "Beige"
            },
            {
                "term_id": 940,
                "gallery": [
                    106861,
                    106862,
                    106864,
                    50956,
                    50957,
                    50958,
                    103738,
                    50961
                ],
                "imgSrc": "/cdn/shop/files/Laborien-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Laborien-2.jpg",
                "imgSrcF": "/cdn/shop/files/Laborien-2.png",
                "price": 35,
                "title": "Laborien / Red",
                "color": "Red"
            },
            {
                "term_id": 939,
                "gallery": [
                    106851,
                    106852,
                    106850,
                    50955,
                    50956,
                    50957,
                    50958,
                    50960,
                    50961
                ],
                "imgSrc": "/cdn/shop/files/Grey-Blue-copy-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-Blue-copy.jpg",
                "imgSrcF": "/cdn/shop/files/Laborien-5.png",
                "price": 35,
                "title": "Laborien / Grey-Blue",
                "color": "Blue"
            },
            {
                "term_id": 937,
                "gallery": [
                    106857,
                    106856,
                    106854,
                    50955,
                    50956,
                    50957,
                    50958,
                    50960,
                    50961
                ],
                "imgSrc": "/cdn/shop/files/Lake-Blue-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Lake-Blue-2.jpg",
                "imgSrcF": "/cdn/shop/files/Laborien-4.png",
                "price": 35,
                "title": "Laborien / Lake-Blue",
                "color": "Blue"
            },
            {
                "term_id": 109930,
                "gallery": [
                    106867,
                    106868,
                    106866,
                    50955,
                    50956,
                    50957,
                    50958,
                    50960
                ],
                "imgSrc": "/cdn/shop/files/White-2-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-2-3.jpg",
                "imgSrcF": "/cdn/shop/files/Laborien-1.png",
                "price": 35,
                "title": "Laborien / White",
                "color": "White"
            },
            {
                "term_id": 32156,
                "gallery": [
                    106845,
                    106844,
                    50955,
                    50956,
                    50957,
                    50958,
                    50960,
                    50961
                ],
                "imgSrc": "/cdn/shop/files/Coffee-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Coffee-2.jpg",
                "imgSrcF": "/cdn/shop/files/Laborien-3.png",
                "price": 35,
                "title": "Laborien / Coffee",
                "color": "Brown"
            },
            {
                "term_id": 39605,
                "gallery": [
                    106860,
                    106859,
                    103736,
                    50955,
                    50956,
                    50957,
                    50958,
                    50960
                ],
                "imgSrc": "/cdn/shop/files/Labronain-navy-blue-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Labronain-navy-blue.jpg",
                "imgSrcF": "/cdn/shop/files/Labronain-navy-blue.png",
                "price": 35,
                "title": "Laborien / Navy Blue",
                "color": "Blue"
            },
            {
                "term_id": 30317,
                "gallery": [
                    106848,
                    106849,
                    50955,
                    50956,
                    50957,
                    50958,
                    50960
                ],
                "imgSrc": "/cdn/shop/files/Grey-copy-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-copy.jpg",
                "imgSrcF": "/cdn/shop/files/Grey.jpg",
                "price": 35,
                "title": "Laborien / Grey",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Linen Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Factory products",
            "Fall Collection",
            "Faux Linen Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Search blackout",
            "Search cotton",
            "Search curtains",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Summer Collection",
            "Synthetic Curtains",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "laborien",
                "name": "Laborien"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "This single-layer blackout curtain can block 80%-95% of light and UV rays (black works better than white). The eco-friendly polyester fabric offers a natural dark environment for the night shift worker who has to sleep during the day. Good quality finishing will withstand years of use.\r\nIn some cases, light can still be seen on the edges of the curtain. The deeper the color, the better the blackout effect it can provide. Blackout curtains are made of polyester, an excellent fabric for blackout curtains; they are smooth, durable, strong, and low-cost. This fabric is also easy-to-clean, and it can hold out against wrinkling.\r\n\r\nLaborien\r\nBlack\r\nBlack out curtains\r\nBlack curtains",
        "imgSrc": "/cdn/shop/files/Grey-7-600x600.jpg",
        "hoverImg": "/cdn/shop/files/grey-fmmd-4-500x500.jpg",
        "subheading": "Linen Look Textured Custom Curtain",
        "Fabrics": [
            "Laborien"
        ],
        "Feature": [],
        "Material": [
            "Faux Linen",
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Red",
            "Blue",
            "Blue",
            "White",
            "Brown",
            "Blue",
            "Grey"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 111,
        "newPrice": 88,
        "extra": "Extra 10%"
    },
    {
        "id": 64162,
        "title": "Peacock Linen Blend Heavyweight Floral Patterned Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-peacock-linen-blend-printed-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64069",
        "_fabric_color": [
            {
                "term_id": 64069,
                "gallery": [
                    65730,
                    64397,
                    64395,
                    64399,
                    64400,
                    64398,
                    64396
                ],
                "imgSrc": "/cdn/shop/files/Frame-41-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-41.png",
                "imgSrcF": "/cdn/shop/files/Frame-41.png",
                "price": 50,
                "title": "Peacock / Spring",
                "color": "Beige"
            },
            {
                "term_id": 64075,
                "gallery": [
                    107408,
                    107409,
                    107414,
                    107410,
                    107412,
                    107413,
                    107411
                ],
                "imgSrc": "/cdn/shop/files/summer-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/summer-1.jpg",
                "imgSrcF": "/cdn/shop/files/summer-1.png",
                "price": 50,
                "title": "Peacock / Summer",
                "color": "Green"
            },
            {
                "term_id": 64074,
                "gallery": [
                    107403,
                    107401,
                    107407,
                    107400,
                    107406,
                    107405,
                    107404,
                    107402
                ],
                "imgSrc": "/cdn/shop/files/fall-3-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/fall-3-2.png",
                "imgSrcF": "/cdn/shop/files/fall-3-1.jpg",
                "price": 50,
                "title": "Peacock / Fall",
                "color": "White"
            },
            {
                "term_id": 64068,
                "gallery": [
                    65731,
                    64397,
                    64395,
                    64399,
                    64398,
                    64400,
                    64396
                ],
                "imgSrc": "/cdn/shop/files/Frame-42-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-42.png",
                "imgSrcF": "/cdn/shop/files/Frame-42.png",
                "price": 50,
                "title": "Peacock / Winter",
                "color": "Black"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Designer Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Designer Curtains",
            "Easter Sale",
            "farmhouse custom curtains",
            "Faux Linen Curtains",
            "flash_categories",
            "floral custom curtains",
            "heavyweight custom curtains",
            "Independence Day",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "Sale",
            "Search curtains",
            "Search faux linen blackout",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "vintage custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/fall-3-2-500x500.png",
        "hoverImg": "/cdn/shop/files/fall-3-1-500x500.jpg",
        "subheading": "Linen Blend Heavyweight Floral Patterned Custom Curtain",
        "Fabrics": [
            "Peacock"
        ],
        "Feature": [],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Floral"
        ],
        "Color": [
            "Beige",
            "Green",
            "White",
            "Black"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 183,
        "newPrice": 146,
        "extra": "Extra 10%"
    },
    {
        "id": 101734,
        "title": "Florence 100% Blackout OEKO Heavyweight Woven Textured Custom Curtain",
        "ProductUrl": "/blackout-curtain/florence-100-blackout-heavyweight-woven-textured-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "101822",
        "_fabric_color": [
            {
                "term_id": 101827,
                "gallery": [
                    108251,
                    108252,
                    102747,
                    108250,
                    110713
                ],
                "imgSrc": "/cdn/shop/files/Ash-Pink-4-copy-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Ash-Pink-4-copy-1.jpg",
                "imgSrcF": "/cdn/shop/files/Ash-Pink-4-300x300-1.jpg",
                "price": 35,
                "title": "Florence / Ash Pink",
                "color": "Beige"
            },
            {
                "term_id": 101825,
                "gallery": [
                    108257,
                    108258,
                    102747,
                    108256,
                    110715
                ],
                "imgSrc": "/cdn/shop/files/Light-Silver-4-copy-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Light-Silver-4-copy-1.jpg",
                "imgSrcF": "/cdn/shop/files/Light-Silver-4-300x300-1.jpg",
                "price": 35,
                "title": "Florence / Light Silver",
                "color": "Beige"
            },
            {
                "term_id": 101822,
                "gallery": [
                    108260,
                    108261,
                    102747,
                    108259,
                    110716
                ],
                "imgSrc": "/cdn/shop/files/Oat-4-copy-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Oat-4-copy-1.jpg",
                "imgSrcF": "/cdn/shop/files/Oat-4-300x300-1.jpg",
                "price": 35,
                "title": "Florence / Oat",
                "color": "Beige"
            },
            {
                "term_id": 101820,
                "gallery": [
                    108254,
                    108255,
                    102747,
                    108253,
                    110714
                ],
                "imgSrc": "/cdn/shop/files/Beige-4-copy-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Beige-4-copy-1.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-4-300x300-1.jpg",
                "price": 35,
                "title": "Florence / Beige",
                "color": "Beige"
            },
            {
                "term_id": 101798,
                "gallery": [
                    108263,
                    108264,
                    102747,
                    108262,
                    110717
                ],
                "imgSrc": "/cdn/shop/files/White-4-1-copy-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-4-1-copy-1.jpg",
                "imgSrcF": "/cdn/shop/files/White-4-1-300x300-1.jpg",
                "price": 35,
                "title": "Florence / White",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 54949,
                "gallery": null,
                "price": 0,
                "title": "White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Blackout Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Blackout pro Curtain",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Synthetic Curtains",
            "华辰-单层",
            "同材质内衬面料分类",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "new-arrival",
                "name": "New Arrival"
            },
            {
                "slug": "signature",
                "name": "signature"
            }
        ],
        "short_description": "These durable and elegant linen blend blackout curtains will decorate your windows and rooms with a new feel. Ideal for bedrooms, living rooms, kitchens, patios, room dividers, practical and modern. While saving energy and reducing noise, it creates a transparent, breathable and rustic style.\r\n<p class=\"atrst\" style=\"margin-bottom: 20px;\">Linen blackout curtains bring casual warmth and sophisticated style to a room. The weave of natural fibers creates dimensional highs and lows for added depth. This curtain is an elegant choice for any room in your home. Lab tests show that these awesome curtain panels are eco-friendly and vinyl-free.</p>",
        "imgSrc": "/cdn/shop/files/Light-Silver-4-copy-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Light-Silver-3-500x500.jpg",
        "subheading": "100% Blackout OEKO Heavyweight Woven Textured Custom Curtain",
        "Fabrics": [
            "Florence"
        ],
        "Feature": [],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 144,
        "newPrice": 115,
        "extra": "Extra 10%"
    },
    {
        "id": 102740,
        "title": "Florence 4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Woven Textured Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/florence-4-layer-oeko-heavyweight-soundproof-thermal-blackout-woven-textured-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "101822",
        "_fabric_color": [
            {
                "term_id": 101827,
                "gallery": [
                    108274,
                    108275,
                    108250,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Ash-Pink-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Ash-Pink-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Ash-Pink-4-300x300-1.jpg",
                "price": 50,
                "title": "Florence / Ash Pink",
                "color": "Beige"
            },
            {
                "term_id": 101825,
                "gallery": [
                    108270,
                    108271,
                    108256,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Light-Silver-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Light-Silver-1.jpg",
                "imgSrcF": "/cdn/shop/files/Light-Silver-4-300x300-1.jpg",
                "price": 50,
                "title": "Florence / Light Silver",
                "color": "Beige"
            },
            {
                "term_id": 101822,
                "gallery": [
                    108268,
                    108269,
                    108259,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Oat-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Oat-1.jpg",
                "imgSrcF": "/cdn/shop/files/Oat-4-300x300-1.jpg",
                "price": 50,
                "title": "Florence / Oat",
                "color": "Beige"
            },
            {
                "term_id": 101820,
                "gallery": [
                    108272,
                    108273,
                    108253,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/Beige-1-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Beige-1-4.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-4-300x300-1.jpg",
                "price": 50,
                "title": "Florence / Beige",
                "color": "Beige"
            },
            {
                "term_id": 101798,
                "gallery": [
                    108265,
                    108266,
                    108262,
                    102749,
                    102750,
                    102748
                ],
                "imgSrc": "/cdn/shop/files/White-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/White-4-1-300x300-1.jpg",
                "price": 50,
                "title": "Florence / White",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "4 layer",
            "All Curtain Sale",
            "All Curtains",
            "Blackout pro Curtain",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Oeko",
            "Outsourced products",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search soundproof",
            "Solid Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Synthetic Curtains",
            "Thermal Curtains",
            "华辰-四层",
            "同材质内衬面料分类",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "signature",
                "name": "signature"
            }
        ],
        "short_description": "These durable and elegant linen blend blackout curtains will decorate your windows and rooms with a new feel. Ideal for bedrooms, living rooms, kitchens, patios, room dividers, practical and modern. While saving energy and reducing noise, it creates a transparent, breathable and rustic style.\r\n<p class=\"atrst\" style=\"margin-bottom: 20px;\">Linen blackout curtains bring casual warmth and sophisticated style to a room. The weave of natural fibers creates dimensional highs and lows for added depth. This curtain is an elegant choice for any room in your home. Lab tests show that these awesome curtain panels are eco-friendly and vinyl-free.</p>",
        "imgSrc": "/cdn/shop/files/Oat-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Oat-3-500x500.jpg",
        "subheading": "4 Layers OEKO Heavyweight Soundproof Thermal 100% Blackout Woven Textured Custom Curtain",
        "Fabrics": [
            "Florence"
        ],
        "Feature": [],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 175,
        "newPrice": 140,
        "extra": "Extra 10%"
    },
    {
        "id": 1166,
        "title": "Hussein OEKO Certified Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/custom-room-darkening-solid-color-blackout-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "733",
        "_fabric_color": [
            {
                "term_id": 733,
                "gallery": [
                    106242,
                    106241,
                    106243,
                    106244,
                    106245
                ],
                "imgSrc": "/cdn/shop/files/Pure-White-1-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Pure-White-1-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/Pure-White-ok.jpg",
                "price": 40,
                "title": "Hussein / Pure White",
                "color": "White"
            },
            {
                "term_id": 703,
                "gallery": [
                    106250,
                    106249,
                    106251,
                    106252,
                    106253
                ],
                "imgSrc": "/cdn/shop/files/Black-4-6-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-4-6-1.jpg",
                "imgSrcF": "/cdn/shop/files/Black-ok.jpg",
                "price": 40,
                "title": "Hussein / Black",
                "color": "Black"
            },
            {
                "term_id": 720,
                "gallery": [
                    106256,
                    106254,
                    106257,
                    106258,
                    106259
                ],
                "imgSrc": "/cdn/shop/files/Greyish-White-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Greyish-White-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Grayish-White-ok.jpg",
                "price": 40,
                "title": "Hussein / Greyish White",
                "color": "White"
            },
            {
                "term_id": 722,
                "gallery": [
                    106260,
                    106261,
                    106262,
                    106263,
                    106264
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-1-3.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-ok.jpg",
                "price": 40,
                "title": "Hussein / Grey",
                "color": "Grey"
            },
            {
                "term_id": 711,
                "gallery": [
                    106265,
                    106266,
                    106267,
                    106268,
                    106269
                ],
                "imgSrc": "/cdn/shop/files/Cappuccino-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Cappuccino-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Cappuccino-ok.jpg",
                "price": 40,
                "title": "Hussein / Cappuccino",
                "color": "Brown"
            },
            {
                "term_id": 696,
                "gallery": [
                    106270,
                    106271,
                    106272,
                    106273,
                    106274
                ],
                "imgSrc": "/cdn/shop/files/Beige-1-7-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Beige-1-7-1.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-ok.jpg",
                "price": 40,
                "title": "Hussein / Beige",
                "color": "Beige"
            },
            {
                "term_id": 734,
                "gallery": [
                    106275,
                    106276,
                    106277,
                    106278
                ],
                "imgSrc": "/cdn/shop/files/Red-4-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Red-4-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/red-ok-1.jpg",
                "price": 40,
                "title": "Hussein / Red",
                "color": "Red"
            },
            {
                "term_id": 728,
                "gallery": [
                    106279,
                    106280,
                    106281,
                    106282,
                    106283
                ],
                "imgSrc": "/cdn/shop/files/Navy-Blue-1-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Navy-Blue-1-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/navyblue-ok.jpg",
                "price": 40,
                "title": "Hussein / Navy Blue",
                "color": "Blue"
            },
            {
                "term_id": 748,
                "gallery": [
                    106284,
                    106285,
                    106286,
                    106287,
                    106288
                ],
                "imgSrc": "/cdn/shop/files/Yellow-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yellow-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Yellow-ok.jpg",
                "price": 40,
                "title": "Hussein / Yellow",
                "color": "Yellow"
            },
            {
                "term_id": 745,
                "gallery": [
                    106289,
                    106290,
                    106291,
                    106292,
                    106293
                ],
                "imgSrc": "/cdn/shop/files/Teal-Blue-1-4-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Teal-Blue-1-4-1.jpg",
                "imgSrcF": "/cdn/shop/files/Teal-Blue-ok.jpg",
                "price": 40,
                "title": "Hussein / Teal Blue",
                "color": "Blue"
            },
            {
                "term_id": 740,
                "gallery": [
                    106294,
                    106296,
                    106297,
                    106298
                ],
                "imgSrc": "/cdn/shop/files/Stone-Blue-1-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Stone-Blue-1-3.jpg",
                "imgSrcF": "/cdn/shop/files/Stone-Blue-ok.jpg",
                "price": 40,
                "title": "Hussein / Stone Blue",
                "color": "Blue"
            },
            {
                "term_id": 738,
                "gallery": [
                    106299,
                    106300,
                    106301,
                    106302,
                    106303
                ],
                "imgSrc": "/cdn/shop/files/Sea-Teal-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sea-Teal-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Sea-Teal-ok-1.png",
                "price": 40,
                "title": "Hussein / Sea Teal",
                "color": "Blue"
            },
            {
                "term_id": 730,
                "gallery": [
                    106304,
                    106305,
                    106306,
                    106307,
                    106308
                ],
                "imgSrc": "/cdn/shop/files/Olive-Green-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Olive-Green-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Olive-Green-ok.jpg",
                "price": 40,
                "title": "Hussein / Olive Green",
                "color": "Green"
            },
            {
                "term_id": 725,
                "gallery": [
                    106309,
                    106310,
                    106311,
                    106312
                ],
                "imgSrc": "/cdn/shop/files/Light-Beige-1-4-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Light-Beige-1-4-1.jpg",
                "imgSrcF": "/cdn/shop/files/Light-Beige-ok.jpg",
                "price": 40,
                "title": "Hussein / Light Beige",
                "color": "Beige"
            },
            {
                "term_id": 723,
                "gallery": [
                    106313,
                    106314,
                    106315,
                    106316,
                    106317
                ],
                "imgSrc": "/cdn/shop/files/Hunter-Green-1-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Hunter-Green-1-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/Hunter-Green-ok.jpg",
                "price": 40,
                "title": "Hussein / Hunter Green",
                "color": "Green"
            },
            {
                "term_id": 717,
                "gallery": [
                    106324,
                    106323,
                    106320,
                    106321,
                    106322
                ],
                "imgSrc": "/cdn/shop/files/Deep-Purple-1-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Deep-Purple-1-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/Deep-Purple-ok.jpg",
                "price": 40,
                "title": "Hussein / Deep Purple",
                "color": "Purple"
            },
            {
                "term_id": 713,
                "gallery": [
                    106325,
                    106326,
                    106327,
                    106328,
                    106329
                ],
                "imgSrc": "/cdn/shop/files/Coffee-1-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Coffee-1-3.jpg",
                "imgSrcF": "/cdn/shop/files/Coffee-ok.jpg",
                "price": 40,
                "title": "Hussein / Coffee",
                "color": "Brown"
            },
            {
                "term_id": 704,
                "gallery": [
                    106330,
                    106331,
                    106332,
                    106333,
                    106334
                ],
                "imgSrc": "/cdn/shop/files/Brick-Red-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Brick-Red-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Brick-Red-ok.jpg",
                "price": 40,
                "title": "Hussein / Brick Red",
                "color": "Brown"
            },
            {
                "term_id": 747,
                "gallery": [
                    106335,
                    106336,
                    106337,
                    106338,
                    106339
                ],
                "imgSrc": "/cdn/shop/files/Tender-Cyan-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Tender-Cyan-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Tender-Cyan-ok.jpg",
                "price": 40,
                "title": "Hussein / Tender Cyan",
                "color": "Green"
            },
            {
                "term_id": 709,
                "gallery": [
                    106340,
                    106341,
                    106342,
                    106343,
                    106344
                ],
                "imgSrc": "/cdn/shop/files/Burgundy-Red-1-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Burgundy-Red-1-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/Burgundy-Red-ok.jpg",
                "price": 40,
                "title": "Hussein / Burgundy Red",
                "color": "Red"
            },
            {
                "term_id": 1077,
                "gallery": [
                    106345,
                    106346,
                    106347,
                    106348
                ],
                "imgSrc": "/cdn/shop/files/Sand-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sand-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Hussein-Sand-ok.jpg",
                "price": 40,
                "title": "Hussein / Sand Color",
                "color": "Grey"
            },
            {
                "term_id": 1076,
                "gallery": [
                    106349,
                    106350,
                    106351,
                    106352
                ],
                "imgSrc": "/cdn/shop/files/Light-Pink-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Light-Pink-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Hussein-Light-pink-ok.jpg",
                "price": 40,
                "title": "Hussein / Light Pink",
                "color": "Pink"
            },
            {
                "term_id": 1075,
                "gallery": [
                    106353,
                    106354,
                    106355,
                    106356
                ],
                "imgSrc": "/cdn/shop/files/Blue-Green-3-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Blue-Green-3-2.jpg",
                "imgSrcF": "/cdn/shop/files/Hussein-blue-green-ok.jpg",
                "price": 40,
                "title": "Hussein / Blue Green",
                "color": "Green"
            },
            {
                "term_id": 1074,
                "gallery": [
                    106357,
                    106358,
                    106360,
                    106359
                ],
                "imgSrc": "/cdn/shop/files/Vintage-Blue-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Vintage-Blue-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Hussein-Vintage-blue.jpg",
                "price": 40,
                "title": "Hussein / Vintage Blue",
                "color": "Blue"
            },
            {
                "term_id": 1072,
                "gallery": [
                    106361,
                    106362,
                    106363,
                    106364
                ],
                "imgSrc": "/cdn/shop/files/Sea-Blue-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sea-Blue-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Hussein-Sea-blue-ok.jpg",
                "price": 40,
                "title": "Hussein / Sea Blue",
                "color": "Blue"
            },
            {
                "term_id": 1069,
                "gallery": [
                    106365,
                    106366,
                    106367,
                    106368
                ],
                "imgSrc": "/cdn/shop/files/Eggplant-Purple-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Eggplant-Purple-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Eggplant-purple-ok.jpg",
                "price": 40,
                "title": "Hussein / Eggplant Purple",
                "color": "Purple"
            },
            {
                "term_id": 1073,
                "gallery": [
                    106369,
                    106370,
                    106371,
                    106372,
                    106373
                ],
                "imgSrc": "/cdn/shop/files/Silver-Grey-1-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-Grey-1-4.jpg",
                "imgSrcF": "/cdn/shop/files/Hussein-Silver-Grey-ok.jpg",
                "price": 40,
                "title": "Hussein / Silver Grey",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 98227,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Cyber Monday",
            "Extra 10%",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Friendly",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Oeko",
            "Search blackout",
            "Search curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Spring Time Sale",
            "Synthetic Curtains",
            "Curtains",
            "Custom Blackout Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "friendly",
                "name": "Friendly"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "oeko",
                "name": "OEKO"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "thanksgiving-20",
                "name": "Thanksgiving 20%"
            }
        ],
        "short_description": "&nbsp;\r\n\r\nThis single-layer blackout curtain can block 85%-99% of light and UV rays (black works better than white). The eco-friendly polyester fabric offers a natural dark environment for the night shift worker who has to sleep during the day. Good quality finishing will withstand years of use.\r\nIn some cases, light can still be seen on the edges of the curtain. The deeper the color, the better the blackout effect it can provide. Blackout curtains are made of polyester, an excellent fabric for blackout curtains; they are smooth, durable, strong, and low-cost. This fabric is also easy-to-clean, and it can hold out against wrinkling.Hussein\r\nBlack\r\nBlack out curtains\r\nBlack curtains",
        "imgSrc": "/cdn/shop/files/Grey-1-3-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Grey-5-4-500x500.jpg",
        "subheading": "OEKO Certified Custom Curtain",
        "Fabrics": [
            "Hussein"
        ],
        "Feature": [],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White",
            "Black",
            "White",
            "Grey",
            "Brown",
            "Beige",
            "Red",
            "Blue",
            "Yellow",
            "Blue",
            "Blue",
            "Blue",
            "Green",
            "Beige",
            "Green",
            "Purple",
            "Brown",
            "Brown",
            "Green",
            "Red",
            "Grey",
            "Pink",
            "Green",
            "Blue",
            "Blue",
            "Purple",
            "Grey"
        ],
        "Light": [
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 114,
        "newPrice": 101,
        "extra": "Extra 10%"
    },
    {
        "id": 101381,
        "title": "Rome 4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain",
        "ProductUrl": "/product/rome-4-layer-foil-printed-heavyweight-soundproof-thermal-blackout-anti-dust-velvet-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64157",
        "_fabric_color": [
            {
                "term_id": 64157,
                "gallery": [
                    107429,
                    107422,
                    107431,
                    107424,
                    107427,
                    107425,
                    107430,
                    107426,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/black-3-4-500x500.png",
                "imgSrc_n": "/cdn/shop/files/black-3-4.png",
                "imgSrcF": "/cdn/shop/files/black-3.png",
                "price": 40,
                "title": "Rome / Black",
                "color": "Black"
            },
            {
                "term_id": 64155,
                "gallery": [
                    107715,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/red-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/red-1.png",
                "imgSrcF": "/cdn/shop/files/red-1.png",
                "price": 40,
                "title": "Rome / Red",
                "color": "Red"
            },
            {
                "term_id": 64156,
                "gallery": [
                    107718,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/teal-500x500.png",
                "imgSrc_n": "/cdn/shop/files/teal.png",
                "imgSrcF": "/cdn/shop/files/teal.png",
                "price": 40,
                "title": "Rome / Teal",
                "color": "Green"
            },
            {
                "term_id": 64150,
                "gallery": [
                    107709,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/goldenbrown-500x500.png",
                "imgSrc_n": "/cdn/shop/files/goldenbrown.png",
                "imgSrcF": "/cdn/shop/files/goldenbrown.png",
                "price": 40,
                "title": "Rome / Golden Brown",
                "color": "Brown"
            },
            {
                "term_id": 64152,
                "gallery": [
                    107714,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/orange-500x500.png",
                "imgSrc_n": "/cdn/shop/files/orange.png",
                "imgSrcF": "/cdn/shop/files/orange.png",
                "price": 40,
                "title": "Rome / Orange",
                "color": "Orange"
            },
            {
                "term_id": 64153,
                "gallery": [
                    107713,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/mustardgreen-500x500.png",
                "imgSrc_n": "/cdn/shop/files/mustardgreen.png",
                "imgSrcF": "/cdn/shop/files/mustardgreen.png",
                "price": 40,
                "title": "Rome / Mustard Green",
                "color": "Cyan"
            },
            {
                "term_id": 64154,
                "gallery": [
                    107707,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/coral-500x500.png",
                "imgSrc_n": "/cdn/shop/files/coral.png",
                "imgSrcF": "/cdn/shop/files/coral.png",
                "price": 40,
                "title": "Rome / Coral",
                "color": "Pink"
            },
            {
                "term_id": 64151,
                "gallery": [
                    107711,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/metallic-500x500.png",
                "imgSrc_n": "/cdn/shop/files/metallic.png",
                "imgSrcF": "/cdn/shop/files/metallic.png",
                "price": 40,
                "title": "Rome / Metallic",
                "color": "Grey"
            },
            {
                "term_id": 64144,
                "gallery": [
                    107708,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/gold-500x500.png",
                "imgSrc_n": "/cdn/shop/files/gold.png",
                "imgSrcF": "/cdn/shop/files/gold.png",
                "price": 40,
                "title": "Rome / Gold",
                "color": "Gold"
            },
            {
                "term_id": 64145,
                "gallery": [
                    107712,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/misty-500x500.png",
                "imgSrc_n": "/cdn/shop/files/misty.png",
                "imgSrcF": "/cdn/shop/files/misty.png",
                "price": 40,
                "title": "Rome / Misty",
                "color": "Grey"
            },
            {
                "term_id": 64146,
                "gallery": [
                    107710,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/lightblue-500x500.png",
                "imgSrc_n": "/cdn/shop/files/lightblue.png",
                "imgSrcF": "/cdn/shop/files/lightblue.png",
                "price": 40,
                "title": "Rome / Light Blue",
                "color": "Blue"
            },
            {
                "term_id": 64147,
                "gallery": [
                    107717,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/silver-500x500.png",
                "imgSrc_n": "/cdn/shop/files/silver.png",
                "imgSrcF": "/cdn/shop/files/silver.png",
                "price": 40,
                "title": "Rome / Silver",
                "color": "Silver"
            },
            {
                "term_id": 64148,
                "gallery": [
                    107706,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/champagne-500x500.png",
                "imgSrc_n": "/cdn/shop/files/champagne.png",
                "imgSrcF": "/cdn/shop/files/champagne.png",
                "price": 40,
                "title": "Rome / Champagne",
                "color": "Gold"
            },
            {
                "term_id": 64149,
                "gallery": [
                    107716,
                    94922,
                    65404,
                    65407,
                    65406,
                    65405,
                    94687,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/rome-display-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/rome-display-3.png",
                "imgSrcF": "/cdn/shop/files/rome-display-3.png",
                "price": 40,
                "title": "Rome / Cream",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Foil Printed Velvet Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "4 layer",
            "All Curtains",
            "black custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "flash_categories",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "patterned custom curtains",
            "Search blackout",
            "Search curtains",
            "Search Foil Print",
            "Search soundproof",
            "Search velvet",
            "Soundproof &amp; Blackout Curtains",
            "striped custom curtains",
            "Synthetic Curtains",
            "Thermal Curtains",
            "velvet custom curtains",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "thermal-curtains",
                "name": "thermal curtains"
            },
            {
                "slug": "velvet-curtains",
                "name": "velvet curtains"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/black-3-4-500x500.png",
        "hoverImg": "/cdn/shop/files/Black-1-3-500x500.png",
        "subheading": "4 Layers Foil Printed Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Velvet Custom Curtain",
        "Fabrics": [
            "Rome"
        ],
        "Feature": [],
        "Material": [
            "Velvet",
            "Synthetic"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Black",
            "Red",
            "Green",
            "Brown",
            "Orange",
            "Cyan",
            "Pink",
            "Grey",
            "Gold",
            "Grey",
            "Blue",
            "Silver",
            "Gold",
            "Beige"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 156,
        "newPrice": 131,
        "extra": "Extra 10%"
    },
    {
        "id": 101372,
        "title": "Chelsea 4 Layers Cotton Blend Heavyweight Soundproof Thermal 100% Blackout Patterned Custom Curtain",
        "ProductUrl": "/product/chelsea-4-layer-cotton-blend-heavyweight-soundproof-thermal-blackout-patterned-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95470",
        "_fabric_color": [
            {
                "term_id": 95470,
                "gallery": [
                    108004,
                    108005,
                    108006,
                    108009,
                    108007,
                    108008,
                    108618,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Grid-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Grid-2.png",
                "imgSrcF": "/cdn/shop/files/Grid-7.png",
                "price": 50,
                "title": "Chelsea / Grid",
                "color": "Brown"
            },
            {
                "term_id": 95469,
                "gallery": [
                    108617,
                    101376,
                    101375,
                    101378,
                    101377,
                    101374,
                    101373,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Ivory-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Ivory-1-1.png",
                "imgSrcF": "/cdn/shop/files/Ivory-1-1.png",
                "price": 50,
                "title": "Chelsea / Ivory",
                "color": "Beige"
            },
            {
                "term_id": 95471,
                "gallery": [
                    108619,
                    101375,
                    101376,
                    101378,
                    101377,
                    101374,
                    101373,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Circuit-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Circuit-1.png",
                "imgSrcF": "/cdn/shop/files/Circuit-1.png",
                "price": 50,
                "title": "Chelsea / Circuit",
                "color": "Blue"
            },
            {
                "term_id": 95465,
                "gallery": [
                    108616,
                    101375,
                    101376,
                    101378,
                    101377,
                    101374,
                    101373,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Grey-1-2.png",
                "imgSrcF": "/cdn/shop/files/Grey-1-2.png",
                "price": 50,
                "title": "Chelsea / Grey",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Cotton Curtains",
            "Designer Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "4 layer",
            "All Curtain Sale",
            "All Curtains",
            "Cotton Blend Curtains",
            "Cotton Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Designer Curtains",
            "geometric custom curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "Sale",
            "Search blackout",
            "Search cotton",
            "Search curtains",
            "Search soundproof",
            "Soundproof &amp; Blackout Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "外包4家-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "primere",
                "name": "primere"
            },
            {
                "slug": "thermal-curtains",
                "name": "thermal curtains"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Grid-2-500x500.png",
        "hoverImg": "/cdn/shop/files/Grid-3-500x500.png",
        "subheading": "4 Layers Cotton Blend Heavyweight Soundproof Thermal 100% Blackout Patterned Custom Curtain",
        "Fabrics": [
            "Chelsea"
        ],
        "Feature": [
            "Soundproof"
        ],
        "Material": [
            "Cotton"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Brown",
            "Beige",
            "Blue",
            "Grey"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 179,
        "newPrice": 161,
        "extra": "Extra 10%"
    },
    {
        "id": 56944,
        "title": "Herringbone 4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain",
        "ProductUrl": "/custom-blackout-curtain/custom-4-layers-100-blackout-thermal-insulated-chenille-soundproof-anti-dust-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "56945",
        "_fabric_color": [
            {
                "term_id": 56945,
                "gallery": [
                    107120,
                    107121,
                    107118,
                    107119,
                    57035,
                    99530,
                    43447,
                    43448,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/beige-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/beige-3.jpg",
                "imgSrcF": "/cdn/shop/files/Beige.png",
                "price": 35,
                "title": "Herringbone / Beige",
                "color": "Beige"
            },
            {
                "term_id": 56947,
                "gallery": [
                    107128,
                    107129,
                    107126,
                    107127,
                    57035,
                    99530,
                    43447,
                    43448,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/cream-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/cream-3.jpg",
                "imgSrcF": "/cdn/shop/files/Cream.png",
                "price": 35,
                "title": "Herringbone / Cream",
                "color": "Beige"
            },
            {
                "term_id": 56951,
                "gallery": [
                    107124,
                    107125,
                    107122,
                    107123,
                    57035,
                    99530,
                    43447,
                    43448,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/charcoal-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/charcoal-3.jpg",
                "imgSrcF": "/cdn/shop/files/charcoal-2.jpg",
                "price": 35,
                "title": "Herringbone / Charcoal Gray",
                "color": "Grey"
            },
            {
                "term_id": 56955,
                "gallery": [
                    107132,
                    107133,
                    107130,
                    107131,
                    57035,
                    99530,
                    43447,
                    43448,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/dustblue-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/dustblue-3.jpg",
                "imgSrcF": "/cdn/shop/files/dustblue-2.jpg",
                "price": 35,
                "title": "Herringbone / Dust Blue",
                "color": "Blue"
            },
            {
                "term_id": 56953,
                "gallery": [
                    107136,
                    107137,
                    107134,
                    107135,
                    57035,
                    99530,
                    43447,
                    43448,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/moss-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/moss-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/moss-2-1.jpg",
                "price": 35,
                "title": "Herringbone / Moss Green",
                "color": "Green"
            },
            {
                "term_id": 56994,
                "gallery": [
                    107140,
                    107141,
                    107138,
                    107139,
                    57035,
                    99530,
                    43447,
                    43448,
                    98392
                ],
                "imgSrc": "/cdn/shop/files/pearl-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/pearl-3.jpg",
                "imgSrcF": "/cdn/shop/files/pearl-2.jpg",
                "price": 35,
                "title": "Herringbone / Pearl",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 614,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 613,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 612,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "4 layer",
            "All Bestsellers",
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Search blackout",
            "Search curtains",
            "Search dust",
            "Search soundproof",
            "Soundproof &amp; Blackout Curtains",
            "Spring Time Sale",
            "Synthetic Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "绍兴-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "<p style=\"margin-bottom: 20px;\">These three-layered curtains are the best problem solved: 100% blackout, soundproof and heat insulation. They will not get folded easily, and they last long by resisting strict conditions. These elegant, luxurious velvet curtain panels will set a perfect relaxation mood of your living room to your bedroom. Velvet curtains impede most light from outside, and they block 100% of harsh sunlight and block the UV light and noise.</p>\r\n<p style=\"margin-bottom: 20px;\">Velvet is environmentally friendly and offers a soft and royal look proving the best window outfit. It is a thick conductive accessory to use in the cold seasons. It has an aesthetic value, and it blends in with different decor styles.</p>\r\nLuxury\r\nVelvet\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
        "imgSrc": "/cdn/shop/files/6-7-500x500.jpg",
        "hoverImg": "/cdn/shop/files/6-4-500x500.jpg",
        "subheading": "4 Layers Herringbone Chenille Soundproof Thermal 100% Blackout Custom Curtain",
        "Fabrics": [
            "Herringbone"
        ],
        "Feature": [
            "Soundproof"
        ],
        "Material": [
            "Polyester"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Beige",
            "Grey",
            "Blue",
            "Green",
            "Beige"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 146,
        "newPrice": 136,
        "extra": "Extra 10%"
    },
    {
        "id": 1167,
        "title": "Classic Velvet Custom Curtain",
        "ProductUrl": "/custom-velvet-curtains/custom-solid-color-velvet-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "759",
        "_fabric_color": [
            {
                "term_id": 759,
                "gallery": [
                    108039,
                    108040,
                    108041,
                    108042,
                    51091,
                    108043,
                    108021
                ],
                "imgSrc": "/cdn/shop/files/Black-1-7-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-1-7.jpg",
                "imgSrcF": "/cdn/shop/files/black.jpg",
                "price": 30,
                "title": "Classic / Black",
                "color": "Black"
            },
            {
                "term_id": 791,
                "gallery": [
                    108074,
                    108078,
                    108077,
                    108076,
                    51091,
                    108075,
                    108028
                ],
                "imgSrc": "/cdn/shop/files/lvory-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/lvory-1.jpg",
                "imgSrcF": "/cdn/shop/files/ivory.jpg",
                "price": 30,
                "title": "Classic / Ivory White",
                "color": "Beige"
            },
            {
                "term_id": 760,
                "gallery": [
                    108045,
                    108044,
                    108047,
                    108046,
                    51091,
                    108048,
                    108022
                ],
                "imgSrc": "/cdn/shop/files/Blush-Beige-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Blush-Beige-2.jpg",
                "imgSrcF": "/cdn/shop/files/blushbeige.jpg",
                "price": 30,
                "title": "Classic / Blush Beige",
                "color": "Beige"
            },
            {
                "term_id": 809,
                "gallery": [
                    108104,
                    108108,
                    108107,
                    108106,
                    51091,
                    108105,
                    108034
                ],
                "imgSrc": "/cdn/shop/files/Stone-Blue-1-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Stone-Blue-1-4.jpg",
                "imgSrcF": "/cdn/shop/files/stoneblue.jpg",
                "price": 30,
                "title": "Classic / Stone Blue",
                "color": "Blue"
            },
            {
                "term_id": 797,
                "gallery": [
                    108089,
                    108093,
                    108092,
                    108091,
                    51091,
                    108090,
                    108031
                ],
                "imgSrc": "/cdn/shop/files/Moss-Greem-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Moss-Greem-1.jpg",
                "imgSrcF": "/cdn/shop/files/Velvet-120x12017-1.jpg",
                "price": 30,
                "title": "Classic / Moss Green",
                "color": "Green"
            },
            {
                "term_id": 807,
                "gallery": [
                    108079,
                    108080,
                    108081,
                    108082,
                    51091,
                    108083,
                    108029
                ],
                "imgSrc": "/cdn/shop/files/Silver-Grey-1-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-Grey-1-5.jpg",
                "imgSrcF": "/cdn/shop/files/lightgrey.jpg",
                "price": 30,
                "title": "Classic / Light Grey",
                "color": "Grey"
            },
            {
                "term_id": 799,
                "gallery": [
                    108094,
                    108095,
                    108096,
                    108097,
                    51091,
                    108098,
                    108032
                ],
                "imgSrc": "/cdn/shop/files/navy-blue-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/navy-blue-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/navyblue.jpg",
                "price": 30,
                "title": "Classic / Navy Blue",
                "color": "Blue"
            },
            {
                "term_id": 789,
                "gallery": [
                    108069,
                    108070,
                    108071,
                    108072,
                    51091,
                    108073,
                    108027
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-1-5.jpg",
                "imgSrcF": "/cdn/shop/files/grey.jpg",
                "price": 30,
                "title": "Classic / Grey",
                "color": "Grey"
            },
            {
                "term_id": 818,
                "gallery": [
                    108119,
                    108123,
                    108122,
                    108121,
                    51091,
                    108120,
                    108037
                ],
                "imgSrc": "/cdn/shop/files/Warm-Gold-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Warm-Gold-1.jpg",
                "imgSrcF": "/cdn/shop/files/warmgold.jpg",
                "price": 30,
                "title": "Classic / Warm Gold",
                "color": "Yellow"
            },
            {
                "term_id": 765,
                "gallery": [
                    108054,
                    108055,
                    108056,
                    108057,
                    51091,
                    108058,
                    108024
                ],
                "imgSrc": "/cdn/shop/files/Chestnut-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Chestnut-1.jpg",
                "imgSrcF": "/cdn/shop/files/coffee.jpg",
                "price": 30,
                "title": "Classic / Chestnut",
                "color": "Brown"
            },
            {
                "term_id": 804,
                "gallery": [
                    108100,
                    108099,
                    108101,
                    108102,
                    108103,
                    108033
                ],
                "imgSrc": "/cdn/shop/files/Red-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Red-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/red.jpg",
                "price": 30,
                "title": "Classic / Red",
                "color": "Red"
            },
            {
                "term_id": 788,
                "gallery": [
                    108064,
                    108065,
                    108066,
                    108067,
                    51091,
                    108068,
                    108025
                ],
                "imgSrc": "/cdn/shop/files/Green-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Green-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Velvet-120x12016-1.jpg",
                "price": 30,
                "title": "Classic / Green",
                "color": "Green"
            },
            {
                "term_id": 816,
                "gallery": [
                    108118,
                    108115,
                    108116,
                    108114,
                    51091,
                    108117,
                    108036
                ],
                "imgSrc": "/cdn/shop/files/Teal-Blue-1-6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Teal-Blue-1-6.jpg",
                "imgSrcF": "/cdn/shop/files/tealblue.jpg",
                "price": 30,
                "title": "Classic / Teal Blue",
                "color": "Blue"
            },
            {
                "term_id": 761,
                "gallery": [
                    108049,
                    108050,
                    108051,
                    108052,
                    51091,
                    108053,
                    108023
                ],
                "imgSrc": "/cdn/shop/files/Burgundy-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Burgundy-1.jpg",
                "imgSrcF": "/cdn/shop/files/burgundy.jpg",
                "price": 30,
                "title": "Classic / Burgundy",
                "color": "Red"
            },
            {
                "term_id": 815,
                "gallery": [
                    108109,
                    108110,
                    108111,
                    108112,
                    51091,
                    108113,
                    108035
                ],
                "imgSrc": "/cdn/shop/files/Taupe-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Taupe-5.jpg",
                "imgSrcF": "/cdn/shop/files/taupe.jpg",
                "price": 30,
                "title": "Classic / Taupe",
                "color": "Brown"
            },
            {
                "term_id": 786,
                "gallery": [
                    108059,
                    108060,
                    108061,
                    108062,
                    51091,
                    108063,
                    108026
                ],
                "imgSrc": "/cdn/shop/files/Gold-Brown-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Gold-Brown-1.jpg",
                "imgSrcF": "/cdn/shop/files/goldbrown.jpg",
                "price": 30,
                "title": "Classic / Gold Brown",
                "color": "Brown"
            },
            {
                "term_id": 820,
                "gallery": [
                    108124,
                    108125,
                    108126,
                    108127,
                    51091,
                    108128,
                    108038
                ],
                "imgSrc": "/cdn/shop/files/Wild-Rose-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Wild-Rose-1.jpg",
                "imgSrcF": "/cdn/shop/files/wildrose.jpg",
                "price": 30,
                "title": "Classic / Wild Rose",
                "color": "Red"
            },
            {
                "term_id": 794,
                "gallery": [
                    108085,
                    108086,
                    108084,
                    108087,
                    51091,
                    108088,
                    108030
                ],
                "imgSrc": "/cdn/shop/files/Light-Pink-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Light-Pink-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/lightpink.jpg",
                "price": 30,
                "title": "Classic / Light Pink",
                "color": "Pink"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 612,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 614,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Oeko",
            "Search blackout",
            "Search curtains",
            "Search Pinch pleat",
            "Search velvet",
            "Solid Curtains",
            "Solid Velvet Curtains",
            "Spring Time Sale",
            "同材质内衬面料分类",
            "绍兴-单层",
            "Curtains",
            "Room Darkening Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "luxury",
                "name": "Luxury"
            },
            {
                "slug": "oeko",
                "name": "OEKO"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            },
            {
                "slug": "thanksgiving-15",
                "name": "Thanksgiving 15%"
            }
        ],
        "short_description": "&nbsp;\r\n\r\nVelvet curtains are super soft to touch and can go anywhere in the home. These elegant, luxurious velvet curtain panels will set a perfect relaxation mood of your living room to your bedroom. Velvet curtains impede most light from outside, and they block 70% of harsh sunlight and block the UV light and noise.\r\nVelvet is environmentally friendly and offers a soft and royal look proving the best window outfit. It is a thick conductive accessory to use in the cold seasons. It has an aesthetic value, and it blends in with different decor styles.\r\n\r\nLuxury\r\nVelvet\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
        "imgSrc": "/cdn/shop/files/Black-1-7-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Classic_Black-500x500.png",
        "subheading": "Velvet Custom Curtain",
        "Fabrics": [
            "Classic"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Black",
            "Beige",
            "Beige",
            "Blue",
            "Green",
            "Grey",
            "Blue",
            "Grey",
            "Yellow",
            "Brown",
            "Red",
            "Green",
            "Blue",
            "Red",
            "Brown",
            "Brown",
            "Red",
            "Pink"
        ],
        "Light": [
            "Light Filtering"
        ],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 114,
        "newPrice": 101,
        "extra": "Extra 10%"
    },
    {
        "id": 64171,
        "title": "Unwind Linen Blend Grid Like Woven Sheer Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-unwind-sheer-linen-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64080",
        "_fabric_color": [
            {
                "term_id": 64080,
                "gallery": [
                    107415,
                    107416,
                    107418,
                    107417,
                    107420,
                    107419,
                    94847
                ],
                "imgSrc": "/cdn/shop/files/Unwind-FT0301-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Unwind-FT0301-2.jpg",
                "imgSrcF": "/cdn/shop/files/FA-FT0301-color.png",
                "price": 40,
                "title": "Unwind / White",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Indoor Sheer Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Extra 10%",
            "farmhouse custom curtains",
            "Faux Linen Curtains",
            "flash_categories",
            "geometric custom curtains",
            "Independence Day",
            "Indoor Sheer Curtains",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Sheer Curtains",
            "Outsourced products",
            "pinch pleat custom curtains",
            "Sale",
            "Search curtains",
            "Search faux linen blackout",
            "Search linen",
            "Search Linen blend curtains",
            "Search sheer",
            "Summer",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Unwind-FT0301-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Unwind-FT0301-5-500x500.jpg",
        "subheading": "Linen Blend Sheer Grid Like Woven Sheer Custom Curtain",
        "Fabrics": [
            "Unwind"
        ],
        "Feature": [],
        "Material": [
            "Linen",
            "Sheer"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "White"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 149,
        "newPrice": 134,
        "extra": "Extra 10%"
    },
    {
        "id": 101313,
        "title": "Ambient 4 Layers Linen Blend Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Jacquard Custom Curtain",
        "ProductUrl": "/product/ambient-4-layer-linen-blend-heavyweight-soundproof-thermal-blackout-anti-dust-jacquard-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95447",
        "_fabric_color": [
            {
                "term_id": 95452,
                "gallery": [
                    107904,
                    107905,
                    107900,
                    107909,
                    107906,
                    107908,
                    107907,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/cream1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/cream1.jpg",
                "imgSrcF": "/cdn/shop/files/Cream-1.png",
                "price": 50,
                "title": "Ambient / Cream",
                "color": "Beige"
            },
            {
                "term_id": 95447,
                "gallery": [
                    107922,
                    107923,
                    107903,
                    107927,
                    107924,
                    107926,
                    107925,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/white1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/white1.jpg",
                "imgSrcF": "/cdn/shop/files/White-6.png",
                "price": 50,
                "title": "Ambient / White",
                "color": "White"
            },
            {
                "term_id": 95453,
                "gallery": [
                    107916,
                    107917,
                    107902,
                    107921,
                    107918,
                    107920,
                    107919,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/silver1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/silver1.jpg",
                "imgSrcF": "/cdn/shop/files/Silver-1.png",
                "price": 50,
                "title": "Ambient / Silver",
                "color": "Silver"
            },
            {
                "term_id": 95451,
                "gallery": [
                    107910,
                    107911,
                    107901,
                    107915,
                    107912,
                    107914,
                    107913,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Moss1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Moss1.jpg",
                "imgSrcF": "/cdn/shop/files/Moss-1.png",
                "price": 50,
                "title": "Ambient / Moss",
                "color": "Green"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Linen Curtains",
            "Textured Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "4 layer",
            "All Curtain Sale",
            "All Curtains",
            "beige custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "farmhouse custom curtains",
            "Faux Linen Curtains",
            "Independence Day",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search linen",
            "Search Linen blend curtains",
            "Search soundproof",
            "Soundproof &amp; Blackout Curtains",
            "Textured Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "外包4家-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "thermal-curtains",
                "name": "thermal curtains"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/white1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/4-1-500x500.jpg",
        "subheading": "4 Layers Linen Blend Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Jacquard Custom Curtain",
        "Fabrics": [
            "Ambient"
        ],
        "Feature": [
            "Soundproof"
        ],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Beige",
            "White",
            "Silver",
            "Green"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 187,
        "newPrice": 150,
        "extra": "Extra 10%"
    },
    {
        "id": 64184,
        "title": "Rome Foil Printed Velvet Custom Curtain | Designed in Italy",
        "ProductUrl": "/custom-curtains/custom-rome-foil-printed-velvet-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64157",
        "_fabric_color": [
            {
                "term_id": 64157,
                "gallery": [
                    94922,
                    65404,
                    94869,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/Rome-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Rome-3.png",
                "imgSrcF": "/cdn/shop/files/black-3.png",
                "price": 45,
                "title": "Rome / Black",
                "color": "Black"
            },
            {
                "term_id": 64155,
                "gallery": [
                    107715,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/red-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/red-1.png",
                "imgSrcF": "/cdn/shop/files/red-1.png",
                "price": 45,
                "title": "Rome / Red",
                "color": "Red"
            },
            {
                "term_id": 64156,
                "gallery": [
                    107718,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/teal-500x500.png",
                "imgSrc_n": "/cdn/shop/files/teal.png",
                "imgSrcF": "/cdn/shop/files/teal.png",
                "price": 45,
                "title": "Rome / Teal",
                "color": "Green"
            },
            {
                "term_id": 64150,
                "gallery": [
                    107709,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/goldenbrown-500x500.png",
                "imgSrc_n": "/cdn/shop/files/goldenbrown.png",
                "imgSrcF": "/cdn/shop/files/goldenbrown.png",
                "price": 45,
                "title": "Rome / Golden Brown",
                "color": "Brown"
            },
            {
                "term_id": 64152,
                "gallery": [
                    107714,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/orange-500x500.png",
                "imgSrc_n": "/cdn/shop/files/orange.png",
                "imgSrcF": "/cdn/shop/files/orange.png",
                "price": 45,
                "title": "Rome / Orange",
                "color": "Orange"
            },
            {
                "term_id": 64153,
                "gallery": [
                    107713,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/mustardgreen-500x500.png",
                "imgSrc_n": "/cdn/shop/files/mustardgreen.png",
                "imgSrcF": "/cdn/shop/files/mustardgreen.png",
                "price": 45,
                "title": "Rome / Mustard Green",
                "color": "Cyan"
            },
            {
                "term_id": 64154,
                "gallery": [
                    107707,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/coral-500x500.png",
                "imgSrc_n": "/cdn/shop/files/coral.png",
                "imgSrcF": "/cdn/shop/files/coral.png",
                "price": 45,
                "title": "Rome / Coral",
                "color": "Pink"
            },
            {
                "term_id": 64151,
                "gallery": [
                    107711,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/metallic-500x500.png",
                "imgSrc_n": "/cdn/shop/files/metallic.png",
                "imgSrcF": "/cdn/shop/files/metallic.png",
                "price": 45,
                "title": "Rome / Metallic",
                "color": "Grey"
            },
            {
                "term_id": 64144,
                "gallery": [
                    107708,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/gold-500x500.png",
                "imgSrc_n": "/cdn/shop/files/gold.png",
                "imgSrcF": "/cdn/shop/files/gold.png",
                "price": 45,
                "title": "Rome / Gold",
                "color": "Gold"
            },
            {
                "term_id": 64145,
                "gallery": [
                    107712,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/misty-500x500.png",
                "imgSrc_n": "/cdn/shop/files/misty.png",
                "imgSrcF": "/cdn/shop/files/misty.png",
                "price": 45,
                "title": "Rome / Misty",
                "color": "Grey"
            },
            {
                "term_id": 64146,
                "gallery": [
                    107710,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/lightblue-500x500.png",
                "imgSrc_n": "/cdn/shop/files/lightblue.png",
                "imgSrcF": "/cdn/shop/files/lightblue.png",
                "price": 45,
                "title": "Rome / Light Blue",
                "color": "Blue"
            },
            {
                "term_id": 64147,
                "gallery": [
                    107717,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/silver-500x500.png",
                "imgSrc_n": "/cdn/shop/files/silver.png",
                "imgSrcF": "/cdn/shop/files/silver.png",
                "price": 45,
                "title": "Rome / Silver",
                "color": "Silver"
            },
            {
                "term_id": 64148,
                "gallery": [
                    107706,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/champagne-500x500.png",
                "imgSrc_n": "/cdn/shop/files/champagne.png",
                "imgSrcF": "/cdn/shop/files/champagne.png",
                "price": 45,
                "title": "Rome / Champagne",
                "color": "Gold"
            },
            {
                "term_id": 64149,
                "gallery": [
                    107716,
                    94922,
                    65404,
                    65407,
                    65406,
                    94648,
                    94647,
                    65405,
                    94687,
                    65403
                ],
                "imgSrc": "/cdn/shop/files/rome-display-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/rome-display-3.png",
                "imgSrcF": "/cdn/shop/files/rome-display-3.png",
                "price": 45,
                "title": "Rome / Cream",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Foil Printed Velvet Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "black custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Extra 10%",
            "flash_categories",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Search curtains",
            "Search Foil Print",
            "Search Pinch pleat",
            "Search velvet",
            "striped custom curtains",
            "Summer",
            "Synthetic Curtains",
            "velvet custom curtains",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/black-3-4-500x500.png",
        "hoverImg": "/cdn/shop/files/Black-4-7-500x500.jpg",
        "subheading": "Foil Printed Velvet Custom Curtain | Designed in Italy",
        "Fabrics": [
            "Rome"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Black",
            "Red",
            "Green",
            "Brown",
            "Orange",
            "Cyan",
            "Pink",
            "Grey",
            "Gold",
            "Grey",
            "Blue",
            "Silver",
            "Gold",
            "Beige"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 130,
        "newPrice": 169,
        "extra": "Extra 10%"
    },
    {
        "id": 1222,
        "title": "Nara Linen &#038; Cotton Blend Lightweight Custom Curtain",
        "ProductUrl": "/linen-cotton-curtains/custom-ivory-linen-cotton-blend-light-filtering-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "1102",
        "_fabric_color": [
            {
                "term_id": 1102,
                "gallery": [
                    23944,
                    51006,
                    51007,
                    51008,
                    51009,
                    51011,
                    51012
                ],
                "imgSrc": "/cdn/shop/files/linen-55-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/linen-55-1.png",
                "imgSrcF": "/cdn/shop/files/ivory-color.png",
                "price": 40,
                "title": "Nara / Ivory",
                "color": "White"
            },
            {
                "term_id": 102308,
                "gallery": [
                    102286,
                    102288,
                    102287,
                    102291,
                    102290
                ],
                "imgSrc": "/cdn/shop/files/Beige-1-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Beige-1-4.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-3-2.png",
                "price": 40,
                "title": "Nara / Beige",
                "color": "White"
            },
            {
                "term_id": 102306,
                "gallery": [
                    102298,
                    102302,
                    102300,
                    102299,
                    102301,
                    102303
                ],
                "imgSrc": "/cdn/shop/files/2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/2-1.jpg",
                "imgSrcF": "/cdn/shop/files/2-3.png",
                "price": 40,
                "title": "Nara / White",
                "color": "White"
            },
            {
                "term_id": 102304,
                "gallery": [
                    102292,
                    102294,
                    102293,
                    102295,
                    102296,
                    102297
                ],
                "imgSrc": "/cdn/shop/files/1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Natural-2.png",
                "price": 40,
                "title": "Nara / Natural",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 98227,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Cotton Curtains",
            "Light Filtering Curtains",
            "Linen Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Black Friday",
            "Cotton Blend Curtains",
            "Cotton Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "flash_categories",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search cotton",
            "Search curtains",
            "Search linen",
            "Solid Curtains",
            "Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            }
        ],
        "short_description": "Nara\r\n\r\nThese curtain panels are made of 45% eco-friendly cotton &amp; 55% high-quality linen blend fabric and weighted 340 GSM, feeling soft and textured with exquisite workmanship. The white curtains have natural black linen dots, which can make the curtains look stylish, conspicuous and versatile. Carefully made by senior workers, these curtains boast finished appearance with perfect trimming and seams. These linen texture curtains can provide privacy and block about 30% of light. These linen look curtains are widely suitable for all kinds of occasions, such as living rooms, bedrooms, dining rooms, lofts, villas, etc.",
        "imgSrc": "/cdn/shop/files/linen-55-1-600x600.png",
        "hoverImg": "/cdn/shop/files/linen-55-3-1-500x500.png",
        "subheading": "Linen & Cotton Blend Lightweight Custom Curtain",
        "Fabrics": [
            "Nara"
        ],
        "Feature": [],
        "Material": [
            "Cotton Blend",
            "Linen",
            "Linen Blend",
            "Cotton"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White",
            "White",
            "White"
        ],
        "Light": [
            "Light Filtering"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 133,
        "newPrice": 106,
        "extra": "Extra 10%"
    },
    {
        "id": 64164,
        "title": "Jade Velvet Toile Heavyweight Patterned Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-jade-printed-velvet-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64063",
        "_fabric_color": [
            {
                "term_id": 64063,
                "gallery": [
                    64385,
                    64392,
                    64388,
                    64391,
                    64393,
                    64387,
                    64386,
                    64389,
                    64390,
                    66074
                ],
                "imgSrc": "/cdn/shop/files/Rose-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Rose-1.jpg",
                "imgSrcF": "/cdn/shop/files/Stone-Blue-1.png",
                "price": 40,
                "title": "Jade / Stone Blue",
                "color": "Blue"
            },
            {
                "term_id": 66071,
                "gallery": [
                    66094,
                    66095,
                    66096,
                    66100,
                    66099,
                    66098,
                    66097,
                    66101
                ],
                "imgSrc": "/cdn/shop/files/1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Rose-6.png",
                "price": 40,
                "title": "Jade / Ink",
                "color": "Brown"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Designer Curtains",
            "Light Filtering Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Designer Curtains",
            "flash_categories",
            "heavyweight custom curtains",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Search curtains",
            "Search Pinch pleat",
            "Search velvet",
            "Synthetic Curtains",
            "Velvet Pattern Curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Rose-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Rose-2-500x500.jpg",
        "subheading": "Velvet Toile Heavyweight Patterned Custom Curtain",
        "Fabrics": [
            "Jade"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Nature"
        ],
        "Color": [
            "Blue",
            "Brown"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 139,
        "newPrice": 132,
        "extra": "Extra 10%"
    },
    {
        "id": 64176,
        "title": "Raw Linen Blend Striped Patterned Semi-Sheer Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-raw-linen-blend-sheer-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64090",
        "_fabric_color": [
            {
                "term_id": 64090,
                "gallery": [
                    97181,
                    65337,
                    65336,
                    65331,
                    65334,
                    65333,
                    65332,
                    65335
                ],
                "imgSrc": "/cdn/shop/files/Group-1000005883-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Group-1000005883.png",
                "imgSrcF": "/cdn/shop/files/38-1.png",
                "price": 40,
                "title": "Raw / Natural",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Indoor Sheer Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Easter Sale",
            "Extra 10%",
            "farmhouse custom curtains",
            "Faux Linen Curtains",
            "flash_categories",
            "Independence Day",
            "Indoor Sheer Curtains",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Sheer Curtains",
            "Outsourced products",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Sale",
            "Search curtains",
            "Search faux linen blackout",
            "Search linen",
            "Search Linen blend curtains",
            "Search sheer",
            "striped custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Group-1000005883-500x500.png",
        "hoverImg": "/cdn/shop/files/Natural-3-500x500.jpg",
        "subheading": "Linen Blend Striped Patterned Semi-Sheer Custom Curtain",
        "Fabrics": [
            "Raw"
        ],
        "Feature": [],
        "Material": [
            "Linen",
            "Sheer"
        ],
        "Pattern": [],
        "Color": [
            "Beige"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 132,
        "newPrice": 106,
        "extra": "Extra 10%"
    },
    {
        "id": 64181,
        "title": "Palma Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "ProductUrl": "/custom-curtains/custom-palma-foil-printed-velvet-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64121",
        "_fabric_color": [
            {
                "term_id": 64121,
                "gallery": [
                    108874,
                    108879,
                    108875,
                    108876,
                    108877,
                    108878
                ],
                "imgSrc": "/cdn/shop/files/rosegold-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/rosegold-1.jpg",
                "imgSrcF": "/cdn/shop/files/palma-color-4.png",
                "price": 40,
                "title": "Palma / Rose Gold",
                "color": "Pink"
            },
            {
                "term_id": 64126,
                "gallery": [
                    108869,
                    108874,
                    108878,
                    108877,
                    108876,
                    108875
                ],
                "imgSrc": "/cdn/shop/files/black-500x500.png",
                "imgSrc_n": "/cdn/shop/files/black.png",
                "imgSrcF": "/cdn/shop/files/palma-color-8.png",
                "price": 40,
                "title": "Palma / Black",
                "color": "Black"
            },
            {
                "term_id": 64127,
                "gallery": [
                    108881,
                    108874,
                    108878,
                    108877,
                    108876,
                    108875
                ],
                "imgSrc": "/cdn/shop/files/teal-500x500.png",
                "imgSrc_n": "/cdn/shop/files/teal.png",
                "imgSrcF": "/cdn/shop/files/palma-color-9.png",
                "price": 40,
                "title": "Palma / Teal",
                "color": "Green"
            },
            {
                "term_id": 64117,
                "gallery": [
                    108867,
                    108874,
                    108878,
                    108877,
                    108876,
                    108875
                ],
                "imgSrc": "/cdn/shop/files/ash-500x500.png",
                "imgSrc_n": "/cdn/shop/files/ash.png",
                "imgSrcF": "/cdn/shop/files/palma-color-10.png",
                "price": 40,
                "title": "Palma / Ash",
                "color": "Beige"
            },
            {
                "term_id": 64118,
                "gallery": [
                    108872,
                    108874,
                    108878,
                    108877,
                    108876,
                    108875
                ],
                "imgSrc": "/cdn/shop/files/gold-500x500.png",
                "imgSrc_n": "/cdn/shop/files/gold.png",
                "imgSrcF": "/cdn/shop/files/palma-color-1.png",
                "price": 40,
                "title": "Palma / Gold",
                "color": "Gold"
            },
            {
                "term_id": 64119,
                "gallery": [
                    108873,
                    108874,
                    108878,
                    108877,
                    108876,
                    108875
                ],
                "imgSrc": "/cdn/shop/files/misty-500x500.png",
                "imgSrc_n": "/cdn/shop/files/misty.png",
                "imgSrcF": "/cdn/shop/files/palma-color-2.png",
                "price": 40,
                "title": "Palma / Misty",
                "color": "Silver"
            },
            {
                "term_id": 64120,
                "gallery": [
                    94950,
                    65706,
                    65707,
                    65708,
                    65709,
                    65710
                ],
                "imgSrc": "/cdn/shop/files/palma-display-5-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/palma-display-5-1.png",
                "imgSrcF": "/cdn/shop/files/palma-color-3.png",
                "price": 40,
                "title": "Palma / Azure",
                "color": "Blue"
            },
            {
                "term_id": 64116,
                "gallery": [
                    94948,
                    65706,
                    65707,
                    65708,
                    65710,
                    65709
                ],
                "imgSrc": "/cdn/shop/files/palma-display-3-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/palma-display-3-1.png",
                "imgSrcF": "/cdn/shop/files/palma-color-5.png",
                "price": 40,
                "title": "Palma / Silver",
                "color": "Silver"
            },
            {
                "term_id": 64113,
                "gallery": [
                    94947,
                    65706,
                    65707,
                    65708,
                    65709,
                    65710
                ],
                "imgSrc": "/cdn/shop/files/palma-display-2-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/palma-display-2-1.png",
                "imgSrcF": "/cdn/shop/files/palma-color-6.png",
                "price": 40,
                "title": "Palma / Champagne",
                "color": "Beige"
            },
            {
                "term_id": 64114,
                "gallery": [
                    94946,
                    65706,
                    65707,
                    65708,
                    65709,
                    65710
                ],
                "imgSrc": "/cdn/shop/files/palma-display-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/palma-display-1-1.png",
                "imgSrcF": "/cdn/shop/files/palma-color-7.png",
                "price": 40,
                "title": "Palma / Cream",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Foil Printed Velvet Curtains",
            "Light Filtering Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Extra 10%",
            "flash_categories",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "patterned custom curtains",
            "Sale",
            "Search curtains",
            "Search Foil Print",
            "Search Pinch pleat",
            "Search velvet",
            "Solid Velvet Curtains",
            "Summer",
            "Synthetic Curtains",
            "velvet custom curtains",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/rosegold-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/rosegold-2-500x500.jpg",
        "subheading": "Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "Fabrics": [
            "Palma"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Pink",
            "Black",
            "Green",
            "Beige",
            "Gold",
            "Silver",
            "Blue",
            "Silver",
            "Beige",
            "Beige"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 147,
        "newPrice": 103,
        "extra": "Extra 10%"
    },
    {
        "id": 64177,
        "title": "Gradient Ultra Light Soft Shimmering Sheer Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-gradient-sheer-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64091",
        "_fabric_color": [
            {
                "term_id": 64091,
                "gallery": [
                    94692,
                    65578,
                    65579,
                    65580,
                    65581,
                    65582,
                    65577
                ],
                "imgSrc": "/cdn/shop/files/FA-KFN0804-500x500.png",
                "imgSrc_n": "/cdn/shop/files/FA-KFN0804.png",
                "imgSrcF": "/cdn/shop/files/FA-KFN0804-color.png",
                "price": 35,
                "title": "Gradient / Ivory",
                "color": "White"
            },
            {
                "term_id": 64092,
                "gallery": [
                    97913,
                    97914,
                    97915,
                    97917,
                    97916,
                    97918,
                    94691
                ],
                "imgSrc": "/cdn/shop/files/Champagne-Silver-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Champagne-Silver-1.jpg",
                "imgSrcF": "/cdn/shop/files/FA-KFN0803-color.png",
                "price": 35,
                "title": "Gradient / Champagne Silver",
                "color": "Silver"
            },
            {
                "term_id": 64093,
                "gallery": [
                    65578,
                    65579,
                    65580,
                    65581,
                    65582,
                    65577,
                    94690
                ],
                "imgSrc": "/cdn/shop/files/Fanta-2-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Fanta-2-3.jpg",
                "imgSrcF": "/cdn/shop/files/FA-KFN0802-color.png",
                "price": 35,
                "title": "Gradient / Fanta",
                "color": "Red"
            },
            {
                "term_id": 64082,
                "gallery": [
                    94689,
                    65578,
                    65579,
                    65580,
                    65581,
                    65582,
                    65577
                ],
                "imgSrc": "/cdn/shop/files/FA-KFN0801-500x500.png",
                "imgSrc_n": "/cdn/shop/files/FA-KFN0801.png",
                "imgSrcF": "/cdn/shop/files/FA-KFN0801-color.png",
                "price": 35,
                "title": "Gradient / Sage",
                "color": "Green"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Indoor Sheer Curtains",
            "Light Filtering Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "flash_categories",
            "Independence Day",
            "Indoor Sheer Curtains",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Sheer Curtains",
            "Outsourced products",
            "Search curtains",
            "Search sheer",
            "Summer",
            "Synthetic Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Fanta-2-3-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Fanta-1-3-500x500.jpg",
        "subheading": "Ultra Light Soft Shimmering Sheer Custom Curtain",
        "Fabrics": [
            "Gradient"
        ],
        "Feature": [],
        "Material": [
            "Sheer",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White",
            "Silver",
            "Red",
            "Green"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 130,
        "newPrice": 106,
        "extra": "Extra 10%"
    },
    {
        "id": 101357,
        "title": "Glint 4 Layers Linen Blend Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain",
        "ProductUrl": "/product/glint-4-layer-linen-blend-heavyweight-soundproof-thermal-blackout-anti-dust-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64089",
        "_fabric_color": [
            {
                "term_id": 64089,
                "gallery": [
                    107110,
                    101359,
                    101303,
                    101302,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Cream-glint-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Cream-glint.png",
                "imgSrcF": "/cdn/shop/files/Cream-glint.png",
                "price": 50,
                "title": "Glint / Cream",
                "color": "Beige"
            },
            {
                "term_id": 64088,
                "gallery": [
                    107111,
                    101359,
                    101303,
                    101302,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Sesame-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Sesame-1.png",
                "imgSrcF": "/cdn/shop/files/Sesame-1.png",
                "price": 50,
                "title": "Glint / Sesame",
                "color": "Grey"
            },
            {
                "term_id": 101304,
                "gallery": [
                    101359,
                    101303,
                    107830,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Frame-1000006165-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-1000006165.png",
                "imgSrcF": "/cdn/shop/files/5-1.jpg",
                "price": 50,
                "title": "Glint / Black",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Linen Curtains",
            "Textured Curtains",
            "Thermal Curtains",
            "Room Darkening Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "4 layer",
            "All Curtain Sale",
            "All Curtains",
            "beige custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "farmhouse custom curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search linen",
            "Search soundproof",
            "Soundproof &amp; Blackout Curtains",
            "Textured Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "外包4家-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Room Darkening Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "thermal-curtains",
                "name": "thermal curtains"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/glint-2-2-500x500.png",
        "hoverImg": "/cdn/shop/files/5-1-500x500.jpg",
        "subheading": "4 Layers Linen Blend Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain",
        "Fabrics": [
            "Glint"
        ],
        "Feature": [
            "Soundproof"
        ],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Grey",
            "Grey"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 198,
        "newPrice": 158,
        "extra": "Extra 10%"
    },
    {
        "id": 64175,
        "title": "Glint Linen Blend Shimmering Textured Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-glint-linen-blend-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64089",
        "_fabric_color": [
            {
                "term_id": 64089,
                "gallery": [
                    107107,
                    107108,
                    107106,
                    107104,
                    107101,
                    107105,
                    107103,
                    107102,
                    107110
                ],
                "imgSrc": "/cdn/shop/files/Cream-4-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Cream-4-1.jpg",
                "imgSrcF": "/cdn/shop/files/Cream-glint.png",
                "price": 40,
                "title": "Glint / Cream",
                "color": "Beige"
            },
            {
                "term_id": 64088,
                "gallery": [
                    107111,
                    65344,
                    65345,
                    65346,
                    65347,
                    65343,
                    65342,
                    65341,
                    65348
                ],
                "imgSrc": "/cdn/shop/files/Sesame-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Sesame-1.png",
                "imgSrcF": "/cdn/shop/files/Sesame-1.png",
                "price": 40,
                "title": "Glint / Sesame",
                "color": "Grey"
            },
            {
                "term_id": 101304,
                "gallery": [
                    107100,
                    107099,
                    107098,
                    107096,
                    107830
                ],
                "imgSrc": "/cdn/shop/files/glint-2-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/glint-2-2.png",
                "imgSrcF": "/cdn/shop/files/5-1.jpg",
                "price": 40,
                "title": "Glint / Black",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Textured Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "beige custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Extra 10%",
            "farmhouse custom curtains",
            "Independence Day",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "Sale",
            "Search curtains",
            "Search linen",
            "Search Pinch pleat",
            "Solid Curtains",
            "Summer",
            "Textured Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": true,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "premiere",
                "name": "premiere"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Cream-4-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Cream-glint-500x500.png",
        "subheading": "Linen Blend Shimmering Textured Custom Curtain",
        "Fabrics": [
            "Glint"
        ],
        "Feature": [],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Grey",
            "Grey"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 151,
        "newPrice": 136,
        "extra": "Extra 10%"
    },
    {
        "id": 1218,
        "title": "Kyoto 100% Linen Semi Sheer Custom Curtain",
        "ProductUrl": "/linen-cotton-curtains/custom-pure-linen-light-filtering-sheer-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "1095",
        "_fabric_color": [
            {
                "term_id": 1095,
                "gallery": [
                    107729,
                    107725,
                    107726,
                    107730,
                    107727,
                    107728
                ],
                "imgSrc": "/cdn/shop/files/white-2-5-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/white-2-5-1.jpg",
                "imgSrcF": "/cdn/shop/files/5-2.jpg",
                "price": 50,
                "title": "Kyoto / White",
                "color": "White"
            },
            {
                "term_id": 31067,
                "gallery": [
                    60268,
                    50967,
                    50968,
                    60270,
                    60271,
                    50970,
                    50971
                ],
                "imgSrc": "/cdn/shop/files/Baby-Pink-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Baby-Pink-1.jpg",
                "imgSrcF": "/cdn/shop/files/Baby-Pink-1.jpg",
                "price": 50,
                "title": "Kyoto / Baby Pink",
                "color": "Pink"
            },
            {
                "term_id": 31072,
                "gallery": [
                    60280,
                    50967,
                    50968,
                    60282,
                    60283,
                    50970,
                    50971
                ],
                "imgSrc": "/cdn/shop/files/Kyoto-Sand-Color-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Kyoto-Sand-Color-1.jpg",
                "imgSrcF": "/cdn/shop/files/Kyoto-Sand-Color.jpg",
                "price": 50,
                "title": "Kyoto / Sand Color",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Cyber Monday",
            "Fall Collection",
            "flash_categories",
            "Independence Day",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Outsourced products",
            "Sale",
            "Search curtains",
            "Search linen",
            "Search sheer",
            "Spring Time Sale",
            "Summer Collection",
            "Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": true,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "premiere",
                "name": "premiere"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "These curtain panels are made of  high-quality pure linen fabric, feeling soft and textured with exquisite workmanship. Made by senior workers, these curtains boast perfect appearance with neat trimming and seams. They have soft surface and silky backing, and their material is healthy, skin-friendly and easy to take care. These curtains are suitable for bedroom, living room, dining room, children's room, etc. The soft, easy-draping, and translucent linen curtains provide privacy while letting in enough daylight to keep the room cheered.",
        "imgSrc": "/cdn/shop/files/kyoto_home-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Honeyview_117-7-500x500.jpg",
        "subheading": "100% Linen Semi Sheer Custom Curtain",
        "Fabrics": [
            "Kyoto"
        ],
        "Feature": [],
        "Material": [
            "Linen",
            "Sheer"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White",
            "Pink",
            "Beige"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 203,
        "newPrice": 183,
        "extra": "Extra 10%"
    },
    {
        "id": 64169,
        "title": "Tide Linen Blend Heavyweight Golden Threads Textured Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-tide-linen-blend-patterned-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64086",
        "_fabric_color": [
            {
                "term_id": 64086,
                "gallery": [
                    65687,
                    65270,
                    65264,
                    65269,
                    65268,
                    65267,
                    65266
                ],
                "imgSrc": "/cdn/shop/files/FB-CR3305-500x500.png",
                "imgSrc_n": "/cdn/shop/files/FB-CR3305.png",
                "imgSrcF": "/cdn/shop/files/FB-CR3305.png",
                "price": 40,
                "title": "Tide / Black",
                "color": "Black"
            },
            {
                "term_id": 64087,
                "gallery": [
                    65691,
                    65270,
                    65264,
                    65269,
                    65268,
                    65267,
                    65266
                ],
                "imgSrc": "/cdn/shop/files/FB-CR3304-500x500.png",
                "imgSrc_n": "/cdn/shop/files/FB-CR3304.png",
                "imgSrcF": "/cdn/shop/files/FB-CR3304.png",
                "price": 40,
                "title": "Tide / Sand",
                "color": "Beige"
            },
            {
                "term_id": 64076,
                "gallery": [
                    65270,
                    65264,
                    65269,
                    65268,
                    65267,
                    65266,
                    65690
                ],
                "imgSrc": "/cdn/shop/files/Cream-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Cream-4.jpg",
                "imgSrcF": "/cdn/shop/files/FB-CR3303.png",
                "price": 40,
                "title": "Tide / Cream",
                "color": "Beige"
            },
            {
                "term_id": 64077,
                "gallery": [
                    65689,
                    65270,
                    65264,
                    65269,
                    65268,
                    65267,
                    65266
                ],
                "imgSrc": "/cdn/shop/files/FB-CR3302-500x500.png",
                "imgSrc_n": "/cdn/shop/files/FB-CR3302.png",
                "imgSrcF": "/cdn/shop/files/FB-CR3302.png",
                "price": 40,
                "title": "Tide / Grey",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Textured Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "beige custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "farmhouse custom curtains",
            "Faux Linen Curtains",
            "flash_categories",
            "Independence Day",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Search curtains",
            "Search faux linen blackout",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "Summer",
            "Textured Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Cream-4-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Cream-1-500x500.png",
        "subheading": "Linen Blend Heavyweight Golden Threads Textured Custom Curtain",
        "Fabrics": [
            "Tide"
        ],
        "Feature": [],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Black",
            "Beige",
            "Beige",
            "Grey"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 145,
        "newPrice": 152,
        "extra": "Extra 10%"
    },
    {
        "id": 101379,
        "title": "Moonlit 4 Layers Textured Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain",
        "ProductUrl": "/product/moonlit-4-layer-textured-heavyweight-soundproof-thermal-blackout-velvet-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64104",
        "_fabric_color": [
            {
                "term_id": 64115,
                "gallery": [
                    98883,
                    98884,
                    98886,
                    98885,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Black-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-1.jpg",
                "imgSrcF": "/cdn/shop/files/black色块.png",
                "price": 50,
                "title": "Moonlit / Black",
                "color": "Black"
            },
            {
                "term_id": 64106,
                "gallery": [
                    108833,
                    108834,
                    108836,
                    108835,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Teal-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Teal-1.jpg",
                "imgSrcF": "/cdn/shop/files/teal色块.png",
                "price": 50,
                "title": "Moonlit / Teal",
                "color": "Blue"
            },
            {
                "term_id": 64107,
                "gallery": [
                    108821,
                    108822,
                    108824,
                    108823,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Red-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Red-1.jpg",
                "imgSrcF": "/cdn/shop/files/red色块.png",
                "price": 50,
                "title": "Moonlit / Red",
                "color": "Red"
            },
            {
                "term_id": 64108,
                "gallery": [
                    108793,
                    108794,
                    108796,
                    108795,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Ebony-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Ebony-1.jpg",
                "imgSrcF": "/cdn/shop/files/ebony色块.png",
                "price": 50,
                "title": "Moonlit / Ebony",
                "color": "Black"
            },
            {
                "term_id": 64109,
                "gallery": [
                    108801,
                    108802,
                    108804,
                    108803,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Metallic-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Metallic-1.jpg",
                "imgSrcF": "/cdn/shop/files/metalic色块.png",
                "price": 50,
                "title": "Moonlit / Metallic",
                "color": "Brown"
            },
            {
                "term_id": 64110,
                "gallery": [
                    108805,
                    108806,
                    108807,
                    108811,
                    108809,
                    108808,
                    108812,
                    108810,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Brown-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Brown.jpg",
                "imgSrcF": "/cdn/shop/files/brown色块.png",
                "price": 50,
                "title": "Moonlit / Brown",
                "color": "Brown"
            },
            {
                "term_id": 64111,
                "gallery": [
                    108813,
                    108814,
                    108815,
                    108816,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Camel-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Camel-1.jpg",
                "imgSrcF": "/cdn/shop/files/camel色块.png",
                "price": 50,
                "title": "Moonlit / Camel",
                "color": "Orange"
            },
            {
                "term_id": 64112,
                "gallery": [
                    108781,
                    108782,
                    108784,
                    108783,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Carrot-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Carrot-1.jpg",
                "imgSrcF": "/cdn/shop/files/carrot色块.png",
                "price": 50,
                "title": "Moonlit / Carrot",
                "color": "Orange"
            },
            {
                "term_id": 64100,
                "gallery": [
                    108825,
                    98856,
                    108828,
                    108827,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Salmon-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Salmon-1.jpg",
                "imgSrcF": "/cdn/shop/files/salmon色块.png",
                "price": 50,
                "title": "Moonlit / Salmon",
                "color": "Orange"
            },
            {
                "term_id": 64101,
                "gallery": [
                    108817,
                    108818,
                    108820,
                    108819,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Mustard-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Mustard-1.jpg",
                "imgSrcF": "/cdn/shop/files/mustard色块.png",
                "price": 50,
                "title": "Moonlit / Mustard",
                "color": "Cyan"
            },
            {
                "term_id": 64102,
                "gallery": [
                    108773,
                    108774,
                    108776,
                    108775,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Azure-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Azure-1.jpg",
                "imgSrcF": "/cdn/shop/files/azure色块.png",
                "price": 50,
                "title": "Moonlit / Azure",
                "color": "Blue"
            },
            {
                "term_id": 64103,
                "gallery": [
                    108797,
                    108798,
                    108800,
                    108799,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/grey色块.png",
                "price": 50,
                "title": "Moonlit / Grey",
                "color": "Grey"
            },
            {
                "term_id": 64104,
                "gallery": [
                    108829,
                    108830,
                    108832,
                    108831,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Silver-Grey-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-Grey-1.jpg",
                "imgSrcF": "/cdn/shop/files/silver-grey色块.png",
                "price": 50,
                "title": "Moonlit / Silver Grey",
                "color": "Grey"
            },
            {
                "term_id": 64105,
                "gallery": [
                    108785,
                    108786,
                    108788,
                    108787,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Champagne-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Champagne-1.jpg",
                "imgSrcF": "/cdn/shop/files/champane色块.png",
                "price": 50,
                "title": "Moonlit / Champagne",
                "color": "Beige"
            },
            {
                "term_id": 64094,
                "gallery": [
                    108789,
                    108790,
                    108792,
                    108791,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Cream-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Cream-1.jpg",
                "imgSrcF": "/cdn/shop/files/cream色块.png",
                "price": 50,
                "title": "Moonlit / Cream",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Foil Printed Velvet Curtains",
            "Thermal Curtains",
            "Room Darkening Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "4 layer",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "flash_categories",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search Foil Print",
            "Search Pinch pleat",
            "Search soundproof",
            "Search velvet",
            "Soundproof &amp; Blackout Curtains",
            "Synthetic Curtains",
            "Thermal Curtains",
            "upcoming fall",
            "velvet custom curtains",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Room Darkening Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "thermal-curtains",
                "name": "thermal curtains"
            },
            {
                "slug": "velvet-curtains",
                "name": "velvet curtains"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Silver-Grey-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Silver-Grey-3-500x500.jpg",
        "subheading": "4 Layers Textured Heavyweight Soundproof Thermal 100% Blackout Velvet Custom Curtain",
        "Fabrics": [
            "Moonlit"
        ],
        "Feature": [
            "Soundproof"
        ],
        "Material": [
            "Velvet",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Black",
            "Blue",
            "Red",
            "Black",
            "Brown",
            "Brown",
            "Orange",
            "Orange",
            "Orange",
            "Cyan",
            "Blue",
            "Grey",
            "Grey",
            "Beige",
            "White"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 208,
        "newPrice": 146,
        "extra": "Extra 10%"
    },
    {
        "id": 64182,
        "title": "Moonlit Velvet Textured Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-moonlit-velvet-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64115",
        "_fabric_color": [
            {
                "term_id": 64115,
                "gallery": [
                    98883,
                    98884,
                    98886,
                    98885
                ],
                "imgSrc": "/cdn/shop/files/Black-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-1.jpg",
                "imgSrcF": "/cdn/shop/files/black色块.png",
                "price": 40,
                "title": "Moonlit / Black",
                "color": "Black"
            },
            {
                "term_id": 64106,
                "gallery": [
                    98851,
                    98852,
                    98854,
                    98853
                ],
                "imgSrc": "/cdn/shop/files/Teal-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Teal-1.jpg",
                "imgSrcF": "/cdn/shop/files/teal色块.png",
                "price": 40,
                "title": "Moonlit / Teal",
                "color": "Blue"
            },
            {
                "term_id": 64107,
                "gallery": [
                    108821,
                    108822,
                    108824,
                    108823
                ],
                "imgSrc": "/cdn/shop/files/Red-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Red-1.jpg",
                "imgSrcF": "/cdn/shop/files/red色块.png",
                "price": 40,
                "title": "Moonlit / Red",
                "color": "Red"
            },
            {
                "term_id": 64108,
                "gallery": [
                    108793,
                    108794,
                    108796,
                    108795
                ],
                "imgSrc": "/cdn/shop/files/Ebony-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Ebony-1.jpg",
                "imgSrcF": "/cdn/shop/files/ebony色块.png",
                "price": 40,
                "title": "Moonlit / Ebony",
                "color": "Black"
            },
            {
                "term_id": 64109,
                "gallery": [
                    108801,
                    108802,
                    108804,
                    108803
                ],
                "imgSrc": "/cdn/shop/files/Metallic-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Metallic-1.jpg",
                "imgSrcF": "/cdn/shop/files/metalic色块.png",
                "price": 40,
                "title": "Moonlit / Metallic",
                "color": "Brown"
            },
            {
                "term_id": 64110,
                "gallery": [
                    108805,
                    108806,
                    108807,
                    108811,
                    108809,
                    108808,
                    108812,
                    108810
                ],
                "imgSrc": "/cdn/shop/files/Brown-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Brown.jpg",
                "imgSrcF": "/cdn/shop/files/brown色块.png",
                "price": 40,
                "title": "Moonlit / Brown",
                "color": "Brown"
            },
            {
                "term_id": 64111,
                "gallery": [
                    108813,
                    108814,
                    108815,
                    108816
                ],
                "imgSrc": "/cdn/shop/files/Camel-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Camel-1.jpg",
                "imgSrcF": "/cdn/shop/files/camel色块.png",
                "price": 40,
                "title": "Moonlit / Camel",
                "color": "Orange"
            },
            {
                "term_id": 64112,
                "gallery": [
                    108781,
                    108782,
                    108784,
                    108783
                ],
                "imgSrc": "/cdn/shop/files/Carrot-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Carrot-1.jpg",
                "imgSrcF": "/cdn/shop/files/carrot色块.png",
                "price": 40,
                "title": "Moonlit / Carrot",
                "color": "Orange"
            },
            {
                "term_id": 64100,
                "gallery": [
                    108825,
                    108826,
                    108828,
                    108827
                ],
                "imgSrc": "/cdn/shop/files/Salmon-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Salmon-1.jpg",
                "imgSrcF": "/cdn/shop/files/salmon色块.png",
                "price": 40,
                "title": "Moonlit / Salmon",
                "color": "Orange"
            },
            {
                "term_id": 64101,
                "gallery": [
                    98863,
                    98864,
                    98866,
                    98865
                ],
                "imgSrc": "/cdn/shop/files/Mustard-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Mustard-1.jpg",
                "imgSrcF": "/cdn/shop/files/mustard色块.png",
                "price": 40,
                "title": "Moonlit / Mustard",
                "color": "Cyan"
            },
            {
                "term_id": 64102,
                "gallery": [
                    98899,
                    98900,
                    98902,
                    98901
                ],
                "imgSrc": "/cdn/shop/files/Azure-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Azure-1.jpg",
                "imgSrcF": "/cdn/shop/files/azure色块.png",
                "price": 40,
                "title": "Moonlit / Azure",
                "color": "Blue"
            },
            {
                "term_id": 64103,
                "gallery": [
                    98891,
                    98892,
                    98894,
                    98893
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-1.jpg",
                "imgSrcF": "/cdn/shop/files/grey色块.png",
                "price": 40,
                "title": "Moonlit / Grey",
                "color": "Grey"
            },
            {
                "term_id": 64104,
                "gallery": [
                    98847,
                    98848,
                    98850,
                    98849
                ],
                "imgSrc": "/cdn/shop/files/Silver-Grey-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-Grey-1.jpg",
                "imgSrcF": "/cdn/shop/files/silver-grey色块.png",
                "price": 40,
                "title": "Moonlit / Silver Grey",
                "color": "Grey"
            },
            {
                "term_id": 64105,
                "gallery": [
                    98875,
                    98876,
                    98878,
                    98877
                ],
                "imgSrc": "/cdn/shop/files/Champagne-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Champagne-1.jpg",
                "imgSrcF": "/cdn/shop/files/champane色块.png",
                "price": 40,
                "title": "Moonlit / Champagne",
                "color": "Beige"
            },
            {
                "term_id": 64094,
                "gallery": [
                    98871,
                    98872,
                    98874,
                    98873
                ],
                "imgSrc": "/cdn/shop/files/Cream-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Cream-1.jpg",
                "imgSrcF": "/cdn/shop/files/cream色块.png",
                "price": 40,
                "title": "Moonlit / Cream",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Foil Printed Velvet Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "flash_categories",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Search curtains",
            "Search Foil Print",
            "Search Pinch pleat",
            "Search velvet",
            "Solid Curtains",
            "Synthetic Curtains",
            "upcoming fall",
            "velvet custom curtains",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Brown-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Brown-4-500x500.jpg",
        "subheading": "Velvet Textured Custom Curtain",
        "Fabrics": [
            "Moonlit"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Black",
            "Blue",
            "Red",
            "Black",
            "Brown",
            "Brown",
            "Orange",
            "Orange",
            "Orange",
            "Cyan",
            "Blue",
            "Grey",
            "Grey",
            "Beige",
            "White"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 136,
        "newPrice": 103,
        "extra": "Extra 10%"
    },
    {
        "id": 64159,
        "title": "Alice Dotted Patterned Heavyweight Soft Textured Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-alice-textured-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64046",
        "_fabric_color": [
            {
                "term_id": 64046,
                "gallery": [
                    95764,
                    95765,
                    95768,
                    95767,
                    95766
                ],
                "imgSrc": "/cdn/shop/files/Alice-Pink-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Alice-Pink-1.png",
                "imgSrcF": "/cdn/shop/files/2402-34-657-1.png",
                "price": 35,
                "title": "Alice / Pink",
                "color": "Pink"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Textured Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Easter Sale",
            "farmhouse custom curtains",
            "heavyweight custom curtains",
            "Independence Day",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "pink custom curtains",
            "Sale",
            "Search curtains",
            "Search Pinch pleat",
            "Synthetic Curtains",
            "Textured Curtains",
            "upcoming fall",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Alice-Pink-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Alice-Pink-4-500x500.png",
        "subheading": "Dotted Patterned Heavyweight Soft Textured Custom Curtains",
        "Fabrics": [
            "Alice"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Pink"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 133,
        "newPrice": 106,
        "extra": "Extra 10%"
    },
    {
        "id": 64161,
        "title": "Crumbled Elegance Linen Blend Lightweight Embroidery Floral Patterned Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-crumbled-elegance-textured-linen-blend-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64045",
        "_fabric_color": [
            {
                "term_id": 64045,
                "gallery": [
                    98182,
                    65427,
                    65424,
                    65428,
                    65426,
                    65429,
                    65425
                ],
                "imgSrc": "/cdn/shop/files/Crumbled-Elegance-Storm-Grey-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Crumbled-Elegance-Storm-Grey.png",
                "imgSrcF": "/cdn/shop/files/Crumbled-Elegance-Storm-Grey.png",
                "price": 40,
                "title": "Crumbled Elegance / Storm Grey",
                "color": "Grey"
            },
            {
                "term_id": 64053,
                "gallery": [
                    98180,
                    65427,
                    65424,
                    65428,
                    65426,
                    65429,
                    65425
                ],
                "imgSrc": "/cdn/shop/files/Crumbled-Elegance-Cream-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Crumbled-Elegance-Cream.png",
                "imgSrcF": "/cdn/shop/files/Crumbled-Elegance-Cream.png",
                "price": 40,
                "title": "Crumbled Elegance / Cream",
                "color": "White"
            },
            {
                "term_id": 64054,
                "gallery": [
                    65427,
                    65424,
                    65428,
                    65429,
                    65425,
                    65426
                ],
                "imgSrc": "/cdn/shop/files/Storm-Grey-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Storm-Grey-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Crumbled-Elegance-Champagne-Gold.png",
                "price": 40,
                "title": "Crumbled Elegance / Champagne Gold",
                "color": "Gold"
            },
            {
                "term_id": 64055,
                "gallery": [
                    98173,
                    98174,
                    98177,
                    98176,
                    98175,
                    98179
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Grey-1-1.png",
                "imgSrcF": "/cdn/shop/files/Crumbled-Elegance-Concrete-Grey.png",
                "price": 40,
                "title": "Crumbled Elegance / Concrete Grey",
                "color": "Grey"
            },
            {
                "term_id": 64056,
                "gallery": [
                    98178,
                    65427,
                    65424,
                    65428,
                    65426,
                    65429,
                    65425
                ],
                "imgSrc": "/cdn/shop/files/Crumbled-Elegance-White-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Crumbled-Elegance-White.png",
                "imgSrcF": "/cdn/shop/files/Crumbled-Elegance-White.png",
                "price": 40,
                "title": "Crumbled Elegance / White",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Textured Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "beige custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "farmhouse custom curtains",
            "Faux Linen Curtains",
            "flash_categories",
            "floral custom curtains",
            "Light Filtering Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Search curtains",
            "Search faux linen blackout",
            "Search linen",
            "Search Linen blend curtains",
            "Synthetic Curtains",
            "Textured Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Storm-Grey-1-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Storm-Grey-4-1-1-500x500.jpg",
        "subheading": "Linen Blend Lightweight Embroidery Floral Patterned Custom Curtain",
        "Fabrics": [
            "Crumbled"
        ],
        "Feature": [],
        "Material": [
            "Linen",
            "Sheer"
        ],
        "Pattern": [
            "Floral"
        ],
        "Color": [
            "Grey",
            "White",
            "Gold",
            "Grey",
            "White"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Sheer"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 132,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 95963,
        "title": "Alpine Wool Blend Sheer Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-alpine-wool-blend-sheer-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95968",
        "_fabric_color": [
            {
                "term_id": 95968,
                "gallery": [
                    96277,
                    96276,
                    96281,
                    96280,
                    96279,
                    96278,
                    96662
                ],
                "imgSrc": "/cdn/shop/files/Alpine-White-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Alpine-White-2.png",
                "imgSrcF": "/cdn/shop/files/Alpine-Oatmeal.png",
                "price": 50,
                "title": "Alpine / Oatmeal",
                "color": "Beige"
            },
            {
                "term_id": 95965,
                "gallery": [
                    96277,
                    96276,
                    96281,
                    96280,
                    96279,
                    96278,
                    96663
                ],
                "imgSrc": "/cdn/shop/files/Alpine-White-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Alpine-White-2.png",
                "imgSrcF": "/cdn/shop/files/Alpine-White.png",
                "price": 50,
                "title": "Alpine / White",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Independence Day",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Sheer Curtains",
            "Outsourced products",
            "pinch pleat custom curtains",
            "Sale",
            "Search curtains",
            "Search Pinch pleat",
            "Search sheer",
            "winter custom curtains",
            "Wool Curtains",
            "Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "primere",
                "name": "primere"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Alpine-White-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Alpine-White-4-500x500.png",
        "subheading": "Wool Blend Sheer Custom Curtain",
        "Fabrics": [
            "Alpine"
        ],
        "Feature": [],
        "Material": [
            "Sheer",
            "Wool"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "White"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 160,
        "newPrice": 144,
        "extra": "Extra 10%"
    },
    {
        "id": 64170,
        "title": "Grace Wool Blend Textured Sheer Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-grace-wool-blend-sheer-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64078",
        "_fabric_color": [
            {
                "term_id": 64078,
                "gallery": [
                    95823,
                    95824,
                    95828,
                    96726,
                    95826,
                    95825,
                    95827
                ],
                "imgSrc": "/cdn/shop/files/Grace-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Grace-1.png",
                "imgSrcF": "/cdn/shop/files/Oatmeal-8.png",
                "price": 40,
                "title": "Grace / Oatmeal",
                "color": "Beige"
            },
            {
                "term_id": 64079,
                "gallery": [
                    96727,
                    95823,
                    95824,
                    95828,
                    95827,
                    95826,
                    95825
                ],
                "imgSrc": "/cdn/shop/files/White-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/White-1.png",
                "imgSrcF": "/cdn/shop/files/White-2.png",
                "price": 40,
                "title": "Grace / White",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "beige custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Extra 10%",
            "farmhouse custom curtains",
            "flash_categories",
            "Independence Day",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Sheer Curtains",
            "Outsourced products",
            "pinch pleat custom curtains",
            "Search curtains",
            "Search Pinch pleat",
            "Search sheer",
            "winter custom curtains",
            "Wool Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Grace-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Grace-3-500x500.png",
        "subheading": "Wool Blend Textured Sheer Custom Curtain",
        "Fabrics": [
            "Grace"
        ],
        "Feature": [],
        "Material": [
            "Sheer",
            "Wool"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Beige",
            "White"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 147,
        "newPrice": 152,
        "extra": "Extra 10%"
    },
    {
        "id": 95263,
        "title": "Composer Linen Blend Geometric Patterned Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-composer-patterned-wool-linen-blend-room-darkening-curtaincomposer/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95463",
        "_fabric_color": [
            {
                "term_id": 95463,
                "gallery": [
                    95851,
                    95845,
                    95850,
                    95843,
                    95846,
                    95849,
                    95848,
                    95847,
                    95852
                ],
                "imgSrc": "/cdn/shop/files/Black-Green-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Black-Green-1.png",
                "imgSrcF": "/cdn/shop/files/Black-Green.png",
                "price": 40,
                "title": "Composer / Black Green",
                "color": "Green"
            },
            {
                "term_id": 95454,
                "gallery": [
                    95842,
                    95851,
                    95845,
                    95850,
                    95846,
                    95849,
                    95848,
                    95847,
                    95852
                ],
                "imgSrc": "/cdn/shop/files/Black-Grey-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Black-Grey.png",
                "imgSrcF": "/cdn/shop/files/Black-Grey.png",
                "price": 40,
                "title": "Composer / Black Grey",
                "color": "Grey"
            },
            {
                "term_id": 95455,
                "gallery": [
                    95841,
                    95851,
                    95845,
                    95850,
                    95846,
                    95849,
                    95848,
                    95847,
                    95852
                ],
                "imgSrc": "/cdn/shop/files/Silver-Grey-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Silver-Grey.png",
                "imgSrcF": "/cdn/shop/files/Silver-Grey.png",
                "price": 40,
                "title": "Composer / Silver Grey",
                "color": "Grey"
            },
            {
                "term_id": 95456,
                "gallery": [
                    95840,
                    95851,
                    95845,
                    95850,
                    95846,
                    95849,
                    95848,
                    95847,
                    95852
                ],
                "imgSrc": "/cdn/shop/files/lit-500x500.png",
                "imgSrc_n": "/cdn/shop/files/lit.png",
                "imgSrcF": "/cdn/shop/files/lit.png",
                "price": 40,
                "title": "Composer / lit",
                "color": "Beige"
            },
            {
                "term_id": 95464,
                "gallery": [
                    95844,
                    95851,
                    95845,
                    95850,
                    95846,
                    95849,
                    95848,
                    95847,
                    95852
                ],
                "imgSrc": "/cdn/shop/files/Orange-Green-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Orange-Green.png",
                "imgSrcF": "/cdn/shop/files/FB-CR3204-5.png",
                "price": 40,
                "title": "Composer / Orange Green",
                "color": "Orange"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Designer Curtains",
            "Linen Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Designer Curtains",
            "Faux Linen Curtains",
            "geometric custom curtains",
            "Independence Day",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Search curtains",
            "Search Pinch pleat",
            "Wool Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Black-Green-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Black-Green-5-500x500.png",
        "subheading": "Linen Blend Geometric Patterned Custom Curtain",
        "Fabrics": [
            "Composer"
        ],
        "Feature": [],
        "Material": [
            "Linen",
            "Wool"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Green",
            "Grey",
            "Grey",
            "Beige",
            "Orange"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 149,
        "newPrice": 102,
        "extra": "Extra 10%"
    },
    {
        "id": 95288,
        "title": "Flora Velvet Emboidered Floral Pattern Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-flora-embroidered-velvet-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95559",
        "_fabric_color": [
            {
                "term_id": 95559,
                "gallery": [
                    95769,
                    95775,
                    96621,
                    95770,
                    95774,
                    95773,
                    95772,
                    95771
                ],
                "imgSrc": "/cdn/shop/files/Flora-Black-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Flora-Black-1.png",
                "imgSrcF": "/cdn/shop/files/BE-1806-5-2.png",
                "price": 40,
                "title": "Flora / Black",
                "color": "Black"
            },
            {
                "term_id": 95560,
                "gallery": [
                    96620,
                    95769,
                    95775,
                    95770,
                    95774,
                    95773,
                    95772,
                    95771
                ],
                "imgSrc": "/cdn/shop/files/BE-1806-4-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BE-1806-4.png",
                "imgSrcF": "/cdn/shop/files/BE-1806-4-2.png",
                "price": 40,
                "title": "Flora / Blue",
                "color": "Blue"
            },
            {
                "term_id": 95561,
                "gallery": [
                    96619,
                    95769,
                    95775,
                    95770,
                    95774,
                    95773,
                    95772,
                    95771
                ],
                "imgSrc": "/cdn/shop/files/BE-1806-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BE-1806-3.png",
                "imgSrcF": "/cdn/shop/files/BE-1806-3-2.png",
                "price": 40,
                "title": "Flora / Grey",
                "color": "Grey"
            },
            {
                "term_id": 95562,
                "gallery": [
                    98626,
                    98627,
                    96618,
                    98628,
                    98630,
                    98629,
                    98631
                ],
                "imgSrc": "/cdn/shop/files/1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/1-1.jpg",
                "imgSrcF": "/cdn/shop/files/BE-1806-2-2.png",
                "price": 40,
                "title": "Flora / Light Taupe",
                "color": "Beige"
            },
            {
                "term_id": 95550,
                "gallery": [
                    96617,
                    95769,
                    95775,
                    95770,
                    95774,
                    95773,
                    95772,
                    95771
                ],
                "imgSrc": "/cdn/shop/files/BE-1806-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BE-1806-1.png",
                "imgSrcF": "/cdn/shop/files/BE-1806-1-2.png",
                "price": 40,
                "title": "Flora / Beige",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Foil Printed Velvet Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "black custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "farmhouse custom curtains",
            "floral custom curtains",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Search curtains",
            "Search Foil Print",
            "Search velvet",
            "velvet custom curtains",
            "Velvet Pattern Curtains",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Flora-Black-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Flora-Black-5-500x500.png",
        "subheading": "Velvet Emboidered Floral Pattern Custom Curtain",
        "Fabrics": [
            "Flora"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Floral"
        ],
        "Color": [
            "Black",
            "Blue",
            "Grey",
            "Beige",
            "Beige"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 233,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 95286,
        "title": "Klimt Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "ProductUrl": "/custom-curtains/custom-klimt-foil-printed-velvet-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95552",
        "_fabric_color": [
            {
                "term_id": 95552,
                "gallery": [
                    95787,
                    95793,
                    95791,
                    95792,
                    95789,
                    95788,
                    95790,
                    108403
                ],
                "imgSrc": "/cdn/shop/files/Klimt-Black-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Klimt-Black-1.png",
                "imgSrcF": "/cdn/shop/files/BF354-6-2.png",
                "price": 50,
                "title": "Klimt / Black",
                "color": "Black"
            },
            {
                "term_id": 95549,
                "gallery": [
                    108402,
                    95787,
                    95793,
                    95792,
                    95791,
                    95789,
                    95788,
                    95790
                ],
                "imgSrc": "/cdn/shop/files/beige-5-500x500.png",
                "imgSrc_n": "/cdn/shop/files/beige-5.png",
                "imgSrcF": "/cdn/shop/files/beige-5.png",
                "price": 50,
                "title": "Klimt / Beige",
                "color": "Beige"
            },
            {
                "term_id": 95551,
                "gallery": [
                    108404,
                    95787,
                    95793,
                    95792,
                    95791,
                    95789,
                    95788,
                    95790
                ],
                "imgSrc": "/cdn/shop/files/copper-500x500.png",
                "imgSrc_n": "/cdn/shop/files/copper.png",
                "imgSrcF": "/cdn/shop/files/copper.png",
                "price": 50,
                "title": "Klimt / Copper",
                "color": "Beige"
            },
            {
                "term_id": 95553,
                "gallery": [
                    108405,
                    95787,
                    95793,
                    95792,
                    95791,
                    95789,
                    95788,
                    95790
                ],
                "imgSrc": "/cdn/shop/files/gold-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/gold-1.png",
                "imgSrcF": "/cdn/shop/files/gold-1.png",
                "price": 50,
                "title": "Klimt / Gold",
                "color": "Gold"
            },
            {
                "term_id": 95554,
                "gallery": [
                    108408,
                    95787,
                    95793,
                    95792,
                    95791,
                    95789,
                    95788,
                    95790
                ],
                "imgSrc": "/cdn/shop/files/silverblue-500x500.png",
                "imgSrc_n": "/cdn/shop/files/silverblue.png",
                "imgSrcF": "/cdn/shop/files/silverblue.png",
                "price": 50,
                "title": "Klimt / Silver Blue",
                "color": "Blue"
            },
            {
                "term_id": 95555,
                "gallery": [
                    108407,
                    95787,
                    95793,
                    95792,
                    95791,
                    95789,
                    95788,
                    95790
                ],
                "imgSrc": "/cdn/shop/files/silver-8-500x500.png",
                "imgSrc_n": "/cdn/shop/files/silver-8.png",
                "imgSrcF": "/cdn/shop/files/silver-8.png",
                "price": 50,
                "title": "Klimt / Silver",
                "color": "Silver"
            },
            {
                "term_id": 95546,
                "gallery": [
                    108406,
                    95787,
                    95793,
                    95792,
                    95791,
                    95790,
                    95789,
                    95788
                ],
                "imgSrc": "/cdn/shop/files/platnium-500x500.png",
                "imgSrc_n": "/cdn/shop/files/platnium.png",
                "imgSrcF": "/cdn/shop/files/platnium.png",
                "price": 50,
                "title": "Klimt / Platinum",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Foil Printed Velvet Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Search curtains",
            "Search Foil Print",
            "Search Pinch pleat",
            "Search velvet",
            "Solid Velvet Curtains",
            "upcoming fall",
            "velvet custom curtains",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Klimt-Black-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Klimt-Black-2-500x500.png",
        "subheading": "Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "Fabrics": [
            "Klimt"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Black",
            "Beige",
            "Beige",
            "Gold",
            "Blue",
            "Silver",
            "White"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 165,
        "newPrice": 144,
        "extra": "Extra 10%"
    },
    {
        "id": 101356,
        "title": "Petra 4 Layers Geometric Patterned Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain",
        "ProductUrl": "/product/petra-4-layer-geometric-patterned-heavyweight-soundproof-thermal-blackout-anti-dust-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64083",
        "_fabric_color": [
            {
                "term_id": 64085,
                "gallery": [
                    97078,
                    97077,
                    97080,
                    97082,
                    97081,
                    97079,
                    97089,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Petra-Lit-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Petra-Lit-2.png",
                "imgSrcF": "/cdn/shop/files/FB-KF0401.jpg",
                "price": 40,
                "title": "Petra / Lit",
                "color": "White"
            },
            {
                "term_id": 64083,
                "gallery": [
                    97088,
                    97078,
                    97077,
                    97080,
                    97082,
                    97081,
                    97079,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FB-KF0405-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FB-KF0405.jpg",
                "imgSrcF": "/cdn/shop/files/FB-KF0405.jpg",
                "price": 40,
                "title": "Petra / Brown",
                "color": "Brown"
            },
            {
                "term_id": 64084,
                "gallery": [
                    97087,
                    97078,
                    97077,
                    97080,
                    97082,
                    97081,
                    97079,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FB-KF0404-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FB-KF0404.jpg",
                "imgSrcF": "/cdn/shop/files/FB-KF0404.jpg",
                "price": 40,
                "title": "Petra / Mint Gold",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Designer Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "4 layer",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Designer Curtains",
            "flash_categories",
            "geometric custom curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "Search blackout",
            "Search curtains",
            "Search soundproof",
            "Soundproof &amp; Blackout Curtains",
            "Synthetic Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "外包4家-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "thermal-curtains",
                "name": "thermal curtains"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Petra-Lit-2-500x500.png",
        "hoverImg": "/cdn/shop/files/Petra-Lit-3-500x500.png",
        "subheading": "4 Layers Geometric Patterned Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain",
        "Fabrics": [
            "Petra"
        ],
        "Feature": [
            "Soundproof"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "White",
            "Brown",
            "Gold"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 140,
        "newPrice": 158,
        "extra": "Extra 10%"
    },
    {
        "id": 64178,
        "title": "Petra Geometric Patterned Heavyweight Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-petra-patterned-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64083",
        "_fabric_color": [
            {
                "term_id": 64083,
                "gallery": [
                    97088,
                    97077,
                    97078,
                    97080,
                    97082,
                    97081,
                    97079
                ],
                "imgSrc": "/cdn/shop/files/FB-KF0405-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FB-KF0405.jpg",
                "imgSrcF": "/cdn/shop/files/FB-KF0405.jpg",
                "price": 40,
                "title": "Petra / Brown",
                "color": "Brown"
            },
            {
                "term_id": 64084,
                "gallery": [
                    97087,
                    97077,
                    97078,
                    97080,
                    97082,
                    97081,
                    97079
                ],
                "imgSrc": "/cdn/shop/files/FB-KF0404-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FB-KF0404.jpg",
                "imgSrcF": "/cdn/shop/files/FB-KF0404.jpg",
                "price": 40,
                "title": "Petra / Mint Gold",
                "color": "Gold"
            },
            {
                "term_id": 64085,
                "gallery": [
                    97077,
                    97078,
                    97080,
                    97082,
                    97081,
                    97079,
                    97089
                ],
                "imgSrc": "/cdn/shop/files/Petra-Lit-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Petra-Lit-1.png",
                "imgSrcF": "/cdn/shop/files/FB-KF0401.jpg",
                "price": 40,
                "title": "Petra / Lit",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Designer Curtains",
            "Light Filtering Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Designer Curtains",
            "flash_categories",
            "geometric custom curtains",
            "Light Filtering Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "Search curtains",
            "Search Pinch pleat",
            "Synthetic Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Petra-Lit-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Petra-Lit-3-500x500.png",
        "subheading": "Geometric Patterned Heavyweight Custom Curtain",
        "Fabrics": [
            "Petra"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Brown",
            "Gold",
            "White"
        ],
        "Light": [
            "Blackout",
            "Light Filtering"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 122,
        "newPrice": 106,
        "extra": "Extra 10%"
    },
    {
        "id": 101310,
        "title": "Mist 4 Layers Patterned Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain",
        "ProductUrl": "/product/mist-4-layer-patterned-heavyweight-soundproof-thermal-blackout-anti-dust-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64052",
        "_fabric_color": [
            {
                "term_id": 64061,
                "gallery": [
                    107309,
                    107310,
                    107315,
                    107314,
                    107313,
                    107312,
                    107311,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/sand-3-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/sand-3-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/sand-4-1.png",
                "price": 50,
                "title": "Mist / Sand",
                "color": "Beige"
            },
            {
                "term_id": 64062,
                "gallery": [
                    107295,
                    107296,
                    107301,
                    107300,
                    107299,
                    107298,
                    107297,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Black-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-1.jpg",
                "imgSrcF": "/cdn/shop/files/black-4-1.png",
                "price": 50,
                "title": "Mist / Black",
                "color": "Black"
            },
            {
                "term_id": 64051,
                "gallery": [
                    107302,
                    107303,
                    107308,
                    107307,
                    107306,
                    107305,
                    107304,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/light-grey-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/light-grey-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/light-grey-3-1.png",
                "price": 50,
                "title": "Mist / Light Grey",
                "color": "Grey"
            },
            {
                "term_id": 64052,
                "gallery": [
                    107288,
                    107289,
                    107294,
                    107293,
                    107292,
                    107291,
                    107290,
                    99116,
                    99530
                ],
                "imgSrc": "/cdn/shop/files/ash-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/ash-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/ash-4-1.png",
                "price": 50,
                "title": "Mist / Ash",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 54949,
                "gallery": null,
                "price": 0,
                "title": "White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 55047,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Cotton Curtains",
            "Designer Curtains",
            "Thermal Curtains",
            "Room Darkening Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "4 layer",
            "All Curtain Sale",
            "All Curtains",
            "beige custom curtains",
            "Cotton Blend Curtains",
            "Cotton Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Designer Curtains",
            "flash_categories",
            "heavyweight custom curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "Sale",
            "Search blackout",
            "Search cotton",
            "Search curtains",
            "Search soundproof",
            "Soundproof &amp; Blackout Curtains",
            "Synthetic Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "外包4家-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Room Darkening Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "thermal-curtains",
                "name": "thermal curtains"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/ash-3-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/ash-4-1-500x500.png",
        "subheading": "4 Layers Patterned Heavyweight Soundproof Thermal 100% Blackout Anti-Dust Custom Curtain",
        "Fabrics": [
            "Mist"
        ],
        "Feature": [
            "Soundproof"
        ],
        "Material": [
            "Cotton"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Beige",
            "Black",
            "Grey",
            "Grey"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 171,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 95964,
        "title": "Manhattan Linen Blend Grid Sheer Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-manhattan-linen-blend-sheer-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95972",
        "_fabric_color": [
            {
                "term_id": 95972,
                "gallery": [
                    95943,
                    95944,
                    95949,
                    95945,
                    95946,
                    95950,
                    95948,
                    95947
                ],
                "imgSrc": "/cdn/shop/files/Black-Gold-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Black-Gold-1.png",
                "imgSrcF": "/cdn/shop/files/Manhattan-Black-Gold-1.png",
                "price": 35,
                "title": "Manhattan / Black Gold",
                "color": "Black"
            },
            {
                "term_id": 95970,
                "gallery": [
                    104113,
                    104120,
                    104121,
                    104119,
                    104118,
                    104116,
                    104115,
                    104114
                ],
                "imgSrc": "/cdn/shop/files/White-Gold-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/White-Gold-1.png",
                "imgSrcF": "/cdn/shop/files/Manhattan-White-Gold-1.png",
                "price": 35,
                "title": "Manhattan / White Gold",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Easter Sale",
            "Extra 10%",
            "Independence Day",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Sheer Curtains",
            "Outsourced products",
            "pinch pleat custom curtains",
            "Sale",
            "Search curtains",
            "Search faux linen blackout",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "Search sheer",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/White-Gold-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Black-Gold-5-500x500.png",
        "subheading": "Linen Blend Grid Sheer Custom Curtain",
        "Fabrics": [
            "Manhattan"
        ],
        "Feature": [],
        "Material": [
            "Linen",
            "Sheer"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Black",
            "White"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 185,
        "newPrice": 130,
        "extra": "Extra 10%"
    },
    {
        "id": 101364,
        "title": "Meteor 4 Layers Linen Blend Heavyweight Soundproof Thermal 100% Blackout Striped Custom Curtain",
        "ProductUrl": "/product/meteor-4-layer-linen-blend-heavyweight-soundproof-thermal-blackout-striped-custom-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95637",
        "_fabric_color": [
            {
                "term_id": 95637,
                "gallery": [
                    101365,
                    101370,
                    101369,
                    101367,
                    101366,
                    95879,
                    101368,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FE-CR1104-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/FE-CR1104-2.png",
                "imgSrcF": "/cdn/shop/files/Oatmeal.png",
                "price": 40,
                "title": "Meteor / Oatmeal",
                "color": "Beige"
            },
            {
                "term_id": 95638,
                "gallery": [
                    95878,
                    101365,
                    101370,
                    101369,
                    101367,
                    101366,
                    101368,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Cream-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Cream.png",
                "imgSrcF": "/cdn/shop/files/Cream.png",
                "price": 40,
                "title": "Meteor / Cream",
                "color": "White"
            },
            {
                "term_id": 95639,
                "gallery": [
                    95881,
                    101365,
                    101370,
                    101369,
                    101367,
                    101366,
                    101368,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Silver-Grey-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Silver-Grey-1.png",
                "imgSrcF": "/cdn/shop/files/Silver-Grey-1.png",
                "price": 40,
                "title": "Meteor / Silver Grey",
                "color": "Grey"
            },
            {
                "term_id": 95640,
                "gallery": [
                    95880,
                    101365,
                    101370,
                    101369,
                    101367,
                    101366,
                    101368,
                    99530,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/Sesame-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Sesame.png",
                "imgSrcF": "/cdn/shop/files/Sesame.png",
                "price": 40,
                "title": "Meteor / Sesame",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 332,
                "gallery": null,
                "price": 0,
                "title": "Greyish White Liner"
            },
            {
                "term_id": 330,
                "gallery": null,
                "price": 0,
                "title": "Black Liner"
            },
            {
                "term_id": 530,
                "gallery": null,
                "price": 0,
                "title": "Comparable Color Liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Textured Curtains",
            "Thermal Curtains",
            "Blackout Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "4 layer",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Faux Linen Curtains",
            "grey custom curtains",
            "heavyweight custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Search blackout",
            "Search curtains",
            "Search linen",
            "Search Linen blend curtains",
            "Search soundproof",
            "Soundproof &amp; Blackout Curtains",
            "striped custom curtains",
            "Synthetic Curtains",
            "Textured Curtains",
            "Thermal Curtains",
            "同材质内衬面料分类",
            "外包4家-四层",
            "Curtains",
            "Custom Blackout Curtains",
            "Blackout Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "blackout-curtains",
                "name": "blackout curtains"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "thermal-curtains",
                "name": "thermal curtains"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/FE-CR1104-500x500.png",
        "hoverImg": "/cdn/shop/files/FE-CR1104-5-500x500.png",
        "subheading": "4 Layers Linen Blend Heavyweight Soundproof Thermal 100% Blackout Striped Custom Curtain",
        "Fabrics": [
            "Meteor"
        ],
        "Feature": [
            "Soundproof"
        ],
        "Material": [
            "Faux Linen",
            "Linen"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "White",
            "Grey",
            "Grey"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 153,
        "newPrice": 161,
        "extra": "Extra 10%"
    },
    {
        "id": 95272,
        "title": "Meteor Linen Blend Heavyweight Striped Textured Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-meteor-linen-blend-textured-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95637",
        "_fabric_color": [
            {
                "term_id": 95637,
                "gallery": [
                    95879,
                    95882,
                    95883,
                    95888,
                    95885,
                    95884,
                    95887,
                    95886
                ],
                "imgSrc": "/cdn/shop/files/Oatmeal-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Oatmeal.png",
                "imgSrcF": "/cdn/shop/files/Oatmeal.png",
                "price": 40,
                "title": "Meteor / Oatmeal",
                "color": "Beige"
            },
            {
                "term_id": 95638,
                "gallery": [
                    95878,
                    95882,
                    95883,
                    95888,
                    95885,
                    95884,
                    95887,
                    95886
                ],
                "imgSrc": "/cdn/shop/files/Cream-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Cream.png",
                "imgSrcF": "/cdn/shop/files/Cream.png",
                "price": 40,
                "title": "Meteor / Cream",
                "color": "White"
            },
            {
                "term_id": 95639,
                "gallery": [
                    95882,
                    95883,
                    95888,
                    95885,
                    95884,
                    95887,
                    95886,
                    95881
                ],
                "imgSrc": "/cdn/shop/files/Silver-Grey-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Silver-Grey-1-1.png",
                "imgSrcF": "/cdn/shop/files/Silver-Grey-1.png",
                "price": 40,
                "title": "Meteor / Silver Grey",
                "color": "Grey"
            },
            {
                "term_id": 95640,
                "gallery": [
                    95880,
                    95882,
                    95883,
                    95888,
                    95884,
                    95885,
                    95887,
                    95886
                ],
                "imgSrc": "/cdn/shop/files/Sesame-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Sesame.png",
                "imgSrcF": "/cdn/shop/files/Sesame.png",
                "price": 40,
                "title": "Meteor / Sesame",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Textured Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Faux Linen Curtains",
            "grey custom curtains",
            "heavyweight custom curtains",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "pinch pleat custom curtains",
            "Search curtains",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "striped custom curtains",
            "Synthetic Curtains",
            "Textured Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Silver-Grey-1-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Silver-Grey-3-500x500.png",
        "subheading": "Linen Blend Heavyweight Striped Textured Custom Crtain",
        "Fabrics": [
            "Meteor"
        ],
        "Feature": [],
        "Material": [
            "Faux Linen",
            "Linen"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "White",
            "Grey",
            "Grey"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 133,
        "newPrice": 96,
        "extra": "Extra 10%"
    },
    {
        "id": 95287,
        "title": "Mirage Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "ProductUrl": "/custom-curtains/custom-mirage-foil-printed-velvet-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95563",
        "_fabric_color": [
            {
                "term_id": 95563,
                "gallery": [
                    96569,
                    95817,
                    95812,
                    95816,
                    95815,
                    95814,
                    95813
                ],
                "imgSrc": "/cdn/shop/files/BF-A06-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-A06-1.png",
                "imgSrcF": "/cdn/shop/files/BF-A06-1-2.png",
                "price": 40,
                "title": "Mirage / Cream",
                "color": "White"
            },
            {
                "term_id": 95564,
                "gallery": [
                    95817,
                    95812,
                    95816,
                    96572,
                    95815,
                    95814,
                    95813
                ],
                "imgSrc": "/cdn/shop/files/Mirage-6-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Mirage-6.png",
                "imgSrcF": "/cdn/shop/files/BF-A06-3-2.png",
                "price": 40,
                "title": "Mirage / Gold",
                "color": "Gold"
            },
            {
                "term_id": 95565,
                "gallery": [
                    96571,
                    95817,
                    95812,
                    95816,
                    95815,
                    95814,
                    95813
                ],
                "imgSrc": "/cdn/shop/files/BF-A06-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-A06-2.png",
                "imgSrcF": "/cdn/shop/files/BF-A06-2-2.png",
                "price": 40,
                "title": "Mirage / Champagne",
                "color": "Gold"
            },
            {
                "term_id": 95566,
                "gallery": [
                    96573,
                    95817,
                    95812,
                    95816,
                    95815,
                    95814,
                    95813
                ],
                "imgSrc": "/cdn/shop/files/BF-A06-4-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-A06-4.png",
                "imgSrcF": "/cdn/shop/files/BF-A06-4-2.png",
                "price": 40,
                "title": "Mirage / Silver",
                "color": "Silver"
            },
            {
                "term_id": 95568,
                "gallery": [
                    96575,
                    95817,
                    95812,
                    95816,
                    95815,
                    95814,
                    95813
                ],
                "imgSrc": "/cdn/shop/files/BF-A06-6-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-A06-6.png",
                "imgSrcF": "/cdn/shop/files/BF-A06-6-2.png",
                "price": 40,
                "title": "Mirage / Teal",
                "color": "Green"
            },
            {
                "term_id": 95569,
                "gallery": [
                    96574,
                    95817,
                    95812,
                    95816,
                    95815,
                    95814,
                    95813
                ],
                "imgSrc": "/cdn/shop/files/BF-A06-5-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-A06-5.png",
                "imgSrcF": "/cdn/shop/files/BF-A06-5-2.png",
                "price": 40,
                "title": "Mirage / Blue",
                "color": "Blue"
            },
            {
                "term_id": 95567,
                "gallery": [
                    96576,
                    95817,
                    95812,
                    95816,
                    95815,
                    95814,
                    95813
                ],
                "imgSrc": "/cdn/shop/files/BF-A06-7-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-A06-7.png",
                "imgSrcF": "/cdn/shop/files/BF-A06-7-2.png",
                "price": 40,
                "title": "Mirage / Black",
                "color": "Black"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Foil Printed Velvet Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Extra 10%",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Search curtains",
            "Search Foil Print",
            "Search Pinch pleat",
            "Search velvet",
            "Solid Velvet Curtains",
            "striped custom curtains",
            "velvet custom curtains",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Mirage-6-500x500.png",
        "hoverImg": "/cdn/shop/files/Mirage-2-500x500.png",
        "subheading": "Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "Fabrics": [
            "Mirage"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "White",
            "Gold",
            "Gold",
            "Silver",
            "Green",
            "Blue",
            "Black"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 157,
        "newPrice": 144,
        "extra": "Extra 10%"
    },
    {
        "id": 95262,
        "title": "Savannah Linen Blend Heavyweight Floral Patterned Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-savannah-patterned-wool-linen-blend-room-darkening-curtainsavannah/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95466",
        "_fabric_color": [
            {
                "term_id": 95466,
                "gallery": [
                    95862,
                    95863,
                    95861,
                    95860,
                    95853,
                    95854,
                    95859,
                    95856,
                    95858,
                    95857,
                    95855
                ],
                "imgSrc": "/cdn/shop/files/Monochrome-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Monochrome-2.png",
                "imgSrcF": "/cdn/shop/files/Monochrome-1.png",
                "price": 40,
                "title": "Savannah / Monochrome",
                "color": "White"
            },
            {
                "term_id": 95467,
                "gallery": [
                    95861,
                    95860,
                    95853,
                    95854,
                    95859,
                    95858,
                    95865,
                    95857,
                    95856,
                    95855,
                    95864
                ],
                "imgSrc": "/cdn/shop/files/Camouflage-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Camouflage-1.png",
                "imgSrcF": "/cdn/shop/files/Camouflage-11.png",
                "price": 40,
                "title": "Savannah / Camouflage",
                "color": "Green"
            },
            {
                "term_id": 95468,
                "gallery": [
                    95866,
                    95861,
                    95860,
                    95853,
                    95854,
                    95859,
                    95858,
                    95857,
                    95856,
                    95855
                ],
                "imgSrc": "/cdn/shop/files/Desert-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Desert.png",
                "imgSrcF": "/cdn/shop/files/Desert.png",
                "price": 40,
                "title": "Savannah / Desert",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Designer Curtains",
            "Linen Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Designer Curtains",
            "Extra 10%",
            "Faux Linen Curtains",
            "floral custom curtains",
            "heavyweight custom curtains",
            "Independence Day",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "mid century custom curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Search curtains",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "vintage custom curtains",
            "Wool Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Camouflage-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Camouflage-6-500x500.png",
        "subheading": "Linen Blend Heavyweight Floral Patterned Custom Curtain",
        "Fabrics": [
            "Savannah"
        ],
        "Feature": [],
        "Material": [
            "Linen",
            "Wool"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "White",
            "Green",
            "Beige"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 169,
        "newPrice": 102,
        "extra": "Extra 10%"
    },
    {
        "id": 64174,
        "title": "Haze Linen Blend Golden Threads Textured Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-haze-linen-blend-light-filtering-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64099",
        "_fabric_color": [
            {
                "term_id": 64098,
                "gallery": [
                    108304,
                    108650,
                    108306,
                    108308,
                    108305,
                    108310,
                    108309,
                    108307
                ],
                "imgSrc": "/cdn/shop/files/oatmeal-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/oatmeal-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/oatmeal.png",
                "price": 50,
                "title": "Haze / Oatmeal",
                "color": "Beige"
            },
            {
                "term_id": 64097,
                "gallery": [
                    108648,
                    108311,
                    108313,
                    108315,
                    108312,
                    108317,
                    108316,
                    108314
                ],
                "imgSrc": "/cdn/shop/files/black-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/black-1.jpg",
                "imgSrcF": "/cdn/shop/files/black-1.jpg",
                "price": 50,
                "title": "Haze / Black",
                "color": "Black"
            },
            {
                "term_id": 64099,
                "gallery": [
                    108311,
                    108649,
                    108313,
                    108315,
                    108312,
                    108317,
                    108316,
                    108314
                ],
                "imgSrc": "/cdn/shop/files/Cream-1-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Cream-1-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/Haze-display.png",
                "price": 50,
                "title": "Haze / Cream",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Textured Curtains"
        ],
        "AllCategory": [
            "All Curtain Sale",
            "All Curtains",
            "beige custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Extra 10%",
            "farmhouse custom curtains",
            "Faux Linen Curtains",
            "flash_categories",
            "Independence Day",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "Sale",
            "Search curtains",
            "Search faux linen blackout",
            "Search linen",
            "Search Linen blend curtains",
            "Search Pinch pleat",
            "Solid Curtains",
            "Textured Curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Cream-1-2-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Cream-1-2-500x500.png",
        "subheading": "Linen Blend Golden Threads Textured Custom Curtain",
        "Fabrics": [
            "Haze"
        ],
        "Feature": [],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Black",
            "Beige"
        ],
        "Light": [
            "Blackout",
            "Light Filtering"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "35% off",
        "salenum": 35,
        "oldPrice": 157,
        "newPrice": 102,
        "extra": "Extra 10%"
    },
    {
        "id": 95289,
        "title": "Tuscany Foil Printed Velvet Floral Patterned Custom Curtain | Designed in Italy",
        "ProductUrl": "/custom-curtains/custom-tuscany-foil-printed-velvet-room-darkening-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "95984",
        "_fabric_color": [
            {
                "term_id": 95988,
                "gallery": [
                    96512,
                    95803,
                    95810,
                    95807,
                    95808,
                    95809,
                    95806,
                    95805,
                    95804
                ],
                "imgSrc": "/cdn/shop/files/BF769-6-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF769-6.png",
                "imgSrcF": "/cdn/shop/files/BF769-6.png",
                "price": 40,
                "title": "Tuscany / Teal",
                "color": "Green"
            },
            {
                "term_id": 95986,
                "gallery": [
                    96511,
                    95803,
                    95810,
                    95807,
                    95808,
                    95809,
                    95806,
                    95805,
                    95804
                ],
                "imgSrc": "/cdn/shop/files/BF769-5-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF769-5.png",
                "imgSrcF": "/cdn/shop/files/BF769-5.png",
                "price": 40,
                "title": "Tuscany / Blue",
                "color": "Blue"
            },
            {
                "term_id": 95984,
                "gallery": [
                    95803,
                    95810,
                    95807,
                    95808,
                    96510,
                    95809,
                    95806,
                    95805,
                    95804
                ],
                "imgSrc": "/cdn/shop/files/Tuscany-Red-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Tuscany-Red-1.png",
                "imgSrcF": "/cdn/shop/files/BF769-4.png",
                "price": 40,
                "title": "Tuscany / Red",
                "color": "Red"
            },
            {
                "term_id": 95982,
                "gallery": [
                    96509,
                    95803,
                    95810,
                    95807,
                    95808,
                    95809,
                    95806,
                    95805,
                    95804
                ],
                "imgSrc": "/cdn/shop/files/BF769-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF769-3.png",
                "imgSrcF": "/cdn/shop/files/BF769-3.png",
                "price": 40,
                "title": "Tuscany / Gold",
                "color": "Gold"
            },
            {
                "term_id": 95980,
                "gallery": [
                    96508,
                    95810,
                    95803,
                    95807,
                    95808,
                    95809,
                    95806,
                    95805,
                    95804
                ],
                "imgSrc": "/cdn/shop/files/BF769-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF769-2.png",
                "imgSrcF": "/cdn/shop/files/BF769-2.png",
                "price": 40,
                "title": "Tuscany / Mustard",
                "color": "Gold"
            },
            {
                "term_id": 95978,
                "gallery": [
                    96507,
                    95803,
                    95810,
                    95807,
                    95808,
                    95809,
                    95806,
                    95805,
                    95804
                ],
                "imgSrc": "/cdn/shop/files/BF769-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF769-1.png",
                "imgSrcF": "/cdn/shop/files/BF769-1.png",
                "price": 40,
                "title": "Tuscany / Ivory",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Foil Printed Velvet Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "floral custom curtains",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Search curtains",
            "Search Foil Print",
            "Search Pinch pleat",
            "Search velvet",
            "velvet custom curtains",
            "Velvet Pattern Curtains",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Tuscany-Red-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Tuscany-Red-2-500x500.png",
        "subheading": "Foil Printed Velvet Floral Patterned Custom Curtain | Designed in Italy",
        "Fabrics": [
            "Tuscany"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Floral"
        ],
        "Color": [
            "Green",
            "Blue",
            "Red",
            "Gold",
            "Gold",
            "White"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 174,
        "newPrice": 144,
        "extra": "Extra 10%"
    },
    {
        "id": 64163,
        "title": "Rosé Patterned Velvet Heavyweight Custom Curtain | Designed in Italy",
        "ProductUrl": "/custom-curtains/custom-rose-printed-velvet-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64070",
        "_fabric_color": [
            {
                "term_id": 64070,
                "gallery": [
                    65906,
                    64377,
                    64382,
                    64381,
                    64378,
                    64380
                ],
                "imgSrc": "/cdn/shop/files/Ink-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Ink.jpg",
                "imgSrcF": "/cdn/shop/files/Ink-5-1.jpg",
                "price": 40,
                "title": "Rosé / Rosé",
                "color": "Red"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Designer Curtains",
            "Light Filtering Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Designer Curtains",
            "farmhouse custom curtains",
            "flash_categories",
            "floral custom curtains",
            "heavyweight custom curtains",
            "Independence Day",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "pink custom curtains",
            "Sale",
            "Search curtains",
            "Search Pinch pleat",
            "Search velvet",
            "Synthetic Curtains",
            "velvet custom curtains",
            "Velvet Pattern Curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": true,
        "tags": [
            {
                "slug": "editors-pick",
                "name": "editor's pick"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Ink-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Ink-3-1-500x500.jpg",
        "subheading": "Velvet Patterned Custom Curtain | Designed in Italy",
        "Fabrics": [
            "Rosé"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Floral"
        ],
        "Color": [
            "Red"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 165,
        "newPrice": 132,
        "extra": "Extra 10%"
    },
    {
        "id": 64185,
        "title": "Luxor Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "ProductUrl": "/custom-curtains/custom-luxor-foil-printed-velvet-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64135",
        "_fabric_color": [
            {
                "term_id": 64135,
                "gallery": [
                    94912,
                    65564,
                    65562,
                    65556,
                    65554,
                    65557,
                    65657
                ],
                "imgSrc": "/cdn/shop/files/BF-TERRA--500x500.png",
                "imgSrc_n": "/cdn/shop/files/BF-TERRA-.png",
                "imgSrcF": "/cdn/shop/files/Frame-1000005880.png",
                "price": 50,
                "title": "Luxor / Cream",
                "color": "White"
            },
            {
                "term_id": 64139,
                "gallery": [
                    65664,
                    94912,
                    65564,
                    65562,
                    65556,
                    65554,
                    65557
                ],
                "imgSrc": "/cdn/shop/files/Frame-1000005887-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-1000005887.png",
                "imgSrcF": "/cdn/shop/files/Frame-1000005887.png",
                "price": 50,
                "title": "Luxor / Black",
                "color": "Black"
            },
            {
                "term_id": 64140,
                "gallery": [
                    65663,
                    94912,
                    65564,
                    65562,
                    65556,
                    65554,
                    65557
                ],
                "imgSrc": "/cdn/shop/files/Frame-1000005886-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-1000005886.png",
                "imgSrcF": "/cdn/shop/files/Frame-1000005886.png",
                "price": 50,
                "title": "Luxor / Teal",
                "color": "Green"
            },
            {
                "term_id": 64141,
                "gallery": [
                    65662,
                    94912,
                    65564,
                    65562,
                    65556,
                    65554,
                    65557
                ],
                "imgSrc": "/cdn/shop/files/Frame-1000005885-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-1000005885.png",
                "imgSrcF": "/cdn/shop/files/Frame-1000005885.png",
                "price": 50,
                "title": "Luxor / Misty",
                "color": "Grey"
            },
            {
                "term_id": 64142,
                "gallery": [
                    65661,
                    94912,
                    65564,
                    65562,
                    65556,
                    65554,
                    65555
                ],
                "imgSrc": "/cdn/shop/files/Frame-1000005884-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-1000005884.png",
                "imgSrcF": "/cdn/shop/files/Frame-1000005884.png",
                "price": 50,
                "title": "Luxor / Carrot",
                "color": "Orange"
            },
            {
                "term_id": 64143,
                "gallery": [
                    65660,
                    94912,
                    65564,
                    65562,
                    65556,
                    65554,
                    65557
                ],
                "imgSrc": "/cdn/shop/files/Frame-1000005883-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-1000005883.png",
                "imgSrcF": "/cdn/shop/files/Frame-1000005883.png",
                "price": 50,
                "title": "Luxor / Gold",
                "color": "Gold"
            },
            {
                "term_id": 64133,
                "gallery": [
                    65659,
                    94912,
                    65564,
                    65562,
                    65556,
                    65554,
                    65557
                ],
                "imgSrc": "/cdn/shop/files/Frame-1000005882-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-1000005882.png",
                "imgSrcF": "/cdn/shop/files/Frame-1000005882.png",
                "price": 50,
                "title": "Luxor / Ash",
                "color": "Grey"
            },
            {
                "term_id": 64134,
                "gallery": [
                    65658,
                    94912,
                    65564,
                    65562,
                    65554,
                    65556,
                    65557
                ],
                "imgSrc": "/cdn/shop/files/Frame-1000005881-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-1000005881.png",
                "imgSrcF": "/cdn/shop/files/Frame-1000005881.png",
                "price": 50,
                "title": "Luxor / Silver",
                "color": "Silver"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Foil Printed Velvet Curtains",
            "Light Filtering Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "flash_categories",
            "Foil Print Cutains",
            "Foil Printed Velvet Curtains",
            "Independence Day",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "Sale",
            "Search curtains",
            "Search Foil Print",
            "Search Pinch pleat",
            "Search velvet",
            "Synthetic Curtains",
            "velvet custom curtains",
            "Velvet Pattern Curtains",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "primere",
                "name": "primere"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/BF-TERRA--500x500.png",
        "hoverImg": "/cdn/shop/files/Cream-1-3-500x500.jpg",
        "subheading": "Foil Printed Velvet Patterned Custom Curtain | Designed in Italy",
        "Fabrics": [
            "Luxor"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "White",
            "Black",
            "Green",
            "Grey",
            "Orange",
            "Gold",
            "Grey",
            "Silver"
        ],
        "Light": [
            "Blackout",
            "Light Filtering"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 188,
        "newPrice": 169,
        "extra": "Extra 10%"
    },
    {
        "id": 64166,
        "title": "Brushstrokes Cotton Blend Heavyweight Unique Patterned Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-brushstoke-cotton-blend-patterned-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64067",
        "_fabric_color": [
            {
                "term_id": 64067,
                "gallery": [
                    94710,
                    94714,
                    94708,
                    94712,
                    94707,
                    94709,
                    94721
                ],
                "imgSrc": "/cdn/shop/files/2405-7-657-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/2405-7-657-2.png",
                "imgSrcF": "/cdn/shop/files/2405-7-657-color-3.png",
                "price": 40,
                "title": "Brushstrokes / Black",
                "color": "Black"
            },
            {
                "term_id": 64065,
                "gallery": [
                    94722,
                    94710,
                    94714,
                    94708,
                    94712,
                    94707,
                    94709
                ],
                "imgSrc": "/cdn/shop/files/2405-7-657-display-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/2405-7-657-display-3.png",
                "imgSrcF": "/cdn/shop/files/2405-7-657-color-2.png",
                "price": 40,
                "title": "Brushstrokes / Sand",
                "color": "Beige"
            },
            {
                "term_id": 64066,
                "gallery": [
                    94720,
                    94710,
                    94714,
                    94708,
                    94712,
                    94707,
                    94709
                ],
                "imgSrc": "/cdn/shop/files/2405-7-657-display-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/2405-7-657-display-1.png",
                "imgSrcF": "/cdn/shop/files/2405-7-657-color-1.png",
                "price": 40,
                "title": "Brushstrokes / Ash",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Cotton Curtains",
            "Designer Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "black custom curtains",
            "Cotton Blend Curtains",
            "Cotton Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Designer Curtains",
            "flash_categories",
            "heavyweight custom curtains",
            "Independence Day",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "pinch pleat custom curtains",
            "Search cotton",
            "Search curtains",
            "Search Pinch pleat",
            "vintage custom curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains"
        ],
        "isBestseller": false,
        "isPremiere": true,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "premiere",
                "name": "premiere"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/fat-500x500.png",
        "hoverImg": "/cdn/shop/files/2405-7-657-2-500x500.jpg",
        "subheading": "Cotton Blend Heavyweight Unique Patterned Custom Curtain",
        "Fabrics": [
            "Brushstrokes"
        ],
        "Feature": [],
        "Material": [
            "Cotton"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Black",
            "Beige",
            "Beige"
        ],
        "Light": [
            "Blackout",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 132,
        "newPrice": 132,
        "extra": "Extra 10%"
    },
    {
        "id": 64165,
        "title": "Nirvana Velvet Heavyweight Floral Patterned Custom Curtain",
        "ProductUrl": "/custom-curtains/custom-nirvana-printed-velvet-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64064",
        "_fabric_color": [
            {
                "term_id": 64064,
                "gallery": [
                    65672,
                    97076,
                    97073,
                    65674,
                    65668,
                    65670,
                    65671,
                    97075,
                    97072,
                    65673,
                    65669
                ],
                "imgSrc": "/cdn/shop/files/Nirvana-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Nirvana-2.png",
                "imgSrcF": "/cdn/shop/files/Anderson.png",
                "price": 40,
                "title": "Nirvana / Nirvana",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 331,
                "gallery": null,
                "price": 0,
                "title": "Unlined"
            },
            {
                "term_id": 96969,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Beige"
            },
            {
                "term_id": 96971,
                "gallery": null,
                "price": 0,
                "title": "Privacy — Grey"
            },
            {
                "term_id": 96973,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Beige"
            },
            {
                "term_id": 96975,
                "gallery": null,
                "price": 0,
                "title": "Soft Flat Finish Lining — Grey"
            },
            {
                "term_id": 96977,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Beige"
            },
            {
                "term_id": 96979,
                "gallery": null,
                "price": 0,
                "title": "Thick Satin Finish Lining — Grey"
            },
            {
                "term_id": 96983,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Beige"
            },
            {
                "term_id": 96981,
                "gallery": null,
                "price": 0,
                "title": "100% Blackout — Grey"
            },
            {
                "term_id": 102503,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 102507,
                "gallery": null,
                "price": 0,
                "title": "Same fabric liner"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Designer Curtains",
            "Light Filtering Curtains",
            "Room Darkening Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "beige custom curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Designer Curtains",
            "farmhouse custom curtains",
            "flash_categories",
            "floral custom curtains",
            "heavyweight custom curtains",
            "Independence Day",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Curtains",
            "patterned custom curtains",
            "Search curtains",
            "Search Pinch pleat",
            "Search velvet",
            "Synthetic Curtains",
            "velvet custom curtains",
            "Velvet Pattern Curtains",
            "winter custom curtains",
            "同材质内衬面料分类",
            "外包4家-单层",
            "Curtains",
            "Room Darkening Curtains",
            "Custom Velvet Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/anderson-3-500x500.png",
        "hoverImg": "/cdn/shop/files/Anderson-3-500x500.jpg",
        "subheading": "Velvet Heavyweight Floral Patterned Custom Curtain",
        "Fabrics": [
            "Nirvana"
        ],
        "Feature": [],
        "Material": [
            "Velvet"
        ],
        "Pattern": [
            "Floral"
        ],
        "Color": [
            "White"
        ],
        "Light": [
            "Blackout",
            "Light Filtering",
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 139,
        "newPrice": 132,
        "extra": "Extra 10%"
    },
    {
        "id": 58405,
        "title": "Chloe Linen Look Burlap Textured Sheer Curtain",
        "ProductUrl": "/custom-sheer-curtains/custom-burlap-semi-sheer-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "58500",
        "_fabric_color": [
            {
                "term_id": 58500,
                "gallery": [
                    58417,
                    58418,
                    58419,
                    58425,
                    58424,
                    58423,
                    58422,
                    58421
                ],
                "imgSrc": "/cdn/shop/files/taupe-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/taupe-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Chloe-3.png",
                "price": 30,
                "title": "Chloe / Taupe",
                "color": "Beige"
            },
            {
                "term_id": 58498,
                "gallery": [
                    58428,
                    58429,
                    58435,
                    58433,
                    58432,
                    58431,
                    58437,
                    58434,
                    58436
                ],
                "imgSrc": "/cdn/shop/files/Brick-red-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Brick-red-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/Chloe-2.png",
                "price": 30,
                "title": "Chloe / Brick Red",
                "color": "Red"
            },
            {
                "term_id": 58496,
                "gallery": [
                    58438,
                    58439,
                    58440,
                    58446,
                    58444,
                    58443,
                    58442,
                    58448,
                    58445,
                    58447
                ],
                "imgSrc": "/cdn/shop/files/green-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/green-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Chloe-1.png",
                "price": 30,
                "title": "Chloe / Green",
                "color": "Green"
            },
            {
                "term_id": 58494,
                "gallery": [
                    58453,
                    58459,
                    58458,
                    58457,
                    58455,
                    58456
                ],
                "imgSrc": "/cdn/shop/files/Brown-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Brown-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Chloe-7.png",
                "price": 30,
                "title": "Chloe / Brown",
                "color": "Brown"
            },
            {
                "term_id": 58492,
                "gallery": [
                    58460,
                    58466,
                    58465,
                    58464,
                    58462,
                    58463
                ],
                "imgSrc": "/cdn/shop/files/Cream-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Cream-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Chloe-4.png",
                "price": 30,
                "title": "Chloe / Cream",
                "color": "White"
            },
            {
                "term_id": 58490,
                "gallery": [
                    58467,
                    58468,
                    58473,
                    58474,
                    58472,
                    58470,
                    58471
                ],
                "imgSrc": "/cdn/shop/files/Light-Beige-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Light-Beige-1.jpg",
                "imgSrcF": "/cdn/shop/files/Chloe-5.png",
                "price": 30,
                "title": "Chloe / Light Beige",
                "color": "Beige"
            },
            {
                "term_id": 58488,
                "gallery": [
                    58482,
                    58485,
                    58484,
                    58487,
                    58486
                ],
                "imgSrc": "/cdn/shop/files/Stone-Blue-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Stone-Blue-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Chloe-6.png",
                "price": 30,
                "title": "Chloe / Stone Blue",
                "color": "Blue"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Indoor Sheer Curtains",
            "Light Filtering Curtains",
            "Linen Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Factory products",
            "flash_categories",
            "Indoor Sheer Curtains",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Search curtains",
            "Search linen",
            "Search sheer",
            "Summer Collection",
            "Synthetic Curtains",
            "Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "chloe",
                "name": "Chloe"
            },
            {
                "slug": "indoor-sheer",
                "name": "Indoor sheer"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "sheer",
                "name": "sheer"
            }
        ],
        "short_description": "Sheer are lightweight and flexible. This curtain offers a thin layer to filter light which is the perfect solution for anyone who seeks the best of both privacy and light control. The fabric is highly versatile, allowing you to easily modify the filtration of natural lighting.",
        "imgSrc": "/cdn/shop/files/Brick-red-2-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Brick-red-10-1-500x500.jpg",
        "subheading": "Linen Look Burlap Textured Sheer Curtain",
        "Fabrics": [
            "Chloe"
        ],
        "Feature": [],
        "Material": [
            "Sheer",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Red",
            "Green",
            "Brown",
            "White",
            "Beige",
            "Blue"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 107,
        "newPrice": 128,
        "extra": "Extra 10%"
    },
    {
        "id": 1204,
        "title": "Yarn Linen Look Sheer Custom Curtain",
        "ProductUrl": "/custom-sheer-curtains/custom-solid-color-flax-texture-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "1046",
        "_fabric_color": [
            {
                "term_id": 1046,
                "gallery": [
                    109237,
                    110629,
                    110630,
                    110631,
                    109232,
                    109233,
                    109235,
                    109234
                ],
                "imgSrc": "/cdn/shop/files/Yarn-Beige-6-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yarn-Beige-6-1.jpg",
                "imgSrcF": "/cdn/shop/files/beige-10.jpg",
                "price": 30,
                "title": "Yarn / Beige",
                "color": "Beige"
            },
            {
                "term_id": 1056,
                "gallery": [
                    109314,
                    109313,
                    109315,
                    109310,
                    109309,
                    109312,
                    109311
                ],
                "imgSrc": "/cdn/shop/files/Yarn-white6-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yarn-white6-1.jpg",
                "imgSrcF": "/cdn/shop/files/white-9.jpg",
                "price": 30,
                "title": "Yarn / White",
                "color": "White"
            },
            {
                "term_id": 1055,
                "gallery": [
                    109307,
                    109306,
                    109308,
                    109303,
                    109302,
                    109305,
                    109304
                ],
                "imgSrc": "/cdn/shop/files/Yarn-terracotta6-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yarn-terracotta6-1.jpg",
                "imgSrcF": "/cdn/shop/files/terracotta-7.jpg",
                "price": 30,
                "title": "Yarn / Terracotta",
                "color": "Red"
            },
            {
                "term_id": 1054,
                "gallery": [
                    109301,
                    109300,
                    109299,
                    109296,
                    109295,
                    109298,
                    109297
                ],
                "imgSrc": "/cdn/shop/files/Yarn-Sea-Mist-10-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yarn-Sea-Mist-10-1.jpg",
                "imgSrcF": "/cdn/shop/files/seamist-1.jpg",
                "price": 30,
                "title": "Yarn / Sea Mist",
                "color": "Blue"
            },
            {
                "term_id": 1053,
                "gallery": [
                    109292,
                    109294,
                    109293,
                    109289,
                    109288,
                    109291,
                    109290
                ],
                "imgSrc": "/cdn/shop/files/Yarn-olivegreen6-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yarn-olivegreen6-1.jpg",
                "imgSrcF": "/cdn/shop/files/olivegreen-1.jpg",
                "price": 30,
                "title": "Yarn / Olive Green",
                "color": "Green"
            },
            {
                "term_id": 1052,
                "gallery": [
                    109285,
                    109281,
                    109282,
                    109287,
                    109283,
                    109286,
                    109284
                ],
                "imgSrc": "/cdn/shop/files/Yarn-Natural-7-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yarn-Natural-7-1.jpg",
                "imgSrcF": "/cdn/shop/files/natural-9.jpg",
                "price": 30,
                "title": "Yarn / Natural",
                "color": "White"
            },
            {
                "term_id": 1051,
                "gallery": [
                    109277,
                    109276,
                    109274,
                    109278,
                    109275,
                    109280,
                    109279
                ],
                "imgSrc": "/cdn/shop/files/Yarn-Grey1-11-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yarn-Grey1-11-1.jpg",
                "imgSrcF": "/cdn/shop/files/grey-8.jpg",
                "price": 30,
                "title": "Yarn / Grey",
                "color": "Grey"
            },
            {
                "term_id": 1050,
                "gallery": [
                    109272,
                    109273,
                    109271,
                    109269,
                    109268,
                    109267,
                    109270
                ],
                "imgSrc": "/cdn/shop/files/Yarn-darkblue6-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yarn-darkblue6-1.jpg",
                "imgSrcF": "/cdn/shop/files/darkblue-1.jpg",
                "price": 30,
                "title": "Yarn / Dark Blue",
                "color": "Blue"
            },
            {
                "term_id": 1049,
                "gallery": [
                    109266,
                    109265,
                    109261,
                    109262,
                    109263,
                    109260,
                    109264
                ],
                "imgSrc": "/cdn/shop/files/Yarn-Charcoal-Grey-10-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yarn-Charcoal-Grey-10-1.jpg",
                "imgSrcF": "/cdn/shop/files/charcoalgrey-1.jpg",
                "price": 30,
                "title": "Yarn / Charcoal Grey",
                "color": "Grey"
            },
            {
                "term_id": 1048,
                "gallery": [
                    109258,
                    109257,
                    109259,
                    109254,
                    109253,
                    109256,
                    109255
                ],
                "imgSrc": "/cdn/shop/files/Yarn-camel6-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yarn-camel6-1.jpg",
                "imgSrcF": "/cdn/shop/files/camel-5.jpg",
                "price": 30,
                "title": "Yarn / Camel",
                "color": "Beige"
            },
            {
                "term_id": 1047,
                "gallery": [
                    109245,
                    109244,
                    109243,
                    109240,
                    109239,
                    109242,
                    109241
                ],
                "imgSrc": "/cdn/shop/files/Yarn-Black-11-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yarn-Black-11-1.jpg",
                "imgSrcF": "/cdn/shop/files/black-6.jpg",
                "price": 30,
                "title": "Yarn / Black",
                "color": "Black"
            },
            {
                "term_id": 1045,
                "gallery": [
                    109247,
                    109246,
                    109252,
                    109249,
                    109248,
                    109251,
                    109250
                ],
                "imgSrc": "/cdn/shop/files/Dusty-Blush-10-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Dusty-Blush-10-1.jpg",
                "imgSrcF": "/cdn/shop/files/blush-1.jpg",
                "price": 30,
                "title": "Yarn / Blush",
                "color": "Pink"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Indoor Sheer Curtains",
            "Light Filtering Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Indoor Sheer Curtains",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Search curtains",
            "Search sheer",
            "Spring Time Sale",
            "Summer Collection",
            "Synthetic Curtains",
            "Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "indoor-sheer",
                "name": "Indoor sheer"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "sheer",
                "name": "sheer"
            },
            {
                "slug": "yarn",
                "name": "Yarn"
            }
        ],
        "short_description": "Sheer are lightweight and flexible. This curtain offers a thin layer to filter light which is the perfect solution for anyone who seeks the best of both privacy and light control. The fabric is highly versatile, allowing you to easily modify the filtration of natural lighting.",
        "imgSrc": "/cdn/shop/files/image00003-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Yarn-Beige-4-1-500x500.jpg",
        "subheading": "Linen Look Sheer Custom Curtain",
        "Fabrics": [
            "Yarn"
        ],
        "Feature": [],
        "Material": [
            "Polyester",
            "Sheer",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "White",
            "Red",
            "Blue",
            "Green",
            "White",
            "Grey",
            "Blue",
            "Grey",
            "Beige",
            "Black",
            "Pink"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 107,
        "newPrice": 183,
        "extra": "Extra 10%"
    },
    {
        "id": 1239,
        "title": "Wengen Linen &#038; Cotton Blend Airy Sheer Custom Curtain",
        "ProductUrl": "/linen-cotton-curtains/custom-cotton-blend-mesh-woven-sheer-light-filtering-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "1122",
        "_fabric_color": [
            {
                "term_id": 1122,
                "gallery": [
                    109078,
                    109075,
                    109074,
                    109072,
                    109073,
                    109077,
                    109076,
                    50994
                ],
                "imgSrc": "/cdn/shop/files/white-7-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/white-7-2.jpg",
                "imgSrcF": "/cdn/shop/files/Wengen-1.png",
                "price": 30,
                "title": "Wengen / White",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Cotton Curtains",
            "Light Filtering Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "Black Friday",
            "Cotton Blend Curtains",
            "Cotton Curtains",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Cyber Monday",
            "Easter Sale",
            "Fall Collection",
            "Light Filtering Curtains",
            "Linen &amp; Cotton Curtains",
            "Linen Cotton Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search cotton",
            "Search curtains",
            "Search sheer",
            "Summer Collection",
            "Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "sheer",
                "name": "sheer"
            },
            {
                "slug": "thanksgiving-20",
                "name": "Thanksgiving 20%"
            },
            {
                "slug": "wengen",
                "name": "Wengen"
            }
        ],
        "short_description": "Wengen\r\n\r\nMade of 80% cotton and 20% linen blend fabric, and weighted 233 g/m², these sheers are transparent enough to let more natural light and fresh air come through, bringing a lightweight and finished look to your rooms the fabric is a solid color, making the sheer curtains look more simple and modern. These sheer curtains can block about 30% of sunlight out, protect your privacy and keep the air fresh.",
        "imgSrc": "/cdn/shop/files/white-7-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Traunsee-5-1-500x500.jpg",
        "subheading": "Linen & Cotton Blend Airy Sheer Custom Curtain",
        "Fabrics": [
            "Wengen"
        ],
        "Feature": [],
        "Material": [
            "Cotton Blend",
            "Cotton"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Rod Pocket"
        ],
        "Space": [],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 138,
        "newPrice": 97,
        "extra": "Extra 10%"
    },
    {
        "id": 1169,
        "title": "Tehreem Textured Sheer Custom Curtain",
        "ProductUrl": "/custom-sheer-curtains/custom-sheer-curtains-light-filtering-drapes/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "878",
        "_fabric_color": [
            {
                "term_id": 878,
                "gallery": [
                    108998,
                    108999,
                    109002,
                    109001,
                    109000,
                    109003,
                    109004
                ],
                "imgSrc": "/cdn/shop/files/White-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Z-White-1-300x300-1.jpg",
                "price": 30,
                "title": "Tehreem / White",
                "color": "White"
            },
            {
                "term_id": 880,
                "gallery": [
                    108969,
                    108974,
                    108972,
                    108971,
                    108970,
                    108973,
                    108975
                ],
                "imgSrc": "/cdn/shop/files/Stone-Blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Stone-Blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/Z-Stone-Blue-1-300x300-1.jpg",
                "price": 30,
                "title": "Tehreem / Stone Blue",
                "color": "Blue"
            },
            {
                "term_id": 879,
                "gallery": [
                    108962,
                    108963,
                    108966,
                    108965,
                    108964,
                    108967,
                    108968
                ],
                "imgSrc": "/cdn/shop/files/Silver-grey-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-grey-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Z-Silver-Grey-1-300x300-1.jpg",
                "price": 30,
                "title": "Tehreem / Silver Grey",
                "color": "Grey"
            },
            {
                "term_id": 874,
                "gallery": [
                    108977,
                    108976,
                    108979,
                    108981,
                    108978,
                    108980,
                    108982
                ],
                "imgSrc": "/cdn/shop/files/Taupe-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Taupe-2.jpg",
                "imgSrcF": "/cdn/shop/files/Z-Taupe-1-300x300-1.jpg",
                "price": 30,
                "title": "Tehreem / Taupe",
                "color": "Beige"
            },
            {
                "term_id": 869,
                "gallery": [
                    108946,
                    108947,
                    108951,
                    108950,
                    108949,
                    108948,
                    108945
                ],
                "imgSrc": "/cdn/shop/files/Light-Beige-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Light-Beige-1.jpg",
                "imgSrcF": "/cdn/shop/files/Z-Light-Beige-300x300-1.jpg",
                "price": 30,
                "title": "Tehreem / Light Beige",
                "color": "Beige"
            },
            {
                "term_id": 863,
                "gallery": [
                    108934,
                    108936,
                    108938,
                    108933,
                    108937,
                    108935,
                    108939
                ],
                "imgSrc": "/cdn/shop/files/Dark-Blue2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Dark-Blue2.jpg",
                "imgSrcF": "/cdn/shop/files/Z-Dark-Blue-1-300x300-1.jpg",
                "price": 30,
                "title": "Tehreem / Dark Blue",
                "color": "Blue"
            },
            {
                "term_id": 860,
                "gallery": [
                    108922,
                    108923,
                    108926,
                    108925,
                    108924,
                    108927,
                    108921
                ],
                "imgSrc": "/cdn/shop/files/Beige-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Beige-1.jpg",
                "imgSrcF": "/cdn/shop/files/Z-Beige-300x300-1.jpg",
                "price": 30,
                "title": "Tehreem / Beige",
                "color": "Beige"
            },
            {
                "term_id": 876,
                "gallery": [
                    108955,
                    108956,
                    108954,
                    108953,
                    108952
                ],
                "imgSrc": "/cdn/shop/files/lightgrey3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/lightgrey3.jpg",
                "imgSrcF": "/cdn/shop/files/Light-Grey-3-300x300-1.jpg",
                "price": 30,
                "title": "Voile / Light Gray",
                "color": "White"
            },
            {
                "term_id": 875,
                "gallery": [
                    108986,
                    108987,
                    108985,
                    108984,
                    108983
                ],
                "imgSrc": "/cdn/shop/files/Voile-Turquoise3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Voile-Turquoise3.jpg",
                "imgSrcF": "/cdn/shop/files/Voile-Turquoise-300x300-1.jpg",
                "price": 30,
                "title": "Voile / Turquoise",
                "color": "Blue"
            },
            {
                "term_id": 861,
                "gallery": [
                    108960,
                    108961,
                    108959,
                    108958,
                    108957
                ],
                "imgSrc": "/cdn/shop/files/Voile-Pure-White-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Voile-Pure-White-4.jpg",
                "imgSrcF": "/cdn/shop/files/Voile-Pure-White-1-300x300-1.jpg",
                "price": 30,
                "title": "Voile / Pure White",
                "color": "White"
            },
            {
                "term_id": 856,
                "gallery": [
                    108940,
                    108942,
                    108943,
                    108941,
                    108944
                ],
                "imgSrc": "/cdn/shop/files/Darkgrey-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Darkgrey-1.jpg",
                "imgSrcF": "/cdn/shop/files/Voile-Dark-Grey-300x300-1.jpg",
                "price": 30,
                "title": "Voile / Dark Grey",
                "color": "Grey"
            },
            {
                "term_id": 851,
                "gallery": [
                    108930,
                    108929,
                    108928,
                    108931,
                    108932
                ],
                "imgSrc": "/cdn/shop/files/black-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/black-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/Voile-Black-300x300-1.jpg",
                "price": 30,
                "title": "Voile / Black",
                "color": "Black"
            },
            {
                "term_id": 850,
                "gallery": [
                    108990,
                    108992,
                    108991,
                    108989,
                    108988
                ],
                "imgSrc": "/cdn/shop/files/beige-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/beige-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/Voile-Beige-1-300x300-1.jpg",
                "price": 30,
                "title": "Voile / Beige",
                "color": "Beige"
            },
            {
                "term_id": 1043,
                "gallery": [
                    108995,
                    108994,
                    108997,
                    108996,
                    108993
                ],
                "imgSrc": "/cdn/shop/files/Voile-ivory-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Voile-ivory-2.jpg",
                "imgSrcF": "/cdn/shop/files/Voile-ivory-1-300x300-1.jpg",
                "price": 30,
                "title": "Voile / Ivory",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 97020,
                "gallery": null,
                "price": 0,
                "title": "Double French Pinch Pleat"
            },
            {
                "term_id": 97022,
                "gallery": null,
                "price": 0,
                "title": "Triple French Pinch Pleat"
            },
            {
                "term_id": 63904,
                "gallery": null,
                "price": 0,
                "title": "Inverted Box Pleat"
            },
            {
                "term_id": 63900,
                "gallery": null,
                "price": 0,
                "title": "Goblet"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 95075,
                "gallery": null,
                "price": 0,
                "title": "4-IN-1"
            },
            {
                "term_id": 63760,
                "gallery": null,
                "price": 0,
                "title": "None"
            },
            {
                "term_id": 63753,
                "gallery": null,
                "price": 50,
                "title": "Memory Trained"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Indoor Sheer Curtains",
            "Light Filtering Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Black Friday",
            "Curtain Measurement",
            "Curtains &amp; Shades",
            "Curtains Memory Training",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Independence Day",
            "Indoor Sheer Curtains",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Search curtains",
            "Search sheer",
            "Spring Time Sale",
            "Summer Collection",
            "Synthetic Curtains",
            "Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "custom-sheer-curtains",
                "name": "custom sheer curtains"
            },
            {
                "slug": "indoor-curtain",
                "name": "Indoor curtain"
            },
            {
                "slug": "indoor-sheer",
                "name": "Indoor sheer"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "sheer",
                "name": "sheer"
            },
            {
                "slug": "tehreem",
                "name": "Tehreem"
            },
            {
                "slug": "voile",
                "name": "Voile"
            }
        ],
        "short_description": "<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \" style=\"border-radius: 0px;\"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\">\r\n<p style=\"margin-bottom: 20px;\">Sheer curtains are lightweight and flexible. They offer a thin layer to filter light which is the perfect solution for anyone who seeks the best of both privacy and light control. The fabric is highly versatile, allowing you to easily modify the filtration of natural lighting.</p>\r\n\r\n</article></div>\r\n</section></div>\r\nVoile, Tehreem",
        "imgSrc": "/cdn/shop/files/Taupe-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Taupe-5-500x500.jpg",
        "subheading": "Textured Sheer Custom Curtain",
        "Fabrics": [
            "Tehreem"
        ],
        "Feature": [],
        "Material": [
            "Polyester",
            "Sheer",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White",
            "Blue",
            "Grey",
            "Beige",
            "Beige",
            "Blue",
            "Beige",
            "White",
            "Blue",
            "White",
            "Grey",
            "Black",
            "Beige",
            "White"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 105,
        "newPrice": 101,
        "extra": "Extra 10%"
    },
    {
        "id": 45445,
        "title": "Gradient Custom Outdoor Sheer Curtain",
        "ProductUrl": "/custom-outdoor-curtains/custom-waterproof-omber-outdoor-sheer-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "45477",
        "_fabric_color": [
            {
                "term_id": 45477,
                "gallery": [
                    45460,
                    45461,
                    45465,
                    45466,
                    45464
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-10.jpg",
                "price": 25,
                "title": "Scottish / Omber Grey",
                "color": "Grey"
            },
            {
                "term_id": 45475,
                "gallery": [
                    45453,
                    45454,
                    45458,
                    45459,
                    45456
                ],
                "imgSrc": "/cdn/shop/files/Green-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Green-1.jpg",
                "imgSrcF": "/cdn/shop/files/Green-8.jpg",
                "price": 25,
                "title": "Scottish / Omber Green",
                "color": "Green"
            },
            {
                "term_id": 45473,
                "gallery": [
                    45446,
                    45447,
                    45451,
                    45452,
                    45450
                ],
                "imgSrc": "/cdn/shop/files/Blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/Blue.jpg",
                "price": 25,
                "title": "Scottish / Omber Blue",
                "color": "Blue"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 619,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 658,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 660,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Custom Outdoor Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Factory products",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outdoor Sheer Curtains",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search sheer",
            "Summer Outdoor Decor",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Curtains",
            "Custom Outdoor Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "aquashield",
                "name": "aquashield"
            },
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            },
            {
                "slug": "sheer",
                "name": "sheer"
            }
        ],
        "short_description": "<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \" style=\"border-radius: 0px;\"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\"><span class=\"a-list-item\">GOOD PERFORMANCE: Outdoor sheer cut down the insect invasion to a certain extent. They blow in the wind and are easily managed with the BONUS TIE BACKS.</span></article></div>\r\n<p class=\"sakd\"><span class=\"a-list-item\">MATERIAL&amp;PRIVACY: Soft flowing voile panel lets a bit of sunlight in, while still providing some privacy from the outside.</span></p>\r\n\r\n</section></div>\r\n<p class=\"sakd\"><span class=\"a-list-item\">GOOD TO GO: Thread trimmed and wrinkle-free, the tab (1.9-inch inner diameter) fits easily with standard curtain rods. All sets for you to put them up right away.</span></p>\r\nOUTDOOR CURTAINS\r\noutdoor\r\npatio curtains\r\npatio\r\nOutdoor curtain\r\nPatio curtain\r\nFarmhouse\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
        "imgSrc": "/cdn/shop/files/Blue-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Blue-5-500x500.jpg",
        "subheading": "Gradient Custom Outdoor Sheer Curtain",
        "Fabrics": [
            "Gradient"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Sheer",
            "Synthetic"
        ],
        "Pattern": [
            "Gradient"
        ],
        "Color": [
            "Grey",
            "Green",
            "Blue"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 101,
        "newPrice": 120,
        "extra": "Extra 10%"
    },
    {
        "id": 45525,
        "title": "Trilon Custom Outdoor Sheer Curtain",
        "ProductUrl": "/custom-outdoor-curtains/custom-voile-outdoor-sheer-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "45536",
        "_fabric_color": [
            {
                "term_id": 45536,
                "gallery": [
                    48549,
                    48551,
                    48552,
                    48553,
                    48554,
                    48556,
                    48557
                ],
                "imgSrc": "/cdn/shop/files/6-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/6-1.jpg",
                "imgSrcF": "/cdn/shop/files/Tehreem-2.png",
                "price": 25,
                "title": "Trilon / White",
                "color": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 610,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Bottom"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 619,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 617,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 616,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Custom Outdoor Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "All Bestsellers",
            "All Curtains",
            "Black Friday",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Cyber Monday",
            "Factory products",
            "flash_categories",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Oeko",
            "Outdoor Sheer Curtains",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search sheer",
            "Search waterproof curtain",
            "Summer Collection",
            "Summer Outdoor Decor",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Waterproof Curtains",
            "Curtains",
            "Custom Outdoor Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "aquashield",
                "name": "aquashield"
            },
            {
                "slug": "oeko",
                "name": "OEKO"
            },
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            },
            {
                "slug": "sheer",
                "name": "sheer"
            },
            {
                "slug": "thanksgiving-20",
                "name": "Thanksgiving 20%"
            }
        ],
        "short_description": "<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \" style=\"border-radius: 0px;\"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\"><span class=\"a-list-item\">GOOD PERFORMANCE: Outdoor sheer cut down the insect invasion to a certain extent. They blow in the wind and are easily managed with the BONUS TIE BACKS.</span></article></div>\r\n<p class=\"sakd\"><span class=\"a-list-item\">MATERIAL&amp;PRIVACY: Soft flowing voile panel lets a bit of sunlight in, while still providing some privacy from the outside.</span></p>\r\n\r\n</section></div>\r\n<p class=\"sakd\"><span class=\"a-list-item\">GOOD TO GO: Thread trimmed and wrinkle-free, the tab (1.9-inch inner diameter) fits easily with standard curtain rods. All sets for you to put them up right away.</span></p>\r\nOUTDOOR CURTAINS\r\noutdoor\r\npatio curtains\r\npatio\r\nOutdoor curtain\r\nPatio curtain\r\nFarmhouse\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
        "imgSrc": "/cdn/shop/files/6-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/White-2-500x500.jpg",
        "subheading": "Custom Outdoor Sheer Curtain",
        "Fabrics": [
            "Trilon"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Sheer",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 103,
        "newPrice": 120,
        "extra": "Extra 10%"
    },
    {
        "id": 1194,
        "title": "Scottish Custom Outdoor Sheer Curtain",
        "ProductUrl": "/custom-sheer-curtains/custom-waterproof-outdoor-sheer-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "985",
        "_fabric_color": [
            {
                "term_id": 985,
                "gallery": [
                    48540,
                    48541,
                    48542,
                    48543,
                    48545,
                    48547,
                    48548
                ],
                "imgSrc": "/cdn/shop/files/5-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/5-1.jpg",
                "imgSrcF": "/cdn/shop/files/White-4-2.jpg",
                "price": 50,
                "title": "Scottish / White",
                "color": "White"
            },
            {
                "term_id": 988,
                "gallery": [
                    43667,
                    48541,
                    48542,
                    48543,
                    48545,
                    48547,
                    48548
                ],
                "imgSrc": "/cdn/shop/files/Beige-20-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Beige-20.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-4-4.jpg",
                "price": 50,
                "title": "Scottish / Beige",
                "color": "Beige"
            },
            {
                "term_id": 989,
                "gallery": [
                    43673,
                    48541,
                    48542,
                    48543,
                    48545,
                    48547,
                    48548
                ],
                "imgSrc": "/cdn/shop/files/Cream-Beige-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Cream-Beige.jpg",
                "imgSrcF": "/cdn/shop/files/Cream-Beige-3.jpg",
                "price": 50,
                "title": "Scottish / Cream Beige",
                "color": "Beige"
            },
            {
                "term_id": 986,
                "gallery": [
                    43685,
                    48541,
                    48542,
                    48543,
                    48545,
                    48547,
                    48548
                ],
                "imgSrc": "/cdn/shop/files/Light-Grey-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Light-Grey-1.jpg",
                "imgSrcF": "/cdn/shop/files/Light-Grey-3.jpg",
                "price": 50,
                "title": "Scottish / Light Grey",
                "color": "Grey"
            },
            {
                "term_id": 987,
                "gallery": [
                    43679,
                    48541,
                    48542,
                    48543,
                    48545,
                    48547,
                    48548
                ],
                "imgSrc": "/cdn/shop/files/Dark-Gray-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Dark-Gray.jpg",
                "imgSrcF": "/cdn/shop/files/Dark-Gray-3.jpg",
                "price": 50,
                "title": "Scottish / Dark Grey",
                "color": "Grey"
            },
            {
                "term_id": 32181,
                "gallery": [
                    49013,
                    48541,
                    48542,
                    48543,
                    48545,
                    48547,
                    48548
                ],
                "imgSrc": "/cdn/shop/files/2-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/2-5.jpg",
                "imgSrcF": "/cdn/shop/files/蓝.jpg",
                "price": 50,
                "title": "Scottish / Turquoise",
                "color": "Blue"
            },
            {
                "term_id": 32179,
                "gallery": [
                    49014,
                    48541,
                    48542,
                    48543,
                    48545,
                    48547,
                    48548
                ],
                "imgSrc": "/cdn/shop/files/3-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/3-5.jpg",
                "imgSrcF": "/cdn/shop/files/深蓝.jpg",
                "price": 50,
                "title": "Scottish / Dark Blue",
                "color": "Blue"
            },
            {
                "term_id": 32173,
                "gallery": [
                    49012,
                    48541,
                    48542,
                    48543,
                    48545,
                    48547,
                    48548
                ],
                "imgSrc": "/cdn/shop/files/1-6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/1-6.jpg",
                "imgSrcF": "/cdn/shop/files/124.jpg",
                "price": 50,
                "title": "Scottish / Coral",
                "color": "Pink"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 610,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Bottom"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 609,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 658,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 660,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Custom Outdoor Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "All Bestsellers",
            "All Curtain Sale",
            "All Curtains",
            "Black Friday",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Cyber Monday",
            "Factory products",
            "flash_categories",
            "Independence Day",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outdoor Sheer Curtains",
            "Sale",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search sheer",
            "Search waterproof curtain",
            "Summer Collection",
            "Summer Outdoor Decor",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Waterproof Curtains",
            "Curtains",
            "Custom Outdoor Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "aquashield",
                "name": "aquashield"
            },
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            },
            {
                "slug": "pinch-pleat",
                "name": "Pinch pleat"
            },
            {
                "slug": "sheer",
                "name": "sheer"
            }
        ],
        "short_description": "<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \" style=\"border-radius: 0px;\"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\"><span class=\"a-list-item\">GOOD PERFORMANCE: Outdoor sheer cut down the insect invasion to a certain extent. They blow in the wind and are easily managed with the BONUS TIE BACKS.</span></article></div>\r\n<p class=\"sakd\"><span class=\"a-list-item\">MATERIAL&amp;PRIVACY: Soft flowing voile panel lets a bit of sunlight in, while still providing some privacy from the outside.</span></p>\r\n\r\n</section></div>\r\n<p class=\"sakd\"><span class=\"a-list-item\">GOOD TO GO: Thread trimmed and wrinkle-free, the tab (1.9-inch inner diameter) fits easily with standard curtain rods. All sets for you to put them up right away.</span></p>\r\nOUTDOOR CURTAINS\r\noutdoor\r\npatio curtains\r\npatio\r\nOutdoor curtain\r\nPatio curtain\r\nFarmhouse\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
        "imgSrc": "/cdn/shop/files/5-3-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/5-9-500x500.jpg",
        "subheading": "Custom Outdoor Sheer Curtain",
        "Fabrics": [
            "Scottish"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Sheer",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White",
            "Beige",
            "Beige",
            "Grey",
            "Grey",
            "Blue",
            "Blue",
            "Pink"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 144,
        "newPrice": 101,
        "extra": "Extra 10%"
    },
    {
        "id": 40821,
        "title": "Noah Linen Look Lightweight Waterproof Custom Outdoor Curtain",
        "ProductUrl": "/custom-outdoor-curtains/noah-linen-outdoor-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "40856",
        "_fabric_color": [
            {
                "term_id": 40856,
                "gallery": [
                    97900,
                    48523,
                    48524,
                    48525,
                    48526,
                    48527,
                    48529,
                    48530,
                    48522
                ],
                "imgSrc": "/cdn/shop/files/Frame-2263-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Frame-2263.png",
                "imgSrcF": "/cdn/shop/files/Natural-120x120-1.jpg",
                "price": 43,
                "title": "Noah / Natural",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 610,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Bottom"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 609,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 47876,
                "gallery": null,
                "price": 0,
                "title": "No Sandbags"
            },
            {
                "term_id": 634,
                "gallery": null,
                "price": 0,
                "title": "Sandbags Included"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Linen Curtains",
            "Custom Outdoor Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "All Outdoor Curtains Sale",
            "Black Friday",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Cyber Monday",
            "Easter Sale",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Linen &amp; Cotton Curtains",
            "Linen Blend Curtains",
            "Linen Cotton Curtains",
            "Linen Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outdoor Sheer Curtains",
            "Sale",
            "Search curtains",
            "Search linen",
            "Search Linen blend curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Solid Outdoor Curtains",
            "Summer",
            "Summer Collection",
            "Summer Outdoor Decor",
            "Curtains",
            "Custom Outdoor Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "custom-outdoor-curtains",
                "name": "Custom Outdoor Curtains"
            },
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "waterproof-curtains",
                "name": "Waterproof Curtains"
            }
        ],
        "short_description": "<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\" data-clipboard-cangjie=\"[\" data-type=\"\">The Outdoor curtains adopt waterproof technology on the fabric, unlike the other blackout drapes. The invisible layer on both sides is water-resistant and will preserve even in heavy rain or the fiercest snowstorm. With the double grommet, the curtain will stay still against the wind.</article></div>\r\n</section></div>",
        "imgSrc": "/cdn/shop/files/Frame-2263-500x500.png",
        "hoverImg": "/cdn/shop/files/800x800-15-500x500.jpg",
        "subheading": "Linen Look Lightweight Waterproof Custom Outdoor Curtain",
        "Fabrics": [
            "Noah"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 137,
        "newPrice": 110,
        "extra": "Extra 10%"
    },
    {
        "id": 95259,
        "title": "Boston High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain",
        "ProductUrl": "/custom-outdoor-curtains/custom-boston-performance-outdoor-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64095",
        "_fabric_color": [
            {
                "term_id": 64095,
                "gallery": [
                    97651,
                    97652,
                    97653,
                    97655,
                    97654
                ],
                "imgSrc": "/cdn/shop/files/Black-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-1.jpg",
                "imgSrcF": "/cdn/shop/files/Black-3-1.png",
                "price": 50,
                "title": "Boston / Dark Grey",
                "color": "Grey"
            },
            {
                "term_id": 64096,
                "gallery": [
                    97656,
                    97657,
                    97658,
                    97660,
                    97659
                ],
                "imgSrc": "/cdn/shop/files/Brown-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Brown-1.jpg",
                "imgSrcF": "/cdn/shop/files/Brown-3.png",
                "price": 50,
                "title": "Boston / Grey",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 610,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Bottom"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 609,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Custom Outdoor Curtains"
        ],
        "AllCategory": [
            "All Curtains",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Extra 10%",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Outdoor Curtains",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search waterproof curtain",
            "Solid Outdoor Curtains",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Waterproof Curtains",
            "Curtains",
            "Custom Outdoor Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            }
        ],
        "short_description": "The Outdoor curtains adopt waterproof technology on the fabric, unlike the other blackout drapes. The invisible layer on both sides is water-resistant and will preserve even in heavy rain or the fiercest snowstorm. With the double grommet, the curtain will stay still against the wind.\r\n\r\nOUTDOOR CURTAINS\r\noutdoor\r\npatio curtains\r\npatio\r\nOutdoor curtain\r\nPatio curtain\r\nFarmhouse\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
        "imgSrc": "/cdn/shop/files/Brown-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Brown-3-500x500.png",
        "subheading": "High-Performing Fade-Resistant Waterproof Custom Outdoor Curtain",
        "Fabrics": [
            "Boston"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Grey",
            "Grey"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "4 In 1",
            "Back Tab",
            "Goblet Pleat",
            "Grommet",
            "Inverted Pleat",
            "Pinch Pleated",
            "Rod Pocket"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 171,
        "newPrice": 278,
        "extra": "Extra 10%"
    },
    {
        "id": 95257,
        "title": "Bohemia Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain",
        "ProductUrl": "/custom-outdoor-curtains/custom-bohemia-outdoor-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64047",
        "_fabric_color": [
            {
                "term_id": 64047,
                "gallery": [
                    96378,
                    96379,
                    96380,
                    96383,
                    96382,
                    96381
                ],
                "imgSrc": "/cdn/shop/files/Green-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Green-1-1.png",
                "imgSrcF": "/cdn/shop/files/Green-6-3.png",
                "price": 50,
                "title": "Bohemia / Green",
                "color": "Green"
            },
            {
                "term_id": 64048,
                "gallery": [
                    96384,
                    96385,
                    96386,
                    96389,
                    96388,
                    96387
                ],
                "imgSrc": "/cdn/shop/files/Yellow-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Yellow-1.png",
                "imgSrcF": "/cdn/shop/files/Yellow-6-1.png",
                "price": 50,
                "title": "Bohemia / Yellow",
                "color": "Yellow"
            },
            {
                "term_id": 64049,
                "gallery": [
                    96372,
                    96373,
                    96374,
                    96377,
                    96376,
                    96375
                ],
                "imgSrc": "/cdn/shop/files/Grey-1-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Grey-1-3.png",
                "imgSrcF": "/cdn/shop/files/Grey-6-5.png",
                "price": 50,
                "title": "Bohemia / Grey",
                "color": "Grey"
            },
            {
                "term_id": 64050,
                "gallery": [
                    96366,
                    96367,
                    96368,
                    96371,
                    96370,
                    96369
                ],
                "imgSrc": "/cdn/shop/files/Wheat-1-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Wheat-1-1.png",
                "imgSrcF": "/cdn/shop/files/Wheat-6-1.png",
                "price": 50,
                "title": "Bohemia / Wheat",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 610,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Bottom"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 609,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Custom Outdoor Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "All Outdoor Curtains Sale",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Outdoor Curtains",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search waterproof curtain",
            "Solid Outdoor Curtains",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Waterproof Curtains",
            "Curtains",
            "Custom Outdoor Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            }
        ],
        "short_description": "The Outdoor curtains adopt waterproof technology on the fabric, unlike the other blackout drapes. The invisible layer on both sides is water-resistant and will preserve even in heavy rain or the fiercest snowstorm. With the double grommet, the curtain will stay still against the wind.\r\n\r\nOUTDOOR CURTAINS\r\noutdoor\r\npatio curtains\r\npatio\r\nOutdoor curtain\r\nPatio curtain\r\nFarmhouse\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
        "imgSrc": "/cdn/shop/files/Grey-1-3-500x500.png",
        "hoverImg": "/cdn/shop/files/Grey-4-2-500x500.png",
        "subheading": "Crisscross Woven Patterned Textured Waterproof Custom Outdoor Curtain",
        "Fabrics": [
            "Bohemia"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Green",
            "Yellow",
            "Grey",
            "Beige"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 160,
        "newPrice": 144,
        "extra": "Extra 10%"
    },
    {
        "id": 95255,
        "title": "Miami Fishtail Patterned Waterproof Custom Outdoor Curtain",
        "ProductUrl": "/custom-outdoor-curtains/custom-miami-patterned-outdoor-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64036",
        "_fabric_color": [
            {
                "term_id": 64036,
                "gallery": [
                    96301,
                    96300,
                    96302,
                    96305,
                    96304,
                    96303
                ],
                "imgSrc": "/cdn/shop/files/Teal-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Teal-2.png",
                "imgSrcF": "/cdn/shop/files/Teal-6-3.png",
                "price": 50,
                "title": "Miami / Teal",
                "color": "Green"
            },
            {
                "term_id": 64037,
                "gallery": [
                    96283,
                    96282,
                    96284,
                    96287,
                    96286,
                    96285
                ],
                "imgSrc": "/cdn/shop/files/Dark-Grey-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Dark-Grey-2.png",
                "imgSrcF": "/cdn/shop/files/Dark-Grey-6-1.png",
                "price": 50,
                "title": "Miami / Dark Grey",
                "color": "Black"
            },
            {
                "term_id": 64038,
                "gallery": [
                    96289,
                    96288,
                    96290,
                    96293,
                    96292,
                    96291
                ],
                "imgSrc": "/cdn/shop/files/Greyish-Blue-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Greyish-Blue-2.png",
                "imgSrcF": "/cdn/shop/files/Greyish-Blue-6-1.png",
                "price": 50,
                "title": "Miami / Greyish Blue",
                "color": "Grey"
            },
            {
                "term_id": 64032,
                "gallery": [
                    96295,
                    96294,
                    96296,
                    96299,
                    96298,
                    96297
                ],
                "imgSrc": "/cdn/shop/files/Sand-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Sand-2.png",
                "imgSrcF": "/cdn/shop/files/Sand-6-1.png",
                "price": 50,
                "title": "Miami / Sand",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 610,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Bottom"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 609,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Custom Outdoor Curtains"
        ],
        "AllCategory": [
            "30% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "All Outdoor Curtains Sale",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Outdoor Curtains",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search waterproof curtain",
            "Solid Outdoor Curtains",
            "Summer",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Waterproof Curtains",
            "Curtains",
            "Custom Outdoor Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            }
        ],
        "short_description": "The Outdoor curtains adopt waterproof technology on the fabric, unlike the other blackout drapes. The invisible layer on both sides is water-resistant and will preserve even in heavy rain or the fiercest snowstorm. With the double grommet, the curtain will stay still against the wind.\r\n\r\nOUTDOOR CURTAINS\r\noutdoor\r\npatio curtains\r\npatio\r\nOutdoor curtain\r\nPatio curtain\r\nFarmhouse\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
        "imgSrc": "/cdn/shop/files/Teal-2-500x500.png",
        "hoverImg": "/cdn/shop/files/Teal-4-500x500.png",
        "subheading": "Fishtail Patterned Waterproof Custom Outdoor Curtain",
        "Fabrics": [
            "Miami"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Green",
            "Black",
            "Grey",
            "Beige"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 172,
        "newPrice": 120,
        "extra": "Extra 10%"
    },
    {
        "id": 95258,
        "title": "Munich Woven Patterned Textured Waterproof Custom Outdoor Curtain",
        "ProductUrl": "/custom-outdoor-curtains/custom-munich-outdoor-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64039",
        "_fabric_color": [
            {
                "term_id": 64039,
                "gallery": [
                    96307,
                    96306,
                    96308,
                    96312,
                    96311,
                    96310,
                    96309
                ],
                "imgSrc": "/cdn/shop/files/Black-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Black-2.png",
                "imgSrcF": "/cdn/shop/files/Black-6-1.png",
                "price": 40,
                "title": "Munich / Black",
                "color": "Black"
            },
            {
                "term_id": 64040,
                "gallery": [
                    96321,
                    96320,
                    96322,
                    96326,
                    96325,
                    96324,
                    96323
                ],
                "imgSrc": "/cdn/shop/files/Teal-2-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Teal-2-1.png",
                "imgSrcF": "/cdn/shop/files/Teal-6-2.png",
                "price": 40,
                "title": "Munich / Teal",
                "color": "Green"
            },
            {
                "term_id": 64041,
                "gallery": [
                    96314,
                    96313,
                    96315,
                    96319,
                    96318,
                    96317,
                    96316
                ],
                "imgSrc": "/cdn/shop/files/Grey-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Grey-2.png",
                "imgSrcF": "/cdn/shop/files/Grey-6-1.png",
                "price": 40,
                "title": "Munich / Grey",
                "color": "Grey"
            },
            {
                "term_id": 64042,
                "gallery": [
                    96328,
                    96327,
                    96329,
                    96333,
                    96332,
                    96331,
                    96330
                ],
                "imgSrc": "/cdn/shop/files/Wheat-8-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Wheat-8.png",
                "imgSrcF": "/cdn/shop/files/Wheat-12-1.png",
                "price": 40,
                "title": "Munich / Wheat",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 610,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Bottom"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 609,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Custom Outdoor Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "All Outdoor Curtains Sale",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Extra 10%",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Outdoor Curtains",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search waterproof curtain",
            "Solid Outdoor Curtains",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Waterproof Curtains",
            "Curtains",
            "Custom Outdoor Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            }
        ],
        "short_description": "The Outdoor curtains adopt waterproof technology on the fabric, unlike the other blackout drapes. The invisible layer on both sides is water-resistant and will preserve even in heavy rain or the fiercest snowstorm. With the double grommet, the curtain will stay still against the wind.\r\n\r\nOUTDOOR CURTAINS\r\noutdoor\r\npatio curtains\r\npatio\r\nOutdoor curtain\r\nPatio curtain\r\nFarmhouse\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
        "imgSrc": "/cdn/shop/files/Grey-1-1-500x500.png",
        "hoverImg": "/cdn/shop/files/Grey-4-500x500.png",
        "subheading": "Woven Patterned Textured Waterproof Custom Outdoor Curtains",
        "Fabrics": [
            "Munich"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Black",
            "Green",
            "Grey",
            "Beige"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 136,
        "newPrice": 109,
        "extra": "Extra 10%"
    },
    {
        "id": 95256,
        "title": "New York Grid Patterned Textured Waterproof Custom Outdoor Curtain",
        "ProductUrl": "/custom-outdoor-curtains/custom-new-york-francisco-patterned-outdoor-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "64043",
        "_fabric_color": [
            {
                "term_id": 64043,
                "gallery": [
                    97044,
                    97045,
                    97060,
                    97048,
                    97047,
                    97046
                ],
                "imgSrc": "/cdn/shop/files/New-York-Black-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/New-York-Black-1.png",
                "imgSrcF": "/cdn/shop/files/OFH50021-150-5.jpg",
                "price": 50,
                "title": "New York / Black",
                "color": "Black"
            },
            {
                "term_id": 64044,
                "gallery": [
                    97050,
                    97051,
                    97059,
                    97054,
                    97053,
                    97052
                ],
                "imgSrc": "/cdn/shop/files/New-York-White-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/New-York-White-1.png",
                "imgSrcF": "/cdn/shop/files/OFH50021-150-4.jpg",
                "price": 50,
                "title": "New York / White",
                "color": "White"
            },
            {
                "term_id": 64033,
                "gallery": [
                    97042,
                    97038,
                    97058,
                    97041,
                    97040,
                    97039
                ],
                "imgSrc": "/cdn/shop/files/New-York-Green-5-500x500.png",
                "imgSrc_n": "/cdn/shop/files/New-York-Green-5.png",
                "imgSrcF": "/cdn/shop/files/OFH50021-150-3.jpg",
                "price": 50,
                "title": "New York / Green",
                "color": "Green"
            },
            {
                "term_id": 64034,
                "gallery": [
                    97032,
                    97033,
                    97057,
                    97034,
                    97037,
                    97036
                ],
                "imgSrc": "/cdn/shop/files/New-York-Dark-Grey-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/New-York-Dark-Grey-1.png",
                "imgSrcF": "/cdn/shop/files/OFH50021-150-2.jpg",
                "price": 50,
                "title": "New York / Dark Grey",
                "color": "Grey"
            },
            {
                "term_id": 64035,
                "gallery": [
                    97026,
                    97027,
                    97056,
                    97030,
                    97029,
                    97028
                ],
                "imgSrc": "/cdn/shop/files/New-York-Grey-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/New-York-Grey-1.png",
                "imgSrcF": "/cdn/shop/files/OFH50021-150-1.jpg",
                "price": 50,
                "title": "New York / Grey",
                "color": "Grey"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 342,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver Black"
            },
            {
                "term_id": 341,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Anti-brass"
            },
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 610,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Bottom"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 609,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Custom Outdoor Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "All Curtain Sale",
            "All Curtains",
            "All Outdoor Curtains Sale",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Outdoor Curtains",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Outdoor Curtains",
            "Sale",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search waterproof curtain",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Waterproof Curtains",
            "Curtains",
            "Custom Outdoor Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "custom-outdoor-curtains",
                "name": "Custom Outdoor Curtains"
            },
            {
                "slug": "fade-resistant-curtain",
                "name": "Fade Resistant Curtain"
            },
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            }
        ],
        "short_description": "The Outdoor curtains adopt waterproof technology on the fabric, unlike the other blackout drapes. The invisible layer on both sides is water-resistant and will preserve even in heavy rain or the fiercest snowstorm. With the double grommet, the curtain will stay still against the wind.",
        "imgSrc": "/cdn/shop/files/New-York-Green-5-500x500.png",
        "hoverImg": "/cdn/shop/files/New-York-Green-2-500x500.png",
        "subheading": "Grid Patterned Textured Waterproof Custom Outdoor Curtains",
        "Fabrics": [
            "New York"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Black",
            "White",
            "Green",
            "Grey",
            "Grey"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 191,
        "newPrice": 172,
        "extra": "Extra 10%"
    },
    {
        "id": 58201,
        "title": "Oxford Thermal Insulated &#038; Soundproof Custom Magnetic Door Curtain",
        "ProductUrl": "/custom-blackout-curtain/custom-soundproof-thermal-insulated-magnetic-door-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "31940",
        "_fabric_color": [
            {
                "term_id": 31940,
                "gallery": [
                    59091,
                    57251,
                    57250,
                    58246
                ],
                "imgSrc": "/cdn/shop/files/dor-curtains-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/dor-curtains-3.jpg",
                "imgSrcF": "/cdn/shop/files/Grey.png",
                "price": 50,
                "title": "Oxford / Grey",
                "color": "Grey"
            },
            {
                "term_id": 34874,
                "gallery": [
                    59089,
                    57247,
                    57246,
                    44832,
                    44831,
                    41326,
                    41325,
                    58755,
                    58242
                ],
                "imgSrc": "/cdn/shop/files/dor-curtains-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/dor-curtains-1.jpg",
                "imgSrcF": "/cdn/shop/files/Black-1.png",
                "price": 50,
                "title": "Oxford / Black",
                "color": "Black"
            },
            {
                "term_id": 34567,
                "gallery": [
                    59093,
                    57243,
                    57242,
                    44832,
                    44831,
                    41310,
                    41309,
                    58753,
                    58247
                ],
                "imgSrc": "/cdn/shop/files/dor-curtains-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/dor-curtains-5.jpg",
                "imgSrcF": "/cdn/shop/files/Navy-blue.png",
                "price": 50,
                "title": "Oxford / Dark Blue",
                "color": "Blue"
            },
            {
                "term_id": 34563,
                "gallery": [
                    59092,
                    57255,
                    57254,
                    44832,
                    44831,
                    41318,
                    41317,
                    58758,
                    58243
                ],
                "imgSrc": "/cdn/shop/files/dor-curtains-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/dor-curtains-4.jpg",
                "imgSrcF": "/cdn/shop/files/camel.png",
                "price": 50,
                "title": "Oxford / Camel",
                "color": "Beige"
            },
            {
                "term_id": 53878,
                "gallery": [
                    59094,
                    57239,
                    57238,
                    53981,
                    53980,
                    53953,
                    53952,
                    53955,
                    58245
                ],
                "imgSrc": "/cdn/shop/files/dor-curtains-6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/dor-curtains-6.jpg",
                "imgSrcF": "/cdn/shop/files/色块-New-Green.jpg",
                "price": 50,
                "title": "Oxford / Green",
                "color": "Green"
            },
            {
                "term_id": 53876,
                "gallery": [
                    59090,
                    57259,
                    57258,
                    53981,
                    53980,
                    53961,
                    53960,
                    58754,
                    58244
                ],
                "imgSrc": "/cdn/shop/files/dor-curtains-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/dor-curtains-2.jpg",
                "imgSrcF": "/cdn/shop/files/色块-Red.jpg",
                "price": 50,
                "title": "Oxford / Red",
                "color": "Red"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 58585,
                "gallery": null,
                "price": 0,
                "title": "2 - IN - 1"
            }
        ],
        "Category": [
            "All Curtains",
            "Thermal Curtains"
        ],
        "AllCategory": [
            "40% Off Sale",
            "All Curtains",
            "Curtains &amp; Shades",
            "Cyber Monday",
            "Factory products",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search door-curtain",
            "Search thermal",
            "Thermal Curtains",
            "Thermal Door curtains",
            "Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "thermal-door-curtain",
                "name": "thermal door curtain"
            }
        ],
        "short_description": "thermal door curtain\r\nthermal insulated door curtain\r\nmagnetic thermal door curtain\r\nmagnetic insulated door curtain\r\nthermal door cover\r\nmagnetic thermal insulated door curtain\r\ninsulated door curtain\r\nmagnetic curtain\r\nmagnetic door curtain",
        "imgSrc": "/cdn/shop/files/dor-curtains-3-500x500.jpg",
        "hoverImg": "/cdn/shop/files/6-3-500x500.jpg",
        "subheading": "Thermal Insulated & Soundproof Custom Magnetic Door Curtain",
        "Fabrics": [
            "Oxford"
        ],
        "Feature": [
            "Thermal"
        ],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Grey",
            "Black",
            "Blue",
            "Beige",
            "Green",
            "Red"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "3 in 1"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "40% Off",
        "salenum": 40,
        "oldPrice": 237,
        "newPrice": 142,
        "extra": "Extra 10%"
    },
    {
        "id": 58203,
        "title": "Oxford Thermal Insulated &#038; Soundproof Custom Magnetic Door Curtain with PVC",
        "ProductUrl": "/custom-blackout-curtain/custom-soundproof-thermal-insulated-magnetic-pvc-screen-door-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "31940",
        "_fabric_color": [
            {
                "term_id": 31940,
                "gallery": [
                    59399,
                    58257,
                    57251,
                    57250
                ],
                "imgSrc": "/cdn/shop/files/snow-pvc-2-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/snow-pvc-2-4.jpg",
                "imgSrcF": "/cdn/shop/files/Grey.png",
                "price": 50,
                "title": "Oxford / Grey",
                "color": "Grey"
            },
            {
                "term_id": 34874,
                "gallery": [
                    59401,
                    58259,
                    57247,
                    57246,
                    44832,
                    44831,
                    41326,
                    41325,
                    58766
                ],
                "imgSrc": "/cdn/shop/files/snow-pvc-2-6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/snow-pvc-2-6.jpg",
                "imgSrcF": "/cdn/shop/files/Black-1.png",
                "price": 50,
                "title": "Oxford / Black",
                "color": "Black"
            },
            {
                "term_id": 34567,
                "gallery": [
                    59400,
                    58258,
                    57243,
                    57242,
                    44832,
                    44831,
                    41310,
                    41309,
                    58770
                ],
                "imgSrc": "/cdn/shop/files/snow-pvc-2-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/snow-pvc-2-5.jpg",
                "imgSrcF": "/cdn/shop/files/Navy-blue.png",
                "price": 50,
                "title": "Oxford / Dark Blue",
                "color": "Blue"
            },
            {
                "term_id": 34563,
                "gallery": [
                    59396,
                    58254,
                    57255,
                    57254,
                    44832,
                    44831,
                    41318,
                    41317,
                    58769
                ],
                "imgSrc": "/cdn/shop/files/snow-pvc-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/snow-pvc-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/camel.png",
                "price": 50,
                "title": "Oxford / Camel",
                "color": "Beige"
            },
            {
                "term_id": 53878,
                "gallery": [
                    59398,
                    58256,
                    57239,
                    57238,
                    53981,
                    53980,
                    53953,
                    53952,
                    58768
                ],
                "imgSrc": "/cdn/shop/files/snow-pvc-2-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/snow-pvc-2-3.jpg",
                "imgSrcF": "/cdn/shop/files/色块-New-Green.jpg",
                "price": 50,
                "title": "Oxford / Green",
                "color": "Green"
            },
            {
                "term_id": 53876,
                "gallery": [
                    59397,
                    58255,
                    57259,
                    57258,
                    53981,
                    53980,
                    53961,
                    53960,
                    58765
                ],
                "imgSrc": "/cdn/shop/files/snow-pvc-2-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/snow-pvc-2-2.jpg",
                "imgSrcF": "/cdn/shop/files/色块-Red.jpg",
                "price": 50,
                "title": "Oxford / Red",
                "color": "Red"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 58585,
                "gallery": null,
                "price": 0,
                "title": "2 - IN - 1"
            }
        ],
        "Category": [
            "All Curtains",
            "Thermal Curtains"
        ],
        "AllCategory": [
            "40% Off Sale",
            "All Curtains",
            "Black Friday",
            "Curtains &amp; Shades",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search door-curtain",
            "Search thermal",
            "Thermal Curtains",
            "Thermal Door curtains",
            "Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "signature",
                "name": "signature"
            },
            {
                "slug": "thermal-door-curtain",
                "name": "thermal door curtain"
            }
        ],
        "short_description": "<p class=\"feature_p1\">See through screen door curtain</p>\r\n\r\n<h3>Rest in the comfort, warmth and peace. Winter Jacket for your home</h3>\r\n<h3>Keep your home cozy\r\nAll the time</h3>\r\n<p class=\"kong_c\">• Saving your energy &amp; costs in cold and hot seasons\r\n• See thorugh PVC screen let the light shine through\r\n• Noise reducing door curtains to help you sleep soundly like a baby</p>\r\n\r\n<div class=\"section_box3\">\r\n<div class=\"section3_right\">\r\n<h3>Thermal insulated technology\r\nWorks well in energy savings</h3>\r\n<p class=\"kong_c\">• High performance in soundproof, thermal insulation for energy savings.</p>\r\n\r\n</div>\r\n</div>\r\n<div id=\"specifi\" class=\"section_box4\">\r\n<div class=\"section4_left\">\r\n<div id=\"specifi\" class=\"section_box4\">\r\n<div class=\"section4_right\">\r\n<div class=\"spec_div\">\r\n<h3>Specifications</h3>\r\n<div class=\"specif_left\">\r\n<p class=\"kong_c\">MATERIAL ：100% polyester</p>\r\n<p class=\"kong_c\">WEIGHT ：668 g/m²</p>\r\n<p class=\"kong_c\">LIGHT FILTRATION ：100% Blackout</p>\r\n<p class=\"kong_c\">FEATURES ：Soundproof &amp; Insulation</p>\r\n<p class=\"kong_c\">LINER OR BACKING INCLUDED ：No</p>\r\n<p class=\"kong_c\">NUMBER OF PANELS INCLUDED ： 1 PC</p>\r\n\r\n</div>\r\n</div>\r\n<div class=\"care_div\">\r\n<h3>CARE</h3>\r\n<p class=\"kong_c\">• Machine wash on gentle cycle</p>\r\n<p class=\"kong_c\">• After washing, hang your curtains to dry</p>\r\n\r\n</div>\r\n<div class=\"install_div\">\r\n<h3>INSTALLATION</h3>\r\n<p class=\"kong_c\">• Free shipping on all orders in the United States</p>\r\n<p class=\"kong_c\">• <a href=\"https://www.nicetown.com/shipping-policy/\">Learn more</a></p>\r\n\r\n</div>\r\n</div>\r\n</div>\r\n<div class=\"section_box5\">\r\n<h3 class=\"fout_title\">The Thermal Door Curtain</h3>\r\n<div class=\"four_section1\">\r\n<div class=\"section1_hover\">\r\n<ul>\r\n \t<li class=\"hover_title\">See through pvc screen — Featuring a see-through PVC screen to give you clear view of outside while keeping inside warm and cozy</li>\r\n</ul>\r\n</div>\r\n</div>\r\n<div class=\"four_section1\">\r\n<div class=\"section1_hover\">\r\n<ul>\r\n \t<li class=\"hover_title\">Thermal Insulation — Compact and substaintial fabric effective in reducing cold air drafts from entering</li>\r\n</ul>\r\n<div class=\"section_box5\">\r\n<div class=\"four_section1\">\r\n<div class=\"section1_hover\">\r\n<ul>\r\n \t<li class=\"hover_title\">Custom-made to order — Customize to fit your door perfectly, for more customization needs contact customer support</li>\r\n</ul>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>",
        "imgSrc": "/cdn/shop/files/snow-pvc-2-5-500x500.jpg",
        "hoverImg": "/cdn/shop/files/4-3-500x500.jpg",
        "subheading": "Oxford Thermal Insulated & Soundproof Custom Magnetic Door Curtain with PVC",
        "Fabrics": [
            "Oxford"
        ],
        "Feature": [
            "Thermal"
        ],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Grey",
            "Black",
            "Blue",
            "Beige",
            "Green",
            "Red"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "3 in 1"
        ],
        "Space": [
            "Indoor"
        ],
        "Sale": "40% Off",
        "salenum": 40,
        "oldPrice": 213,
        "newPrice": 128,
        "extra": "Extra 10%"
    },
    {
        "id": 58202,
        "title": "Oxford Thermal Insulated &#038; Soundproof Custom Door Curtain With PVC",
        "ProductUrl": "/custom-blackout-curtain/custom-soundproof-thermal-insulated-pvc-screen-door-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "31940",
        "_fabric_color": [
            {
                "term_id": 31940,
                "gallery": [
                    59406,
                    58226,
                    58233,
                    57251,
                    57250
                ],
                "imgSrc": "/cdn/shop/files/snow-pvc-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/snow-pvc-3.jpg",
                "imgSrcF": "/cdn/shop/files/Grey.png",
                "price": 50,
                "title": "Oxford / Grey",
                "color": "Grey"
            },
            {
                "term_id": 34874,
                "gallery": [
                    59405,
                    58228,
                    58231,
                    57247,
                    57246,
                    44832,
                    44831,
                    41326,
                    41325,
                    58772
                ],
                "imgSrc": "/cdn/shop/files/snow-pvc-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/snow-pvc-2.jpg",
                "imgSrcF": "/cdn/shop/files/Black-1.png",
                "price": 50,
                "title": "Oxford / Black",
                "color": "Black"
            },
            {
                "term_id": 34567,
                "gallery": [
                    59409,
                    58227,
                    58232,
                    57243,
                    57242,
                    44832,
                    44831,
                    41310,
                    41309,
                    58776
                ],
                "imgSrc": "/cdn/shop/files/snow-pvc-6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/snow-pvc-6.jpg",
                "imgSrcF": "/cdn/shop/files/Navy-blue.png",
                "price": 50,
                "title": "Oxford / Dark Blue",
                "color": "Blue"
            },
            {
                "term_id": 34563,
                "gallery": [
                    59408,
                    58223,
                    58236,
                    57255,
                    57254,
                    44832,
                    44831,
                    41318,
                    41317,
                    58775
                ],
                "imgSrc": "/cdn/shop/files/snow-pvc-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/snow-pvc-5.jpg",
                "imgSrcF": "/cdn/shop/files/camel.png",
                "price": 50,
                "title": "Oxford / Camel",
                "color": "Beige"
            },
            {
                "term_id": 53878,
                "gallery": [
                    59407,
                    58225,
                    58234,
                    57239,
                    57238,
                    53981,
                    53980,
                    53953,
                    53952,
                    58774
                ],
                "imgSrc": "/cdn/shop/files/snow-pvc-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/snow-pvc-4.jpg",
                "imgSrcF": "/cdn/shop/files/色块-New-Green.jpg",
                "price": 50,
                "title": "Oxford / Green",
                "color": "Green"
            },
            {
                "term_id": 53876,
                "gallery": [
                    59404,
                    58224,
                    58235,
                    57259,
                    57258,
                    53981,
                    53980,
                    53961,
                    53960,
                    58771
                ],
                "imgSrc": "/cdn/shop/files/snow-pvc-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/snow-pvc-1.jpg",
                "imgSrcF": "/cdn/shop/files/色块-Red.jpg",
                "price": 50,
                "title": "Oxford / Red",
                "color": "Red"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 32047,
                "gallery": null,
                "price": 0,
                "title": null
            }
        ],
        "Category": [
            "All Curtains",
            "Thermal Curtains"
        ],
        "AllCategory": [
            "40% Off Sale",
            "All Curtains",
            "Curtains &amp; Shades",
            "Factory products",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search door-curtain",
            "Search thermal",
            "Thermal Curtains",
            "Thermal Door curtains",
            "Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "signature",
                "name": "signature"
            },
            {
                "slug": "thermal-door-curtain",
                "name": "thermal door curtain"
            }
        ],
        "short_description": "The Custom Insulated Door Curtain with Window offers a blend of style and functionality for your home. Let's explore its standout features:\r\n<ol>\r\n \t<li><strong>Versatile Design</strong>: These curtains fit various decor styles, including modern and contemporary themes, seamlessly integrating with your home's look.</li>\r\n \t<li><strong>Easy to Use and Install</strong>: With grommet tops, these curtains are simple to slide and install. This design ensures a straightforward, user-friendly experience.</li>\r\n \t<li><strong>Energy Efficiency</strong>: The curtains provide wind resistance, stabilizing your indoor environment. They help maintain consistent indoor temperatures, reducing heating and cooling needs.</li>\r\n \t<li><strong>Effective Soundproofing and Light Blocking</strong>: Their multi-layered fabric excels in reducing noise for a quieter home. They also offer complete blackout capability for privacy and light control.</li>\r\n \t<li><strong>Durability for Various Settings</strong>: Magzo's curtains use robust weatherproof Oxford fabric, making them ideal for different areas like kitchens and air-conditioned rooms.</li>\r\n \t<li><strong>Family-Friendly</strong>: These curtains allow easy access for kids and pets while maintaining an effective thermal barrier.</li>\r\n</ol>\r\nShop Custom Insulated Door Curtain with Window at TheHues today!",
        "imgSrc": "/cdn/shop/files/snow-pvc-5-500x500.jpg",
        "hoverImg": "/cdn/shop/files/1-4-500x500.jpg",
        "subheading": "Thermal Insulated & Soundproof Custom Door Curtain With PVC",
        "Fabrics": [
            "Oxford"
        ],
        "Feature": [
            "Thermal"
        ],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Grey",
            "Black",
            "Blue",
            "Beige",
            "Green",
            "Red"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "3 in 1"
        ],
        "Space": [
            "Indoor",
            "Outdoor"
        ],
        "Sale": "40% Off",
        "salenum": 40,
        "oldPrice": 226,
        "newPrice": 136,
        "extra": "Extra 10%"
    },
    {
        "id": 31945,
        "title": "Oxford Thermal Insulated &#038; Soundproof Custom Door Curtain",
        "ProductUrl": "/custom-blackout-curtain/oxford-thermal-door-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "34563",
        "_fabric_color": [
            {
                "term_id": 34563,
                "gallery": [
                    41315,
                    57253,
                    57252,
                    57255,
                    57254,
                    41313,
                    41314
                ],
                "imgSrc": "/cdn/shop/files/Camel-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Camel-3.jpg",
                "imgSrcF": "/cdn/shop/files/camel.png",
                "price": 50,
                "title": "Oxford / Camel",
                "color": "Beige"
            },
            {
                "term_id": 31940,
                "gallery": [
                    98842,
                    57249,
                    57248,
                    57251,
                    57250,
                    44832,
                    44831,
                    34250,
                    34252,
                    34251,
                    58685,
                    34256,
                    34255
                ],
                "imgSrc": "/cdn/shop/files/door3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/door3.jpg",
                "imgSrcF": "/cdn/shop/files/Grey.png",
                "price": 50,
                "title": "Oxford / Grey",
                "color": "Grey"
            },
            {
                "term_id": 34874,
                "gallery": [
                    41323,
                    57245,
                    57244,
                    57247,
                    57246,
                    44832,
                    44831,
                    41324,
                    41326,
                    41325,
                    58687,
                    41321,
                    41322
                ],
                "imgSrc": "/cdn/shop/files/Black-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-3.jpg",
                "imgSrcF": "/cdn/shop/files/Black-1.png",
                "price": 50,
                "title": "Oxford / Black",
                "color": "Black"
            },
            {
                "term_id": 34567,
                "gallery": [
                    41307,
                    57240,
                    57241,
                    57243,
                    57242,
                    44832,
                    44831,
                    41308,
                    41310,
                    41309,
                    58692,
                    41306,
                    41305
                ],
                "imgSrc": "/cdn/shop/files/Navy-Blue-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Navy-Blue-3.png",
                "imgSrcF": "/cdn/shop/files/Navy-blue.png",
                "price": 50,
                "title": "Oxford / Dark Blue",
                "color": "Blue"
            },
            {
                "term_id": 53878,
                "gallery": [
                    53950,
                    57237,
                    57236,
                    57239,
                    57238,
                    53981,
                    53980,
                    53951,
                    53953,
                    53952,
                    58684,
                    53949,
                    53948
                ],
                "imgSrc": "/cdn/shop/files/Green-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Green-3.jpg",
                "imgSrcF": "/cdn/shop/files/色块-New-Green.jpg",
                "price": 50,
                "title": "Oxford / Green",
                "color": "Green"
            },
            {
                "term_id": 53876,
                "gallery": [
                    53958,
                    57257,
                    57256,
                    57259,
                    57258,
                    53981,
                    53980,
                    53959,
                    53961,
                    53960,
                    58683,
                    53957,
                    53956
                ],
                "imgSrc": "/cdn/shop/files/red-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/red-3.jpg",
                "imgSrcF": "/cdn/shop/files/色块-Red.jpg",
                "price": 50,
                "title": "Oxford / Red",
                "color": "Red"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 32047,
                "gallery": null,
                "price": 5,
                "title": null
            }
        ],
        "Category": [
            "All Curtains",
            "Thermal Curtains",
            "Soundproof Curtains"
        ],
        "AllCategory": [
            "40% Off Sale",
            "All Curtains",
            "Black Friday",
            "Curtains &amp; Shades",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Oeko",
            "Search blackout",
            "Search curtains",
            "Search door-curtain",
            "Search thermal",
            "Thermal Curtains",
            "Thermal Door curtains",
            "Curtains",
            "Custom Blackout Curtains",
            "Soundproof Curtains"
        ],
        "isBestseller": true,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "bestseller",
                "name": "bestseller"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "thermal-door-curtain",
                "name": "thermal door curtain"
            },
            {
                "slug": "thermal-insulated-curtains",
                "name": "thermal insulated curtains"
            }
        ],
        "short_description": "<p style=\"margin-bottom: 20px;\">Multi-purpose: Hang it on the door frame or window in winter, effectively resist the cold wind, keep the indoor temperature, and prevent the loss of indoor cold air in summer.</p>\r\n<p style=\"margin-bottom: 20px;\">Cotton Curtain Material: Waterproof Oxford cloth fabric, tightly woven, abrasion resistant, tear-resistant, inner filling: Silk cotton, fluffy. The drape is good, has a good thickness, is waterproof, and is easy to clean; it does not shrink, and the sound insulation is very good.</p>\r\nthermal\r\nThermal\r\nThermal curtains\r\nsound\r\nSoundproof\r\nsoundproof curtains\r\nWhite curtains\r\nthermal curtain\r\ninsulated curtains\r\nnoise reducing\r\ninsulated\r\nNoise reduction\r\nSound blocking\r\nThermal Insulated Curtains\r\nnoise reduction curtains\r\nSoundproof curtain\r\nthermal drapes\r\n100% blackout",
        "imgSrc": "/cdn/shop/files/Camel-3-500x500.jpg",
        "hoverImg": "/cdn/shop/files/1-4-500x500.jpg",
        "subheading": "Thermal Insulated & Soundproof Custom Door Curtain",
        "Fabrics": [
            "Oxford"
        ],
        "Feature": [
            "Thermal"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Grey",
            "Black",
            "Blue",
            "Green",
            "Red"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "3 in 1"
        ],
        "Space": [
            "Indoor",
            "Outdoor"
        ],
        "Sale": "40% Off",
        "salenum": 40,
        "oldPrice": 218,
        "newPrice": 131,
        "extra": "Extra 10%"
    },
    {
        "id": 59418,
        "title": "Oxford Thermal Insulation Replacement Custom Pet Door Cover",
        "ProductUrl": "/custom-thermal-curtain/custom-thermal-insulation-pet-door-replacement-covers/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "31940",
        "_fabric_color": [
            {
                "term_id": 31940,
                "gallery": [
                    59413,
                    59661,
                    59414,
                    59416,
                    59417,
                    59415,
                    59412,
                    59411,
                    59410
                ],
                "imgSrc": "/cdn/shop/files/pet-door-flag-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/pet-door-flag-1.jpg",
                "imgSrcF": "/cdn/shop/files/Grey.png",
                "price": 40,
                "title": "Oxford / Grey",
                "color": "Grey"
            },
            {
                "term_id": 34874,
                "gallery": [
                    41329,
                    59413,
                    59417,
                    59416,
                    59415,
                    59414,
                    59412,
                    59411,
                    59410
                ],
                "imgSrc": "/cdn/shop/files/Black-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Black-1.png",
                "imgSrcF": "/cdn/shop/files/Black-1.png",
                "price": 40,
                "title": "Oxford / Black",
                "color": "Black"
            },
            {
                "term_id": 34567,
                "gallery": [
                    41332,
                    59413,
                    59417,
                    59416,
                    59415,
                    59414,
                    59412,
                    59411,
                    59410
                ],
                "imgSrc": "/cdn/shop/files/Navy-blue-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Navy-blue.png",
                "imgSrcF": "/cdn/shop/files/Navy-blue.png",
                "price": 40,
                "title": "Oxford / Dark Blue",
                "color": "Blue"
            },
            {
                "term_id": 53878,
                "gallery": [
                    54011,
                    59413,
                    59416,
                    59417,
                    59415,
                    59414,
                    59412,
                    59411,
                    59410
                ],
                "imgSrc": "/cdn/shop/files/色块-New-Green-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/色块-New-Green.jpg",
                "imgSrcF": "/cdn/shop/files/色块-New-Green.jpg",
                "price": 40,
                "title": "Oxford / Green",
                "color": "Green"
            },
            {
                "term_id": 53876,
                "gallery": [
                    54012,
                    59414,
                    59416,
                    59417,
                    59415,
                    59413,
                    59412,
                    59411,
                    59410
                ],
                "imgSrc": "/cdn/shop/files/色块-Red-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/色块-Red.jpg",
                "imgSrcF": "/cdn/shop/files/色块-Red.jpg",
                "price": 40,
                "title": "Oxford / Red",
                "color": "Red"
            },
            {
                "term_id": 53874,
                "gallery": [
                    54010,
                    59413,
                    59417,
                    59416,
                    59415,
                    59414,
                    59412,
                    59411,
                    59410
                ],
                "imgSrc": "/cdn/shop/files/色块-Roya-Blue-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/色块-Roya-Blue.jpg",
                "imgSrcF": "/cdn/shop/files/色块-Roya-Blue.jpg",
                "price": 40,
                "title": "Oxford / Roya Blue",
                "color": "Blue"
            },
            {
                "term_id": 34563,
                "gallery": [
                    41330,
                    59413,
                    59417,
                    59416,
                    59415,
                    59414,
                    59412,
                    59411,
                    59410
                ],
                "imgSrc": "/cdn/shop/files/camel-500x500.png",
                "imgSrc_n": "/cdn/shop/files/camel.png",
                "imgSrcF": "/cdn/shop/files/camel.png",
                "price": 40,
                "title": "Oxford / Camel",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 59451,
                "gallery": null,
                "price": 0,
                "title": "Top Velcro"
            },
            {
                "term_id": 107020,
                "gallery": null,
                "price": 0,
                "title": "Top + Side Velcro"
            },
            {
                "term_id": 107023,
                "gallery": null,
                "price": 0,
                "title": "No Magnetic strip"
            },
            {
                "term_id": 107027,
                "gallery": null,
                "price": 0,
                "title": "Magnetic strip"
            }
        ],
        "Category": [
            "All Curtains",
            "Thermal Curtains"
        ],
        "AllCategory": [
            "20% Off Sale",
            "All Curtains",
            "Curtains &amp; Shades",
            "Easter Sale",
            "Factory products",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Sale",
            "Search blackout",
            "Search curtains",
            "Search door-curtain",
            "Search thermal",
            "Thermal Curtains",
            "Thermal Door curtains",
            "Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "signature",
                "name": "signature"
            },
            {
                "slug": "thermal-door-curtain",
                "name": "thermal door curtain"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/pet-door-flag-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/pet-door-flag-8-500x500.jpg",
        "subheading": "Thermal Insulation Replacement Custom Pet Door Cover",
        "Fabrics": [
            "Oxford"
        ],
        "Feature": [
            "Thermal"
        ],
        "Material": [
            "Polyester",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Grey",
            "Black",
            "Blue",
            "Green",
            "Red",
            "Blue",
            "Beige"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "3 in 1"
        ],
        "Space": [
            "Indoor",
            "Outdoor"
        ],
        "Sale": "20% Off",
        "salenum": 20,
        "oldPrice": 170,
        "newPrice": 136,
        "extra": "Extra 10%"
    },
    {
        "id": 98931,
        "title": "FadeShield Pro™ 4-Layers Blackout Anti-Dust Water-Resistant Outdoor Curtain",
        "ProductUrl": "/custom-outdoor-curtains/fadeshield-pro-blackout-anti-dust-water-resistant-outdoor-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "45882",
        "_fabric_color": [
            {
                "term_id": 45882,
                "gallery": [
                    98988,
                    62124,
                    62123,
                    45252,
                    45253,
                    45251,
                    98987,
                    62120,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Caramel-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Caramel-2.jpg",
                "imgSrcF": "/cdn/shop/files/Caramel-3.jpg",
                "price": 50,
                "title": "FadeShield Pro™/ Caramel",
                "color": "Brown"
            },
            {
                "term_id": 45894,
                "gallery": [
                    98980,
                    62169,
                    62168,
                    45263,
                    45265,
                    45264,
                    98979,
                    62165,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Prussian-Blue-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Prussian-Blue-2.jpg",
                "imgSrcF": "/cdn/shop/files/Prussian-Blue.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Prussian Blue",
                "color": "Blue"
            },
            {
                "term_id": 45892,
                "gallery": [
                    98995,
                    62129,
                    62128,
                    45276,
                    45278,
                    45277,
                    98994,
                    62125,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Cerulean-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Cerulean-2.jpg",
                "imgSrcF": "/cdn/shop/files/Cerulean.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Cerulean",
                "color": "Blue"
            },
            {
                "term_id": 45890,
                "gallery": [
                    99000,
                    62144,
                    62143,
                    45258,
                    45257,
                    45283,
                    98970,
                    62140,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Forest-Green-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Forest-Green-1.jpg",
                "imgSrcF": "/cdn/shop/files/Forest-Green.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Forest Green",
                "color": "Green"
            },
            {
                "term_id": 45888,
                "gallery": [
                    98975,
                    62159,
                    62158,
                    45255,
                    98976,
                    62155,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Matcha-Tea-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Matcha-Tea-1.jpg",
                "imgSrcF": "/cdn/shop/files/Matcha-Tea.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Matcha Tea",
                "color": "Green"
            },
            {
                "term_id": 45886,
                "gallery": [
                    98998,
                    62139,
                    62138,
                    45249,
                    98999,
                    62135,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Chocolate-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Chocolate-1.jpg",
                "imgSrcF": "/cdn/shop/files/Chocolate.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Chocolate",
                "color": "Brown"
            },
            {
                "term_id": 45884,
                "gallery": [
                    98992,
                    62119,
                    62118,
                    45269,
                    98993,
                    62115,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Berry-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Berry-1.jpg",
                "imgSrcF": "/cdn/shop/files/Berry.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Berry",
                "color": "Red"
            },
            {
                "term_id": 45880,
                "gallery": [
                    98981,
                    62174,
                    62173,
                    45266,
                    98982,
                    62170,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Pumpkin-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Pumpkin-1.jpg",
                "imgSrcF": "/cdn/shop/files/Pumpkin.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Pumpkin",
                "color": "Orange"
            },
            {
                "term_id": 45878,
                "gallery": [
                    98971,
                    62149,
                    62148,
                    45281,
                    98972,
                    62145,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Honey-Yellow-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Honey-Yellow-1.jpg",
                "imgSrcF": "/cdn/shop/files/Honey-Yellow.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Honey Yellow",
                "color": "Yellow"
            },
            {
                "term_id": 45876,
                "gallery": [
                    98996,
                    62134,
                    62133,
                    45943,
                    98997,
                    62130,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Charcoal-Grey-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Charcoal-Grey-1.jpg",
                "imgSrcF": "/cdn/shop/files/Charcoal-Grey.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Charcoal Grey",
                "color": "Grey"
            },
            {
                "term_id": 45872,
                "gallery": [
                    98985,
                    62184,
                    62183,
                    45950,
                    98986,
                    62180,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Tree-Bark-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Tree-Bark-1.jpg",
                "imgSrcF": "/cdn/shop/files/Tree-Bark.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Tree Bark",
                "color": "Grey"
            },
            {
                "term_id": 45843,
                "gallery": [
                    98973,
                    62154,
                    62153,
                    45946,
                    98974,
                    62150,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Koala-Grey-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Koala-Grey-1.jpg",
                "imgSrcF": "/cdn/shop/files/Koala-Gray.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Koala Grey",
                "color": "Grey"
            },
            {
                "term_id": 46781,
                "gallery": [
                    98983,
                    62179,
                    62178,
                    46791,
                    98984,
                    62175,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Soft-Purple-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Soft-Purple-1.jpg",
                "imgSrcF": "/cdn/shop/files/Soft-Purple.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Soft Purple",
                "color": "Purple"
            },
            {
                "term_id": 46779,
                "gallery": [
                    98990,
                    62114,
                    62113,
                    46785,
                    98991,
                    62110,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Apple-Red-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Apple-Red-1.jpg",
                "imgSrcF": "/cdn/shop/files/Apple-Red.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Apple Red",
                "color": "Red"
            },
            {
                "term_id": 46774,
                "gallery": [
                    98977,
                    62139,
                    62138,
                    46788,
                    98978,
                    62135,
                    99116
                ],
                "imgSrc": "/cdn/shop/files/FadeShield-Pro™-Midnight-Black-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/FadeShield-Pro™-Midnight-Black-1.jpg",
                "imgSrcF": "/cdn/shop/files/Midnight-Black.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Midnight Black",
                "color": "Black"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 609,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 47876,
                "gallery": null,
                "price": 0,
                "title": "No Sandbags"
            },
            {
                "term_id": 634,
                "gallery": null,
                "price": 0,
                "title": "Sandbags Included"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "4 layer",
            "All Curtains",
            "Soundproof Curtains",
            "Custom Outdoor Curtains"
        ],
        "AllCategory": [
            "10% Off Sale",
            "4 layer",
            "All Bestsellers",
            "All Curtain Sale",
            "All Curtains",
            "All Outdoor Curtains Sale",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "flash_categories",
            "New Content",
            "New Outdoor Curtains",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search waterproof curtain",
            "Solid Outdoor Curtains",
            "Soundproof &amp; Blackout Curtains",
            "Spring Time Sale",
            "Summer",
            "Summer Collection",
            "Summer Outdoor Decor",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Waterproof Curtains",
            "Curtains",
            "Soundproof Curtains",
            "Dustproof Curtains",
            "Custom Outdoor Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "custom-outdoor-curtains",
                "name": "Custom Outdoor Curtains"
            },
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "Elevate your outdoor space with our Custom Blackout Waterproof Outdoor Curtain. These curtains offer superior functionality and sleek design, perfect for any patio, deck, or garden.Made from high-performance, waterproof materials, our curtains withstand harsh weather conditions. They keep your outdoor area dry and comfortable, even during heavy rain or intense sunlight. The waterproof feature also simplifies maintenance—just wipe them down, and they’re ready to use.\r\n\r\nOUTDOOR CURTAINS\r\noutdoor\r\npatio curtains\r\npatio\r\nwaterproof curtains\r\nOutdoor curtain\r\nPatio curtain\r\nFarmhouse\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nCaramel\r\nBlue curtain",
        "imgSrc": "/cdn/shop/files/12-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Koala-Gray-4-1-500x500.jpg",
        "subheading": "4-Layers Blackout Anti-Dust Water-Resistant Outdoor Curtain",
        "Fabrics": [
            "FadeShield Pro™"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Brown",
            "Blue",
            "Blue",
            "Green",
            "Green",
            "Brown",
            "Red",
            "Orange",
            "Yellow",
            "Grey",
            "Grey",
            "Grey",
            "Purple",
            "Red",
            "Black"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 160,
        "newPrice": 144,
        "extra": "Extra 10%"
    },
    {
        "id": 45244,
        "title": "FadeShield Pro™ Fade-Resistant &#038; Waterproof Lightweight Custom Outdoor Curtain",
        "ProductUrl": "/custom-outdoor-curtains/custom-fade-resistant-waterproof-outdoor-canvas-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "45882",
        "_fabric_color": [
            {
                "term_id": 45882,
                "gallery": [
                    62122,
                    62121,
                    62120,
                    62124,
                    62123,
                    45252,
                    45253,
                    45251
                ],
                "imgSrc": "/cdn/shop/files/Caramel-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Caramel-3.jpg",
                "imgSrcF": "/cdn/shop/files/Caramel-3.jpg",
                "price": 50,
                "title": "FadeShield Pro™/ Caramel",
                "color": "Brown"
            },
            {
                "term_id": 45892,
                "gallery": [
                    62127,
                    62126,
                    62125,
                    62129,
                    62128,
                    45276,
                    45278,
                    45277
                ],
                "imgSrc": "/cdn/shop/files/Cerulean-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Cerulean-3.jpg",
                "imgSrcF": "/cdn/shop/files/Cerulean.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Cerulean",
                "color": "Blue"
            },
            {
                "term_id": 45890,
                "gallery": [
                    62142,
                    62141,
                    62140,
                    45258,
                    62144,
                    62143,
                    45257,
                    45283
                ],
                "imgSrc": "/cdn/shop/files/Forest-Green-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Forest-Green-3.jpg",
                "imgSrcF": "/cdn/shop/files/Forest-Green.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Forest Green",
                "color": "Green"
            },
            {
                "term_id": 45888,
                "gallery": [
                    62157,
                    62156,
                    62155,
                    62159,
                    62158,
                    45255,
                    45256,
                    45254
                ],
                "imgSrc": "/cdn/shop/files/Matcha-Tea-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Matcha-Tea-3.jpg",
                "imgSrcF": "/cdn/shop/files/Matcha-Tea.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Matcha Tea",
                "color": "Green"
            },
            {
                "term_id": 45886,
                "gallery": [
                    62137,
                    62136,
                    62135,
                    62139,
                    62138,
                    45249,
                    45250,
                    45248
                ],
                "imgSrc": "/cdn/shop/files/Chocolate-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Chocolate-3.jpg",
                "imgSrcF": "/cdn/shop/files/Chocolate.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Chocolate",
                "color": "Brown"
            },
            {
                "term_id": 45884,
                "gallery": [
                    62117,
                    62116,
                    62115,
                    62119,
                    62118,
                    45269,
                    45271,
                    45270
                ],
                "imgSrc": "/cdn/shop/files/Berry-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Berry-3.jpg",
                "imgSrcF": "/cdn/shop/files/Berry.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Berry",
                "color": "Red"
            },
            {
                "term_id": 45880,
                "gallery": [
                    62172,
                    62171,
                    62170,
                    62174,
                    62173,
                    45266,
                    45268,
                    45267
                ],
                "imgSrc": "/cdn/shop/files/Pumpkin-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Pumpkin-3.jpg",
                "imgSrcF": "/cdn/shop/files/Pumpkin.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Pumpkin",
                "color": "Orange"
            },
            {
                "term_id": 45878,
                "gallery": [
                    62147,
                    62146,
                    62145,
                    62149,
                    62148,
                    45281,
                    45280,
                    45279
                ],
                "imgSrc": "/cdn/shop/files/Honey-Yellow-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Honey-Yellow-3.jpg",
                "imgSrcF": "/cdn/shop/files/Honey-Yellow.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Honey Yellow",
                "color": "Yellow"
            },
            {
                "term_id": 45876,
                "gallery": [
                    62132,
                    62131,
                    62130,
                    62134,
                    62133,
                    45943,
                    45944,
                    45942
                ],
                "imgSrc": "/cdn/shop/files/Charcoal-Grey-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Charcoal-Grey-3.jpg",
                "imgSrcF": "/cdn/shop/files/Charcoal-Grey.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Charcoal Grey",
                "color": "Grey"
            },
            {
                "term_id": 45872,
                "gallery": [
                    62182,
                    62181,
                    62180,
                    62184,
                    62183,
                    45950,
                    45955,
                    45951
                ],
                "imgSrc": "/cdn/shop/files/Tree-Bark-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Tree-Bark-3.jpg",
                "imgSrcF": "/cdn/shop/files/Tree-Bark.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Tree Bark",
                "color": "Grey"
            },
            {
                "term_id": 45843,
                "gallery": [
                    62152,
                    62151,
                    62150,
                    62154,
                    62153,
                    45946,
                    45954,
                    48463
                ],
                "imgSrc": "/cdn/shop/files/Koala-Gray-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Koala-Gray-3.jpg",
                "imgSrcF": "/cdn/shop/files/Koala-Gray.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Koala Grey",
                "color": "Grey"
            },
            {
                "term_id": 46781,
                "gallery": [
                    62177,
                    62176,
                    62175,
                    62179,
                    62178,
                    46791,
                    46790,
                    46792
                ],
                "imgSrc": "/cdn/shop/files/Soft-Purple-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Soft-Purple-3.jpg",
                "imgSrcF": "/cdn/shop/files/Soft-Purple.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Soft Purple",
                "color": "Purple"
            },
            {
                "term_id": 46779,
                "gallery": [
                    62112,
                    62111,
                    62110,
                    62114,
                    62113,
                    46785,
                    46784,
                    46786
                ],
                "imgSrc": "/cdn/shop/files/Apple-Red-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Apple-Red-3.jpg",
                "imgSrcF": "/cdn/shop/files/Apple-Red.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Apple Red",
                "color": "Red"
            },
            {
                "term_id": 45894,
                "gallery": [
                    62167,
                    62166,
                    62165,
                    62169,
                    62168,
                    45263,
                    45265,
                    45264
                ],
                "imgSrc": "/cdn/shop/files/Prussian-Blue-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Prussian-Blue-3.jpg",
                "imgSrcF": "/cdn/shop/files/Prussian-Blue.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Prussian Blue",
                "color": "Blue"
            },
            {
                "term_id": 46774,
                "gallery": [
                    62137,
                    62136,
                    62135,
                    62139,
                    62138,
                    46788,
                    46787,
                    46789
                ],
                "imgSrc": "/cdn/shop/files/Chocolate-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Chocolate-3.jpg",
                "imgSrcF": "/cdn/shop/files/Midnight-Black.jpg",
                "price": 50,
                "title": "FadeShield Pro™ / Midnight Black",
                "color": "Black"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 610,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Bottom"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 609,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 47876,
                "gallery": null,
                "price": 0,
                "title": "No Sandbags"
            },
            {
                "term_id": 634,
                "gallery": null,
                "price": 0,
                "title": "Sandbags Included"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Custom Outdoor Curtains"
        ],
        "AllCategory": [
            "40% Off Sale",
            "All Bestsellers",
            "All Curtain Sale",
            "All Curtains",
            "All Outdoor Curtains Sale",
            "Black Friday",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Cyber Monday",
            "Fall Collection",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Outsourced products",
            "Sale",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search waterproof curtain",
            "Solid Outdoor Curtains",
            "Spring Time Sale",
            "Summer",
            "Summer Collection",
            "Summer Outdoor Decor",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Waterproof Curtains",
            "Curtains",
            "Custom Outdoor Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "fade-resistant-curtain",
                "name": "Fade Resistant Curtain"
            },
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            }
        ],
        "short_description": "Unlike other blackout drapes, <a href=\"/outdoor/\">Outdoor curtains</a> use waterproof technology in the fabric. The invisible layer on both sides is water-resistant and will be preserved even in heavy rain or the fiercest snowstorm. With the double grommet, the curtain will stay still against the wind.\r\n\r\nUpgrade your outdoor space with a real Fade-Resistant Outdoor Curtain. It is lab-tested and designed to combat harmful UV rays for long-lasting outdoor use.\r\n\r\nOUTDOOR CURTAINS\r\noutdoor\r\npatio curtains\r\npatio\r\nOutdoor curtain\r\nPatio curtain\r\nFarmhouse\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains",
        "imgSrc": "/cdn/shop/files/Caramel-3-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Caramel-4-500x500.jpg",
        "subheading": "Fade-Resistant & Waterproof Lightweight Custom Outdoor Curtain",
        "Fabrics": [
            "FadeShield Pro™"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Brown",
            "Blue",
            "Green",
            "Green",
            "Brown",
            "Red",
            "Orange",
            "Yellow",
            "Grey",
            "Grey",
            "Grey",
            "Purple",
            "Red",
            "Blue",
            "Black"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "40% Off",
        "salenum": 40,
        "oldPrice": 149,
        "newPrice": 89,
        "extra": "Extra 10%"
    },
    {
        "id": 62799,
        "title": "FadeShield Pro™ Fade-Resistant &#038; Waterproof Lightweight Striped Custom Outdoor Curtain",
        "ProductUrl": "/custom-outdoor-curtain/custom-fadeshield-pro-canvas-striped-outdoor-curtain/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "62812",
        "_fabric_color": [
            {
                "term_id": 62812,
                "gallery": [
                    62820,
                    62822,
                    62819,
                    62823,
                    62803
                ],
                "imgSrc": "/cdn/shop/files/Sea-Blue-6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sea-Blue-6.jpg",
                "imgSrcF": "/cdn/shop/files/Sea-Blue-2.jpg",
                "price": 40,
                "title": "FadeShield Pro™/ Sea Blue",
                "color": "Blue"
            },
            {
                "term_id": 62813,
                "gallery": [
                    62816,
                    62817,
                    62815,
                    62818,
                    62802
                ],
                "imgSrc": "/cdn/shop/files/Sky-Blue-6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sky-Blue-6.jpg",
                "imgSrcF": "/cdn/shop/files/Sky-Blue-2.jpg",
                "price": 40,
                "title": "FadeShield Pro™/ Sky Blue",
                "color": "Blue"
            },
            {
                "term_id": 62810,
                "gallery": [
                    62826,
                    62828,
                    62824,
                    62827,
                    62825
                ],
                "imgSrc": "/cdn/shop/files/PETUNIA-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/PETUNIA-2.jpg",
                "imgSrcF": "/cdn/shop/files/PETUNIA-1.jpg",
                "price": 40,
                "title": "FadeShield Pro™/ Petunia",
                "color": "Purple"
            },
            {
                "term_id": 62811,
                "gallery": [
                    62835,
                    62837,
                    62834,
                    62836,
                    62806
                ],
                "imgSrc": "/cdn/shop/files/WATERMELON-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/WATERMELON-2.jpg",
                "imgSrcF": "/cdn/shop/files/WATERMELON-1.jpg",
                "price": 40,
                "title": "FadeShield Pro™/ Watermelon",
                "color": "Green"
            },
            {
                "term_id": 62809,
                "gallery": [
                    62831,
                    62833,
                    62829,
                    62832,
                    62830
                ],
                "imgSrc": "/cdn/shop/files/zebra-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/zebra-2.jpg",
                "imgSrcF": "/cdn/shop/files/zebra-1.jpg",
                "price": 40,
                "title": "FadeShield Pro™/ Zebra",
                "color": "Black"
            },
            {
                "term_id": 62807,
                "gallery": [
                    62839,
                    62814,
                    62838,
                    62840,
                    62801
                ],
                "imgSrc": "/cdn/shop/files/CINNAMON-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/CINNAMON-2.jpg",
                "imgSrcF": "/cdn/shop/files/CINNAMON-1.jpg",
                "price": 40,
                "title": "FadeShield Pro™/ Cinnamon",
                "color": "Brown"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 610,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Bottom"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 609,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 47876,
                "gallery": null,
                "price": 0,
                "title": "No Sandbags"
            },
            {
                "term_id": 634,
                "gallery": null,
                "price": 0,
                "title": "Sandbags Included"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Custom Outdoor Curtains"
        ],
        "AllCategory": [
            "All Bestsellers",
            "All Curtains",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Patterned Outdoor Curtains",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search waterproof curtain",
            "Summer Collection",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Waterproof Curtains",
            "Curtains",
            "Custom Outdoor Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            }
        ],
        "short_description": "The Outdoor curtains adopt waterproof technology on the fabric, unlike the other blackout drapes. The invisible layer on both sides is water-resistant and will preserve even in heavy rain or the fiercest snowstorm. With the double grommet, the curtain will stay still against the wind.\r\n\r\nOUTDOOR CURTAINS\r\noutdoor\r\npatio curtains\r\npatio\r\nOutdoor curtain\r\nPatio curtain\r\nFarmhouse\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
        "imgSrc": "/cdn/shop/files/zebra-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Grey-2-12-500x500.jpg",
        "subheading": "Fade-Resistant & Waterproof Lightweight Striped Custom Outdoor Curtain",
        "Fabrics": [
            "FadeShield Pro™"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Polyester",
            "Canvas"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Blue",
            "Blue",
            "Purple",
            "Green",
            "Black",
            "Brown"
        ],
        "Light": [
            "Blackout"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 115,
        "newPrice": 106,
        "extra": "Extra 10%"
    },
    {
        "id": 1200,
        "title": "FadeShield™ Canvas Waterproof Lightweight Custom Outdoor Curtain",
        "ProductUrl": "/custom-outdoor-curtains/custom-waterproof-solid-color-outdoor-canvas-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "726",
        "_fabric_color": [
            {
                "term_id": 726,
                "gallery": [
                    96891,
                    62243,
                    62241,
                    62242,
                    62245,
                    62244
                ],
                "imgSrc": "/cdn/shop/files/Taupe-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Taupe.jpg",
                "imgSrcF": "/cdn/shop/files/Taupe-4-2.jpg",
                "price": 50,
                "title": "FadeShield™ / Taupe",
                "color": "Beige"
            },
            {
                "term_id": 718,
                "gallery": [
                    96890,
                    62217,
                    62215,
                    62216,
                    62219,
                    62218
                ],
                "imgSrc": "/cdn/shop/files/Grey-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-5.jpg",
                "imgSrcF": "/cdn/shop/files/New-Grey-1-1.jpg",
                "price": 50,
                "title": "FadeShield™ / Grey",
                "color": "Grey"
            },
            {
                "term_id": 32169,
                "gallery": [
                    96892,
                    62238,
                    62236,
                    62237,
                    62240,
                    62239
                ],
                "imgSrc": "/cdn/shop/files/Royal-Blue-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Royal-Blue.jpg",
                "imgSrcF": "/cdn/shop/files/Roya-Blue.jpg",
                "price": 50,
                "title": "FadeShield™ / Royal Blue",
                "color": "Blue"
            },
            {
                "term_id": 724,
                "gallery": [
                    96885,
                    62227,
                    62225,
                    62226,
                    62230,
                    62229
                ],
                "imgSrc": "/cdn/shop/files/WHite-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/WHite.jpg",
                "imgSrcF": "/cdn/shop/files/New-Pure-White-2-.jpg",
                "price": 50,
                "title": "FadeShield™ / Pure White",
                "color": "White"
            },
            {
                "term_id": 721,
                "gallery": [
                    96886,
                    62222,
                    62220,
                    62221,
                    62224,
                    62223
                ],
                "imgSrc": "/cdn/shop/files/Orange-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Orange.jpg",
                "imgSrcF": "/cdn/shop/files/New-Orange-5-2.jpg",
                "price": 50,
                "title": "FadeShield™ / Orange",
                "color": "Orange"
            },
            {
                "term_id": 714,
                "gallery": [
                    96893,
                    62212,
                    62210,
                    62211,
                    62214,
                    62213
                ],
                "imgSrc": "/cdn/shop/files/Green-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Green-1.jpg",
                "imgSrcF": "/cdn/shop/files/New-Green-5-.jpg",
                "price": 50,
                "title": "FadeShield™ / Green",
                "color": "Green"
            },
            {
                "term_id": 712,
                "gallery": [
                    96884,
                    62197,
                    62195,
                    62196,
                    62199,
                    62198
                ],
                "imgSrc": "/cdn/shop/files/Blue-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Blue.jpg",
                "imgSrcF": "/cdn/shop/files/New-Blue.jpg",
                "price": 50,
                "title": "FadeShield™ / Blue",
                "color": "Blue"
            },
            {
                "term_id": 32164,
                "gallery": [
                    96888,
                    62233,
                    62231,
                    62232,
                    62235,
                    62234
                ],
                "imgSrc": "/cdn/shop/files/Red-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Red-2.jpg",
                "imgSrcF": "/cdn/shop/files/Red.jpg",
                "price": 50,
                "title": "FadeShield™ / Red",
                "color": "Red"
            },
            {
                "term_id": 32171,
                "gallery": [
                    96887,
                    62192,
                    62190,
                    62191,
                    62194,
                    62193
                ],
                "imgSrc": "/cdn/shop/files/Black-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-5.jpg",
                "imgSrcF": "/cdn/shop/files/Black.jpg",
                "price": 50,
                "title": "FadeShield™ / Black",
                "color": "Black"
            },
            {
                "term_id": 40021,
                "gallery": [
                    96894,
                    62187,
                    62185,
                    62186,
                    62189,
                    62188
                ],
                "imgSrc": "/cdn/shop/files/Begie-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Begie.jpg",
                "imgSrcF": "/cdn/shop/files/8-1.png",
                "price": 50,
                "title": "FadeShield™ / Begie",
                "color": "Beige"
            },
            {
                "term_id": 40011,
                "gallery": [
                    96895,
                    62202,
                    62200,
                    62201,
                    62204,
                    62203
                ],
                "imgSrc": "/cdn/shop/files/Charcoal-Grey-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Charcoal-Grey.jpg",
                "imgSrcF": "/cdn/shop/files/sw.jpg",
                "price": 50,
                "title": "FadeShield™ / Charcoal Grey",
                "color": "Grey"
            },
            {
                "term_id": 39998,
                "gallery": [
                    96889,
                    62207,
                    62205,
                    62206,
                    62209,
                    62208
                ],
                "imgSrc": "/cdn/shop/files/Grayish-Blue-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grayish-Blue.jpg",
                "imgSrcF": "/cdn/shop/files/120x120-1.png",
                "price": 50,
                "title": "FadeShield™ / Grayish Blue",
                "color": "Blue"
            },
            {
                "term_id": 44971,
                "gallery": [
                    44956,
                    44957,
                    44967,
                    44966,
                    44965,
                    44964,
                    44963,
                    44959,
                    44961,
                    44960,
                    44962
                ],
                "imgSrc": "/cdn/shop/files/Green-Heat-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Green-Heat-2.jpg",
                "imgSrcF": false,
                "price": 50,
                "title": null,
                "color": "Blue"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 340,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Silver"
            },
            {
                "term_id": 610,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Bottom"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 609,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 606,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 608,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 47876,
                "gallery": null,
                "price": 0,
                "title": "No Sandbags"
            },
            {
                "term_id": 634,
                "gallery": null,
                "price": 0,
                "title": "Sandbags Included"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Custom Outdoor Curtains"
        ],
        "AllCategory": [
            "40% Off Sale",
            "All Bestsellers",
            "All Curtains",
            "All Outdoor Curtains Sale",
            "Black Friday",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Cyber Monday",
            "Extra 10%",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search waterproof curtain",
            "Solid Outdoor Curtains",
            "Spring Time Sale",
            "summer best seller",
            "Summer Collection",
            "Summer Outdoor Decor",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Waterproof Curtains",
            "Curtains",
            "Custom Outdoor Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "custom-outdoor-curtains",
                "name": "Custom Outdoor Curtains"
            },
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            },
            {
                "slug": "waterproof-curtains",
                "name": "Waterproof Curtains"
            }
        ],
        "short_description": "<strong>Upgrade Your Outdoor Space with FadeShield™ Waterproof Custom Outdoor Curtains</strong>\r\n\r\nTransform your outdoor area into a stylish and functional retreat with our FadeShield™ Waterproof Custom Outdoor Curtains. These curtains are designed to combine elegance with resilience, ensuring that your outdoor space looks stunning while staying protected against the elements. Whether it’s your patio, deck, gazebo, or any outdoor setting, FadeShield™ curtains offer the perfect solution for comfort and privacy.\r\n\r\n<strong>Why Choose FadeShield™ Waterproof Outdoor Curtains?</strong>\r\n\r\n<strong>1. Unmatched Durability:</strong> FadeShield™ outdoor curtains are crafted from premium, waterproof materials that resist fading, even under prolonged exposure to sunlight. This ensures that your outdoor curtain maintains its vibrant color and functionality, regardless of weather conditions.\r\n\r\n<strong>2. Customization for Perfect Fit:</strong> Every outdoor space is unique, and so are our FadeShield™ curtains. We offer a wide range of customization options, including leaf pattern curtain, beige outdoor curtain, grey outdoor curtain, red outdoor curtain, black outdoor curtain, blue outdoor curtain, green outdoor curtain, and white outdoor curtain. Custom-fit curtains ensure a seamless and sophisticated look, perfectly matching your décor and fitting your space.\r\n\r\n<strong>3. Ultimate Protection:</strong> Our outdoor curtains provide excellent protection against harsh weather conditions. They are designed to be waterproof, ensuring that your outdoor furniture and space remain dry and comfortable. Additionally, they offer shade and block harmful UV rays, making your outdoor area a safe haven during sunny days.\r\n\r\n<strong>4. Low Maintenance:</strong> FadeShield™ patio curtains are easy to clean and maintain. Their waterproof and stain-resistant properties mean that a simple wipe-down or occasional wash will keep them looking fresh and new, saving you time and effort.\r\n\r\n<strong>Enhance Your Outdoor Living Experience</strong>\r\n\r\nFadeShield™ Waterproof Custom Outdoor Curtains are more than just a functional addition; they are an aesthetic upgrade that adds value and charm to your outdoor living space. Whether you're hosting outdoor parties, enjoying a quiet evening, or creating a cozy reading nook, these curtains set the perfect ambiance. Choose from various styles, such as farmhouse drapes, pinch pleated patio curtains, and grommet blackout curtains to suit your taste.\r\n\r\n<strong>Order Your FadeShield™ Waterproof Outdoor Curtains Today!</strong>\r\n\r\nDon’t compromise on style or functionality. Contact us now to explore customization options and place your order. With FadeShield™ Waterproof Custom Outdoor Curtains, you can enjoy a beautifully transformed outdoor space that stands up to the elements. Elevate your outdoor experience and make every moment outside extraordinary!\r\n\r\n&nbsp;",
        "imgSrc": "/cdn/shop/files/Taupe-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Taupe-4-500x500.jpg",
        "subheading": "Canvas Waterproof Lightweight Custom Outdoor Curtain",
        "Fabrics": [
            "FadeShield™"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Grey",
            "Blue",
            "White",
            "Orange",
            "Green",
            "Blue",
            "Red",
            "Black",
            "Beige",
            "Grey",
            "Blue"
        ],
        "Light": [
            "Room Darkening"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Pinch Pleated",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "40% Off",
        "salenum": 40,
        "oldPrice": 147,
        "newPrice": 88,
        "extra": "Extra 10%"
    },
    {
        "id": 32123,
        "title": "Sabrina Linen Look Lightweight Custom Outdoor Sheer Curtain",
        "ProductUrl": "/custom-sheer-curtains/custom-outdoor-grommet-faux-linen-sheer-curtains/?fwidth=21&flength=21",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "32139",
        "_fabric_color": [
            {
                "term_id": 32139,
                "gallery": [
                    48531,
                    48532,
                    48533,
                    48534,
                    48536,
                    48538,
                    48539
                ],
                "imgSrc": "/cdn/shop/files/4-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/4-1.jpg",
                "imgSrcF": "/cdn/shop/files/White.jpg",
                "price": 30,
                "title": "Sabrina / White",
                "color": "White"
            },
            {
                "term_id": 32124,
                "gallery": [
                    32134,
                    48531,
                    48533,
                    48534,
                    48536,
                    48538,
                    48539
                ],
                "imgSrc": "/cdn/shop/files/W52xL108Beige-01-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/W52xL108Beige-01-1.jpg",
                "imgSrcF": "/cdn/shop/files/geige.jpg",
                "price": 30,
                "title": "Sabrina / Beige",
                "color": "Beige"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 610,
                "gallery": null,
                "price": 0,
                "title": "Grommet Top Bottom"
            },
            {
                "term_id": 614,
                "gallery": null,
                "price": 0,
                "title": "Single Rod Pocket"
            },
            {
                "term_id": 607,
                "gallery": null,
                "price": 0,
                "title": "Double Rod Pockets"
            },
            {
                "term_id": 611,
                "gallery": null,
                "price": 0,
                "title": "Velcro Tab Top"
            },
            {
                "term_id": 609,
                "gallery": null,
                "price": 0,
                "title": "Tab Top"
            },
            {
                "term_id": 660,
                "gallery": null,
                "price": 0,
                "title": "Back Tab"
            },
            {
                "term_id": 107895,
                "gallery": null,
                "price": 0,
                "title": "No Tiebacks"
            },
            {
                "term_id": 107893,
                "gallery": null,
                "price": 5,
                "title": "Matching Tiebacks"
            }
        ],
        "Category": [
            "All Curtains",
            "Light Filtering Curtains",
            "Custom Outdoor Curtains",
            "Custom Sheer Curtains"
        ],
        "AllCategory": [
            "All Bestsellers",
            "All Curtains",
            "Curtains &amp; Shades",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Factory products",
            "Fall Collection",
            "Light Filtering Curtains",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outdoor Sheer Curtains",
            "Search curtains",
            "Search outdoor",
            "Search outdoor curtains",
            "Search sheer",
            "Solid Outdoor Curtains",
            "Summer Collection",
            "Summer Outdoor Decor",
            "Synthetic Curtains",
            "Synthetic Outdoor Curtains",
            "Curtains",
            "Custom Outdoor Curtains",
            "Custom Sheer Curtains"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "aquashield",
                "name": "aquashield"
            },
            {
                "slug": "outdoor",
                "name": "outdoor"
            },
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            },
            {
                "slug": "sabrina",
                "name": "Sabrina"
            },
            {
                "slug": "sheer",
                "name": "sheer"
            }
        ],
        "short_description": "The curtains on white background sheer which is interesting and special to catch the eyes and will decorate your outdoor zone with a vibrant and innovative sense. The decorative linen sheer curtains are versatile for your outdoor living\r\nThe semi-sheer texture adopts waterproof technology is privacy and wrinkle-free for a vertical sense, while also will allow natural light filter but fade the glare of sunlight.",
        "imgSrc": "/cdn/shop/files/W52xL108Beige-01-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/4-8-1-500x500.jpg",
        "subheading": "Linen Look Lightweight Custom Outdoor Curtain",
        "Fabrics": [
            "Sabrina"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Sheer",
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "White",
            "Beige"
        ],
        "Light": [
            "Sheer"
        ],
        "Hanging": [
            "Back Tab",
            "Grommet",
            "Inverted Pleat",
            "Rod Pocket",
            "Tab Top"
        ],
        "Space": [
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 107,
        "newPrice": 101,
        "extra": "Extra 10%"
    }
];
var shadesList = [];
var accessoriesList = [
    {
        "id": 105467,
        "title": "Black Roman Round Custom Finial Curtain Rod",
        "ProductUrl": "/custom-curtain-rods/black-roman-round-custom-finial-curtain-rod/?fwidth=40&flength=40fwidth=40&flength=40",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "105466",
        "_fabric_color": [
            {
                "term_id": 105466,
                "gallery": [
                    105469,
                    105473,
                    105471,
                    105474,
                    105475
                ],
                "imgSrc": "/cdn/shop/files/1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/1.jpg",
                "imgSrcF": "/cdn/shop/files/1.jpg",
                "title": "Black"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Custom Curtain Rod",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/3-500x500.jpg",
        "subheading": "Custom Finials Curtain Rods",
        "Fabrics": [
            "Black Roman Round"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 123,
        "newPrice": 105
    },
    {
        "id": 99654,
        "title": "Adjustable Heavy Duty Curtain Track Kits",
        "ProductUrl": "/accessories/adjustable-heavy-duty-curtain-track-kits/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "99708",
        "_fabric_color": [
            {
                "term_id": 99708,
                "gallery": [
                    99694,
                    99692,
                    99691,
                    99690,
                    99693
                ],
                "imgSrc": "/cdn/shop/files/Track-kit-5-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Track-kit-5.png",
                "imgSrcF": "/cdn/shop/files/Track-kit-3.png",
                "title": "Curtain Track"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 99697,
                "gallery": null,
                "price": 0,
                "title": "Small 4.3 ft"
            },
            {
                "term_id": 99699,
                "gallery": null,
                "price": 0,
                "title": "Medium 6.5 ft"
            },
            {
                "term_id": 99701,
                "gallery": null,
                "price": 0,
                "title": "Large 9.75 ft"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Track",
            "Factory products",
            "Fixed Size",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "No Sale Coupons",
            "Search Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Track-kit-5-500x500.png",
        "hoverImg": "/cdn/shop/files/Track-kit-3-500x500.png",
        "subheading": "Adjustable Heavy Duty Curtain Track",
        "Fabrics": [
            "Adjustable"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 82,
        "newPrice": 102
    },
    {
        "id": 62843,
        "title": "Ringed Rope Curtain Tieback",
        "ProductUrl": "/tiebacks/ringed-rope-curtain-tieback/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63143",
        "_fabric_color": [
            {
                "term_id": 63149,
                "gallery": [
                    63061,
                    63062,
                    63068,
                    63067,
                    63066,
                    63065,
                    63063,
                    63064
                ],
                "imgSrc": "/cdn/shop/files/Brown-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Brown-1.jpg",
                "imgSrcF": "/cdn/shop/files/Brown-5.jpg",
                "title": "Brown",
                "color": "Green"
            },
            {
                "term_id": 63147,
                "gallery": [
                    63116,
                    63117,
                    63123,
                    63122,
                    63120,
                    63121,
                    63118,
                    63119
                ],
                "imgSrc": "/cdn/shop/files/Yellow-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yellow-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Yellow-6-1.jpg",
                "title": "Yellow",
                "color": "Green"
            },
            {
                "term_id": 63146,
                "gallery": [
                    63109,
                    63108,
                    63115,
                    63114,
                    63112,
                    63110,
                    63113,
                    63111
                ],
                "imgSrc": "/cdn/shop/files/Sliver-Beige-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sliver-Beige-2.jpg",
                "imgSrcF": "/cdn/shop/files/Sliver-Beige-4.jpg",
                "title": "Silver Beige",
                "color": "Green"
            },
            {
                "term_id": 63142,
                "gallery": [
                    63100,
                    63101,
                    63107,
                    63106,
                    63103,
                    63105,
                    63102,
                    63104
                ],
                "imgSrc": "/cdn/shop/files/Flash-White-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Flash-White-1.jpg",
                "imgSrcF": "/cdn/shop/files/Flash-White-6.jpg",
                "title": "Flash White",
                "color": "Green"
            },
            {
                "term_id": 63143,
                "gallery": [
                    63093,
                    63094,
                    63099,
                    63098,
                    63096,
                    63095,
                    63097
                ],
                "imgSrc": "/cdn/shop/files/Diamond-Brown-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Diamond-Brown-1.jpg",
                "imgSrcF": "/cdn/shop/files/Diamond-Brown-5.jpg",
                "title": "Diamond Brown",
                "color": "Green"
            },
            {
                "term_id": 63144,
                "gallery": [
                    63079,
                    63086,
                    63084,
                    63083,
                    63081,
                    63082,
                    63080
                ],
                "imgSrc": "/cdn/shop/files/crystal-green-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/crystal-green-2.jpg",
                "imgSrcF": "/cdn/shop/files/crystal-green-5.jpg",
                "title": "Crystal green",
                "color": "Green"
            },
            {
                "term_id": 63145,
                "gallery": [
                    63069,
                    63074,
                    63073,
                    63072,
                    63070,
                    63071
                ],
                "imgSrc": "/cdn/shop/files/Crystal-Gray-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Crystal-Gray-1.jpg",
                "imgSrcF": "/cdn/shop/files/Crystal-Gray-4.jpg",
                "title": "Crystal Gray",
                "color": "Green"
            },
            {
                "term_id": 63141,
                "gallery": [
                    63086,
                    63085,
                    63092,
                    63091,
                    63087,
                    63089,
                    63090,
                    63088
                ],
                "imgSrc": "/cdn/shop/files/Black-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Black-4-1.jpg",
                "title": "Black",
                "color": "Green"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Search tieback",
            "Summer Collection",
            "Tiebacks"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Diamond-Brown-7-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Diamond-Brown-4-500x500.jpg",
        "subheading": "Rop Curtain Tieback",
        "Fabrics": [
            "Ringed"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 161,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 63444,
        "title": "Ball Custom Finials Curtain Rods",
        "ProductUrl": "/custom-curtain-rod/custom-ball-finial-curtain-rod-with-ball-finials/?fwidth=40&flength=40fwidth=40&flength=40",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63448",
        "_fabric_color": [
            {
                "term_id": 63448,
                "gallery": [
                    63309,
                    63305,
                    63311,
                    63310,
                    63308,
                    63307,
                    63306
                ],
                "imgSrc": "/cdn/shop/files/Round-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Round-5.jpg",
                "imgSrcF": "/cdn/shop/files/Round-3.jpg",
                "title": "Ball Finial"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Custom Curtain Rod",
            "Extra 10%",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search Rod",
            "Summer Collection",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Round-5-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Round-6-500x500.jpg",
        "subheading": "Custom Finials Curtain Rods",
        "Fabrics": [
            "Ball"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 111,
        "newPrice": 94,
        "extra": "Extra 10%"
    },
    {
        "id": 63170,
        "title": "Sweater Yarn Wooden Curtain Wall Hook",
        "ProductUrl": "/wall-hook/botton-yarn-wooden-curtain-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63182",
        "_fabric_color": [
            {
                "term_id": 63182,
                "gallery": [
                    63045,
                    63046,
                    63038,
                    63043,
                    63044,
                    63042,
                    63041,
                    63040,
                    63039
                ],
                "imgSrc": "/cdn/shop/files/Sweater-wood-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sweater-wood-8.jpg",
                "imgSrcF": "/cdn/shop/files/Sweater-wood-1.jpg",
                "title": "Sweater / Wood"
            },
            {
                "term_id": 63180,
                "gallery": [
                    63037,
                    63036,
                    63029,
                    63033,
                    63035,
                    63034,
                    63032,
                    63031,
                    63030
                ],
                "imgSrc": "/cdn/shop/files/Sweater-black-9-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sweater-black-9.jpg",
                "imgSrcF": "/cdn/shop/files/Sweater-black-1.jpg",
                "title": "Sweater / Black"
            },
            {
                "term_id": 63181,
                "gallery": [
                    63027,
                    63028,
                    63020,
                    63025,
                    63026,
                    63024,
                    63023,
                    63022,
                    63021
                ],
                "imgSrc": "/cdn/shop/files/Lambswool-wood-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Lambswool-wood-8.jpg",
                "imgSrcF": "/cdn/shop/files/Lambswool-wood-1.jpg",
                "title": "Lambswool / Wood"
            },
            {
                "term_id": 63177,
                "gallery": [
                    63011,
                    63012,
                    63013,
                    63017,
                    63019,
                    63018,
                    63016,
                    63015,
                    63014
                ],
                "imgSrc": "/cdn/shop/files/Lambswool-Black-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Lambswool-Black-1.jpg",
                "imgSrcF": "/cdn/shop/files/Lambswool-Black-3.jpg",
                "title": "Lambswool / Black"
            },
            {
                "term_id": 63178,
                "gallery": [
                    63189,
                    63190,
                    63009,
                    63187,
                    63188,
                    63186,
                    63185,
                    63184,
                    63183
                ],
                "imgSrc": "/cdn/shop/files/Coral-Wood-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Coral-Wood-8.jpg",
                "imgSrcF": "/cdn/shop/files/Coral-Wood-1.jpg",
                "title": "Coral / Wood"
            },
            {
                "term_id": 63179,
                "gallery": [
                    63001,
                    63002,
                    63003,
                    63006,
                    63008,
                    63007,
                    63005,
                    63004
                ],
                "imgSrc": "/cdn/shop/files/Coral-Black-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Coral-Black-1.jpg",
                "imgSrcF": "/cdn/shop/files/Coral-Black-3.jpg",
                "title": "Coral / Black"
            },
            {
                "term_id": 63175,
                "gallery": [
                    63000,
                    62999,
                    62993,
                    62998,
                    62997,
                    62996,
                    62995,
                    62994
                ],
                "imgSrc": "/cdn/shop/files/Chanel-Style-Cherry-Wood-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Chanel-Style-Cherry-Wood-8.jpg",
                "imgSrcF": "/cdn/shop/files/Chanel-Style-Cherry-Wood-1.jpg",
                "title": "Chanel Style / Wood"
            },
            {
                "term_id": 63176,
                "gallery": [
                    62992,
                    62991,
                    62985,
                    62989,
                    62990,
                    62988,
                    62987,
                    62986
                ],
                "imgSrc": "/cdn/shop/files/Chanel-Style-Black-Mahogany-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Chanel-Style-Black-Mahogany-8.jpg",
                "imgSrcF": "/cdn/shop/files/Chanel-Style-Black-Mahogany-1.jpg",
                "title": "Chanel Style / Black"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Extra 10%",
            "Fixed Size",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Summer Collection",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Sweater-wood-8-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Sweater-wood-1-500x500.jpg",
        "subheading": "Yarn Wooden Curtain Wall Hook",
        "Fabrics": [
            "Sweater"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 135,
        "newPrice": 115,
        "extra": "Extra 10%"
    },
    {
        "id": 35519,
        "title": "Simple Modern Curtain TieBack",
        "ProductUrl": "/tiebacks/simple-and-modern-curtain-tie-backs-1-piece/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "35540",
        "_fabric_color": [
            {
                "term_id": 35552,
                "gallery": [
                    35534,
                    35560,
                    35556,
                    35557,
                    35559,
                    35554,
                    35558
                ],
                "imgSrc": "/cdn/shop/files/TB2H6L2q29TBuNjy0FcXXbeiFXa___2014305272-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/TB2H6L2q29TBuNjy0FcXXbeiFXa___2014305272.jpg",
                "imgSrcF": "/cdn/shop/files/TB2H6L2q29TBuNjy0FcXXbeiFXa___2014305272.jpg",
                "title": "Modern / Brown",
                "color": "Gold"
            },
            {
                "term_id": 35550,
                "gallery": [
                    35537,
                    35560,
                    35556,
                    35557,
                    35559,
                    35554,
                    35558
                ],
                "imgSrc": "/cdn/shop/files/TB2s..FaMZC2uNjSZFnXXaxZpXa___2014305272-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/TB2s..FaMZC2uNjSZFnXXaxZpXa___2014305272.jpg",
                "imgSrcF": "/cdn/shop/files/TB2s..FaMZC2uNjSZFnXXaxZpXa___2014305272.jpg",
                "title": "Modern / Sky Blue",
                "color": "Gold"
            },
            {
                "term_id": 35547,
                "gallery": [
                    35535,
                    35560,
                    35556,
                    35557,
                    35559,
                    35554,
                    35558
                ],
                "imgSrc": "/cdn/shop/files/TB2KmSViOCYBuNkHFCcXXcHtVXa___2014305272-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/TB2KmSViOCYBuNkHFCcXXcHtVXa___2014305272.jpg",
                "imgSrcF": "/cdn/shop/files/TB2KmSViOCYBuNkHFCcXXcHtVXa___2014305272.jpg",
                "title": "Modern / White",
                "color": "Gold"
            },
            {
                "term_id": 35544,
                "gallery": [
                    35539,
                    35560,
                    35556,
                    35557,
                    35559,
                    35554,
                    35558
                ],
                "imgSrc": "/cdn/shop/files/TB2zTdcrhGYBuNjy0FnXXX5lpXa___2014305272-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/TB2zTdcrhGYBuNjy0FnXXX5lpXa___2014305272.jpg",
                "imgSrcF": "/cdn/shop/files/TB2zTdcrhGYBuNjy0FnXXX5lpXa___2014305272.jpg",
                "title": "Modern / Black",
                "color": "Gold"
            },
            {
                "term_id": 35542,
                "gallery": [
                    35533,
                    35560,
                    35556,
                    35557,
                    35559,
                    35554,
                    35558
                ],
                "imgSrc": "/cdn/shop/files/TB2_XAJfAomBKNjSZFqXXXtqVXa___2014305272-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/TB2_XAJfAomBKNjSZFqXXXtqVXa___2014305272.jpg",
                "imgSrcF": "/cdn/shop/files/TB2_XAJfAomBKNjSZFqXXXtqVXa___2014305272.jpg",
                "title": "Modern / Silver",
                "color": "Gold"
            },
            {
                "term_id": 35540,
                "gallery": [
                    35536,
                    35560,
                    35556,
                    35557,
                    35559,
                    35554,
                    35558
                ],
                "imgSrc": "/cdn/shop/files/TB2ppMwfyMnBKNjSZFoXXbOSFXa___2014305272-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/TB2ppMwfyMnBKNjSZFoXXbOSFXa___2014305272.jpg",
                "imgSrcF": "/cdn/shop/files/TB2ppMwfyMnBKNjSZFoXXbOSFXa___2014305272.jpg",
                "title": "Modern / Gold",
                "color": "Gold"
            },
            {
                "term_id": 35528,
                "gallery": [
                    35532,
                    35560,
                    35556,
                    35557,
                    35559,
                    35554,
                    35558
                ],
                "imgSrc": "/cdn/shop/files/Simpleandmoderncurtainstraps_creativecurtain_1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Simpleandmoderncurtainstraps_creativecurtain_1.jpg",
                "imgSrcF": "/cdn/shop/files/Simpleandmoderncurtainstraps_creativecurtain_1.jpg",
                "title": "Modern / Pink",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories",
            "All Accessories",
            "All Curtain Accessories",
            "Factory products",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "Search tieback",
            "Tiebacks"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "Description\r\n\r\nHigh Quality:  The product is made of high-quality non-woven fabric, soft and comfortable, not easy to fall, easy to clean, and reusable.\r\n\r\nWidely used:  These cute cartoon curtain buttons can be used in many situations. They are one of the essential holiday decorations in your home, suitable for bedrooms, bathrooms, kitchens, offices, etc.",
        "imgSrc": "/cdn/shop/files/3-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Beige-02-500x500.jpg",
        "subheading": "Modern Curtain Holdback",
        "Fabrics": [
            "Simple"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor",
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 74,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 63530,
        "title": "Minimal Beech Wood Curtain Rod",
        "ProductUrl": "/curtain-rod/beech-minimal-curtain-rod/?fwidth=40&flength=40",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63450",
        "_fabric_color": [
            {
                "term_id": 63450,
                "gallery": [
                    63313,
                    63312,
                    63318,
                    63317,
                    63314,
                    63316,
                    63315
                ],
                "imgSrc": "/cdn/shop/files/Beech-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Beech-1.jpg",
                "imgSrcF": "/cdn/shop/files/Beech-1.jpg",
                "title": "Beech"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 63465,
                "gallery": null,
                "price": 0,
                "title": "7 Brass Rings"
            },
            {
                "term_id": 63467,
                "gallery": null,
                "price": 0,
                "title": "14 Brass Rings"
            },
            {
                "term_id": 63466,
                "gallery": null,
                "price": 0,
                "title": "21 Brass Rings"
            },
            {
                "term_id": 63454,
                "gallery": null,
                "price": 0,
                "title": "39.37\""
            },
            {
                "term_id": 63453,
                "gallery": null,
                "price": 0,
                "title": "47.24\""
            },
            {
                "term_id": 63463,
                "gallery": null,
                "price": 0,
                "title": "51.18\""
            },
            {
                "term_id": 63464,
                "gallery": null,
                "price": 0,
                "title": "55.11\""
            },
            {
                "term_id": 63461,
                "gallery": null,
                "price": 0,
                "title": "59.05\""
            },
            {
                "term_id": 63462,
                "gallery": null,
                "price": 0,
                "title": "62.99\""
            },
            {
                "term_id": 63459,
                "gallery": null,
                "price": 0,
                "title": "70.86\""
            },
            {
                "term_id": 63460,
                "gallery": null,
                "price": 0,
                "title": "78.74\""
            },
            {
                "term_id": 63457,
                "gallery": null,
                "price": 0,
                "title": "82.67\""
            },
            {
                "term_id": 63458,
                "gallery": null,
                "price": 0,
                "title": "86.61\""
            },
            {
                "term_id": 63455,
                "gallery": null,
                "price": 0,
                "title": "90.55\""
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Fixed Size",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search Rod",
            "Summer Collection",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Beech-4-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Beech-5-500x500.jpg",
        "subheading": "Beech Wood Curtain Rod",
        "Fabrics": [
            "Minimal"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 135,
        "newPrice": 72,
        "extra": "Extra 10%"
    },
    {
        "id": 63210,
        "title": "Modern Curtain Wall Hook",
        "ProductUrl": "/wallhook/classic-curtain-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63212",
        "_fabric_color": [
            {
                "term_id": 63211,
                "gallery": [
                    62922,
                    62923,
                    62928,
                    62930,
                    62929,
                    62927,
                    62926,
                    62925,
                    62924
                ],
                "imgSrc": "/cdn/shop/files/black-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/black-1.jpg",
                "imgSrcF": "/cdn/shop/files/black-7.jpg",
                "title": "Black"
            },
            {
                "term_id": 63212,
                "gallery": [
                    63076,
                    62935,
                    63075,
                    62930,
                    62929,
                    62934,
                    62931,
                    62933,
                    62932
                ],
                "imgSrc": "/cdn/shop/files/2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/2.png",
                "imgSrcF": "/cdn/shop/files/Gold-3.jpg",
                "title": "Gold"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/black-9-500x500.jpg",
        "hoverImg": "",
        "subheading": "Curtain Wall Hook",
        "Fabrics": [
            "Modern"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 105,
        "newPrice": 102,
        "extra": "Extra 10%"
    },
    {
        "id": 63532,
        "title": "Springed Round Snap Curtain Tieback",
        "ProductUrl": "/tieback/springed-round-tieback/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63542",
        "_fabric_color": [
            {
                "term_id": 63542,
                "gallery": [
                    63137,
                    63138,
                    63132,
                    63131,
                    63135,
                    63134,
                    63136,
                    63133
                ],
                "imgSrc": "/cdn/shop/files/Sliver-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Sliver-1.jpg",
                "imgSrcF": "/cdn/shop/files/Sliver-7.jpg",
                "title": "Silver"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Extra 10%",
            "Fixed Size",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "No Sale Coupons",
            "Outsourced products",
            "Sale",
            "Search tieback",
            "Tiebacks"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Sliver-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Sliver-3-500x500.jpg",
        "subheading": "Round Snap Curtain Tieback",
        "Fabrics": [
            "Springed"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 85,
        "newPrice": 72,
        "extra": "Extra 10%"
    },
    {
        "id": 63169,
        "title": "Umbrella Engraved Curtain Wall Hook",
        "ProductUrl": "/wallhook/umbrella-engraved-curtain-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63191",
        "_fabric_color": [
            {
                "term_id": 63191,
                "gallery": [
                    63130,
                    63129,
                    63124,
                    63125,
                    63127,
                    63126,
                    63128
                ],
                "imgSrc": "/cdn/shop/files/Gold-7-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Gold-7.jpg",
                "imgSrcF": "/cdn/shop/files/Gold-1-1.jpg",
                "title": "Gold"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Gold-7-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Gold-2-1-500x500.jpg",
        "subheading": "Engraved Curtain Wall Hook",
        "Fabrics": [
            "Umbrella"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 115,
        "newPrice": 98,
        "extra": "Extra 10%"
    },
    {
        "id": 35586,
        "title": "Hanging Ball Curtain Tieback",
        "ProductUrl": "/tiebacks/curtain-tie-back-hook-buckle-straps-tied-curtain-rope-hanging-ball-1-pieces/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "35615",
        "_fabric_color": [
            {
                "term_id": 35633,
                "gallery": [
                    35592,
                    35607,
                    35612,
                    35611,
                    35610,
                    35609
                ],
                "imgSrc": "/cdn/shop/files/SKU-06-Rosa-Dos-paquetes-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-06-Rosa-Dos-paquetes.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-06-Rosa-Dos-paquetes.jpg",
                "title": "Ball / Pink",
                "color": "Green"
            },
            {
                "term_id": 35631,
                "gallery": [
                    35595,
                    35605,
                    35612,
                    35611,
                    35610,
                    35609
                ],
                "imgSrc": "/cdn/shop/files/SKU-09-Gray-Blue-Two-Packs-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-09-Gray-Blue-Two-Packs.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-09-Gray-Blue-Two-Packs.jpg",
                "title": "Ball / Litter Blue",
                "color": "Green"
            },
            {
                "term_id": 35629,
                "gallery": [
                    35587,
                    35604,
                    35612,
                    35611,
                    35610,
                    35609
                ],
                "imgSrc": "/cdn/shop/files/SKU-01-Marron-Dos-Paquetes-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-01-Marron-Dos-Paquetes.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-01-Marron-Dos-Paquetes.jpg",
                "title": "Ball / Brown",
                "color": "Green"
            },
            {
                "term_id": 35627,
                "gallery": [
                    35593,
                    35603,
                    35612,
                    35611,
                    35610,
                    35609
                ],
                "imgSrc": "/cdn/shop/files/SKU-07-Date-Red-Two-Packs-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-07-Date-Red-Two-Packs.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-07-Date-Red-Two-Packs.jpg",
                "title": "Ball / Red",
                "color": "Green"
            },
            {
                "term_id": 35625,
                "gallery": [
                    35594,
                    35601,
                    35612,
                    35611,
                    35610,
                    35609
                ],
                "imgSrc": "/cdn/shop/files/SKU-08-Dark-Purple-Two-Packs-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-08-Dark-Purple-Two-Packs.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-08-Dark-Purple-Two-Packs.jpg",
                "title": "Ball / Purple",
                "color": "Green"
            },
            {
                "term_id": 35623,
                "gallery": [
                    35596,
                    35599,
                    35612,
                    35611,
                    35610,
                    35609
                ],
                "imgSrc": "/cdn/shop/files/SKU-10-Verde-Dos-Paquetes-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-10-Verde-Dos-Paquetes.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-10-Verde-Dos-Paquetes.jpg",
                "title": "Ball / Green",
                "color": "Green"
            },
            {
                "term_id": 35619,
                "gallery": [
                    35588,
                    35606,
                    35612,
                    35611,
                    35610,
                    35609
                ],
                "imgSrc": "/cdn/shop/files/SKU-02-Beige-Dos-Paquetes-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-02-Beige-Dos-Paquetes.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-02-Beige-Dos-Paquetes.jpg",
                "title": "Ball / Khaki",
                "color": "Green"
            },
            {
                "term_id": 35617,
                "gallery": [
                    35597,
                    35602,
                    35612,
                    35611,
                    35610,
                    35609
                ],
                "imgSrc": "/cdn/shop/files/SKU-11-Gris-Dos-paquetes-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-11-Gris-Dos-paquetes.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-11-Gris-Dos-paquetes.jpg",
                "title": "Ball / Grey",
                "color": "Green"
            },
            {
                "term_id": 35615,
                "gallery": [
                    35590,
                    35600,
                    35612,
                    35611,
                    35610,
                    35609
                ],
                "imgSrc": "/cdn/shop/files/SKU-04-Color-vino-arroz-dos-paquetes-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-04-Color-vino-arroz-dos-paquetes.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-04-Color-vino-arroz-dos-paquetes.jpg",
                "title": "Ball / Orange",
                "color": "Green"
            },
            {
                "term_id": 35613,
                "gallery": [
                    35591,
                    35608,
                    35612,
                    35611,
                    35610,
                    35609
                ],
                "imgSrc": "/cdn/shop/files/SKU-05-Royal-Blue-Two-Packs-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-05-Royal-Blue-Two-Packs.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-05-Royal-Blue-Two-Packs.jpg",
                "title": "Ball / Royal Blue",
                "color": "Green"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories",
            "All Accessories",
            "All Curtain Accessories",
            "Black Friday",
            "Cyber Monday",
            "Factory products",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "Search tieback",
            "Tiebacks"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "<p class=\"feat_txt\">High Quality:  The product is made of high-quality non-woven fabric, soft and comfortable, not easy to fall, easy to clean, and reusable.</p>\r\n<p class=\"feat_txt\">Widely used:  These cute cartoon curtain buttons can be used in many situations. They are one of the essential holiday decorations in your home, suitable for bedrooms, bathrooms, kitchens, offices, etc.</p>",
        "imgSrc": "/cdn/shop/files/SKU-04-Color-vino-arroz-dos-paquetes-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Hoja-verde-y-blanco-06-500x500.jpg",
        "subheading": "Curtain Tieback",
        "Fabrics": [
            "Hanging Ball"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor",
            "Outdoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 70,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 63452,
        "title": "Minimal Wooden Curtain Rod",
        "ProductUrl": "/curtain-rod/wooden-minimal-curtain-rod/?fwidth=40&flength=40",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63451",
        "_fabric_color": [
            {
                "term_id": 63451,
                "gallery": [
                    63325,
                    63323,
                    63322,
                    63321,
                    63324,
                    63320,
                    63319
                ],
                "imgSrc": "/cdn/shop/files/black-walnut-7-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/black-walnut-7.jpg",
                "imgSrcF": "/cdn/shop/files/black-walnut-1.jpg",
                "title": "Black Walnut"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 63465,
                "gallery": null,
                "price": 0,
                "title": "7 Brass Rings"
            },
            {
                "term_id": 63467,
                "gallery": null,
                "price": 0,
                "title": "14 Brass Rings"
            },
            {
                "term_id": 63466,
                "gallery": null,
                "price": 0,
                "title": "21 Brass Rings"
            },
            {
                "term_id": 63454,
                "gallery": null,
                "price": 0,
                "title": "39.37\""
            },
            {
                "term_id": 63453,
                "gallery": null,
                "price": 0,
                "title": "47.24\""
            },
            {
                "term_id": 63463,
                "gallery": null,
                "price": 0,
                "title": "51.18\""
            },
            {
                "term_id": 63464,
                "gallery": null,
                "price": 0,
                "title": "55.11\""
            },
            {
                "term_id": 63461,
                "gallery": null,
                "price": 0,
                "title": "59.05\""
            },
            {
                "term_id": 63462,
                "gallery": null,
                "price": 0,
                "title": "62.99\""
            },
            {
                "term_id": 63459,
                "gallery": null,
                "price": 0,
                "title": "70.86\""
            },
            {
                "term_id": 63460,
                "gallery": null,
                "price": 0,
                "title": "78.74\""
            },
            {
                "term_id": 63457,
                "gallery": null,
                "price": 0,
                "title": "82.67\""
            },
            {
                "term_id": 63458,
                "gallery": null,
                "price": 0,
                "title": "86.61\""
            },
            {
                "term_id": 63455,
                "gallery": null,
                "price": 0,
                "title": "90.55\""
            },
            {
                "term_id": 63456,
                "gallery": null,
                "price": 0,
                "title": "94.48\""
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Fixed Size",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Search Rod",
            "Summer Collection",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/black-walnut-6-500x500.jpg",
        "hoverImg": "/cdn/shop/files/black-walnut-3-500x500.jpg",
        "subheading": "Wooden Curtain Rod",
        "Fabrics": [
            "Minimal"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 175,
        "newPrice": 149,
        "extra": "Extra 10%"
    },
    {
        "id": 63441,
        "title": "Bird Metal Curtain Wall Hook",
        "ProductUrl": "/wallhook/bird-curtain-holdback-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63219",
        "_fabric_color": [
            {
                "term_id": 63219,
                "gallery": [
                    62852,
                    62851,
                    62856,
                    62855,
                    62854,
                    62853,
                    62857
                ],
                "imgSrc": "/cdn/shop/files/bird-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/bird-2.jpg",
                "imgSrcF": "/cdn/shop/files/bird-6.jpg",
                "title": "Bird"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/bird-2-500x500.jpg",
        "hoverImg": "",
        "subheading": "Metal Curtain Wall Hook",
        "Fabrics": [
            "Bird"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 120,
        "newPrice": 102,
        "extra": "Extra 10%"
    },
    {
        "id": 35412,
        "title": "Woven Ball Curtain Tieback",
        "ProductUrl": "/tiebacks/woven-ball-curtain-tie-backs-1-piece/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "35419",
        "_fabric_color": [
            {
                "term_id": 35419,
                "gallery": [
                    35418,
                    35415,
                    35479,
                    35477,
                    35482,
                    35480,
                    35481,
                    35478
                ],
                "imgSrc": "/cdn/shop/files/19_3e123bbd-9193-46c0-8da5-c4e1b89be674-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/19_3e123bbd-9193-46c0-8da5-c4e1b89be674.jpg",
                "imgSrcF": "/cdn/shop/files/19_3e123bbd-9193-46c0-8da5-c4e1b89be674.jpg",
                "title": "Ball / Beige White",
                "color": "Gold"
            },
            {
                "term_id": 35466,
                "gallery": [
                    35468,
                    35483,
                    35479,
                    35477,
                    35482,
                    35480,
                    35481,
                    35478
                ],
                "imgSrc": "/cdn/shop/files/SKU-14-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-14.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-14.jpg",
                "title": "Ball / Green",
                "color": "Gold"
            },
            {
                "term_id": 35462,
                "gallery": [
                    35464,
                    35484,
                    35479,
                    35477,
                    35482,
                    35480,
                    35481,
                    35478
                ],
                "imgSrc": "/cdn/shop/files/16_52115f25-55d4-4534-9cf8-3d82def52420-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/16_52115f25-55d4-4534-9cf8-3d82def52420.jpg",
                "imgSrcF": "/cdn/shop/files/16_52115f25-55d4-4534-9cf8-3d82def52420.jpg",
                "title": "Ball / Fluorescence green",
                "color": "Gold"
            },
            {
                "term_id": 35442,
                "gallery": [
                    35444,
                    35485,
                    35479,
                    35477,
                    35482,
                    35480,
                    35481,
                    35478
                ],
                "imgSrc": "/cdn/shop/files/SKU-01-Red-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-01-Red.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-01-Red.jpg",
                "title": "Ball / Red",
                "color": "Gold"
            },
            {
                "term_id": 35439,
                "gallery": [
                    35441,
                    35488,
                    35479,
                    35477,
                    35482,
                    35480,
                    35481,
                    35478
                ],
                "imgSrc": "/cdn/shop/files/04_931a96d0-6152-4d2e-94b1-d4d0eed24477-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/04_931a96d0-6152-4d2e-94b1-d4d0eed24477.jpg",
                "imgSrcF": "/cdn/shop/files/04_931a96d0-6152-4d2e-94b1-d4d0eed24477.jpg",
                "title": "Ball / Yellow",
                "color": "Gold"
            },
            {
                "term_id": 35436,
                "gallery": [
                    35438,
                    35489,
                    35479,
                    35477,
                    35482,
                    35480,
                    35481,
                    35478
                ],
                "imgSrc": "/cdn/shop/files/21_51b9b69b-a274-40f7-b294-f3d28aaa4fcb-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/21_51b9b69b-a274-40f7-b294-f3d28aaa4fcb.jpg",
                "imgSrcF": "/cdn/shop/files/21_51b9b69b-a274-40f7-b294-f3d28aaa4fcb.jpg",
                "title": "Ball / Pink",
                "color": "Gold"
            },
            {
                "term_id": 35433,
                "gallery": [
                    35435,
                    35490,
                    35479,
                    35477,
                    35482,
                    35480,
                    35481,
                    35478
                ],
                "imgSrc": "/cdn/shop/files/24_542a872c-10c3-457f-870b-7f333115b958-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/24_542a872c-10c3-457f-870b-7f333115b958.jpg",
                "imgSrcF": "/cdn/shop/files/24_542a872c-10c3-457f-870b-7f333115b958.jpg",
                "title": "Ball / Blue",
                "color": "Gold"
            },
            {
                "term_id": 35430,
                "gallery": [
                    35432,
                    35491,
                    35479,
                    35477,
                    35482,
                    35480,
                    35481,
                    35478
                ],
                "imgSrc": "/cdn/shop/files/17_776119b4-de57-4d87-b214-be5397626cb5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/17_776119b4-de57-4d87-b214-be5397626cb5.jpg",
                "imgSrcF": "/cdn/shop/files/17_776119b4-de57-4d87-b214-be5397626cb5.jpg",
                "title": "Ball / Purple",
                "color": "Gold"
            },
            {
                "term_id": 35469,
                "gallery": [
                    35473,
                    35492,
                    35479,
                    35477,
                    35482,
                    35480,
                    35481,
                    35478
                ],
                "imgSrc": "/cdn/shop/files/19_ba83aef1-c35b-4184-b455-6cdac6993602_720x-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/19_ba83aef1-c35b-4184-b455-6cdac6993602_720x.jpg",
                "imgSrcF": "/cdn/shop/files/19_ba83aef1-c35b-4184-b455-6cdac6993602_720x.jpg",
                "title": "Ball / Orange",
                "color": "Gold"
            },
            {
                "term_id": 35427,
                "gallery": [
                    35429,
                    35493,
                    35479,
                    35477,
                    35482,
                    35480,
                    35481,
                    35478
                ],
                "imgSrc": "/cdn/shop/files/05-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/05.jpg",
                "imgSrcF": "/cdn/shop/files/05.jpg",
                "title": "Ball / Grey",
                "color": "Gold"
            },
            {
                "term_id": 35424,
                "gallery": [
                    35426,
                    35494,
                    35479,
                    35477,
                    35482,
                    35480,
                    35481,
                    35478
                ],
                "imgSrc": "/cdn/shop/files/13_76222b38-ad77-4f87-a3ac-27bc1ba856c4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/13_76222b38-ad77-4f87-a3ac-27bc1ba856c4.jpg",
                "imgSrcF": "/cdn/shop/files/13_76222b38-ad77-4f87-a3ac-27bc1ba856c4.jpg",
                "title": "Ball / Dark Blue",
                "color": "Gold"
            },
            {
                "term_id": 35421,
                "gallery": [
                    35423,
                    35495,
                    35479,
                    35477,
                    35482,
                    35480,
                    35481,
                    35478
                ],
                "imgSrc": "/cdn/shop/files/10_f29b9576-cf0b-4a0a-906d-91363e21dfe2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/10_f29b9576-cf0b-4a0a-906d-91363e21dfe2.jpg",
                "imgSrcF": "/cdn/shop/files/10_f29b9576-cf0b-4a0a-906d-91363e21dfe2.jpg",
                "title": "Ball / Brown",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 35413,
                "gallery": null,
                "price": 0,
                "title": "Single Ball 25Inch"
            },
            {
                "term_id": 35416,
                "gallery": null,
                "price": 0,
                "title": "Double Ball 52Inch"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories",
            "All Accessories",
            "All Curtain Accessories",
            "Easter Sale",
            "Factory products",
            "Fixed Size",
            "Independence Day",
            "New Product UI",
            "new rod UI",
            "Search tieback",
            "Tiebacks"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "<h3 style=\"font-size: 24px;\">Description</h3>\r\n<p class=\"feat_txt\">High Quality:  The product is made of high-quality non-woven fabric, soft and comfortable, not easy to fall, easy to clean, and reusable.</p>\r\n<p class=\"feat_txt\">Widely used:  These cute cartoon curtain buttons can be used in many situations. They are one of the essential holiday decorations in your home, suitable for bedrooms, bathrooms, kitchens, offices, etc.</p>",
        "imgSrc": "/cdn/shop/files/2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/22-500x500.jpg",
        "subheading": "Curtain Tieback",
        "Fabrics": [
            "Woven Ball"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor",
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 91,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 63549,
        "title": "Black Roman Square Custom Finials Curtain Rods",
        "ProductUrl": "/custom-curtain-rods/custom-black-roman-square-finial-curtain-rod-with-ball-finials/?fwidth=40&flength=40fwidth=40&flength=40",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63241",
        "_fabric_color": [
            {
                "term_id": 63241,
                "gallery": [
                    63254,
                    63252,
                    63251,
                    63250,
                    63255,
                    63256,
                    63253
                ],
                "imgSrc": "/cdn/shop/files/Black-7-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-7-2.jpg",
                "imgSrcF": "/cdn/shop/files/Black-1-2.jpg",
                "title": "Black"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Custom Curtain Rod",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search Rod",
            "Summer Collection",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Black-6-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Black-5-2-500x500.jpg",
        "subheading": "Custom Finials Curtain Rods",
        "Fabrics": [
            "Black Roman Square"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 123,
        "newPrice": 105
    },
    {
        "id": 63343,
        "title": "Coral Yarn Wooden Curtain Wall Hook",
        "ProductUrl": "/wallhook/coral-botton-yarn-wooden-curtain-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63178",
        "_fabric_color": [
            {
                "term_id": 63178,
                "gallery": [
                    63189,
                    63190,
                    63009,
                    63187,
                    63188,
                    63186,
                    63185,
                    63184,
                    63183
                ],
                "imgSrc": "/cdn/shop/files/Coral-Wood-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Coral-Wood-8.jpg",
                "imgSrcF": "/cdn/shop/files/Coral-Wood-1.jpg",
                "title": "Coral / Wood"
            },
            {
                "term_id": 63179,
                "gallery": [
                    63001,
                    63002,
                    63003,
                    63006,
                    63008,
                    63007,
                    63005,
                    63004
                ],
                "imgSrc": "/cdn/shop/files/Coral-Black-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Coral-Black-1.jpg",
                "imgSrcF": "/cdn/shop/files/Coral-Black-3.jpg",
                "title": "Coral / Black"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Coral-Wood-8-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Coral-Wood-1-500x500.jpg",
        "subheading": "Yarn Wooden Curtain Wall Hook",
        "Fabrics": [
            "Coral"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 135,
        "newPrice": 115,
        "extra": "Extra 10%"
    },
    {
        "id": 35411,
        "title": "Macrame Tassel Curtain Tieback",
        "ProductUrl": "/tiebacks/macrame-tassels-curtain-tiebacks-clips-1-piece/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "35503",
        "_fabric_color": [
            {
                "term_id": 35503,
                "gallery": [
                    35506,
                    35508,
                    35507,
                    35510,
                    35509
                ],
                "imgSrc": "/cdn/shop/files/size-tassel-06-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/size-tassel-06.jpg",
                "imgSrcF": "/cdn/shop/files/size-tassel-06.jpg",
                "title": "Tassels / A",
                "color": "Gold"
            },
            {
                "term_id": 35511,
                "gallery": [
                    35514,
                    35508,
                    35507,
                    35510,
                    35509
                ],
                "imgSrc": "/cdn/shop/files/SKU-02-m0809-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-02-m0809.jpg",
                "imgSrcF": "/cdn/shop/files/SKU-02-m0809.jpg",
                "title": "Tassels / B",
                "color": "Gold"
            },
            {
                "term_id": 35516,
                "gallery": [
                    35515,
                    35508,
                    35507,
                    35510,
                    35509
                ],
                "imgSrc": "/cdn/shop/files/size-tassel-07-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/size-tassel-07.jpg",
                "imgSrcF": "/cdn/shop/files/size-tassel-07.jpg",
                "title": "Tassels / C",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories",
            "All Accessories",
            "All Curtain Accessories",
            "Factory products",
            "Fixed Size",
            "flash_categories",
            "New Product UI",
            "new rod UI",
            "Search tieback",
            "Tiebacks"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "<p class=\"feat_txt\">High Quality:  The product is made of high-quality non-woven fabric, soft and comfortable, not easy to fall, easy to clean, and reusable.</p>\r\n<p class=\"feat_txt\">Widely used:  These cute cartoon curtain buttons can be used in many situations. They are one of the essential holiday decorations in your home, suitable for bedrooms, bathrooms, kitchens, offices, etc.</p>",
        "imgSrc": "/cdn/shop/files/1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/size-tassel-11-500x500.jpg",
        "subheading": "Tassel Curtain Tieback",
        "Fabrics": [
            "Macrame"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor",
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 76,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 103082,
        "title": "Heavy Duty Metal Curtain Track with Magnetic Closing",
        "ProductUrl": "/heavy-duty-metal-curtain-track-with-magnetic-closing/?fwidth=40&flength=40fwidth=40&flength=40",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "103117",
        "_fabric_color": [
            {
                "term_id": 103117,
                "gallery": [
                    103110,
                    103513,
                    103099,
                    103100,
                    103086,
                    103090,
                    103094,
                    103093,
                    103112,
                    103111
                ],
                "imgSrc": "/cdn/shop/files/rod-b-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/rod-b-5.jpg",
                "imgSrcF": "/cdn/shop/files/rod-b-5.jpg",
                "title": "Dark Grey"
            },
            {
                "term_id": 103115,
                "gallery": [
                    103108,
                    103089,
                    103095,
                    103098,
                    103085,
                    103091,
                    103094,
                    103093,
                    103112,
                    103111
                ],
                "imgSrc": "/cdn/shop/files/rod-b-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/rod-b-3.jpg",
                "imgSrcF": "/cdn/shop/files/rod-b-3.jpg",
                "title": "Silver Grey"
            },
            {
                "term_id": 103113,
                "gallery": [
                    103109,
                    103088,
                    103097,
                    103096,
                    103084,
                    103092,
                    103094,
                    103093,
                    103112,
                    103111
                ],
                "imgSrc": "/cdn/shop/files/rod-b-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/rod-b-4.jpg",
                "imgSrcF": "/cdn/shop/files/rod-b-4.jpg",
                "title": "White"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 103121,
                "gallery": null,
                "price": 0,
                "title": "Wall Mounted"
            },
            {
                "term_id": 103119,
                "gallery": null,
                "price": 0,
                "title": "Ceiling Mounted"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Curtain Track",
            "Custom Curtain Rod",
            "New Content",
            "New Product UI",
            "new rod UI",
            "No Sale Coupons",
            "Outsourced products",
            "Sale",
            "Search Pinch pleat",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Grey-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/10-500x500.jpg",
        "subheading": "Metal Curtain Track with Magnetic Closing",
        "Fabrics": [
            "Heavy Duty"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 120,
        "newPrice": 102
    },
    {
        "id": 103514,
        "title": "Heavy Duty Metal Custom Curtain Track",
        "ProductUrl": "/heavy-duty-metal-custom-curtain-track/?fwidth=40&flength=40fwidth=40&flength=40",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "103532",
        "_fabric_color": [
            {
                "term_id": 103536,
                "gallery": [
                    103529,
                    103527,
                    103531,
                    103530,
                    103528,
                    103515,
                    103516,
                    103538,
                    103539
                ],
                "imgSrc": "/cdn/shop/files/White-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/White-5-1.jpg",
                "title": "White"
            },
            {
                "term_id": 103534,
                "gallery": [
                    103526,
                    103524,
                    103523,
                    103520,
                    103525,
                    103515,
                    103516,
                    103538,
                    103539
                ],
                "imgSrc": "/cdn/shop/files/Dark-Grey-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Dark-Grey-4.jpg",
                "imgSrcF": "/cdn/shop/files/Dark-Grey-1.jpg",
                "title": "Dark Grey"
            },
            {
                "term_id": 103532,
                "gallery": [
                    103519,
                    103517,
                    103522,
                    103521,
                    103518,
                    103515,
                    103516,
                    103538,
                    103539
                ],
                "imgSrc": "/cdn/shop/files/Black-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/Black-6.jpg",
                "title": "Black"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 103121,
                "gallery": null,
                "price": 0,
                "title": "Wall Mounted"
            },
            {
                "term_id": 103119,
                "gallery": null,
                "price": 0,
                "title": "Ceiling Mounted"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Curtain Track",
            "Custom Curtain Rod",
            "New Content",
            "New Product UI",
            "new rod UI",
            "No Sale Coupons",
            "Outsourced products",
            "Sale",
            "Search Pinch pleat",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Dark-Grey-4-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Black-1-1-500x500.jpg",
        "subheading": "Metal Custom Curtain Track",
        "Fabrics": [
            "Heavy Duty"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 120,
        "newPrice": 102
    },
    {
        "id": 63140,
        "title": "Roman Square Custom Finials Curtain Rods",
        "ProductUrl": "/curtain-rods/custom-roman-square-finial-curtain-rod-with-ball-finials/?fwidth=40&flength=40fwidth=40&flength=40",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63239",
        "_fabric_color": [
            {
                "term_id": 63239,
                "gallery": [
                    63268,
                    63272,
                    63274,
                    63273,
                    63270,
                    63269,
                    63271
                ],
                "imgSrc": "/cdn/shop/files/Dark-Grey-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Dark-Grey-1.jpg",
                "imgSrcF": "/cdn/shop/files/Dark-Grey-3.jpg",
                "title": "Dark Grey",
                "color": "Green"
            },
            {
                "term_id": 63240,
                "gallery": [
                    63257,
                    63260,
                    63262,
                    63261,
                    63263,
                    63258,
                    63259
                ],
                "imgSrc": "/cdn/shop/files/Brown-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Brown-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Brown-1-1.jpg",
                "title": "Brown",
                "color": "Green"
            },
            {
                "term_id": 63241,
                "gallery": [
                    63254,
                    63252,
                    63251,
                    63250,
                    63255,
                    63256,
                    63253
                ],
                "imgSrc": "/cdn/shop/files/Black-7-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-7-2.jpg",
                "imgSrcF": "/cdn/shop/files/Black-1-2.jpg",
                "title": "Black",
                "color": "Green"
            },
            {
                "term_id": 63242,
                "gallery": [
                    63243,
                    63247,
                    63249,
                    63248,
                    63244,
                    63245,
                    63246
                ],
                "imgSrc": "/cdn/shop/files/White-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/White-1-1.jpg",
                "title": "White",
                "color": "Green"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Custom Curtain Rod",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search Rod",
            "Summer Collection",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Brown-3-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Dark-Grey-5-500x500.jpg",
        "subheading": "Custom Finials Curtain Rods",
        "Fabrics": [
            "Roman Square"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 123,
        "newPrice": 105,
        "extra": "Extra 10%"
    },
    {
        "id": 63342,
        "title": "Chanel Botton\tYarn Wooden Curtain Wall Hook",
        "ProductUrl": "/wallhook/chanel-style-botton-yarn-wooden-curtain-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63175",
        "_fabric_color": [
            {
                "term_id": 63175,
                "gallery": [
                    63000,
                    62999,
                    62993,
                    62998,
                    62997,
                    62996,
                    62995,
                    62994
                ],
                "imgSrc": "/cdn/shop/files/Chanel-Style-Cherry-Wood-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Chanel-Style-Cherry-Wood-8.jpg",
                "imgSrcF": "/cdn/shop/files/Chanel-Style-Cherry-Wood-1.jpg",
                "title": "Chanel Style / Wood"
            },
            {
                "term_id": 63176,
                "gallery": [
                    62992,
                    62991,
                    62985,
                    62989,
                    62990,
                    62988,
                    62987,
                    62986
                ],
                "imgSrc": "/cdn/shop/files/Chanel-Style-Black-Mahogany-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Chanel-Style-Black-Mahogany-8.jpg",
                "imgSrcF": "/cdn/shop/files/Chanel-Style-Black-Mahogany-1.jpg",
                "title": "Chanel Style / Black"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Extra 10%",
            "Fixed Size",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Chanel-Style-Cherry-Wood-8-500x500.jpg",
        "hoverImg": "",
        "subheading": "Botton Yarn Wooden Curtain Wall Hook",
        "Fabrics": [
            "Chanel Botton"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 135,
        "newPrice": 115,
        "extra": "Extra 10%"
    },
    {
        "id": 63151,
        "title": "Tassel Elegant Tassel Curtain Tieback",
        "ProductUrl": "/tiebacks/elegant-tassel-tieback/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63153",
        "_fabric_color": [
            {
                "term_id": 63152,
                "gallery": [
                    63156,
                    63155,
                    63159,
                    63158,
                    63160
                ],
                "imgSrc": "/cdn/shop/files/Dark-Blue-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Dark-Blue-2.jpg",
                "imgSrcF": "/cdn/shop/files/Dark-Blue-6.jpg",
                "title": "Dark Blue",
                "color": "Green"
            },
            {
                "term_id": 63153,
                "gallery": [
                    63060,
                    63059,
                    63058,
                    63056,
                    63057,
                    63055
                ],
                "imgSrc": "/cdn/shop/files/Beige-White-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Beige-White-1.jpg",
                "imgSrcF": "/cdn/shop/files/Beige-White-5.jpg",
                "title": "Beige White",
                "color": "Green"
            },
            {
                "term_id": 63154,
                "gallery": [
                    63049,
                    63047,
                    63048,
                    63052,
                    63051,
                    63053,
                    63054
                ],
                "imgSrc": "/cdn/shop/files/Grey-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-3.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-5.jpg",
                "title": "Grey",
                "color": "Green"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Extra 10%",
            "Fixed Size",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Search tieback",
            "Summer Collection",
            "Tiebacks"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Beige-White-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Beige-White-6-500x500.jpg",
        "subheading": "Elegant Tassel Curtain Tieback",
        "Fabrics": [
            "Tassel"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 145,
        "newPrice": 123,
        "extra": "Extra 10%"
    },
    {
        "id": 53985,
        "title": "Hanging Rings Curtain Rod Eyelet Rings 10pcs",
        "ProductUrl": "/accessories/10pcs-curtain-hanging-rings-with-eyelet-rings/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "54134",
        "_fabric_color": [
            {
                "term_id": 54134,
                "gallery": [
                    54032,
                    54037,
                    54035,
                    54031,
                    54036,
                    54034,
                    54033,
                    54038
                ],
                "imgSrc": "/cdn/shop/files/Silver-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-1.jpg",
                "imgSrcF": "/cdn/shop/files/Silver-1-1.jpg",
                "title": "Silver",
                "color": "Green"
            },
            {
                "term_id": 105426,
                "gallery": [
                    105415,
                    105414,
                    105417,
                    105416
                ],
                "imgSrc": "/cdn/shop/files/Gold-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Gold-2.jpg",
                "imgSrcF": "/cdn/shop/files/Gold-1.jpg",
                "title": "Gold",
                "color": "Green"
            },
            {
                "term_id": 105424,
                "gallery": [
                    105411,
                    105410,
                    105413,
                    105412
                ],
                "imgSrc": "/cdn/shop/files/Black-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-2.jpg",
                "imgSrcF": "/cdn/shop/files/Black-1.jpg",
                "title": "Black",
                "color": "Green"
            },
            {
                "term_id": 105422,
                "gallery": [
                    105419,
                    105418,
                    105421,
                    105420
                ],
                "imgSrc": "/cdn/shop/files/Whtie-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Whtie-2.jpg",
                "imgSrcF": "/cdn/shop/files/Whtie-1.jpg",
                "title": "White",
                "color": "Green"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 99988,
                "gallery": null,
                "price": 0,
                "title": "Diameter 1 inch"
            },
            {
                "term_id": 99990,
                "gallery": null,
                "price": 0,
                "title": "Diameter 1.5 inches"
            },
            {
                "term_id": 99992,
                "gallery": null,
                "price": 0,
                "title": "Diameter 1.8 inches"
            },
            {
                "term_id": 99994,
                "gallery": null,
                "price": 0,
                "title": "Diameter 2.2 inches"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtains Hooks Rings",
            "Fixed Size",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Search Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "curtain-rings",
                "name": "curtain rings"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "sun-shade-sails",
                "name": "Sun Shade Sails"
            }
        ],
        "short_description": "Our 10-piece curtain ring set offers the perfect blend of durability and style, making it ideal for a wide range of curtain types. Whether you're working with thick, heavy drapes or lightweight sheers, these metal rings are designed to securely hold and suspend your curtains, ensuring they stay perfectly in place.\r\n\r\n<strong>Package Includes:</strong>\r\n<ul>\r\n \t<li>1 Pack of 10 durable metal curtain rings.</li>\r\n</ul>\r\n<strong>Versatility and Compatibility:</strong> These curtain rings are suitable for most curtains, from heavy blackout curtains to lighter, airy fabrics. The built-in clips are designed to grip your curtains tightly without causing damage, ensuring they remain securely attached, no matter their weight or material.\r\n\r\n<strong>Size Options:</strong> To accommodate various curtain rods, these rings are available in four different diameters:\r\n<ul>\r\n \t<li>1 inch</li>\r\n \t<li>1.5 inches</li>\r\n \t<li>1.8 inches</li>\r\n \t<li>2.2 inches</li>\r\n</ul>\r\nPlease confirm the appropriate size before purchasing to ensure a perfect fit.\r\n\r\n<strong>Durable Construction:</strong> Crafted from high-quality metal, these curtain rings are strong enough to bear the weight of even the heaviest curtains. The rings are meticulously polished to a smooth finish, eliminating any burrs that could snag or damage your curtains during use. This ensures a smooth and effortless glide across the rod, making it easy to open and close your curtains.\r\n\r\n<strong>Wide Range of Applications:</strong> Available in both black and silver, these curtain rings are versatile enough to complement a variety of curtain colors and styles. Whether you're updating your living room, bedroom, or bathroom, these rings are the perfect accessory to enhance your space.\r\n\r\n<strong>Exquisite Workmanship:</strong> The high-quality metal construction and polished finish not only add to the durability but also lend an elegant touch to your curtain setup. These rings are as functional as they are stylish, providing a reliable solution for hanging curtains in any room of your home.",
        "imgSrc": "/cdn/shop/files/Silver-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Silver-4-500x500.jpg",
        "subheading": "Curtain Rod Eyelet Rings",
        "Fabrics": [
            "Hanging Rings"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 69,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 53984,
        "title": "Clip Hooks Rustproof Metal Clip Hooks",
        "ProductUrl": "/accessories/10-pcs-rustproof-metal-hook-clips-for-curtain-rods/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "54115",
        "_fabric_color": [
            {
                "term_id": 54126,
                "gallery": [
                    54051,
                    54041,
                    54042,
                    54046
                ],
                "imgSrc": "/cdn/shop/files/SILVER-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SILVER.jpg",
                "imgSrcF": "/cdn/shop/files/SILVER-10.jpg",
                "title": "Silver",
                "color": "Green"
            },
            {
                "term_id": 54124,
                "gallery": [
                    54050,
                    54042,
                    54041,
                    54046
                ],
                "imgSrc": "/cdn/shop/files/Matt-Silver-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Matt-Silver.jpg",
                "imgSrcF": "/cdn/shop/files/Matt-Silver-1.jpg",
                "title": "Matt Silver",
                "color": "Green"
            },
            {
                "term_id": 54123,
                "gallery": [
                    54049,
                    54042,
                    54041,
                    54046
                ],
                "imgSrc": "/cdn/shop/files/LIGHT-GOLD-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/LIGHT-GOLD.jpg",
                "imgSrcF": "/cdn/shop/files/LIGHT-GOLD-1.jpg",
                "title": "Light Gold",
                "color": "Green"
            },
            {
                "term_id": 54121,
                "gallery": [
                    54048,
                    54042,
                    54041,
                    54046
                ],
                "imgSrc": "/cdn/shop/files/KRAUT-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/KRAUT.jpg",
                "imgSrcF": "/cdn/shop/files/KRAUT-1.jpg",
                "title": "Kraut",
                "color": "Green"
            },
            {
                "term_id": 54119,
                "gallery": [
                    54044,
                    54042,
                    54041,
                    54046
                ],
                "imgSrc": "/cdn/shop/files/BRONZE-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/BRONZE.jpg",
                "imgSrcF": "/cdn/shop/files/BRONZE-1.jpg",
                "title": "Bronze",
                "color": "Green"
            },
            {
                "term_id": 54117,
                "gallery": [
                    54043,
                    54042,
                    54041,
                    54046
                ],
                "imgSrc": "/cdn/shop/files/BRONZE-RED-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/BRONZE-RED.jpg",
                "imgSrcF": "/cdn/shop/files/BRONZE-RED-1.jpg",
                "title": "Brone Red",
                "color": "Green"
            },
            {
                "term_id": 54115,
                "gallery": [
                    54040,
                    54041,
                    54042,
                    54046
                ],
                "imgSrc": "/cdn/shop/files/BLACK-2-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/BLACK-2-2.jpg",
                "imgSrcF": "/cdn/shop/files/BLACK-2-3.jpg",
                "title": "Black",
                "color": "Green"
            },
            {
                "term_id": 54111,
                "gallery": [
                    54045,
                    54041,
                    54042,
                    54047,
                    54046
                ],
                "imgSrc": "/cdn/shop/files/GOLD-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/GOLD-1.jpg",
                "imgSrcF": "/cdn/shop/files/GOLD-1-1.jpg",
                "title": "Gold",
                "color": "Green"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtains Hooks Rings",
            "Factory products",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "Search Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "header",
                "name": "header"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "<div class=\"flex_accessories\">\r\n<div class=\"spec_left\">\r\n<h3 style=\"font-size: 24px;\">Specification</h3>\r\n<p class=\"feat_txt\"><strong>Package Included:  </strong>1 Pack of 10 pieces</p>\r\n\r\n</div>\r\n<div class=\"desc_right\">\r\n\r\nA curtain ring is a small clip for suspending a curtain. They hold up curtains of all types, including shower curtains.\r\n\r\nDiameter：1.7in\r\n\r\n&nbsp;\r\n\r\n</div>\r\n</div>",
        "imgSrc": "/cdn/shop/files/SILVER-500x500.jpg",
        "hoverImg": "/cdn/shop/files/BLACK-4-500x500.jpg",
        "subheading": "Rustproof Metal Clip Hooks",
        "Fabrics": [
            "Clip Hooks"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 70,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 1175,
        "title": "Brass Adjustable Brass Curtain Rod",
        "ProductUrl": "/curtain-rod/1-inch-adjustable-antique-brass-curtain-rod-with-reeded-ball-finials-length-28-144-inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "891",
        "_fabric_color": [
            {
                "term_id": 891,
                "gallery": [
                    19936,
                    19933,
                    19938,
                    19937,
                    19934,
                    19935,
                    19939
                ],
                "imgSrc": "/cdn/shop/files/Antique-Brass-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Antique-Brass-5.jpg",
                "imgSrcF": "/cdn/shop/files/Antique-Brass-5.jpg",
                "title": "Antique Brass",
                "color": "Gold"
            },
            {
                "term_id": 898,
                "gallery": [
                    40814,
                    40812,
                    40813,
                    40811
                ],
                "imgSrc": "/cdn/shop/files/Matte-Black-4-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Matte-Black-4-4.jpg",
                "imgSrcF": "/cdn/shop/files/Matte-Black-4-3.jpg",
                "title": "Matte Black",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 599,
                "gallery": null,
                "price": 0,
                "title": "48''-86''"
            },
            {
                "term_id": 585,
                "gallery": null,
                "price": 0,
                "title": "101''-144''"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "Adjustable Curtain rod",
            "All Accessories",
            "All Curtain Accessories",
            "Black Friday",
            "Curtain Rod Categories",
            "Cyber Monday",
            "Factory products",
            "Fixed Size",
            "flash_categories",
            "Independence Day",
            "New Product UI",
            "new rod UI",
            "Search Rod",
            "Spring Time Sale",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "header",
                "name": "header"
            }
        ],
        "short_description": "<ul>\r\n \t<li>Basic Info: Sold by the single per package. 1 inch diameter adjustable aluminum alloy curtain rod which is conveniently strong enough to hold both light and heavy curtains.</li>\r\n \t<li>Dimension Options: Here are 3 sizes of the curtain rod that adjusts from 28-48, 48-86, and 72-144 inches for your choices, which are perfect for the office, bedroom, and living room.</li>\r\n \t<li>Rod Design: The curtain rod adopts round finials which are natural and simple for any space decor such as bedroom, living room, kitchen, and sliding door.</li>\r\n \t<li>Wide Compatibility: The curtain rod will be suitable with both heavy and lightweight curtains also for all different curtain tops such as grommet, rod pocket, back tab, tab top, and so on.</li>\r\n</ul>",
        "imgSrc": "/cdn/shop/files/Antique-Brass-5-600x600.jpg",
        "hoverImg": "/cdn/shop/files/Antique-Brass-1-500x500.jpg",
        "subheading": "Adjustable Brass Curtain Rod",
        "Fabrics": [
            "Brass"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 119,
        "newPrice": 107,
        "extra": "Extra 10%"
    },
    {
        "id": 1176,
        "title": "Classic Ball Adjustable Curtain Rod",
        "ProductUrl": "/curtain-rod/1-1-8-inch-adjustable-curtain-rod-with-ball-finials-length-28-144-inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "894",
        "_fabric_color": [
            {
                "term_id": 895,
                "gallery": [
                    19967,
                    19966,
                    19965,
                    19970,
                    19969,
                    19968,
                    19971,
                    19972
                ],
                "imgSrc": "/cdn/shop/files/Matte-White-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Matte-White-3.jpg",
                "imgSrcF": "/cdn/shop/files/Matte-White-3.jpg",
                "title": "Matte White",
                "color": "Gold"
            },
            {
                "term_id": 894,
                "gallery": [
                    19961,
                    19962,
                    19963,
                    19960,
                    19959,
                    19958,
                    19955,
                    19956,
                    19957,
                    19964
                ],
                "imgSrc": "/cdn/shop/files/Matte-Black-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Matte-Black-8.jpg",
                "imgSrcF": "/cdn/shop/files/Matte-Black-8.jpg",
                "title": "Matte Black",
                "color": "Gold"
            },
            {
                "term_id": 893,
                "gallery": [
                    19951,
                    19952,
                    19953,
                    19954,
                    19950
                ],
                "imgSrc": "/cdn/shop/files/Black-3-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-3-2.jpg",
                "imgSrcF": "/cdn/shop/files/Black-3-2.jpg",
                "title": null,
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": "589",
                "gallery": null,
                "price": 0,
                "title": "28''-48''"
            },
            {
                "term_id": "590",
                "gallery": null,
                "price": 0,
                "title": "48''-86''"
            },
            {
                "term_id": "582",
                "gallery": null,
                "price": 0,
                "title": "72''-144''"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "10% Off Sale",
            "Adjustable Curtain rod",
            "All Accessories",
            "All Curtain Accessories",
            "Black Friday",
            "Curtain Rod Categories",
            "Cyber Monday",
            "Extra 10%",
            "Factory products",
            "Fall Collection",
            "Fixed Size",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "header",
                "name": "header"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "thanksgiving-10",
                "name": "Thanksgiving 10%"
            }
        ],
        "short_description": "<ul>\r\n \t<li>Basic Info: Sold by the single per package. 1 1/8 inch diameter adjustable aluminum alloy curtain rod which is conveniently strong enough to hold both light and heavy curtains.</li>\r\n \t<li>Dimension Options: Here are 3 sizes of the curtain rod that adjusts from 28-48, 48-86, and 72-144 inches for your choices, which are perfect for the office, bedroom, and living room.</li>\r\n \t<li>Rod Design: The curtain rod adopts round finials which are natural and simple for any space decor such as bedroom, living room, kitchen, and sliding door.</li>\r\n \t<li>Wide Compatibility: The curtain rod will be suitable with both heavy and lightweight curtains also for all different curtain tops such as grommet, rod pocket, back tab, tab top, and so on.</li>\r\n</ul>",
        "imgSrc": "/cdn/shop/files/Matte-Black-8-600x600.jpg",
        "hoverImg": "/cdn/shop/files/Matte-Black-11-500x500.jpg",
        "subheading": "Adjustable Curtain Rod",
        "Fabrics": [
            "Classic Ball"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 119,
        "newPrice": 107,
        "extra": "Extra 10%"
    },
    {
        "id": 1186,
        "title": "End Cap Adjustable Curtain Rod",
        "ProductUrl": "/curtain-rod/1-inch-adjustable-curtain-rod-with-end-cap-finials-length-28-144inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "920",
        "_fabric_color": [
            {
                "term_id": 919,
                "gallery": [
                    20105,
                    20104,
                    20103,
                    20106
                ],
                "imgSrc": "/cdn/shop/files/Black-3-6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-3-6.jpg",
                "imgSrcF": "/cdn/shop/files/Black-3-6.jpg",
                "title": "Black",
                "color": "Gold"
            },
            {
                "term_id": 920,
                "gallery": [
                    20114,
                    20113
                ],
                "imgSrc": "/cdn/shop/files/Matte-Gray-6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Matte-Gray-6.jpg",
                "imgSrcF": "/cdn/shop/files/Matte-Gray-6.jpg",
                "title": "Matte Gray",
                "color": "Gold"
            },
            {
                "term_id": 921,
                "gallery": [
                    20111,
                    20110,
                    20109,
                    20108,
                    20107
                ],
                "imgSrc": "/cdn/shop/files/Bright-Gray3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Bright-Gray3.jpg",
                "imgSrcF": "/cdn/shop/files/Bright-Gray3.jpg",
                "title": "Bright Gray",
                "color": "Gold"
            },
            {
                "term_id": 922,
                "gallery": [
                    20117,
                    20116,
                    20118,
                    20115
                ],
                "imgSrc": "/cdn/shop/files/White-3-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-3-2.jpg",
                "imgSrcF": "/cdn/shop/files/White-3-2.jpg",
                "title": "White",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 493,
                "gallery": null,
                "price": 0,
                "title": "28''-48''"
            },
            {
                "term_id": 494,
                "gallery": null,
                "price": 0,
                "title": "48''-86''"
            },
            {
                "term_id": 508,
                "gallery": null,
                "price": 0,
                "title": "72''-144''"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "All Accessories",
            "All Curtain Accessories",
            "Factory products",
            "Fixed Size",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "curtain-rod",
                "name": "curtain rod"
            },
            {
                "slug": "outdoor-accessories",
                "name": "outdoor accessories"
            },
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "<ul>\r\n \t<li>Basic Info: Sold by the single per package. 1 inch diameter adjustable aluminum alloy curtain rod which is conveniently strong enough to hold both light and heavy curtains.</li>\r\n \t<li>Dimension Options: Here are 3 sizes of the curtain rod that adjusts from 28-48, 48-86, and 72-144 inches for your choices, which are perfect for the office, bedroom, and living room.</li>\r\n \t<li>Rod Design: The curtain rod adopts an advanced process for a more elegant look.</li>\r\n \t<li>Wide Compatibility: The curtain rod will be suitable with both heavy and lightweight curtains also for all different curtain tops such as grommet, rod pocket, back tab, tab top, and so on.</li>\r\n</ul>",
        "imgSrc": "/cdn/shop/files/Matte-Gray-6-600x600.jpg",
        "hoverImg": "/cdn/shop/files/White-3-2-1-500x500.jpg",
        "subheading": "Adjustable Curtain Rod",
        "Fabrics": [
            "End Cap"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 119,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 63442,
        "title": "Deer Metal Curtain Wall Hook",
        "ProductUrl": "/wallhook/deer-curtain-holdback-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63220",
        "_fabric_color": [
            {
                "term_id": 63220,
                "gallery": [
                    62858,
                    62859,
                    62862,
                    62863,
                    62861,
                    62860,
                    62864
                ],
                "imgSrc": "/cdn/shop/files/Milu-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Milu-1.jpg",
                "imgSrcF": "/cdn/shop/files/Milu-5.jpg",
                "title": "Elk"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Milu-1-500x500.jpg",
        "hoverImg": "",
        "subheading": "Metal Curtain Wall Hook",
        "Fabrics": [
            "Deer"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 120,
        "newPrice": 102,
        "extra": "Extra 10%"
    },
    {
        "id": 63171,
        "title": "Fur Textured Curtain Wall Hook",
        "ProductUrl": "/wallhook/fur-textured-curtain-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63194",
        "_fabric_color": [
            {
                "term_id": 63194,
                "gallery": [
                    62941,
                    62942,
                    62938,
                    62950,
                    62939,
                    62940,
                    62937
                ],
                "imgSrc": "/cdn/shop/files/White-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-1.jpg",
                "imgSrcF": "/cdn/shop/files/White-4.jpg",
                "title": "White"
            },
            {
                "term_id": 63193,
                "gallery": [
                    62944,
                    62943,
                    62945,
                    62950,
                    62946,
                    62948,
                    62947,
                    62949
                ],
                "imgSrc": "/cdn/shop/files/Blackout-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Blackout-2.jpg",
                "imgSrcF": "/cdn/shop/files/Blackout-3.jpg",
                "title": "Black"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Summer Collection",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/White-1-500x500.jpg",
        "hoverImg": "",
        "subheading": "Curtain Wall Hook",
        "Fabrics": [
            "Fur Textured"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 115,
        "newPrice": 98,
        "extra": "Extra 10%"
    },
    {
        "id": 63163,
        "title": "Gemstone Curtain Wall Hook",
        "ProductUrl": "/wallhooks/gemstone-curtain-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63165",
        "_fabric_color": [
            {
                "term_id": 63168,
                "gallery": [
                    62920,
                    62921,
                    62915,
                    62917,
                    62916,
                    62919,
                    62918
                ],
                "imgSrc": "/cdn/shop/files/Khaki-6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Khaki-6.jpg",
                "imgSrcF": "/cdn/shop/files/Khaki-1.jpg",
                "title": "Wood Khaki"
            },
            {
                "term_id": 63164,
                "gallery": [
                    62910,
                    62909,
                    62913,
                    62911,
                    62912,
                    62914
                ],
                "imgSrc": "/cdn/shop/files/rose-Red-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/rose-Red-2.jpg",
                "imgSrcF": "/cdn/shop/files/rose-Red-5.jpg",
                "title": "Rose Red",
                "color": "Red"
            },
            {
                "term_id": 63165,
                "gallery": [
                    62904,
                    62903,
                    62906,
                    62905,
                    62907,
                    62908
                ],
                "imgSrc": "/cdn/shop/files/Green-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Green-2.jpg",
                "imgSrcF": "/cdn/shop/files/Green-4.jpg",
                "title": "Jade Green",
                "color": "Green"
            },
            {
                "term_id": 63166,
                "gallery": [
                    62898,
                    62897,
                    62901,
                    62899,
                    62900,
                    62902
                ],
                "imgSrc": "/cdn/shop/files/Grey-White-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Grey-White-2.jpg",
                "imgSrcF": "/cdn/shop/files/Grey-White-5.jpg",
                "title": "Grey White",
                "color": "Green"
            },
            {
                "term_id": 63167,
                "gallery": [
                    62892,
                    62891,
                    62894,
                    62895,
                    62893,
                    62896
                ],
                "imgSrc": "/cdn/shop/files/Yellow-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Yellow-2.jpg",
                "imgSrcF": "/cdn/shop/files/Yellow-4.jpg",
                "title": "Amber Yellow",
                "color": "Green"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Green-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Green-4-500x500.jpg",
        "subheading": "Curtain Wall Hook",
        "Fabrics": [
            "Gemstone"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [
            "Red",
            "Green"
        ],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 115,
        "newPrice": 98,
        "extra": "Extra 10%"
    },
    {
        "id": 63344,
        "title": "Lambswool Yarn Wooden Curtain Wall Hook",
        "ProductUrl": "/wallhook/lambswool-botton-yarn-wooden-curtain-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63181",
        "_fabric_color": [
            {
                "term_id": 63181,
                "gallery": [
                    63027,
                    63028,
                    63020,
                    63025,
                    63026,
                    63024,
                    63023,
                    63022,
                    63021
                ],
                "imgSrc": "/cdn/shop/files/Lambswool-wood-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Lambswool-wood-8.jpg",
                "imgSrcF": "/cdn/shop/files/Lambswool-wood-1.jpg",
                "title": "Lambswool / Wood"
            },
            {
                "term_id": 63177,
                "gallery": [
                    63011,
                    63012,
                    63013,
                    63017,
                    63019,
                    63018,
                    63016,
                    63015,
                    63014
                ],
                "imgSrc": "/cdn/shop/files/Lambswool-Black-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Lambswool-Black-1.jpg",
                "imgSrcF": "/cdn/shop/files/Lambswool-Black-3.jpg",
                "title": "Lambswool / Black"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Lambswool-wood-8-500x500.jpg",
        "hoverImg": "",
        "subheading": "Yarn Wooden Curtain Wall Hook",
        "Fabrics": [
            "Lambswool"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 135,
        "newPrice": 115,
        "extra": "Extra 10%"
    },
    {
        "id": 63173,
        "title": "Leather Knob Curtain Wall Hook",
        "ProductUrl": "/wallhook/leather-doorknob-curtain-wall-hook/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "63198",
        "_fabric_color": [
            {
                "term_id": 63199,
                "gallery": [
                    62966,
                    62965,
                    62967,
                    62970,
                    62972,
                    62971,
                    62969,
                    62968
                ],
                "imgSrc": "/cdn/shop/files/wood-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/wood-2.jpg",
                "imgSrcF": "/cdn/shop/files/wood-3.jpg",
                "title": "Wood"
            },
            {
                "term_id": 63200,
                "gallery": [
                    62958,
                    62957,
                    62959,
                    62960,
                    62964,
                    62963,
                    62962,
                    62961
                ],
                "imgSrc": "/cdn/shop/files/dark-coffee-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/dark-coffee-2.jpg",
                "imgSrcF": "/cdn/shop/files/dark-coffee-3.jpg",
                "title": "Dark Brown"
            },
            {
                "term_id": 63198,
                "gallery": [
                    62955,
                    62956,
                    62952,
                    62951,
                    62954,
                    62953
                ],
                "imgSrc": "/cdn/shop/files/Orange-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Orange-5.jpg",
                "imgSrcF": "/cdn/shop/files/Orange-2.jpg",
                "title": "Orange"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Summer Collection",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Orange-5-500x500.jpg",
        "hoverImg": "",
        "subheading": "Curtain Wall Hook",
        "Fabrics": [
            "Leather Knob"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 125,
        "newPrice": 106,
        "extra": "Extra 10%"
    },
    {
        "id": 35565,
        "title": "Cat Magnetic Curtain TieBack",
        "ProductUrl": "/tiebacks/cat-magnetic-curtain-tie-backs-1-pieces/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "35579",
        "_fabric_color": [
            {
                "term_id": 35579,
                "gallery": [
                    35573,
                    35585,
                    35581,
                    35582,
                    35583,
                    35584
                ],
                "imgSrc": "/cdn/shop/files/主图-09-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/主图-09.jpg",
                "imgSrcF": "/cdn/shop/files/主图-09.jpg",
                "title": "Cat / Rose Golden",
                "color": "Gold"
            },
            {
                "term_id": 35577,
                "gallery": [
                    35572,
                    35585,
                    35581,
                    35582,
                    35583,
                    35584
                ],
                "imgSrc": "/cdn/shop/files/主图-08-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/主图-08.jpg",
                "imgSrcF": "/cdn/shop/files/主图-08.jpg",
                "title": "Cat / Dark Golden",
                "color": "Gold"
            },
            {
                "term_id": 35575,
                "gallery": [
                    35571,
                    35585,
                    35582,
                    35581,
                    35584,
                    35583
                ],
                "imgSrc": "/cdn/shop/files/主图-07-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/主图-07.jpg",
                "imgSrcF": "/cdn/shop/files/主图-07.jpg",
                "title": "Cat / Silver",
                "color": "Gold"
            },
            {
                "term_id": 35568,
                "gallery": [
                    35570,
                    35585,
                    35582,
                    35581,
                    35584,
                    35583
                ],
                "imgSrc": "/cdn/shop/files/主图-02-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/主图-02.jpg",
                "imgSrcF": "/cdn/shop/files/主图-02.jpg",
                "title": "Cat / Gold",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories",
            "All Accessories",
            "All Curtain Accessories",
            "Factory products",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "Search tieback",
            "Tiebacks"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "<h3 style=\"font-size: 24px;\">Description</h3>\r\n<p class=\"feat_txt\">High Quality:  The product is made of high-quality non-woven fabric, soft and comfortable, not easy to fall, easy to clean, and reusable.</p>\r\n<p class=\"feat_txt\">Widely used:  These cute cartoon curtain buttons can be used in many situations. They are one of the essential holiday decorations in your home, suitable for bedrooms, bathrooms, kitchens, offices, etc.</p>",
        "imgSrc": "/cdn/shop/files/7149V40_gXL-500x500.jpg",
        "hoverImg": "/cdn/shop/files/51C1kbhQo9L-500x500.jpg",
        "subheading": "Magnetic Curtain Tieback",
        "Fabrics": [
            "Cat"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [
            "Gold"
        ],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor",
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 70,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 63209,
        "title": "Mannequin Metal Curtain Wall Hook",
        "ProductUrl": "/wallhooks/mannequin-curtain-holdback-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63218",
        "_fabric_color": [
            {
                "term_id": 63218,
                "gallery": [
                    62850,
                    62849,
                    62845,
                    62848,
                    62847,
                    62846,
                    62844
                ],
                "imgSrc": "/cdn/shop/files/Portraits-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Portraits-1.jpg",
                "imgSrcF": "/cdn/shop/files/Portraits-3.jpg",
                "title": "Portraits"
            },
            {
                "term_id": 63219,
                "gallery": [
                    62852,
                    62851,
                    62856,
                    62855,
                    62854,
                    62853,
                    62857
                ],
                "imgSrc": "/cdn/shop/files/bird-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/bird-2.jpg",
                "imgSrcF": "/cdn/shop/files/bird-6.jpg",
                "title": "Bird"
            },
            {
                "term_id": 63220,
                "gallery": [
                    62858,
                    62859,
                    62862,
                    62863,
                    62861,
                    62860,
                    62864
                ],
                "imgSrc": "/cdn/shop/files/Milu-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Milu-1.jpg",
                "imgSrcF": "/cdn/shop/files/Milu-5.jpg",
                "title": "Elk"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Summer Collection",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Portraits-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Portraits-3-500x500.jpg",
        "subheading": "Metal Curtain Wall Hook",
        "Fabrics": [
            "Mannequin"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 120,
        "newPrice": 102,
        "extra": "Extra 10%"
    },
    {
        "id": 63172,
        "title": "Natural Crystal Curtain Wall Hook",
        "ProductUrl": "/wallhook/natural-crystal-curtain-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63207",
        "_fabric_color": [
            {
                "term_id": 63207,
                "gallery": [
                    63206,
                    63205,
                    63204,
                    63203,
                    63201,
                    63202
                ],
                "imgSrc": "/cdn/shop/files/Green-3-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Green-3-1.jpg",
                "imgSrcF": "/cdn/shop/files/Green-1-1.jpg",
                "title": "Green"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Summer Collection",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Green-3-1-500x500.jpg",
        "hoverImg": "",
        "subheading": "Curtain Wall Hook",
        "Fabrics": [
            "Natural Crystal"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 140,
        "newPrice": 102,
        "extra": "Extra 10%"
    },
    {
        "id": 63208,
        "title": "Seashell Curtain Wall Hook",
        "ProductUrl": "/wallhook/seashell-curtain-holdback-wall-hook/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63226",
        "_fabric_color": [
            {
                "term_id": 63226,
                "gallery": [
                    62884,
                    62883,
                    62882,
                    62888,
                    62890,
                    62889,
                    62886,
                    62887,
                    62885
                ],
                "imgSrc": "/cdn/shop/files/Pearlescent-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Pearlescent-3.jpg",
                "imgSrcF": "/cdn/shop/files/Pearlescent-1.jpg",
                "title": "Pearlescent"
            },
            {
                "term_id": 63227,
                "gallery": [
                    62881,
                    62874,
                    62875,
                    62878,
                    62877,
                    62876,
                    62879,
                    62880
                ],
                "imgSrc": "/cdn/shop/files/Color-shell-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Color-shell-1.jpg",
                "imgSrcF": "/cdn/shop/files/Color-shell-3.jpg",
                "title": "Color Shell"
            },
            {
                "term_id": 63228,
                "gallery": [
                    62867,
                    62866,
                    62865,
                    62868,
                    62873,
                    62872,
                    62870,
                    62869,
                    62871
                ],
                "imgSrc": "/cdn/shop/files/White-shell-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-shell-3.jpg",
                "imgSrcF": "/cdn/shop/files/White-shell-1.jpg",
                "title": "White Shell"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Fixed Size",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Summer Collection",
            "Wall Hook"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Pearlescent-3-500x500.jpg",
        "hoverImg": "",
        "subheading": "Curtain Wall Hook",
        "Fabrics": [
            "Seashell"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 120,
        "newPrice": 102,
        "extra": "Extra 10%"
    },
    {
        "id": 63550,
        "title": "Brown Roman Square Custom Finials Curtain Rods",
        "ProductUrl": "/custom-curtain-rods/custom-brown-roman-square-finial-curtain-rod-with-ball-finials/?fwidth=40&flength=40fwidth=40&flength=40",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63240",
        "_fabric_color": [
            {
                "term_id": 63240,
                "gallery": [
                    63257,
                    63260,
                    63262,
                    63261,
                    63263,
                    63258,
                    63259
                ],
                "imgSrc": "/cdn/shop/files/Brown-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Brown-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/Brown-1-1.jpg",
                "title": "Brown"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Custom Curtain Rod",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Brown-3-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Brown-4-1-500x500.jpg",
        "subheading": "Custom Finials Curtain Rods",
        "Fabrics": [
            "Brown Roman Square"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 123,
        "newPrice": 105
    },
    {
        "id": 63547,
        "title": "Classic Red Carved Custom Finials Curtain Rods",
        "ProductUrl": "/custom-curtain-rods/custom-classic-red-wooden-carved-details-curtain-rod-with-ball-finials/?fwidth=40&flength=40fwidth=40&flength=40",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63331",
        "_fabric_color": [
            {
                "term_id": 63331,
                "gallery": [
                    63290,
                    63286,
                    63285,
                    63284,
                    63289,
                    63288,
                    63287
                ],
                "imgSrc": "/cdn/shop/files/Classic-red-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Classic-red-2.jpg",
                "imgSrcF": "/cdn/shop/files/Classic-red-6.jpg",
                "title": "Classic Red"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Custom Curtain Rod",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "curtain-rod",
                "name": "curtain rod"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Classic-red-2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Classic-red-3-1-500x500.jpg",
        "subheading": "Custom Finials Curtain Rods",
        "Fabrics": [
            "Classic Red Carved"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 131,
        "newPrice": 111
    },
    {
        "id": 63554,
        "title": "White Roman Square Custom Curtain Rods",
        "ProductUrl": "/custom-curtain-rods/custom-white-roman-square-finial-curtain-rod-with-ball-finials/?fwidth=40&flength=40fwidth=40&flength=40",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63242",
        "_fabric_color": [
            {
                "term_id": 63242,
                "gallery": [
                    63243,
                    63247,
                    63249,
                    63248,
                    63244,
                    63245,
                    63246
                ],
                "imgSrc": "/cdn/shop/files/White-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/White-1-1.jpg",
                "title": "White"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Custom Curtain Rod",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/White-4-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/White-5-1-500x500.jpg",
        "subheading": "Custom Curtain Rods",
        "Fabrics": [
            "White Roman Square"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 123,
        "newPrice": 105
    },
    {
        "id": 63440,
        "title": "Carved Custom Wooden Curtain Rods",
        "ProductUrl": "/custom-curtain-rod/custom-wooden-carved-details-curtain-rod-with-ball-finials/?fwidth=40&flength=40fwidth=40&flength=40",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "63330",
        "_fabric_color": [
            {
                "term_id": 63330,
                "gallery": [
                    63294,
                    63293,
                    63297,
                    63296,
                    63295,
                    63292,
                    63291
                ],
                "imgSrc": "/cdn/shop/files/Teak-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Teak-4.jpg",
                "imgSrcF": "/cdn/shop/files/Teak-3.jpg",
                "title": "Teak"
            },
            {
                "term_id": 63331,
                "gallery": [
                    63290,
                    63286,
                    63285,
                    63284,
                    63289,
                    63288,
                    63287
                ],
                "imgSrc": "/cdn/shop/files/Classic-red-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Classic-red-2.jpg",
                "imgSrcF": "/cdn/shop/files/Classic-red-6.jpg",
                "title": "Classic Red"
            },
            {
                "term_id": 63332,
                "gallery": [
                    63282,
                    63277,
                    63278,
                    63283,
                    63281,
                    63280,
                    63279
                ],
                "imgSrc": "/cdn/shop/files/White-4-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-4-2.jpg",
                "imgSrcF": "/cdn/shop/files/White-2-2.jpg",
                "title": "White"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "15% Off Sale",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Custom Curtain Rod",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Sale",
            "Search Rod",
            "Summer Collection",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/Teak-4-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Teak-5-500x500.jpg",
        "subheading": "Custom Wooden Curtain Rods",
        "Fabrics": [
            "Carved"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "15% Off",
        "salenum": 15,
        "oldPrice": 131,
        "newPrice": 111,
        "extra": "Extra 10%"
    },
    {
        "id": 44999,
        "title": "Outdoor Rod Adjustable Anti-Rust Outdoor Curtain Rod",
        "ProductUrl": "/curtain-rod/1-inch-adjustable-anti-rust-outdoor-curtain-rod-length-28-168-inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "45105",
        "_fabric_color": [
            {
                "term_id": 45105,
                "gallery": [
                    45039,
                    45046,
                    45055,
                    45041,
                    45040,
                    45043,
                    45047,
                    45045,
                    45044
                ],
                "imgSrc": "/cdn/shop/files/black-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/black-5.jpg",
                "imgSrcF": "/cdn/shop/files/black-120x120-1.jpg",
                "title": "Black",
                "color": "Green"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 601,
                "gallery": null,
                "price": 0,
                "title": "28''-48''"
            },
            {
                "term_id": 599,
                "gallery": null,
                "price": 0,
                "title": "48''-86''"
            },
            {
                "term_id": 600,
                "gallery": null,
                "price": 0,
                "title": "72''-144''"
            },
            {
                "term_id": 45111,
                "gallery": null,
                "price": 0,
                "title": "144\"-168\""
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "All Accessories",
            "All Curtain Accessories",
            "Black Friday",
            "Curtain Rod Categories",
            "Cyber Monday",
            "Factory products",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Search Rod",
            "Summer Outdoor Decor",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "curtain-rod",
                "name": "curtain rod"
            },
            {
                "slug": "outdoor-accessories",
                "name": "outdoor accessories"
            },
            {
                "slug": "outdoor-curtains",
                "name": "Outdoor Curtains"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            }
        ],
        "short_description": "All Installations: The adjustable outdoor curtain rod comes with everything you need for installation. Kit includes 2 oval metal terminals, wall-mounted curtain rod bracket, screws, drywall anchors, and easy-to-follow installation instructions.\r\nSIZE OPTIONS: Available in 4 sizes, designed to fit a variety of window sizes, these rust-resistant curtain rods adjust from 28\" - 48\" (small windows), 48\" - 86\" (standard size windows), 72\" - 144\" (sliding glass doors, French windows) and 144\"-168\" (balconies, patios).\r\nRod Design: High quality metal gives the curtain rod an elegant look, simple yet stylish curtain rod with universal oval end design, suitable for almost any room in your home.\r\nVersatile: 1 inch rod diameter designed to hold curtains up to 22 lbs, anti-rust coating protects the curtain rod from the elements. The perfect window treatment for bedrooms, doorways, bathrooms, balconies, patios, and other indoor and outdoor locations.\r\nQUICK TO USE: The oval end cap outdoor curtain rod can be mounted to the ceiling or wall with the included brackets and hardware. The fixed projection is 3.75 inches from the wall to the pole centerline. If you have any concerns or questions, please feel free to contact us.",
        "imgSrc": "/cdn/shop/files/black-5-500x500.jpg",
        "hoverImg": "/cdn/shop/files/black-2-500x500.jpg",
        "subheading": "Adjustable Anti-Rust Outdoor Curtain Rod",
        "Fabrics": [
            "Outdoor Rod"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 119,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 38337,
        "title": "Hardware Kit Sun Shade Sail 304 Stainless Steel Hardware Kit for Outdoor",
        "ProductUrl": "/accessories/sun-shade-sail-hardware-kit-for-rectangle-outdoor-installation-304-stainless-steel/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "38348",
        "_fabric_color": [
            {
                "term_id": 38348,
                "gallery": [
                    38980,
                    38981,
                    38987,
                    38986,
                    38979,
                    38983,
                    38985,
                    38984,
                    38982,
                    38975,
                    38977,
                    38976
                ],
                "imgSrc": "/cdn/shop/files/M5-40-Piece-Set-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/M5-40-Piece-Set-1.jpg",
                "imgSrcF": "/cdn/shop/files/M5-40-Piece-Set-1.webp",
                "title": "M5-40 Piece Set",
                "color": "Green"
            },
            {
                "term_id": 38350,
                "gallery": [
                    38989,
                    38988,
                    38987,
                    38986,
                    38979,
                    38983,
                    38985,
                    38984,
                    38982,
                    38975,
                    38977,
                    38976
                ],
                "imgSrc": "/cdn/shop/files/M5-80-Piece-Set-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/M5-80-Piece-Set-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/M5-80-Piece-Set-1.jpg",
                "title": "M5-80 Piece Set",
                "color": "Green"
            },
            {
                "term_id": 38353,
                "gallery": [
                    38991,
                    38990,
                    38987,
                    38986,
                    38985,
                    38984,
                    38983,
                    38982,
                    38979,
                    38975,
                    38977,
                    38976
                ],
                "imgSrc": "/cdn/shop/files/M6-40-Piece-Set-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/M6-40-Piece-Set-1.jpg",
                "imgSrcF": "/cdn/shop/files/M6-40-Piece-Set-1.webp",
                "title": "M6-40 Piece Set",
                "color": "Green"
            },
            {
                "term_id": 38358,
                "gallery": [
                    38993,
                    38992,
                    38979,
                    38987,
                    38986,
                    38985,
                    38984,
                    38983,
                    38982,
                    38975,
                    38977,
                    38976
                ],
                "imgSrc": "/cdn/shop/files/M6-80-Piece-Set-1-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/M6-80-Piece-Set-1-1.jpg",
                "imgSrcF": "/cdn/shop/files/M6-80-Piece-Set-1.jpg",
                "title": "M6-80 Piece Set",
                "color": "Green"
            },
            {
                "term_id": 38362,
                "gallery": [
                    38995,
                    38994,
                    38982,
                    38987,
                    38986,
                    38985,
                    38984,
                    38983,
                    38979,
                    38975,
                    38977,
                    38976
                ],
                "imgSrc": "/cdn/shop/files/M8-40-Piece-Set-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/M8-40-Piece-Set-1.jpg",
                "imgSrcF": "/cdn/shop/files/M8-40-Piece-Set-1.webp",
                "title": "M8-40 Piece Set",
                "color": "Green"
            },
            {
                "term_id": 38366,
                "gallery": [
                    38996,
                    38997,
                    38987,
                    38986,
                    38985,
                    38984,
                    38983,
                    38982,
                    38979,
                    38975,
                    38977,
                    38976
                ],
                "imgSrc": "/cdn/shop/files/M8-80-Piece-Set-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/M8-80-Piece-Set-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/M8-80-Piece-Set-2.jpg",
                "title": "M8-80 Piece Set",
                "color": "Green"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "10% Off Sale",
            "Accessories",
            "All Accessories",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Extra 10%",
            "Factory products",
            "Fixed Size",
            "Independence Day",
            "New Product UI",
            "new rod UI",
            "Search outdoor",
            "Search sail",
            "Summer Outdoor Decor",
            "Sun Shade Sail",
            "Sun Shade Sail Accessories"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "outdoor-accessories",
                "name": "outdoor accessories"
            },
            {
                "slug": "shade-sail-hardware",
                "name": "shade sail hardware"
            },
            {
                "slug": "sun-shade-sails",
                "name": "Sun Shade Sails"
            }
        ],
        "short_description": "<h3 style=\"font-size: 24px;\">Specification</h3>\r\n<p class=\"feat_txt\"><strong>Package Included:   </strong>M5-40 Piece Set/M5-80 Piece Set/M6-40 Piece Set/M6-80 Piece Set/<span class=\"swatch__value_pr\">M8-40 Piece Set/</span>M8-80 Piece Set</p>",
        "imgSrc": "/cdn/shop/files/M5-40-Piece-Set-1-500x500.jpg",
        "hoverImg": "/cdn/shop/files/M5-40-Piece-Set-6-500x500.jpg",
        "subheading": "Sun Shade Sail 304 Stainless Steel Hardware Kit for Outdoor",
        "Fabrics": [
            "Hardware Kit"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 110,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 1188,
        "title": "Tension Rod Adjustable No Drill Tension Curtain Rod",
        "ProductUrl": "/curtain-rod/1-1-8-inch-adjustable-no-drill-tension-curtain-rod-length-28-120-inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "930",
        "_fabric_color": [
            {
                "term_id": 926,
                "gallery": [
                    20125,
                    20126,
                    20124,
                    20123,
                    20127,
                    20128
                ],
                "imgSrc": "/cdn/shop/files/Black-2-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-2-8.jpg",
                "imgSrcF": false,
                "title": null,
                "color": "Gold"
            },
            {
                "term_id": 928,
                "gallery": [
                    20137,
                    20134,
                    20135,
                    20136,
                    20122,
                    20120,
                    20121
                ],
                "imgSrc": "/cdn/shop/files/Silver-4-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-4-1.jpg",
                "imgSrcF": false,
                "title": null,
                "color": "Gold"
            },
            {
                "term_id": 930,
                "gallery": [
                    20139,
                    20140,
                    20141,
                    20138,
                    20132,
                    20131,
                    20130
                ],
                "imgSrc": "/cdn/shop/files/White-2-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-2-3.jpg",
                "imgSrcF": false,
                "title": null,
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 493,
                "gallery": null,
                "price": 0,
                "title": "28''-48''"
            },
            {
                "term_id": 513,
                "gallery": null,
                "price": 0,
                "title": "48''-80''"
            },
            {
                "term_id": 514,
                "gallery": null,
                "price": 0,
                "title": "80''-120''"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "All Accessories",
            "All Curtain Accessories",
            "Curtain Rod Categories",
            "Factory products",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "header",
                "name": "header"
            }
        ],
        "short_description": "<ul>\r\n \t<li>ROD DETAIL: Heavy duty spring strong tension curtain rod contains stainless steel strong rough spring, 2 strong suction cup, a strong stretch to extend enough to support max load 30 lbs.</li>\r\n \t<li>EASY INSTALLATION: Adjustable width design for easily hanging curtains. Unlike normal rod, this tension curtain rod Don't Need Any Tools To Install. Just unscrew them until they are about 1.5 -2 longer than the area you're putting them in, then squeeze them into place.</li>\r\n \t<li>WIDE SCOPE: Tension curtain rod not only can be used as curtains rods, like the shower curtain, doors and windows support rods, drying support rods, but also can be used as closet rods, shoes racks, coat hanger and so on.</li>\r\n \t<li>HUMANIZED DESIGN: Apply for All Surface, Include Wallpaper Wall, Tile Wall, Wooden Frame, Etc. Besides, no drilling, screws, or tools required, protecting your wall, closet, cupboard, or other places away from being damaged.</li>\r\n \t<li>NICE SERVICE: Nice pre-sale and after-sale service. Your 100% satisfaction is our #1 priority.</li>\r\n</ul>\r\n&nbsp;",
        "imgSrc": "/cdn/shop/files/White-2-3-600x600.jpg",
        "hoverImg": "/cdn/shop/files/Silver-1-1-1-500x500.jpg",
        "subheading": "Adjustable No Drill Tension Curtain Rod",
        "Fabrics": [
            "Tension Rod"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Bathroom",
            "Indoor",
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 109,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 98301,
        "title": "Stainless Steel Sun Shade Sail Support Pole",
        "ProductUrl": "/sun-shade-sail-accessories/stainless-steel-sun-shade-sail-support-pole/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "98308",
        "_fabric_color": [
            {
                "term_id": 98308,
                "gallery": [
                    98327,
                    98306,
                    98304,
                    98824
                ],
                "imgSrc": "/cdn/shop/files/acc-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/acc-1.png",
                "imgSrcF": "/cdn/shop/files/shade-sail-pole-3.png",
                "title": "Shade Sail Pole"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 98309,
                "gallery": null,
                "price": 0,
                "title": "96 inches (8 ft)"
            },
            {
                "term_id": 98322,
                "gallery": null,
                "price": 0,
                "title": "144 inches (12 ft)"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories",
            "All Accessories",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Fixed Size",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Outsourced products",
            "Search sail",
            "Sun Shade Sail",
            "Sun Shade Sail Accessories"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "outdoor-accessories",
                "name": "outdoor accessories"
            },
            {
                "slug": "sun-shade-sails",
                "name": "Sun Shade Sails"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/acc-1-500x500.png",
        "hoverImg": "/cdn/shop/files/shade-sail-pole-3-500x500.png",
        "subheading": "Stainless Steel Sun Shade Sail Support Pole",
        "Fabrics": [
            "Support Rod"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 408,
        "newPrice": 102
    },
    {
        "id": 38389,
        "title": "Rope Sun Shade Sail Outdoor Multi-Purpose Rope Polyester Solid",
        "ProductUrl": "/sun-shade-sail-accessories/sun-shade-sail-rope-polyester-solid-line-for-garden-patio-camping/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "38390",
        "_fabric_color": [
            {
                "term_id": 38390,
                "gallery": [
                    38392,
                    38397,
                    38396,
                    38395,
                    38394,
                    38393
                ],
                "imgSrc": "/cdn/shop/files/1-12-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/1-12.jpg",
                "imgSrcF": "/cdn/shop/files/1-12.jpg",
                "title": "White",
                "color": "Green"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 38372,
                "gallery": null,
                "price": 0,
                "title": "50Ft"
            },
            {
                "term_id": 38374,
                "gallery": null,
                "price": 0,
                "title": "100Ft"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories",
            "All Accessories",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Factory products",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "Search outdoor",
            "Search sail",
            "Sun Shade Sail",
            "Sun Shade Sail Accessories"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "outdoor-accessories",
                "name": "outdoor accessories"
            },
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "shade-sail-hardware",
                "name": "shade sail hardware"
            },
            {
                "slug": "sun-shade-sails",
                "name": "Sun Shade Sails"
            }
        ],
        "short_description": "<div class=\"flex_accessories\">\r\n<div class=\"spec_left\">\r\n<h3 style=\"font-size: 24px;\">Specification</h3>\r\n<p class=\"feat_txt\"><strong>Package Included:  </strong>1 Pack of 1 pieces</p>\r\n\r\n</div>\r\n<div class=\"desc_right\">\r\n\r\n&nbsp;\r\n\r\n&nbsp;\r\n\r\n</div>\r\n</div>",
        "imgSrc": "/cdn/shop/files/1-12-500x500.jpg",
        "hoverImg": "/cdn/shop/files/6-2-500x500.jpg",
        "subheading": "Sun Shade Sail Outdoor Multi-Purpose Rope Polyester Solid",
        "Fabrics": [
            "Rope"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 87,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 1183,
        "title": "Antique Style Adjustable Curtain Rod",
        "ProductUrl": "/curtain-rod/1-1-8-inch-adjustable-antique-style-curtain-rod-length-28-144-inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "913",
        "_fabric_color": [
            {
                "term_id": 912,
                "gallery": [
                    20076,
                    20077,
                    20078,
                    20075,
                    20080,
                    20079
                ],
                "imgSrc": "/cdn/shop/files/White-3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-3.jpg",
                "imgSrcF": false,
                "title": null,
                "color": "Gold"
            },
            {
                "term_id": 913,
                "gallery": [
                    20066,
                    20067,
                    20069,
                    20065,
                    20068
                ],
                "imgSrc": "/cdn/shop/files/Black-2-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-2-5.jpg",
                "imgSrcF": "/cdn/shop/files/Black-2-5.jpg",
                "title": "Black",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 493,
                "gallery": null,
                "price": 0,
                "title": "28''-48''"
            },
            {
                "term_id": 494,
                "gallery": null,
                "price": 0,
                "title": "48''-86''"
            },
            {
                "term_id": 495,
                "gallery": null,
                "price": 0,
                "title": "101''-144''"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "Adjustable Curtain rod",
            "All Accessories",
            "All Curtain Accessories",
            "Factory products",
            "Fixed Size",
            "flash_categories",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Search Rod",
            "Spring Time Sale",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "header",
                "name": "header"
            }
        ],
        "short_description": "<ul>\r\n \t<li>Basic Info: Sold by the single per package. 1 1/8 inch diameter adjustable aluminum alloy curtain rod which is conveniently strong enough to hold both light and heavy curtains.</li>\r\n \t<li>Set Including: Entire set includes the curtain rod, 2 metal finials, 3 brackets, and 6 screws with anchors which are all accessories mounting hardware for easy installation.</li>\r\n \t<li>Dimension Options: Here are 3 sizes of the curtain rod that adjusts from 28-48, 48-86, and 72-144 inches for your choices, which are perfect for the office, bedroom, and living room.</li>\r\n \t<li>Rod Design: The curtain rod adopts antique white with a special process so that you will see the loose gold pattern on the rod for the retro style and the finials look like trophy cups.</li>\r\n \t<li>Wide Compatibility: The curtain rod will be suitable with both heavy and lightweight curtains also for all different curtain tops such as grommet, rod pocket, back tab, tab top, and so on.</li>\r\n</ul>",
        "imgSrc": "/cdn/shop/files/Black-2-5-600x600.jpg",
        "hoverImg": "/cdn/shop/files/White-3-7-500x500.jpg",
        "subheading": "Adjustable Curtain Rod",
        "Fabrics": [
            "Antique Style"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 119,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 1179,
        "title": "Birdcage Adjustable Curtain Rod",
        "ProductUrl": "/curtain-rod/1-inch-adjustable-curtain-rod-with-birdcage-finials-length-28-144-inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "901",
        "_fabric_color": [
            {
                "term_id": 901,
                "gallery": [
                    20004,
                    20003,
                    20002,
                    20005,
                    20006,
                    20007
                ],
                "imgSrc": "/cdn/shop/files/Silver-4-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Silver-4.jpg",
                "imgSrcF": "/cdn/shop/files/Silver-4.jpg",
                "title": "Silver",
                "color": "Gold"
            },
            {
                "term_id": 902,
                "gallery": [
                    20000,
                    19999,
                    19998,
                    19997
                ],
                "imgSrc": "/cdn/shop/files/Matte-Black-6-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Matte-Black-6-1.jpg",
                "imgSrcF": "/cdn/shop/files/Matte-Black-6-1.jpg",
                "title": "Matte Black",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": "493",
                "gallery": null,
                "price": 0,
                "title": "28''-48''"
            },
            {
                "term_id": "494",
                "gallery": null,
                "price": 0,
                "title": "48''-86''"
            },
            {
                "term_id": "495",
                "gallery": null,
                "price": 0,
                "title": "101''-144''"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "Adjustable Curtain rod",
            "All Accessories",
            "All Curtain Accessories",
            "Black Friday",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "Fixed Size",
            "Independence Day",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "header",
                "name": "header"
            }
        ],
        "short_description": "<ul>\r\n \t<li>Basic Info: Sold by the single per package. 1 inch diameter adjustable aluminum alloy curtain rod which is conveniently strong enough to hold both light and heavy curtains.</li>\r\n \t<li>Dimension Options: Here are 3 sizes of the curtain rod that adjusts from 28-48, 48-86, and 101-144 inches for your choices, which are perfect for the office, bedroom, and living room.</li>\r\n \t<li>Rod Design: The curtain rod adopts a simple design, and the top decoration looks like a ball, which is very suitable for offices, children's rooms, bedrooms and living rooms.</li>\r\n \t<li>Wide Compatibility: The curtain rod will be suitable with both heavy and lightweight curtains also for all different curtain tops such as grommet, rod pocket, back tab, tab top, and so on.</li>\r\n</ul>",
        "imgSrc": "/cdn/shop/files/Silver-4-600x600.jpg",
        "hoverImg": "/cdn/shop/files/Silver-500x500.jpg",
        "subheading": "Adjustable Curtain Rod",
        "Fabrics": [
            "Birdcage"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 119,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 1177,
        "title": "Ball Finials Adjustable Double Curtain Rod",
        "ProductUrl": "/curtain-rod/1-inch-adjustable-double-curtain-rod-set-with-ball-finials-length-28-144-inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "890",
        "_fabric_color": [
            {
                "term_id": 890,
                "gallery": [
                    19979,
                    19978,
                    19980,
                    19981,
                    19982
                ],
                "imgSrc": "/cdn/shop/files/Matte-Black-2-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Matte-Black-2-2.jpg",
                "imgSrcF": "/cdn/shop/files/Matte-Black-2-2.jpg",
                "title": "Matte Black",
                "color": "Gold"
            },
            {
                "term_id": 899,
                "gallery": [
                    19987,
                    19983,
                    19984,
                    19985,
                    19986,
                    19988
                ],
                "imgSrc": "/cdn/shop/files/Antique-Brass-6-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Antique-Brass-6-2.jpg",
                "imgSrcF": "/cdn/shop/files/Antique-Brass-6-2.jpg",
                "title": "Antique Brass",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": "605",
                "gallery": null,
                "price": 0,
                "title": "28''-48''"
            },
            {
                "term_id": "599",
                "gallery": null,
                "price": 0,
                "title": "48''-86''"
            },
            {
                "term_id": "594",
                "gallery": null,
                "price": 0,
                "title": "101''-144''"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "All Accessories",
            "All Curtain Accessories",
            "Factory products",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "header",
                "name": "header"
            }
        ],
        "short_description": "<ul>\r\n \t<li>Basic Info: Sold by the double drapery rod set package. 1 inch diameter adjustable aluminum alloy curtain rod which is conveniently strong enough to hold both light and heavy curtains.</li>\r\n \t<li>Dimension Options: Here are 3 sizes of the curtain rod that adjusts from 28-48, 48-86, and 72-144 inches for your choices, which are perfect for the office, bedroom, and living room.</li>\r\n \t<li>Rod Design: The curtain rod adopts round finials which are natural and simple for any space decor such as bedroom, living room, kitchen, and sliding door.</li>\r\n \t<li>Wide Compatibility: The curtain rod will be suitable with both heavy and lightweight curtains also for all different curtain tops such as grommet, rod pocket, back tab, tab top, and so on.</li>\r\n</ul>",
        "imgSrc": "/cdn/shop/files/Matte-Black-2-2-600x600.jpg",
        "hoverImg": "/cdn/shop/files/Matte-Black-1-1-500x500.jpg",
        "subheading": "Adjustable Double Curtain Rod",
        "Fabrics": [
            "Ball Finials"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 119,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 1174,
        "title": "Reeded Ball Adjustable Finials Curtain Rod",
        "ProductUrl": "/curtain-rod/1-1-8-inch-adjustable-curtain-rod-with-reeded-ball-finials-length-28-144-inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "888",
        "_fabric_color": [
            {
                "term_id": 888,
                "gallery": [
                    19929,
                    19931,
                    19926,
                    19928,
                    19927,
                    19923,
                    19925,
                    19924,
                    19930,
                    19932
                ],
                "imgSrc": "/cdn/shop/files/1-Matte-White-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/1-Matte-White-8.jpg",
                "imgSrcF": "/cdn/shop/files/1-Matte-White-8.jpg",
                "title": "Matte White",
                "color": "Gold"
            },
            {
                "term_id": 887,
                "gallery": [
                    19919,
                    19922,
                    19921,
                    19920,
                    19918,
                    19917,
                    19916,
                    19915,
                    19914,
                    19913
                ],
                "imgSrc": "/cdn/shop/files/1-Matte-Black-6-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/1-Matte-Black-6.jpg",
                "imgSrcF": "/cdn/shop/files/1-Matte-Black-6.jpg",
                "title": "Matte Black",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 584,
                "gallery": null,
                "price": 0,
                "title": "48''-86''"
            },
            {
                "term_id": 585,
                "gallery": null,
                "price": 0,
                "title": "101''-144''"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "All Accessories",
            "All Curtain Accessories",
            "Factory products",
            "Fixed Size",
            "flash_categories",
            "New Product UI",
            "new rod UI",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "accessories",
                "name": "accessories"
            },
            {
                "slug": "curtain-rod",
                "name": "curtain rod"
            }
        ],
        "short_description": "<ul>\r\n \t<li>Basic Info: Sold by the single per package. 1 1/8 inch diameter adjustable aluminum alloy curtain rod which is conveniently strong enough to hold both light and heavy curtains.</li>\r\n \t<li>Dimension Options: Here are 3 sizes of the curtain rod that adjusts from 28-48, 48-86, and 72-144 inches for your choices, which are perfect for the office, bedroom, and living room.</li>\r\n \t<li>Rod Design: The curtain rod adopts petal ball finials which are simple but special for eye-catching.Suit any style of your home decor.</li>\r\n \t<li>Wide Compatibility: The curtain rod will be suitable with both heavy and lightweight curtains also for all different curtain tops such as grommet, rod pocket, back tab, tab top, and so on.</li>\r\n</ul>",
        "imgSrc": "/cdn/shop/files/1-Black-7-600x600.jpg",
        "hoverImg": "/cdn/shop/files/1-Black-5-500x500.jpg",
        "subheading": "Adjustable Finials Curtain Rod",
        "Fabrics": [
            "Reeded Ball"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 119,
        "newPrice": 107,
        "extra": "Extra 10%"
    },
    {
        "id": 1184,
        "title": "Antique Adjustable White Curtain Rod",
        "ProductUrl": "/curtain-rod/1-inch-adjustable-antique-white-curtain-rod-with-finials-length-28-144-inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "916",
        "_fabric_color": [
            {
                "term_id": 915,
                "gallery": [
                    20081,
                    20082,
                    20083,
                    20084,
                    20086,
                    20087,
                    20088,
                    20089,
                    20085
                ],
                "imgSrc": "/cdn/shop/files/Black-1-5-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-1-5.jpg",
                "imgSrcF": "/cdn/shop/files/Black-1-5.jpg",
                "title": "Black",
                "color": "Gold"
            },
            {
                "term_id": 916,
                "gallery": [
                    20091,
                    20090,
                    20094,
                    20093,
                    20092
                ],
                "imgSrc": "/cdn/shop/files/White-2-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/White-2-1.jpg",
                "imgSrcF": "/cdn/shop/files/White-4.jpg",
                "title": "White",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 493,
                "gallery": null,
                "price": 0,
                "title": "28''-48''"
            },
            {
                "term_id": 494,
                "gallery": null,
                "price": 0,
                "title": "48''-86''"
            },
            {
                "term_id": 495,
                "gallery": null,
                "price": 0,
                "title": "101''-144''"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "All Accessories",
            "All Curtain Accessories",
            "Black Friday",
            "Cyber Monday",
            "Factory products",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "Sale",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "header",
                "name": "header"
            }
        ],
        "short_description": "",
        "imgSrc": "/cdn/shop/files/White-2-1-1-600x600.jpg",
        "hoverImg": "/cdn/shop/files/White-12-500x500.jpg",
        "subheading": "Adjustable White Curtain Rod",
        "Fabrics": [
            "Antique"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 119,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 1181,
        "title": "Leaf Adjustable Brass Curtain Rod",
        "ProductUrl": "/curtain-rod/1-inch-adjustable-brass-curtain-rod-with-ivy-finials-length-28-144-inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "908",
        "_fabric_color": [
            {
                "term_id": 906,
                "gallery": [
                    20037,
                    20030,
                    20038,
                    20034,
                    20031,
                    20032,
                    20036,
                    20035,
                    20033
                ],
                "imgSrc": "/cdn/shop/files/Antique-Brass-9-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Antique-Brass-9.jpg",
                "imgSrcF": "/cdn/shop/files/Antique-Brass-9.jpg",
                "title": "Antique Brass",
                "color": "Gold"
            },
            {
                "term_id": 908,
                "gallery": [
                    20044,
                    20039,
                    20045,
                    20043,
                    20040
                ],
                "imgSrc": "/cdn/shop/files/Matte-Black-6-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Matte-Black-6-2.jpg",
                "imgSrcF": "/cdn/shop/files/Matte-Black-6-2.jpg",
                "title": "Matte Black",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 494,
                "gallery": null,
                "price": 0,
                "title": "48''-86''"
            },
            {
                "term_id": 495,
                "gallery": null,
                "price": 0,
                "title": "101''-144''"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "All Accessories",
            "All Curtain Accessories",
            "Factory products",
            "Fixed Size",
            "Independence Day",
            "New Product UI",
            "new rod UI",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "header",
                "name": "header"
            }
        ],
        "short_description": "<ul>\r\n \t<li>Basic Info: Sold by the single per package. 1 inch diameter adjustable aluminum alloy curtain rod which is conveniently strong enough to hold both light and heavy curtains.</li>\r\n \t<li>Dimension Options: Here are 3 sizes of the curtain rod that adjusts from 28-48, 48-86, and 101-144 inches for your choices, which are perfect for the office, bedroom, and living room.</li>\r\n \t<li>Rod Design: The unique design of 3 leaves, which are perfect for the office, bedroom, and living room.</li>\r\n \t<li>Wide Compatibility: The curtain rod will be suitable with both heavy and lightweight curtains also for all different curtain tops such as grommet, rod pocket, back tab, tab top, and so on.</li>\r\n</ul>",
        "imgSrc": "/cdn/shop/files/Matte-Black-6-2-600x600.jpg",
        "hoverImg": "/cdn/shop/files/Antique-Brass-4-2-500x500.jpg",
        "subheading": "Adjustable Brass Curtain Rod",
        "Fabrics": [
            "Leaf"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 119,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 1180,
        "title": "Crystal Adjustable Curtain Rod",
        "ProductUrl": "/curtain-rod/1-inch-adjustable-curtain-rod-with-crystal-finials-length-28-144-inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "905",
        "_fabric_color": [
            {
                "term_id": 903,
                "gallery": [
                    20008,
                    20011,
                    20010,
                    20012,
                    20009
                ],
                "imgSrc": "/cdn/shop/files/Black-1-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Black-1-2.jpg",
                "imgSrcF": "/cdn/shop/files/Black-1-2.jpg",
                "title": "Black",
                "color": "Gold"
            },
            {
                "term_id": 905,
                "gallery": [
                    20020,
                    20017,
                    20018,
                    20019,
                    20016,
                    20015,
                    20014,
                    20021
                ],
                "imgSrc": "/cdn/shop/files/Pink-8-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Pink-8.jpg",
                "imgSrcF": "/cdn/shop/files/Pink-4.jpg",
                "title": "Pink",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": "493",
                "gallery": null,
                "price": 0,
                "title": "28''-48''"
            },
            {
                "term_id": "494",
                "gallery": null,
                "price": 0,
                "title": "48''-86''"
            },
            {
                "term_id": "495",
                "gallery": null,
                "price": 0,
                "title": "101''-144''"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "All Accessories",
            "All Curtain Accessories",
            "Factory products",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "header",
                "name": "header"
            }
        ],
        "short_description": "<ul>\r\n \t<li>Basic Info: Sold by the single per package. 1 inch diameter adjustable aluminum alloy curtain rod which is conveniently strong enough to hold both light and heavy curtains.</li>\r\n \t<li>Dimension Options: Here are 3 sizes of the curtain rod that adjusts from 28-48, 48-86, and 101-144 inches for your choices, which are perfect for the office, bedroom, and living room.</li>\r\n \t<li>Rod Design: The curtain rod adopts antique white for the retro style and the finials look like trophy cups, which is perfect for the office, kids' room, bedroom, and living room.</li>\r\n \t<li>Wide Compatibility: The curtain rod will be suitable with both heavy and lightweight curtains also for all different curtain tops such as grommet, rod pocket, back tab, tab top, and so on.</li>\r\n</ul>",
        "imgSrc": "/cdn/shop/files/Pink-8-600x600.jpg",
        "hoverImg": "/cdn/shop/files/format_webp-22-500x500.jpg",
        "subheading": "Adjustable Curtain Rod",
        "Fabrics": [
            "Crystal"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 119,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 1185,
        "title": "Traditional Adjustable Curtain Rod",
        "ProductUrl": "/curtain-rod/5-8-inch-set-of-2-adjustable-curtain-rod-with-traditional-finials-length-28-144-inch/?fwidth=40&flength=40",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "918",
        "_fabric_color": [
            {
                "term_id": 918,
                "gallery": [
                    20102,
                    20097,
                    20095,
                    20098,
                    20100,
                    20099,
                    20101,
                    20096
                ],
                "imgSrc": "/cdn/shop/files/format_webp-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/format_webp-2.jpg",
                "imgSrcF": "/cdn/shop/files/format_webp-2.jpg",
                "title": "Black",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 493,
                "gallery": null,
                "price": 0,
                "title": "28''-48''"
            },
            {
                "term_id": 494,
                "gallery": null,
                "price": 0,
                "title": "48''-86''"
            },
            {
                "term_id": 495,
                "gallery": null,
                "price": 0,
                "title": "101''-144''"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "All Accessories",
            "All Curtain Accessories",
            "Factory products",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "Search Rod",
            "Curtain Rod"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "header",
                "name": "header"
            }
        ],
        "short_description": "<ul>\r\n \t<li>5/8 inch diameter adjustable aluminum alloy curtain rod which is conveniently strong enough to hold both light and heavy curtains.</li>\r\n \t<li>Dimension Options: Here are 3 sizes of the curtain rod that adjusts from 28-48, 48-86, and 101-144 inches for your choices, which are perfect for the office, bedroom, and living room.</li>\r\n \t<li>Rod Design: The curtain rod is perfect for the office, kids' room, bedroom, and living room.</li>\r\n \t<li>Wide Compatibility: The curtain rod will be suitable with both heavy and lightweight curtains also for all different curtain tops such as grommet, rod pocket, back tab, tab top, and so on.</li>\r\n</ul>",
        "imgSrc": "/cdn/shop/files/format_webp-2-600x600.jpg",
        "hoverImg": "/cdn/shop/files/format_webp-4-500x500.jpg",
        "subheading": "Adjustable Curtain Rod",
        "Fabrics": [
            "Traditional"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 119,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 38407,
        "title": "Turn Buckle Awning Fixed Canopy Tent Fixed Buckle",
        "ProductUrl": "/sun-shade-sail-accessories/awning-fixed-canopy-tent-fixed-buckle/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "38416",
        "_fabric_color": [
            {
                "term_id": 38416,
                "gallery": [
                    38412,
                    38415,
                    38414,
                    38413
                ],
                "imgSrc": "/cdn/shop/files/Spring-Buckle-1-500x500.webp",
                "imgSrc_n": "/cdn/shop/files/Spring-Buckle-1.webp",
                "imgSrcF": "/cdn/shop/files/Spring-Buckle-1.webp",
                "title": "Spring Buckle 1",
                "color": "Green"
            },
            {
                "term_id": 38423,
                "gallery": [
                    38425,
                    38415,
                    38412,
                    38414,
                    38413
                ],
                "imgSrc": "/cdn/shop/files/Spring-Buckle-12-Ring-Buckle-500x500.webp",
                "imgSrc_n": "/cdn/shop/files/Spring-Buckle-12-Ring-Buckle.webp",
                "imgSrcF": "/cdn/shop/files/Spring-Buckle-12-Ring-Buckle.webp",
                "title": "Spring Buckle 1+2 Ring Buckle",
                "color": "Green"
            },
            {
                "term_id": 38426,
                "gallery": [
                    38428,
                    38415,
                    38412,
                    38414,
                    38413
                ],
                "imgSrc": "/cdn/shop/files/Spring-Buckle-12-D-Ring-Buckle-500x500.webp",
                "imgSrc_n": "/cdn/shop/files/Spring-Buckle-12-D-Ring-Buckle.webp",
                "imgSrcF": "/cdn/shop/files/Spring-Buckle-12-D-Ring-Buckle.webp",
                "title": "Spring Buckle 1+2 D Ring Buckle",
                "color": "Green"
            },
            {
                "term_id": 38429,
                "gallery": [
                    38431,
                    38415,
                    38412,
                    38414,
                    38413
                ],
                "imgSrc": "/cdn/shop/files/Spring-Buckle-510-Ring-Buckle-500x500.webp",
                "imgSrc_n": "/cdn/shop/files/Spring-Buckle-510-Ring-Buckle.webp",
                "imgSrcF": "/cdn/shop/files/Spring-Buckle-510-Ring-Buckle.webp",
                "title": "Spring Buckle 5+10 Ring Buckle",
                "color": "Green"
            },
            {
                "term_id": 38433,
                "gallery": [
                    38435,
                    38415,
                    38412,
                    38414,
                    38413
                ],
                "imgSrc": "/cdn/shop/files/Spring-Buckle-510-D-Ring-Buckle-500x500.webp",
                "imgSrc_n": "/cdn/shop/files/Spring-Buckle-510-D-Ring-Buckle.webp",
                "imgSrcF": "/cdn/shop/files/Spring-Buckle-510-D-Ring-Buckle.webp",
                "title": "Spring Buckle 5+10 D Ring Buckle",
                "color": "Green"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories",
            "All Accessories",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "Search outdoor",
            "Search sail",
            "Sun Shade Sail",
            "Sun Shade Sail Accessories"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "product_image_test",
                "name": "product_image_test"
            },
            {
                "slug": "sun-shade-sails",
                "name": "Sun Shade Sails"
            }
        ],
        "short_description": "<div class=\"flex_accessories\">\r\n<div class=\"spec_left\">\r\n<h3 style=\"font-size: 24px;\">Specification</h3>\r\n<p class=\"feat_txt\"><strong>Package Included:  </strong>1 Pack of 1 pieces</p>\r\n\r\n</div>\r\n<div class=\"desc_right\">\r\n\r\n&nbsp;\r\n\r\n&nbsp;\r\n\r\n</div>\r\n</div>",
        "imgSrc": "/cdn/shop/files/Spring-Buckle-1-500x500.webp",
        "hoverImg": "/cdn/shop/files/Spring-Buckle-1-2-500x500.webp",
        "subheading": "Awning Fixed Canopy Tent Fixed Buckle",
        "Fabrics": [
            "Turn Buckle"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 69,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 57146,
        "title": "Bronze Decorative Curtain Holdbacks",
        "ProductUrl": "/tieback/bronze-decorative-curtain-holdbacks/?",
        "isNewArrival": true,
        "meetingExtraType": 0,
        "_is_default_fabric": "57150",
        "_fabric_color": [
            {
                "term_id": 57150,
                "gallery": [
                    57156,
                    57152,
                    57155,
                    57154,
                    57153,
                    57151
                ],
                "imgSrc": "/cdn/shop/files/Bronze-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Bronze.png",
                "imgSrcF": "/cdn/shop/files/bronze-4.jpg",
                "title": "Copper Gold",
                "color": "Green"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 56274,
                "gallery": null,
                "price": 0,
                "title": "1 PC"
            },
            {
                "term_id": 56277,
                "gallery": null,
                "price": 0,
                "title": "2 PCS"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "10% Off Sale",
            "Accessories",
            "Accessories New Arrivals",
            "All Accessories",
            "All Curtain Accessories",
            "Curtains Hooks Rings",
            "Fixed Size",
            "New Product UI",
            "new rod UI",
            "No Sale Coupons",
            "Outsourced products",
            "Search Hook",
            "Search tieback",
            "Tiebacks"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "<h3 style=\"font-size: 24px;\">Description</h3>\r\n<p class=\"feat_txt\">High Quality:  The product is made of high-quality non-woven fabric, soft and comfortable, not easy to fall, easy to clean, and reusable.</p>\r\n<p class=\"feat_txt\">Widely used:  These cute cartoon curtain buttons can be used in many situations. They are one of the essential holiday decorations in your home, suitable for bedrooms, bathrooms, kitchens, offices, etc.</p>",
        "imgSrc": "/cdn/shop/files/Bronze-500x500.png",
        "hoverImg": "/cdn/shop/files/bronze-4-500x500.jpg",
        "subheading": "Decorative Curtain Holdback",
        "Fabrics": [
            "Bronze"
        ],
        "Feature": [],
        "Material": [],
        "Pattern": [],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor",
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 90,
        "newPrice": 137,
        "extra": "Extra 10%"
    },
    {
        "id": 33693,
        "title": "Tablecloth Plaid Rectangle Polyester Scratch Resistant Fade Waterproof Tablecloth",
        "ProductUrl": "/tablecloth/plaid-rectangle-polyester-scratch-resistant-fade-waterproof-tablecloth/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "33744",
        "_fabric_color": [
            {
                "term_id": 33744,
                "gallery": [
                    33746,
                    33751,
                    33750,
                    33749,
                    33748,
                    33747
                ],
                "imgSrc": "/cdn/shop/files/60-x-84-inch-_White-_-Black-01-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/60-x-84-inch-_White-_-Black-01.jpg",
                "imgSrcF": "/cdn/shop/files/60-x-84-inch-_White-_-Black-03.jpg",
                "title": "White / Black",
                "color": "Gold"
            },
            {
                "term_id": 33736,
                "gallery": [
                    33738,
                    33743,
                    33742,
                    33741,
                    33740,
                    33739
                ],
                "imgSrc": "/cdn/shop/files/60-x-102-inch-_Taupe-_-White-01-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/60-x-102-inch-_Taupe-_-White-01.jpg",
                "imgSrcF": "/cdn/shop/files/60-x-102-inch-_Taupe-_-White-05.jpg",
                "title": "Taupe / White",
                "color": "Gold"
            },
            {
                "term_id": 33729,
                "gallery": [
                    33731,
                    33735,
                    33734,
                    33733,
                    33732
                ],
                "imgSrc": "/cdn/shop/files/60-x-84-inch-_Red-_-Black-01-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/60-x-84-inch-_Red-_-Black-01.jpg",
                "imgSrcF": "/cdn/shop/files/60-x-84-inch-_Red-_-Black-04.jpg",
                "title": "Red / Black",
                "color": "Gold"
            },
            {
                "term_id": 33719,
                "gallery": [
                    33721,
                    33727,
                    33726,
                    33725,
                    33724,
                    33723,
                    33722,
                    33728
                ],
                "imgSrc": "/cdn/shop/files/60-x-84-inch-_Patchwork-01-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/60-x-84-inch-_Patchwork-01.jpg",
                "imgSrcF": "/cdn/shop/files/60-x-84-inch-_Patchwork-08.jpg",
                "title": "Patchwork",
                "color": "Gold"
            },
            {
                "term_id": 33710,
                "gallery": [
                    33712,
                    33718,
                    33717,
                    33716,
                    33715,
                    33714,
                    33713
                ],
                "imgSrc": "/cdn/shop/files/60-x-84-inch-_Grey-_-White-01-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/60-x-84-inch-_Grey-_-White-01.jpg",
                "imgSrcF": "/cdn/shop/files/60-x-84-inch-_Grey-_-White-05.jpg",
                "title": "Grey / White",
                "color": "Gold"
            },
            {
                "term_id": 33702,
                "gallery": [
                    33704,
                    33708,
                    33707,
                    33706,
                    33705
                ],
                "imgSrc": "/cdn/shop/files/60-x-102-inch-_Black-_-White-01-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/60-x-102-inch-_Black-_-White-01.jpg",
                "imgSrcF": "/cdn/shop/files/60-x-102-inch-_Black-_-White-05.jpg",
                "title": "Black / White",
                "color": "Gold"
            },
            {
                "term_id": 33694,
                "gallery": [
                    33696,
                    33701,
                    33700,
                    33699,
                    33698,
                    33697
                ],
                "imgSrc": "/cdn/shop/files/60-x-102-inch-_Beige-_-White-01-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/60-x-102-inch-_Beige-_-White-01.jpg",
                "imgSrcF": "/cdn/shop/files/60-x-102-inch-_Beige-_-White-06.jpg",
                "title": "Beige / White",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 33590,
                "gallery": null,
                "price": 0,
                "title": "54\"L x 54\"W"
            },
            {
                "term_id": 33680,
                "gallery": null,
                "price": 0,
                "title": "60\"L x 60\"W"
            },
            {
                "term_id": 33678,
                "gallery": null,
                "price": 0,
                "title": "70\"L x 54\"W"
            },
            {
                "term_id": 33682,
                "gallery": null,
                "price": 0,
                "title": "84\"L x 60\"W"
            },
            {
                "term_id": 33684,
                "gallery": null,
                "price": 0,
                "title": "90\"L x 60\"W"
            },
            {
                "term_id": 33687,
                "gallery": null,
                "price": 0,
                "title": "102\"L x 60\"W"
            },
            {
                "term_id": 33689,
                "gallery": null,
                "price": 0,
                "title": "120\"L x 60\"W"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories",
            "All Accessories",
            "Factory products",
            "Fixed Size",
            "Gift Surprise",
            "Gift under $50",
            "New Product UI",
            "new rod UI",
            "Tablecloths"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "<p class=\"feat_txt\">Convenient Size:  Perfect Seating 8 to 10 People. Fits most folding buffet tables, outdoor picnic tables, kitchen &amp; dining tables.</p>\r\n<p class=\"feat_txt\">Spillproof: Keeps your table surface protected from spills and scratches. Spilled red wine on the table? No problem, just blot and wipe clean!</p>\r\n<p class=\"feat_txt\">Hard Wearing:  This versatile tablecloth is a perfect combination of waterproof, stain &amp; dust resistant, wrinkle-free and won't fade, tear, or pill after repeated use.</p>\r\n<p class=\"feat_txt\">Elegant Plaid:  Gingham table cover can create a modern &amp; ructic atmosphere and add a touch of elegance to any home decor. Great for an indoor dining or outdoor picnic settings.</p>\r\n<p class=\"feat_txt\">Easy Care:  Wipe clean with a damp cloth recommended. Machine washable. Iron at low temperature.</p>",
        "imgSrc": "/cdn/shop/files/60-x-102-inch-_Beige-_-White-01-500x500.jpg",
        "hoverImg": "/cdn/shop/files/60-x-102-inch-_Beige-_-White-02-500x500.jpg",
        "subheading": "Plaid Rectangle Polyester Scratch Resistant Fade Waterproof Tablecloth",
        "Fabrics": [
            "Tablecloth"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor",
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 93,
        "newPrice": 60,
        "extra": "Extra 10%"
    },
    {
        "id": 33907,
        "title": "Tablecloth Rectangular Linen Waterproof Wrinkle Resistant Patio Tablecloth",
        "ProductUrl": "/tablecloth/rectangular-linen-waterproof-wrinkle-resistant-patio-tablecloth/?",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "_is_default_fabric": "33932",
        "_fabric_color": [
            {
                "term_id": 33932,
                "gallery": [
                    34198,
                    33937,
                    33936,
                    33939,
                    33938,
                    33940
                ],
                "imgSrc": "/cdn/shop/files/W54xL78-Khaki-01-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/W54xL78-Khaki-01-1.jpg",
                "imgSrcF": "/cdn/shop/files/W54xL78-Khaki-03.jpg",
                "title": "Khaki",
                "color": "Gold"
            },
            {
                "term_id": 33917,
                "gallery": [
                    34197,
                    33915,
                    33913,
                    33928,
                    33914,
                    33916
                ],
                "imgSrc": "/cdn/shop/files/SKU-05-W60xL102-Grey-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/SKU-05-W60xL102-Grey.jpg",
                "imgSrcF": "/cdn/shop/files/W60xL102-Grey-05.jpg",
                "title": "Grey",
                "color": "Gold"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 33678,
                "gallery": null,
                "price": 0,
                "title": "70\"L x 54\"W"
            },
            {
                "term_id": 33682,
                "gallery": null,
                "price": 0,
                "title": "84\"L x 60\"W"
            },
            {
                "term_id": 33687,
                "gallery": null,
                "price": 0,
                "title": "102\"L x 60\"W"
            },
            {
                "term_id": 33689,
                "gallery": null,
                "price": 0,
                "title": "120\"L x 60\"W"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "Accessories",
            "All Accessories",
            "Factory products",
            "Fixed Size",
            "Gift Surprise",
            "Gift under $50",
            "New Product UI",
            "new rod UI",
            "Tablecloths"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [],
        "short_description": "<p class=\"feat_txt\">Faux Linen Textured:  Utilizes high quality import polyester fabric which forms it super durable, soft flexible and breathable. This rustic linen design along with the solid color makes the table cover neat and elegant.</p>\r\n<p class=\"feat_txt\">Proper Size:  Fit most folding buffet tables, kitchen &amp; dining tables, and outdoor picnic tables.</p>",
        "imgSrc": "/cdn/shop/files/SKU-05-W60xL102-Grey-500x500.jpg",
        "hoverImg": "/cdn/shop/files/menl_mobile-500x500.jpg",
        "subheading": "Rectangular Linen Waterproof Wrinkle Resistant Patio Tablecloth",
        "Fabrics": [
            "Tablecloth"
        ],
        "Feature": [],
        "Material": [
            "Linen"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Indoor",
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 97,
        "newPrice": 60,
        "extra": "Extra 10%"
    }
];
var rugList = [
	{
		"id": 61302,
		"title": "Diana&#8217;s Garden Deep Taupe Washable Area Rug",
		"ProductUrl": "/area-rugs/dianas-garden-deep-taupe-washable-area-rug/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "60574",
		"_fabric_color": [
			{
				"term_id": 60574,
				"gallery": [
					60537,
					60545,
					60543,
					60541,
					60540,
					60538
				],
				"imgSrc": "/cdn/shop/files/Deep-Taupe-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Deep-Taupe-1.jpg",
				"imgSrcF": "/cdn/shop/files/Deep-Taupe-1.png",
				"title": "Garden / Deep Taupe"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 60386,
				"gallery": null,
				"price": 0,
				"title": "2' x 3'"
			},
			{
				"term_id": 60388,
				"gallery": null,
				"price": 0,
				"title": "3' x 5'"
			},
			{
				"term_id": 60387,
				"gallery": null,
				"price": 0,
				"title": "4' x 6'"
			},
			{
				"term_id": 60390,
				"gallery": null,
				"price": 0,
				"title": "5' x 8'"
			},
			{
				"term_id": 60389,
				"gallery": null,
				"price": 0,
				"title": "6' x 9'"
			},
			{
				"term_id": 60391,
				"gallery": null,
				"price": 0,
				"title": "8' x 10'"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"10% Off Sale",
			"Factory products",
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Sale",
			"Washable Area Rug"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Deep-Taupe-1-500x500.jpg",
		"hoverImg": "",
		"subheading": "Deep Taupe Washable Area Rug",
		"Fabrics": [
			"Diana's Garden"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [],
		"Color": [],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Sale": "10% Off",
		"salenum": 10,
		"oldPrice": 116,
		"newPrice": 104
	},
	{
		"id": 61301,
		"title": "Diana&#8217;s Garden Denim Blue Washable Area Rug",
		"ProductUrl": "/area-rugs/dianas-garden-denim-blue-washable-area-rug/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "60578",
		"_fabric_color": [
			{
				"term_id": 60578,
				"gallery": [
					60546,
					60557,
					60554,
					60550,
					60549,
					60547,
					60553,
					60551
				],
				"imgSrc": "/cdn/shop/files/Denim-Blue-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Denim-Blue-1.jpg",
				"imgSrcF": "/cdn/shop/files/Denim-Blue-1.png",
				"title": "Garden / Denim Blue"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 60386,
				"gallery": null,
				"price": 0,
				"title": "2' x 3'"
			},
			{
				"term_id": 60388,
				"gallery": null,
				"price": 0,
				"title": "3' x 5'"
			},
			{
				"term_id": 60387,
				"gallery": null,
				"price": 0,
				"title": "4' x 6'"
			},
			{
				"term_id": 60390,
				"gallery": null,
				"price": 0,
				"title": "5' x 8'"
			},
			{
				"term_id": 60389,
				"gallery": null,
				"price": 0,
				"title": "6' x 9'"
			},
			{
				"term_id": 60391,
				"gallery": null,
				"price": 0,
				"title": "8' x 10'"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"10% Off Sale",
			"Easter Sale",
			"Factory products",
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Sale",
			"Washable Area Rug"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Denim-Blue-1-500x500.jpg",
		"hoverImg": "",
		"subheading": "Denim Blue Washable Area Rug",
		"Fabrics": [
			"Diana's Garden"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [],
		"Color": [],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Sale": "10% Off",
		"salenum": 10,
		"oldPrice": 116,
		"newPrice": 104
	},
	{
		"id": 61303,
		"title": "Diana&#8217;s Garden Gull Gray Washable Area Rug",
		"ProductUrl": "/area-rugs/dianas-garden-gull-gray-washable-area-rug/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "60580",
		"_fabric_color": [
			{
				"term_id": 60580,
				"gallery": [
					60558,
					60567,
					60565,
					60562,
					60561,
					60559
				],
				"imgSrc": "/cdn/shop/files/Gull-Gray-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Gull-Gray-1.jpg",
				"imgSrcF": "/cdn/shop/files/Gull-Gray-1.png",
				"title": "Garden / Gull Gray"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 60386,
				"gallery": null,
				"price": 0,
				"title": "2' x 3'"
			},
			{
				"term_id": 60388,
				"gallery": null,
				"price": 0,
				"title": "3' x 5'"
			},
			{
				"term_id": 60387,
				"gallery": null,
				"price": 0,
				"title": "4' x 6'"
			},
			{
				"term_id": 60390,
				"gallery": null,
				"price": 0,
				"title": "5' x 8'"
			},
			{
				"term_id": 60389,
				"gallery": null,
				"price": 0,
				"title": "6' x 9'"
			},
			{
				"term_id": 60391,
				"gallery": null,
				"price": 0,
				"title": "8' x 10'"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"10% Off Sale",
			"Factory products",
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Sale",
			"Washable Area Rug"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Gull-Gray-1-500x500.jpg",
		"hoverImg": "",
		"subheading": "Gull Gray Washable Area Rug",
		"Fabrics": [
			"Diana's Garden"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [],
		"Color": [],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Sale": "10% Off",
		"salenum": 10,
		"oldPrice": 116,
		"newPrice": 104
	},
	{
		"id": 60262,
		"title": "Diana&#8217;s Garden Washable Area Rug",
		"ProductUrl": "/area-rugs/dianas-garden-washable-area-rug/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "60582",
		"_fabric_color": [
			{
				"term_id": 60582,
				"gallery": [
					60568,
					60577,
					60575,
					60572,
					60571,
					60569
				],
				"imgSrc": "/cdn/shop/files/Red-Wine-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Red-Wine-1.jpg",
				"imgSrcF": "/cdn/shop/files/Red-Wine-1.png",
				"title": "Garden / Red Wine"
			},
			{
				"term_id": 60580,
				"gallery": [
					60558,
					60567,
					60565,
					60562,
					60561,
					60559
				],
				"imgSrc": "/cdn/shop/files/Gull-Gray-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Gull-Gray-1.jpg",
				"imgSrcF": "/cdn/shop/files/Gull-Gray-1.png",
				"title": "Garden / Gull Gray"
			},
			{
				"term_id": 60578,
				"gallery": [
					60546,
					60557,
					60554,
					60550,
					60549,
					60547,
					60553,
					60551
				],
				"imgSrc": "/cdn/shop/files/Denim-Blue-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Denim-Blue-1.jpg",
				"imgSrcF": "/cdn/shop/files/Denim-Blue-1.png",
				"title": "Garden / Denim Blue"
			},
			{
				"term_id": 60574,
				"gallery": [
					60537,
					60545,
					60543,
					60541,
					60540,
					60538
				],
				"imgSrc": "/cdn/shop/files/Deep-Taupe-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Deep-Taupe-1.jpg",
				"imgSrcF": "/cdn/shop/files/Deep-Taupe-1.png",
				"title": "Garden / Deep Taupe"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 60386,
				"gallery": null,
				"price": 0,
				"title": "2' x 3'"
			},
			{
				"term_id": 60388,
				"gallery": null,
				"price": 0,
				"title": "3' x 5'"
			},
			{
				"term_id": 60387,
				"gallery": null,
				"price": 0,
				"title": "4' x 6'"
			},
			{
				"term_id": 60390,
				"gallery": null,
				"price": 0,
				"title": "5' x 8'"
			},
			{
				"term_id": 60389,
				"gallery": null,
				"price": 0,
				"title": "6' x 9'"
			},
			{
				"term_id": 60391,
				"gallery": null,
				"price": 0,
				"title": "8' x 10'"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"10% Off Sale",
			"Easter Sale",
			"Factory products",
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Sale",
			"Spring Time Sale",
			"Washable Area Rug"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Red-Wine-1-500x500.jpg",
		"hoverImg": "",
		"subheading": "Washable Area Rug",
		"Fabrics": [
			"Diana's Garden"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [],
		"Color": [],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Sale": "10% Off",
		"salenum": 10,
		"oldPrice": 116,
		"newPrice": 104
	},
	{
		"id": 60264,
		"title": "Antique Terracotta Washable Area Rug",
		"ProductUrl": "/area-rugs/antique-terracotta-washable-area-rug/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "60626",
		"_fabric_color": [
			{
				"term_id": 60626,
				"gallery": [
					60628,
					60632,
					60639,
					60636,
					60637,
					60635,
					60633,
					60631,
					60629
				],
				"imgSrc": "/cdn/shop/files/Terracotta-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Terracotta-1.jpg",
				"imgSrcF": "/cdn/shop/files/Terracotta-1.png",
				"title": "Antique / Terracotta"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 60386,
				"gallery": null,
				"price": 0,
				"title": "2' x 3'"
			},
			{
				"term_id": 60388,
				"gallery": null,
				"price": 0,
				"title": "3' x 5'"
			},
			{
				"term_id": 60387,
				"gallery": null,
				"price": 0,
				"title": "4' x 6'"
			},
			{
				"term_id": 60390,
				"gallery": null,
				"price": 0,
				"title": "5' x 8'"
			},
			{
				"term_id": 60389,
				"gallery": null,
				"price": 0,
				"title": "6' x 9'"
			},
			{
				"term_id": 60391,
				"gallery": null,
				"price": 0,
				"title": "8' x 10'"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Spring Time Sale",
			"Washable Area Rug"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "Washed Antique Neutral Terracotta\r\n\r\n• Warm earthy tones that completments any space\r\n\r\n• Super versatile with subtle pattern that is elegant\r\n\r\n&nbsp;\r\n\r\nMachine Washable Rug\r\n\r\n• Highly easy low maintenance rugs that can be machine washed\r\n\r\n• Soft faux cashmere material that is soft and durable\r\n\r\n&nbsp;\r\n\r\nSPECIFICATIONS\r\n\r\n• Machine washable area rug\r\n\r\n• 100% faux cashmere\r\n\r\n• Weigh 1100 g/m²\r\n\r\n• Thickness 0.28\"\r\n\r\n&nbsp;\r\n\r\nCARE\r\n\r\n• Machine Washable - cold cycle only\r\n\r\n• Air dry recommended\r\n\r\n• Dryer on low heat only\r\n\r\n• Do not iron\r\n\r\n• Professional rug cleaning recommended when neccesary\r\n\r\n&nbsp;\r\n\r\nFREE FAST SHIPPING\r\n\r\n• Free shipping on all orders worldwide.",
		"imgSrc": "/cdn/shop/files/P-G230806W-500x500.jpg",
		"hoverImg": "",
		"subheading": "Washable Area Rug",
		"Fabrics": [
			"Antique Terracotta"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [],
		"Color": [],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 116,
		"newPrice": 104
	},
	{
		"id": 61319,
		"title": "Geometric Vintage Tara Dark Gray Washable Area Rug",
		"ProductUrl": "/area-rugs/geometric-vintage-tara-dark-gray-washable-area-rug/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "60624",
		"_fabric_color": [
			{
				"term_id": 60624,
				"gallery": [
					60585,
					60589,
					60596,
					60593,
					60594,
					60592,
					60590,
					60588,
					60586
				],
				"imgSrc": "/cdn/shop/files/Dark-Grey-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Dark-Grey-1.jpg",
				"imgSrcF": "/cdn/shop/files/Dark-Grey-1.png",
				"title": "Tara / Dark Gray"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 60386,
				"gallery": null,
				"price": 0,
				"title": "2' x 3'"
			},
			{
				"term_id": 60388,
				"gallery": null,
				"price": 0,
				"title": "3' x 5'"
			},
			{
				"term_id": 60387,
				"gallery": null,
				"price": 0,
				"title": "4' x 6'"
			},
			{
				"term_id": 60390,
				"gallery": null,
				"price": 0,
				"title": "5' x 8'"
			},
			{
				"term_id": 60391,
				"gallery": null,
				"price": 0,
				"title": "8' x 10'"
			},
			{
				"term_id": 60389,
				"gallery": null,
				"price": 0,
				"title": "6' x 9'"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Sale",
			"Washable Area Rug"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "Washed Geometric Print Design\r\n\r\n• Makes for a great accent rug, boasts shades of neutrals and cold tones\r\n\r\n• Beloved synthetic fiber that is soft and durable\r\n\r\n&nbsp;\r\n\r\nMachine Washable Rug\r\n\r\n• Highly easy low maintenance rugs that can be machine washed\r\n\r\n• Soft faux cashmere material that is soft\r\n\r\n&nbsp;\r\n\r\nSPECIFICATIONS\r\n\r\n• Machine washable area rug\r\n\r\n• 100% faux cashmere\r\n\r\n• Weigh 1100 g/m²\r\n\r\n• Thickness 0.28\"\r\n\r\n&nbsp;\r\n\r\nCARE\r\n\r\n• Machine Washable - cold cycle only\r\n\r\n• Air dry recommended\r\n\r\n• Dryer on low heat only\r\n\r\n• Do not iron\r\n\r\n• Professional rug cleaning recommended when neccesary\r\n\r\n&nbsp;\r\n\r\nFREE FAST SHIPPING\r\n\r\n• Free shipping on all orders worldwide.",
		"imgSrc": "/cdn/shop/files/Dark-Grey-1-500x500.jpg",
		"hoverImg": "",
		"subheading": "Vintage Tara Dark Gray Washable Area Rug",
		"Fabrics": [
			"Geometric"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [],
		"Color": [],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 116
	},
	{
		"id": 61320,
		"title": "Geometric Vintage Tara Neutral Washable Area Rug",
		"ProductUrl": "/area-rugs/geometric-vintage-tara-neutral-washable-area-rug/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "60619",
		"_fabric_color": [
			{
				"term_id": 60619,
				"gallery": [
					60597,
					60601,
					60605,
					60603,
					60600,
					60598,
					60606
				],
				"imgSrc": "/cdn/shop/files/Fog-Beige-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Fog-Beige-1.jpg",
				"imgSrcF": "/cdn/shop/files/Fog-Beige-1.png",
				"title": "Tara / Neutral"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 60386,
				"gallery": null,
				"price": 0,
				"title": "2' x 3'"
			},
			{
				"term_id": 60388,
				"gallery": null,
				"price": 0,
				"title": "3' x 5'"
			},
			{
				"term_id": 60387,
				"gallery": null,
				"price": 0,
				"title": "4' x 6'"
			},
			{
				"term_id": 60390,
				"gallery": null,
				"price": 0,
				"title": "5' x 8'"
			},
			{
				"term_id": 60391,
				"gallery": null,
				"price": 0,
				"title": "8' x 10'"
			},
			{
				"term_id": 60389,
				"gallery": null,
				"price": 0,
				"title": "6' x 9'"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Sale",
			"Washable Area Rug"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "Washed Geometric Print Design\r\n\r\n• Makes for a great accent rug, boasts shades of neutrals and cold tones\r\n\r\n• Beloved synthetic fiber that is soft and durable\r\n\r\n&nbsp;\r\n\r\nMachine Washable Rug\r\n\r\n• Highly easy low maintenance rugs that can be machine washed\r\n\r\n• Soft faux cashmere material that is soft\r\n\r\n&nbsp;\r\n\r\nSPECIFICATIONS\r\n\r\n• Machine washable area rug\r\n\r\n• 100% faux cashmere\r\n\r\n• Weigh 1100 g/m²\r\n\r\n• Thickness 0.28\"\r\n\r\n&nbsp;\r\n\r\nCARE\r\n\r\n• Machine Washable - cold cycle only\r\n\r\n• Air dry recommended\r\n\r\n• Dryer on low heat only\r\n\r\n• Do not iron\r\n\r\n• Professional rug cleaning recommended when neccesary\r\n\r\n&nbsp;\r\n\r\nFREE FAST SHIPPING\r\n\r\n• Free shipping on all orders worldwide.",
		"imgSrc": "/cdn/shop/files/Fog-Beige-1-500x500.jpg",
		"hoverImg": "",
		"subheading": "Vintage Tara Neutral Washable Area Rug",
		"Fabrics": [
			"Geometric"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [],
		"Color": [],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 116
	},
	{
		"id": 60265,
		"title": "Geometric Vintage Tara Washable Area Rug",
		"ProductUrl": "/product/geometric-washable-area-rug/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "60622",
		"_fabric_color": [
			{
				"term_id": 60622,
				"gallery": [
					60607,
					60611,
					60618,
					60615,
					60616,
					60614,
					60612,
					60610,
					60608
				],
				"imgSrc": "/cdn/shop/files/Warm-Gray-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Warm-Gray-1.jpg",
				"imgSrcF": "/cdn/shop/files/Warm-Gray-1.png",
				"title": "Tara / Blue Gray"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 60386,
				"gallery": null,
				"price": 0,
				"title": "2' x 3'"
			},
			{
				"term_id": 60388,
				"gallery": null,
				"price": 0,
				"title": "3' x 5'"
			},
			{
				"term_id": 60387,
				"gallery": null,
				"price": 0,
				"title": "4' x 6'"
			},
			{
				"term_id": 60390,
				"gallery": null,
				"price": 0,
				"title": "5' x 8'"
			},
			{
				"term_id": 60391,
				"gallery": null,
				"price": 0,
				"title": "8' x 10'"
			},
			{
				"term_id": 60389,
				"gallery": null,
				"price": 0,
				"title": "6' x 9'"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Washable Area Rug"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "Washed Geometric Print Design\r\n\r\n• Makes for a great accent rug, boasts shades of neutrals and cold tones\r\n\r\n• Beloved synthetic fiber that is soft and durable\r\n\r\n&nbsp;\r\n\r\nMachine Washable Rug\r\n\r\n• Highly easy low maintenance rugs that can be machine washed\r\n\r\n• Soft faux cashmere material that is soft\r\n\r\n&nbsp;\r\n\r\nSPECIFICATIONS\r\n\r\n• Machine washable area rug\r\n\r\n• 100% faux cashmere\r\n\r\n• Weigh 1100 g/m²\r\n\r\n• Thickness 0.28\"\r\n\r\n&nbsp;\r\n\r\nCARE\r\n\r\n• Machine Washable - cold cycle only\r\n\r\n• Air dry recommended\r\n\r\n• Dryer on low heat only\r\n\r\n• Do not iron\r\n\r\n• Professional rug cleaning recommended when neccesary\r\n\r\n&nbsp;\r\n\r\nFREE FAST SHIPPING\r\n\r\n• Free shipping on all orders worldwide.",
		"imgSrc": "/cdn/shop/files/Warm-Gray-1-500x500.jpg",
		"hoverImg": "",
		"subheading": "Vintage Tara Washable Area Rug",
		"Fabrics": [
			"Geometric"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [],
		"Color": [],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 116,
		"newPrice": 104
	},
	{
		"id": 61316,
		"title": "Mystic Clouds Warm Beige Washable Area Rug",
		"ProductUrl": "/area-rugs/mystic-clouds-warm-beige-washable-area-rug/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "60676",
		"_fabric_color": [
			{
				"term_id": 60676,
				"gallery": [
					60678,
					60690,
					60686,
					60700,
					60681,
					60683,
					60687,
					60685,
					60679
				],
				"imgSrc": "/cdn/shop/files/Warm-Beige-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Warm-Beige-1.jpg",
				"imgSrcF": "/cdn/shop/files/Warm-Beige-7.png",
				"title": "Mystic / Warm Beige"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 60386,
				"gallery": null,
				"price": 0,
				"title": "2' x 3'"
			},
			{
				"term_id": 60388,
				"gallery": null,
				"price": 0,
				"title": "3' x 5'"
			},
			{
				"term_id": 60387,
				"gallery": null,
				"price": 0,
				"title": "4' x 6'"
			},
			{
				"term_id": 60390,
				"gallery": null,
				"price": 0,
				"title": "5' x 8'"
			},
			{
				"term_id": 60389,
				"gallery": null,
				"price": 0,
				"title": "6' x 9'"
			},
			{
				"term_id": 60391,
				"gallery": null,
				"price": 0,
				"title": "8' x 10'"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"Fixed Size",
			"Gift Surprise",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Washable Area Rug"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "Fade Mystic Clouds Print Design\r\n\r\n• Decorate your space with this simple subdued pattern\r\n\r\n• Crafted in neutral colors to seemlessly blend into your space\r\n\r\n&nbsp;\r\n\r\nMachine Washable Rug\r\n\r\n• Highly easy low maintenance rugs that can be machine washed\r\n\r\n• Soft faux cashmere material that is soft and\r\n\r\n&nbsp;\r\n\r\nSPECIFICATIONS\r\n\r\n• Machine washable area rug\r\n\r\n• 100% faux cashmere\r\n\r\n• Weigh 1100 g/m²\r\n\r\n• Thickness Approx. 0.24''\r\n\r\n&nbsp;\r\n\r\nCARE\r\n\r\n• Machine Washable - cold cycle only\r\n\r\n• Air dry recommended\r\n\r\n• Dryer on low heat only\r\n\r\n• Do not iron\r\n\r\n• Professional rug cleaning recommended when neccesary\r\n\r\n&nbsp;\r\n\r\nFREE FAST SHIPPING\r\n\r\n• Free shipping on all orders worldwide.",
		"imgSrc": "/cdn/shop/files/Warm-Beige-1-500x500.jpg",
		"hoverImg": "",
		"subheading": "Warm Beige Washable Area Rug",
		"Fabrics": [
			"Mystic Clouds"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [],
		"Color": [],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 116
	},
	{
		"id": 60263,
		"title": "Mystic Clouds Washable Area Rug",
		"ProductUrl": "/area-rugs/washable-mystic-clouds-area-rug/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "60704",
		"_fabric_color": [
			{
				"term_id": 60704,
				"gallery": [
					60692,
					60694,
					60696,
					60700,
					60701,
					60699,
					60697,
					60695,
					60703
				],
				"imgSrc": "/cdn/shop/files/Blue-Gray-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Blue-Gray-1.jpg",
				"imgSrcF": "/cdn/shop/files/Blue-Gray-1.png",
				"title": "Mystic / Blue Gray"
			},
			{
				"term_id": 60676,
				"gallery": [
					60678,
					60690,
					60686,
					60700,
					60681,
					60683,
					60687,
					60685,
					60679
				],
				"imgSrc": "/cdn/shop/files/Warm-Beige-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Warm-Beige-1.jpg",
				"imgSrcF": "/cdn/shop/files/Warm-Beige-7.png",
				"title": "Mystic / Warm Beige"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 60386,
				"gallery": null,
				"price": 0,
				"title": "2' x 3'"
			},
			{
				"term_id": 60388,
				"gallery": null,
				"price": 0,
				"title": "3' x 5'"
			},
			{
				"term_id": 60387,
				"gallery": null,
				"price": 0,
				"title": "4' x 6'"
			},
			{
				"term_id": 60390,
				"gallery": null,
				"price": 0,
				"title": "5' x 8'"
			},
			{
				"term_id": 60389,
				"gallery": null,
				"price": 0,
				"title": "6' x 9'"
			},
			{
				"term_id": 60391,
				"gallery": null,
				"price": 0,
				"title": "8' x 10'"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"Fixed Size",
			"Gift Surprise",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Spring Time Sale",
			"Washable Area Rug"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "area-rugs",
				"name": "area rugs"
			},
			{
				"slug": "custom-rugs",
				"name": "custom rugs"
			},
			{
				"slug": "rugs",
				"name": "rugs"
			}
		],
		"short_description": "Fade Mystic Clouds Print Design\r\n\r\n• Decorate your space with this simple subdued pattern\r\n\r\n• Crafted in neutral colors to seemlessly blend into your space\r\n\r\n&nbsp;\r\n\r\nMachine Washable Rug\r\n\r\n• Highly easy low maintenance rugs that can be machine washed\r\n\r\n• Soft faux cashmere material that is soft and\r\n\r\n&nbsp;\r\n\r\nSPECIFICATIONS\r\n\r\n• Machine washable area rug\r\n\r\n• 100% faux cashmere\r\n\r\n• Weigh 1100 g/m²\r\n\r\n• Thickness 0.28\"\r\n\r\n&nbsp;\r\n\r\nCARE\r\n\r\n• Machine Washable - cold cycle only\r\n\r\n• Air dry recommended\r\n\r\n• Dryer on low heat only\r\n\r\n• Do not iron\r\n\r\n• Professional rug cleaning recommended when neccesary\r\n\r\n&nbsp;\r\n\r\nFREE FAST SHIPPING\r\n\r\n• Free shipping on all orders worldwide.",
		"imgSrc": "/cdn/shop/files/P-H231049W-500x500.jpg",
		"hoverImg": "",
		"subheading": "Washable Area Rug",
		"Fabrics": [
			"Mystic Clouds"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [],
		"Color": [],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 116,
		"newPrice": 104
	},
	{
		"id": 61318,
		"title": "Vintage Faded Moroccan Light Washable Area Rug",
		"ProductUrl": "/area-rugs/vintage-faded-moroccan-light-washable-area-rug/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "60670",
		"_fabric_color": [
			{
				"term_id": 60670,
				"gallery": [
					60649,
					60657,
					60655,
					60653,
					60652,
					60650
				],
				"imgSrc": "/cdn/shop/files/Light-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Light-1.jpg",
				"imgSrcF": "/cdn/shop/files/Light-1.png",
				"title": "Moroccan / Light"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 60386,
				"gallery": null,
				"price": 0,
				"title": "2' x 3'"
			},
			{
				"term_id": 60388,
				"gallery": null,
				"price": 0,
				"title": "3' x 5'"
			},
			{
				"term_id": 60387,
				"gallery": null,
				"price": 0,
				"title": "4' x 6'"
			},
			{
				"term_id": 60390,
				"gallery": null,
				"price": 0,
				"title": "5' x 8'"
			},
			{
				"term_id": 60389,
				"gallery": null,
				"price": 0,
				"title": "6' x 9'"
			},
			{
				"term_id": 60391,
				"gallery": null,
				"price": 0,
				"title": "8' x 10'"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Sale",
			"Washable Area Rug"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "Faded Pattern On Vintage Prints\r\n\r\n• Elegant timeless design with neutral undertones\r\n\r\n• Sumptuous antique look that never goes out of style\r\n\r\n&nbsp;\r\n\r\nMachine Washable Rug\r\n\r\n• Highly easy low maintenance rugs that can be machine washed\r\n\r\n• Soft faux cashmere material that is soft\r\n\r\n&nbsp;\r\n\r\nSPECIFICATIONS\r\n\r\n• Machine washable area rug\r\n\r\n• 100% faux cashmere\r\n\r\n• Weigh 1100 g/m²\r\n\r\n• Thickness 0.28\"\r\n\r\n&nbsp;\r\n\r\nCARE\r\n\r\n• Machine Washable - cold cycle only\r\n\r\n• Air dry recommended\r\n\r\n• Dryer on low heat only\r\n\r\n• Do not iron\r\n\r\n• Professional rug cleaning recommended when neccesary\r\n\r\n&nbsp;\r\n\r\nFREE FAST SHIPPING\r\n\r\n• Free shipping on all orders worldwide.",
		"imgSrc": "/cdn/shop/files/Light-1-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Light-7-500x500.jpg",
		"subheading": "Faded Moroccan Light Washable Area Rug",
		"Fabrics": [
			"Vintage Faded Moroccan"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [],
		"Color": [],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 116
	},
	{
		"id": 60266,
		"title": "Vintage Faded Moroccan Washable Area Rug",
		"ProductUrl": "/area-rugs/vintage-faded-moroccan-washable-area-rug/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "60645",
		"_fabric_color": [
			{
				"term_id": 60670,
				"gallery": [
					60649,
					60657,
					60655,
					60653,
					60652,
					60650
				],
				"imgSrc": "/cdn/shop/files/Light-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Light-1.jpg",
				"imgSrcF": "/cdn/shop/files/Light-1.png",
				"title": "Moroccan / Light"
			},
			{
				"term_id": 60645,
				"gallery": [
					60658,
					60669,
					60667,
					60666,
					60665,
					60663,
					60662,
					60661,
					60659
				],
				"imgSrc": "/cdn/shop/files/Dark-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Dark-1.jpg",
				"imgSrcF": "/cdn/shop/files/Dark-1.png",
				"title": "Moroccan / Dark"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 60386,
				"gallery": null,
				"price": 0,
				"title": "2' x 3'"
			},
			{
				"term_id": 60388,
				"gallery": null,
				"price": 0,
				"title": "3' x 5'"
			},
			{
				"term_id": 60387,
				"gallery": null,
				"price": 0,
				"title": "4' x 6'"
			},
			{
				"term_id": 60390,
				"gallery": null,
				"price": 0,
				"title": "5' x 8'"
			},
			{
				"term_id": 60389,
				"gallery": null,
				"price": 0,
				"title": "6' x 9'"
			},
			{
				"term_id": 60391,
				"gallery": null,
				"price": 0,
				"title": "8' x 10'"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"10% Off Sale",
			"Factory products",
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Washable Area Rug"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "Faded Pattern On Vintage Prints\r\n\r\n• Elegant timeless design with neutral undertones\r\n\r\n• Sumptuous antique look that never goes out of style\r\n\r\n&nbsp;\r\n\r\nMachine Washable Rug\r\n\r\n• Highly easy low maintenance rugs that can be machine washed\r\n\r\n• Soft faux cashmere material that is soft\r\n\r\n&nbsp;\r\n\r\nSPECIFICATIONS\r\n\r\n• Machine washable area rug\r\n\r\n• 100% faux cashmere\r\n\r\n• Weigh 1100 g/m²\r\n\r\n• Thickness Approx. 0.24''\r\n\r\n&nbsp;\r\n\r\nCARE\r\n\r\n• Machine Washable - cold cycle only\r\n\r\n• Air dry recommended\r\n\r\n• Dryer on low heat only\r\n\r\n• Do not iron\r\n\r\n• Professional rug cleaning recommended when neccesary\r\n\r\n&nbsp;\r\n\r\nFREE FAST SHIPPING\r\n\r\n• Free shipping on all orders worldwide.",
		"imgSrc": "/cdn/shop/files/LP-M240205N-500x500.jpg",
		"hoverImg": "",
		"subheading": "Faded Moroccan Washable Area Rug",
		"Fabrics": [
			"Vintage Faded Moroccan"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [],
		"Color": [],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Sale": "10% Off",
		"salenum": 10,
		"oldPrice": 116,
		"newPrice": 104
	}
];
var samplesaleList = [
	{
		"id": 103134,
		"title": "Alice 46 x 95 Inch Triple French Pinch Pleat Pink Dotted Patterned Textured Curtain",
		"ProductUrl": "/sale/alice-46-x-95-inch-triple-french-pinch-pleat-pink-dotted-patterned-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64046",
		"_fabric_color": [
			{
				"term_id": 64046,
				"gallery": [
					95764,
					95765,
					95768,
					95767,
					95766
				],
				"imgSrc": "/cdn/shop/files/Alice-Pink-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Alice-Pink-1.png",
				"imgSrcF": "/cdn/shop/files/2402-34-657-1.png",
				"title": "Alice / Pink",
				"color": "Pink"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"65% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Alice-Pink-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Alice-Pink-4-500x500.png",
		"subheading": "46 x 95 Inch Triple French Pinch Pleat Pink Dotted Patterned Textured Curtain",
		"Fabrics": [
			"Alice"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Pink"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "65% Off",
		"salenum": 65,
		"oldPrice": 441,
		"newPrice": 154
	},
	{
		"id": 103133,
		"title": "Alice 47 x 94 Inch Triple French Pinch Pleat Pink Dotted Patterned Textured Curtain",
		"ProductUrl": "/sale/alice-47-x-94-inch-triple-french-pinch-pleat-pink-dotted-patterned-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64046",
		"_fabric_color": [
			{
				"term_id": 64046,
				"gallery": [
					95764,
					95765,
					95768,
					95767,
					95766
				],
				"imgSrc": "/cdn/shop/files/Alice-Pink-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Alice-Pink-1.png",
				"imgSrcF": "/cdn/shop/files/2402-34-657-1.png",
				"title": "Alice / Pink",
				"color": "Pink"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"65% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Alice-Pink-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Alice-Pink-4-500x500.png",
		"subheading": "47 x 94 Inch Triple French Pinch Pleat Pink Dotted Patterned Textured Curtain",
		"Fabrics": [
			"Alice"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Pink"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "65% Off",
		"salenum": 65,
		"oldPrice": 439,
		"newPrice": 154
	},
	{
		"id": 103135,
		"title": "Alice 80 x 123 Inch Triple French Pinch Pleat Pink Dotted Patterned Textured Curtain",
		"ProductUrl": "/sale/alice-80-x-123-inch-triple-french-pinch-pleat-pink-dotted-patterned-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64046",
		"_fabric_color": [
			{
				"term_id": 64046,
				"gallery": [
					95764,
					95765,
					95768,
					95767,
					95766
				],
				"imgSrc": "/cdn/shop/files/Alice-Pink-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Alice-Pink-1.png",
				"imgSrcF": "/cdn/shop/files/2402-34-657-1.png",
				"title": "Alice / Pink",
				"color": "Pink"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"65% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Alice-Pink-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Alice-Pink-4-500x500.png",
		"subheading": "80 x 123 Inch Triple French Pinch Pleat Pink Dotted Patterned Textured Curtain",
		"Fabrics": [
			"Alice"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Pink"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "65% Off",
		"salenum": 65,
		"oldPrice": 927,
		"newPrice": 324
	},
	{
		"id": 103136,
		"title": "Alice 81 x 123 Inch Triple French Pinch Pleat Pink Dotted Patterned Textured Curtain",
		"ProductUrl": "/sale/alice-81-x-123-inch-triple-french-pinch-pleat-pink-dotted-patterned-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64046",
		"_fabric_color": [
			{
				"term_id": 64046,
				"gallery": [
					95764,
					95765,
					95768,
					95767,
					95766
				],
				"imgSrc": "/cdn/shop/files/Alice-Pink-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Alice-Pink-1.png",
				"imgSrcF": "/cdn/shop/files/2402-34-657-1.png",
				"title": "Alice / Pink",
				"color": "Pink"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"65% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Alice-Pink-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Alice-Pink-4-500x500.png",
		"subheading": "81 x 123 Inch Triple French Pinch Pleat Pink Dotted Patterned Textured Curtain",
		"Fabrics": [
			"Alice"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Pink"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "65% Off",
		"salenum": 65,
		"oldPrice": 928,
		"newPrice": 325
	},
	{
		"id": 103150,
		"title": "Glint 38 x 106 Inch Inverted Box Pleat Cream Linen Shimmering Textured Curtain",
		"ProductUrl": "/sale/glint-38-x-106-inch-inverted-box-pleat-cream-linen-shimmering-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64089",
		"_fabric_color": [
			{
				"term_id": 64089,
				"gallery": [
					65344,
					65345,
					66092,
					65346,
					65347,
					65343,
					65342,
					65341,
					65348
				],
				"imgSrc": "/cdn/shop/files/Cream-4-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Cream-4-1.jpg",
				"imgSrcF": "/cdn/shop/files/Cream-glint.png",
				"title": "Glint / Cream",
				"color": "Beige"
			},
			{
				"term_id": 64088,
				"gallery": [
					66093,
					65344,
					65345,
					65346,
					65347,
					65343,
					65342,
					65341,
					65348
				],
				"imgSrc": "/cdn/shop/files/Sesame-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sesame-1.png",
				"imgSrcF": "/cdn/shop/files/Sesame-1.png",
				"title": "Glint / Sesame",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"60% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale",
			"Room Darkening Curtains"
		],
		"isBestseller": false,
		"isPremiere": true,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "premiere",
				"name": "premiere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Cream-4-1-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Cream-3-1-500x500.jpg",
		"subheading": "38 x 106 Inch Inverted Box Pleat Cream Linen Shimmering Textured Curtain",
		"Fabrics": [
			"Glint"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Grey"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 397,
		"newPrice": 159
	},
	{
		"id": 103152,
		"title": "Glint 51 x 98 Inch Inverted Box Pleat Cream Linen Shimmering Textured Curtain",
		"ProductUrl": "/sale/glint-51-x-98-inch-inverted-box-pleat-cream-linen-shimmering-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64088",
		"_fabric_color": [
			{
				"term_id": 64088,
				"gallery": [
					66093,
					65344,
					65345,
					65346,
					65347,
					65343,
					65342,
					65341,
					65348
				],
				"imgSrc": "/cdn/shop/files/Sesame-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sesame-1.png",
				"imgSrcF": "/cdn/shop/files/Sesame-1.png",
				"title": "Glint / Sesame",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"60% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": true,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "premiere",
				"name": "premiere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Cream-4-1-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Cream-3-1-500x500.jpg",
		"subheading": "51 x 98 Inch Inverted Box Pleat Cream Linen Shimmering Textured Curtain",
		"Fabrics": [
			"Glint"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Grey"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 392,
		"newPrice": 157
	},
	{
		"id": 103204,
		"title": "Grace 35 x 103 Inch Double French Pinch Pleat Oatmeal Wool Textured Sheer Curtain",
		"ProductUrl": "/sale/grace-35-x-103-inch-double-french-pinch-pleat-oatmeal-wool-textured-sheer-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64078",
		"_fabric_color": [
			{
				"term_id": 64078,
				"gallery": [
					95823,
					95824,
					95828,
					96726,
					95827,
					95826,
					95825
				],
				"imgSrc": "/cdn/shop/files/Grace-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Grace-1.png",
				"imgSrcF": "/cdn/shop/files/Oatmeal-8.png",
				"title": "Grace / Oatmeal",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Grace-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Grace-3-500x500.png",
		"subheading": "35 x 103 Inch Double French Pinch Pleat Oatmeal Wool Textured Sheer Curtain",
		"Fabrics": [
			"Grace"
		],
		"Feature": [],
		"Material": [
			"Sheer",
			"Wool"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 381,
		"newPrice": 114
	},
	{
		"id": 103251,
		"title": "Mist 39 x 107 Inch Double French Pinch Pleat Ash Patterned Curtain",
		"ProductUrl": "/sale/mist-39-x-107-inch-double-french-pinch-pleat-ash-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64052",
		"_fabric_color": [
			{
				"term_id": 64052,
				"gallery": [
					98250,
					98251,
					98252,
					98255,
					98253,
					98254,
					96395
				],
				"imgSrc": "/cdn/shop/files/1-12-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/1-12.jpg",
				"imgSrcF": "/cdn/shop/files/ash-4-1.png",
				"title": "Mist / Ash",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Mist-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Mist-4-500x500.png",
		"subheading": "39 x 107 Inch Double French Pinch Pleat Ash Patterned Curtain",
		"Fabrics": [
			"Mist"
		],
		"Feature": [],
		"Material": [
			"Cotton"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Grey"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 628,
		"newPrice": 157
	},
	{
		"id": 103253,
		"title": "Mist 52 x 95 Inch Double French Pinch Pleat Ash Patterned Curtain",
		"ProductUrl": "/sale/mist-52-x-95-inch-double-french-pinch-pleat-ash-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64052",
		"_fabric_color": [
			{
				"term_id": 64052,
				"gallery": [
					98250,
					98251,
					98252,
					98255,
					98253,
					98254,
					96395
				],
				"imgSrc": "/cdn/shop/files/1-12-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/1-12.jpg",
				"imgSrcF": "/cdn/shop/files/ash-4-1.png",
				"title": "Mist / Ash",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Mist-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Mist-4-500x500.png",
		"subheading": "Mist 52 x 95 Inch Double French Pinch Pleat Ash Patterned Curtain",
		"Fabrics": [
			"Mist"
		],
		"Feature": [],
		"Material": [
			"Cotton"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Grey"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 486,
		"newPrice": 122
	},
	{
		"id": 103058,
		"title": "Nirvana 48 x 95 Inch Goblet Velvet Floral Patterned Curtain",
		"ProductUrl": "/sale/nirvana-48-x-95-inch-goblet-velvet-floral-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64064",
		"_fabric_color": [
			{
				"term_id": 64064,
				"gallery": [
					65672,
					65674,
					65668,
					65670,
					65671,
					97075,
					97072,
					65673,
					65669
				],
				"imgSrc": "/cdn/shop/files/Nirvana-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Nirvana-2.png",
				"imgSrcF": "/cdn/shop/files/Anderson.png",
				"title": "Nirvana / Nirvana",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"60% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/anderson-3-500x500.png",
		"hoverImg": "/cdn/shop/files/Anderson-3-500x500.jpg",
		"subheading": "48 x 95 Inch Goblet Velvet Floral Patterned Curtain",
		"Fabrics": [
			"Nirvana"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Floral"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Goblet Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 383,
		"newPrice": 153
	},
	{
		"id": 103057,
		"title": "Nirvana 79 x 125 inch Goblet Velvet Floral Patterned Curtain",
		"ProductUrl": "/sale/nirvana-79-x-125-inch-goblet-velvet-floral-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64064",
		"_fabric_color": [
			{
				"term_id": 64064,
				"gallery": [
					65672,
					65674,
					65668,
					65670,
					65671,
					97075,
					97072,
					65673,
					65669
				],
				"imgSrc": "/cdn/shop/files/Nirvana-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Nirvana-2.png",
				"imgSrcF": "/cdn/shop/files/Anderson.png",
				"title": "Nirvana / Nirvana",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"60% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/anderson-3-500x500.png",
		"hoverImg": "/cdn/shop/files/Anderson-3-500x500.jpg",
		"subheading": "79 x 125 Inch Goblet Velvet Floral Patterned Curtain",
		"Fabrics": [
			"Nirvana"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Floral"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Goblet Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 689,
		"newPrice": 276
	},
	{
		"id": 103312,
		"title": "Petra 52 x107 Inch Inverted Box Pleat Lit Geometric Patterned Curtain",
		"ProductUrl": "/sale/petra-52-x107-inch-inverted-box-pleat-lit-geometric-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64085",
		"_fabric_color": [
			{
				"term_id": 64085,
				"gallery": [
					97077,
					97078,
					97089,
					97080,
					97082,
					97081,
					97079
				],
				"imgSrc": "/cdn/shop/files/Petra-Lit-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Petra-Lit-1.png",
				"imgSrcF": "/cdn/shop/files/FB-KF0401.jpg",
				"title": "Petra / Lit",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Petra-Lit-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Petra-Lit-3-500x500.png",
		"subheading": "52 x107 Inch Inverted Box Pleat Lit Geometric Patterned Curtain",
		"Fabrics": [
			"Petra"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Blackout",
			"Light Filtering"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 592,
		"newPrice": 178
	},
	{
		"id": 103148,
		"title": "Glimmer 39 x 108 Inch Inverted Box Pleat Linen Lightweight Textured Curtain",
		"ProductUrl": "/sale/glimmer-39-x-108-inch-inverted-box-pleat-linen-lightweight-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64073",
		"_fabric_color": [
			{
				"term_id": 64073,
				"gallery": [
					64412,
					64410,
					64411,
					64409,
					97627,
					97629,
					97630,
					97631,
					65705
				],
				"imgSrc": "/cdn/shop/files/Glimmer-3-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Glimmer-3.jpg",
				"imgSrcF": "/cdn/shop/files/glimmer-color.png",
				"title": "Glimmer / Glimmer",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"80% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": true,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "bestseller",
				"name": "bestseller"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Glimmer-3-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Glimmer-6-1-500x500.jpg",
		"subheading": "39 x 108 Inch Inverted Box Pleat Linen Lightweight Textured Curtain",
		"Fabrics": [
			"Glimmer"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "80% Off",
		"salenum": 80,
		"oldPrice": 786,
		"newPrice": 157
	},
	{
		"id": 103149,
		"title": "Glimmer 52 x 56 Inch Inverted Box Pleat Linen Lightweight Textured Curtain",
		"ProductUrl": "/sale/glimmer-52-x-56-inch-inverted-box-pleat-linen-lightweight-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64073",
		"_fabric_color": [
			{
				"term_id": 64073,
				"gallery": [
					64412,
					64410,
					64411,
					64409,
					97627,
					97629,
					97630,
					97631,
					65705
				],
				"imgSrc": "/cdn/shop/files/Glimmer-3-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Glimmer-3.jpg",
				"imgSrcF": "/cdn/shop/files/glimmer-color.png",
				"title": "Glimmer / Glimmer",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"80% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": true,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "bestseller",
				"name": "bestseller"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Glimmer-3-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Glimmer-6-1-500x500.jpg",
		"subheading": "52 x 56 Inch Inverted Box Pleat Linen Lightweight Textured Curtain",
		"Fabrics": [
			"Glimmer"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "80% Off",
		"salenum": 80,
		"oldPrice": 489,
		"newPrice": 98
	},
	{
		"id": 103031,
		"title": "Aztec 43 x 118 inch Goblet Black Linen Patterned Curtain",
		"ProductUrl": "/sale/aztec-43-x-118-inch-goblet-black-linen-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64059",
		"_fabric_color": [
			{
				"term_id": 64059,
				"gallery": [
					94731,
					94730,
					94738,
					94726,
					94725,
					94728,
					94727,
					94732
				],
				"imgSrc": "/cdn/shop/files/2405-6-661-4-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/2405-6-661-4.jpg",
				"imgSrcF": "/cdn/shop/files/2405-6-661-color-3.png",
				"title": "Aztec / Black",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"65% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale",
			"Search faux linen blackout"
		],
		"isBestseller": false,
		"isPremiere": true,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "premiere",
				"name": "premiere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/2405-6-661-4-500x500.jpg",
		"hoverImg": "/cdn/shop/files/2405-6-661-1-500x500.jpg",
		"subheading": "43 x 118 inch Goblet Black Linen Patterned Curtain",
		"Fabrics": [
			"Aztec"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Black"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Goblet Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "65% Off",
		"salenum": 65,
		"oldPrice": 523,
		"newPrice": 183
	},
	{
		"id": 103035,
		"title": "Aztec 52 x 95 inch Goblet Black Linen Patterned Curtain",
		"ProductUrl": "/sale/aztec-52-x-95-inch-goblet-black-linen-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64059",
		"_fabric_color": [
			{
				"term_id": 64059,
				"gallery": [
					94731,
					94730,
					94738,
					94726,
					94725,
					94728,
					94727,
					94732
				],
				"imgSrc": "/cdn/shop/files/2405-6-661-4-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/2405-6-661-4.jpg",
				"imgSrcF": "/cdn/shop/files/2405-6-661-color-3.png",
				"title": "Aztec / Black",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"65% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": true,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "premiere",
				"name": "premiere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/2405-6-661-4-500x500.jpg",
		"hoverImg": "/cdn/shop/files/2405-6-661-1-500x500.jpg",
		"subheading": "52 x 95 inch Goblet Black Linen Patterned Curtain",
		"Fabrics": [
			"Aztec"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Black"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Goblet Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "65% Off",
		"salenum": 65,
		"oldPrice": 471,
		"newPrice": 165
	},
	{
		"id": 103055,
		"title": "Brushstrokes 47 x 95 inch Triple French Pinch Pleat Black Cotton Unique Patterned Curtain",
		"ProductUrl": "/sale/brushstrokes-47-x-95-inch-triple-french-pinch-pleat-black-cotton-unique-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64067",
		"_fabric_color": [
			{
				"term_id": 64067,
				"gallery": [
					94710,
					94714,
					94721,
					94708,
					94712,
					94707,
					94709
				],
				"imgSrc": "/cdn/shop/files/2405-7-657-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2405-7-657-2.png",
				"imgSrcF": "/cdn/shop/files/2405-7-657-color-3.png",
				"title": "Brushstrokes / Black",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"60% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": true,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "premiere",
				"name": "premiere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/fat-500x500.png",
		"hoverImg": "/cdn/shop/files/2405-7-657-2-500x500.jpg",
		"subheading": "47 x 95 inch Triple French Pinch Pleat Black Cotton Unique Patterned Curtain",
		"Fabrics": [
			"Brushstrokes"
		],
		"Feature": [],
		"Material": [
			"Cotton"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Black"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 421,
		"newPrice": 168
	},
	{
		"id": 103054,
		"title": "Brushstrokes 79 x 140 inch Triple French Pinch Pleat Black Cotton Unique Patterned Curtain",
		"ProductUrl": "/sale/brushstrokes-79-x-140-inch-triple-french-pinch-pleat-black-cotton-unique-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64067",
		"_fabric_color": [
			{
				"term_id": 64067,
				"gallery": [
					94710,
					94714,
					94721,
					94708,
					94712,
					94707,
					94709
				],
				"imgSrc": "/cdn/shop/files/2405-7-657-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2405-7-657-2.png",
				"imgSrcF": "/cdn/shop/files/2405-7-657-color-3.png",
				"title": "Brushstrokes / Black",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"60% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": true,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "premiere",
				"name": "premiere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/fat-500x500.png",
		"hoverImg": "/cdn/shop/files/2405-7-657-2-500x500.jpg",
		"subheading": "79 x 140 inch Triple French Pinch Pleat Black Cotton Unique Patterned Curtain",
		"Fabrics": [
			"Brushstrokes"
		],
		"Feature": [],
		"Material": [
			"Cotton"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Black"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 900,
		"newPrice": 360
	},
	{
		"id": 103141,
		"title": "Alpine 36 x 106 Inch Double French PInch Pleat White Wool Blend Sheer Curtain",
		"ProductUrl": "/sale/alpine-36-x-106-inch-double-french-pinch-pleat-white-wool-blend-sheer-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95965",
		"_fabric_color": [
			{
				"term_id": 95965,
				"gallery": [
					96277,
					96276,
					96281,
					96663,
					96280,
					96279,
					96278
				],
				"imgSrc": "/cdn/shop/files/Alpine-White-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Alpine-White-2.png",
				"imgSrcF": "/cdn/shop/files/Alpine-White.png",
				"title": "Alpine / White",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"80% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "primere",
				"name": "primere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Alpine-White-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Alpine-White-4-500x500.png",
		"subheading": "36 x 106 Inch Double French PInch Pleat White Wool Blend Sheer Curtain",
		"Fabrics": [
			"Alpine"
		],
		"Feature": [],
		"Material": [
			"Sheer",
			"Wool"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "80% Off",
		"salenum": 80,
		"oldPrice": 703,
		"newPrice": 141
	},
	{
		"id": 103144,
		"title": "Ambient 36 x 107 Inch Triple French Pinch Pleat Cream Linen Jacquard Curtain",
		"ProductUrl": "/sale/ambient-36-x-107-inch-triple-french-pinch-pleat-cream-linen-jacquard-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95452",
		"_fabric_color": [
			{
				"term_id": 95452,
				"gallery": [
					95839,
					95838,
					96683,
					96682,
					95891,
					96679,
					96681,
					96680
				],
				"imgSrc": "/cdn/shop/files/Ambient-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Ambient-1.png",
				"imgSrcF": "/cdn/shop/files/Cream-1.png",
				"title": "Ambient / Cream",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": true,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "bestseller",
				"name": "bestseller"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Ambient-1-500x500.png",
		"hoverImg": "/cdn/shop/files/FB-CR2304-4-500x500.png",
		"subheading": "36 x 107 Inch Triple French Pinch Pleat Cream Linen Jacquard Curtain",
		"Fabrics": [
			"Ambient"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 833,
		"newPrice": 208
	},
	{
		"id": 103268,
		"title": "Aspen 52 x 95 Inch Double French Pinch Pleat Green Grey Wool Textured Curtain",
		"ProductUrl": "/sale/aspen-52-x-95-inch-double-french-pinch-pleat-green-grey-wool-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95446",
		"_fabric_color": [
			{
				"term_id": 95446,
				"gallery": [
					95875,
					95867,
					95868,
					95871,
					95869,
					95870,
					95872
				],
				"imgSrc": "/cdn/shop/files/Frame-183-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Frame-183.png",
				"imgSrcF": "/cdn/shop/files/greengrey.png",
				"title": "Aspen / Green Grey",
				"color": "Grey"
			}
		],
		"_fabric_classic": [
			{
				"term_id": 342,
				"gallery": null,
				"price": 0,
				"title": "Grommet Top Silver Black"
			},
			{
				"term_id": 341,
				"gallery": null,
				"price": 0,
				"title": "Grommet Top Anti-brass"
			},
			{
				"term_id": 340,
				"gallery": null,
				"price": 0,
				"title": "Grommet Top Silver"
			},
			{
				"term_id": 608,
				"gallery": null,
				"price": 0,
				"title": "Back Tab"
			},
			{
				"term_id": 97020,
				"gallery": null,
				"price": 0,
				"title": "Double French Pinch Pleat"
			},
			{
				"term_id": 97022,
				"gallery": null,
				"price": 0,
				"title": "Triple French Pinch Pleat"
			},
			{
				"term_id": 63904,
				"gallery": null,
				"price": 0,
				"title": "Inverted Box Pleat"
			},
			{
				"term_id": 63900,
				"gallery": null,
				"price": 0,
				"title": "Goblet"
			},
			{
				"term_id": 606,
				"gallery": null,
				"price": 0,
				"title": "Single Rod Pocket"
			},
			{
				"term_id": 607,
				"gallery": null,
				"price": 0,
				"title": "Double Rod Pockets"
			},
			{
				"term_id": 95075,
				"gallery": null,
				"price": 0,
				"title": "4-IN-1"
			},
			{
				"term_id": 331,
				"gallery": null,
				"price": 0,
				"title": "Unlined"
			},
			{
				"term_id": 96969,
				"gallery": null,
				"price": 0,
				"title": "Privacy — Beige"
			},
			{
				"term_id": 96971,
				"gallery": null,
				"price": 0,
				"title": "Privacy — Grey"
			},
			{
				"term_id": 96973,
				"gallery": null,
				"price": 0,
				"title": "Soft Flat Finish Lining — Beige"
			},
			{
				"term_id": 96975,
				"gallery": null,
				"price": 0,
				"title": "Soft Flat Finish Lining — Grey"
			},
			{
				"term_id": 96977,
				"gallery": null,
				"price": 0,
				"title": "Thick Satin Finish Lining — Beige"
			},
			{
				"term_id": 96979,
				"gallery": null,
				"price": 0,
				"title": "Thick Satin Finish Lining — Grey"
			},
			{
				"term_id": 96983,
				"gallery": null,
				"price": 0,
				"title": "100% Blackout — Beige"
			},
			{
				"term_id": 96981,
				"gallery": null,
				"price": 0,
				"title": "100% Blackout — Grey"
			},
			{
				"term_id": 102503,
				"gallery": null,
				"price": 0,
				"title": "Same fabric liner"
			},
			{
				"term_id": 102507,
				"gallery": null,
				"price": 0,
				"title": "Same fabric liner"
			}
		],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": true,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "premiere",
				"name": "premiere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Aspen-2-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Aspen-4-500x500.png",
		"subheading": "52 x 95 Inch Double French Pinch Pleat Green Grey Wool Textured Curtain",
		"Fabrics": [
			"Aspen"
		],
		"Feature": [],
		"Material": [
			"Cotton",
			"Wool"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Grey"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 1494,
		"newPrice": 448
	},
	{
		"id": 103048,
		"title": "Chelsea 51 x 123 Inch Inverted Box Pleat Circuit Cotton Grid Patterned Curtain",
		"ProductUrl": "/sale/chelsea-51-x-123-inch-inverted-box-pleat-circuit-cotton-grid-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95471",
		"_fabric_color": [
			{
				"term_id": 95471,
				"gallery": [
					95909,
					95917,
					95912,
					95916,
					95915,
					95914,
					95913
				],
				"imgSrc": "/cdn/shop/files/Circuit-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Circuit.png",
				"imgSrcF": "/cdn/shop/files/Circuit-1.png",
				"title": "Chelsea / Circuit",
				"color": "Blue"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Grid-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Grid-3-500x500.png",
		"subheading": "51 x 123 Inch Inverted Box Pleat Circuit Cotton Grid Patterned Curtain",
		"Fabrics": [
			"Chelsea"
		],
		"Feature": [],
		"Material": [
			"Cotton"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Blue"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 660,
		"newPrice": 198
	},
	{
		"id": 103051,
		"title": "Chelsea 52 x 94 Inch Inverted Box Pleat Grid Cotton Geometric Patterned Curtain",
		"ProductUrl": "/sale/chelsea-52-x-94-inch-inverted-box-pleat-grid-cotton-geometric-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95470",
		"_fabric_color": [
			{
				"term_id": 95470,
				"gallery": [
					95917,
					95912,
					95910,
					95916,
					95915,
					95914,
					95913
				],
				"imgSrc": "/cdn/shop/files/Grid-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Grid-1.png",
				"imgSrcF": "/cdn/shop/files/Grid-7.png",
				"title": "Chelsea / Grid",
				"color": "Brown"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Cotton Blend Curtains",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Grid-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Grid-3-500x500.png",
		"subheading": "52 x 94 Inch Inverted Box Pleat Grid Cotton Geometric Patterned Curtain",
		"Fabrics": [
			"Chelsea"
		],
		"Feature": [],
		"Material": [
			"Cotton"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Brown"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 428,
		"newPrice": 128
	},
	{
		"id": 103036,
		"title": "Composer 43 x 51 inch Double French Pinch Pleat Black Green Linen Patterned Curtain",
		"ProductUrl": "/sale/composer-43-x-51-inch-double-french-pinch-pleat-black-green-linen-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95463",
		"_fabric_color": [
			{
				"term_id": 95463,
				"gallery": [
					95851,
					95845,
					95850,
					95843,
					95846,
					95849,
					95848,
					95847,
					95852
				],
				"imgSrc": "/cdn/shop/files/Black-Green-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Black-Green-1.png",
				"imgSrcF": "/cdn/shop/files/Black-Green.png",
				"title": "Composer / Black Green",
				"color": "Green"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"65% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Black-Green-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Black-Green-5-500x500.png",
		"subheading": "43 x 51 inch Double French Pinch Pleat Black Green Linen Patterned Curtain",
		"Fabrics": [
			"Composer"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Wool"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Green"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "65% Off",
		"salenum": 65,
		"oldPrice": 365,
		"newPrice": 128
	},
	{
		"id": 103037,
		"title": "Composer 53 x 96 inch Double French Pinch Pleat Silver Grey Linen Patterned Curtain",
		"ProductUrl": "/product/composer-53-x-96-inch-double-french-pinch-pleat-silver-grey-linen-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "0",
		"_fabric_color": [
			{
				"term_id": 95455,
				"gallery": [
					95841,
					95852,
					95851,
					95845,
					95848,
					95850,
					95846,
					95849,
					95847
				],
				"imgSrc": "/cdn/shop/files/Silver-Grey-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Silver-Grey.png",
				"imgSrcF": "/cdn/shop/files/Silver-Grey.png",
				"title": "Composer / Silver Grey",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"65% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Black-Green-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Black-Green-5-500x500.png",
		"subheading": "53 x 96 inch Double French Pinch Pleat Silver Grey Linen Patterned Curtain",
		"Fabrics": [
			"Composer"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Wool"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Grey"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "65% Off",
		"salenum": 65,
		"oldPrice": 486,
		"newPrice": 170
	},
	{
		"id": 103146,
		"title": "Deconstructed 36 x 106 Inch Double French Pinch Pleat Urban Linen Wool Geometric Fringed Curtain",
		"ProductUrl": "/sale/deconstructed-36-x-106-inch-double-french-pinch-pleat-urban-linen-wool-geometric-fringed-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "65275",
		"_fabric_color": [
			{
				"term_id": 65275,
				"gallery": [
					65286,
					65287,
					65285,
					65290,
					65289,
					65288
				],
				"imgSrc": "/cdn/shop/files/Urban-2-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Urban-2.jpg",
				"imgSrcF": "/cdn/shop/files/Urban-1.jpg",
				"title": "Deconstructed / Urban",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Urban-2-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Urban-6-500x500.jpg",
		"subheading": "36 x 106 Inch Double French Pinch Pleat Urban Linen Wool Geometric Fringed Curtain",
		"Fabrics": [
			"Deconstructed"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Wool"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 1047,
		"newPrice": 262
	},
	{
		"id": 103147,
		"title": "Deconstructed 52 x 95 Inch Double French Pinch Pleat Urban Linen Wool Geometric Fringed Curtain",
		"ProductUrl": "/sale/deconstructed-52-x-95-inch-double-french-pinch-pleat-urban-linen-wool-geometric-fringed-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "65275",
		"_fabric_color": [
			{
				"term_id": 65275,
				"gallery": [
					65286,
					65287,
					65285,
					65290,
					65289,
					65288
				],
				"imgSrc": "/cdn/shop/files/Urban-2-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Urban-2.jpg",
				"imgSrcF": "/cdn/shop/files/Urban-1.jpg",
				"title": "Deconstructed / Urban",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Urban-2-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Urban-6-500x500.jpg",
		"subheading": "52 x 95 Inch Double French Pinch Pleat Urban Linen Wool Geometric Fringed Curtain",
		"Fabrics": [
			"Deconstructed"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Wool"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 869,
		"newPrice": 217
	},
	{
		"id": 103017,
		"title": "Flora 39 x 125 inch Double French Pinch Pleat Black Velvet Emboidered Floral Pattern Curtain",
		"ProductUrl": "/sale/flora-39-x-125-inch-double-black-french-pinch-pleat-velvet-emboidered-floral-pattern-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95559",
		"_fabric_color": [
			{
				"term_id": 95559,
				"gallery": [
					95769,
					95775,
					96621,
					95770,
					95774,
					95773,
					95772,
					95771
				],
				"imgSrc": "/cdn/shop/files/Flora-Black-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Flora-Black-1.png",
				"imgSrcF": "/cdn/shop/files/BE-1806-5-2.png",
				"title": "Flora / Black",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"60% Off Sale",
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Flora-Black-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Flora-Black-5-500x500.png",
		"subheading": "39 x 125 inch Double French Pinch Pleat Black Velvet Emboidered Floral Pattern Curtain",
		"Fabrics": [
			"Flora"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Floral"
		],
		"Color": [
			"Black"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 1669,
		"newPrice": 668
	},
	{
		"id": 103027,
		"title": "Flora 51 x 94 inch Double French Pinch Pleat Light Taupe Velvet Emboidered Floral Pattern Curtain",
		"ProductUrl": "/product/flora-51-x-94-inch-double-french-pinch-pleat-light-taupe-velvet-emboidered-floral-pattern-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "0",
		"_fabric_color": [
			{
				"term_id": 95562,
				"gallery": [
					98626,
					98627,
					96618,
					98628,
					98630,
					98629,
					98631
				],
				"imgSrc": "/cdn/shop/files/1-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/1-1.jpg",
				"imgSrcF": "/cdn/shop/files/BE-1806-2-2.png",
				"title": "Flora / Light Taupe",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"60% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/1-1-500x500.jpg",
		"hoverImg": "/cdn/shop/files/6-1-500x500.jpg",
		"subheading": "51 x 94 inch Double French Pinch Pleat Light Taupe Velvet Emboidered Floral Pattern Curtain",
		"Fabrics": [
			"Flora"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Floral"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"4 In 1",
			"Back Tab",
			"Goblet Pleat",
			"Grommet",
			"Inverted Pleat",
			"Pinch Pleated",
			"Rod Pocket"
		],
		"Space": [],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 1056,
		"newPrice": 422
	},
	{
		"id": 103056,
		"title": "Impression 79 x 123 inch Triple French Pinch Pleat Black Foil Printed Velvet Patterned Curtain",
		"ProductUrl": "/sale/impression-79-x-123-inch-triple-french-pinch-pleat-black-foil-printed-velvet-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95490",
		"_fabric_color": [
			{
				"term_id": 95490,
				"gallery": [
					95794,
					95802,
					95799,
					96599,
					95795,
					95800,
					95796,
					95801,
					95798,
					95797
				],
				"imgSrc": "/cdn/shop/files/Impression-Black-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Impression-Black-1.png",
				"imgSrcF": "/cdn/shop/files/BF-577-8-2.png",
				"title": "Impression / Black",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": true,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "premiere",
				"name": "premiere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Impression-Black-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Impression-Black-4-500x500.png",
		"subheading": "79 x 123 inch Triple French Pinch Pleat Black Foil Printed Velvet Patterned Curtain",
		"Fabrics": [
			"Impression"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Black"
		],
		"Light": [
			"Blackout"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 1944,
		"newPrice": 583
	},
	{
		"id": 103019,
		"title": "Klimt 39 x 126 inch Double French Pinch Pleat Black Foil Printed Velvet Patterned Curtain",
		"ProductUrl": "/sale/klimt-39-x-126-inch-double-french-pinch-pleat-black-foil-printed-velvet-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95552",
		"_fabric_color": [
			{
				"term_id": 95552,
				"gallery": [
					95787,
					95793,
					96525,
					95791,
					95792,
					95789,
					95788,
					95790
				],
				"imgSrc": "/cdn/shop/files/Klimt-Black-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Klimt-Black-1.png",
				"imgSrcF": "/cdn/shop/files/BF354-6-2.png",
				"title": "Klimt / Black",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Klimt-Black-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Klimt-Black-2-500x500.png",
		"subheading": "39 x 126 inch Double French Pinch Pleat Black Foil Printed Velvet Patterned Curtain",
		"Fabrics": [
			"Klimt"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Black"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 1377,
		"newPrice": 413
	},
	{
		"id": 103211,
		"title": "Lana 36 x 108 Inch Double French Pinch Pleat Pink Cotton Textured Curtain",
		"ProductUrl": "/sale/lana-36-x-108-inch-double-french-pinch-pleat-pink-cotton-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95475",
		"_fabric_color": [
			{
				"term_id": 95475,
				"gallery": [
					95894,
					95899,
					95900,
					95893,
					95897,
					95896,
					95895,
					95898
				],
				"imgSrc": "/cdn/shop/files/Pink-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Pink-1.png",
				"imgSrcF": "/cdn/shop/files/Pink-8.png",
				"title": "Lana / Pink",
				"color": "Pink"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Pink-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Pink-2-500x500.png",
		"subheading": "36 x 108 Inch Double French Pinch Pleat Pink Cotton Textured Curtain",
		"Fabrics": [
			"Lana"
		],
		"Feature": [],
		"Material": [
			"Cotton"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Pink"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 417,
		"newPrice": 125
	},
	{
		"id": 103249,
		"title": "Manhattan 33 x 107 Inch Double French Pinch Pleat White Gold Linen Grid Sheer Curtain",
		"ProductUrl": "/sale/manhattan-33-x-107-inch-double-french-pinch-pleat-white-gold-linen-grid-sheer-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "0",
		"_fabric_color": [
			{
				"term_id": 95970,
				"gallery": [
					104113,
					104120,
					104121,
					104119,
					104118,
					104116,
					104115,
					104114
				],
				"imgSrc": "/cdn/shop/files/White-Gold-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/White-Gold-1.png",
				"imgSrcF": "/cdn/shop/files/Manhattan-White-Gold-1.png",
				"title": "Manhattan / White Gold",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": true,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "bestseller",
				"name": "bestseller"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/White-Gold-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Black-Gold-5-500x500.png",
		"subheading": "33 x 107 Inch Double French Pinch Pleat White Gold Linen Grid Sheer Curtain",
		"Fabrics": [
			"Manhattan"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Sheer"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 655,
		"newPrice": 164
	},
	{
		"id": 103245,
		"title": "Manhattan 36 x 106 Inch Double French Pinch Pleat Black Gold Linen Grid Sheer Curtain",
		"ProductUrl": "/sale/manhattan-36-x-106-inch-double-french-pinch-pleat-black-gold-linen-grid-sheer-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95972",
		"_fabric_color": [
			{
				"term_id": 95972,
				"gallery": [
					95943,
					95944,
					95949,
					95945,
					95946,
					95950,
					95948,
					95947
				],
				"imgSrc": "/cdn/shop/files/Black-Gold-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Black-Gold-1.png",
				"imgSrcF": "/cdn/shop/files/Manhattan-Black-Gold-1.png",
				"title": "Manhattan / Black Gold",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": true,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "bestseller",
				"name": "bestseller"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Black-Gold-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Black-Gold-5-500x500.png",
		"subheading": "36 x 106 Inch Double French Pinch Pleat Black Gold Linen Grid Sheer Curtain",
		"Fabrics": [
			"Manhattan"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Sheer"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Black"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 655,
		"newPrice": 164
	},
	{
		"id": 103272,
		"title": "Meteor 52 x 95 Inch Double French Pinch Pleat Cream Linen Striped Textured Curtain",
		"ProductUrl": "/sale/meteor-52-x-95-inch-double-french-pinch-pleat-cream-linen-striped-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95638",
		"_fabric_color": [
			{
				"term_id": 95638,
				"gallery": [
					95878,
					95882,
					95883,
					95888,
					95885,
					95884,
					95887,
					95886
				],
				"imgSrc": "/cdn/shop/files/Cream-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Cream.png",
				"imgSrcF": "/cdn/shop/files/Cream.png",
				"title": "Meteor / Cream",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"50% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Silver-Grey-1-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Silver-Grey-3-500x500.png",
		"subheading": "52 x 95 Inch Double French Pinch Pleat Cream Linen Striped Textured Curtain",
		"Fabrics": [
			"Meteor"
		],
		"Feature": [],
		"Material": [
			"Faux Linen",
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 354,
		"newPrice": 142
	},
	{
		"id": 103040,
		"title": "Mirage 43 x 114 inch Goblet Champagne Foil Printed Velvet Patterned Curtain",
		"ProductUrl": "/sale/mirage-43-x-114-inch-goblet-champagne-foil-printed-velvet-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95565",
		"_fabric_color": [
			{
				"term_id": 95565,
				"gallery": [
					96571,
					95817,
					95812,
					95816,
					95815,
					95814,
					95813
				],
				"imgSrc": "/cdn/shop/files/BF-A06-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A06-2.png",
				"imgSrcF": "/cdn/shop/files/BF-A06-2-2.png",
				"title": "Mirage / Champagne",
				"color": "Gold"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"50% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Mirage-6-500x500.png",
		"hoverImg": "/cdn/shop/files/Mirage-2-500x500.png",
		"subheading": "43 x 114 inch Goblet Champagne Foil Printed Velvet Patterned Curtain",
		"Fabrics": [
			"Mirage"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Gold"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Goblet Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "50% Off",
		"salenum": 50,
		"oldPrice": 815,
		"newPrice": 408
	},
	{
		"id": 103042,
		"title": "Mirage 49 x 93 inch Goblet Teal Foil Printed Velvet Patterned Curtain",
		"ProductUrl": "/sale/mirage-49-x-93-inch-goblet-teal-foil-printed-velvet-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95568",
		"_fabric_color": [
			{
				"term_id": 95568,
				"gallery": [
					96575,
					95817,
					95812,
					95816,
					95815,
					95814,
					95813
				],
				"imgSrc": "/cdn/shop/files/BF-A06-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A06-6.png",
				"imgSrcF": "/cdn/shop/files/BF-A06-6-2.png",
				"title": "Mirage / Teal",
				"color": "Green"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"50% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Mirage-6-500x500.png",
		"hoverImg": "/cdn/shop/files/Mirage-2-500x500.png",
		"subheading": "49 x 93 inch Goblet Teal Foil Printed Velvet Patterned Curtain",
		"Fabrics": [
			"Mirage"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Green"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Goblet Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "50% Off",
		"salenum": 50,
		"oldPrice": 545,
		"newPrice": 273
	},
	{
		"id": 103276,
		"title": "Pebbles 51 x 93 Inch Goblet Ivory Foil Printed Velvet Patterned Curtain",
		"ProductUrl": "/sale/pebbles-51-x-93-inch-goblet-ivory-foil-printed-velvet-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95541",
		"_fabric_color": [
			{
				"term_id": 95541,
				"gallery": [
					95818,
					95821,
					95820,
					96543,
					95819
				],
				"imgSrc": "/cdn/shop/files/Pebbles-Gold-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Pebbles-Gold-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A10-1-2.png",
				"title": "Pebbles / Ivory",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"65% Off Sale",
			"Curtain Measurement",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Pebbles-Gold-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Pebbles-Gold-4-500x500.png",
		"subheading": "51 x 93 Inch Goblet Ivory Foil Printed Velvet Patterned Curtain",
		"Fabrics": [
			"Pebbles"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Goblet Pleat"
		],
		"Space": [],
		"Sale": "65% Off",
		"salenum": 65,
		"oldPrice": 849,
		"newPrice": 297
	},
	{
		"id": 103045,
		"title": "Savannah 44 x 117 inch Double French Pinch Pleat Camouflage Linen Floral Patterned Curtain",
		"ProductUrl": "/sale/savannah-44-x-117inch-double-french-pinch-pleat-camouflage-linen-floral-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95467",
		"_fabric_color": [
			{
				"term_id": 95467,
				"gallery": [
					95861,
					95860,
					95865,
					95853,
					95854,
					95859,
					95858,
					95857,
					95856,
					95855,
					95864
				],
				"imgSrc": "/cdn/shop/files/Camouflage-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Camouflage-1.png",
				"imgSrcF": "/cdn/shop/files/Camouflage-11.png",
				"title": "Savannah / Camouflage",
				"color": "Green"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"80% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Camouflage-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Camouflage-6-500x500.png",
		"subheading": "44 x 117 inch Double French Pinch Pleat Camouflage Linen Floral Patterned Curtain",
		"Fabrics": [
			"Savannah"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Wool"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Green"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "80% Off",
		"salenum": 80,
		"oldPrice": 1213,
		"newPrice": 243
	},
	{
		"id": 103046,
		"title": "Savannah 52 x 95 inch Double French Pinch Pleat Camouflage Linen Floral Patterned Curtain",
		"ProductUrl": "/sale/savannah-52-x-95-inch-double-french-pinch-pleat-camouflage-linen-floral-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95467",
		"_fabric_color": [
			{
				"term_id": 95467,
				"gallery": [
					95861,
					95860,
					95865,
					95853,
					95854,
					95859,
					95858,
					95857,
					95856,
					95855,
					95864
				],
				"imgSrc": "/cdn/shop/files/Camouflage-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Camouflage-1.png",
				"imgSrcF": "/cdn/shop/files/Camouflage-11.png",
				"title": "Savannah / Camouflage",
				"color": "Green"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"80% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Camouflage-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Camouflage-6-500x500.png",
		"subheading": "52 x 95 inch Double French Pinch Pleat Camouflage Linen Floral Patterned Curtain",
		"Fabrics": [
			"Savannah"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Wool"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Green"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "80% Off",
		"salenum": 80,
		"oldPrice": 898,
		"newPrice": 180
	},
	{
		"id": 103047,
		"title": "Tuscany 44 x 115 Inch Goblet Foil Printed Velvet Floral Patterned Curtain",
		"ProductUrl": "/sale/tuscany-44-x-115-inch-goblet-foil-printed-velvet-floral-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95984",
		"_fabric_color": [
			{
				"term_id": 95984,
				"gallery": [
					95803,
					95810,
					95807,
					95808,
					96510,
					95809,
					95806,
					95805,
					95804
				],
				"imgSrc": "/cdn/shop/files/Tuscany-Red-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Tuscany-Red-1.png",
				"imgSrcF": "/cdn/shop/files/BF769-4.png",
				"title": "Tuscany / Red",
				"color": "Red"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"60% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Tuscany-Red-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Tuscany-Red-2-500x500.png",
		"subheading": "44 x 115 Inch Goblet Foil Printed Velvet Floral Patterned Curtain",
		"Fabrics": [
			"Tuscany"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Floral"
		],
		"Color": [
			"Red"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Goblet Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 1029,
		"newPrice": 412
	},
	{
		"id": 103028,
		"title": "Palma 41 x 125 inch Triple French Pinch Pleat Rose Gold Foil Printed Velvet Patterned Curtain",
		"ProductUrl": "/sale/palma-41-x-125-inch-triple-french-pinch-pleat-rose-gold-foil-printed-velvet-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64121",
		"_fabric_color": [
			{
				"term_id": 64121,
				"gallery": [
					65706,
					65707,
					94949,
					65708,
					65709,
					65710
				],
				"imgSrc": "/cdn/shop/files/1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/1.jpg",
				"imgSrcF": "/cdn/shop/files/palma-color-4.png",
				"title": "Palma / Rose Gold",
				"color": "Pink"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"50% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": true,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "bestseller",
				"name": "bestseller"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Rose-Gold-4-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Rose-Gold-6-500x500.jpg",
		"subheading": "41 x 125 inch Triple French Pinch Pleat Rose Gold Foil Printed Velvet Patterned Curtain",
		"Fabrics": [
			"Palma"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Pink"
		],
		"Light": [
			"Light Filtering"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "50% Off",
		"salenum": 50,
		"oldPrice": 527,
		"newPrice": 264
	},
	{
		"id": 103269,
		"title": "Boston 52 x 84 Inch Grommet Grey Fade-Resistant Waterproof Outdoor Curtain",
		"ProductUrl": "/product/boston-52-x-84-inch-grommet-grey-fade-resistant-waterproof-outdoor-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64096",
		"_fabric_color": [
			{
				"term_id": 64096,
				"gallery": [
					97656,
					97657,
					97658,
					97660,
					97659
				],
				"imgSrc": "/cdn/shop/files/Brown-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Brown-1.jpg",
				"imgSrcF": "/cdn/shop/files/Brown-3.png",
				"title": "Boston / Grey",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"60% Off Sale",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "outdoor-curtains",
				"name": "Outdoor Curtains"
			}
		],
		"short_description": "The Outdoor curtains adopt waterproof technology on the fabric, unlike the other blackout drapes. The invisible layer on both sides is water-resistant and will preserve even in heavy rain or the fiercest snowstorm. With the double grommet, the curtain will stay still against the wind.\r\n\r\nOUTDOOR CURTAINS\r\noutdoor\r\npatio curtains\r\npatio\r\nOutdoor curtain\r\nPatio curtain\r\nFarmhouse\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
		"imgSrc": "/cdn/shop/files/Brown-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Brown-3-500x500.png",
		"subheading": "52 x 84 Inch Grommet Grey Fade-Resistant Waterproof Outdoor Curtain",
		"Fabrics": [
			"Boston"
		],
		"Feature": [
			"Waterproof"
		],
		"Material": [
			"Polyester",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Grey"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Grommet"
		],
		"Space": [
			"Outdoor"
		],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 310,
		"newPrice": 124
	},
	{
		"id": 103043,
		"title": "Rome 51 x 115 inch Triple French Pinch Pleat Black Foil Printed Velvet Curtain",
		"ProductUrl": "/sale/rome-51-x-115-inch-triple-french-pinch-pleat-black-foil-printed-velvet-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64157",
		"_fabric_color": [
			{
				"term_id": 64157,
				"gallery": [
					94922,
					65404,
					94869,
					65407,
					65406,
					94648,
					94647,
					65405,
					94687,
					65403
				],
				"imgSrc": "/cdn/shop/files/Rome-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Rome-3.png",
				"imgSrcF": "/cdn/shop/files/black-3.png",
				"title": "Rome / Black",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Rome-3-500x500.png",
		"hoverImg": "/cdn/shop/files/Black-4-7-500x500.jpg",
		"subheading": "51 x 115 inch Triple French Pinch Pleat Black Foil Printed Velvet Curtain",
		"Fabrics": [
			"Rome"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Black"
		],
		"Light": [
			"Blackout"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 862,
		"newPrice": 259
	},
	{
		"id": 103256,
		"title": "Raw 37 x 107 Inch Double French Pinch Pleat Natural Linen Striped Semi-Sheer Curtain",
		"ProductUrl": "/sale/raw-37-x-107-inch-double-french-pinch-pleat-natural-linen-striped-semi-sheer-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64090",
		"_fabric_color": [
			{
				"term_id": 64090,
				"gallery": [
					97181,
					65337,
					65336,
					65331,
					65334,
					65333,
					65332,
					65335
				],
				"imgSrc": "/cdn/shop/files/Group-1000005883-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Group-1000005883.png",
				"imgSrcF": "/cdn/shop/files/38-1.png",
				"title": "Raw / Natural",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"55% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Group-1000005883-500x500.png",
		"hoverImg": "/cdn/shop/files/Natural-3-500x500.jpg",
		"subheading": "37 x 107 Inch Double French Pinch Pleat Natural Linen Striped Semi-Sheer Curtain",
		"Fabrics": [
			"Raw"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Sheer"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "55% Off",
		"salenum": 55,
		"oldPrice": 309,
		"newPrice": 139
	},
	{
		"id": 103257,
		"title": "Raw 51 x 95 Inch Double French Pinch Pleat  Natural Linen Striped Semi-Sheer Curtain",
		"ProductUrl": "/sale/raw-51-x-95-inch-double-french-pinch-pleat-natural-linen-striped-semi-sheer-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64090",
		"_fabric_color": [
			{
				"term_id": 64090,
				"gallery": [
					97181,
					65337,
					65336,
					65331,
					65334,
					65333,
					65332,
					65335
				],
				"imgSrc": "/cdn/shop/files/Group-1000005883-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Group-1000005883.png",
				"imgSrcF": "/cdn/shop/files/38-1.png",
				"title": "Raw / Natural",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"55% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Group-1000005883-500x500.png",
		"hoverImg": "/cdn/shop/files/Natural-3-500x500.jpg",
		"subheading": "51 x 95 Inch Double French Pinch Pleat Natural Linen Striped Semi-Sheer Curtain",
		"Fabrics": [
			"Raw"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Sheer"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "55% Off",
		"salenum": 55,
		"oldPrice": 271,
		"newPrice": 122
	},
	{
		"id": 103205,
		"title": "Gradient 39 x 106 Inch Inverted Box Pleat Fanta Ultra Light Soft Sheer Curtain",
		"ProductUrl": "/sale/gradient-39-x-106-inch-inverted-box-pleat-fanta-ultra-light-soft-sheer-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64093",
		"_fabric_color": [
			{
				"term_id": 64093,
				"gallery": [
					65578,
					65579,
					94690,
					65580,
					65581,
					65582,
					65577
				],
				"imgSrc": "/cdn/shop/files/Fanta-2-3-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Fanta-2-3.jpg",
				"imgSrcF": "/cdn/shop/files/FA-KFN0802-color.png",
				"title": "Gradient / Fanta",
				"color": "Red"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"80% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Fanta-2-3-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Fanta-1-3-500x500.jpg",
		"subheading": "39 x 106 Inch Inverted Box Pleat Fanta Ultra Light Soft Sheer Curtain",
		"Fabrics": [
			"Gradient"
		],
		"Feature": [],
		"Material": [
			"Sheer",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Red"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "80% Off",
		"salenum": 80,
		"oldPrice": 687,
		"newPrice": 137
	},
	{
		"id": 103138,
		"title": "Moonlit 52 x 95 inch Inverted Box Pleat Camel Velvet Textured Curtain",
		"ProductUrl": "/sale/moonlit-52-x-95-inch-inverted-box-pleat-camel-velvet-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64111",
		"_fabric_color": [
			{
				"term_id": 64111,
				"gallery": [
					98895,
					98896,
					98898,
					98897
				],
				"imgSrc": "/cdn/shop/files/Camel-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Camel-1.jpg",
				"imgSrcF": "/cdn/shop/files/camel色块.png",
				"title": "Moonlit / Camel",
				"color": "Orange"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Camel-1-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Brown-4-500x500.jpg",
		"subheading": "52 x 95 inch Inverted Box Pleat Camel Velvet Textured Curtain",
		"Fabrics": [
			"Moonlit"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Orange"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 747,
		"newPrice": 187
	},
	{
		"id": 103137,
		"title": "Moonlit 78 x 126 inch Inverted Box Pleat Metallic Velvet Textured Curtain",
		"ProductUrl": "/sale/moonlit-78-x-126-inch-inverted-box-pleat-metallic-velvet-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64109",
		"_fabric_color": [
			{
				"term_id": 64109,
				"gallery": [
					98887,
					98888,
					98890,
					98889
				],
				"imgSrc": "/cdn/shop/files/Metallic-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Metallic-1.jpg",
				"imgSrcF": "/cdn/shop/files/metalic色块.png",
				"title": "Moonlit / Metallic",
				"color": "Brown"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Metallic-1-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Brown-4-500x500.jpg",
		"subheading": "78 x 126 inch Inverted Box Pleat Metallic Velvet Textured Curtain",
		"Fabrics": [
			"Moonlit"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Brown"
		],
		"Light": [
			"Blackout",
			"Room Darkening"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 1477,
		"newPrice": 369
	},
	{
		"id": 103039,
		"title": "Haze 44 x 116 inch Inverted Box Pleat Cream Linen Textured Curtain",
		"ProductUrl": "/sale/haze-44-x-116-inch-inverted-box-pleat-cream-linen-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64099",
		"_fabric_color": [
			{
				"term_id": 64099,
				"gallery": [
					65350,
					65354,
					94878,
					65353,
					65355,
					65357,
					65356,
					65351
				],
				"imgSrc": "/cdn/shop/files/Cream-1-2-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Cream-1-2.jpg",
				"imgSrcF": "/cdn/shop/files/Haze-display.png",
				"title": "Haze / Cream",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Cream-1-2-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Cream-1-2-500x500.png",
		"subheading": "44 x 116 inch Inverted Box Pleat Cream Linen Textured Curtain",
		"Fabrics": [
			"Haze"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Blackout",
			"Light Filtering"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 874,
		"newPrice": 219
	},
	{
		"id": 103132,
		"title": "Jade 51 x 95 Inch Inverted Box Pleat Ink Velvet Toile Patterned Curtain",
		"ProductUrl": "/sale/jade-51-x-95-inch-inverted-box-pleat-ink-velvet-toile-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66071",
		"_fabric_color": [
			{
				"term_id": 66071,
				"gallery": [
					66094,
					66095,
					66101,
					66096,
					66100,
					66099,
					66098,
					66097
				],
				"imgSrc": "/cdn/shop/files/1-2-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/1-2.jpg",
				"imgSrcF": "/cdn/shop/files/Rose-6.png",
				"title": "Jade / Ink",
				"color": "Brown"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/1-2-500x500.jpg",
		"hoverImg": "/cdn/shop/files/5-2-500x500.jpg",
		"subheading": "51 x 95 Inch Inverted Box Pleat Ink Velvet Toile Patterned Curtain",
		"Fabrics": [
			"Jade"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Nature"
		],
		"Color": [
			"Brown"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 414,
		"newPrice": 124
	},
	{
		"id": 103131,
		"title": "Jade 52 x 95 Inch Double French Pinch Pleat Stone Blue Velvet Toile Patterned Curtain",
		"ProductUrl": "/sale/jade-51-x-95-inch-double-french-pinch-pleat-stone-blue-velvet-toile-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64063",
		"_fabric_color": [
			{
				"term_id": 64063,
				"gallery": [
					64385,
					64392,
					64388,
					66074,
					64391,
					64393,
					64387,
					64386,
					64389,
					64390
				],
				"imgSrc": "/cdn/shop/files/Rose-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Rose-1.jpg",
				"imgSrcF": "/cdn/shop/files/Stone-Blue-1.png",
				"title": "Jade / Stone Blue",
				"color": "Blue"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/2-2-500x500.jpg",
		"hoverImg": "/cdn/shop/files/5-2-500x500.jpg",
		"subheading": "52 x 95 Inch Double French Pinch Pleat Stone Blue Velvet Toile Patterned Curtain",
		"Fabrics": [
			"Jade"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Nature"
		],
		"Color": [
			"Blue"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 415,
		"newPrice": 125
	},
	{
		"id": 103129,
		"title": "Jade 62 x 111 Inch Inverted Box Pleat Ink Velvet Toile Patterned Curtain",
		"ProductUrl": "/sale/jade-62-x-111-inch-inverted-box-pleat-ink-velvet-toile-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66071",
		"_fabric_color": [
			{
				"term_id": 66071,
				"gallery": [
					66094,
					66095,
					66101,
					66096,
					66100,
					66099,
					66098,
					66097
				],
				"imgSrc": "/cdn/shop/files/1-2-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/1-2.jpg",
				"imgSrcF": "/cdn/shop/files/Rose-6.png",
				"title": "Jade / Ink",
				"color": "Brown"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/1-2-500x500.jpg",
		"hoverImg": "/cdn/shop/files/5-2-500x500.jpg",
		"subheading": "62 x 111 Inch Inverted Box Pleat Ink Velvet Toile Patterned Curtain",
		"Fabrics": [
			"Jade"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Nature"
		],
		"Color": [
			"Brown"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 761,
		"newPrice": 228
	},
	{
		"id": 103215,
		"title": "Luxor 39 x 106 Inch Inverted Box Pleat Cream Foil Printed Velvet Patterned Curtain",
		"ProductUrl": "/sale/luxor-39-x-106-inch-inverted-box-pleat-cream-foil-printed-velvet-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64135",
		"_fabric_color": [
			{
				"term_id": 64135,
				"gallery": [
					94912,
					65564,
					65562,
					65657,
					65556,
					65554,
					65557
				],
				"imgSrc": "/cdn/shop/files/BF-TERRA--500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-TERRA-.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005880.png",
				"title": "Luxor / Cream",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"55% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "primere",
				"name": "primere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/BF-TERRA--500x500.png",
		"hoverImg": "/cdn/shop/files/Cream-1-3-500x500.jpg",
		"subheading": "39 x 106 Inch Inverted Box Pleat Cream Foil Printed Velvet Patterned Curtain",
		"Fabrics": [
			"Luxor"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Blackout",
			"Light Filtering"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "55% Off",
		"salenum": 55,
		"oldPrice": 727,
		"newPrice": 327
	},
	{
		"id": 103246,
		"title": "Luxor 51 x 85 Inch Inverted Box Pleat Carrot Foil Printed Velvet Patterned Curtain",
		"ProductUrl": "/sale/luxor-51-x-85-inch-inverted-box-pleat-carrot-foil-printed-velvet-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64142",
		"_fabric_color": [
			{
				"term_id": 64142,
				"gallery": [
					65661,
					94912,
					65564,
					65562,
					65556,
					65554,
					65555
				],
				"imgSrc": "/cdn/shop/files/Frame-1000005884-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Frame-1000005884.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005884.png",
				"title": "Luxor / Carrot",
				"color": "Orange"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"55% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "primere",
				"name": "primere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/BF-TERRA--500x500.png",
		"hoverImg": "/cdn/shop/files/Cream-1-3-500x500.jpg",
		"subheading": "51 x 85 Inch Inverted Box Pleat Carrot Foil Printed Velvet Patterned Curtain",
		"Fabrics": [
			"Luxor"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Orange"
		],
		"Light": [
			"Blackout",
			"Light Filtering"
		],
		"Hanging": [
			"Inverted Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "55% Off",
		"salenum": 55,
		"oldPrice": 597,
		"newPrice": 269
	},
	{
		"id": 103275,
		"title": "Peacock 47 x 94 Inch Goblet Summer Linen Floral Patterned Curtain",
		"ProductUrl": "/sale/peacock-47-x-94-inch-goblet-summer-linen-floral-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64075",
		"_fabric_color": [
			{
				"term_id": 64075,
				"gallery": [
					98620,
					98621,
					98622,
					98624,
					98625,
					98623
				],
				"imgSrc": "/cdn/shop/files/1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/1.jpg",
				"imgSrcF": "/cdn/shop/files/summer-1.png",
				"title": "Peacock / Summer",
				"color": "Green"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Fall-2-500x500.png",
		"hoverImg": "/cdn/shop/files/Fall-2-500x500.jpg",
		"subheading": "47 x 94 Inch Goblet Summer Linen Floral Patterned Curtain",
		"Fabrics": [
			"Peacock"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Floral"
		],
		"Color": [
			"Green"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Goblet Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 716,
		"newPrice": 179
	},
	{
		"id": 103140,
		"title": "Rosé 47 x 95 Inch Triple French Pinch Pleat Velvet Patterned Curtain",
		"ProductUrl": "/sale/rose-47-x-95-inch-triple-french-pinch-pleat-velvet-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64070",
		"_fabric_color": [
			{
				"term_id": 64070,
				"gallery": [
					65906,
					64377,
					64382,
					64381,
					64378,
					64380
				],
				"imgSrc": "/cdn/shop/files/Ink-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Ink.jpg",
				"imgSrcF": "/cdn/shop/files/Ink-5-1.jpg",
				"title": "Rosé / Rosé",
				"color": "Red"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Ink-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Ink-3-1-500x500.jpg",
		"subheading": "47 x 95 Inch Triple French Pinch Pleat Velvet Patterned Curtain",
		"Fabrics": [
			"Rosé"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Floral"
		],
		"Color": [
			"Red"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 621,
		"newPrice": 155
	},
	{
		"id": 103139,
		"title": "Rosé 78 x 124 Inch Triple French Pinch Pleat Velvet Patterned Curtain",
		"ProductUrl": "/sale/rose-78-x-124-inch-triple-french-pinch-pleat-velvet-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64070",
		"_fabric_color": [
			{
				"term_id": 64070,
				"gallery": [
					65906,
					64377,
					64382,
					64381,
					64378,
					64380
				],
				"imgSrc": "/cdn/shop/files/Ink-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Ink.jpg",
				"imgSrcF": "/cdn/shop/files/Ink-5-1.jpg",
				"title": "Rosé / Rosé",
				"color": "Red"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": true,
		"tags": [
			{
				"slug": "editors-pick",
				"name": "editor's pick"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Ink-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Ink-3-1-500x500.jpg",
		"subheading": "78 x 124 Inch Triple French Pinch Pleat Velvet Patterned Curtain",
		"Fabrics": [
			"Rosé"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Floral"
		],
		"Color": [
			"Red"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 1175,
		"newPrice": 294
	},
	{
		"id": 103259,
		"title": "Silhouette 38 x 108 Inch Double French Pinch Pleat Sand Linen Woven Sheer Curtain",
		"ProductUrl": "/sale/silhouette-38-x-108-inch-double-french-pinch-pleat-sand-linen-woven-sheer-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64081",
		"_fabric_color": [
			{
				"term_id": 64081,
				"gallery": [
					64416,
					64418,
					94831,
					64424,
					64423,
					64422,
					64419,
					64417
				],
				"imgSrc": "/cdn/shop/files/Sand-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Sand-1.jpg",
				"imgSrcF": "/cdn/shop/files/FA-FT0103-color-1.png",
				"title": "Silhouette / Sand",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": true,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "bestseller",
				"name": "bestseller"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Sand-1-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Sand-1-500x500.png",
		"subheading": "38 x 108 Inch Double French Pinch Pleat Sand Linen Woven Sheer Curtain",
		"Fabrics": [
			"Silhouette"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Light Filtering"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 579,
		"newPrice": 174
	},
	{
		"id": 103261,
		"title": "Silhouette 52 x 95 Inch Double French Pinch Pleat Sand Linen Woven Sheer Curtain",
		"ProductUrl": "/sale/silhouette-52-x-95-inch-double-french-pinch-pleat-sand-linen-woven-sheer-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64081",
		"_fabric_color": [
			{
				"term_id": 64081,
				"gallery": [
					64416,
					64418,
					94831,
					64424,
					64423,
					64422,
					64419,
					64417
				],
				"imgSrc": "/cdn/shop/files/Sand-1-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Sand-1.jpg",
				"imgSrcF": "/cdn/shop/files/FA-FT0103-color-1.png",
				"title": "Silhouette / Sand",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"70% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": true,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "bestseller",
				"name": "bestseller"
			},
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Sand-1-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Sand-1-500x500.png",
		"subheading": "52 x 95 Inch Double French Pinch Pleat Sand Linen Woven Sheer Curtain",
		"Fabrics": [
			"Silhouette"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Light Filtering"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "70% Off",
		"salenum": 70,
		"oldPrice": 558,
		"newPrice": 167
	},
	{
		"id": 103262,
		"title": "Tide 38 x 107 Inch Goblet Cream Linen Textured Curtain",
		"ProductUrl": "/sale/tide-38-x-107-inch-goblet-cream-linen-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64076",
		"_fabric_color": [
			{
				"term_id": 64076,
				"gallery": [
					65270,
					65264,
					65690,
					65269,
					65268,
					65267,
					65266
				],
				"imgSrc": "/cdn/shop/files/Cream-4-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Cream-4.jpg",
				"imgSrcF": "/cdn/shop/files/FB-CR3303.png",
				"title": "Tide / Cream",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"60% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Cream-4-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Cream-1-500x500.png",
		"subheading": "38 x 107 Inch Goblet Cream Linen Textured Curtain",
		"Fabrics": [
			"Tide"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Goblet Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 561,
		"newPrice": 224
	},
	{
		"id": 103264,
		"title": "Tide 51 x 95 Inch Goblet Cream Linen Textured Curtain",
		"ProductUrl": "/sale/tide-51-x-95-inch-goblet-cream-linen-textured-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64076",
		"_fabric_color": [
			{
				"term_id": 64076,
				"gallery": [
					65270,
					65264,
					65690,
					65269,
					65268,
					65267,
					65266
				],
				"imgSrc": "/cdn/shop/files/Cream-4-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Cream-4.jpg",
				"imgSrcF": "/cdn/shop/files/FB-CR3303.png",
				"title": "Tide / Cream",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"60% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Cream-4-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Cream-1-500x500.png",
		"subheading": "51 x 95 Inch Goblet Cream Linen Textured Curtain",
		"Fabrics": [
			"Tide"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Beige"
		],
		"Light": [
			"Blackout",
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [
			"Goblet Pleat"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "60% Off",
		"salenum": 60,
		"oldPrice": 401,
		"newPrice": 160
	},
	{
		"id": 103316,
		"title": "Unwind 79 x 125 Inch Triple French Pinch Pleat White Linen Grid Woven Sheer Curtain",
		"ProductUrl": "/sale/unwind-79-x-125-inch-triple-french-pinch-pleat-white-linen-grid-woven-sheer-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64080",
		"_fabric_color": [
			{
				"term_id": 64080,
				"gallery": [
					94631,
					94633,
					94634,
					94636,
					97910,
					97911
				],
				"imgSrc": "/cdn/shop/files/Unwind-FT0301-2-500x500.jpg",
				"imgSrc_n": "/cdn/shop/files/Unwind-FT0301-2.jpg",
				"imgSrcF": "/cdn/shop/files/FA-FT0301-color.png",
				"title": "Unwind / White",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"75% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "primere",
				"name": "primere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Unwind-FT0301-2-500x500.jpg",
		"hoverImg": "/cdn/shop/files/Unwind-FT0301-6-500x500.jpg",
		"subheading": "79 x 125 Inch Triple French Pinch Pleat White Linen Grid Woven Sheer Curtain",
		"Fabrics": [
			"Unwind"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Sheer"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "75% Off",
		"salenum": 75,
		"oldPrice": 1121,
		"newPrice": 280
	},
	{
		"id": 103029,
		"title": "Zen 39 x 123 inch Double French Pinch Pleat Black Velvet Patterned Curtain",
		"ProductUrl": "/sale/zen-39-x-123-inch-double-french-pinch-pleat-black-velvet-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64132",
		"_fabric_color": [
			{
				"term_id": 64132,
				"gallery": [
					94923,
					65392,
					65645,
					94686,
					65390,
					65389
				],
				"imgSrc": "/cdn/shop/files/BF509-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF509-3.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005879-1.png",
				"title": "Zen / Black",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"65% Off Sale",
			"Curtain Measurement",
			"Fixed Size",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale",
			"upcoming fall"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "primere",
				"name": "primere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/BF509-3-500x500.png",
		"hoverImg": "/cdn/shop/files/Black-2-2-500x500.jpg",
		"subheading": "39 x 123 inch Double French Pinch Pleat Black Velvet Patterned Curtain",
		"Fabrics": [
			"Zen"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Nature"
		],
		"Color": [
			"Black"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "65% Off",
		"salenum": 65,
		"oldPrice": 1436,
		"newPrice": 503
	},
	{
		"id": 103030,
		"title": "Zen 52 x 95 inch Double French Pinch Pleat Black Velvet Patterned Curtain",
		"ProductUrl": "/sale/zen-52-x-95-inch-double-french-pinch-pleat-black-velvet-patterned-curtain/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64132",
		"_fabric_color": [
			{
				"term_id": 64132,
				"gallery": [
					94923,
					65392,
					65645,
					94686,
					65390,
					65389
				],
				"imgSrc": "/cdn/shop/files/BF509-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF509-3.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005879-1.png",
				"title": "Zen / Black",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"65% Off Sale",
			"Curtain Measurement",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Sample Sale",
			"upcoming fall"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "indoor-curtain",
				"name": "Indoor curtain"
			},
			{
				"slug": "primere",
				"name": "primere"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/BF509-3-500x500.png",
		"hoverImg": "/cdn/shop/files/Black-2-2-500x500.jpg",
		"subheading": "52 x 95 inch Double French Pinch Pleat Black Velvet Patterned Curtain",
		"Fabrics": [
			"Zen"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Nature"
		],
		"Color": [
			"Black"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Pinch Pleated"
		],
		"Space": [
			"Indoor"
		],
		"Sale": "65% Off",
		"salenum": 65,
		"oldPrice": 1071,
		"newPrice": 375
	}
];
var sunshadesList = [
    {
        "id": 110679,
        "title": "HDPE Breathable Quadrati Custom Rectangle Sun Shade Sail",
        "ProductUrl": "/sun-shade-sail/hdpe-breathable-quadrati-custom-rectangle-sun-shade-sail/?fwidth=60&flength=60",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "extra": "Extra 10%",
        "_is_default_fabric": "110806",
        "_fabric_color": [
            {
                "term_id": 110806,
                "gallery": [
                    110726,
                    110725,
                    110727,
                    110815,
                    110729,
                    110730,
                    110731
                ],
                "imgSrc": "/cdn/shop/files/beige_副本1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/beige_副本1.jpg",
                "imgSrcF": "/cdn/shop/files/beige-3.jpg",
                "price": 40,
                "title": "HDPE / Beige",
                "color": "Beige"
            },
            {
                "term_id": 110807,
                "gallery": [
                    110756,
                    110757,
                    110760,
                    110762,
                    110758,
                    110761,
                    110763
                ],
                "imgSrc": "/cdn/shop/files/khaki-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/khaki-1.jpg",
                "imgSrcF": "/cdn/shop/files/khaki-2.jpg",
                "price": 40,
                "title": "HDPE / Khaki",
                "color": "Beige"
            },
            {
                "term_id": 110808,
                "gallery": [
                    110786,
                    110785,
                    110784,
                    110783,
                    110781,
                    110780,
                    110787
                ],
                "imgSrc": "/cdn/shop/files/white_副本3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/white_副本3.jpg",
                "imgSrcF": "/cdn/shop/files/white-2.jpg",
                "price": 40,
                "title": "HDPE / White",
                "color": "White"
            },
            {
                "term_id": 110810,
                "gallery": [
                    110748,
                    110749,
                    110751,
                    110755,
                    110754,
                    110753,
                    110750
                ],
                "imgSrc": "/cdn/shop/files/grey-2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/grey-2.jpg",
                "imgSrcF": "/cdn/shop/files/grey-3.jpg",
                "price": 40,
                "title": "HDPE / Gray",
                "color": "Grey"
            },
            {
                "term_id": 110811,
                "gallery": [
                    110778,
                    110777,
                    110776,
                    110775,
                    110773,
                    110772,
                    110779
                ],
                "imgSrc": "/cdn/shop/files/teal_副本3-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/teal_副本3.jpg",
                "imgSrcF": "/cdn/shop/files/teal-3.jpg",
                "price": 40,
                "title": "HDPE / Teal",
                "color": "Blue"
            },
            {
                "term_id": 110812,
                "gallery": [
                    110734,
                    110735,
                    110733,
                    110736,
                    110737,
                    110738,
                    110739
                ],
                "imgSrc": "/cdn/shop/files/brown_副本1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/brown_副本1.jpg",
                "imgSrcF": "/cdn/shop/files/brown-2.jpg",
                "price": 40,
                "title": "HDPE / Brown",
                "color": "Brown"
            },
            {
                "term_id": 110809,
                "gallery": [
                    110743,
                    110744,
                    110746,
                    110745,
                    110741,
                    110740,
                    110747
                ],
                "imgSrc": "/cdn/shop/files/green_副本-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/green_副本.jpg",
                "imgSrcF": "/cdn/shop/files/green-1.jpg",
                "price": 40,
                "title": "HDPE / Hunter Green",
                "color": "Green"
            }
        ],
        "_fabric_classic": [],
        "CategoriesAll": [],
        "AllCategory": [
            "10% Off Sale",
            "All Bestsellers",
            "Black Friday",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Cyber Monday",
            "Extra 10%",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Sale",
            "Search outdoor",
            "Search sail",
            "Spring Time Sale",
            "Summer",
            "Summer Collection",
            "Summer Outdoor Decor",
            "Sun Shade Sail",
            "UVShield™ Sun Shades",
            "Waterproof Sun Shades"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "aquashield",
                "name": "aquashield"
            },
            {
                "slug": "sun-shade-sails",
                "name": "Sun Shade Sails"
            }
        ],
        "short_description": "<strong>Customized To Your Need</strong>\r\n\r\nWith a variety of size options available, you can get the perfect fit for your space. Our sun shade also available with top-quality mounting hardware and adjustable ropes, ensuring that your installation will be both secure and tailored to your specific needs. Durable &amp; Cost-effective\r\n\r\n<strong>Durable &amp; Cost-effective</strong>\r\n\r\nCompared to other shading options, such as permanent structures or retractable awnings, a sunshade sail is a more affordable option while still providing the same benefits. Our sunshade sail can withstand the toughest outdoor conditions, making it a great investment that will provide shade for years to come.\r\n\r\n<strong>Perfect For A Variety Of Outdoor Scenes</strong>\r\n\r\nOur sunshade sails can be used in a variety of settings, including patios, decks, pools, and even commercial spaces, making it a versatile option for providing shade wherever you need it. Enjoy the beauty of the great outdoors without worrying about sun damage or excessive heat!",
        "imgSrc": "/cdn/shop/files/FotoJet-37-500x500.jpg",
        "hoverImg": "/cdn/shop/files/D型环反-500x500.jpg",
        "subheading": "Breathable Quadrati Custom Rectangle Sun Shade Sail",
        "Fabrics": [
            "HDPE"
        ],
        "Feature": [
            "Anti-Dust"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Beige",
            "White",
            "Grey",
            "Blue",
            "Brown",
            "Green"
        ],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Outdoor"
        ],
        "Sale": "10% Off",
        "salenum": 10,
        "oldPrice": 390,
        "newPrice": 351
    },
    {
        "id": 38183,
        "title": "UVShield™ Waterproof Custom Triangle Sun Shade Sail",
        "ProductUrl": "/sun-shade-sail/outdoor-waterproof-sun-shade-sail-canopy-triangle-uv-block-for-patio/?fwidth=60&flength=60",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "extra": "Extra 10%",
        "_is_default_fabric": "38104",
        "_fabric_color": [
            {
                "term_id": 38104,
                "gallery": [
                    110824,
                    110825,
                    99542,
                    99541,
                    99552,
                    99540,
                    99545,
                    99543,
                    99544,
                    99548
                ],
                "imgSrc": "/cdn/shop/files/image-1-copy-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/image-1-copy.jpg",
                "imgSrcF": "/cdn/shop/files/Beige.png",
                "price": 40,
                "title": "UVShield™ / Beige",
                "color": "Beige"
            },
            {
                "term_id": 38876,
                "gallery": [
                    99634,
                    99633,
                    99635,
                    99636,
                    99639,
                    99637,
                    99640,
                    99638
                ],
                "imgSrc": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Grey-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Grey-2.png",
                "imgSrcF": "/cdn/shop/files/grey.png",
                "price": 40,
                "title": "UVShield™ / Grey",
                "color": "Grey"
            },
            {
                "term_id": 38246,
                "gallery": [
                    99229,
                    99233,
                    99230,
                    99231,
                    99351,
                    99350,
                    99485,
                    99474
                ],
                "imgSrc": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-7.png",
                "price": 40,
                "title": "UVShield™ / Navy Blue",
                "color": "Blue"
            },
            {
                "term_id": 38216,
                "gallery": [
                    99221,
                    99224,
                    99222,
                    99223,
                    99275,
                    99274,
                    99483,
                    99472
                ],
                "imgSrc": "/cdn/shop/files/Triangle-Sun-Shade-Sail-White-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Triangle-Sun-Shade-Sail-White-1.jpg",
                "imgSrcF": "/cdn/shop/files/white.png",
                "price": 40,
                "title": "UVShield™ / White",
                "color": "White"
            },
            {
                "term_id": 42748,
                "gallery": [
                    99252,
                    99255,
                    99253,
                    99254,
                    99269,
                    99268,
                    99489,
                    99478
                ],
                "imgSrc": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Hunter-Green-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Hunter-Green-1.jpg",
                "imgSrcF": "/cdn/shop/files/sun-7.png",
                "price": 40,
                "title": "UVShield™ / Hunter Green",
                "color": "Green"
            },
            {
                "term_id": 38239,
                "gallery": [
                    99217,
                    99220,
                    99218,
                    99219,
                    99273,
                    99272,
                    99486,
                    99475
                ],
                "imgSrc": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Red-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Red-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-8.png",
                "price": 40,
                "title": "UVShield™ / Red",
                "color": "Red"
            },
            {
                "term_id": 99158,
                "gallery": [
                    99213,
                    99216,
                    99214,
                    99215,
                    99271,
                    99270,
                    99481,
                    99470
                ],
                "imgSrc": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Olive-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Olive-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-3.png",
                "price": 40,
                "title": "UVShield™ / Olive",
                "color": "Red"
            },
            {
                "term_id": 99155,
                "gallery": [
                    99679,
                    99682,
                    99680,
                    99681,
                    99677,
                    99676,
                    99674,
                    99675
                ],
                "imgSrc": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Cream-5-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Cream-5.png",
                "imgSrcF": "/cdn/shop/files/1-2.png",
                "price": 40,
                "title": "UVShield™ / Cream",
                "color": "Red"
            },
            {
                "term_id": 99152,
                "gallery": [
                    99240,
                    99243,
                    99241,
                    99242,
                    99263,
                    99262,
                    99479,
                    99468
                ],
                "imgSrc": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Carrot-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Carrot-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-1-1.png",
                "price": 40,
                "title": "UVShield™ / Carrot",
                "color": "Red"
            },
            {
                "term_id": 99151,
                "gallery": [
                    99256,
                    99212,
                    99257,
                    99211,
                    99267,
                    99266,
                    99488,
                    99477
                ],
                "imgSrc": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Navy-Blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Navy-Blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-10.png",
                "price": 40,
                "title": "UVShield™ / Blue",
                "color": "Red"
            },
            {
                "term_id": 99150,
                "gallery": [
                    99248,
                    99251,
                    99249,
                    99250,
                    99279,
                    99278,
                    99484,
                    99473
                ],
                "imgSrc": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Forest-Green-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Forest-Green-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-6.png",
                "price": 40,
                "title": "UVShield™ / Forest Green",
                "color": "Red"
            },
            {
                "term_id": 99148,
                "gallery": [
                    99236,
                    99239,
                    99237,
                    99238,
                    99261,
                    99260,
                    99482,
                    99471
                ],
                "imgSrc": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Burgundy-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Burgundy-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-4.png",
                "price": 40,
                "title": "UVShield™ / Burgundy",
                "color": "Red"
            },
            {
                "term_id": 99146,
                "gallery": [
                    99225,
                    99228,
                    99226,
                    99227,
                    99277,
                    99276,
                    99487,
                    99476
                ],
                "imgSrc": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Yellow-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Triangle-Sun-Shade-Sail-Yellow-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-9.png",
                "price": 40,
                "title": "UVShield™ / Yellow",
                "color": "Red"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 95143,
                "gallery": null,
                "price": 0,
                "title": "No Hardware"
            },
            {
                "term_id": 38762,
                "gallery": null,
                "price": 89,
                "title": "M8-40 Pieces Set"
            },
            {
                "term_id": 38760,
                "gallery": null,
                "price": 69,
                "title": "M6-40 Pieces Set"
            },
            {
                "term_id": 38758,
                "gallery": null,
                "price": 58,
                "title": "M5-40 Pieces Set"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "All Bestsellers",
            "Black Friday",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Cyber Monday",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Sale",
            "Search outdoor",
            "Search sail",
            "Spring Time Sale",
            "Summer Collection",
            "Summer Outdoor Decor",
            "Sun Shade Sail",
            "UVShield™ Sun Shades",
            "Waterproof Sun Shades"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "aquashield",
                "name": "aquashield"
            },
            {
                "slug": "sun-shade-sails",
                "name": "Sun Shade Sails"
            },
            {
                "slug": "thanksgiving-20",
                "name": "Thanksgiving 20%"
            }
        ],
        "short_description": "<strong>Customized To Your Need</strong>\r\n\r\nWith a variety of size options available, you can get the perfect fit for your space. Our sun shade also available with top-quality mounting hardware and adjustable ropes, ensuring that your installation will be both secure and tailored to your specific needs. Durable &amp; Cost-effective\r\n\r\n<strong>Durable &amp; Cost-effective</strong>\r\n\r\nCompared to other shading options, such as permanent structures or retractable awnings, a sunshade sail is a more affordable option while still providing the same benefits. Our sunshade sail can withstand the toughest outdoor conditions, making it a great investment that will provide shade for years to come.\r\n\r\n<strong>Perfect For A Variety Of Outdoor Scenes</strong>\r\n\r\nOur sunshade sails can be used in a variety of settings, including patios, decks, pools, and even commercial spaces, making it a versatile option for providing shade wherever you need it. Enjoy the beauty of the great outdoors without worrying about sun damage or excessive heat!",
        "imgSrc": "/cdn/shop/files/image-3-copy-500x500.png",
        "hoverImg": "/cdn/shop/files/Triangle-beige-6-500x500.png",
        "subheading": "Waterproof Custom Triangle Sun Shade Sail",
        "Fabrics": [
            "UVShield™"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Grey",
            "Blue",
            "White",
            "Green",
            "Red"
        ],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 168,
        "newPrice": 226
    },
    {
        "id": 38094,
        "title": "UVShield™ Waterproof Quadrati Custom Rectangle Sun Shade Sail",
        "ProductUrl": "/sun-shade-sail/outdoor-waterproof-sun-shade-sail-rectangle-uv-block-for-patio-garden-backyard-lawn/?fwidth=60&flength=60",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "extra": "Extra 10%",
        "_is_default_fabric": "38104",
        "_fabric_color": [
            {
                "term_id": 38104,
                "gallery": [
                    110823,
                    99538,
                    99536,
                    99537,
                    99038,
                    99533,
                    99539,
                    99535,
                    99534
                ],
                "imgSrc": "/cdn/shop/files/image-5-copy2-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/image-5-copy2.jpg",
                "imgSrcF": "/cdn/shop/files/Beige.png",
                "price": 21,
                "title": "UVShield™ / Beige",
                "color": "Beige"
            },
            {
                "term_id": 38876,
                "gallery": [
                    99652,
                    99651,
                    99650,
                    99387,
                    99648,
                    99646,
                    99649,
                    99647
                ],
                "imgSrc": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Grey-6-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Grey-6.png",
                "imgSrcF": "/cdn/shop/files/grey.png",
                "price": 21,
                "title": "UVShield™ / Grey",
                "color": "Grey"
            },
            {
                "term_id": 38106,
                "gallery": [
                    99205,
                    99206,
                    99207,
                    99038,
                    99351,
                    99350,
                    99485,
                    99474
                ],
                "imgSrc": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-7.png",
                "price": 21,
                "title": "UVShield™ / Royal Blue",
                "color": "Blue"
            },
            {
                "term_id": 38133,
                "gallery": [
                    99193,
                    99194,
                    99195,
                    99038,
                    99273,
                    99272,
                    99486,
                    99475
                ],
                "imgSrc": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Red-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Red-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-8.png",
                "price": 21,
                "title": "UVShield™ / Red",
                "color": "Red"
            },
            {
                "term_id": 38145,
                "gallery": [
                    99202,
                    99203,
                    99204,
                    99038,
                    99275,
                    99274,
                    99483,
                    99472
                ],
                "imgSrc": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-White1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-White1.jpg",
                "imgSrcF": "/cdn/shop/files/white.png",
                "price": 21,
                "title": "UVShield™ / White",
                "color": "White"
            },
            {
                "term_id": 38119,
                "gallery": [
                    99187,
                    99188,
                    99189,
                    99038,
                    99269,
                    99268,
                    99489,
                    99478
                ],
                "imgSrc": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Hunter-Green-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Hunter-Green-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-11.png",
                "price": 21,
                "title": "UVShield™ / Hunter Green",
                "color": "Green"
            },
            {
                "term_id": 99158,
                "gallery": [
                    99190,
                    99191,
                    99192,
                    99387,
                    99271,
                    99270,
                    99481,
                    99470
                ],
                "imgSrc": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Olive-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Olive-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-3.png",
                "price": 21,
                "title": "UVShield™ / Olive",
                "color": "Green"
            },
            {
                "term_id": 99155,
                "gallery": [
                    99666,
                    99665,
                    99664,
                    99387,
                    99663,
                    99662,
                    99667,
                    99668
                ],
                "imgSrc": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Cream-5-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Cream-5.png",
                "imgSrcF": "/cdn/shop/files/1-2.png",
                "price": 21,
                "title": "UVShield™ / Cream",
                "color": "Green"
            },
            {
                "term_id": 99152,
                "gallery": [
                    99178,
                    99179,
                    99180,
                    99387,
                    99263,
                    99262,
                    99479,
                    99468
                ],
                "imgSrc": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Carrot-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Carrot-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-1-1.png",
                "price": 21,
                "title": "UVShield™ / Carrot",
                "color": "Green"
            },
            {
                "term_id": 99151,
                "gallery": [
                    99196,
                    99197,
                    99198,
                    99387,
                    99359,
                    99358,
                    99488,
                    99477
                ],
                "imgSrc": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Royal-Blue-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Royal-Blue-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-10.png",
                "price": 21,
                "title": "UVShield™ / Blue",
                "color": "Green"
            },
            {
                "term_id": 99150,
                "gallery": [
                    99184,
                    99185,
                    99186,
                    99387,
                    99279,
                    99278,
                    99484,
                    99473
                ],
                "imgSrc": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Forest-Green-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Forest-Green-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-6.png",
                "price": 21,
                "title": "UVShield™ / Forest Green",
                "color": "Green"
            },
            {
                "term_id": 99148,
                "gallery": [
                    99208,
                    99209,
                    99210,
                    99387,
                    99261,
                    99260,
                    99482,
                    99471
                ],
                "imgSrc": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Burgundy-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Burgundy-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-4.png",
                "price": 21,
                "title": "UVShield™ / Burgundy",
                "color": "Green"
            },
            {
                "term_id": 99146,
                "gallery": [
                    99199,
                    99200,
                    99201,
                    99387,
                    99277,
                    99276,
                    99487,
                    99476
                ],
                "imgSrc": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Yellow-1-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-Yellow-1.jpg",
                "imgSrcF": "/cdn/shop/files/1-9.png",
                "price": 21,
                "title": "UVShield™ / Yellow",
                "color": "Green"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 95143,
                "gallery": null,
                "price": 0,
                "title": "No Hardware"
            },
            {
                "term_id": 38758,
                "gallery": null,
                "price": 58,
                "title": "M5-40 Pieces Set"
            },
            {
                "term_id": 38760,
                "gallery": null,
                "price": 69,
                "title": "M6-40 Pieces Set"
            },
            {
                "term_id": 38762,
                "gallery": null,
                "price": 89,
                "title": "M8-40 Pieces Set"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "30% Off Sale",
            "All Bestsellers",
            "Black Friday",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Cyber Monday",
            "Extra 10%",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "Independence Day",
            "New Content",
            "New Product UI",
            "new rod UI",
            "New Year's Day",
            "Sale",
            "Search outdoor",
            "Search sail",
            "Spring Time Sale",
            "Summer",
            "Summer Collection",
            "Summer Outdoor Decor",
            "Sun Shade Sail",
            "UVShield™ Sun Shades",
            "Waterproof Sun Shades"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "aquashield",
                "name": "aquashield"
            },
            {
                "slug": "sun-shade-sails",
                "name": "Sun Shade Sails"
            }
        ],
        "short_description": "<strong>Customized To Your Need</strong>\r\n\r\nWith a variety of size options available, you can get the perfect fit for your space. Our sun shade also available with top-quality mounting hardware and adjustable ropes, ensuring that your installation will be both secure and tailored to your specific needs. Durable &amp; Cost-effective\r\n\r\n<strong>Durable &amp; Cost-effective</strong>\r\n\r\nCompared to other shading options, such as permanent structures or retractable awnings, a sunshade sail is a more affordable option while still providing the same benefits. Our sunshade sail can withstand the toughest outdoor conditions, making it a great investment that will provide shade for years to come.\r\n\r\n<strong>Perfect For A Variety Of Outdoor Scenes</strong>\r\n\r\nOur sunshade sails can be used in a variety of settings, including patios, decks, pools, and even commercial spaces, making it a versatile option for providing shade wherever you need it. Enjoy the beauty of the great outdoors without worrying about sun damage or excessive heat!",
        "imgSrc": "/cdn/shop/files/image-5-copy2-500x500.jpg",
        "hoverImg": "/cdn/shop/files/Triangle-beige-6-500x500.png",
        "subheading": "Waterproof Quadrati Custom Rectangle Sun Shade Sail",
        "Fabrics": [
            "UVShield™"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Grey",
            "Blue",
            "Red",
            "White",
            "Green"
        ],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Outdoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 371,
        "newPrice": 260
    },
    {
        "id": 95071,
        "title": "UVShield™ Waterproof Irregular Custom Rectangle Sun Shade Sail",
        "ProductUrl": "/sun-shade-sails/custom-uvshield-irregular-quadrilateral-sun-shade-sail/?fwidth=60&flength=60",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "extra": "Extra 10%",
        "_is_default_fabric": "38104",
        "_fabric_color": [
            {
                "term_id": 38104,
                "gallery": [
                    99546,
                    99549,
                    99547,
                    99550,
                    99548
                ],
                "imgSrc": "/cdn/shop/files/Irregular-Quadrilateral-Sun-Shade-Sail-beige-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Irregular-Quadrilateral-Sun-Shade-Sail-beige-2.png",
                "imgSrcF": "/cdn/shop/files/Beige.png",
                "price": 21,
                "title": "UVShield™ / Beige",
                "color": "Beige"
            },
            {
                "term_id": 38876,
                "gallery": [
                    99644,
                    99642,
                    99645,
                    99641,
                    99643
                ],
                "imgSrc": "/cdn/shop/files/Irregular-Quadrilateral-Sun-Shade-Sail-Grey4-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Irregular-Quadrilateral-Sun-Shade-Sail-Grey4.png",
                "imgSrcF": "/cdn/shop/files/grey.png",
                "price": 21,
                "title": "UVShield™ / Grey",
                "color": "Grey"
            },
            {
                "term_id": 38106,
                "gallery": [
                    99166,
                    99259,
                    99258,
                    99485,
                    99474
                ],
                "imgSrc": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Blue-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Blue.jpg",
                "imgSrcF": "/cdn/shop/files/1-7.png",
                "price": 21,
                "title": "UVShield™ / Royal Blue",
                "color": "Blue"
            },
            {
                "term_id": 38133,
                "gallery": [
                    99174,
                    99365,
                    99364,
                    99486,
                    99475
                ],
                "imgSrc": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Red-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Red.jpg",
                "imgSrcF": "/cdn/shop/files/1-8.png",
                "price": 21,
                "title": "UVShield™ / Red",
                "color": "Red"
            },
            {
                "term_id": 38145,
                "gallery": [
                    99176,
                    99367,
                    99366,
                    99483,
                    99472
                ],
                "imgSrc": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-White-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-White.jpg",
                "imgSrcF": "/cdn/shop/files/white.png",
                "price": 21,
                "title": "UVShield™ / White",
                "color": "White"
            },
            {
                "term_id": 38119,
                "gallery": [
                    99172,
                    99361,
                    99360,
                    99489,
                    99478
                ],
                "imgSrc": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Hunter-Green-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Hunter-Green.jpg",
                "imgSrcF": "/cdn/shop/files/1-11.png",
                "price": 21,
                "title": "UVShield™ / Hunter Green",
                "color": "Green"
            },
            {
                "term_id": 99158,
                "gallery": [
                    99173,
                    99363,
                    99362,
                    99481,
                    99470
                ],
                "imgSrc": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Olive-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Olive.jpg",
                "imgSrcF": "/cdn/shop/files/1-3.png",
                "price": 21,
                "title": "UVShield™ / Olive",
                "color": "Green"
            },
            {
                "term_id": 99155,
                "gallery": [
                    99672,
                    99673,
                    99671,
                    99669,
                    99670
                ],
                "imgSrc": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Cream-4-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Cream-4.png",
                "imgSrcF": "/cdn/shop/files/1-2.png",
                "price": 21,
                "title": "UVShield™ / Cream",
                "color": "Green"
            },
            {
                "term_id": 99152,
                "gallery": [
                    99169,
                    99355,
                    99354,
                    99479,
                    99468
                ],
                "imgSrc": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Carrot-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Carrot.jpg",
                "imgSrcF": "/cdn/shop/files/1-1-1.png",
                "price": 21,
                "title": "UVShield™ / Carrot",
                "color": "Green"
            },
            {
                "term_id": 99151,
                "gallery": [
                    99175,
                    99267,
                    99266,
                    99488,
                    99477
                ],
                "imgSrc": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Royal-Blue-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Royal-Blue.jpg",
                "imgSrcF": "/cdn/shop/files/1-10.png",
                "price": 21,
                "title": "UVShield™ / Blue",
                "color": "Green"
            },
            {
                "term_id": 99150,
                "gallery": [
                    99171,
                    99371,
                    99370,
                    99484,
                    99473
                ],
                "imgSrc": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Forest-Green-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Forest-Green.jpg",
                "imgSrcF": "/cdn/shop/files/1-6.png",
                "price": 21,
                "title": "UVShield™ / Forest Green",
                "color": "Green"
            },
            {
                "term_id": 99148,
                "gallery": [
                    99168,
                    99353,
                    99352,
                    99482,
                    99471
                ],
                "imgSrc": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Burgundy-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Burgundy.jpg",
                "imgSrcF": "/cdn/shop/files/1-4.png",
                "price": 21,
                "title": "UVShield™ / Burgundy",
                "color": "Green"
            },
            {
                "term_id": 99146,
                "gallery": [
                    99177,
                    99368,
                    99369,
                    99487,
                    99476
                ],
                "imgSrc": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Yellow-500x500.jpg",
                "imgSrc_n": "/cdn/shop/files/Quadrilateral-Sun-Shade-Sail-Yellow.jpg",
                "imgSrcF": "/cdn/shop/files/1-9.png",
                "price": 21,
                "title": "UVShield™ / Yellow",
                "color": "Green"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 95143,
                "gallery": null,
                "price": 0,
                "title": "No Hardware"
            },
            {
                "term_id": 38758,
                "gallery": null,
                "price": 58,
                "title": "M5-40 Pieces Set"
            },
            {
                "term_id": 38760,
                "gallery": null,
                "price": 69,
                "title": "M6-40 Pieces Set"
            },
            {
                "term_id": 38762,
                "gallery": null,
                "price": 89,
                "title": "M8-40 Pieces Set"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "30% Off Sale",
            "All Bestsellers",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Factory products",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Search outdoor",
            "Search sail",
            "Sun Shade Sail",
            "UVShield™ Sun Shades",
            "Waterproof Sun Shades"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "sun-shade-sails",
                "name": "Sun Shade Sails"
            }
        ],
        "short_description": "<strong>Customized To Your Need</strong>\r\n\r\nWith a variety of size options available, you can get the perfect fit for your space. Our sun shade also available with top-quality mounting hardware and adjustable ropes, ensuring that your installation will be both secure and tailored to your specific needs. Durable &amp; Cost-effective\r\n\r\n<strong>Durable &amp; Cost-effective</strong>\r\n\r\nCompared to other shading options, such as permanent structures or retractable awnings, a sunshade sail is a more affordable option while still providing the same benefits. Our sunshade sail can withstand the toughest outdoor conditions, making it a great investment that will provide shade for years to come.\r\n\r\n<strong>Perfect For A Variety Of Outdoor Scenes</strong>\r\n\r\nOur sunshade sails can be used in a variety of settings, including patios, decks, pools, and even commercial spaces, making it a versatile option for providing shade wherever you need it. Enjoy the beauty of the great outdoors without worrying about sun damage or excessive heat!",
        "imgSrc": "/cdn/shop/files/Irregular-Quadrilateral-Sun-Shade-Sail-beige-2-500x500.png",
        "hoverImg": "/cdn/shop/files/Rectangle-Sun-Shade-Sail-beige-2-500x500.png",
        "subheading": "Waterproof Irregular Custom Rectangle Sun Shade Sail",
        "Fabrics": [
            "UVShield™"
        ],
        "Feature": [],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Solid"
        ],
        "Color": [
            "Beige",
            "Grey",
            "Blue",
            "Red",
            "White",
            "Green"
        ],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Outdoor"
        ],
        "Sale": "30% Off",
        "salenum": 30,
        "oldPrice": 269,
        "newPrice": 188
    },
    {
        "id": 38304,
        "title": "UVShield™ Striped Waterproof Custom Triangle Sun Shade Sail",
        "ProductUrl": "/sun-shade-sail/outdoor-striped-triangle-sun-shade-sail-opaque-privacy-protection-uv-block-canopy-for-patio/?fwidth=60&flength=60",
        "isNewArrival": false,
        "meetingExtraType": 0,
        "extra": "Extra 10%",
        "_is_default_fabric": "97557",
        "_fabric_color": [
            {
                "term_id": 97557,
                "gallery": [
                    97542,
                    97541,
                    97540,
                    97544,
                    97543
                ],
                "imgSrc": "/cdn/shop/files/Blue-3-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Blue-3.png",
                "imgSrcF": "/cdn/shop/files/Blue-4-1.png",
                "price": 40,
                "title": "UVShield™ / Blue",
                "color": "Blue"
            },
            {
                "term_id": 97555,
                "gallery": [
                    97546,
                    97547,
                    97545,
                    97549,
                    97548
                ],
                "imgSrc": "/cdn/shop/files/Green-2-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Green-2.png",
                "imgSrcF": "/cdn/shop/files/Green-4-1.png",
                "price": 40,
                "title": "UVShield™ / Green",
                "color": "Green"
            },
            {
                "term_id": 97553,
                "gallery": [
                    97536,
                    97537,
                    97535,
                    97539,
                    97538
                ],
                "imgSrc": "/cdn/shop/files/Black-2-1-500x500.png",
                "imgSrc_n": "/cdn/shop/files/Black-2-1.png",
                "imgSrcF": "/cdn/shop/files/Black-4-1.png",
                "price": 40,
                "title": "UVShield™ / Black",
                "color": "Black"
            }
        ],
        "_fabric_classic": [
            {
                "term_id": 95143,
                "gallery": null,
                "price": 0,
                "title": "No Hardware"
            },
            {
                "term_id": 38758,
                "gallery": null,
                "price": 58,
                "title": "M5-40 Pieces Set"
            },
            {
                "term_id": 38760,
                "gallery": null,
                "price": 69,
                "title": "M6-40 Pieces Set"
            },
            {
                "term_id": 38762,
                "gallery": null,
                "price": 89,
                "title": "M8-40 Pieces Set"
            }
        ],
        "CategoriesAll": [],
        "AllCategory": [
            "All Bestsellers",
            "Custom Outdoor Curtains &amp; Sun Shade Sails Collection",
            "Factory products",
            "Fall Collection",
            "flash_categories",
            "New Content",
            "New Product UI",
            "new rod UI",
            "Search outdoor",
            "Search sail",
            "Summer Collection",
            "Summer Outdoor Decor",
            "Sun Shade Sail",
            "UVShield™ Sun Shades",
            "Waterproof Sun Shades"
        ],
        "isBestseller": false,
        "isPremiere": false,
        "isEditorsPick": false,
        "tags": [
            {
                "slug": "aquashield",
                "name": "aquashield"
            },
            {
                "slug": "sun-shade-sails",
                "name": "Sun Shade Sails"
            }
        ],
        "short_description": "<strong>Customized To Your Need</strong>\r\n\r\nWith a variety of size options available, you can get the perfect fit for your space. Our sun shade also available with top-quality mounting hardware and adjustable ropes, ensuring that your installation will be both secure and tailored to your specific needs. Durable &amp; Cost-effective\r\n\r\n<strong>Durable &amp; Cost-effective</strong>\r\n\r\nCompared to other shading options, such as permanent structures or retractable awnings, a sunshade sail is a more affordable option while still providing the same benefits. Our sunshade sail can withstand the toughest outdoor conditions, making it a great investment that will provide shade for years to come.\r\n\r\n<strong>Perfect For A Variety Of Outdoor Scenes</strong>\r\n\r\nOur sunshade sails can be used in a variety of settings, including patios, decks, pools, and even commercial spaces, making it a versatile option for providing shade wherever you need it. Enjoy the beauty of the great outdoors without worrying about sun damage or excessive heat!",
        "imgSrc": "/cdn/shop/files/Black-1-1-500x500.png",
        "hoverImg": "/cdn/shop/files/2-3-500x500.webp",
        "subheading": "Striped Waterproof Custom Triangle Sun Shade Sail",
        "Fabrics": [
            "UVShield™"
        ],
        "Feature": [
            "Waterproof"
        ],
        "Material": [
            "Synthetic"
        ],
        "Pattern": [
            "Pattern"
        ],
        "Color": [
            "Blue",
            "Green",
            "Black"
        ],
        "Light": [],
        "Hanging": [],
        "Space": [
            "Outdoor"
        ],
        "Sale": "",
        "salenum": 0,
        "oldPrice": 168,
        "newPrice": 226
    }
];
var swatchesList = [
	{
		"id": 110003,
		"title": "Sally 50% Linen Blend Lightfiltering Fabric Swatches",
		"ProductUrl": "/swatches/sally-50-linen-blend-lightfiltering-fabric-swatches/?",
		"isNewArrival": true,
		"meetingExtraType": 0,
		"_is_default_fabric": "110006",
		"_fabric_color": [
			{
				"term_id": 109994,
				"gallery": [
					109975
				],
				"imgSrc": "/cdn/shop/files/Beige-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Beige.png",
				"imgSrcF": "/cdn/shop/files/Beige-1-scaled.jpg",
				"title": "Sally / Beige",
				"color": "Beige"
			},
			{
				"term_id": 109995,
				"gallery": [
					109981
				],
				"imgSrc": "/cdn/shop/files/Sand-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sand-4.png",
				"imgSrcF": "/cdn/shop/files/Sand-scaled.jpg",
				"title": "Sally / Sand",
				"color": "Brown"
			},
			{
				"term_id": 109996,
				"gallery": [
					109982
				],
				"imgSrc": "/cdn/shop/files/Sea-Foam-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sea-Foam.png",
				"imgSrcF": "/cdn/shop/files/Sea-Foam-scaled.jpg",
				"title": "Sally / Sea Foam",
				"color": "Green"
			},
			{
				"term_id": 109997,
				"gallery": [
					109979
				],
				"imgSrc": "/cdn/shop/files/Sage-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sage-4.png",
				"imgSrcF": "/cdn/shop/files/Sage-scaled.jpg",
				"title": "Sally /  Sage",
				"color": "Green"
			},
			{
				"term_id": 109998,
				"gallery": [
					109977
				],
				"imgSrc": "/cdn/shop/files/Lavender-Blush-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Lavender-Blush.png",
				"imgSrcF": "/cdn/shop/files/Lavender-Blush-scaled.jpg",
				"title": "Sally / Lavender Blush",
				"color": "Pink"
			},
			{
				"term_id": 109999,
				"gallery": [
					109974
				],
				"imgSrc": "/cdn/shop/files/Baby-Blue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Baby-Blue.png",
				"imgSrcF": "/cdn/shop/files/Baby-Blue-scaled.jpg",
				"title": "Sally / Baby Blue",
				"color": "Purple"
			},
			{
				"term_id": 110000,
				"gallery": [
					109976
				],
				"imgSrc": "/cdn/shop/files/Denim-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Denim.png",
				"imgSrcF": "/cdn/shop/files/Denim-scaled.jpg",
				"title": "Sally / Denim",
				"color": "Purple"
			},
			{
				"term_id": 110001,
				"gallery": [
					109978
				],
				"imgSrc": "/cdn/shop/files/Moss-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Moss.png",
				"imgSrcF": "/cdn/shop/files/Moss-scaled.jpg",
				"title": "Sally / Moss",
				"color": "Green"
			},
			{
				"term_id": 110006,
				"gallery": [
					109980
				],
				"imgSrc": "/cdn/shop/files/Sally-All-Color-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sally-All-Color.png",
				"imgSrcF": "/cdn/shop/files/Sally-All-Color.png",
				"title": "Sally — All Color",
				"color": "Green"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Arrivals",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "<p class=\"\" data-start=\"463\" data-end=\"859\">Crafted from a 50% linen and 50% polyester blend, Sally 50% Linen Blend Swatches offer a soft, airy touch with a beautifully natural texture. As light filters gently through, the Sally 50% Linen Blend Swatches create an inviting atmosphere, perfect for brightening any living space with effortless elegance. Experience the timeless charm firsthand and start customizing your dream curtains today.</p>",
		"imgSrc": "/cdn/shop/files/Sally-All-Color-500x500.png",
		"hoverImg": "",
		"subheading": "50% Linen Blend Lightfiltering Fabric Swatches",
		"Fabrics": [
			"Sally"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Polyester"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Brown",
			"Green",
			"Green",
			"Pink",
			"Purple",
			"Purple",
			"Green"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"4 In 1",
			"Back Tab",
			"Grommet",
			"Pinch Pleated",
			"Rod Pocket"
		],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"109906"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 0
	},
	{
		"id": 109811,
		"title": "Breeze Lightfiltering Fabric Swatches",
		"ProductUrl": "/swatches/breeze-lightfiltering-fabric-swatches/?",
		"isNewArrival": true,
		"meetingExtraType": 0,
		"_is_default_fabric": "109828",
		"_fabric_color": [
			{
				"term_id": 109824,
				"gallery": [
					110495
				],
				"imgSrc": "/cdn/shop/files/Beige-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Beige-4.png",
				"imgSrcF": "/cdn/shop/files/1804-copy_WH_300x300px.jpg",
				"title": "Breeze / Beige",
				"color": "Beige"
			},
			{
				"term_id": 109821,
				"gallery": [
					110026
				],
				"imgSrc": "/cdn/shop/files/Sand-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sand-5.png",
				"imgSrcF": "/cdn/shop/files/1801-copy_WH_300x300px.jpg",
				"title": "Breeze / Sand",
				"color": "Brown"
			},
			{
				"term_id": 109822,
				"gallery": [
					110499
				],
				"imgSrc": "/cdn/shop/files/Sage-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sage.png",
				"imgSrcF": "/cdn/shop/files/1803-copy_WH_300x300px.jpg",
				"title": "Breeze / Sage",
				"color": "Green"
			},
			{
				"term_id": 109825,
				"gallery": [
					110497
				],
				"imgSrc": "/cdn/shop/files/Green-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Green-3.png",
				"imgSrcF": "/cdn/shop/files/1805-copy_WH_300x300px.jpg",
				"title": "Breeze / Green",
				"color": "Green"
			},
			{
				"term_id": 109826,
				"gallery": [
					110498
				],
				"imgSrc": "/cdn/shop/files/Navy-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Navy-2.png",
				"imgSrcF": "/cdn/shop/files/1806-copy_WH_300x300px.jpg",
				"title": "Breeze / Navy",
				"color": "Blue"
			},
			{
				"term_id": 109828,
				"gallery": [
					110496
				],
				"imgSrc": "/cdn/shop/files/Breeze-All-Color-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Breeze-All-Color-1.png",
				"imgSrcF": "/cdn/shop/files/Breeze-All-Color.png",
				"title": "Breeze — All Color",
				"color": "Blue"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Arrivals",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "<p class=\"\" data-start=\"627\" data-end=\"1075\">Discover the natural elegance of Breeze Lightfiltering Swatches, crafted with a 20% linen blend to offer a soft, breathable texture. Each swatch beautifully previews the gentle light diffusion and airy feel of our Breeze Lightfiltering Custom Curtains. With Breeze Lightfiltering Swatches, you can experience the delicate balance of privacy and brightness, inspiring custom curtains that transform your space into a serene retreat.</p>",
		"imgSrc": "/cdn/shop/files/Breeze-All-Color-1-500x500.png",
		"hoverImg": "",
		"subheading": "Lightfiltering Fabric Swatches",
		"Fabrics": [
			"Breeze"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Polyester",
			"Sheer"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Brown",
			"Green",
			"Green",
			"Blue"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [
			"4 In 1",
			"Back Tab",
			"Grommet",
			"Pinch Pleated",
			"Rod Pocket"
		],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"109907"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 0
	},
	{
		"id": 109868,
		"title": "Sunveil Linen Sheer Fabric Swatches",
		"ProductUrl": "/swatches/sunveil-linen-sheer-fabric-swatches/?",
		"isNewArrival": true,
		"meetingExtraType": 0,
		"_is_default_fabric": "109887",
		"_fabric_color": [
			{
				"term_id": 109885,
				"gallery": [
					109871
				],
				"imgSrc": "/cdn/shop/files/White-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/White-1.png",
				"imgSrcF": "/cdn/shop/files/White.jpg",
				"title": "Sunveil / White",
				"color": "White"
			},
			{
				"term_id": 109886,
				"gallery": [
					109872
				],
				"imgSrc": "/cdn/shop/files/Beige-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Beige-1-1.png",
				"imgSrcF": "/cdn/shop/files/Beige.jpg",
				"title": "Sunveil / Beige",
				"color": "Beige"
			},
			{
				"term_id": 109887,
				"gallery": [
					109873
				],
				"imgSrc": "/cdn/shop/files/Sunveil-All-Color-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sunveil-All-Color.png",
				"imgSrcF": "/cdn/shop/files/Sunveil-All-Color.png",
				"title": "Sunveil — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Arrivals",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "<p class=\"\" data-start=\"647\" data-end=\"1058\">Experience the breezy elegance of Sunveil Linen Sheer Swatches, crafted from fine polyester to capture the relaxed charm of natural linen. Each swatch lets you preview the light-filtering softness and organic texture of our Sunveil Linen Sheer Custom Curtains. With Sunveil Linen Sheer Swatches, you can touch the effortless beauty that will transform your windows into serene, inviting spaces.</p>",
		"imgSrc": "/cdn/shop/files/Sunveil-All-Color-500x500.png",
		"hoverImg": "",
		"subheading": "Look Linen Fabric Swatches",
		"Fabrics": [
			"Sunveil"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Sheer"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White",
			"Beige"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [
			"4 In 1",
			"Back Tab",
			"Grommet",
			"Pinch Pleated",
			"Rod Pocket"
		],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"109732"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 0
	},
	{
		"id": 110002,
		"title": "Sahara Linen Blend Patterned Fabric Swatches",
		"ProductUrl": "/swatches/sahara-linen-blend-patterned-fabric-swatches/?",
		"isNewArrival": true,
		"meetingExtraType": 0,
		"_is_default_fabric": "110005",
		"_fabric_color": [
			{
				"term_id": 109992,
				"gallery": [
					109963
				],
				"imgSrc": "/cdn/shop/files/Sandstone-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sandstone.png",
				"imgSrcF": "/cdn/shop/files/Sandstone-1.jpg",
				"title": "Sahara / Sandstone",
				"color": "Brown"
			},
			{
				"term_id": 109993,
				"gallery": [
					110158
				],
				"imgSrc": "/cdn/shop/files/Ashnew-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Ashnew.png",
				"imgSrcF": "/cdn/shop/files/Ashnew.jpg",
				"title": "Sahara / Ash",
				"color": "Brown"
			},
			{
				"term_id": 110005,
				"gallery": [
					110159
				],
				"imgSrc": "/cdn/shop/files/Sahara-All-Colornew-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sahara-All-Colornew.png",
				"imgSrcF": "/cdn/shop/files/Sahara-All-Colornew.png",
				"title": "Sahara — All Color",
				"color": "Brown"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Arrivals",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "<p class=\"\" data-start=\"582\" data-end=\"1027\">Woven from 65% linen and 35% polyester, Sahara Linen Blend Patterned Swatches deliver a soft, airy touch paired with intricate natural patterns. As you explore Sahara Linen Blend Patterned Swatches, you’ll feel the understated movement and delicate texture that breathe life into any room. Let Sahara Linen Blend Patterned Swatches inspire your custom curtains, bringing an effortless sense of warmth and artistry to your space.</p>",
		"imgSrc": "/cdn/shop/files/Sahara-All-Colornew-500x500.png",
		"hoverImg": "",
		"subheading": "Linen Blend Patterned Fabric Swatches",
		"Fabrics": [
			"Sahara"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Polyester"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Brown",
			"Brown"
		],
		"Light": [
			"Light Filtering"
		],
		"Hanging": [
			"4 In 1",
			"Back Tab",
			"Grommet",
			"Pinch Pleated",
			"Rod Pocket"
		],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"110247"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 0
	},
	{
		"id": 109951,
		"title": "Liwa Linen Blend Patterned Fabric Swatches",
		"ProductUrl": "/swatches/liwa-linen-blend-patterned-fabric-swatches/?",
		"isNewArrival": true,
		"meetingExtraType": 0,
		"_is_default_fabric": "110004",
		"_fabric_color": [
			{
				"term_id": 109991,
				"gallery": [
					110276
				],
				"imgSrc": "/cdn/shop/files/Oatnew-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Oatnew.png",
				"imgSrcF": "/cdn/shop/files/Liwa-Oat.jpg",
				"title": "Liwa / Oat",
				"color": "Grey"
			},
			{
				"term_id": 109989,
				"gallery": [
					110274
				],
				"imgSrc": "/cdn/shop/files/Dunenew-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Dunenew.png",
				"imgSrcF": "/cdn/shop/files/Liwa-Dune.jpg",
				"title": "Liwa / Dune",
				"color": "Brown"
			},
			{
				"term_id": 110004,
				"gallery": [
					110275
				],
				"imgSrc": "/cdn/shop/files/Liwa-All-Colornew-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Liwa-All-Colornew.png",
				"imgSrcF": "/cdn/shop/files/Liwa-All-Colornew.png",
				"title": "Liwa — All Color",
				"color": "Brown"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Arrivals",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Sheer are lightweight and flexible. This curtain offers a thin layer to filter light which is the perfect solution for anyone who seeks the best of both privacy and light control. The fabric is highly versatile, allowing you to easily modify the filtration of natural lighting.",
		"imgSrc": "/cdn/shop/files/Liwa-All-Colornew-500x500.png",
		"hoverImg": "",
		"subheading": "Linen Blend Patterned Fabric Swatches",
		"Fabrics": [
			"Liwa"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Grey",
			"Brown"
		],
		"Light": [
			"Light Filtering"
		],
		"Hanging": [
			"4 In 1",
			"Back Tab",
			"Grommet",
			"Pinch Pleated",
			"Rod Pocket"
		],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"110248"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 0
	},
	{
		"id": 109754,
		"title": "Jupiter Linen Fabric Swatches",
		"ProductUrl": "/swatches/jupiter-linen-fabric-swatches/?",
		"isNewArrival": true,
		"meetingExtraType": 0,
		"_is_default_fabric": "109827",
		"_fabric_color": [
			{
				"term_id": 109717,
				"gallery": [
					109857
				],
				"imgSrc": "/cdn/shop/files/Cream-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Cream-1.png",
				"imgSrcF": "/cdn/shop/files/Cream-2.png",
				"title": "Jupitert / Cream",
				"color": "Beige"
			},
			{
				"term_id": 109795,
				"gallery": [
					109856
				],
				"imgSrc": "/cdn/shop/files/Ash-Beige-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Ash-Beige-1.png",
				"imgSrcF": "/cdn/shop/files/Ash-Beige-2.png",
				"title": "Jupitert / Ash Beige",
				"color": "Beige"
			},
			{
				"term_id": 109799,
				"gallery": [
					109861
				],
				"imgSrc": "/cdn/shop/files/Sand-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sand-1.png",
				"imgSrcF": "/cdn/shop/files/Sand-6.png",
				"title": "Jupitert / Sand",
				"color": "Green"
			},
			{
				"term_id": 109798,
				"gallery": [
					109860
				],
				"imgSrc": "/cdn/shop/files/Sage-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sage-1.png",
				"imgSrcF": "/cdn/shop/files/Sage-6.png",
				"title": "Jupitert / Sage",
				"color": "Green"
			},
			{
				"term_id": 109796,
				"gallery": [
					109858
				],
				"imgSrc": "/cdn/shop/files/Dark-Green-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Dark-Green-1.png",
				"imgSrcF": "/cdn/shop/files/Dark-Green-2.png",
				"title": "Jupitert / Dark Green",
				"color": "Green"
			},
			{
				"term_id": 109797,
				"gallery": [
					109863
				],
				"imgSrc": "/cdn/shop/files/Red-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Red-1-1.png",
				"imgSrcF": "/cdn/shop/files/Red-1.png",
				"title": "Jupitert / Red",
				"color": "Red"
			},
			{
				"term_id": 109827,
				"gallery": [
					109865
				],
				"imgSrc": "/cdn/shop/files/Jupiter-All-Color-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Jupiter-All-Color.png",
				"imgSrcF": "/cdn/shop/files/Jupiter-All-Color.png",
				"title": "Jupiter — All Color",
				"color": "Red"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Arrivals",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "<p class=\"\" data-start=\"778\" data-end=\"1211\">Feel the effortless elegance of Jupiter Linen Swatches, designed to capture the soft weight and organic texture of our Jupiter Linen Custom Curtains. Each swatch reveals a gentle drape and airy richness that brings relaxed luxury into any space. With Jupiter Linen Swatches in hand, you can experience the perfect balance of structure and softness before creating curtains that elevate your home with natural beauty.</p>\r\n<p class=\"\" data-start=\"757\" data-end=\"776\"></p>",
		"imgSrc": "/cdn/shop/files/Jupiter-All-Color-500x500.png",
		"hoverImg": "",
		"subheading": "Look Linen Fabric Swatches",
		"Fabrics": [
			"Jupiter"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Beige",
			"Green",
			"Green",
			"Green",
			"Red"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [
			"4 In 1",
			"Back Tab",
			"Grommet",
			"Pinch Pleated",
			"Rod Pocket"
		],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"109921"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 0
	},
	{
		"id": 66038,
		"title": "Rome Foil Printed Velvet Fabric Swatches",
		"ProductUrl": "/swatches/rome-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66112",
		"_fabric_color": [
			{
				"term_id": 64157,
				"gallery": [
					66032
				],
				"imgSrc": "/cdn/shop/files/ROME-Black-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Black.png",
				"imgSrcF": "/cdn/shop/files/black-3.png",
				"title": "Rome / Black",
				"color": "Black"
			},
			{
				"term_id": 64155,
				"gallery": [
					66031
				],
				"imgSrc": "/cdn/shop/files/ROME-Red-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Red.png",
				"imgSrcF": "/cdn/shop/files/red-1.png",
				"title": "Rome / Red",
				"color": "Red"
			},
			{
				"term_id": 64156,
				"gallery": [
					66030
				],
				"imgSrc": "/cdn/shop/files/ROME-Teal-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Teal.png",
				"imgSrcF": "/cdn/shop/files/teal.png",
				"title": "Rome / Teal",
				"color": "Green"
			},
			{
				"term_id": 64150,
				"gallery": [
					66029
				],
				"imgSrc": "/cdn/shop/files/ROME-Golden-Brown-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Golden-Brown.png",
				"imgSrcF": "/cdn/shop/files/goldenbrown.png",
				"title": "Rome / Golden Brown",
				"color": "Brown"
			},
			{
				"term_id": 64152,
				"gallery": [
					66027
				],
				"imgSrc": "/cdn/shop/files/ROME-Orange-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Orange.png",
				"imgSrcF": "/cdn/shop/files/orange.png",
				"title": "Rome / Orange",
				"color": "Orange"
			},
			{
				"term_id": 64153,
				"gallery": [
					66026
				],
				"imgSrc": "/cdn/shop/files/ROME-Mustard-Green-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Mustard-Green.png",
				"imgSrcF": "/cdn/shop/files/mustardgreen.png",
				"title": "Rome / Mustard Green",
				"color": "Cyan"
			},
			{
				"term_id": 64154,
				"gallery": [
					66025
				],
				"imgSrc": "/cdn/shop/files/ROME-Coral-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Coral.png",
				"imgSrcF": "/cdn/shop/files/coral.png",
				"title": "Rome / Coral",
				"color": "Pink"
			},
			{
				"term_id": 64151,
				"gallery": [
					66028
				],
				"imgSrc": "/cdn/shop/files/ROME-Metallic-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Metallic.png",
				"imgSrcF": "/cdn/shop/files/metallic.png",
				"title": "Rome / Metallic",
				"color": "Grey"
			},
			{
				"term_id": 64144,
				"gallery": [
					66024
				],
				"imgSrc": "/cdn/shop/files/ROME-Gold-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Gold.png",
				"imgSrcF": "/cdn/shop/files/gold.png",
				"title": "Rome / Gold",
				"color": "Gold"
			},
			{
				"term_id": 64145,
				"gallery": [
					66023
				],
				"imgSrc": "/cdn/shop/files/ROME-Misty-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Misty.png",
				"imgSrcF": "/cdn/shop/files/misty.png",
				"title": "Rome / Misty",
				"color": "Grey"
			},
			{
				"term_id": 64146,
				"gallery": [
					66022
				],
				"imgSrc": "/cdn/shop/files/ROME-Light-Blue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Light-Blue.png",
				"imgSrcF": "/cdn/shop/files/lightblue.png",
				"title": "Rome / Light Blue",
				"color": "Blue"
			},
			{
				"term_id": 64147,
				"gallery": [
					66021
				],
				"imgSrc": "/cdn/shop/files/ROME-Silver-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Silver.png",
				"imgSrcF": "/cdn/shop/files/silver.png",
				"title": "Rome / Silver",
				"color": "Silver"
			},
			{
				"term_id": 64148,
				"gallery": [
					66020
				],
				"imgSrc": "/cdn/shop/files/ROME-Champagne-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Champagne.png",
				"imgSrcF": "/cdn/shop/files/champagne.png",
				"title": "Rome / Champagne",
				"color": "Gold"
			},
			{
				"term_id": 64149,
				"gallery": [
					66019
				],
				"imgSrc": "/cdn/shop/files/ROME-Cream-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-Cream.png",
				"imgSrcF": "/cdn/shop/files/rome-display-3.png",
				"title": "Rome / Cream",
				"color": "Beige"
			},
			{
				"term_id": 66112,
				"gallery": [
					66018
				],
				"imgSrc": "/cdn/shop/files/ROME-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ROME-1.png",
				"imgSrcF": "/cdn/shop/files/ROME-1.png",
				"title": "Rome — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/ROME-1-500x500.png",
		"hoverImg": "/cdn/shop/files/ROME-1-500x500.png",
		"subheading": "Foil Printed Velvet Fabric Swatches",
		"Fabrics": [
			"Rome"
		],
		"Feature": [],
		"Material": [
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Foil Printed"
		],
		"Color": [
			"Black",
			"Red",
			"Green",
			"Brown",
			"Orange",
			"Cyan",
			"Pink",
			"Grey",
			"Gold",
			"Grey",
			"Blue",
			"Silver",
			"Gold",
			"Beige"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64184",
			"101381"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 14,
		"newPrice": 5
	},
	{
		"id": 102831,
		"title": "Quinn OEKO Blackout Heavyweight Velvet Swatches",
		"ProductUrl": "/swatches/quinn-oeko-blackout-heavyweight-velvet-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "101891",
		"_fabric_color": [
			{
				"term_id": 101891,
				"gallery": [
					102833
				],
				"imgSrc": "/cdn/shop/files/2-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2-5.png",
				"imgSrcF": "/cdn/shop/files/Grey-Blue-4-300x300-1.jpg",
				"title": "Quinn / Grey Blue",
				"color": "White"
			},
			{
				"term_id": 101889,
				"gallery": [
					102836
				],
				"imgSrc": "/cdn/shop/files/5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/5-1.png",
				"imgSrcF": "/cdn/shop/files/Light-Brown-4-300x300-1.jpg",
				"title": "Quinn / Light Brown",
				"color": "White"
			},
			{
				"term_id": 101887,
				"gallery": [
					102835
				],
				"imgSrc": "/cdn/shop/files/4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/4.png",
				"imgSrcF": "/cdn/shop/files/Champagne-4-300x300-1.jpg",
				"title": "Quinn / Champagne",
				"color": "White"
			},
			{
				"term_id": 101885,
				"gallery": [
					102834
				],
				"imgSrc": "/cdn/shop/files/3-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/3-1.png",
				"imgSrcF": "/cdn/shop/files/Bone-4-300x300-1.jpg",
				"title": "Quinn / Bone",
				"color": "White"
			},
			{
				"term_id": 101883,
				"gallery": [
					102833
				],
				"imgSrc": "/cdn/shop/files/2-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2-5.png",
				"imgSrcF": "/cdn/shop/files/Grey-4-2-300x300-1.jpg",
				"title": "Quinn / Grey",
				"color": "White"
			},
			{
				"term_id": 101868,
				"gallery": [
					102832
				],
				"imgSrc": "/cdn/shop/files/1-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/1-5.png",
				"imgSrcF": "/cdn/shop/files/Chocolate-4-300x300-1.jpg",
				"title": "Quinn / Chocolate",
				"color": "White"
			},
			{
				"term_id": 104246,
				"gallery": [
					105034
				],
				"imgSrc": "/cdn/shop/files/wine-500x500.png",
				"imgSrc_n": "/cdn/shop/files/wine.png",
				"imgSrcF": "/cdn/shop/files/wine.jpg",
				"title": "Quinn / Wine",
				"color": "White"
			},
			{
				"term_id": 104244,
				"gallery": [
					105041
				],
				"imgSrc": "/cdn/shop/files/teal-500x500.png",
				"imgSrc_n": "/cdn/shop/files/teal.png",
				"imgSrcF": "/cdn/shop/files/teal-4.jpg",
				"title": "Quinn / Teal",
				"color": "White"
			},
			{
				"term_id": 104242,
				"gallery": [
					105040
				],
				"imgSrc": "/cdn/shop/files/taro-500x500.png",
				"imgSrc_n": "/cdn/shop/files/taro.png",
				"imgSrcF": "/cdn/shop/files/taro.jpg",
				"title": "Quinn / Taro",
				"color": "White"
			},
			{
				"term_id": 104240,
				"gallery": [
					105039
				],
				"imgSrc": "/cdn/shop/files/purple-500x500.png",
				"imgSrc_n": "/cdn/shop/files/purple.png",
				"imgSrcF": "/cdn/shop/files/purple-4.jpg",
				"title": "Quinn / Purple",
				"color": "White"
			},
			{
				"term_id": 104238,
				"gallery": [
					105038
				],
				"imgSrc": "/cdn/shop/files/ocean-blue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ocean-blue.png",
				"imgSrcF": "/cdn/shop/files/oceanblue.jpg",
				"title": "Quinn / Ocean Blue",
				"color": "White"
			},
			{
				"term_id": 104236,
				"gallery": [
					105037
				],
				"imgSrc": "/cdn/shop/files/navy-blue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/navy-blue.png",
				"imgSrcF": "/cdn/shop/files/navyblue.jpg",
				"title": "Quinn / Navy Blue",
				"color": "White"
			},
			{
				"term_id": 104234,
				"gallery": [
					105036
				],
				"imgSrc": "/cdn/shop/files/khaki-500x500.png",
				"imgSrc_n": "/cdn/shop/files/khaki.png",
				"imgSrcF": "/cdn/shop/files/khaki.jpg",
				"title": "Quinn / Khaki",
				"color": "White"
			},
			{
				"term_id": 104232,
				"gallery": [
					105035
				],
				"imgSrc": "/cdn/shop/files/grass-green-500x500.png",
				"imgSrc_n": "/cdn/shop/files/grass-green.png",
				"imgSrcF": "/cdn/shop/files/grassgreen.jpg",
				"title": "Quinn / Grass Green",
				"color": "White"
			},
			{
				"term_id": 102867,
				"gallery": [
					105042
				],
				"imgSrc": "/cdn/shop/files/531394-500x500.png",
				"imgSrc_n": "/cdn/shop/files/531394.png",
				"imgSrcF": "/cdn/shop/files/531394.png",
				"title": "Quinn — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/531394-500x500.png",
		"hoverImg": "/cdn/shop/files/531394-500x500.png",
		"subheading": "OEKO Blackout Heavyweight Velvet Swatches",
		"Fabrics": [
			"Quinn"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Blackout"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"101725",
			"102742"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1
	},
	{
		"id": 102872,
		"title": "Victoria OEKO Blackout Heavyweight Linen Look Swatches",
		"ProductUrl": "/swatches/victoria-oeko-blackout-heavyweight-linen-look-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "102870",
		"_fabric_color": [
			{
				"term_id": 101905,
				"gallery": [
					102839
				],
				"imgSrc": "/cdn/shop/files/1-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/1-6.png",
				"imgSrcF": "/cdn/shop/files/Moss-4-300x300-2.jpg",
				"title": "Victoria / Moss",
				"color": "White"
			},
			{
				"term_id": 101903,
				"gallery": [
					102840
				],
				"imgSrc": "/cdn/shop/files/2-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2-6.png",
				"imgSrcF": "/cdn/shop/files/Hazelnut-4-300x300-2.jpg",
				"title": "Victoria / Hazelnut",
				"color": "White"
			},
			{
				"term_id": 101901,
				"gallery": [
					102841
				],
				"imgSrc": "/cdn/shop/files/3-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/3-2.png",
				"imgSrcF": "/cdn/shop/files/Oat-4-1-300x300-2.jpg",
				"title": "Victoria / Oat",
				"color": "White"
			},
			{
				"term_id": 101899,
				"gallery": [
					102842
				],
				"imgSrc": "/cdn/shop/files/4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/4-1.png",
				"imgSrcF": "/cdn/shop/files/Beige-4-1-300x300-2.jpg",
				"title": "Victoria / Beige",
				"color": "White"
			},
			{
				"term_id": 101897,
				"gallery": [
					102843
				],
				"imgSrc": "/cdn/shop/files/5-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/5-2.png",
				"imgSrcF": "/cdn/shop/files/Pink-4.jpg",
				"title": "Victoria / Pink",
				"color": "White"
			},
			{
				"term_id": 101895,
				"gallery": [
					102844
				],
				"imgSrc": "/cdn/shop/files/6-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/6-3.png",
				"imgSrcF": "/cdn/shop/files/Silver-White-4-300x300-2.jpg",
				"title": "Victoria / Silver White",
				"color": "White"
			},
			{
				"term_id": 101893,
				"gallery": [
					102845
				],
				"imgSrc": "/cdn/shop/files/7-500x500.png",
				"imgSrc_n": "/cdn/shop/files/7.png",
				"imgSrcF": "/cdn/shop/files/Ivory-4-300x300-2.jpg",
				"title": "Victoria / Ivory",
				"color": "White"
			},
			{
				"term_id": 104261,
				"gallery": [
					105044
				],
				"imgSrc": "/cdn/shop/files/ash-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ash-2.png",
				"imgSrcF": "/cdn/shop/files/ash.jpg",
				"title": "Victoria / Ash",
				"color": "White"
			},
			{
				"term_id": 104259,
				"gallery": [
					105045
				],
				"imgSrc": "/cdn/shop/files/blue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/blue.png",
				"imgSrcF": "/cdn/shop/files/blue.jpg",
				"title": "Victoria / Blue",
				"color": "White"
			},
			{
				"term_id": 104257,
				"gallery": [
					105046
				],
				"imgSrc": "/cdn/shop/files/blue-grey-500x500.png",
				"imgSrc_n": "/cdn/shop/files/blue-grey.png",
				"imgSrcF": "/cdn/shop/files/bluegrey.jpg",
				"title": "Victoria / Blue Grey",
				"color": "White"
			},
			{
				"term_id": 104255,
				"gallery": [
					105047
				],
				"imgSrc": "/cdn/shop/files/purple-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/purple-1.png",
				"imgSrcF": "/cdn/shop/files/purple.jpg",
				"title": "Victoria / Purple",
				"color": "White"
			},
			{
				"term_id": 104253,
				"gallery": [
					105048
				],
				"imgSrc": "/cdn/shop/files/red-500x500.png",
				"imgSrc_n": "/cdn/shop/files/red.png",
				"imgSrcF": "/cdn/shop/files/red.jpg",
				"title": "Victoria / Red",
				"color": "White"
			},
			{
				"term_id": 104251,
				"gallery": [
					105049
				],
				"imgSrc": "/cdn/shop/files/taupe-500x500.png",
				"imgSrc_n": "/cdn/shop/files/taupe.png",
				"imgSrcF": "/cdn/shop/files/taupe.jpg",
				"title": "Victoria / Taupe",
				"color": "White"
			},
			{
				"term_id": 104248,
				"gallery": [
					105050
				],
				"imgSrc": "/cdn/shop/files/teal-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/teal-1.png",
				"imgSrcF": "/cdn/shop/files/teal.jpg",
				"title": "Victoria / Teal",
				"color": "White"
			},
			{
				"term_id": 102870,
				"gallery": [
					105043
				],
				"imgSrc": "/cdn/shop/files/531410-500x500.png",
				"imgSrc_n": "/cdn/shop/files/531410.png",
				"imgSrcF": "/cdn/shop/files/531410.png",
				"title": "Victoria — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/531410-500x500.png",
		"hoverImg": "/cdn/shop/files/531410-500x500.png",
		"subheading": "OEKO Blackout Heavyweight Linen Look Swatches",
		"Fabrics": [
			"Victoria"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Blackout"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"101735",
			"102741"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 14
	},
	{
		"id": 66044,
		"title": "Glint Linen Blend Shimmering Textured Fabric Swatches",
		"ProductUrl": "/swatches/glint-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66104",
		"_fabric_color": [
			{
				"term_id": 64088,
				"gallery": [
					65869
				],
				"imgSrc": "/cdn/shop/files/Sesame-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Sesame.png",
				"imgSrcF": "/cdn/shop/files/Sesame-1.png",
				"title": "Glint / Sesame",
				"color": "Grey"
			},
			{
				"term_id": 64089,
				"gallery": [
					65868
				],
				"imgSrc": "/cdn/shop/files/Cream-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Cream-6.png",
				"imgSrcF": "/cdn/shop/files/Cream-glint.png",
				"title": "Glint / Cream",
				"color": "Beige"
			},
			{
				"term_id": 66104,
				"gallery": [
					65870
				],
				"imgSrc": "/cdn/shop/files/Glint-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Glint.png",
				"imgSrcF": "/cdn/shop/files/Glint.png",
				"title": "Glint — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/Glint-800x800.png",
		"hoverImg": "/cdn/shop/files/Glint-500x500.png",
		"subheading": "Linen Blend Shimmering Textured Fabric Swatches",
		"Fabrics": [
			"Glint"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Grey",
			"Beige"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64175",
			"101357"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 2,
		"newPrice": 5
	},
	{
		"id": 66041,
		"title": "Palma Foil Printed Velvet Patterned Fabric Swatches",
		"ProductUrl": "/swatches/palma-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66108",
		"_fabric_color": [
			{
				"term_id": 64126,
				"gallery": [
					66016
				],
				"imgSrc": "/cdn/shop/files/PALMA-Black-500x500.png",
				"imgSrc_n": "/cdn/shop/files/PALMA-Black.png",
				"imgSrcF": "/cdn/shop/files/palma-color-8.png",
				"title": "Palma / Black",
				"color": "Black"
			},
			{
				"term_id": 64127,
				"gallery": [
					66015
				],
				"imgSrc": "/cdn/shop/files/PALMA-Teal-500x500.png",
				"imgSrc_n": "/cdn/shop/files/PALMA-Teal.png",
				"imgSrcF": "/cdn/shop/files/palma-color-9.png",
				"title": "Palma / Teal",
				"color": "Green"
			},
			{
				"term_id": 64117,
				"gallery": [
					66014
				],
				"imgSrc": "/cdn/shop/files/PALMA-Ash-500x500.png",
				"imgSrc_n": "/cdn/shop/files/PALMA-Ash.png",
				"imgSrcF": "/cdn/shop/files/palma-color-10.png",
				"title": "Palma / Ash",
				"color": "Beige"
			},
			{
				"term_id": 64118,
				"gallery": [
					66013
				],
				"imgSrc": "/cdn/shop/files/PALMA-Gold-500x500.png",
				"imgSrc_n": "/cdn/shop/files/PALMA-Gold.png",
				"imgSrcF": "/cdn/shop/files/palma-color-1.png",
				"title": "Palma / Gold",
				"color": "Gold"
			},
			{
				"term_id": 64119,
				"gallery": [
					66012
				],
				"imgSrc": "/cdn/shop/files/PALMA-Misty-500x500.png",
				"imgSrc_n": "/cdn/shop/files/PALMA-Misty.png",
				"imgSrcF": "/cdn/shop/files/palma-color-2.png",
				"title": "Palma / Misty",
				"color": "Silver"
			},
			{
				"term_id": 64120,
				"gallery": [
					66011
				],
				"imgSrc": "/cdn/shop/files/PALMA-Azure-500x500.png",
				"imgSrc_n": "/cdn/shop/files/PALMA-Azure.png",
				"imgSrcF": "/cdn/shop/files/palma-color-3.png",
				"title": "Palma / Azure",
				"color": "Blue"
			},
			{
				"term_id": 64121,
				"gallery": [
					66010
				],
				"imgSrc": "/cdn/shop/files/PALMA-Rose-Gold-500x500.png",
				"imgSrc_n": "/cdn/shop/files/PALMA-Rose-Gold.png",
				"imgSrcF": "/cdn/shop/files/palma-color-4.png",
				"title": "Palma / Rose Gold",
				"color": "Pink"
			},
			{
				"term_id": 64116,
				"gallery": [
					66009
				],
				"imgSrc": "/cdn/shop/files/PALMA-Silver-500x500.png",
				"imgSrc_n": "/cdn/shop/files/PALMA-Silver.png",
				"imgSrcF": "/cdn/shop/files/palma-color-5.png",
				"title": "Palma / Silver",
				"color": "Silver"
			},
			{
				"term_id": 64113,
				"gallery": [
					66008
				],
				"imgSrc": "/cdn/shop/files/PALMA-Champagne-500x500.png",
				"imgSrc_n": "/cdn/shop/files/PALMA-Champagne.png",
				"imgSrcF": "/cdn/shop/files/palma-color-6.png",
				"title": "Palma / Champagne",
				"color": "Beige"
			},
			{
				"term_id": 64114,
				"gallery": [
					66007
				],
				"imgSrc": "/cdn/shop/files/PALMA-Cream-500x500.png",
				"imgSrc_n": "/cdn/shop/files/PALMA-Cream.png",
				"imgSrcF": "/cdn/shop/files/palma-color-7.png",
				"title": "Palma / Cream",
				"color": "Beige"
			},
			{
				"term_id": 66108,
				"gallery": [
					66006
				],
				"imgSrc": "/cdn/shop/files/PALMA-500x500.png",
				"imgSrc_n": "/cdn/shop/files/PALMA.png",
				"imgSrcF": "/cdn/shop/files/PALMA.png",
				"title": "Palma — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/PALMA-500x500.png",
		"hoverImg": "/cdn/shop/files/PALMA-500x500.png",
		"subheading": "Foil Printed Velvet Patterned Fabric Swatches",
		"Fabrics": [
			"Palma"
		],
		"Feature": [],
		"Material": [
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Black",
			"Green",
			"Beige",
			"Gold",
			"Silver",
			"Blue",
			"Pink",
			"Silver",
			"Beige",
			"Beige"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64181"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 10,
		"newPrice": 5
	},
	{
		"id": 96259,
		"title": "Anti-Dust Soundproof Blackout Fabric Swatches",
		"ProductUrl": "/swatches/anti-dust-thermal-insulated-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96274",
		"_fabric_color": [
			{
				"term_id": 96274,
				"gallery": [
					96273
				],
				"imgSrc": "/cdn/shop/files/4-layers-500x500.png",
				"imgSrc_n": "/cdn/shop/files/4-layers.png",
				"imgSrcF": "/cdn/shop/files/4-layers.png",
				"title": "4 Layers / Grey",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search curtains",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "hussein",
				"name": "Hussein"
			}
		],
		"short_description": "<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \" style=\"border-radius: 0px;\"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\">\r\n<p style=\"margin-bottom: 20px;\">These four-layered curtains are the best problem solved: 100% blackout, soundproof, heat insulation, and dust absorbing. Allow the dust to settle down on the curtain by preventing them from entering your house. They will not get folded easily, and they last long by resisting strict conditions.</p>\r\n\r\n</article></div>\r\n</section></div>\r\n<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \" style=\"border-radius: 0px;\"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\">\r\n<p style=\"margin-bottom: 20px;\">Dust is a considerable problem anytime. Dirty places, primary work locations, need cleaning supplies and the workforce to clean surfaces all the time. Trying to maintain cleanliness is expensive and complicated. Our industrial curtains are removable, practical barriers that help control dust and fumes. They can reduce workplace noises and be adjusted or reinstalled to work around interior and exterior projects. They are composed of two layers of blackout cloth and two lining layers. One of the blackout clothes is always grayish white.</p>\r\n\r\n</article></div>\r\n</section></div>",
		"imgSrc": "/cdn/shop/files/4-layers-500x500.png",
		"hoverImg": "/cdn/shop/files/4-layers-500x500.png",
		"subheading": "Anti-Dust Soundproof Blackout Fabric Swatches",
		"Fabrics": [
			"4 Layers / Grey"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [],
		"Light": [
			"Blackout"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 96100,
		"title": "Hussein OEKO Certified Fabric Swatches",
		"ProductUrl": "/swatches/hussein-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96015",
		"_fabric_color": [
			{
				"term_id": 96068,
				"gallery": [
					107840
				],
				"imgSrc": "/cdn/shop/files/grayishwhite-500x500.png",
				"imgSrc_n": "/cdn/shop/files/grayishwhite.png",
				"imgSrcF": "/cdn/shop/files/Grayish-White.jpg",
				"title": "Hussein / Greyish White",
				"color": "White"
			},
			{
				"term_id": 96071,
				"gallery": [
					107856
				],
				"imgSrc": "/cdn/shop/files/white-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/white-4.png",
				"imgSrcF": "/cdn/shop/files/Pure-White.jpg",
				"title": "Hussein / Pure White",
				"color": "White"
			},
			{
				"term_id": 96080,
				"gallery": [
					107843
				],
				"imgSrc": "/cdn/shop/files/light-beige-500x500.png",
				"imgSrc_n": "/cdn/shop/files/light-beige.png",
				"imgSrcF": "/cdn/shop/files/Light-Beige.jpg",
				"title": "Hussein / Light Beige",
				"color": "Beige"
			},
			{
				"term_id": 96075,
				"gallery": [
					107831
				],
				"imgSrc": "/cdn/shop/files/beige-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/beige-3.png",
				"imgSrcF": "/cdn/shop/files/Beige.jpg",
				"title": "Hussein / Beige",
				"color": "Beige"
			},
			{
				"term_id": 96086,
				"gallery": [
					107851
				],
				"imgSrc": "/cdn/shop/files/silver-gray-500x500.png",
				"imgSrc_n": "/cdn/shop/files/silver-gray.png",
				"imgSrcF": "/cdn/shop/files/Silver-Grey.jpg",
				"title": "Hussein / Silver Grey",
				"color": "Grey"
			},
			{
				"term_id": 96054,
				"gallery": [
					107841
				],
				"imgSrc": "/cdn/shop/files/grey-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/grey-3.png",
				"imgSrcF": "/cdn/shop/files/Grey.jpg",
				"title": "Hussein / Grey",
				"color": "Grey"
			},
			{
				"term_id": 96085,
				"gallery": [
					107855
				],
				"imgSrc": "/cdn/shop/files/vintageblue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/vintageblue.png",
				"imgSrcF": "/cdn/shop/files/Vintage-blue.jpg",
				"title": "Hussein / Vintage blue",
				"color": "Blue"
			},
			{
				"term_id": 96076,
				"gallery": [
					107845
				],
				"imgSrc": "/cdn/shop/files/navyblue-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/navyblue-1.png",
				"imgSrcF": "/cdn/shop/files/Navy-Blue-1.jpg",
				"title": "Hussein / Navy Blue",
				"color": "Blue"
			},
			{
				"term_id": 96083,
				"gallery": [
					108535
				],
				"imgSrc": "/cdn/shop/files/burgundy-red-500x500.png",
				"imgSrc_n": "/cdn/shop/files/burgundy-red.png",
				"imgSrcF": "/cdn/shop/files/Burgundy-Red.jpg",
				"title": "Hussein / Burgundy Red",
				"color": "Red"
			},
			{
				"term_id": 96097,
				"gallery": [
					107844
				],
				"imgSrc": "/cdn/shop/files/lightpink-500x500.png",
				"imgSrc_n": "/cdn/shop/files/lightpink.png",
				"imgSrcF": "/cdn/shop/files/Light-pink.jpg",
				"title": "Hussein / Light Pink",
				"color": "Pink"
			},
			{
				"term_id": 96082,
				"gallery": [
					107834
				],
				"imgSrc": "/cdn/shop/files/brickred-500x500.png",
				"imgSrc_n": "/cdn/shop/files/brickred.png",
				"imgSrcF": "/cdn/shop/files/Brick-Red.jpg",
				"title": "Hussein / Brick Red",
				"color": "Red"
			},
			{
				"term_id": 96089,
				"gallery": [
					107839
				],
				"imgSrc": "/cdn/shop/files/eggplant-purple-500x500.png",
				"imgSrc_n": "/cdn/shop/files/eggplant-purple.png",
				"imgSrcF": "/cdn/shop/files/Deep-Purple.jpg",
				"title": "Hussein / Eggplant Purple",
				"color": "Purple"
			},
			{
				"term_id": 96098,
				"gallery": [
					107846
				],
				"imgSrc": "/cdn/shop/files/olive-green-500x500.png",
				"imgSrc_n": "/cdn/shop/files/olive-green.png",
				"imgSrcF": "/cdn/shop/files/Olive-Green.jpg",
				"title": "Hussein / Olive Green",
				"color": "Green"
			},
			{
				"term_id": 96087,
				"gallery": [
					107854
				],
				"imgSrc": "/cdn/shop/files/tendercyan-500x500.png",
				"imgSrc_n": "/cdn/shop/files/tendercyan.png",
				"imgSrcF": "/cdn/shop/files/Tender-Cyan.jpg",
				"title": "Hussein / Tender Cyan",
				"color": "Green"
			},
			{
				"term_id": 96079,
				"gallery": [
					108536
				],
				"imgSrc": "/cdn/shop/files/stone-blue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/stone-blue.png",
				"imgSrcF": "/cdn/shop/files/Stone-Blue.jpg",
				"title": "Hussein / Stone Blue",
				"color": "Blue"
			},
			{
				"term_id": 96091,
				"gallery": [
					107833
				],
				"imgSrc": "/cdn/shop/files/bluegreen-500x500.png",
				"imgSrc_n": "/cdn/shop/files/bluegreen.png",
				"imgSrcF": "/cdn/shop/files/Blue-Green.jpg",
				"title": "Hussein / Blue Green",
				"color": "Green"
			},
			{
				"term_id": 96088,
				"gallery": [
					107849
				],
				"imgSrc": "/cdn/shop/files/seablue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/seablue.png",
				"imgSrcF": "/cdn/shop/files/Sea-blue.jpg",
				"title": "Hussein / Sea Blue",
				"color": "Green"
			},
			{
				"term_id": 96081,
				"gallery": [
					107842
				],
				"imgSrc": "/cdn/shop/files/hunter-green-500x500.png",
				"imgSrc_n": "/cdn/shop/files/hunter-green.png",
				"imgSrcF": "/cdn/shop/files/Hunter-Green.jpg",
				"title": "Hussein / Hunter Green",
				"color": "Green"
			},
			{
				"term_id": 96096,
				"gallery": [
					107848
				],
				"imgSrc": "/cdn/shop/files/sand-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/sand-2.png",
				"imgSrcF": "/cdn/shop/files/Sand.jpg",
				"title": "Hussein / Sand",
				"color": "Grey"
			},
			{
				"term_id": 96077,
				"gallery": [
					107857
				],
				"imgSrc": "/cdn/shop/files/yellow-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/yellow-1.png",
				"imgSrcF": "/cdn/shop/files/Yellow.jpg",
				"title": "Hussein / Yellow",
				"color": "Yellow"
			},
			{
				"term_id": 96078,
				"gallery": [
					107850
				],
				"imgSrc": "/cdn/shop/files/seateal-500x500.png",
				"imgSrc_n": "/cdn/shop/files/seateal.png",
				"imgSrcF": "/cdn/shop/files/Sea-Teal.jpg",
				"title": "Hussein / Sea Teal",
				"color": "Green"
			},
			{
				"term_id": 96073,
				"gallery": [
					108537
				],
				"imgSrc": "/cdn/shop/files/deep-purple-500x500.png",
				"imgSrc_n": "/cdn/shop/files/deep-purple.png",
				"imgSrcF": "/cdn/shop/files/Deep-Purple.jpg",
				"title": "Hussein / Deep Purple",
				"color": "Purple"
			},
			{
				"term_id": 96070,
				"gallery": [
					107836
				],
				"imgSrc": "/cdn/shop/files/cappuccino-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/cappuccino-1.png",
				"imgSrcF": "/cdn/shop/files/Cappuccino.jpg",
				"title": "Hussein / Cappuccino",
				"color": "Brown"
			},
			{
				"term_id": 96064,
				"gallery": [
					107853
				],
				"imgSrc": "/cdn/shop/files/tealblue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/tealblue.png",
				"imgSrcF": "/cdn/shop/files/Sea-Teal.jpg",
				"title": "Hussein / Teal Blue",
				"color": "Blue"
			},
			{
				"term_id": 96062,
				"gallery": [
					96019
				],
				"imgSrc": "/cdn/shop/files/27-500x500.png",
				"imgSrc_n": "/cdn/shop/files/27.png",
				"imgSrcF": "/cdn/shop/files/Coffee.jpg",
				"title": "Hussein / Coffee",
				"color": "Brown"
			},
			{
				"term_id": 96060,
				"gallery": [
					107832
				],
				"imgSrc": "/cdn/shop/files/black-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/black-4.png",
				"imgSrcF": "/cdn/shop/files/Black.jpg",
				"title": "Hussein / Black",
				"color": "Black"
			},
			{
				"term_id": 96058,
				"gallery": [
					107847
				],
				"imgSrc": "/cdn/shop/files/red-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/red-2.png",
				"imgSrcF": "/cdn/shop/files/Red.jpg",
				"title": "Hussein / Red",
				"color": "Red"
			},
			{
				"term_id": 96015,
				"gallery": [
					96029
				],
				"imgSrc": "/cdn/shop/files/Frame-1000005980-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Frame-1000005980.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005980.png",
				"title": "Hussein — All Color",
				"color": "Red"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "hussein",
				"name": "Hussein"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Frame-1000005980-800x800.png",
		"hoverImg": "/cdn/shop/files/Frame-1000005980-500x500.png",
		"subheading": "OEKO Certified Fabric Swatches",
		"Fabrics": [
			"Hussein"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White",
			"White",
			"Beige",
			"Beige",
			"Grey",
			"Grey",
			"Blue",
			"Blue",
			"Red",
			"Pink",
			"Red",
			"Purple",
			"Green",
			"Green",
			"Blue",
			"Green",
			"Green",
			"Green",
			"Grey",
			"Yellow",
			"Green",
			"Purple",
			"Brown",
			"Blue",
			"Brown",
			"Black",
			"Red"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"1166",
			"1171"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 35,
		"newPrice": 5
	},
	{
		"id": 96143,
		"title": "Zoe Linen Look Soft Fabric Swatches",
		"ProductUrl": "/swatches/zoe-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96216",
		"_fabric_color": [
			{
				"term_id": 96214,
				"gallery": [
					96268
				],
				"imgSrc": "/cdn/shop/files/9-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/9-3.png",
				"imgSrcF": "/cdn/shop/files/Straw-Brown-2-2.png",
				"title": "Zoe / Straw Brown",
				"color": "Beige"
			},
			{
				"term_id": 96212,
				"gallery": [
					96262
				],
				"imgSrc": "/cdn/shop/files/3-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/3-5.png",
				"imgSrcF": "/cdn/shop/files/Angora-3.png",
				"title": "Zoe / Angora",
				"color": "Grey"
			},
			{
				"term_id": 96210,
				"gallery": [
					96263
				],
				"imgSrc": "/cdn/shop/files/4-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/4-5.png",
				"imgSrcF": "/cdn/shop/files/Zoe-Caramel.png",
				"title": "Zoe / Caramel",
				"color": "Orange"
			},
			{
				"term_id": 96208,
				"gallery": [
					96266
				],
				"imgSrc": "/cdn/shop/files/7-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/7-4.png",
				"imgSrcF": "/cdn/shop/files/Zoe-Brown.png",
				"title": "Zoe / Brown",
				"color": "Brown"
			},
			{
				"term_id": 96206,
				"gallery": [
					96267
				],
				"imgSrc": "/cdn/shop/files/8-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/8-4.png",
				"imgSrcF": "/cdn/shop/files/Zoe-Grey.png",
				"title": "Zoe / Grey",
				"color": "Grey"
			},
			{
				"term_id": 96202,
				"gallery": [
					96260
				],
				"imgSrc": "/cdn/shop/files/1-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/1-5.png",
				"imgSrcF": "/cdn/shop/files/Zoe-Navy-Blue.png",
				"title": "Zoe / Navy Blue",
				"color": "Blue"
			},
			{
				"term_id": 96200,
				"gallery": [
					96265
				],
				"imgSrc": "/cdn/shop/files/6-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/6-4.png",
				"imgSrcF": "/cdn/shop/files/Zoe-Haze-Blue.png",
				"title": "Zoe / Haze Blue",
				"color": "Blue"
			},
			{
				"term_id": 96198,
				"gallery": [
					96261
				],
				"imgSrc": "/cdn/shop/files/2-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2-5.png",
				"imgSrcF": "/cdn/shop/files/Silver-White-3.png",
				"title": "Zoe / Silver White",
				"color": "White"
			},
			{
				"term_id": 96196,
				"gallery": [
					96264
				],
				"imgSrc": "/cdn/shop/files/5-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/5-5.png",
				"imgSrcF": "/cdn/shop/files/Ivory-White-1.png",
				"title": "Zoe / Ivory White",
				"color": "White"
			},
			{
				"term_id": 102147,
				"gallery": [
					102777
				],
				"imgSrc": "/cdn/shop/files/c89-500x500.png",
				"imgSrc_n": "/cdn/shop/files/c89.png",
				"imgSrcF": "/cdn/shop/files/Dark-rose-2-1.png",
				"title": "Zoe / Dark rose",
				"color": "White"
			},
			{
				"term_id": 102145,
				"gallery": [
					102776
				],
				"imgSrc": "/cdn/shop/files/c83-500x500.png",
				"imgSrc_n": "/cdn/shop/files/c83.png",
				"imgSrcF": "/cdn/shop/files/Sage-green-3-1.png",
				"title": "Zoe / Sage green",
				"color": "White"
			},
			{
				"term_id": 102142,
				"gallery": [
					102774
				],
				"imgSrc": "/cdn/shop/files/c76-500x500.png",
				"imgSrc_n": "/cdn/shop/files/c76.png",
				"imgSrcF": "/cdn/shop/files/Stone-blue-2-1.png",
				"title": "Zoe / Stone blue",
				"color": "White"
			},
			{
				"term_id": 102140,
				"gallery": [
					102773
				],
				"imgSrc": "/cdn/shop/files/c65-500x500.png",
				"imgSrc_n": "/cdn/shop/files/c65.png",
				"imgSrcF": "/cdn/shop/files/Forest-green-1-1.png",
				"title": "Zoe / Forest green",
				"color": "White"
			},
			{
				"term_id": 102138,
				"gallery": [
					102771
				],
				"imgSrc": "/cdn/shop/files/c50-500x500.png",
				"imgSrc_n": "/cdn/shop/files/c50.png",
				"imgSrcF": "/cdn/shop/files/Oatmeal-3-2.png",
				"title": "Zoe / Oatmeal",
				"color": "White"
			},
			{
				"term_id": 102136,
				"gallery": [
					102766
				],
				"imgSrc": "/cdn/shop/files/c36-500x500.png",
				"imgSrc_n": "/cdn/shop/files/c36.png",
				"imgSrcF": "/cdn/shop/files/Dark-Green-1-1.png",
				"title": "Zoe / Dark Green",
				"color": "White"
			},
			{
				"term_id": 102134,
				"gallery": [
					102767
				],
				"imgSrc": "/cdn/shop/files/c37-500x500.png",
				"imgSrc_n": "/cdn/shop/files/c37.png",
				"imgSrcF": "/cdn/shop/files/Golden-Brown-3-1.png",
				"title": "Zoe / Golden Brown",
				"color": "White"
			},
			{
				"term_id": 58394,
				"gallery": [
					102765
				],
				"imgSrc": "/cdn/shop/files/c28-500x500.png",
				"imgSrc_n": "/cdn/shop/files/c28.png",
				"imgSrcF": "/cdn/shop/files/Silver-Grey-3.png",
				"title": "Zoe / Silver Grey",
				"color": "Grey"
			},
			{
				"term_id": 96216,
				"gallery": [
					96270
				],
				"imgSrc": "/cdn/shop/files/531250-500x500.png",
				"imgSrc_n": "/cdn/shop/files/531250.png",
				"imgSrcF": "/cdn/shop/files/531250.png",
				"title": "Zoe — All Color",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "Zoe\r\n<div class=\"flex_column av_one_full flex_column_div av-zero-column-padding first avia-builder-el-12 el_after_av_hr el_before_av_hr \" style=\"border-radius: 0px;\"><section class=\"av_textblock_section \">\r\n<div class=\"avia_textblock \"><article class=\"4ever-article\">\r\n<p style=\"margin-bottom: 20px;\">Made from high-quality materials, these curtains offer a rich and realistic woven texture that adds depth and dimension to any decor. The faux linen fabric has a soft, warm feel that will envelop your room in comfort and create a cozy atmosphere.</p>\r\n<p style=\"margin-bottom: 20px;\">In addition to its beautiful look, these curtains are also highly functional that blocks out light and noise, providing you with a peaceful and dark environment for a good night's sleep. Whether you are looking for a solution for your bedroom, living room, or any other room in your home, these curtains are the perfect choice.</p>\r\n<p style=\"margin-bottom: 20px;\">Customizable to fit your window size, these curtains offer both quality and style, making them a versatile addition to any room. With their elegant look, they are perfect for adding a touch of sophistication to your home, while the blackout feature makes them ideal for creating a comfortable and private space.</p>\r\n\r\n</article></div>\r\n</section></div>\r\n<div class=\"hr hr-invisible avia-builder-el-15 el_after_av_one_full el_before_av_two_fifth \" style=\"height: 35px;\"></div>",
		"imgSrc": "/cdn/shop/files/531250-800x800.png",
		"hoverImg": "/cdn/shop/files/531250-500x500.png",
		"subheading": "Linen Look Soft Fabric Swatches",
		"Fabrics": [
			"Zoe"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Grey",
			"Orange",
			"Brown",
			"Grey",
			"Blue",
			"Blue",
			"White",
			"White",
			"Grey"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"36313",
			"53698"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 17,
		"newPrice": 5
	},
	{
		"id": 66049,
		"title": "Silhouette Linen Blend Woven Sheer Fabric Swatches",
		"ProductUrl": "/swatches/silhouette-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66082",
		"_fabric_color": [
			{
				"term_id": 64081,
				"gallery": [
					65873
				],
				"imgSrc": "/cdn/shop/files/FA-FT0103-Sand-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FA-FT0103-Sand.png",
				"imgSrcF": "/cdn/shop/files/FA-FT0103-color-1.png",
				"title": "Silhouette / Sand",
				"color": "Beige"
			},
			{
				"term_id": 64071,
				"gallery": [
					65872
				],
				"imgSrc": "/cdn/shop/files/FA-FT0102-White-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FA-FT0102-White.png",
				"imgSrcF": "/cdn/shop/files/FA-FT0103-color-3.png",
				"title": "Silhouette / White",
				"color": "White"
			},
			{
				"term_id": 64072,
				"gallery": [
					65871
				],
				"imgSrc": "/cdn/shop/files/FA-FT0101-Ivory-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FA-FT0101-Ivory.png",
				"imgSrcF": "/cdn/shop/files/FA-FT0103-color-2.png",
				"title": "Silhouette / Ivory",
				"color": "White"
			},
			{
				"term_id": 66082,
				"gallery": [
					65874
				],
				"imgSrc": "/cdn/shop/files/Silhouette-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Silhouette.png",
				"imgSrcF": "/cdn/shop/files/Silhouette.png",
				"title": "Silhouette — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/Silhouette-500x500.png",
		"hoverImg": "/cdn/shop/files/Silhouette-500x500.png",
		"subheading": "Linen Blend Woven Sheer Fabric Swatches",
		"Fabrics": [
			"Silhouette"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"White",
			"White"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64172"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 3,
		"newPrice": 5
	},
	{
		"id": 96236,
		"title": "Latvian Linen Blend Lightweight Fabric Swatches",
		"ProductUrl": "/swatches/latvian-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96256",
		"_fabric_color": [
			{
				"term_id": 96254,
				"gallery": [
					96233
				],
				"imgSrc": "/cdn/shop/files/6-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/6-3.png",
				"imgSrcF": "/cdn/shop/files/terracotta.png",
				"title": "Latvian / Terracotta",
				"color": "Red"
			},
			{
				"term_id": 96252,
				"gallery": [
					96230
				],
				"imgSrc": "/cdn/shop/files/3-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/3-4.png",
				"imgSrcF": "/cdn/shop/files/angora-1.png",
				"title": "Latvian / Angora",
				"color": "Beige"
			},
			{
				"term_id": 96250,
				"gallery": [
					96235
				],
				"imgSrc": "/cdn/shop/files/8-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/8-3.png",
				"imgSrcF": "/cdn/shop/files/burlap-1.png",
				"title": "Latvian / Burlap",
				"color": "Beige"
			},
			{
				"term_id": 96248,
				"gallery": [
					96234
				],
				"imgSrc": "/cdn/shop/files/7-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/7-3.png",
				"imgSrcF": "/cdn/shop/files/stoneblue.png",
				"title": "Latvian / Stone Blue",
				"color": "Blue"
			},
			{
				"term_id": 96246,
				"gallery": [
					96232
				],
				"imgSrc": "/cdn/shop/files/5-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/5-4.png",
				"imgSrcF": "/cdn/shop/files/brickred.png",
				"title": "Latvian / Brick Red",
				"color": "Red"
			},
			{
				"term_id": 96243,
				"gallery": [
					96231
				],
				"imgSrc": "/cdn/shop/files/4-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/4-4.png",
				"imgSrcF": "/cdn/shop/files/grey-1.png",
				"title": "Latvian / Grey",
				"color": "Grey"
			},
			{
				"term_id": 96241,
				"gallery": [
					96229
				],
				"imgSrc": "/cdn/shop/files/2-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2-4.png",
				"imgSrcF": "/cdn/shop/files/shell.png",
				"title": "Latvian / Shell",
				"color": "Beige"
			},
			{
				"term_id": 96239,
				"gallery": [
					96228
				],
				"imgSrc": "/cdn/shop/files/1-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/1-4.png",
				"imgSrcF": "/cdn/shop/files/natural.png",
				"title": "Latvian / Natural",
				"color": "Beige"
			},
			{
				"term_id": 96256,
				"gallery": [
					96237
				],
				"imgSrc": "/cdn/shop/files/531255-500x500.png",
				"imgSrc_n": "/cdn/shop/files/531255.png",
				"imgSrcF": "/cdn/shop/files/531255.png",
				"title": "Latvian — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "latvian",
				"name": "Latvian"
			}
		],
		"short_description": "<p style=\"margin-bottom: 20px;\">This single-layer blackout curtain can block 80%-95% of light and UV rays (black works better than white). The eco-friendly linen blend fabric offers a natural dark environment for the night shift worker who has to sleep during the day. Good quality finishing will withstand years of use. Linen curtain panel available in various home textile colors. Soft, easy draping, linen curtains provide privacy while at the same time letting just enough daylight to keep the room cheered.</p>\r\nIn some cases, light can still be seen on the edges of the curtain. The deeper the color, the better the blackout effect it can provide. Blackout curtains are made of polyester, an excellent fabric for blackout curtains; they are smooth, durable, strong, and low-cost. This fabric is also easy-to-clean, and it can hold out against wrinkling.\r\n\r\nLatvian\r\n\r\n&nbsp;",
		"imgSrc": "/cdn/shop/files/531255-500x500.png",
		"hoverImg": "/cdn/shop/files/531255-500x500.png",
		"subheading": "Linen Blend Lightweight Fabric Swatches",
		"Fabrics": [
			"Latvian"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Linen Blend"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Red",
			"Beige",
			"Blue",
			"Red",
			"Grey",
			"Beige",
			"Beige"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"1198",
			"35747"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 8,
		"newPrice": 5
	},
	{
		"id": 109368,
		"title": "Yarn Linen Look Sheer Fabric Swatches",
		"ProductUrl": "/swatches/yarn-linen-look-sheer-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "1056",
		"_fabric_color": [
			{
				"term_id": 1056,
				"gallery": [
					109381
				],
				"imgSrc": "/cdn/shop/files/white-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/white-4.png",
				"imgSrcF": "/cdn/shop/files/white-9.jpg",
				"title": "Yarn / White",
				"color": "White"
			},
			{
				"term_id": 1046,
				"gallery": [
					109370
				],
				"imgSrc": "/cdn/shop/files/beige-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/beige-2.png",
				"imgSrcF": "/cdn/shop/files/beige-10.jpg",
				"title": "Yarn / Beige",
				"color": "Beige"
			},
			{
				"term_id": 1055,
				"gallery": [
					109380
				],
				"imgSrc": "/cdn/shop/files/terracotta-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/terracotta-2.png",
				"imgSrcF": "/cdn/shop/files/terracotta-7.jpg",
				"title": "Yarn / Terracotta",
				"color": "Red"
			},
			{
				"term_id": 1054,
				"gallery": [
					109379
				],
				"imgSrc": "/cdn/shop/files/seamist-500x500.png",
				"imgSrc_n": "/cdn/shop/files/seamist.png",
				"imgSrcF": "/cdn/shop/files/seamist-1.jpg",
				"title": "Yarn / Sea Mist",
				"color": "Blue"
			},
			{
				"term_id": 1053,
				"gallery": [
					109378
				],
				"imgSrc": "/cdn/shop/files/olivegreen-500x500.png",
				"imgSrc_n": "/cdn/shop/files/olivegreen.png",
				"imgSrcF": "/cdn/shop/files/olivegreen-1.jpg",
				"title": "Yarn / Olive Green",
				"color": "Green"
			},
			{
				"term_id": 1052,
				"gallery": [
					109377
				],
				"imgSrc": "/cdn/shop/files/natural-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/natural-1.png",
				"imgSrcF": "/cdn/shop/files/natural-9.jpg",
				"title": "Yarn / Natural",
				"color": "White"
			},
			{
				"term_id": 1051,
				"gallery": [
					109376
				],
				"imgSrc": "/cdn/shop/files/grey-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/grey-2.png",
				"imgSrcF": "/cdn/shop/files/grey-8.jpg",
				"title": "Yarn / Grey",
				"color": "Grey"
			},
			{
				"term_id": 1050,
				"gallery": [
					109375
				],
				"imgSrc": "/cdn/shop/files/darkblue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/darkblue.png",
				"imgSrcF": "/cdn/shop/files/darkblue-1.jpg",
				"title": "Yarn / Dark Blue",
				"color": "Blue"
			},
			{
				"term_id": 1049,
				"gallery": [
					109374
				],
				"imgSrc": "/cdn/shop/files/charcoal-grey-500x500.png",
				"imgSrc_n": "/cdn/shop/files/charcoal-grey.png",
				"imgSrcF": "/cdn/shop/files/charcoalgrey-1.jpg",
				"title": "Yarn / Charcoal Grey",
				"color": "Grey"
			},
			{
				"term_id": 1048,
				"gallery": [
					109373
				],
				"imgSrc": "/cdn/shop/files/camel-500x500.png",
				"imgSrc_n": "/cdn/shop/files/camel.png",
				"imgSrcF": "/cdn/shop/files/camel-5.jpg",
				"title": "Yarn / Camel",
				"color": "Beige"
			},
			{
				"term_id": 1047,
				"gallery": [
					109371
				],
				"imgSrc": "/cdn/shop/files/black-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/black-1.png",
				"imgSrcF": "/cdn/shop/files/black-6.jpg",
				"title": "Yarn / Black",
				"color": "Black"
			},
			{
				"term_id": 1045,
				"gallery": [
					109372
				],
				"imgSrc": "/cdn/shop/files/blush-500x500.png",
				"imgSrc_n": "/cdn/shop/files/blush.png",
				"imgSrcF": "/cdn/shop/files/blush-1.jpg",
				"title": "Yarn / Blush",
				"color": "Pink"
			},
			{
				"term_id": 109383,
				"gallery": [
					109382
				],
				"imgSrc": "/cdn/shop/files/All-500x500.png",
				"imgSrc_n": "/cdn/shop/files/All.png",
				"imgSrcF": "/cdn/shop/files/All.png",
				"title": "Yarn — All Color",
				"color": "Pink"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Experience the refined beauty of Yarn Linen Look Sheer Fabric Swatches, thoughtfully crafted to mirror the natural elegance of our Custom Solid Color Flax Texture Curtains. Each swatch captures the soft texture and light, flowing quality that define this timeless style. By choosing Yarn Linen Look Sheer Fabric Swatches, you can feel the fine craftsmanship firsthand and confidently design curtains that elevate any room with effortless sophistication.",
		"imgSrc": "/cdn/shop/files/All-500x500.png",
		"hoverImg": "",
		"subheading": "Linen Look Sheer Fabric Swatches",
		"Fabrics": [
			"Yarn"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Sheer",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White",
			"Beige",
			"Red",
			"Blue",
			"Green",
			"White",
			"Grey",
			"Blue",
			"Grey",
			"Beige",
			"Black",
			"Pink"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [
			"4 In 1",
			"Back Tab",
			"Grommet",
			"Pinch Pleated",
			"Rod Pocket"
		],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"1204"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1
	},
	{
		"id": 102874,
		"title": "Kensington OEKO Blackout Linen Look Swatches",
		"ProductUrl": "/swatches/kensington-oeko-blackout-linen-look-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "102871",
		"_fabric_color": [
			{
				"term_id": 101764,
				"gallery": [
					102853
				],
				"imgSrc": "/cdn/shop/files/1-8-500x500.png",
				"imgSrc_n": "/cdn/shop/files/1-8.png",
				"imgSrcF": "/cdn/shop/files/Brown-4.jpg",
				"title": "Kensington / Brown",
				"color": "White"
			},
			{
				"term_id": 101762,
				"gallery": [
					102854
				],
				"imgSrc": "/cdn/shop/files/2-8-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2-8.png",
				"imgSrcF": "/cdn/shop/files/Terracotta-4-300x300-1.jpg",
				"title": "Kensington / Terracotta",
				"color": "White"
			},
			{
				"term_id": 101760,
				"gallery": [
					102855
				],
				"imgSrc": "/cdn/shop/files/3-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/3-4.png",
				"imgSrcF": "/cdn/shop/files/Sand-3-300x300-1.jpg",
				"title": "Kensington / Sand",
				"color": "White"
			},
			{
				"term_id": 101758,
				"gallery": [
					102856
				],
				"imgSrc": "/cdn/shop/files/4-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/4-3.png",
				"imgSrcF": "/cdn/shop/files/Grey-4-300x300-1.jpg",
				"title": "Kensington / Grey",
				"color": "White"
			},
			{
				"term_id": 101736,
				"gallery": [
					102857
				],
				"imgSrc": "/cdn/shop/files/5-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/5-4.png",
				"imgSrcF": "/cdn/shop/files/Cream-4-300x300-1.jpg",
				"title": "Kensington / Cream",
				"color": "White"
			},
			{
				"term_id": 102871,
				"gallery": [
					102858
				],
				"imgSrc": "/cdn/shop/files/all-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/all-3.png",
				"imgSrcF": "/cdn/shop/files/all-4.png",
				"title": "Kensington — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/all-3-500x500.png",
		"hoverImg": "/cdn/shop/files/all-3-500x500.png",
		"subheading": "OEKO Blackout Linen Look Swatches",
		"Fabrics": [
			"Kensington"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Blackout"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"101732",
			"102738"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 5
	},
	{
		"id": 66050,
		"title": "Glimmer Linen Blend Lightweight Textured Fabric Swatches",
		"ProductUrl": "/swatches/glimmer-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64073",
		"_fabric_color": [
			{
				"term_id": 64073,
				"gallery": [
					66134
				],
				"imgSrc": "/cdn/shop/files/FA-BD4202-Glimmer-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FA-BD4202-Glimmer-1.png",
				"imgSrcF": "/cdn/shop/files/glimmer-color.png",
				"title": "Glimmer / Glimmer",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/FA-BD4202-Glimmer-1-500x500.png",
		"hoverImg": "/cdn/shop/files/FA-BD4202-Glimmer-1-500x500.png",
		"subheading": "Linen Blend Lightweight Textured Fabric Swatches",
		"Fabrics": [
			"Glimmer"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64173",
			"105173"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 66051,
		"title": "Deconstructed Linen &#038; Wool Blend Heavyweight Geometric Fringed Patterned Fabric Swatches",
		"ProductUrl": "/swatches/deconstructed-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66085",
		"_fabric_color": [
			{
				"term_id": 65275,
				"gallery": [
					65918
				],
				"imgSrc": "/cdn/shop/files/Urban-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Urban.png",
				"imgSrcF": "/cdn/shop/files/Urban-1.jpg",
				"title": "Deconstructed / Urban",
				"color": "Beige"
			},
			{
				"term_id": 65277,
				"gallery": [
					65919
				],
				"imgSrc": "/cdn/shop/files/Pool-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Pool.png",
				"imgSrcF": "/cdn/shop/files/FB-KF0303-Pool.jpg",
				"title": "Deconstructed / Pool",
				"color": "Green"
			},
			{
				"term_id": 65276,
				"gallery": [
					65917
				],
				"imgSrc": "/cdn/shop/files/Khaki-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Khaki.png",
				"imgSrcF": "/cdn/shop/files/FB-KF0301-Khaki-1.jpg",
				"title": "Deconstructed / Khaki",
				"color": "Beige"
			},
			{
				"term_id": 66085,
				"gallery": [
					65920
				],
				"imgSrc": "/cdn/shop/files/Deconstructed-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Deconstructed.png",
				"imgSrcF": "/cdn/shop/files/Deconstructed.png",
				"title": "Deconstructed — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/Deconstructed-500x500.png",
		"hoverImg": "/cdn/shop/files/Deconstructed-500x500.png",
		"subheading": "Linen & Wool Blend Heavyweight Geometric Fringed Patterned Fabric Swatches",
		"Fabrics": [
			"Deconstructed"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Wool"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Beige",
			"Green",
			"Beige"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64168"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 3,
		"newPrice": 5
	},
	{
		"id": 66057,
		"title": "Aztec Fabric Swatches",
		"ProductUrl": "/swatches/aztec-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64057",
		"_fabric_color": [
			{
				"term_id": 64059,
				"gallery": [
					65941
				],
				"imgSrc": "/cdn/shop/files/AZTEC-Black-500x500.png",
				"imgSrc_n": "/cdn/shop/files/AZTEC-Black.png",
				"imgSrcF": "/cdn/shop/files/2405-6-661-color-3.png",
				"title": "Aztec / Black",
				"color": "Black"
			},
			{
				"term_id": 64057,
				"gallery": [
					65939
				],
				"imgSrc": "/cdn/shop/files/AZTEC-White-500x500.png",
				"imgSrc_n": "/cdn/shop/files/AZTEC-White.png",
				"imgSrcF": "/cdn/shop/files/2405-6-661-color-1.png",
				"title": "Aztec / White",
				"color": "White"
			},
			{
				"term_id": 64058,
				"gallery": [
					65943
				],
				"imgSrc": "/cdn/shop/files/AZTEC-Lavender-Grey-500x500.png",
				"imgSrc_n": "/cdn/shop/files/AZTEC-Lavender-Grey.png",
				"imgSrcF": "/cdn/shop/files/2405-6-661-color-4.png",
				"title": "Aztec / Lavender Grey",
				"color": "Grey"
			},
			{
				"term_id": 64060,
				"gallery": [
					65942
				],
				"imgSrc": "/cdn/shop/files/AZTEC-Light-Taro-500x500.png",
				"imgSrc_n": "/cdn/shop/files/AZTEC-Light-Taro.png",
				"imgSrcF": "/cdn/shop/files/2405-6-661-color-2.png",
				"title": "Aztec / Light Taro",
				"color": "Beige"
			},
			{
				"term_id": 66061,
				"gallery": [
					65940
				],
				"imgSrc": "/cdn/shop/files/AZTEC-500x500.png",
				"imgSrc_n": "/cdn/shop/files/AZTEC.png",
				"imgSrcF": "/cdn/shop/files/AZTEC.png",
				"title": "Aztec — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Aztec fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/AZTEC-500x500.png",
		"hoverImg": "/cdn/shop/files/AZTEC-500x500.png",
		"subheading": "Fabric Swatches",
		"Fabrics": [
			"Aztec"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Black",
			"White",
			"Grey",
			"Beige"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64167"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 102873,
		"title": "Florence OEKO Blackout Heavyweight Woven Textured Swatches",
		"ProductUrl": "/swatches/florence-oeko-blackout-heavyweight-woven-textured-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "102869",
		"_fabric_color": [
			{
				"term_id": 101827,
				"gallery": [
					102860
				],
				"imgSrc": "/cdn/shop/files/1-9-500x500.png",
				"imgSrc_n": "/cdn/shop/files/1-9.png",
				"imgSrcF": "/cdn/shop/files/Ash-Pink-4-300x300-1.jpg",
				"title": "Florence / Ash Pink",
				"color": "White"
			},
			{
				"term_id": 101825,
				"gallery": [
					102861
				],
				"imgSrc": "/cdn/shop/files/2-9-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2-9.png",
				"imgSrcF": "/cdn/shop/files/Light-Silver-4-300x300-1.jpg",
				"title": "Florence / Light Silver",
				"color": "White"
			},
			{
				"term_id": 101822,
				"gallery": [
					102862
				],
				"imgSrc": "/cdn/shop/files/3-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/3-5.png",
				"imgSrcF": "/cdn/shop/files/Oat-4-300x300-1.jpg",
				"title": "Florence / Oat",
				"color": "White"
			},
			{
				"term_id": 101820,
				"gallery": [
					102863
				],
				"imgSrc": "/cdn/shop/files/4-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/4-4.png",
				"imgSrcF": "/cdn/shop/files/Beige-4-300x300-1.jpg",
				"title": "Florence / Beige",
				"color": "White"
			},
			{
				"term_id": 101798,
				"gallery": [
					102864
				],
				"imgSrc": "/cdn/shop/files/5-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/5-5.png",
				"imgSrcF": "/cdn/shop/files/White-4-1-300x300-1.jpg",
				"title": "Florence / White",
				"color": "White"
			},
			{
				"term_id": 102869,
				"gallery": [
					102865
				],
				"imgSrc": "/cdn/shop/files/all-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/all-4.png",
				"imgSrcF": "/cdn/shop/files/all-4.png",
				"title": "Florence — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/all-4-500x500.png",
		"hoverImg": "/cdn/shop/files/all-4-500x500.png",
		"subheading": "OEKO Blackout Heavyweight Woven Textured Swatches",
		"Fabrics": [
			"Florence"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Blackout"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"101734",
			"102740"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 5
	},
	{
		"id": 96144,
		"title": "Cronin Linen Look Blackout Fabric Swatches",
		"ProductUrl": "/swatches/cronin-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96218",
		"_fabric_color": [
			{
				"term_id": 96164,
				"gallery": [
					96180
				],
				"imgSrc": "/cdn/shop/files/1-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/1-3.png",
				"imgSrcF": "/cdn/shop/files/Natural-2.jpg",
				"title": "Cronin / Natural",
				"color": "Beige"
			},
			{
				"term_id": 96158,
				"gallery": [
					96181
				],
				"imgSrc": "/cdn/shop/files/2-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2-3.png",
				"imgSrcF": "/cdn/shop/files/Sea-Green-2-300x300-1.png",
				"title": "Cronin / Sage Green",
				"color": "Green"
			},
			{
				"term_id": 96153,
				"gallery": [
					96182
				],
				"imgSrc": "/cdn/shop/files/3-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/3-3.png",
				"imgSrcF": "/cdn/shop/files/silvergrey.png",
				"title": "Cronin / Sliver Grey",
				"color": "Grey"
			},
			{
				"term_id": 102210,
				"gallery": [
					102757
				],
				"imgSrc": "/cdn/shop/files/v24-500x500.png",
				"imgSrc_n": "/cdn/shop/files/v24.png",
				"imgSrcF": "/cdn/shop/files/Camel-3-1.png",
				"title": "Cronin / Camel",
				"color": "Orange"
			},
			{
				"term_id": 102208,
				"gallery": [
					102759
				],
				"imgSrc": "/cdn/shop/files/v40-500x500.png",
				"imgSrc_n": "/cdn/shop/files/v40.png",
				"imgSrcF": "/cdn/shop/files/Ivory-White-3-1-300x300-1.png",
				"title": "Cronin / Ivory",
				"color": "Beige"
			},
			{
				"term_id": 102203,
				"gallery": [
					102755
				],
				"imgSrc": "/cdn/shop/files/c34-500x500.png",
				"imgSrc_n": "/cdn/shop/files/c34.png",
				"imgSrcF": "/cdn/shop/files/Beige-2-3.png",
				"title": "Cronin / Beige",
				"color": "Beige"
			},
			{
				"term_id": 96218,
				"gallery": [
					96171
				],
				"imgSrc": "/cdn/shop/files/Frame-1000005979-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Frame-1000005979.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005979.png",
				"title": "Cronin — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "cronin",
				"name": "Cronin"
			}
		],
		"short_description": "These durable and elegant linen blend blackout curtains will decorate your windows and rooms with a new feel. Ideal for bedrooms, living rooms, kitchens, patios, room dividers, practical and modern. While saving energy and reducing noise, it creates a transparent, breathable and rustic style.\r\n<p class=\"atrst\" style=\"margin-bottom: 20px;\">Linen blackout curtains bring casual warmth and sophisticated style to a room. The weave of natural fibers creates dimensional highs and lows for added depth. This curtain is an elegant choice for any room in your home. Lab tests show that these awesome curtain panels are eco-friendly and vinyl-free.</p>",
		"imgSrc": "/cdn/shop/files/Frame-1000005979-800x800.png",
		"hoverImg": "/cdn/shop/files/Frame-1000005979-500x500.png",
		"subheading": "Linen Look Blackout Fabric Swatches",
		"Fabrics": [
			"Cronin"
		],
		"Feature": [],
		"Material": [
			"Faux Linen",
			"Linen",
			"Polyester"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Green",
			"Grey",
			"Orange",
			"Beige"
		],
		"Light": [
			"Blackout"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"31662",
			"36329"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 5,
		"newPrice": 5
	},
	{
		"id": 66052,
		"title": "Peacock Linen Blend Heavyweight Floral Patterned Fabric Swatches",
		"ProductUrl": "/swatches/peacock-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66080",
		"_fabric_color": [
			{
				"term_id": 64069,
				"gallery": [
					65912
				],
				"imgSrc": "/cdn/shop/files/Spring-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Spring.png",
				"imgSrcF": "/cdn/shop/files/Frame-41.png",
				"title": "Peacock / Spring",
				"color": "Beige"
			},
			{
				"term_id": 64075,
				"gallery": [
					65914
				],
				"imgSrc": "/cdn/shop/files/Summer-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Summer.png",
				"imgSrcF": "/cdn/shop/files/summer-1.png",
				"title": "Peacock / Summer",
				"color": "Green"
			},
			{
				"term_id": 64074,
				"gallery": [
					65915
				],
				"imgSrc": "/cdn/shop/files/Fall-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Fall.png",
				"imgSrcF": "/cdn/shop/files/fall-3-1.jpg",
				"title": "Peacock / Fall",
				"color": "White"
			},
			{
				"term_id": 64068,
				"gallery": [
					65913
				],
				"imgSrc": "/cdn/shop/files/Winter-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Winter.png",
				"imgSrcF": "/cdn/shop/files/Frame-42.png",
				"title": "Peacock / Winter",
				"color": "Black"
			},
			{
				"term_id": 66080,
				"gallery": [
					65916
				],
				"imgSrc": "/cdn/shop/files/Peacock-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Peacock.png",
				"imgSrcF": "/cdn/shop/files/Peacock.png",
				"title": "Peacock — All Color",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/Peacock-500x500.png",
		"hoverImg": "/cdn/shop/files/Peacock-500x500.png",
		"subheading": "Linen Blend Heavyweight Floral Patterned Fabric Swatches",
		"Fabrics": [
			"Peacock"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Beige",
			"Green",
			"White",
			"Black"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64162"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 4,
		"newPrice": 5
	},
	{
		"id": 66056,
		"title": "Brushstrokes Cotton Blend Heavyweight Unique Patterned Fabric Swatches",
		"ProductUrl": "/swatches/brushstrokes-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66068",
		"_fabric_color": [
			{
				"term_id": 64067,
				"gallery": [
					65996
				],
				"imgSrc": "/cdn/shop/files/BRUSHSTROKES-Black-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BRUSHSTROKES-Black.png",
				"imgSrcF": "/cdn/shop/files/2405-7-657-color-3.png",
				"title": "Brushstrokes / Black",
				"color": "Black"
			},
			{
				"term_id": 64065,
				"gallery": [
					65997
				],
				"imgSrc": "/cdn/shop/files/BRUSHSTROKES-Sand-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BRUSHSTROKES-Sand.png",
				"imgSrcF": "/cdn/shop/files/2405-7-657-color-2.png",
				"title": "Brushstrokes / Sand",
				"color": "Beige"
			},
			{
				"term_id": 64066,
				"gallery": [
					65994
				],
				"imgSrc": "/cdn/shop/files/BRUSHSTROKES-Ash-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BRUSHSTROKES-Ash.png",
				"imgSrcF": "/cdn/shop/files/2405-7-657-color-1.png",
				"title": "Brushstrokes / Ash",
				"color": "Beige"
			},
			{
				"term_id": 66068,
				"gallery": [
					65995
				],
				"imgSrc": "/cdn/shop/files/BRUSHSTROKE-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BRUSHSTROKE.png",
				"imgSrcF": "/cdn/shop/files/BRUSHSTROKE.png",
				"title": "Brushstrokes — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Brushstrokes patterned fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\nBrushstrokes patterned fabric swatches\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/BRUSHSTROKE-500x500.png",
		"hoverImg": "/cdn/shop/files/BRUSHSTROKE-500x500.png",
		"subheading": "Cotton Blend Heavyweight Unique Patterned Fabric Swatches",
		"Fabrics": [
			"Brushstrokes"
		],
		"Feature": [],
		"Material": [
			"Cotton"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Black",
			"Beige",
			"Beige"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64166"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 3,
		"newPrice": 5
	},
	{
		"id": 66045,
		"title": "Raw Linen Blend Striped Patterned Semi-Sheer Fabric Swatches",
		"ProductUrl": "/swatches/raw-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64090",
		"_fabric_color": [
			{
				"term_id": 64090,
				"gallery": [
					66017
				],
				"imgSrc": "/cdn/shop/files/RAW-Natural-500x500.png",
				"imgSrc_n": "/cdn/shop/files/RAW-Natural.png",
				"imgSrcF": "/cdn/shop/files/38-1.png",
				"title": "Raw / Natural",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/RAW-Natural-500x500.png",
		"hoverImg": "/cdn/shop/files/RAW-Natural-500x500.png",
		"subheading": "Linen Blend Striped Patterned Semi-Sheer Fabric Swatches",
		"Fabrics": [
			"Raw"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64176"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 66048,
		"title": "Unwind Linen Blend Grid Like Woven Sheer Fabric Swatches",
		"ProductUrl": "/swatches/unwind-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64080",
		"_fabric_color": [
			{
				"term_id": 64080,
				"gallery": [
					65937
				],
				"imgSrc": "/cdn/shop/files/FA-FT0301-Unwind-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FA-FT0301-Unwind.png",
				"imgSrcF": "/cdn/shop/files/FA-FT0301-color.png",
				"title": "Unwind / White",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/FA-FT0301-Unwind-500x500.png",
		"hoverImg": "/cdn/shop/files/FA-FT0301-Unwind-500x500.png",
		"subheading": "Linen Blend Grid Like Woven Sheer Fabric Swatches",
		"Fabrics": [
			"Unwind"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64171"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 66046,
		"title": "Gradient Ultra Light Soft Shimmering Sheer Fabric Swatches",
		"ProductUrl": "/swatches/gradient-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "94664",
		"_fabric_color": [
			{
				"term_id": 64091,
				"gallery": [
					65878
				],
				"imgSrc": "/cdn/shop/files/FA-KFN0804-Ivory-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FA-KFN0804-Ivory.png",
				"imgSrcF": "/cdn/shop/files/FA-KFN0804-color.png",
				"title": "Gradient / Ivory",
				"color": "White"
			},
			{
				"term_id": 64092,
				"gallery": [
					65877
				],
				"imgSrc": "/cdn/shop/files/FA-KFN0803-Champagne-Silver-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FA-KFN0803-Champagne-Silver.png",
				"imgSrcF": "/cdn/shop/files/FA-KFN0803-color.png",
				"title": "Gradient / Champagne Silver",
				"color": "Silver"
			},
			{
				"term_id": 64093,
				"gallery": [
					65876
				],
				"imgSrc": "/cdn/shop/files/FA-KFN0802-Fanta-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FA-KFN0802-Fanta.png",
				"imgSrcF": "/cdn/shop/files/FA-KFN0802-color.png",
				"title": "Gradient / Fanta",
				"color": "Red"
			},
			{
				"term_id": 64082,
				"gallery": [
					65875
				],
				"imgSrc": "/cdn/shop/files/FA-KFN0801-Sage-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FA-KFN0801-Sage.png",
				"imgSrcF": "/cdn/shop/files/FA-KFN0801-color.png",
				"title": "Gradient / Sage",
				"color": "Green"
			},
			{
				"term_id": 94664,
				"gallery": [
					65879
				],
				"imgSrc": "/cdn/shop/files/Gradient-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Gradient.png",
				"imgSrcF": "/cdn/shop/files/Gradient.png",
				"title": "Gradient — All Color",
				"color": "Green"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/Gradient-500x500.png",
		"hoverImg": "/cdn/shop/files/Gradient-500x500.png",
		"subheading": "Ultra Light Soft Shimmering Sheer Fabric Swatches",
		"Fabrics": [
			"Gradient"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White",
			"Silver",
			"Red",
			"Green"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64177"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 4,
		"newPrice": 5
	},
	{
		"id": 96823,
		"title": "Alice Dotted Patterned Heavyweight Soft Textured Fabric Swatches",
		"ProductUrl": "/swatches/alice-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64046",
		"_fabric_color": [
			{
				"term_id": 64046,
				"gallery": [
					96403
				],
				"imgSrc": "/cdn/shop/files/2402-34-657-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2402-34-657.png",
				"imgSrcF": "/cdn/shop/files/2402-34-657-1.png",
				"title": "Alice / Pink",
				"color": "Pink"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/2402-34-657-500x500.png",
		"hoverImg": "/cdn/shop/files/2402-34-657-500x500.png",
		"subheading": "Dotted Patterned Heavyweight Soft Textured Fabric Swatches",
		"Fabrics": [
			"Alice"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Pink"
		],
		"Light": [
			"Light Filtering",
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64159"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 98190,
		"title": "Crumbled Elegance Linen Blend Lightweight Embroidery Floral Patterned Fabric Swatches",
		"ProductUrl": "/swatches/crumbled-elegance-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "98191",
		"_fabric_color": [
			{
				"term_id": 64045,
				"gallery": [
					98187
				],
				"imgSrc": "/cdn/shop/files/Crumbled-Elegance-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Crumbled-Elegance-5.png",
				"imgSrcF": "/cdn/shop/files/Crumbled-Elegance-Storm-Grey.png",
				"title": "Crumbled Elegance / Storm Grey",
				"color": "Grey"
			},
			{
				"term_id": 64053,
				"gallery": [
					98185
				],
				"imgSrc": "/cdn/shop/files/Crumbled-Elegance-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Crumbled-Elegance-3.png",
				"imgSrcF": "/cdn/shop/files/Crumbled-Elegance-Cream.png",
				"title": "Crumbled Elegance / Cream",
				"color": "White"
			},
			{
				"term_id": 64054,
				"gallery": [
					98186
				],
				"imgSrc": "/cdn/shop/files/Crumbled-Elegance-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Crumbled-Elegance-4.png",
				"imgSrcF": "/cdn/shop/files/Crumbled-Elegance-Champagne-Gold.png",
				"title": "Crumbled Elegance / Champagne Gold",
				"color": "Gold"
			},
			{
				"term_id": 64055,
				"gallery": [
					98184
				],
				"imgSrc": "/cdn/shop/files/Crumbled-Elegance-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Crumbled-Elegance-2.png",
				"imgSrcF": "/cdn/shop/files/Crumbled-Elegance-Concrete-Grey.png",
				"title": "Crumbled Elegance / Concrete Grey",
				"color": "Grey"
			},
			{
				"term_id": 64056,
				"gallery": [
					98183
				],
				"imgSrc": "/cdn/shop/files/Crumbled-Elegance-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Crumbled-Elegance-1.png",
				"imgSrcF": "/cdn/shop/files/Crumbled-Elegance-White.png",
				"title": "Crumbled Elegance / White",
				"color": "White"
			},
			{
				"term_id": 98191,
				"gallery": [
					98188
				],
				"imgSrc": "/cdn/shop/files/Crumbled-Elegance-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Crumbled-Elegance-6.png",
				"imgSrcF": "/cdn/shop/files/Crumbled-Elegance-6.png",
				"title": "Crumbled Elegance — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Crumbled-Elegance-6-500x500.png",
		"hoverImg": "/cdn/shop/files/Crumbled-Elegance-6-500x500.png",
		"subheading": "Linen Blend Lightweight Embroidery Floral Patterned Custom Curtain",
		"Fabrics": [
			"Crumbled"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Floral"
		],
		"Color": [
			"Grey",
			"White",
			"Gold",
			"Grey",
			"White"
		],
		"Light": [
			"Light Filtering"
		],
		"Hanging": [
			"4 In 1",
			"Back Tab",
			"Goblet Pleat",
			"Grommet",
			"Inverted Pleat",
			"Pinch Pleated",
			"Rod Pocket"
		],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64161"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 5
	},
	{
		"id": 96831,
		"title": "Grace Wool Blend Textured Sheer Fabric Swatches",
		"ProductUrl": "/swatches/grace-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96832",
		"_fabric_color": [
			{
				"term_id": 64078,
				"gallery": [
					96730
				],
				"imgSrc": "/cdn/shop/files/FB-QM0104-14-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-QM0104-14.png",
				"imgSrcF": "/cdn/shop/files/Oatmeal-8.png",
				"title": "Grace / Oatmeal",
				"color": "Beige"
			},
			{
				"term_id": 64079,
				"gallery": [
					96728
				],
				"imgSrc": "/cdn/shop/files/FB-QM0104-13-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-QM0104-13.png",
				"imgSrcF": "/cdn/shop/files/White-2.png",
				"title": "Grace / White",
				"color": "White"
			},
			{
				"term_id": 96832,
				"gallery": [
					96729
				],
				"imgSrc": "/cdn/shop/files/FB-QM0104-15-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-QM0104-15.png",
				"imgSrcF": "/cdn/shop/files/FB-QM0104-15.png",
				"title": "Grace - All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/FB-QM0104-15-500x500.png",
		"hoverImg": "/cdn/shop/files/FB-QM0104-15-500x500.png",
		"subheading": "Wool Blend Textured Sheer Fabric Swatches",
		"Fabrics": [
			"Grace"
		],
		"Feature": [],
		"Material": [
			"Wool"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"White"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64170"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 2,
		"newPrice": 5
	},
	{
		"id": 97197,
		"title": "UVShield™ Sun Shade Fabric Swatches",
		"ProductUrl": "/swatches/uvshield-sun-shade-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "43466",
		"_fabric_color": [
			{
				"term_id": 38104,
				"gallery": [
					97216
				],
				"imgSrc": "/cdn/shop/files/sun-2-7-500x500.png",
				"imgSrc_n": "/cdn/shop/files/sun-2-7.png",
				"imgSrcF": "/cdn/shop/files/Beige.png",
				"title": "UVShield™ / Beige",
				"color": "Beige"
			},
			{
				"term_id": 38133,
				"gallery": [
					97212
				],
				"imgSrc": "/cdn/shop/files/sun-2-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/sun-2-3.png",
				"imgSrcF": "/cdn/shop/files/1-8.png",
				"title": "UVShield™ / Red",
				"color": "Red"
			},
			{
				"term_id": 38139,
				"gallery": [
					97213
				],
				"imgSrc": "/cdn/shop/files/sun-2-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/sun-2-4.png",
				"imgSrcF": "/cdn/shop/files/sun-5.png",
				"title": "UVShield™ / Black",
				"color": "Black"
			},
			{
				"term_id": 38145,
				"gallery": [
					97211
				],
				"imgSrc": "/cdn/shop/files/sun-2-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/sun-2-2.png",
				"imgSrcF": "/cdn/shop/files/white.png",
				"title": "UVShield™ / White",
				"color": "White"
			},
			{
				"term_id": 38119,
				"gallery": [
					97215
				],
				"imgSrc": "/cdn/shop/files/sun-2-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/sun-2-6.png",
				"imgSrcF": "/cdn/shop/files/1-11.png",
				"title": "UVShield™ / Hunter Green",
				"color": "Green"
			},
			{
				"term_id": 38106,
				"gallery": [
					97210
				],
				"imgSrc": "/cdn/shop/files/sun-2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/sun-2-1.png",
				"imgSrcF": "/cdn/shop/files/1-7.png",
				"title": "UVShield™ / Royal Blue",
				"color": "Blue"
			},
			{
				"term_id": 38876,
				"gallery": [
					97214
				],
				"imgSrc": "/cdn/shop/files/sun-2-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/sun-2-5.png",
				"imgSrcF": "/cdn/shop/files/grey.png",
				"title": "UVShield™ / Grey",
				"color": "Grey"
			},
			{
				"term_id": 43466,
				"gallery": [
					97217
				],
				"imgSrc": "/cdn/shop/files/sun-2-8-500x500.png",
				"imgSrc_n": "/cdn/shop/files/sun-2-8.png",
				"imgSrcF": "/cdn/shop/files/sun-2-8.png",
				"title": "UVShield™ — All Color",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "sun-shade-sails",
				"name": "Sun Shade Sails"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our UVShield™ sun shade fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your shade sail-buying experience.\r\n\r\nsun shade sail swatches\r\nsun shade fabric swatches\r\nfree shade sail swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\nshade sail for free\r\nfree drapery samples\r\nfree sun shade sails\r\nshade sail samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/sun-2-8-500x500.png",
		"hoverImg": "/cdn/shop/files/sun-2-8-500x500.png",
		"subheading": "Sun Shade Fabric Swatches",
		"Fabrics": [
			"UVShield™"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Red",
			"Black",
			"White",
			"Green",
			"Blue",
			"Grey"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Outdoor"
		],
		"Finished Product": [
			"95071",
			"38094",
			"38183"
		],
		"Sale": "30% Off",
		"salenum": 30,
		"oldPrice": 7,
		"newPrice": 5
	},
	{
		"id": 96824,
		"title": "Mist Patterned Heavyweight Fabric Swatches",
		"ProductUrl": "/swatches/mist-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96825",
		"_fabric_color": [
			{
				"term_id": 64061,
				"gallery": [
					96401
				],
				"imgSrc": "/cdn/shop/files/2406-9-657-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2406-9-657-1.png",
				"imgSrcF": "/cdn/shop/files/sand-4-1.png",
				"title": "Mist / Sand",
				"color": "Beige"
			},
			{
				"term_id": 64062,
				"gallery": [
					96400
				],
				"imgSrc": "/cdn/shop/files/2405-8-657-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2405-8-657-1.png",
				"imgSrcF": "/cdn/shop/files/black-4-1.png",
				"title": "Mist / Black",
				"color": "Black"
			},
			{
				"term_id": 64051,
				"gallery": [
					96398
				],
				"imgSrc": "/cdn/shop/files/2401-10-657-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2401-10-657-1.png",
				"imgSrcF": "/cdn/shop/files/light-grey-3-1.png",
				"title": "Mist / Light Grey",
				"color": "Grey"
			},
			{
				"term_id": 64052,
				"gallery": [
					96399
				],
				"imgSrc": "/cdn/shop/files/2403-7-657-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2403-7-657-1.png",
				"imgSrcF": "/cdn/shop/files/ash-4-1.png",
				"title": "Mist / Ash",
				"color": "Grey"
			},
			{
				"term_id": 96825,
				"gallery": [
					96402
				],
				"imgSrc": "/cdn/shop/files/531388-500x500.png",
				"imgSrc_n": "/cdn/shop/files/531388.png",
				"imgSrcF": "/cdn/shop/files/531388.png",
				"title": "Mist — All Color",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/531388-500x500.png",
		"hoverImg": "/cdn/shop/files/531388-500x500.png",
		"subheading": "Patterned Heavyweight Fabric Swatches",
		"Fabrics": [
			"Mist"
		],
		"Feature": [],
		"Material": [
			"Cotton Blend",
			"Polyester",
			"Cotton",
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Beige",
			"Black",
			"Grey",
			"Grey"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64160",
			"101310"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 4,
		"newPrice": 5
	},
	{
		"id": 96122,
		"title": "Classic Velvet Fabric Swatches",
		"ProductUrl": "/swatches/luxury-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96030",
		"_fabric_color": [
			{
				"term_id": 96094,
				"gallery": [
					96041
				],
				"imgSrc": "/cdn/shop/files/10-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/10-2.png",
				"imgSrcF": "/cdn/shop/files/Black-1.jpg",
				"title": "Classic / Black",
				"color": "Black"
			},
			{
				"term_id": 96108,
				"gallery": [
					96137
				],
				"imgSrc": "/cdn/shop/files/Ivory-White-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Ivory-White-2.png",
				"imgSrcF": "/cdn/shop/files/Ivory-White-1.png",
				"title": "Classic / Ivory White",
				"color": "White"
			},
			{
				"term_id": 96093,
				"gallery": [
					96033
				],
				"imgSrc": "/cdn/shop/files/2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2-1.png",
				"imgSrcF": "/cdn/shop/files/Blush-Beige.jpg",
				"title": "Classic / Blush Beige",
				"color": "Beige"
			},
			{
				"term_id": 96105,
				"gallery": [
					96040
				],
				"imgSrc": "/cdn/shop/files/9-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/9-2.png",
				"imgSrcF": "/cdn/shop/files/Stone-Blue-2.jpg",
				"title": "Classic / Stone Blue",
				"color": "Blue"
			},
			{
				"term_id": 96112,
				"gallery": [
					96045
				],
				"imgSrc": "/cdn/shop/files/14-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/14-2.png",
				"imgSrcF": "/cdn/shop/files/Moss-Green.jpg",
				"title": "Classic / Moss Green",
				"color": "Green"
			},
			{
				"term_id": 96107,
				"gallery": [
					99740
				],
				"imgSrc": "/cdn/shop/files/Silver-Grey-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Silver-Grey.png",
				"imgSrcF": "/cdn/shop/files/Silver-Grey.jpg",
				"title": "Classic / Light Grey",
				"color": "Grey"
			},
			{
				"term_id": 96106,
				"gallery": [
					96038
				],
				"imgSrc": "/cdn/shop/files/7-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/7-2.png",
				"imgSrcF": "/cdn/shop/files/Navy-Blue-2.jpg",
				"title": "Classic / Navy Blue",
				"color": "Blue"
			},
			{
				"term_id": 96109,
				"gallery": [
					99742
				],
				"imgSrc": "/cdn/shop/files/Grey-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Grey-1.png",
				"imgSrcF": "/cdn/shop/files/Grey.jpg",
				"title": "Classic / Grey",
				"color": "Grey"
			},
			{
				"term_id": 96116,
				"gallery": [
					96035
				],
				"imgSrc": "/cdn/shop/files/4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/4-1.png",
				"imgSrcF": "/cdn/shop/files/Warm-Gold.jpg",
				"title": "Classic / Warm Gold",
				"color": "Gold"
			},
			{
				"term_id": 96110,
				"gallery": [
					96032
				],
				"imgSrc": "/cdn/shop/files/1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/1-1.png",
				"imgSrcF": "/cdn/shop/files/Chestnut.jpg",
				"title": "Classic / Chestnut",
				"color": "Brown"
			},
			{
				"term_id": 96115,
				"gallery": [
					96141
				],
				"imgSrc": "/cdn/shop/files/Red-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Red-1.png",
				"imgSrcF": "/cdn/shop/files/Red-2.png",
				"title": "Classic / Red",
				"color": "Red"
			},
			{
				"term_id": 96102,
				"gallery": [
					96052
				],
				"imgSrc": "/cdn/shop/files/21-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/21-1.png",
				"imgSrcF": "/cdn/shop/files/Dark-Green.jpg",
				"title": "Classic / Dark Green",
				"color": "Green"
			},
			{
				"term_id": 96104,
				"gallery": [
					96046
				],
				"imgSrc": "/cdn/shop/files/15-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/15-1.png",
				"imgSrcF": "/cdn/shop/files/Teal-Blue-1.jpg",
				"title": "Classic / Teal",
				"color": "Cyan"
			},
			{
				"term_id": 96114,
				"gallery": [
					96051
				],
				"imgSrc": "/cdn/shop/files/20-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/20-1.png",
				"imgSrcF": "/cdn/shop/files/Burgundy.jpg",
				"title": "Classic / Burgundy",
				"color": "Red"
			},
			{
				"term_id": 99743,
				"gallery": [
					99741
				],
				"imgSrc": "/cdn/shop/files/Taupe-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Taupe.png",
				"imgSrcF": "/cdn/shop/files/Taupe-1.jpg",
				"title": "Classic / Taupe",
				"color": "Red"
			},
			{
				"term_id": 96101,
				"gallery": [
					96047
				],
				"imgSrc": "/cdn/shop/files/16-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/16-1.png",
				"imgSrcF": "/cdn/shop/files/Gold-Brown.jpg",
				"title": "Classic / Gold Brown",
				"color": "Red"
			},
			{
				"term_id": 96121,
				"gallery": [
					96039
				],
				"imgSrc": "/cdn/shop/files/8-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/8-2.png",
				"imgSrcF": "/cdn/shop/files/Wild-Rose.jpg",
				"title": "Classic / Wild Rose",
				"color": "Red"
			},
			{
				"term_id": 96119,
				"gallery": [
					102973
				],
				"imgSrc": "/cdn/shop/files/18-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/18-3.png",
				"imgSrcF": "/cdn/shop/files/Dark-Blue-1.jpg",
				"title": "Classic / Dark Blue",
				"color": "Blue"
			},
			{
				"term_id": 96030,
				"gallery": [
					96053
				],
				"imgSrc": "/cdn/shop/files/Frame-1000006063-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Frame-1000006063.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000006063.png",
				"title": "Classic — All Color",
				"color": "Blue"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "&nbsp;\r\n\r\nVelvet curtains are super soft to touch and can go anywhere in the home. These elegant, luxurious velvet curtain panels will set a perfect relaxation mood of your living room to your bedroom. Velvet curtains impede most light from outside, and they block 70% of harsh sunlight and block the UV light and noise.\r\nVelvet is environmentally friendly and offers a soft and royal look proving the best window outfit. It is a thick conductive accessory to use in the cold seasons. It has an aesthetic value, and it blends in with different decor styles.\r\n\r\nLuxury\r\nVelvet\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
		"imgSrc": "/cdn/shop/files/Frame-1000006063-500x500.png",
		"hoverImg": "/cdn/shop/files/Frame-1000006063-500x500.png",
		"subheading": "Velvet Fabric Swatches",
		"Fabrics": [
			"Classic"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Black",
			"White",
			"Beige",
			"Blue",
			"Green",
			"Grey",
			"Blue",
			"Grey",
			"Gold",
			"Brown",
			"Red",
			"Green",
			"Cyan",
			"Red",
			"Red",
			"Blue"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"1167",
			"53696"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 18,
		"newPrice": 5
	},
	{
		"id": 97320,
		"title": "Jazlynn Linen Pattern Velvet Heavyweight Fabric Swatches",
		"ProductUrl": "/swatches/jazlynn-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "97334",
		"_fabric_color": [
			{
				"term_id": 61677,
				"gallery": [
					97331
				],
				"imgSrc": "/cdn/shop/files/Jazlynn-1-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Jazlynn-1-5.png",
				"imgSrcF": "/cdn/shop/files/Coffee-6.jpg",
				"title": "Jazlynn / Coffee",
				"color": "Brown"
			},
			{
				"term_id": 61947,
				"gallery": [
					97330
				],
				"imgSrc": "/cdn/shop/files/Jazlynn-1-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Jazlynn-1-4.png",
				"imgSrcF": "/cdn/shop/files/ginger-yellow-4.jpg",
				"title": "Jazlynn / Ginger",
				"color": "Gold"
			},
			{
				"term_id": 61948,
				"gallery": [
					97332
				],
				"imgSrc": "/cdn/shop/files/Jazlynn-1-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Jazlynn-1-6.png",
				"imgSrcF": "/cdn/shop/files/Ink-blue-4.jpg",
				"title": "Jazlynn / Ink Blue",
				"color": "Blue"
			},
			{
				"term_id": 61946,
				"gallery": [
					97329
				],
				"imgSrc": "/cdn/shop/files/Jazlynn-1-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Jazlynn-1-3.png",
				"imgSrcF": "/cdn/shop/files/silver-gray-3.jpg",
				"title": "Jazlynn / Silver Gray",
				"color": "Grey"
			},
			{
				"term_id": 61945,
				"gallery": [
					97327
				],
				"imgSrc": "/cdn/shop/files/Jazlynn-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Jazlynn-1-1.png",
				"imgSrcF": "/cdn/shop/files/olive-green-6-1.jpg",
				"title": "Jazlynn / Olive Green",
				"color": "Green"
			},
			{
				"term_id": 61944,
				"gallery": [
					97328
				],
				"imgSrc": "/cdn/shop/files/Jazlynn-1-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Jazlynn-1-2.png",
				"imgSrcF": "/cdn/shop/files/gray-pink-6.jpg",
				"title": "Jazlynn / Dusty Rose",
				"color": "Red"
			},
			{
				"term_id": 97334,
				"gallery": [
					97333
				],
				"imgSrc": "/cdn/shop/files/Jazlynn-1-7-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Jazlynn-1-7.png",
				"imgSrcF": "/cdn/shop/files/Jazlynn-1-7.png",
				"title": "Jazlynn — All Color",
				"color": "Red"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Jazlynn-1-7-500x500.png",
		"hoverImg": "/cdn/shop/files/Jazlynn-1-7-500x500.png",
		"subheading": "Linen Pattern Velvet Heavyweight Fabric Swatches",
		"Fabrics": [
			"Jazlynn"
		],
		"Feature": [],
		"Material": [
			"Velvet"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Brown",
			"Gold",
			"Blue",
			"Grey",
			"Green",
			"Red"
		],
		"Light": [
			"Blackout"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"59223"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 6
	},
	{
		"id": 97307,
		"title": "Voy Linen Look Fabric Swatches",
		"ProductUrl": "/swatches/voy-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "42755",
		"_fabric_color": [
			{
				"term_id": 42755,
				"gallery": [
					97315
				],
				"imgSrc": "/cdn/shop/files/Voy-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Voy-3.png",
				"imgSrcF": "/cdn/shop/files/beige-1.png",
				"title": "Voy / Beige",
				"color": "Beige"
			},
			{
				"term_id": 42757,
				"gallery": [
					97314
				],
				"imgSrc": "/cdn/shop/files/Voy-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Voy-2.png",
				"imgSrcF": "/cdn/shop/files/lightbeige-1.png",
				"title": "Voy / Light Beige",
				"color": "Beige"
			},
			{
				"term_id": 42759,
				"gallery": [
					97313
				],
				"imgSrc": "/cdn/shop/files/Voy-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Voy-1.png",
				"imgSrcF": "/cdn/shop/files/white-3.png",
				"title": "Voy / Pure White",
				"color": "White"
			},
			{
				"term_id": 42761,
				"gallery": [
					97317
				],
				"imgSrc": "/cdn/shop/files/Voy-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Voy-5.png",
				"imgSrcF": "/cdn/shop/files/silvergrey-1.png",
				"title": "Voy / Silver Gray",
				"color": "Grey"
			},
			{
				"term_id": 42763,
				"gallery": [
					97316
				],
				"imgSrc": "/cdn/shop/files/Voy-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Voy-4.png",
				"imgSrcF": "/cdn/shop/files/stoneblue-2.png",
				"title": "Voy / Stone Blue",
				"color": "Blue"
			},
			{
				"term_id": 58329,
				"gallery": [
					97318
				],
				"imgSrc": "/cdn/shop/files/Voy-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Voy-6.png",
				"imgSrcF": "/cdn/shop/files/Voy-6.png",
				"title": "Voy — All Color",
				"color": "Blue"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Voy linen fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/Voy-6-500x500.png",
		"hoverImg": "/cdn/shop/files/Voy-6-500x500.png",
		"subheading": "Linen Look Fabric Swatches",
		"Fabrics": [
			"Voy"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Beige",
			"White",
			"Grey",
			"Blue"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"42644"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1
	},
	{
		"id": 97251,
		"title": "Chloe Linen Blend Burlap Textured Sheer Fabric Swatches",
		"ProductUrl": "/swatches/chloe-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "97261",
		"_fabric_color": [
			{
				"term_id": 58500,
				"gallery": [
					97254
				],
				"imgSrc": "/cdn/shop/files/Chloe-Fabric-Swatches-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Chloe-Fabric-Swatches-3.png",
				"imgSrcF": "/cdn/shop/files/Chloe-3.png",
				"title": "Chloe / Taupe",
				"color": "Beige"
			},
			{
				"term_id": 58498,
				"gallery": [
					97253
				],
				"imgSrc": "/cdn/shop/files/Chloe-Fabric-Swatches-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Chloe-Fabric-Swatches-2.png",
				"imgSrcF": "/cdn/shop/files/Chloe-2.png",
				"title": "Chloe / Brick Red",
				"color": "Red"
			},
			{
				"term_id": 58496,
				"gallery": [
					97252
				],
				"imgSrc": "/cdn/shop/files/Chloe-Fabric-Swatches-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Chloe-Fabric-Swatches-1.png",
				"imgSrcF": "/cdn/shop/files/Chloe-1.png",
				"title": "Chloe / Green",
				"color": "Green"
			},
			{
				"term_id": 58494,
				"gallery": [
					97258
				],
				"imgSrc": "/cdn/shop/files/Chloe-Fabric-Swatches-7-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Chloe-Fabric-Swatches-7.png",
				"imgSrcF": "/cdn/shop/files/Chloe-7.png",
				"title": "Chloe / Brown",
				"color": "Brown"
			},
			{
				"term_id": 58492,
				"gallery": [
					97256
				],
				"imgSrc": "/cdn/shop/files/Chloe-Fabric-Swatches-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Chloe-Fabric-Swatches-5.png",
				"imgSrcF": "/cdn/shop/files/Chloe-5.png",
				"title": "Chloe / Cream",
				"color": "White"
			},
			{
				"term_id": 58490,
				"gallery": [
					97255
				],
				"imgSrc": "/cdn/shop/files/Chloe-Fabric-Swatches-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Chloe-Fabric-Swatches-4.png",
				"imgSrcF": "/cdn/shop/files/Chloe-4.png",
				"title": "Chloe / Light Beige",
				"color": "Beige"
			},
			{
				"term_id": 58488,
				"gallery": [
					97257
				],
				"imgSrc": "/cdn/shop/files/Chloe-Fabric-Swatches-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Chloe-Fabric-Swatches-6.png",
				"imgSrcF": "/cdn/shop/files/Chloe-6.png",
				"title": "Chloe / Stone Blue",
				"color": "Blue"
			},
			{
				"term_id": 97261,
				"gallery": [
					97259
				],
				"imgSrc": "/cdn/shop/files/Chloe-Fabric-Swatches-8-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Chloe-Fabric-Swatches-8.png",
				"imgSrcF": "/cdn/shop/files/Chloe-Fabric-Swatches-8.png",
				"title": "Chloe — All Color",
				"color": "Blue"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Chloe sheer fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/Chloe-Fabric-Swatches-8-500x500.png",
		"hoverImg": "/cdn/shop/files/Chloe-Fabric-Swatches-8-500x500.png",
		"subheading": "Linen Blend Burlap Textured Sheer Fabric Swatches",
		"Fabrics": [
			"Chloe"
		],
		"Feature": [],
		"Material": [
			"Faux Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Red",
			"Green",
			"Brown",
			"White",
			"Beige",
			"Blue"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"58405"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 6
	},
	{
		"id": 97283,
		"title": "Laborien Blackout Thermal Linen Look Textured Fabric Swatches",
		"ProductUrl": "/swatches/laborien-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "1042",
		"_fabric_color": [
			{
				"term_id": 936,
				"gallery": [
					107869
				],
				"imgSrc": "/cdn/shop/files/beige-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/beige-4.png",
				"imgSrcF": "/cdn/shop/files/Laborien-7.png",
				"title": "Laborien / Beige",
				"color": "Beige"
			},
			{
				"term_id": 939,
				"gallery": [
					107872
				],
				"imgSrc": "/cdn/shop/files/greyblue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/greyblue.png",
				"imgSrcF": "/cdn/shop/files/Laborien-5.png",
				"title": "Laborien / Grey-Blue",
				"color": "Blue"
			},
			{
				"term_id": 937,
				"gallery": [
					107873
				],
				"imgSrc": "/cdn/shop/files/lakeblue-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/lakeblue-1.png",
				"imgSrcF": "/cdn/shop/files/Laborien-4.png",
				"title": "Laborien / Lake-Blue",
				"color": "Blue"
			},
			{
				"term_id": 32156,
				"gallery": [
					107870
				],
				"imgSrc": "/cdn/shop/files/coffee-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/coffee-1.png",
				"imgSrcF": "/cdn/shop/files/Laborien-3.png",
				"title": "Laborien / Coffee",
				"color": "Brown"
			},
			{
				"term_id": 39605,
				"gallery": [
					103340
				],
				"imgSrc": "/cdn/shop/files/c02-500x500.png",
				"imgSrc_n": "/cdn/shop/files/c02.png",
				"imgSrcF": "/cdn/shop/files/Labronain-navy-blue.png",
				"title": "Laborien / Navy Blue",
				"color": "Blue"
			},
			{
				"term_id": 940,
				"gallery": [
					107874
				],
				"imgSrc": "/cdn/shop/files/red-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/red-3.png",
				"imgSrcF": "/cdn/shop/files/Laborien-2.png",
				"title": "Laborien / Red",
				"color": "Red"
			},
			{
				"term_id": 109930,
				"gallery": [
					107875
				],
				"imgSrc": "/cdn/shop/files/white-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/white-5.png",
				"imgSrcF": "/cdn/shop/files/Laborien-1.png",
				"title": "Laborien / White",
				"color": "White"
			},
			{
				"term_id": 1042,
				"gallery": [
					97291
				],
				"imgSrc": "/cdn/shop/files/Laborien-Fabric-Swatches-8-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Laborien-Fabric-Swatches-8.png",
				"imgSrcF": "/cdn/shop/files/Laborien-Fabric-Swatches-8.png",
				"title": "Laborien — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Factory products",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Laborien-Fabric-Swatches-8-500x500.png",
		"hoverImg": "/cdn/shop/files/Laborien-Fabric-Swatches-8-500x500.png",
		"subheading": "Blackout Thermal Linen Look Textured Fabric Swatches",
		"Fabrics": [
			"Laborien"
		],
		"Feature": [],
		"Material": [
			"Faux Linen",
			"Polyester",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Blue",
			"Blue",
			"Brown",
			"Blue",
			"Red",
			"White"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"1199",
			"35822"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 7
	},
	{
		"id": 97342,
		"title": "Tehreem Textured Sheer Fabric Swatches",
		"ProductUrl": "/swatches/tehreem-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "97374",
		"_fabric_color": [
			{
				"term_id": 97372,
				"gallery": [
					97353
				],
				"imgSrc": "/cdn/shop/files/Tehreem-11-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Tehreem-11-4.png",
				"imgSrcF": "/cdn/shop/files/Tehreem-4.png",
				"title": "Tehreem / Beige",
				"color": "Beige"
			},
			{
				"term_id": 97369,
				"gallery": [
					97354
				],
				"imgSrc": "/cdn/shop/files/Tehreem-11-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Tehreem-11-5.png",
				"imgSrcF": "/cdn/shop/files/Tehreem-5.png",
				"title": "Tehreem / Dark Blue",
				"color": "Blue"
			},
			{
				"term_id": 97367,
				"gallery": [
					97350
				],
				"imgSrc": "/cdn/shop/files/Tehreem-11-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Tehreem-11-1.png",
				"imgSrcF": "/cdn/shop/files/Tehreem-1.png",
				"title": "Tehreem / Light Beige",
				"color": "Beige"
			},
			{
				"term_id": 97362,
				"gallery": [
					97351
				],
				"imgSrc": "/cdn/shop/files/Tehreem-11-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Tehreem-11-2.png",
				"imgSrcF": "/cdn/shop/files/Tehreem-2.png",
				"title": "Tehreem / White",
				"color": "White"
			},
			{
				"term_id": 97365,
				"gallery": [
					97352
				],
				"imgSrc": "/cdn/shop/files/Tehreem-11-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Tehreem-11-3.png",
				"imgSrcF": "/cdn/shop/files/Tehreem-3.png",
				"title": "Tehreem / Taupe",
				"color": "Beige"
			},
			{
				"term_id": 97360,
				"gallery": [
					97356
				],
				"imgSrc": "/cdn/shop/files/Tehreem-11-7-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Tehreem-11-7.png",
				"imgSrcF": "/cdn/shop/files/Tehreem-7.png",
				"title": "Tehreem / Silver Grey",
				"color": "Grey"
			},
			{
				"term_id": 97358,
				"gallery": [
					97355
				],
				"imgSrc": "/cdn/shop/files/Tehreem-11-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Tehreem-11-6.png",
				"imgSrcF": "/cdn/shop/files/Tehreem-6.png",
				"title": "Tehreem / Stone Blue",
				"color": "Blue"
			},
			{
				"term_id": 97374,
				"gallery": [
					97357
				],
				"imgSrc": "/cdn/shop/files/Tehreem-11-8-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Tehreem-11-8.png",
				"imgSrcF": "/cdn/shop/files/Tehreem-11-8.png",
				"title": "Tehreem — All Color",
				"color": "Blue"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Tehreem-11-8-500x500.png",
		"hoverImg": "/cdn/shop/files/Tehreem-11-8-500x500.png",
		"subheading": "Textured Sheer Fabric Swatches",
		"Fabrics": [
			"Tehreem"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Blue",
			"Beige",
			"White",
			"Beige",
			"Grey",
			"Blue"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"1169"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 7
	},
	{
		"id": 96847,
		"title": "Alpine Wool Blend Sheer Fabric Swatches",
		"ProductUrl": "/swatches/alpine-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96851",
		"_fabric_color": [
			{
				"term_id": 95968,
				"gallery": [
					96850
				],
				"imgSrc": "/cdn/shop/files/FA-FTN250-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FA-FTN250-3.png",
				"imgSrcF": "/cdn/shop/files/Alpine-Oatmeal.png",
				"title": "Alpine / Oatmeal",
				"color": "Beige"
			},
			{
				"term_id": 95965,
				"gallery": [
					96848
				],
				"imgSrc": "/cdn/shop/files/FA-FTN250-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FA-FTN250-1.png",
				"imgSrcF": "/cdn/shop/files/Alpine-White.png",
				"title": "Alpine / White",
				"color": "White"
			},
			{
				"term_id": 96851,
				"gallery": [
					96849
				],
				"imgSrc": "/cdn/shop/files/FA-FTN250-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FA-FTN250-2.png",
				"imgSrcF": "/cdn/shop/files/FA-FTN250-2.png",
				"title": "Alpine — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Alpine wool fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/FA-FTN250-2-500x500.png",
		"hoverImg": "/cdn/shop/files/FA-FTN250-2-500x500.png",
		"subheading": "Wool Blend Sheer Fabric Swatches",
		"Fabrics": [
			"Alpine"
		],
		"Feature": [],
		"Material": [
			"Wool"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"White"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95963"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 2,
		"newPrice": 5
	},
	{
		"id": 96834,
		"title": "Ambient Linen Blend Jacquard Fabric Swatches",
		"ProductUrl": "/swatches/ambient-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95452",
		"_fabric_color": [
			{
				"term_id": 95447,
				"gallery": [
					96503
				],
				"imgSrc": "/cdn/shop/files/FB-CR2304-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-CR2304-1-1.png",
				"imgSrcF": "/cdn/shop/files/White-6.png",
				"title": "Ambient / White",
				"color": "White"
			},
			{
				"term_id": 95453,
				"gallery": [
					96504
				],
				"imgSrc": "/cdn/shop/files/FB-CR2304-2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-CR2304-2-1.png",
				"imgSrcF": "/cdn/shop/files/Silver-1.png",
				"title": "Ambient / Silver",
				"color": "Silver"
			},
			{
				"term_id": 95451,
				"gallery": [
					96506
				],
				"imgSrc": "/cdn/shop/files/FB-CR2304-6-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-CR2304-6-1.png",
				"imgSrcF": "/cdn/shop/files/Moss-1.png",
				"title": "Ambient / Moss",
				"color": "Green"
			},
			{
				"term_id": 95452,
				"gallery": [
					96505
				],
				"imgSrc": "/cdn/shop/files/FB-CR2304-5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-CR2304-5-1.png",
				"imgSrcF": "/cdn/shop/files/Cream-1.png",
				"title": "Ambient / Cream",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/FB-CR2304-6-1-500x500.png",
		"hoverImg": "",
		"subheading": "Linen Blend Jacquard Fabric Swatches",
		"Fabrics": [
			"Ambient"
		],
		"Feature": [],
		"Material": [
			"Faux Linen",
			"Linen",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White",
			"Silver",
			"Green",
			"Beige"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95270",
			"101313"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 103707,
		"title": "Nara Linen Cotton Blend Lightweight Fabric Swatches",
		"ProductUrl": "/product/nara-linen-cotton-blend-lightweight-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "102304",
		"_fabric_color": [
			{
				"term_id": 102306,
				"gallery": [
					103709
				],
				"imgSrc": "/cdn/shop/files/2-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/2-2.png",
				"imgSrcF": "/cdn/shop/files/2-3.png",
				"title": "Nara / White",
				"color": "White"
			},
			{
				"term_id": 102304,
				"gallery": [
					107594
				],
				"imgSrc": "/cdn/shop/files/natural-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/natural-1.png",
				"imgSrcF": "/cdn/shop/files/Natural-2.png",
				"title": "Nara / Natural",
				"color": "White"
			},
			{
				"term_id": 102308,
				"gallery": [
					103710
				],
				"imgSrc": "/cdn/shop/files/17-500x500.png",
				"imgSrc_n": "/cdn/shop/files/17.png",
				"imgSrcF": "/cdn/shop/files/Beige-3-2.png",
				"title": "Nara / Beige",
				"color": "White"
			},
			{
				"term_id": 1102,
				"gallery": [
					107593
				],
				"imgSrc": "/cdn/shop/files/ivory-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ivory.png",
				"imgSrcF": "/cdn/shop/files/ivory-color.png",
				"title": "Nara / Ivory",
				"color": "White"
			},
			{
				"term_id": 107598,
				"gallery": [
					107592
				],
				"imgSrc": "/cdn/shop/files/Frame-16-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Frame-16.png",
				"imgSrcF": "/cdn/shop/files/Frame-16.png",
				"title": "Nara — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Voy linen fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/Frame-16-500x500.png",
		"hoverImg": "/cdn/shop/files/Frame-16-500x500.png",
		"subheading": "Linen Cotton Blend Lightweight Fabric Swatches",
		"Fabrics": [
			"Nara"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White",
			"White",
			"White"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"1222"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1
	},
	{
		"id": 96827,
		"title": "Aspen Wool Blend Sweater Soft Textured Fabric Swatches",
		"ProductUrl": "/swatches/aspen-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96828",
		"_fabric_color": [
			{
				"term_id": 95444,
				"gallery": [
					96412
				],
				"imgSrc": "/cdn/shop/files/fc-cr4501N2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/fc-cr4501N2-1.png",
				"imgSrcF": "/cdn/shop/files/taupe.png",
				"title": "Aspen / Taupe",
				"color": "Brown"
			},
			{
				"term_id": 95445,
				"gallery": [
					96411
				],
				"imgSrc": "/cdn/shop/files/fc-cr4501N1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/fc-cr4501N1-1.png",
				"imgSrcF": "/cdn/shop/files/ashypink.png",
				"title": "Aspen / Ashy PInk",
				"color": "Pink"
			},
			{
				"term_id": 95446,
				"gallery": [
					96413
				],
				"imgSrc": "/cdn/shop/files/fc-cr4501N3-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/fc-cr4501N3-1.png",
				"imgSrcF": "/cdn/shop/files/greengrey.png",
				"title": "Aspen / Green Grey",
				"color": "Grey"
			},
			{
				"term_id": 95448,
				"gallery": [
					96415
				],
				"imgSrc": "/cdn/shop/files/fc-cr4501N5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/fc-cr4501N5-1.png",
				"imgSrcF": "/cdn/shop/files/camel-1.png",
				"title": "Aspen / Camel",
				"color": "Pink"
			},
			{
				"term_id": 95449,
				"gallery": [
					96414
				],
				"imgSrc": "/cdn/shop/files/fc-cr4501N4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/fc-cr4501N4-1.png",
				"imgSrcF": "/cdn/shop/files/moonwalk.png",
				"title": "Aspen / Moonwalk",
				"color": "Grey"
			},
			{
				"term_id": 96828,
				"gallery": [
					96410
				],
				"imgSrc": "/cdn/shop/files/531392-500x500.png",
				"imgSrc_n": "/cdn/shop/files/531392.png",
				"imgSrcF": "/cdn/shop/files/531392.png",
				"title": "Aspen — All Color",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"Fixed Size",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/531392-500x500.png",
		"hoverImg": "/cdn/shop/files/531392-500x500.png",
		"subheading": "Wool Blend Sweater Soft Textured Fabric Swatches",
		"Fabrics": [
			"Aspen"
		],
		"Feature": [],
		"Material": [
			"Cotton",
			"Wool"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Brown",
			"Pink",
			"Grey",
			"Pink",
			"Grey"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95261"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 5,
		"newPrice": 5
	},
	{
		"id": 96843,
		"title": "Chelsea Cotton Blend Geometric Golden Grid Patterned Fabric Swatches",
		"ProductUrl": "/swatches/chelsea-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96844",
		"_fabric_color": [
			{
				"term_id": 95469,
				"gallery": [
					96447
				],
				"imgSrc": "/cdn/shop/files/LB-TR4102-4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR4102-4-1.png",
				"imgSrcF": "/cdn/shop/files/Ivory-1-1.png",
				"title": "Chelsea / Ivory",
				"color": "Beige"
			},
			{
				"term_id": 95470,
				"gallery": [
					96446
				],
				"imgSrc": "/cdn/shop/files/LB-TR4102-3-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR4102-3-1.png",
				"imgSrcF": "/cdn/shop/files/Grid-7.png",
				"title": "Chelsea / Grid",
				"color": "Brown"
			},
			{
				"term_id": 95471,
				"gallery": [
					96445
				],
				"imgSrc": "/cdn/shop/files/LB-TR4102-2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR4102-2-1.png",
				"imgSrcF": "/cdn/shop/files/Circuit-1.png",
				"title": "Chelsea / Circuit",
				"color": "Blue"
			},
			{
				"term_id": 95465,
				"gallery": [
					96444
				],
				"imgSrc": "/cdn/shop/files/LB-TR4102-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR4102-1.png",
				"imgSrcF": "/cdn/shop/files/Grey-1-2.png",
				"title": "Chelsea / Grey",
				"color": "Grey"
			},
			{
				"term_id": 96844,
				"gallery": [
					96448
				],
				"imgSrc": "/cdn/shop/files/LB-TR410-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR410.png",
				"imgSrcF": "/cdn/shop/files/LB-TR410.png",
				"title": "Chelsea — All Color",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "Order FREE Swatches Today. Our Chelsea patterned fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\nChelsea patterned fabric swatches\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/LB-TR410-500x500.png",
		"hoverImg": "/cdn/shop/files/LB-TR410-500x500.png",
		"subheading": "Cotton Blend Geometric Golden Grid Patterned Fabric Swatches",
		"Fabrics": [
			"Chelsea"
		],
		"Feature": [],
		"Material": [
			"Cotton"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Beige",
			"Brown",
			"Blue",
			"Grey"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95280",
			"101372"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 4,
		"newPrice": 5
	},
	{
		"id": 96840,
		"title": "Composer Linen Blend Geometric Patterned Fabric Swatches",
		"ProductUrl": "/swatches/composer-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95463",
		"_fabric_color": [
			{
				"term_id": 95463,
				"gallery": [
					96497
				],
				"imgSrc": "/cdn/shop/files/FB-CR3204-4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-CR3204-4-1.png",
				"imgSrcF": "/cdn/shop/files/Black-Green.png",
				"title": "Composer / Black Green",
				"color": "Green"
			},
			{
				"term_id": 95454,
				"gallery": [
					96496
				],
				"imgSrc": "/cdn/shop/files/FB-CR3204-3-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-CR3204-3-1.png",
				"imgSrcF": "/cdn/shop/files/Black-Grey.png",
				"title": "Composer / Black Grey",
				"color": "Grey"
			},
			{
				"term_id": 95455,
				"gallery": [
					96495
				],
				"imgSrc": "/cdn/shop/files/FB-CR3204-2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-CR3204-2-1.png",
				"imgSrcF": "/cdn/shop/files/Silver-Grey.png",
				"title": "Composer / Silver Grey",
				"color": "Grey"
			},
			{
				"term_id": 95456,
				"gallery": [
					96494
				],
				"imgSrc": "/cdn/shop/files/FB-CR3204-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-CR3204-1-1.png",
				"imgSrcF": "/cdn/shop/files/lit.png",
				"title": "Composer / lit",
				"color": "Beige"
			},
			{
				"term_id": 95464,
				"gallery": [
					96498
				],
				"imgSrc": "/cdn/shop/files/FB-CR3204-5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-CR3204-5-1.png",
				"imgSrcF": "/cdn/shop/files/FB-CR3204-5.png",
				"title": "Composer / Orange Green",
				"color": "Orange"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/FB-CR3204-4-1-500x500.png",
		"hoverImg": "",
		"subheading": "Linen Blend Geometric Patterned Fabric Swatches",
		"Fabrics": [
			"Composer"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Wool"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Green",
			"Grey",
			"Grey",
			"Beige",
			"Orange"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95263"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 97003,
		"title": "Flora Velvet Emboidered Floral Pattern Fabric Swatches",
		"ProductUrl": "/swatches/flora-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "97004",
		"_fabric_color": [
			{
				"term_id": 95559,
				"gallery": [
					96627
				],
				"imgSrc": "/cdn/shop/files/BE-1806-5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BE-1806-5-1.png",
				"imgSrcF": "/cdn/shop/files/BE-1806-5-2.png",
				"title": "Flora / Black",
				"color": "Black"
			},
			{
				"term_id": 95560,
				"gallery": [
					96626
				],
				"imgSrc": "/cdn/shop/files/BE-1806-4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BE-1806-4-1.png",
				"imgSrcF": "/cdn/shop/files/BE-1806-4-2.png",
				"title": "Flora / Blue",
				"color": "Blue"
			},
			{
				"term_id": 95561,
				"gallery": [
					96625
				],
				"imgSrc": "/cdn/shop/files/BE-1806-3-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BE-1806-3-1.png",
				"imgSrcF": "/cdn/shop/files/BE-1806-3-2.png",
				"title": "Flora / Grey",
				"color": "Grey"
			},
			{
				"term_id": 95562,
				"gallery": [
					96624
				],
				"imgSrc": "/cdn/shop/files/BE-1806-2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BE-1806-2-1.png",
				"imgSrcF": "/cdn/shop/files/BE-1806-2-2.png",
				"title": "Flora / Light Taupe",
				"color": "Beige"
			},
			{
				"term_id": 95550,
				"gallery": [
					96623
				],
				"imgSrc": "/cdn/shop/files/BE-1806-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BE-1806-1-1.png",
				"imgSrcF": "/cdn/shop/files/BE-1806-1-2.png",
				"title": "Flora / Beige",
				"color": "Beige"
			},
			{
				"term_id": 97004,
				"gallery": [
					96622
				],
				"imgSrc": "/cdn/shop/files/531380-500x500.png",
				"imgSrc_n": "/cdn/shop/files/531380.png",
				"imgSrcF": "/cdn/shop/files/531380.png",
				"title": "Flora — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Flora velvet fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/531380-500x500.png",
		"hoverImg": "/cdn/shop/files/531380-500x500.png",
		"subheading": "Velvet Emboidered Floral Pattern Fabric Swatches",
		"Fabrics": [
			"Flora"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Black",
			"Blue",
			"Grey",
			"Beige",
			"Beige"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95288"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 5,
		"newPrice": 5
	},
	{
		"id": 96918,
		"title": "Impression Foil Printed Velvet Patterned Fabric Swatches",
		"ProductUrl": "/swatches/impression-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95490",
		"_fabric_color": [
			{
				"term_id": 95482,
				"gallery": [
					96601
				],
				"imgSrc": "/cdn/shop/files/BF-577-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-577-1-1.png",
				"imgSrcF": "/cdn/shop/files/BF-577-1.png",
				"title": "Impression / Cream",
				"color": "White"
			},
			{
				"term_id": 95477,
				"gallery": [
					96606
				],
				"imgSrc": "/cdn/shop/files/BF-577-6-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-577-6-1.png",
				"imgSrcF": "/cdn/shop/files/BF-577-6-2.png",
				"title": "Impression / Gold",
				"color": "Gold"
			},
			{
				"term_id": 95478,
				"gallery": [
					96605
				],
				"imgSrc": "/cdn/shop/files/BF-577-5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-577-5-1.png",
				"imgSrcF": "/cdn/shop/files/BF-577-5-2.png",
				"title": "Impression / Pink",
				"color": "Pink"
			},
			{
				"term_id": 95479,
				"gallery": [
					96604
				],
				"imgSrc": "/cdn/shop/files/BF-577-4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-577-4-1.png",
				"imgSrcF": "/cdn/shop/files/BF-577-4-2.png",
				"title": "Impression / Blue",
				"color": "Blue"
			},
			{
				"term_id": 95480,
				"gallery": [
					96603
				],
				"imgSrc": "/cdn/shop/files/BF-577-3-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-577-3-1.png",
				"imgSrcF": "/cdn/shop/files/BF-577-3-2.png",
				"title": "Impression / Grey Blue",
				"color": "Blue"
			},
			{
				"term_id": 95481,
				"gallery": [
					96602
				],
				"imgSrc": "/cdn/shop/files/BF-577-2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-577-2-1.png",
				"imgSrcF": "/cdn/shop/files/BF-577-2-2.png",
				"title": "Impression / Lit",
				"color": "Beige"
			},
			{
				"term_id": 95490,
				"gallery": [
					96608
				],
				"imgSrc": "/cdn/shop/files/BF-577-8-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-577-8-1.png",
				"imgSrcF": "/cdn/shop/files/BF-577-8-2.png",
				"title": "Impression / Black",
				"color": "Black"
			},
			{
				"term_id": 95491,
				"gallery": [
					96607
				],
				"imgSrc": "/cdn/shop/files/BF-577-7-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-577-7-1.png",
				"imgSrcF": "/cdn/shop/files/BF-577-7-2.png",
				"title": "Impression / Teal",
				"color": "Green"
			},
			{
				"term_id": 96919,
				"gallery": [
					96600
				],
				"imgSrc": "/cdn/shop/files/531367-500x500.png",
				"imgSrc_n": "/cdn/shop/files/531367.png",
				"imgSrcF": "/cdn/shop/files/531367.png",
				"title": "Impression — All Color",
				"color": "Green"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Impression velvet fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/531367-500x500.png",
		"hoverImg": "/cdn/shop/files/531367-500x500.png",
		"subheading": "Foil Printed Velvet Patterned Fabric Swatches",
		"Fabrics": [
			"Impression"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White",
			"Gold",
			"Pink",
			"Blue",
			"Blue",
			"Beige",
			"Black",
			"Green"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95285"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 96838,
		"title": "Ivy Linen Look Heavyweight Herringbone Textured Fabric Swatches",
		"ProductUrl": "/swatches/ivy-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96835",
		"_fabric_color": [
			{
				"term_id": 95460,
				"gallery": [
					96436
				],
				"imgSrc": "/cdn/shop/files/LB-TR4604X-7-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR4604X-7-1.png",
				"imgSrcF": "/cdn/shop/files/oatmeal-1.png",
				"title": "Ivy / Oatmeal",
				"color": "Beige"
			},
			{
				"term_id": 95450,
				"gallery": [
					96439
				],
				"imgSrc": "/cdn/shop/files/LB-TR4604X-10-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR4604X-10-1.png",
				"imgSrcF": "/cdn/shop/files/moss-8.png",
				"title": "Ivy / Moss",
				"color": "Green"
			},
			{
				"term_id": 95457,
				"gallery": [
					96431
				],
				"imgSrc": "/cdn/shop/files/LB-TR4604X-2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR4604X-2-1.png",
				"imgSrcF": "/cdn/shop/files/black-5.png",
				"title": "Ivy / Black",
				"color": "Black"
			},
			{
				"term_id": 95458,
				"gallery": [
					96432
				],
				"imgSrc": "/cdn/shop/files/LB-TR4604X-3-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR4604X-3-1.png",
				"imgSrcF": "/cdn/shop/files/stone.png",
				"title": "Ivy / Stone",
				"color": "Grey"
			},
			{
				"term_id": 95459,
				"gallery": [
					96434
				],
				"imgSrc": "/cdn/shop/files/LB-TR4604X-5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR4604X-5-1.png",
				"imgSrcF": "/cdn/shop/files/brown.png",
				"title": "Ivy / Brown",
				"color": "Brown"
			},
			{
				"term_id": 95461,
				"gallery": [
					96437
				],
				"imgSrc": "/cdn/shop/files/LB-TR4604X-8-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR4604X-8-1.png",
				"imgSrcF": "/cdn/shop/files/ivory-3.png",
				"title": "Ivy / Ivory",
				"color": "White"
			},
			{
				"term_id": 95462,
				"gallery": [
					96438
				],
				"imgSrc": "/cdn/shop/files/LB-TR4604X-9-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR4604X-9-1.png",
				"imgSrcF": "/cdn/shop/files/maldives.jpg",
				"title": "Ivy / Maldives",
				"color": "Green"
			},
			{
				"term_id": 96835,
				"gallery": [
					96449
				],
				"imgSrc": "/cdn/shop/files/LB-TR4604X-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LB-TR4604X.png",
				"imgSrcF": "/cdn/shop/files/LB-TR4604X.png",
				"title": "Ivy — All Color",
				"color": "Green"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/LB-TR4604X-500x500.png",
		"hoverImg": "/cdn/shop/files/LB-TR4604X-500x500.png",
		"subheading": "Linen Look Heavyweight Herringbone Textured Fabric Swatches",
		"Fabrics": [
			"Ivy"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Green",
			"Black",
			"Grey",
			"Brown",
			"White",
			"Green"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95271"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 10,
		"newPrice": 5
	},
	{
		"id": 103695,
		"title": "Traunsee Cotton Blend Textured Fabric Swatches",
		"ProductUrl": "/product/traunsee-cotton-blend-textured-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "0",
		"_fabric_color": [
			{
				"term_id": 1120,
				"gallery": [
					103696
				],
				"imgSrc": "/cdn/shop/files/1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/1-1.png",
				"imgSrcF": "/cdn/shop/files/16.jpg",
				"title": "Traunsee / White",
				"color": "White"
			},
			{
				"term_id": 104576,
				"gallery": [
					107603
				],
				"imgSrc": "/cdn/shop/files/denim-blue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/denim-blue.png",
				"imgSrcF": "/cdn/shop/files/31.jpg",
				"title": "Traunsee / Denim Blue",
				"color": "White"
			},
			{
				"term_id": 104574,
				"gallery": [
					107601
				],
				"imgSrc": "/cdn/shop/files/cappuccino-500x500.png",
				"imgSrc_n": "/cdn/shop/files/cappuccino.png",
				"imgSrcF": "/cdn/shop/files/Cappuccino-3.jpg",
				"title": "Traunsee / Cappuccino",
				"color": "White"
			},
			{
				"term_id": 104572,
				"gallery": [
					107602
				],
				"imgSrc": "/cdn/shop/files/darkgrey-500x500.png",
				"imgSrc_n": "/cdn/shop/files/darkgrey.png",
				"imgSrcF": "/cdn/shop/files/22.jpg",
				"title": "Traunsee / Dark Grey",
				"color": "White"
			},
			{
				"term_id": 104570,
				"gallery": [
					107606
				],
				"imgSrc": "/cdn/shop/files/grey-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/grey-1.png",
				"imgSrcF": "/cdn/shop/files/20.jpg",
				"title": "Traunsee / Grey",
				"color": "White"
			},
			{
				"term_id": 104568,
				"gallery": [
					107605
				],
				"imgSrc": "/cdn/shop/files/green-500x500.png",
				"imgSrc_n": "/cdn/shop/files/green.png",
				"imgSrcF": "/cdn/shop/files/green-3.jpg",
				"title": "Traunsee / Green",
				"color": "White"
			},
			{
				"term_id": 104566,
				"gallery": [
					107608
				],
				"imgSrc": "/cdn/shop/files/sand-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/sand-1.png",
				"imgSrcF": "/cdn/shop/files/30.jpg",
				"title": "Traunsee / Sand",
				"color": "White"
			},
			{
				"term_id": 104564,
				"gallery": [
					107609
				],
				"imgSrc": "/cdn/shop/files/silvergrey-500x500.png",
				"imgSrc_n": "/cdn/shop/files/silvergrey.png",
				"imgSrcF": "/cdn/shop/files/3-3.jpg",
				"title": "Traunsee / Silver Grey",
				"color": "White"
			},
			{
				"term_id": 104562,
				"gallery": [
					107607
				],
				"imgSrc": "/cdn/shop/files/ivory-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ivory-1.png",
				"imgSrcF": "/cdn/shop/files/1-2.jpg",
				"title": "Traunsee / Ivory",
				"color": "White"
			},
			{
				"term_id": 107623,
				"gallery": [
					107604
				],
				"imgSrc": "/cdn/shop/files/Frame-1000006066-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Frame-1000006066.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000006066.png",
				"title": "Traunsee — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Voy linen fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/Frame-1000006066-500x500.png",
		"hoverImg": "/cdn/shop/files/Frame-1000006066-500x500.png",
		"subheading": "Cotton Blend Textured Fabric Swatches",
		"Fabrics": [
			"Traunsee"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"1238"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1
	},
	{
		"id": 96862,
		"title": "Lana Cotton Blend Lightweight Textured Fabric Swatches",
		"ProductUrl": "/swatches/lana-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95475",
		"_fabric_color": [
			{
				"term_id": 95475,
				"gallery": [
					96459
				],
				"imgSrc": "/cdn/shop/files/LA-TR4802X1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LA-TR4802X1-1.png",
				"imgSrcF": "/cdn/shop/files/Pink-8.png",
				"title": "Lana / Pink",
				"color": "Pink"
			},
			{
				"term_id": 95474,
				"gallery": [
					96465
				],
				"imgSrc": "/cdn/shop/files/LA-TR4802X7-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LA-TR4802X7-1.png",
				"imgSrcF": "/cdn/shop/files/Ivory-3-1.png",
				"title": "Lana / Ivory",
				"color": "White"
			},
			{
				"term_id": 95472,
				"gallery": [
					96463
				],
				"imgSrc": "/cdn/shop/files/LA-TR4802X5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LA-TR4802X5-1.png",
				"imgSrcF": "/cdn/shop/files/brown-3-1.png",
				"title": "Lana / Brown",
				"color": "Brown"
			},
			{
				"term_id": 95473,
				"gallery": [
					96462
				],
				"imgSrc": "/cdn/shop/files/LA-TR4802X4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LA-TR4802X4-1.png",
				"imgSrcF": "/cdn/shop/files/Oatmeal-3-1.png",
				"title": "Lana / Oatmeal",
				"color": "Beige"
			},
			{
				"term_id": 95476,
				"gallery": [
					96466
				],
				"imgSrc": "/cdn/shop/files/LA-TR4802X8-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LA-TR4802X8-1.png",
				"imgSrcF": "/cdn/shop/files/Moss-1-1.png",
				"title": "Lana / Moss",
				"color": "Green"
			},
			{
				"term_id": 95483,
				"gallery": [
					96461
				],
				"imgSrc": "/cdn/shop/files/LA-TR4802X3-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LA-TR4802X3-1.png",
				"imgSrcF": "/cdn/shop/files/stone-3-8.png",
				"title": "Lana / Stone",
				"color": "Grey"
			},
			{
				"term_id": 95484,
				"gallery": [
					96460
				],
				"imgSrc": "/cdn/shop/files/LA-TR4802X2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LA-TR4802X2-1.png",
				"imgSrcF": "/cdn/shop/files/grey-3-1.png",
				"title": "Lana / Grey",
				"color": "Grey"
			},
			{
				"term_id": 95485,
				"gallery": [
					96464
				],
				"imgSrc": "/cdn/shop/files/LA-TR4802X6-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/LA-TR4802X6-1.png",
				"imgSrcF": "/cdn/shop/files/Beige.png",
				"title": "Lana / Beige",
				"color": "Beige"
			},
			{
				"term_id": 96864,
				"gallery": [
					96458
				],
				"imgSrc": "/cdn/shop/files/531391-500x500.png",
				"imgSrc_n": "/cdn/shop/files/531391.png",
				"imgSrcF": "/cdn/shop/files/531391.png",
				"title": "Lana — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Lana cotton fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/531391-500x500.png",
		"hoverImg": "/cdn/shop/files/531391-500x500.png",
		"subheading": "Cotton Blend Lightweight Textured Fabric Swatches",
		"Fabrics": [
			"Lana"
		],
		"Feature": [],
		"Material": [
			"Cotton"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Pink",
			"White",
			"Brown",
			"Beige",
			"Green",
			"Grey",
			"Grey",
			"Beige"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95283"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 96854,
		"title": "Manhattan Linen Blend Grid Fabric Swatches",
		"ProductUrl": "/swatches/manhattan-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96856",
		"_fabric_color": [
			{
				"term_id": 95972,
				"gallery": [
					96819
				],
				"imgSrc": "/cdn/shop/files/FB-QM0104-10-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-QM0104-10.png",
				"imgSrcF": "/cdn/shop/files/Manhattan-Black-Gold-1.png",
				"title": "Manhattan / Black Gold",
				"color": "Black"
			},
			{
				"term_id": 95970,
				"gallery": [
					96818
				],
				"imgSrc": "/cdn/shop/files/FB-QM0104-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-QM0104-6.png",
				"imgSrcF": "/cdn/shop/files/Manhattan-White-Gold-1.png",
				"title": "Manhattan / White Gold",
				"color": "White"
			},
			{
				"term_id": 96856,
				"gallery": [
					96817
				],
				"imgSrc": "/cdn/shop/files/FB-QM0104-12-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-QM0104-12.png",
				"imgSrcF": "/cdn/shop/files/FB-QM0104-12.png",
				"title": "Manhattan — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "sdasdadadasdasdasd",
		"imgSrc": "/cdn/shop/files/FB-QM0104-12-500x500.png",
		"hoverImg": "/cdn/shop/files/FB-QM0104-12-500x500.png",
		"subheading": "Linen Blend Grid Fabric Swatches",
		"Fabrics": [
			"Manhattan"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Black",
			"White"
		],
		"Light": [
			"Sheer"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95964"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 2,
		"newPrice": 5
	},
	{
		"id": 96839,
		"title": "Meteor Linen Blend Heavyweight Striped Textured Fabric Swatches",
		"ProductUrl": "/swatches/meteor-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95639",
		"_fabric_color": [
			{
				"term_id": 95637,
				"gallery": [
					96475
				],
				"imgSrc": "/cdn/shop/files/FE-CR1104-2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FE-CR1104-2-1.png",
				"imgSrcF": "/cdn/shop/files/Oatmeal.png",
				"title": "Meteor / Oatmeal",
				"color": "Beige"
			},
			{
				"term_id": 95638,
				"gallery": [
					96474
				],
				"imgSrc": "/cdn/shop/files/FE-CR1104-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FE-CR1104-1-1.png",
				"imgSrcF": "/cdn/shop/files/Cream.png",
				"title": "Meteor / Cream",
				"color": "White"
			},
			{
				"term_id": 95639,
				"gallery": [
					96473
				],
				"imgSrc": "/cdn/shop/files/FE-CR1104-6-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FE-CR1104-6-1.png",
				"imgSrcF": "/cdn/shop/files/Silver-Grey-1.png",
				"title": "Meteor / Silver Grey",
				"color": "Grey"
			},
			{
				"term_id": 95640,
				"gallery": [
					96478
				],
				"imgSrc": "/cdn/shop/files/FE-CR1104-5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FE-CR1104-5-1.png",
				"imgSrcF": "/cdn/shop/files/Sesame.png",
				"title": "Meteor / Sesame",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/FE-CR1104-5-1-500x500.png",
		"hoverImg": "",
		"subheading": "Linen Blend Heavyweight Striped Textured Fabric Swatches",
		"Fabrics": [
			"Meteor"
		],
		"Feature": [],
		"Material": [
			"Faux Linen",
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"White",
			"Grey",
			"Grey"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95272",
			"101364"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 97006,
		"title": "Mirage Foil Printed Velvet Patterned Fabric Swatches",
		"ProductUrl": "/swatches/mirage-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "95564",
		"_fabric_color": [
			{
				"term_id": 95563,
				"gallery": [
					96578
				],
				"imgSrc": "/cdn/shop/files/BF-A06-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A06-1-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A06-1-2.png",
				"title": "Mirage / Cream",
				"color": "White"
			},
			{
				"term_id": 95564,
				"gallery": [
					96580
				],
				"imgSrc": "/cdn/shop/files/BF-A06-3-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A06-3-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A06-3-2.png",
				"title": "Mirage / Gold",
				"color": "Gold"
			},
			{
				"term_id": 95565,
				"gallery": [
					96579
				],
				"imgSrc": "/cdn/shop/files/BF-A06-2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A06-2-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A06-2-2.png",
				"title": "Mirage / Champagne",
				"color": "Gold"
			},
			{
				"term_id": 95566,
				"gallery": [
					96581
				],
				"imgSrc": "/cdn/shop/files/BF-A06-4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A06-4-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A06-4-2.png",
				"title": "Mirage / Silver",
				"color": "Silver"
			},
			{
				"term_id": 95568,
				"gallery": [
					96583
				],
				"imgSrc": "/cdn/shop/files/BF-A06-6-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A06-6-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A06-6-2.png",
				"title": "Mirage / Teal",
				"color": "Green"
			},
			{
				"term_id": 95569,
				"gallery": [
					96582
				],
				"imgSrc": "/cdn/shop/files/BF-A06-5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A06-5-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A06-5-2.png",
				"title": "Mirage / Blue",
				"color": "Blue"
			},
			{
				"term_id": 95567,
				"gallery": [
					96584
				],
				"imgSrc": "/cdn/shop/files/BF-A06-7-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A06-7-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A06-7-2.png",
				"title": "Mirage / Black",
				"color": "Black"
			},
			{
				"term_id": 97007,
				"gallery": [
					96577
				],
				"imgSrc": "/cdn/shop/files/531385-500x500.png",
				"imgSrc_n": "/cdn/shop/files/531385.png",
				"imgSrcF": "/cdn/shop/files/531385.png",
				"title": "Mirage — All Color",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/531385-500x500.png",
		"hoverImg": "/cdn/shop/files/531385-500x500.png",
		"subheading": "Foil Printed Velvet Patterned Fabric Swatches",
		"Fabrics": [
			"Mirage"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White",
			"Gold",
			"Gold",
			"Silver",
			"Green",
			"Blue",
			"Black"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95287"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 97231,
		"title": "FadeShield Pro™ Canvas Fade-Resistant &#038; Waterproof Lightweight Fabric Swatches",
		"ProductUrl": "/swatches/fadeshield-pro-canvas-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "45843",
		"_fabric_color": [
			{
				"term_id": 45882,
				"gallery": [
					97234
				],
				"imgSrc": "/cdn/shop/files/45244-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-3.png",
				"imgSrcF": "/cdn/shop/files/Caramel-3.jpg",
				"title": "FadeShield Pro™/ Caramel",
				"color": "Brown"
			},
			{
				"term_id": 45894,
				"gallery": [
					97239
				],
				"imgSrc": "/cdn/shop/files/45244-8-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-8.png",
				"imgSrcF": "/cdn/shop/files/Prussian-Blue.jpg",
				"title": "FadeShield Pro™ / Prussian Blue",
				"color": "Blue"
			},
			{
				"term_id": 45892,
				"gallery": [
					97244
				],
				"imgSrc": "/cdn/shop/files/45244-13-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-13.png",
				"imgSrcF": "/cdn/shop/files/Cerulean.jpg",
				"title": "FadeShield Pro™ / Cerulean",
				"color": "Blue"
			},
			{
				"term_id": 45890,
				"gallery": [
					97241
				],
				"imgSrc": "/cdn/shop/files/45244-10-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-10.png",
				"imgSrcF": "/cdn/shop/files/Forest-Green.jpg",
				"title": "FadeShield Pro™ / Forest Green",
				"color": "Green"
			},
			{
				"term_id": 45888,
				"gallery": [
					97236
				],
				"imgSrc": "/cdn/shop/files/45244-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-5.png",
				"imgSrcF": "/cdn/shop/files/Matcha-Tea.jpg",
				"title": "FadeShield Pro™ / Matcha Tea",
				"color": "Green"
			},
			{
				"term_id": 45886,
				"gallery": [
					97240
				],
				"imgSrc": "/cdn/shop/files/45244-9-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-9.png",
				"imgSrcF": "/cdn/shop/files/Chocolate.jpg",
				"title": "FadeShield Pro™ / Chocolate",
				"color": "Brown"
			},
			{
				"term_id": 45884,
				"gallery": [
					97233
				],
				"imgSrc": "/cdn/shop/files/45244-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-2.png",
				"imgSrcF": "/cdn/shop/files/Berry.jpg",
				"title": "FadeShield Pro™ / Berry",
				"color": "Red"
			},
			{
				"term_id": 45880,
				"gallery": [
					97237
				],
				"imgSrc": "/cdn/shop/files/45244-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-6.png",
				"imgSrcF": "/cdn/shop/files/Pumpkin.jpg",
				"title": "FadeShield Pro™ / Pumpkin",
				"color": "Orange"
			},
			{
				"term_id": 45878,
				"gallery": [
					97232
				],
				"imgSrc": "/cdn/shop/files/45244-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-1.png",
				"imgSrcF": "/cdn/shop/files/Honey-Yellow.jpg",
				"title": "FadeShield Pro™ / Honey Yellow",
				"color": "Yellow"
			},
			{
				"term_id": 45876,
				"gallery": [
					97243
				],
				"imgSrc": "/cdn/shop/files/45244-12-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-12.png",
				"imgSrcF": "/cdn/shop/files/Charcoal-Grey.jpg",
				"title": "FadeShield Pro™ / Charcoal Grey",
				"color": "Grey"
			},
			{
				"term_id": 45872,
				"gallery": [
					97242
				],
				"imgSrc": "/cdn/shop/files/45244-11-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-11.png",
				"imgSrcF": "/cdn/shop/files/Tree-Bark.jpg",
				"title": "FadeShield Pro™ / Tree Bark",
				"color": "Grey"
			},
			{
				"term_id": 45843,
				"gallery": [
					97235
				],
				"imgSrc": "/cdn/shop/files/45244-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-4.png",
				"imgSrcF": "/cdn/shop/files/Koala-Gray.jpg",
				"title": "FadeShield Pro™ / Koala Grey",
				"color": "Grey"
			},
			{
				"term_id": 46779,
				"gallery": [
					97238
				],
				"imgSrc": "/cdn/shop/files/45244-7-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-7.png",
				"imgSrcF": "/cdn/shop/files/Apple-Red.jpg",
				"title": "FadeShield Pro™ / Apple Red",
				"color": "Red"
			},
			{
				"term_id": 46774,
				"gallery": [
					97245
				],
				"imgSrc": "/cdn/shop/files/45244-14-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-14.png",
				"imgSrcF": "/cdn/shop/files/Midnight-Black.jpg",
				"title": "FadeShield Pro™ / Midnight Black",
				"color": "Black"
			},
			{
				"term_id": 97248,
				"gallery": [
					97246
				],
				"imgSrc": "/cdn/shop/files/45244-15-500x500.png",
				"imgSrc_n": "/cdn/shop/files/45244-15.png",
				"imgSrcF": "/cdn/shop/files/45244-15.png",
				"title": "FadeShield Pro™ — All Color",
				"color": "Black"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our FadeShield Pro™ canvas fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/45244-15-500x500.png",
		"hoverImg": "/cdn/shop/files/45244-15-500x500.png",
		"subheading": "Canvas Fade-Resistant & Waterproof Lightweight Fabric Swatches",
		"Fabrics": [
			"FadeShield Pro™"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Canvas",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Brown",
			"Blue",
			"Blue",
			"Green",
			"Green",
			"Brown",
			"Red",
			"Orange",
			"Yellow",
			"Grey",
			"Grey",
			"Grey",
			"Red",
			"Black"
		],
		"Light": [
			"Blackout"
		],
		"Hanging": [],
		"Space": [
			"Outdoor"
		],
		"Finished Product": [
			"45244",
			"98931"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1
	},
	{
		"id": 96841,
		"title": "Savannah Linen Blend Heavyweight Floral Patterned Fabric Swatches",
		"ProductUrl": "/swatches/savannah-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "98488",
		"_fabric_color": [
			{
				"term_id": 95466,
				"gallery": [
					96488
				],
				"imgSrc": "/cdn/shop/files/FB-QM0104-5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-QM0104-5-1.png",
				"imgSrcF": "/cdn/shop/files/Monochrome-1.png",
				"title": "Savannah / Monochrome",
				"color": "White"
			},
			{
				"term_id": 95467,
				"gallery": [
					96484
				],
				"imgSrc": "/cdn/shop/files/FB-QM0104-4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-QM0104-4-1.png",
				"imgSrcF": "/cdn/shop/files/Camouflage-11.png",
				"title": "Savannah / Camouflage",
				"color": "Green"
			},
			{
				"term_id": 95468,
				"gallery": [
					96485
				],
				"imgSrc": "/cdn/shop/files/FB-QM0104-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-QM0104-1-1.png",
				"imgSrcF": "/cdn/shop/files/Desert.png",
				"title": "Savannah / Desert",
				"color": "Beige"
			},
			{
				"term_id": 98488,
				"gallery": [
					98489
				],
				"imgSrc": "/cdn/shop/files/FB-QM0104-17-500x500.png",
				"imgSrc_n": "/cdn/shop/files/FB-QM0104-17.png",
				"imgSrcF": "/cdn/shop/files/FB-QM0104-17.png",
				"title": "Savannah — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/FB-QM0104-17-500x500.png",
		"hoverImg": "/cdn/shop/files/FB-QM0104-17-500x500.png",
		"subheading": "Linen Blend Heavyweight Floral Patterned Fabric Swatches",
		"Fabrics": [
			"Savannah"
		],
		"Feature": [],
		"Material": [
			"Linen",
			"Wool"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"White",
			"Green",
			"Beige",
			"White"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95262"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 3,
		"newPrice": 5
	},
	{
		"id": 97013,
		"title": "Tuscany Foil Printed Velvet Floral Patterned Fabric Swatches",
		"ProductUrl": "/swatches/tuscany-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "97010",
		"_fabric_color": [
			{
				"term_id": 95988,
				"gallery": [
					96519
				],
				"imgSrc": "/cdn/shop/files/BF769-6-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF769-6-1.png",
				"imgSrcF": "/cdn/shop/files/BF769-6.png",
				"title": "Tuscany / Teal",
				"color": "Green"
			},
			{
				"term_id": 95986,
				"gallery": [
					96518
				],
				"imgSrc": "/cdn/shop/files/BF769-5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF769-5-1.png",
				"imgSrcF": "/cdn/shop/files/BF769-5.png",
				"title": "Tuscany / Blue",
				"color": "Blue"
			},
			{
				"term_id": 95984,
				"gallery": [
					96517
				],
				"imgSrc": "/cdn/shop/files/BF769-4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF769-4-1.png",
				"imgSrcF": "/cdn/shop/files/BF769-4.png",
				"title": "Tuscany / Red",
				"color": "Red"
			},
			{
				"term_id": 95982,
				"gallery": [
					96516
				],
				"imgSrc": "/cdn/shop/files/BF769-3-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF769-3-1.png",
				"imgSrcF": "/cdn/shop/files/BF769-3.png",
				"title": "Tuscany / Gold",
				"color": "Gold"
			},
			{
				"term_id": 95980,
				"gallery": [
					96515
				],
				"imgSrc": "/cdn/shop/files/BF769-2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF769-2-1.png",
				"imgSrcF": "/cdn/shop/files/BF769-2.png",
				"title": "Tuscany / Mustard",
				"color": "Gold"
			},
			{
				"term_id": 95978,
				"gallery": [
					96514
				],
				"imgSrc": "/cdn/shop/files/BF769-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF769-1-1.png",
				"imgSrcF": "/cdn/shop/files/BF769-1.png",
				"title": "Tuscany / Ivory",
				"color": "White"
			},
			{
				"term_id": 97010,
				"gallery": [
					96513
				],
				"imgSrc": "/cdn/shop/files/531372-500x500.png",
				"imgSrc_n": "/cdn/shop/files/531372.png",
				"imgSrcF": "/cdn/shop/files/531372.png",
				"title": "Tuscany — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Tuscany velvet fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/531372-500x500.png",
		"hoverImg": "/cdn/shop/files/531372-500x500.png",
		"subheading": "Foil Printed Velvet Floral Patterned Fabric Swatches",
		"Fabrics": [
			"Tuscany"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Green",
			"Blue",
			"Red",
			"Gold",
			"Gold",
			"White"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95289"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 6,
		"newPrice": 5
	},
	{
		"id": 97998,
		"title": "Bohemia Crisscross Woven Patterned Textured Waterproof Outdoor Fabric Swatches",
		"ProductUrl": "/swatches/bohemia-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64049",
		"_fabric_color": [
			{
				"term_id": 64047,
				"gallery": [
					98023
				],
				"imgSrc": "/cdn/shop/files/OFS18045-13-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFS18045-13.png",
				"imgSrcF": "/cdn/shop/files/Green-6-3.png",
				"title": "Bohemia / Green",
				"color": "Green"
			},
			{
				"term_id": 64048,
				"gallery": [
					98022
				],
				"imgSrc": "/cdn/shop/files/OFS18045-10-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFS18045-10.png",
				"imgSrcF": "/cdn/shop/files/Yellow-6-1.png",
				"title": "Bohemia / Yellow",
				"color": "Yellow"
			},
			{
				"term_id": 64049,
				"gallery": [
					98021
				],
				"imgSrc": "/cdn/shop/files/OFS18045-8-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFS18045-8-1.png",
				"imgSrcF": "/cdn/shop/files/Grey-6-5.png",
				"title": "Bohemia / Grey",
				"color": "Grey"
			},
			{
				"term_id": 64050,
				"gallery": [
					98020
				],
				"imgSrc": "/cdn/shop/files/OFS18045-4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFS18045-4-1.png",
				"imgSrcF": "/cdn/shop/files/Wheat-6-1.png",
				"title": "Bohemia / Wheat",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/all-4-500x500.png",
		"hoverImg": "/cdn/shop/files/all-4-500x500.png",
		"subheading": "Crisscross Woven Patterned Textured Waterproof Outdoor Fabric Swatches",
		"Fabrics": [
			"Bohemia"
		],
		"Feature": [
			"Waterproof"
		],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Green",
			"Yellow",
			"Grey",
			"Beige"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"Back Tab",
			"Grommet",
			"Pinch Pleated",
			"Rod Pocket",
			"Tab Top"
		],
		"Space": [
			"Outdoor"
		],
		"Finished Product": [
			"95257"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1
	},
	{
		"id": 97997,
		"title": "Boston High-Performing Fade-Resistant Waterproof Outdoor Fabric Swatches",
		"ProductUrl": "/swatches/boston-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64096",
		"_fabric_color": [
			{
				"term_id": 64095,
				"gallery": [
					98048
				],
				"imgSrc": "/cdn/shop/files/Boston-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Boston-2.png",
				"imgSrcF": "/cdn/shop/files/Boston1-1.png",
				"title": "Boston / Dark Grey",
				"color": "Grey"
			},
			{
				"term_id": 64096,
				"gallery": [
					98049
				],
				"imgSrc": "/cdn/shop/files/Boston-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Boston-3.png",
				"imgSrcF": "/cdn/shop/files/Boston1-2.png",
				"title": "Boston / Grey",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/Boston-1-500x500.png",
		"hoverImg": "/cdn/shop/files/Boston-1-500x500.png",
		"subheading": "High-Performing Fade-Resistant Waterproof Outdoor Fabric Swatches",
		"Fabrics": [
			"Boston"
		],
		"Feature": [
			"Waterproof"
		],
		"Material": [
			"Polyester",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Grey",
			"Grey"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [
			"4 In 1",
			"Back Tab",
			"Goblet Pleat",
			"Grommet",
			"Inverted Pleat",
			"Pinch Pleated",
			"Rod Pocket"
		],
		"Space": [
			"Outdoor"
		],
		"Finished Product": [
			"95259"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1
	},
	{
		"id": 96814,
		"title": "Miami Fishtail Patterned Waterproof Outdoor Fabric Swatches",
		"ProductUrl": "/swatches/miami-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64036",
		"_fabric_color": [
			{
				"term_id": 64036,
				"gallery": [
					98004
				],
				"imgSrc": "/cdn/shop/files/OFH18035-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFH18035-4.png",
				"imgSrcF": "/cdn/shop/files/Teal-6-3.png",
				"title": "Miami / Teal",
				"color": "Green"
			},
			{
				"term_id": 64037,
				"gallery": [
					98003
				],
				"imgSrc": "/cdn/shop/files/OFH18035-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFH18035-3.png",
				"imgSrcF": "/cdn/shop/files/Dark-Grey-6-1.png",
				"title": "Miami / Dark Grey",
				"color": "Black"
			},
			{
				"term_id": 64038,
				"gallery": [
					98002
				],
				"imgSrc": "/cdn/shop/files/OFH18035-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFH18035-2.png",
				"imgSrcF": "/cdn/shop/files/Greyish-Blue-6-1.png",
				"title": "Miami / Greyish Blue",
				"color": "Grey"
			},
			{
				"term_id": 64032,
				"gallery": [
					98001
				],
				"imgSrc": "/cdn/shop/files/OFH18035-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFH18035-1.png",
				"imgSrcF": "/cdn/shop/files/Sand-6-1.png",
				"title": "Miami / Sand",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "The Outdoor curtains adopt waterproof technology on the fabric, unlike the other blackout drapes. The invisible layer on both sides is water-resistant and will preserve even in heavy rain or the fiercest snowstorm. With the double grommet, the curtain will stay still against the wind.\r\n\r\nOUTDOOR CURTAINS\r\noutdoor\r\npatio curtains\r\npatio\r\nOutdoor curtain\r\nPatio curtain\r\nFarmhouse\r\nDrapes\r\npinch pleated\r\nGrommet blackout curtains\r\nNavy\r\nNavy blue curtains\r\nPure white",
		"imgSrc": "/cdn/shop/files/all-1-500x500.png",
		"hoverImg": "/cdn/shop/files/all-1-500x500.png",
		"subheading": "Fishtail Patterned Waterproof Outdoor Fabric Swatches",
		"Fabrics": [
			"Miami"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Green",
			"Black",
			"Grey",
			"Beige"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Outdoor"
		],
		"Finished Product": [
			"95255"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 98000,
		"title": "New York Grid Patterned Textured Waterproof Outdoor Fabric Swatches",
		"ProductUrl": "/swatches/new-york-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64033",
		"_fabric_color": [
			{
				"term_id": 64043,
				"gallery": [
					98010
				],
				"imgSrc": "/cdn/shop/files/OFH50021-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFH50021-5.png",
				"imgSrcF": "/cdn/shop/files/OFH50021-150-5.jpg",
				"title": "New York / Black",
				"color": "Black"
			},
			{
				"term_id": 64044,
				"gallery": [
					98009
				],
				"imgSrc": "/cdn/shop/files/OFH50021-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFH50021-4.png",
				"imgSrcF": "/cdn/shop/files/OFH50021-150-4.jpg",
				"title": "New York / White",
				"color": "White"
			},
			{
				"term_id": 64033,
				"gallery": [
					98008
				],
				"imgSrc": "/cdn/shop/files/OFH50021-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFH50021-3.png",
				"imgSrcF": "/cdn/shop/files/OFH50021-150-3.jpg",
				"title": "New York / Green",
				"color": "Green"
			},
			{
				"term_id": 64034,
				"gallery": [
					98007
				],
				"imgSrc": "/cdn/shop/files/OFH50021-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFH50021-2.png",
				"imgSrcF": "/cdn/shop/files/OFH50021-150-2.jpg",
				"title": "New York / Dark Grey",
				"color": "Grey"
			},
			{
				"term_id": 64035,
				"gallery": [
					98006
				],
				"imgSrc": "/cdn/shop/files/OFH50021-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFH50021-1.png",
				"imgSrcF": "/cdn/shop/files/OFH50021-150-1.jpg",
				"title": "New York / Grey",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/all-2-500x500.png",
		"hoverImg": "/cdn/shop/files/all-2-500x500.png",
		"subheading": "Grid Patterned Textured Waterproof Outdoor Fabric Swatches",
		"Fabrics": [
			"New York"
		],
		"Feature": [
			"Waterproof"
		],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Black",
			"White",
			"Green",
			"Grey",
			"Grey"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Outdoor"
		],
		"Finished Product": [
			"95256"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1
	},
	{
		"id": 96987,
		"title": "Pebbles Foil Printed Velvet Patterned Fabric Swatches",
		"ProductUrl": "/swatches/pebbles-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "96988",
		"_fabric_color": [
			{
				"term_id": 95541,
				"gallery": [
					96551
				],
				"imgSrc": "/cdn/shop/files/BF-A10-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A10-1-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A10-1-2.png",
				"title": "Pebbles / Ivory",
				"color": "White"
			},
			{
				"term_id": 95542,
				"gallery": [
					96552
				],
				"imgSrc": "/cdn/shop/files/BF-A10-2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A10-2-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A10-2-2.png",
				"title": "Pebbles / Shimmer",
				"color": "Silver"
			},
			{
				"term_id": 95543,
				"gallery": [
					96555
				],
				"imgSrc": "/cdn/shop/files/BF-A10-5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A10-5-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A10-5-2.png",
				"title": "Pebbles / Hazy Blue",
				"color": "Blue"
			},
			{
				"term_id": 95544,
				"gallery": [
					96554
				],
				"imgSrc": "/cdn/shop/files/BF-A10-4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A10-4-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A10-4-2.png",
				"title": "Pebbles / Silver Grey",
				"color": "Grey"
			},
			{
				"term_id": 95548,
				"gallery": [
					96557
				],
				"imgSrc": "/cdn/shop/files/BF-A10-7-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A10-7-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A10-7-2.png",
				"title": "Pebbles / Black Gold",
				"color": "Black"
			},
			{
				"term_id": 95545,
				"gallery": [
					96553
				],
				"imgSrc": "/cdn/shop/files/BF-A10-3-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A10-3-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A10-3-2.png",
				"title": "Pebbles / Gold",
				"color": "Gold"
			},
			{
				"term_id": 95547,
				"gallery": [
					96556
				],
				"imgSrc": "/cdn/shop/files/BF-A10-6-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF-A10-6-1.png",
				"imgSrcF": "/cdn/shop/files/BF-A10-6-2.png",
				"title": "Pebbles / Teal",
				"color": "Cyan"
			},
			{
				"term_id": 96988,
				"gallery": [
					96550
				],
				"imgSrc": "/cdn/shop/files/531382-500x500.png",
				"imgSrc_n": "/cdn/shop/files/531382.png",
				"imgSrcF": "/cdn/shop/files/531382.png",
				"title": "Pebbles — All Color",
				"color": "Cyan"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Pebbles velvet fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/531382-500x500.png",
		"hoverImg": "/cdn/shop/files/531382-500x500.png",
		"subheading": "Foil Printed Velvet Patterned Fabric Swatches",
		"Fabrics": [
			"Pebbles"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White",
			"Silver",
			"Blue",
			"Grey",
			"Black",
			"Gold",
			"Cyan"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95284"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 7,
		"newPrice": 5
	},
	{
		"id": 103704,
		"title": "Wengen Linen Cotton Blend Airy Sheer Fabric Swatches",
		"ProductUrl": "/product/wengen-linen-cotton-blend-airy-sheer-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "1122",
		"_fabric_color": [
			{
				"term_id": 1122,
				"gallery": [
					103705
				],
				"imgSrc": "/cdn/shop/files/1-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/1-2.png",
				"imgSrcF": "/cdn/shop/files/Wengen-1.png",
				"title": "Wengen / White",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample",
			"Swatches-Old"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Voy linen fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/2-2-500x500.png",
		"hoverImg": "",
		"subheading": "Linen Cotton Blend Airy Sheer Fabric Swatches",
		"Fabrics": [
			"Wengen"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"White"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"1239"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1
	},
	{
		"id": 66047,
		"title": "Tide Linen Blend Heavyweight Golden Threads Textured Fabric Swatches",
		"ProductUrl": "/swatches/tide-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66084",
		"_fabric_color": [
			{
				"term_id": 64086,
				"gallery": [
					65883
				],
				"imgSrc": "/cdn/shop/files/Black-6-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Black-6.png",
				"imgSrcF": "/cdn/shop/files/FB-CR3305.png",
				"title": "Tide / Black",
				"color": "Black"
			},
			{
				"term_id": 64087,
				"gallery": [
					65882
				],
				"imgSrc": "/cdn/shop/files/Tide-Sand-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Tide-Sand.png",
				"imgSrcF": "/cdn/shop/files/FB-CR3304.png",
				"title": "Tide / Sand",
				"color": "Beige"
			},
			{
				"term_id": 64076,
				"gallery": [
					65881
				],
				"imgSrc": "/cdn/shop/files/Cream-7-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Cream-7.png",
				"imgSrcF": "/cdn/shop/files/FB-CR3303.png",
				"title": "Tide / Cream",
				"color": "Beige"
			},
			{
				"term_id": 64077,
				"gallery": [
					65880
				],
				"imgSrc": "/cdn/shop/files/Tide-Grey-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Tide-Grey.png",
				"imgSrcF": "/cdn/shop/files/FB-CR3302.png",
				"title": "Tide / Grey",
				"color": "Grey"
			},
			{
				"term_id": 66084,
				"gallery": [
					65884
				],
				"imgSrc": "/cdn/shop/files/Tide-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Tide.png",
				"imgSrcF": "/cdn/shop/files/Tide.png",
				"title": "Tide — All Color",
				"color": "Grey"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/Tide-500x500.png",
		"hoverImg": "/cdn/shop/files/Tide-500x500.png",
		"subheading": "Linen Blend Heavyweight Golden Threads Textured Fabric Swatches",
		"Fabrics": [
			"Tide"
		],
		"Feature": [],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Black",
			"Beige",
			"Beige",
			"Grey"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64169"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 5,
		"newPrice": 5
	},
	{
		"id": 66043,
		"title": "Haze Linen Blend Golden Threads Textured Frabic Swatches",
		"ProductUrl": "/swatches/haze-frabic-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66105",
		"_fabric_color": [
			{
				"term_id": 64097,
				"gallery": [
					66036
				],
				"imgSrc": "/cdn/shop/files/STATIC-Black-500x500.png",
				"imgSrc_n": "/cdn/shop/files/STATIC-Black.png",
				"imgSrcF": "/cdn/shop/files/black-1.jpg",
				"title": "Haze / Black",
				"color": "Black"
			},
			{
				"term_id": 64098,
				"gallery": [
					66035
				],
				"imgSrc": "/cdn/shop/files/STATIC-Oatmeal-500x500.png",
				"imgSrc_n": "/cdn/shop/files/STATIC-Oatmeal.png",
				"imgSrcF": "/cdn/shop/files/oatmeal.png",
				"title": "Haze / Oatmeal",
				"color": "Beige"
			},
			{
				"term_id": 64099,
				"gallery": [
					66034
				],
				"imgSrc": "/cdn/shop/files/STATIC-Cream-500x500.png",
				"imgSrc_n": "/cdn/shop/files/STATIC-Cream.png",
				"imgSrcF": "/cdn/shop/files/Haze-display.png",
				"title": "Haze / Cream",
				"color": "Beige"
			},
			{
				"term_id": 66105,
				"gallery": [
					66033
				],
				"imgSrc": "/cdn/shop/files/STATIC-500x500.png",
				"imgSrc_n": "/cdn/shop/files/STATIC.png",
				"imgSrcF": "/cdn/shop/files/STATIC.png",
				"title": "Haze — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/STATIC-500x500.png",
		"hoverImg": "/cdn/shop/files/STATIC-500x500.png",
		"subheading": "Linen Blend Golden Threads Textured Frabic Swatches",
		"Fabrics": [
			"Haze"
		],
		"Feature": [],
		"Material": [
			"Linen"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Black",
			"Beige",
			"Beige"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64174"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 3,
		"newPrice": 5
	},
	{
		"id": 66039,
		"title": "Zen Foil Printed Velvet Patterned Fabric Swatches",
		"ProductUrl": "/swatches/zen-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66109",
		"_fabric_color": [
			{
				"term_id": 64132,
				"gallery": [
					65866
				],
				"imgSrc": "/cdn/shop/files/Black-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Black-5.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005879-1.png",
				"title": "Zen / Black",
				"color": "Black"
			},
			{
				"term_id": 64122,
				"gallery": [
					65865
				],
				"imgSrc": "/cdn/shop/files/Silver-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Silver.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005878-2.png",
				"title": "Zen / Silver",
				"color": "Silver"
			},
			{
				"term_id": 64123,
				"gallery": [
					65864
				],
				"imgSrc": "/cdn/shop/files/Brown-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Brown-3.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005877-1.png",
				"title": "Zen / Brown",
				"color": "Brown"
			},
			{
				"term_id": 64124,
				"gallery": [
					65863
				],
				"imgSrc": "/cdn/shop/files/Gold-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Gold.png",
				"imgSrcF": "/cdn/shop/files/Rectangle-23.png",
				"title": "Zen / Gold",
				"color": "Gold"
			},
			{
				"term_id": 64125,
				"gallery": [
					65862
				],
				"imgSrc": "/cdn/shop/files/Cream-5-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Cream-5.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005875-1.png",
				"title": "Zen / Cream",
				"color": "Beige"
			},
			{
				"term_id": 66109,
				"gallery": [
					65861
				],
				"imgSrc": "/cdn/shop/files/Zen-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Zen.png",
				"imgSrcF": "/cdn/shop/files/Zen.png",
				"title": "Zen — All Color",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/Zen-500x500.png",
		"hoverImg": "/cdn/shop/files/Zen-500x500.png",
		"subheading": "Foil Printed Velvet Patterned Fabric Swatches",
		"Fabrics": [
			"Zen"
		],
		"Feature": [],
		"Material": [
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Foil Printed",
			"Pattern"
		],
		"Color": [
			"Black",
			"Silver",
			"Brown",
			"Gold",
			"Beige"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64179"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 5,
		"newPrice": 5
	},
	{
		"id": 66040,
		"title": "Casablanca Foil Printed Velvet Patterned Fabric Swatches",
		"ProductUrl": "/swatches/casablanca-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66110",
		"_fabric_color": [
			{
				"term_id": 64136,
				"gallery": [
					66005
				],
				"imgSrc": "/cdn/shop/files/CASABLANCA-Black-500x500.png",
				"imgSrc_n": "/cdn/shop/files/CASABLANCA-Black.png",
				"imgSrcF": "/cdn/shop/files/Casablanca-color-7.png",
				"title": "Casablanca / Black",
				"color": "Black"
			},
			{
				"term_id": 64137,
				"gallery": [
					66004
				],
				"imgSrc": "/cdn/shop/files/CASABLANCA-Taupe-500x500.png",
				"imgSrc_n": "/cdn/shop/files/CASABLANCA-Taupe.png",
				"imgSrcF": "/cdn/shop/files/Casablanca-color-1.png",
				"title": "Casablanca / Sahara",
				"color": "Gold"
			},
			{
				"term_id": 64138,
				"gallery": [
					66003
				],
				"imgSrc": "/cdn/shop/files/CASABLANCA-Sahara-500x500.png",
				"imgSrc_n": "/cdn/shop/files/CASABLANCA-Sahara.png",
				"imgSrcF": "/cdn/shop/files/Casablanca-color-2-2.png",
				"title": "Casablanca / Grey",
				"color": "Grey"
			},
			{
				"term_id": 64128,
				"gallery": [
					66002
				],
				"imgSrc": "/cdn/shop/files/CASABLANCA-Hazy-Blue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/CASABLANCA-Hazy-Blue.png",
				"imgSrcF": "/cdn/shop/files/Casablanca-color-3.png",
				"title": "Casablanca / Hazy Blue",
				"color": "Blue"
			},
			{
				"term_id": 64129,
				"gallery": [
					66001
				],
				"imgSrc": "/cdn/shop/files/CASABLANCA-Misty-500x500.png",
				"imgSrc_n": "/cdn/shop/files/CASABLANCA-Misty.png",
				"imgSrcF": "/cdn/shop/files/Casablanca-color-4.png",
				"title": "Casablanca / Misty",
				"color": "Grey"
			},
			{
				"term_id": 64130,
				"gallery": [
					66000
				],
				"imgSrc": "/cdn/shop/files/CASABLANCA-Champagne-500x500.png",
				"imgSrc_n": "/cdn/shop/files/CASABLANCA-Champagne.png",
				"imgSrcF": "/cdn/shop/files/Casablanca-color-5.png",
				"title": "Casablanca / Champagne",
				"color": "Gold"
			},
			{
				"term_id": 64131,
				"gallery": [
					65999
				],
				"imgSrc": "/cdn/shop/files/CASABLANCA-Cream-500x500.png",
				"imgSrc_n": "/cdn/shop/files/CASABLANCA-Cream.png",
				"imgSrcF": "/cdn/shop/files/Casablanca-color-6.png",
				"title": "Casablanca / Cream",
				"color": "White"
			},
			{
				"term_id": 66110,
				"gallery": [
					65998
				],
				"imgSrc": "/cdn/shop/files/CASABLANCA-500x500.png",
				"imgSrc_n": "/cdn/shop/files/CASABLANCA.png",
				"imgSrcF": "/cdn/shop/files/CASABLANCA.png",
				"title": "Casablanca — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Casablanca velvet fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/CASABLANCA-500x500.png",
		"hoverImg": "/cdn/shop/files/CASABLANCA-500x500.png",
		"subheading": "Foil Printed Velvet Patterned Fabric Swatches",
		"Fabrics": [
			"Casablanca"
		],
		"Feature": [],
		"Material": [
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Foil Printed"
		],
		"Color": [
			"Black",
			"Gold",
			"Grey",
			"Blue",
			"Grey",
			"Gold",
			"White"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64180"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 8,
		"newPrice": 5
	},
	{
		"id": 66037,
		"title": "Luxor Foil Printed Velvet Patterned Fabric Swatches",
		"ProductUrl": "/swatches/luxor-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64143",
		"_fabric_color": [
			{
				"term_id": 64139,
				"gallery": [
					65935
				],
				"imgSrc": "/cdn/shop/files/Black-7-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Black-7.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005887.png",
				"title": "Luxor / Black",
				"color": "Black"
			},
			{
				"term_id": 64140,
				"gallery": [
					65934
				],
				"imgSrc": "/cdn/shop/files/Teal-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Teal.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005886.png",
				"title": "Luxor / Teal",
				"color": "Green"
			},
			{
				"term_id": 64141,
				"gallery": [
					65933
				],
				"imgSrc": "/cdn/shop/files/Misty-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Misty.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005885.png",
				"title": "Luxor / Misty",
				"color": "Grey"
			},
			{
				"term_id": 64142,
				"gallery": [
					65932
				],
				"imgSrc": "/cdn/shop/files/Carrot-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Carrot.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005884.png",
				"title": "Luxor / Carrot",
				"color": "Orange"
			},
			{
				"term_id": 64143,
				"gallery": [
					65931
				],
				"imgSrc": "/cdn/shop/files/Gold-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Gold-1.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005883.png",
				"title": "Luxor / Gold",
				"color": "Gold"
			},
			{
				"term_id": 64133,
				"gallery": [
					65930
				],
				"imgSrc": "/cdn/shop/files/Ash-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Ash.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005882.png",
				"title": "Luxor / Ash",
				"color": "Grey"
			},
			{
				"term_id": 64134,
				"gallery": [
					65929
				],
				"imgSrc": "/cdn/shop/files/Silve-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Silve.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005881.png",
				"title": "Luxor / Silver",
				"color": "Silver"
			},
			{
				"term_id": 64135,
				"gallery": [
					65928
				],
				"imgSrc": "/cdn/shop/files/Cream-8-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Cream-8.png",
				"imgSrcF": "/cdn/shop/files/Frame-1000005880.png",
				"title": "Luxor / Cream",
				"color": "White"
			},
			{
				"term_id": 66111,
				"gallery": [
					65936
				],
				"imgSrc": "/cdn/shop/files/Luxor-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Luxor.png",
				"imgSrcF": "/cdn/shop/files/Luxor.png",
				"title": "Luxor — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "sample",
				"name": "Sample"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Luxor velvet fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/Luxor-500x500.png",
		"hoverImg": "/cdn/shop/files/Luxor-500x500.png",
		"subheading": "Foil Printed Velvet Patterned Fabric Swatches",
		"Fabrics": [
			"Luxor"
		],
		"Feature": [],
		"Material": [
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Foil Printed",
			"Pattern"
		],
		"Color": [
			"Black",
			"Green",
			"Grey",
			"Orange",
			"Gold",
			"Grey",
			"Silver",
			"White"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64185"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 66055,
		"title": "Nirvana Velvet Heavyweight Floral Patterned Fabric Swatches",
		"ProductUrl": "/swatches/nirvana-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64064",
		"_fabric_color": [
			{
				"term_id": 64064,
				"gallery": [
					65921
				],
				"imgSrc": "/cdn/shop/files/Nirvana-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Nirvana.png",
				"imgSrcF": "/cdn/shop/files/Anderson.png",
				"title": "Nirvana / Nirvana",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/Nirvana-500x500.png",
		"hoverImg": "/cdn/shop/files/Nirvana-500x500.png",
		"subheading": "Velvet Heavyweight Floral Patterned Fabric Swatches",
		"Fabrics": [
			"Nirvana"
		],
		"Feature": [],
		"Material": [
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"White"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64165"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 66053,
		"title": "Rosé Patterned Velvet Fabric Swatches",
		"ProductUrl": "/swatches/rose-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64070",
		"_fabric_color": [
			{
				"term_id": 64070,
				"gallery": [
					65925
				],
				"imgSrc": "/cdn/shop/files/Rose-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Rose.png",
				"imgSrcF": "/cdn/shop/files/Ink-5-1.jpg",
				"title": "Rosé / Rosé",
				"color": "Red"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/Rose-500x500.png",
		"hoverImg": "/cdn/shop/files/Rose-5-500x500.png",
		"subheading": "Patterned Velvet Fabric Swatches",
		"Fabrics": [
			"Rosé"
		],
		"Feature": [],
		"Material": [
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Red"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64163"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	},
	{
		"id": 66054,
		"title": "Jade Velvet Heavyweight Patterned Fabric Swatches",
		"ProductUrl": "/swatches/jade-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "66072",
		"_fabric_color": [
			{
				"term_id": 64063,
				"gallery": [
					65924
				],
				"imgSrc": "/cdn/shop/files/Stone-Blue-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Stone-Blue.png",
				"imgSrcF": "/cdn/shop/files/Stone-Blue-1.png",
				"title": "Jade / Stone Blue",
				"color": "Blue"
			},
			{
				"term_id": 66071,
				"gallery": [
					65923
				],
				"imgSrc": "/cdn/shop/files/Ink-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Ink.png",
				"imgSrcF": "/cdn/shop/files/Rose-6.png",
				"title": "Jade / Ink",
				"color": "Brown"
			},
			{
				"term_id": 66072,
				"gallery": [
					65922
				],
				"imgSrc": "/cdn/shop/files/Jade-500x500.png",
				"imgSrc_n": "/cdn/shop/files/Jade.png",
				"imgSrcF": "/cdn/shop/files/Jade.png",
				"title": "Jade — All Color",
				"color": "Brown"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "sample",
				"name": "Sample"
			}
		],
		"short_description": "Sample",
		"imgSrc": "/cdn/shop/files/Jade-500x500.png",
		"hoverImg": "/cdn/shop/files/Jade-500x500.png",
		"subheading": "Velvet Heavyweight Patterned Fabric Swatches",
		"Fabrics": [
			"Jade"
		],
		"Feature": [],
		"Material": [
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Blue",
			"Brown"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64164"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 3,
		"newPrice": 5
	},
	{
		"id": 97000,
		"title": "Klimt Foil Printed Velvet Patterned Fabric Swatches",
		"ProductUrl": "/swatches/klimt-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "97001",
		"_fabric_color": [
			{
				"term_id": 95549,
				"gallery": [
					96529
				],
				"imgSrc": "/cdn/shop/files/BF354-2-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF354-2-1.png",
				"imgSrcF": "/cdn/shop/files/beige-5.png",
				"title": "Klimt / Beige",
				"color": "Beige"
			},
			{
				"term_id": 95551,
				"gallery": [
					96535
				],
				"imgSrc": "/cdn/shop/files/BF354-7-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF354-7-1.png",
				"imgSrcF": "/cdn/shop/files/copper.png",
				"title": "Klimt / Copper",
				"color": "Beige"
			},
			{
				"term_id": 95552,
				"gallery": [
					96534
				],
				"imgSrc": "/cdn/shop/files/BF354-6-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF354-6-1.png",
				"imgSrcF": "/cdn/shop/files/BF354-6-2.png",
				"title": "Klimt / Black",
				"color": "Black"
			},
			{
				"term_id": 95553,
				"gallery": [
					96532
				],
				"imgSrc": "/cdn/shop/files/BF354-5-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF354-5-1.png",
				"imgSrcF": "/cdn/shop/files/gold-1.png",
				"title": "Klimt / Gold",
				"color": "Gold"
			},
			{
				"term_id": 95554,
				"gallery": [
					96531
				],
				"imgSrc": "/cdn/shop/files/BF354-4-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF354-4-1.png",
				"imgSrcF": "/cdn/shop/files/silverblue.png",
				"title": "Klimt / Silver Blue",
				"color": "Blue"
			},
			{
				"term_id": 95555,
				"gallery": [
					96530
				],
				"imgSrc": "/cdn/shop/files/BF354-3-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF354-3-1.png",
				"imgSrcF": "/cdn/shop/files/silver-8.png",
				"title": "Klimt / Silver",
				"color": "Silver"
			},
			{
				"term_id": 95546,
				"gallery": [
					96528
				],
				"imgSrc": "/cdn/shop/files/BF354-1-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF354-1-1.png",
				"imgSrcF": "/cdn/shop/files/platnium.png",
				"title": "Klimt / Platinum",
				"color": "White"
			},
			{
				"term_id": 97001,
				"gallery": [
					98490
				],
				"imgSrc": "/cdn/shop/files/BF354-500x500.png",
				"imgSrc_n": "/cdn/shop/files/BF354.png",
				"imgSrcF": "/cdn/shop/files/BF354.png",
				"title": "Klimt — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "Order FREE Swatches Today. Our Klimt velvet fabric swatches are easy to order and quickly delivered to your door. Once you receive them, you can feel the fabric's softness, examine the weave, and appreciate the craftsmanship. This small step makes a big difference in your curtain-buying experience.\r\n\r\ncurtain swatches\r\nfree curtain swatches\r\nfabric samples\r\nfabric material samples\r\nfree curtain samples\r\nfree curtain swatches\r\ncurtains for free\r\nfree drapery samples\r\nfree curtains\r\ncurtain samples\r\nfree swatch samples\r\nfree swatches\r\nfree swatch",
		"imgSrc": "/cdn/shop/files/BF354-500x500.png",
		"hoverImg": "/cdn/shop/files/BF354-500x500.png",
		"subheading": "Foil Printed Velvet Patterned Fabric Swatches",
		"Fabrics": [
			"Klimt"
		],
		"Feature": [],
		"Material": [
			"Polyester",
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Beige",
			"Beige",
			"Black",
			"Gold",
			"Blue",
			"Silver",
			"White"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"95286"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 7,
		"newPrice": 5
	},
	{
		"id": 97999,
		"title": "Munich Woven Patterned Textured Waterproof Outdoor Fabric Swatches",
		"ProductUrl": "/swatches/munich-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64042",
		"_fabric_color": [
			{
				"term_id": 64039,
				"gallery": [
					98015
				],
				"imgSrc": "/cdn/shop/files/OFS18043-4-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFS18043-4.png",
				"imgSrcF": "/cdn/shop/files/Black-6-1.png",
				"title": "Munich / Black",
				"color": "Black"
			},
			{
				"term_id": 64040,
				"gallery": [
					98014
				],
				"imgSrc": "/cdn/shop/files/OFS18043-3-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFS18043-3.png",
				"imgSrcF": "/cdn/shop/files/Teal-6-2.png",
				"title": "Munich / Teal",
				"color": "Green"
			},
			{
				"term_id": 64041,
				"gallery": [
					98013
				],
				"imgSrc": "/cdn/shop/files/OFS18043-2-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFS18043-2.png",
				"imgSrcF": "/cdn/shop/files/Grey-6-1.png",
				"title": "Munich / Grey",
				"color": "Grey"
			},
			{
				"term_id": 64042,
				"gallery": [
					98012
				],
				"imgSrc": "/cdn/shop/files/OFS18043-1-500x500.png",
				"imgSrc_n": "/cdn/shop/files/OFS18043-1.png",
				"imgSrcF": "/cdn/shop/files/Wheat-12-1.png",
				"title": "Munich / Wheat",
				"color": "Beige"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [
			{
				"slug": "curtain-swatches",
				"name": "curtain swatches"
			},
			{
				"slug": "fabric-samples",
				"name": "fabric samples"
			},
			{
				"slug": "fabric-swatches",
				"name": "fabric swatches"
			},
			{
				"slug": "free-swatches",
				"name": "free swatches"
			},
			{
				"slug": "swatches",
				"name": "swatches"
			}
		],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/all-3-500x500.png",
		"hoverImg": "/cdn/shop/files/all-3-500x500.png",
		"subheading": "Woven Patterned Textured Waterproof Outdoor Fabric Swatches",
		"Fabrics": [
			"Munich"
		],
		"Feature": [
			"Waterproof"
		],
		"Material": [
			"Synthetic"
		],
		"Pattern": [
			"Pattern"
		],
		"Color": [
			"Black",
			"Green",
			"Grey",
			"Beige"
		],
		"Light": [
			"Room Darkening"
		],
		"Hanging": [],
		"Space": [
			"Outdoor"
		],
		"Finished Product": [
			"95258"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1
	},
	{
		"id": 66042,
		"title": "Moonlit Fabric Swatches",
		"ProductUrl": "/swatches/moonlit-fabric-swatches/?",
		"isNewArrival": false,
		"meetingExtraType": 0,
		"_is_default_fabric": "64110",
		"_fabric_color": [
			{
				"term_id": 64115,
				"gallery": [
					105340
				],
				"imgSrc": "/cdn/shop/files/black-500x500.png",
				"imgSrc_n": "/cdn/shop/files/black.png",
				"imgSrcF": "/cdn/shop/files/black色块.png",
				"title": "Moonlit / Black",
				"color": "Black"
			},
			{
				"term_id": 64106,
				"gallery": [
					105353
				],
				"imgSrc": "/cdn/shop/files/teal-500x500.png",
				"imgSrc_n": "/cdn/shop/files/teal.png",
				"imgSrcF": "/cdn/shop/files/teal色块.png",
				"title": "Moonlit / Teal",
				"color": "Blue"
			},
			{
				"term_id": 64107,
				"gallery": [
					105350
				],
				"imgSrc": "/cdn/shop/files/red-500x500.png",
				"imgSrc_n": "/cdn/shop/files/red.png",
				"imgSrcF": "/cdn/shop/files/red色块.png",
				"title": "Moonlit / Red",
				"color": "Red"
			},
			{
				"term_id": 64108,
				"gallery": [
					105346
				],
				"imgSrc": "/cdn/shop/files/ebony-500x500.png",
				"imgSrc_n": "/cdn/shop/files/ebony.png",
				"imgSrcF": "/cdn/shop/files/ebony色块.png",
				"title": "Moonlit / Ebony",
				"color": "Black"
			},
			{
				"term_id": 64109,
				"gallery": [
					105348
				],
				"imgSrc": "/cdn/shop/files/metallic-500x500.png",
				"imgSrc_n": "/cdn/shop/files/metallic.png",
				"imgSrcF": "/cdn/shop/files/metalic色块.png",
				"title": "Moonlit / Metallic",
				"color": "Brown"
			},
			{
				"term_id": 64110,
				"gallery": [
					105341
				],
				"imgSrc": "/cdn/shop/files/brown-500x500.png",
				"imgSrc_n": "/cdn/shop/files/brown.png",
				"imgSrcF": "/cdn/shop/files/brown色块.png",
				"title": "Moonlit / Brown",
				"color": "Brown"
			},
			{
				"term_id": 64111,
				"gallery": [
					105342
				],
				"imgSrc": "/cdn/shop/files/camel-500x500.png",
				"imgSrc_n": "/cdn/shop/files/camel.png",
				"imgSrcF": "/cdn/shop/files/camel色块.png",
				"title": "Moonlit / Camel",
				"color": "Orange"
			},
			{
				"term_id": 64112,
				"gallery": [
					105343
				],
				"imgSrc": "/cdn/shop/files/carrot-500x500.png",
				"imgSrc_n": "/cdn/shop/files/carrot.png",
				"imgSrcF": "/cdn/shop/files/carrot色块.png",
				"title": "Moonlit / Carrot",
				"color": "Orange"
			},
			{
				"term_id": 64100,
				"gallery": [
					105351
				],
				"imgSrc": "/cdn/shop/files/salmon-500x500.png",
				"imgSrc_n": "/cdn/shop/files/salmon.png",
				"imgSrcF": "/cdn/shop/files/salmon色块.png",
				"title": "Moonlit / Salmon",
				"color": "Orange"
			},
			{
				"term_id": 64101,
				"gallery": [
					105349
				],
				"imgSrc": "/cdn/shop/files/mustard-500x500.png",
				"imgSrc_n": "/cdn/shop/files/mustard.png",
				"imgSrcF": "/cdn/shop/files/mustard色块.png",
				"title": "Moonlit / Mustard",
				"color": "Cyan"
			},
			{
				"term_id": 64102,
				"gallery": [
					105339
				],
				"imgSrc": "/cdn/shop/files/azure-500x500.png",
				"imgSrc_n": "/cdn/shop/files/azure.png",
				"imgSrcF": "/cdn/shop/files/azure色块.png",
				"title": "Moonlit / Azure",
				"color": "Blue"
			},
			{
				"term_id": 64103,
				"gallery": [
					105347
				],
				"imgSrc": "/cdn/shop/files/grey-500x500.png",
				"imgSrc_n": "/cdn/shop/files/grey.png",
				"imgSrcF": "/cdn/shop/files/grey色块.png",
				"title": "Moonlit / Grey",
				"color": "Grey"
			},
			{
				"term_id": 64104,
				"gallery": [
					105352
				],
				"imgSrc": "/cdn/shop/files/silver-grey-500x500.png",
				"imgSrc_n": "/cdn/shop/files/silver-grey.png",
				"imgSrcF": "/cdn/shop/files/silver-grey色块.png",
				"title": "Moonlit / Silver Grey",
				"color": "Grey"
			},
			{
				"term_id": 64105,
				"gallery": [
					105344
				],
				"imgSrc": "/cdn/shop/files/champane-500x500.png",
				"imgSrc_n": "/cdn/shop/files/champane.png",
				"imgSrcF": "/cdn/shop/files/champane色块.png",
				"title": "Moonlit / Champagne",
				"color": "Beige"
			},
			{
				"term_id": 64094,
				"gallery": [
					105345
				],
				"imgSrc": "/cdn/shop/files/cream-500x500.png",
				"imgSrc_n": "/cdn/shop/files/cream.png",
				"imgSrcF": "/cdn/shop/files/cream色块.png",
				"title": "Moonlit / Cream",
				"color": "White"
			},
			{
				"term_id": 66107,
				"gallery": [
					105354
				],
				"imgSrc": "/cdn/shop/files/moonlit-all-500x500.png",
				"imgSrc_n": "/cdn/shop/files/moonlit-all.png",
				"imgSrcF": "/cdn/shop/files/moonlit-all.png",
				"title": "Moonlit — All Color",
				"color": "White"
			}
		],
		"_fabric_classic": [],
		"CategoriesAll": [],
		"AllCategory": [
			"flash_categories",
			"New Content",
			"New Product UI",
			"new rod UI",
			"No Sale Coupons",
			"Outsourced products",
			"Search sample",
			"Swatches Sample"
		],
		"isBestseller": false,
		"isPremiere": false,
		"isEditorsPick": false,
		"tags": [],
		"short_description": "",
		"imgSrc": "/cdn/shop/files/moonlit-all-500x500.png",
		"hoverImg": "/cdn/shop/files/moonlit-all-500x500.png",
		"subheading": "Fabric Swatches",
		"Fabrics": [
			"Moonlit"
		],
		"Feature": [],
		"Material": [
			"Velvet",
			"Synthetic"
		],
		"Pattern": [
			"Solid"
		],
		"Color": [
			"Black",
			"Blue",
			"Red",
			"Black",
			"Brown",
			"Brown",
			"Orange",
			"Orange",
			"Orange",
			"Cyan",
			"Blue",
			"Grey",
			"Grey",
			"Beige",
			"White"
		],
		"Light": [],
		"Hanging": [],
		"Space": [
			"Indoor"
		],
		"Finished Product": [
			"64182",
			"101379"
		],
		"Sale": "",
		"salenum": 0,
		"oldPrice": 1,
		"newPrice": 5
	}
];
var filterStart = {
	// 展示在侧边栏的筛选属性
	showType: [
		"Fabrics",
		"Light",
		"Pattern",
		"Color",
		"Hanging",
		"Material",
		"Category",
		"Sale",
	],
	// 侧边栏选中的属性标签数量
	$TagNum: $(".curtainFilter .curtainFilterTitle > div:first-child > div span"),
	// 关闭侧边栏的元素
	$filterExit: $(".curtainFilter .curtainFilterTitle .exit"),
	// 侧边栏选中的属性标签
	$filterTag: $(".curtainFilter .curtainFilterTitle .curtainFilterTag"),
	// 展示区商品列表
	$Box: $(".curtainFilter .curtainFilterDetail .filterListBox"),
	// 展示区属性标签
	$BoxTag: $(".curtainAll .content .filterBox .curtainFilterTag"),
	fwidth: 0,
	flength: 0,
	// 排序方式
	orderby: "menu_order",
	per_page: -1,
	// 初始类别
	termsSlug: "all-curtains",
	// 用户是否操作侧边栏
	userSetting: false,
	// 初始缓存 合并各类别产品列表
	dataList: [
		...curtainsList,
		...shadesList,
		...accessoriesList,
		...rugList,
		...samplesaleList,
		...sunshadesList,
		...swatchesList,
	],
	// 侧边栏选中的内衬标签
	lining: [],
	// 是否展示指定商品 true 展示第一个商品, number 展示指定id的商品
	showItem: false,
	// 接口返回的数据
	list: [],
};
var productSortList = [];
$(".curtainAll .content .productCategories p.showMore").on(
	"click",
	function () {
		if ($(this).text() == "Show More") {
			$(".curtainAll .content .productCategories p").css("display", "block");
			$(this).text("Show Less");
		} else {
			$(".curtainAll .content .productCategories p").css(
				"display",
				"-webkit-box"
			);
			$(this).text("Show More");
		}
	}
);
$(".curtainFilterBtn").on("click", function () {
	$(".curtainFilter").addClass("active");
	$("body").css("position", "fixed");
});
$(".curtainshade").on("click", function () {
	$(".curtainFilter").removeClass("active");
	$("body").css("position", "static");
});
filterStart.$filterExit.on("click", function () {
	$(".curtainFilter").removeClass("active");
	$("body").css("position", "static");
});
$(".curtainAll .orderby").on("change", function () {
	$(".filterList").html(
		`<div class="loading"><img src="/cdn/shop/files/loadding.gif" /></div>`
	);
	filterStart.$filterTag.find("> span").click();
	filterStart.orderby = $(this).val();
	filterInit();
});
// 删除全部Tag
filterStart.$filterTag.find("> span").on("click", function () {
	lining = [];
	$(
		".curtainFilter .curtainFilterDetail .filterListBox .detail > div input[type=checkbox]"
	).prop("checked", false);
	$(`.productTags .item .btn`).removeClass("active");
	filterStart.$BoxTag.find(".selection").remove();
	filterStart.$filterTag.find(".selection").remove();
	$(".curtainFilter .curtainFilterDetail .filterListBox").css(
		"height",
		`calc(100vh - 121px)`
	);
	$(".curtainFilterBtn span").text("(0)");
	filterStart.$TagNum.text("(0)");
	filterStart.$BoxTag.css("display", "none");
	filterStart.$filterTag.css("display", "none");
	$(".curtainFilterNum").hide();
	get_filterData();
});
// 删除全部Tag
filterStart.$BoxTag.find("> span").on("click", function () {
	filterStart.$filterTag.find("> span").click();
});
// 内衬参数
function liningChange () {
	if (filterStart.lining.includes("Blackout")) {
		filterStart.liningType = "Blackout";
	} else if (filterStart.lining.includes("Room Darkening")) {
		filterStart.liningType = "Soft";
	} else if (filterStart.lining.includes("Light Filtering")) {
		filterStart.liningType = "Privacy";
	} else {
		filterStart.liningType = "Unlined";
	}
	return filterStart.liningType;
}
async function filterProduct (User = {}) {
	if (User != {}) {
		filterStart = updateFilterStart(User, filterStart);
	}
	const sort = await fetchProductSortList(filterStart.termsSlug);
	if (sort) {
		filterStart.dataList = listOrderByArr(filterStart.dataList, sort);
	}
	if (filterStart.dataList.length > 0) {
		startListChange(filterStart.dataList);
		ListChange(filterStart.dataList);
		filterData(filterStart.dataList);
	}
	filterInit();
}
async function filterInit () {
	const res = await fetchCurtainsData({
		termsSlug: filterStart.termsSlug,
		orderby: filterStart.orderby,
		fwidth: filterStart.fwidth,
		flength: filterStart.flength,
		per_page: filterStart.per_page,
	});
	const sort = await fetchProductSortList(filterStart.termsSlug);
	if (res?.data && sort) {
		if (pakoUnlock(res.data).length > 0) {
			filterStart.dataList = filterStart.list = listOrderByArr(
				pakoUnlock(res.data),
				sort
			);
		}
		if (filterStart.orderby != "") {
			$(".filterList").css("display", "flex");
		}
		startListChange(filterStart.list);
		ListChange(filterStart.list);
		filterData(filterStart.list);
	}
}
function updateFilterStart (referList, targetList) {
	$.each(referList, function (i, item) {
		targetList[i] = referList[i];
	});
	return targetList;
}
function ListChange (list = []) {
	if ($(".curtainFilterTag .selection").length == 0) {
		if (
			$(".curtainAll .orderby").val() == "menu_order" ||
			($(".curtainAll .orderby").val() != "menu_order" && list == [])
		) {
			list = filterStart.dataList;
		}
	}
	productCard(
		".curtainAll .content .filterList",
		list,
		{
			showType: filterStart.showType,
			fwidth: filterStart.fwidth,
			flength: filterStart.flength,
		},
		liningChange()
	);
	if (
		searchParams.get("search") != "" &&
		searchParams.get("search") != null &&
		!filterStart.userSetting
	) {
		var searchValue = searchParams.get("search").toLowerCase();
		var searchArr = [];
		var newArr = [];
		var submitType = false;
		$.each(fetchSearchData(), function (index, item) {
			if (
				item.name.toLowerCase().includes(searchValue) &&
				item.url != "" &&
				item.url != undefined
			) {
				submitType = true;
				searchArr.push(item);
			}
		});
		newArr = removeDuplicates(searchArr, "url");
		newArr.shift();
		var str = [];
		str.push(
			`<div>${$(".filterList.productList>.item:not(.itemCard)").length
			} search results for "${searchParams.get("search")}"</div>`
		);
		if (newArr.length > 0 && newArr[0].url != undefined) {
			str.push(`<div>Related Searches: `);
			$.each(newArr, function (index, item) {
				str.push(`<a href="${item.url}&search=${item.name}">${item.name}</a>`);
			});
			str.push(`</div>`);
		}
		$(".searchResult").html(str.join(""));
		$(".searchResult").css("display", "flex");
	}
	if ($(".curtainFilterTag .selection").length == 0) {
		// if (filterStart.showItem) {
		// 		if (typeof filterStart.showItem == "boolean") {
		// 			$(".filterList .item:nth-of-type(3)").after(
		// 				`<div class="showItem"><div class="showItemContainer"><div class="showItemBox"><p>Customize your own curtains</p><div class="itemBox"><div class="detailsItem"><img style="width:53px;height:51px" src="/cdn/shop/files/cloths.png" /><p>Unique printing technique</p></div><div class="detailsItem"><img style="width:62px;height:50px" src="/cdn/shop/files/chart.png" /><p>Customizable styles</p></div><div class="detailsItem"><img style="width:62px;height:48px" src="/cdn/shop/files/measuring-tape.png" /><p>Sizes tailored to your preference</p></div></div></div><a href="${$(
		// 					".curtainAll .content .filterList.productList .item:first-of-type .itemContainer"
		// 				).attr("href")}" class="showItemBox"><img src="${$(
		// 					".curtainAll .content .filterList.productList .item:first-of-type .itemContainer > div.productImg > img:not(.hoverImg)"
		// 				).attr("src")}" /></a></div></div>`
		// 			);
		// 		} else if (typeof filterStart.showItem == "number") {
		// 			var arr = list.filter(function (item) {
		// 				return item.id == filterStart.showItem;
		// 			})[0];
		// 			$(".filterList .item:nth-of-type(3)").after(
		// 				`<div class="showItem"><div class="showItemContainer"><div class="showItemBox"><p>Customize your own curtains</p><div class="itemBox"><div class="detailsItem"><img style="width:53px;height:51px" src="/cdn/shop/files/cloths.png" /><p>Unique printing technique</p></div><div class="detailsItem"><img style="width:62px;height:50px" src="/cdn/shop/files/chart.png" /><p>Customizable styles</p></div><div class="detailsItem"><img style="width:62px;height:48px" src="/cdn/shop/files/measuring-tape.png" /><p>Sizes tailored to your preference</p></div></div></div><a href="${arr.ProductUrl
		// 				}&lining=${liningChange()}" class="showItemBox"><img src="${arr.imgSrc
		// 				}" /></a></div></div>`
		// 			);
		// 		}
		// }
		if (['soundproof-curtains', 'solid-curtains', 'custom-blackout-curtains', 'all-curtains'].includes(filterStart.termsSlug)) {
			vctBannerChange();
		}
	}
	if ($(".startList").length > 0) {
		$(".startList").css(
			"display",
			$(".curtainFilterTag .selection").length == 0 ? "flex" : "none"
		);
		$(".filterList").css(
			"display",
			$(".curtainFilterTag .selection").length == 0 ? "none" : "flex"
		);
	}
	$(".curtainFilterNum span").text(
		$(".curtainAll .content .filterList .item").length
	);
}
function startListChange (list = []) {
	if ($(".startList .productList").length > 0) {
		if ($(".curtainFilterTag .selection").length == 0) {
			if (
				$(".curtainAll .orderby").val() == "menu_order" ||
				($(".curtainAll .orderby").val() != "menu_order" && list == [])
			) {
				list = filterStart.dataList;
			}
		}
		$(".startList .productList").each(function (i, ele) {
			const typeList = list.filter(function (item) {
				return item.Sale == $(ele).attr("name");
			});
			if (typeList.length > 0) {
				productCard(
					ele,
					typeList,
					{
						showType: filterStart.showType,
						fwidth: filterStart.fwidth,
						flength: filterStart.flength,
					},
					liningChange()
				);
				$(ele).css("display", "flex");
			}
		});
		$(".startList").css(
			"display",
			$(".curtainFilterTag .selection").length == 0 ? "flex" : "none"
		);
		$(".filterList").css(
			"display",
			$(".curtainFilterTag .selection").length == 0 ? "none" : "flex"
		);
	}
}
function filterData (list) {
	var filterList = {};
	$.each(list, function (index, item) {
		$.each(Object.keys(item), function (i, itemType) {
			if (filterStart.showType.includes(itemType)) {
				if (!filterList.hasOwnProperty(itemType)) {
					filterList[itemType] = [];
				}
				var valueToAdd = item[itemType];
				// 如果是数组，则遍历并添加唯一的元素
				if ($.isArray(valueToAdd)) {
					$.each(valueToAdd, function (i, itemTypeChild) {
						if (filterList[itemType].indexOf(itemTypeChild) === -1) {
							filterList[itemType].push(itemTypeChild);
						}
					});
				} else {
					// 如果不是数组，则直接添加（但首先检查是否已经存在）
					if (
						filterList[itemType].indexOf(valueToAdd) === -1 &&
						valueToAdd != ""
					) {
						filterList[itemType].push(valueToAdd);
					}
				}
			}
		});
	});
	filterShow(filterList);
}
function filterShow (list) {
	const str = [];
	for (const [itemType, values] of Object.entries(list)) {
		var itemTypeName = "";
		if (values != "") {
			switch (itemType) {
				case "Light":
					itemTypeName = "Light Control";
					break;
				case "Hanging":
					itemTypeName = "Hanging Style";
					break;
				default:
					itemTypeName = itemType;
					break;
			}
			str.push(`<div class="filterItem">`);
			str.push(
				`<div class="title" name="${itemType}">${itemTypeName} <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.93005 6.03223L9.93005 12.0322L15.9301 6.03223" stroke="#2E2E2E" stroke-width="2" /></svg></div>`
			);
			str.push(`<div class="detail">`);
			for (const value of values) {
				if (value != "") {
					const id = `${itemType.replace(/\//g, "-")}_${value.replace(
						/ /g,
						"_"
					)}`;
					if (itemType == "Color") {
						str.push(
							`<div><input type="checkbox" name="${itemType}" id="${id}"><label for="${id}"><div class="${id}"></div></label><label for="${id}">${value}</label></div>`
						);
					} else {
						str.push(
							`<div><input type="checkbox" name="${itemType}" id="${id}"><label for="${id}">${value}</label></div>`
						);
					}
				}
			}
			str.push(`</div>`);
			str.push(`</div>`);
		}
	}
	$(".curtainFilter .curtainFilterDetail .filterListBox").html(str.join(""));
	filterStart.$Box.find(".title").on("click", function () {
		if ($(this).hasClass("active")) {
			$(this).removeClass("active");
		} else {
			$(this).addClass("active");
		}
	});
	filterStart.$Box
		.find(".detail > div input[type=checkbox]")
		.on("change", function () {
			const inputChecked = this.checked;
			const inputId = $(this).attr("id");
			filterStart.userSetting = true;
			const text = this.id.split("_").slice(1).join("_").replace(/_/g, " ");
			$(".searchResult").css("display", "none");
			if (this.checked) {
				// checkbox选中
				if (this.name == "Light" && !filterStart.lining.includes(text)) {
					filterStart.lining.push(text);
				}
				if (this.name == "Color") {
					filterStart.$filterTag
						.find(">span")
						.before(
							`<div class="selection" name="${this.id}"><div class="${this.id}"></div>${text}<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 13" stroke="#1F1F1F" stroke-width="1.5" /><path d="M1 13L13 1" stroke="#1F1F1F" stroke-width="1.5" /></svg></div>`
						);
					filterStart.$BoxTag
						.find(">span")
						.before(
							`<div class="selection" name="${this.id}"><div class="${this.id}"></div>${text}<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 13" stroke="#1F1F1F" stroke-width="1.5" /><path d="M1 13L13 1" stroke="#1F1F1F" stroke-width="1.5" /></svg></div>`
						);
				} else {
					filterStart.$filterTag
						.find(">span")
						.before(
							`<div class="selection" name="${this.id}">${text}<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 13" stroke="#1F1F1F" stroke-width="1.5" /><path d="M1 13L13 1" stroke="#1F1F1F" stroke-width="1.5" /></svg></div>`
						);
					filterStart.$BoxTag
						.find(">span")
						.before(
							`<div class="selection" name="${this.id}">${text}<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 13" stroke="#1F1F1F" stroke-width="1.5" /><path d="M1 13L13 1" stroke="#1F1F1F" stroke-width="1.5" /></svg></div>`
						);
				}
				filterStart.$TagNum.text(
					`(${filterStart.$filterTag.find(".selection").length})`
				);
				$(".curtainFilterBtn span").text(
					`(${filterStart.$filterTag.find(".selection").length})`
				);
				filterStart.$filterTag.css("display", "flex");
				filterStart.$BoxTag.css("display", "flex");
				$(".curtainFilterNum").show();
				// tag点击删除
				filterStart.$filterTag.find(".selection svg").on("click", function () {
					$(this).closest(".selection").remove();
					filterStart.$BoxTag
						.find(
							`.selection[name="${$(this).closest("div").attr("name")}"] svg`
						)
						.click();
					filterStart.lining = filterStart.lining.filter(
						(item) =>
							item.toLowerCase() !== $(this).closest("div").text().toLowerCase()
					);
					$(
						`.curtainFilter .curtainFilterDetail .filterListBox .detail > div input[type=checkbox][id="${$(
							this
						)
							.closest("div")
							.attr("name")}"]`
					).prop("checked", false);
					filterStart.$filterTag.css(
						"display",
						filterStart.$filterTag.find(".selection").length > 0
							? "flex"
							: "none"
					);
					filterStart.$BoxTag.css(
						"display",
						filterStart.$filterTag.find(".selection").length > 0
							? "flex"
							: "none"
					);
					filterStart.$TagNum.text(
						`(${filterStart.$filterTag.find(".selection").length})`
					);
					$(".curtainFilterBtn span").text(
						`(${filterStart.$filterTag.find(".selection").length})`
					);
					$(".curtainFilterNum").css(
						"display",
						$(".curtainFilter .curtainFilterTitle .curtainFilterTag .selection")
							.length > 0
							? "block"
							: "none"
					);
					$(".curtainFilter .curtainFilterDetail .filterListBox").css(
						"height",
						`calc(100vh - ${parseInt(
							$(".curtainFilter .curtainFilterTitle").outerHeight()
						)}px - 72px)`
					);
					$(
						`.productTags .item .btn[name="${$(this)
							.closest("div")
							.attr("name")}"]`
					).removeClass("active");
					get_filterData();
				});
				filterStart.$BoxTag.find(".selection svg").on("click", function () {
					$(this).closest(".selection").remove();
					filterStart.$filterTag
						.find(
							`.selection[name="${$(this).closest("div").attr("name")}"] svg`
						)
						.click();
				});
				$(`.productTags .item .btn[name="${$(this).attr("id")}"]`).addClass(
					"active"
				);
			} else {
				filterStart.$filterTag
					.find(`.selection[name="${this.id}"] svg`)
					.click();
				filterStart.lining = filterStart.lining.filter(
					(item) => item.toLowerCase() !== text.toLowerCase()
				);
				$(`.productTags .item .btn[name="${$(this).attr("id")}"]`).removeClass(
					"active"
				);
			}
			$(".curtainFilter .curtainFilterDetail .filterListBox").css(
				"height",
				`calc(100vh - ${parseInt(
					$(".curtainFilter .curtainFilterTitle").outerHeight()
				)}px - 72px)`
			);
			get_filterData();
		});
	if (searchParams.get("filter") != null && !filterStart.userSetting) {
		filter = searchParams.get("filter");
		filterStart.$filterTag.find("> span").click();
		$(
			".curtainFilter .curtainFilterDetail .filterListBox .filterItem .detail>div input[type=checkbox]"
		).each(function (i, item) {
			if (filter.includes($(item).attr("id"))) {
				$(item).click();
			}
		});
	}
	if (filterStart.userSetting) {
		var arr = [];
		$(".curtainFilterTag .selection").each(function (i, item) {
			arr.push($(item).attr("name"));
		});
		filterStart.$filterTag.find("> span").click();
		$(
			".curtainFilter .curtainFilterDetail .filterListBox .filterItem .detail>div input[type=checkbox]"
		).each(function (i, item) {
			if (arr.includes($(item).attr("id"))) {
				$(item).click();
			}
		});
	}
}
function get_filterData () {
	let dataAttr = [];
	const checkedValues = {};
	window.scroll(0, 0);
	filterStart.$Box
		.find('.detail > div input[type="checkbox"]:checked')
		.each(function () {
			const name = this.name;
			const value = this.id.split("_").slice(1).join("_").replace(/_/g, " ");
			if (!checkedValues[name]) {
				checkedValues[name] = new Set();
			}
			checkedValues[name].add(value);
		});
	for (const item of filterStart.dataList) {
		let hasAllMatches = true;
		for (const [itemType, values] of Object.entries(checkedValues)) {
			if (itemType in item) {
				const itemValues = Array.isArray(item[itemType])
					? item[itemType]
					: [item[itemType]];
				let hasMatch = false;
				for (const value of itemValues) {
					if (values.has(value)) {
						hasMatch = true;
						break;
					}
				}
				if (!hasMatch) {
					hasAllMatches = false;
					break;
				}
			}
		}
		if (hasAllMatches) {
			dataAttr.push(item);
		}
	}
	dataAttr = removeDuplicates(dataAttr);
	ListChange(dataAttr);
}
function vctBannerChange () {
	if ($('.vctBanner').length == 0) {
		var str = [];
		str.push(`<div class="vctBanner">`);
		str.push(`<a href="/visualization/" target="_blank" class="vctBannerBox">`);
		str.push(`<img src="/cdn/shop/files/vctBanner.png">`);
		str.push(`<div class="rectangle">`);
		str.push(`<div>`);
		str.push(`<p>Visualize Your Curtains Before You Buy</p>`);
		str.push(`<p>Instantly preview your selections—fabric, color, header, and more—to ensure the perfect look for your space.</p>`);
		str.push(`</div>`);
		str.push(`<div class="btn" type="link">TRY NOW</div>`);
		str.push(`</div>`);
		str.push(`</a>`);
		str.push(`</div>`);
		$('.curtainAll .content .filterList .item').eq(2).after(str.join(""));
	}
}
